const CitiesModel = [
    {"city": "L'Abergement-Clémenciat"},
    {"city": "L'Abergement-de-Varey"},
    {"city": "Ambérieu-en-Bugey"},
    {"city": "Ambérieux-en-Dombes"},
    {"city": "Ambléon"},
    {"city": "Ambronay"},
    {"city": "Ambutrix"},
    {"city": "Andert-et-Condon"},
    {"city": "Anglefort"},
    {"city": "Apremont"},
    {"city": "Aranc"},
    {"city": "Arandas"},
    {"city": "Arbent"},
    {"city": "Arboys en Bugey"},
    {"city": "Arbigny"},
    {"city": "Argis"},
    {"city": "Armix"},
    {"city": "Ars-sur-Formans"},
    {"city": "Artemare"},
    {"city": "Asnières-sur-Saône"},
    {"city": "Attignat"},
    {"city": "Bâgé-Dommartin"},
    {"city": "Bâgé-le-Châtel"},
    {"city": "Balan"},
    {"city": "Baneins"},
    {"city": "Beaupont"},
    {"city": "Beauregard"},
    {"city": "Bellignat"},
    {"city": "Béligneux"},
    {"city": "Valserhône"},
    {"city": "Belley"},
    {"city": "Belleydoux"},
    {"city": "Valromey-sur-Séran"},
    {"city": "Bénonces"},
    {"city": "Bény"},
    {"city": "Béon"},
    {"city": "Béréziat"},
    {"city": "Bettant"},
    {"city": "Bey"},
    {"city": "Beynost"},
    {"city": "Billiat"},
    {"city": "Birieux"},
    {"city": "Biziat"},
    {"city": "Blyes"},
    {"city": "La Boisse"},
    {"city": "Boissey"},
    {"city": "Bolozon"},
    {"city": "Bouligneux"},
    {"city": "Bourg-en-Bresse"},
    {"city": "Bourg-Saint-Christophe"},
    {"city": "Boyeux-Saint-Jérôme"},
    {"city": "Boz"},
    {"city": "Brégnier-Cordon"},
    {"city": "Brénod"},
    {"city": "Brens"},
    {"city": "Bressolles"},
    {"city": "Brion"},
    {"city": "Briord"},
    {"city": "Buellas"},
    {"city": "La Burbanche"},
    {"city": "Ceignes"},
    {"city": "Cerdon"},
    {"city": "Certines"},
    {"city": "Cessy"},
    {"city": "Ceyzériat"},
    {"city": "Ceyzérieu"},
    {"city": "Chalamont"},
    {"city": "Chaleins"},
    {"city": "Chaley"},
    {"city": "Challes-la-Montagne"},
    {"city": "Challex"},
    {"city": "Champagne-en-Valromey"},
    {"city": "Champdor-Corcelles"},
    {"city": "Champfromier"},
    {"city": "Chanay"},
    {"city": "Chaneins"},
    {"city": "Chanoz-Châtenay"},
    {"city": "La Chapelle-du-Châtelard"},
    {"city": "Charix"},
    {"city": "Charnoz-sur-Ain"},
    {"city": "Château-Gaillard"},
    {"city": "Châtenay"},
    {"city": "Châtillon-la-Palud"},
    {"city": "Châtillon-sur-Chalaronne"},
    {"city": "Chavannes-sur-Reyssouze"},
    {"city": "Nivigne et Suran"},
    {"city": "Chaveyriat"},
    {"city": "Chazey-Bons"},
    {"city": "Chazey-sur-Ain"},
    {"city": "Cheignieu-la-Balme"},
    {"city": "Chevillard"},
    {"city": "Chevroux"},
    {"city": "Chevry"},
    {"city": "Chézery-Forens"},
    {"city": "Civrieux"},
    {"city": "Cize"},
    {"city": "Cleyzieu"},
    {"city": "Coligny"},
    {"city": "Collonges"},
    {"city": "Colomieu"},
    {"city": "Conand"},
    {"city": "Condamine"},
    {"city": "Condeissiat"},
    {"city": "Confort"},
    {"city": "Confrançon"},
    {"city": "Contrevoz"},
    {"city": "Conzieu"},
    {"city": "Corbonod"},
    {"city": "Corlier"},
    {"city": "Cormoranche-sur-Saône"},
    {"city": "Cormoz"},
    {"city": "Corveissiat"},
    {"city": "Courmangoux"},
    {"city": "Courtes"},
    {"city": "Crans"},
    {"city": "Bresse Vallons"},
    {"city": "Cressin-Rochefort"},
    {"city": "Crottet"},
    {"city": "Crozet"},
    {"city": "Cruzilles-lès-Mépillat"},
    {"city": "Culoz"},
    {"city": "Curciat-Dongalon"},
    {"city": "Curtafond"},
    {"city": "Cuzieu"},
    {"city": "Dagneux"},
    {"city": "Divonne-les-Bains"},
    {"city": "Dompierre-sur-Veyle"},
    {"city": "Dompierre-sur-Chalaronne"},
    {"city": "Domsure"},
    {"city": "Dortan"},
    {"city": "Douvres"},
    {"city": "Drom"},
    {"city": "Druillat"},
    {"city": "Échallon"},
    {"city": "Échenevex"},
    {"city": "Évosges"},
    {"city": "Faramans"},
    {"city": "Fareins"},
    {"city": "Farges"},
    {"city": "Feillens"},
    {"city": "Ferney-Voltaire"},
    {"city": "Flaxieu"},
    {"city": "Foissiat"},
    {"city": "Francheleins"},
    {"city": "Frans"},
    {"city": "Garnerans"},
    {"city": "Genouilleux"},
    {"city": "Béard-Géovreissiat"},
    {"city": "Géovreisset"},
    {"city": "Gex"},
    {"city": "Giron"},
    {"city": "Gorrevod"},
    {"city": "Grand-Corent"},
    {"city": "Grièges"},
    {"city": "Grilly"},
    {"city": "Groissiat"},
    {"city": "Guéreins"},
    {"city": "Hautecourt-Romanèche"},
    {"city": "Plateau d'Hauteville"},
    {"city": "Haut Valromey"},
    {"city": "Illiat"},
    {"city": "Injoux-Génissiat"},
    {"city": "Innimond"},
    {"city": "Izenave"},
    {"city": "Izernore"},
    {"city": "Izieu"},
    {"city": "Jassans-Riottier"},
    {"city": "Jasseron"},
    {"city": "Jayat"},
    {"city": "Journans"},
    {"city": "Joyeux"},
    {"city": "Jujurieux"},
    {"city": "Labalme"},
    {"city": "Lagnieu"},
    {"city": "Laiz"},
    {"city": "Le Poizat-Lalleyriat"},
    {"city": "Lantenay"},
    {"city": "Lapeyrouse"},
    {"city": "Lavours"},
    {"city": "Léaz"},
    {"city": "Lélex"},
    {"city": "Lent"},
    {"city": "Lescheroux"},
    {"city": "Leyment"},
    {"city": "Leyssard"},
    {"city": "Surjoux-Lhopital"},
    {"city": "Lhuis"},
    {"city": "Lompnas"},
    {"city": "Loyettes"},
    {"city": "Lurcy"},
    {"city": "Magnieu"},
    {"city": "Maillat"},
    {"city": "Malafretaz"},
    {"city": "Mantenay-Montlin"},
    {"city": "Manziat"},
    {"city": "Marboz"},
    {"city": "Marchamp"},
    {"city": "Marignieu"},
    {"city": "Marlieux"},
    {"city": "Marsonnas"},
    {"city": "Martignat"},
    {"city": "Massieux"},
    {"city": "Massignieu-de-Rives"},
    {"city": "Matafelon-Granges"},
    {"city": "Meillonnas"},
    {"city": "Mérignat"},
    {"city": "Messimy-sur-Saône"},
    {"city": "Meximieux"},
    {"city": "Bohas-Meyriat-Rignat"},
    {"city": "Mézériat"},
    {"city": "Mijoux"},
    {"city": "Mionnay"},
    {"city": "Miribel"},
    {"city": "Misérieux"},
    {"city": "Mogneneins"},
    {"city": "Montagnat"},
    {"city": "Montagnieu"},
    {"city": "Montanges"},
    {"city": "Montceaux"},
    {"city": "Montcet"},
    {"city": "Le Montellier"},
    {"city": "Monthieux"},
    {"city": "Montluel"},
    {"city": "Montmerle-sur-Saône"},
    {"city": "Montracol"},
    {"city": "Montréal-la-Cluse"},
    {"city": "Montrevel-en-Bresse"},
    {"city": "Nurieux-Volognat"},
    {"city": "Murs-et-Gélignieux"},
    {"city": "Nantua"},
    {"city": "Neuville-les-Dames"},
    {"city": "Neuville-sur-Ain"},
    {"city": "Les Neyrolles"},
    {"city": "Neyron"},
    {"city": "Niévroz"},
    {"city": "Nivollet-Montgriffon"},
    {"city": "Oncieu"},
    {"city": "Ordonnaz"},
    {"city": "Ornex"},
    {"city": "Outriaz"},
    {"city": "Oyonnax"},
    {"city": "Ozan"},
    {"city": "Parcieux"},
    {"city": "Parves et Nattages"},
    {"city": "Péron"},
    {"city": "Péronnas"},
    {"city": "Pérouges"},
    {"city": "Perrex"},
    {"city": "Peyriat"},
    {"city": "Peyrieu"},
    {"city": "Peyzieux-sur-Saône"},
    {"city": "Pirajoux"},
    {"city": "Pizay"},
    {"city": "Plagne"},
    {"city": "Le Plantay"},
    {"city": "Polliat"},
    {"city": "Pollieu"},
    {"city": "Poncin"},
    {"city": "Pont-d'Ain"},
    {"city": "Pont-de-Vaux"},
    {"city": "Pont-de-Veyle"},
    {"city": "Port"},
    {"city": "Pougny"},
    {"city": "Pouillat"},
    {"city": "Prémeyzel"},
    {"city": "Prémillieu"},
    {"city": "Prévessin-Moëns"},
    {"city": "Priay"},
    {"city": "Ramasse"},
    {"city": "Rancé"},
    {"city": "Relevant"},
    {"city": "Replonges"},
    {"city": "Revonnas"},
    {"city": "Reyrieux"},
    {"city": "Reyssouze"},
    {"city": "Rignieux-le-Franc"},
    {"city": "Romans"},
    {"city": "Rossillon"},
    {"city": "Ruffieu"},
    {"city": "Saint-Alban"},
    {"city": "Saint-André-de-Bâgé"},
    {"city": "Saint-André-de-Corcy"},
    {"city": "Saint-André-d'Huiriat"},
    {"city": "Saint-André-le-Bouchoux"},
    {"city": "Saint-André-sur-Vieux-Jonc"},
    {"city": "Saint-Bénigne"},
    {"city": "Groslée-Saint-Benoit"},
    {"city": "Saint-Bernard"},
    {"city": "Sainte-Croix"},
    {"city": "Saint-Cyr-sur-Menthon"},
    {"city": "Saint-Denis-lès-Bourg"},
    {"city": "Saint-Denis-en-Bugey"},
    {"city": "Saint-Didier-d'Aussiat"},
    {"city": "Saint-Didier-de-Formans"},
    {"city": "Saint-Didier-sur-Chalaronne"},
    {"city": "Saint-Éloi"},
    {"city": "Saint-Étienne-du-Bois"},
    {"city": "Saint-Étienne-sur-Chalaronne"},
    {"city": "Saint-Étienne-sur-Reyssouze"},
    {"city": "Sainte-Euphémie"},
    {"city": "Saint-Genis-Pouilly"},
    {"city": "Saint-Genis-sur-Menthon"},
    {"city": "Saint-Georges-sur-Renon"},
    {"city": "Saint-Germain-de-Joux"},
    {"city": "Saint-Germain-les-Paroisses"},
    {"city": "Saint-Germain-sur-Renon"},
    {"city": "Saint-Jean-de-Gonville"},
    {"city": "Saint-Jean-de-Niost"},
    {"city": "Saint-Jean-de-Thurigneux"},
    {"city": "Saint-Jean-le-Vieux"},
    {"city": "Saint-Jean-sur-Reyssouze"},
    {"city": "Saint-Jean-sur-Veyle"},
    {"city": "Sainte-Julie"},
    {"city": "Saint-Julien-sur-Reyssouze"},
    {"city": "Saint-Julien-sur-Veyle"},
    {"city": "Saint-Just"},
    {"city": "Saint-Laurent-sur-Saône"},
    {"city": "Saint-Marcel"},
    {"city": "Saint-Martin-de-Bavel"},
    {"city": "Saint-Martin-du-Frêne"},
    {"city": "Saint-Martin-du-Mont"},
    {"city": "Saint-Martin-le-Châtel"},
    {"city": "Saint-Maurice-de-Beynost"},
    {"city": "Saint-Maurice-de-Gourdans"},
    {"city": "Saint-Maurice-de-Rémens"},
    {"city": "Saint-Nizier-le-Bouchoux"},
    {"city": "Saint-Nizier-le-Désert"},
    {"city": "Sainte-Olive"},
    {"city": "Saint-Paul-de-Varax"},
    {"city": "Saint-Rambert-en-Bugey"},
    {"city": "Saint-Rémy"},
    {"city": "Saint-Sorlin-en-Bugey"},
    {"city": "Saint-Sulpice"},
    {"city": "Saint-Trivier-de-Courtes"},
    {"city": "Saint-Trivier-sur-Moignans"},
    {"city": "Saint-Vulbas"},
    {"city": "Salavre"},
    {"city": "Samognat"},
    {"city": "Sandrans"},
    {"city": "Sault-Brénaz"},
    {"city": "Sauverny"},
    {"city": "Savigneux"},
    {"city": "Ségny"},
    {"city": "Seillonnaz"},
    {"city": "Sergy"},
    {"city": "Sermoyer"},
    {"city": "Serrières-de-Briord"},
    {"city": "Serrières-sur-Ain"},
    {"city": "Servas"},
    {"city": "Servignat"},
    {"city": "Seyssel"},
    {"city": "Simandre-sur-Suran"},
    {"city": "Sonthonnax-la-Montagne"},
    {"city": "Souclin"},
    {"city": "Sulignat"},
    {"city": "Talissieu"},
    {"city": "Tenay"},
    {"city": "Thil"},
    {"city": "Thoiry"},
    {"city": "Thoissey"},
    {"city": "Torcieu"},
    {"city": "Tossiat"},
    {"city": "Toussieux"},
    {"city": "Tramoyes"},
    {"city": "La Tranclière"},
    {"city": "Val-Revermont"},
    {"city": "Trévoux"},
    {"city": "Valeins"},
    {"city": "Vandeins"},
    {"city": "Varambon"},
    {"city": "Vaux-en-Bugey"},
    {"city": "Verjon"},
    {"city": "Vernoux"},
    {"city": "Versailleux"},
    {"city": "Versonnex"},
    {"city": "Vesancy"},
    {"city": "Vescours"},
    {"city": "Vésines"},
    {"city": "Vieu-d'Izenave"},
    {"city": "Villars-les-Dombes"},
    {"city": "Villebois"},
    {"city": "Villemotier"},
    {"city": "Villeneuve"},
    {"city": "Villereversure"},
    {"city": "Villes"},
    {"city": "Villette-sur-Ain"},
    {"city": "Villieu-Loyes-Mollon"},
    {"city": "Viriat"},
    {"city": "Virieu-le-Grand"},
    {"city": "Arvière-en-Valromey"},
    {"city": "Virignin"},
    {"city": "Vongnes"},
    {"city": "Vonnas"},
    {"city": "Abbécourt"},
    {"city": "Achery"},
    {"city": "Acy"},
    {"city": "Agnicourt-et-Séchelles"},
    {"city": "Aguilcourt"},
    {"city": "Aisonville-et-Bernoville"},
    {"city": "Aizelles"},
    {"city": "Aizy-Jouy"},
    {"city": "Alaincourt"},
    {"city": "Allemant"},
    {"city": "Ambleny"},
    {"city": "Ambrief"},
    {"city": "Amifontaine"},
    {"city": "Amigny-Rouy"},
    {"city": "Ancienville"},
    {"city": "Andelain"},
    {"city": "Anguilcourt-le-Sart"},
    {"city": "Anizy-le-Grand"},
    {"city": "Annois"},
    {"city": "Any-Martin-Rieux"},
    {"city": "Archon"},
    {"city": "Arcy-Sainte-Restitue"},
    {"city": "Armentières-sur-Ourcq"},
    {"city": "Arrancy"},
    {"city": "Artemps"},
    {"city": "Assis-sur-Serre"},
    {"city": "Athies-sous-Laon"},
    {"city": "Attilly"},
    {"city": "Aubencheul-aux-Bois"},
    {"city": "Aubenton"},
    {"city": "Aubigny-aux-Kaisnes"},
    {"city": "Aubigny-en-Laonnois"},
    {"city": "Audignicourt"},
    {"city": "Audigny"},
    {"city": "Augy"},
    {"city": "Aulnois-sous-Laon"},
    {"city": "Les Autels"},
    {"city": "Autremencourt"},
    {"city": "Autreppes"},
    {"city": "Autreville"},
    {"city": "Azy-sur-Marne"},
    {"city": "Bagneux"},
    {"city": "Bancigny"},
    {"city": "Barenton-Bugny"},
    {"city": "Barenton-Cel"},
    {"city": "Barenton-sur-Serre"},
    {"city": "Barisis-aux-Bois"},
    {"city": "Barzy-en-Thiérache"},
    {"city": "Barzy-sur-Marne"},
    {"city": "Bassoles-Aulers"},
    {"city": "Vallées en Champagne"},
    {"city": "Bazoches-sur-Vesles"},
    {"city": "Beaumé"},
    {"city": "Beaumont-en-Beine"},
    {"city": "Beaurevoir"},
    {"city": "Beaurieux"},
    {"city": "Beautor"},
    {"city": "Beauvois-en-Vermandois"},
    {"city": "Becquigny"},
    {"city": "Belleau"},
    {"city": "Bellenglise"},
    {"city": "Belleu"},
    {"city": "Bellicourt"},
    {"city": "Benay"},
    {"city": "Bergues-sur-Sambre"},
    {"city": "Berlancourt"},
    {"city": "Berlise"},
    {"city": "Bernot"},
    {"city": "Berny-Rivière"},
    {"city": "Berrieux"},
    {"city": "Berry-au-Bac"},
    {"city": "Bertaucourt-Epourdon"},
    {"city": "Berthenicourt"},
    {"city": "Bertricourt"},
    {"city": "Berzy-le-Sec"},
    {"city": "Besmé"},
    {"city": "Besmont"},
    {"city": "Besny-et-Loizy"},
    {"city": "Béthancourt-en-Vaux"},
    {"city": "Beugneux"},
    {"city": "Beuvardes"},
    {"city": "Bézu-le-Guéry"},
    {"city": "Bézu-Saint-Germain"},
    {"city": "Bichancourt"},
    {"city": "Bieuxy"},
    {"city": "Bièvres"},
    {"city": "Billy-sur-Aisne"},
    {"city": "Billy-sur-Ourcq"},
    {"city": "Blanzy-lès-Fismes"},
    {"city": "Blérancourt"},
    {"city": "Blesmes"},
    {"city": "Bohain-en-Vermandois"},
    {"city": "Bois-lès-Pargny"},
    {"city": "Boncourt"},
    {"city": "Bonneil"},
    {"city": "Bonnesvalyn"},
    {"city": "Bony"},
    {"city": "Bosmont-sur-Serre"},
    {"city": "Bouconville-Vauclair"},
    {"city": "Boué"},
    {"city": "Bouffignereux"},
    {"city": "Bouresches"},
    {"city": "Bourg-et-Comin"},
    {"city": "Bourguignon-sous-Coucy"},
    {"city": "Bourguignon-sous-Montbavin"},
    {"city": "La Bouteille"},
    {"city": "Braine"},
    {"city": "Brancourt-en-Laonnois"},
    {"city": "Brancourt-le-Grand"},
    {"city": "Brasles"},
    {"city": "Braye-en-Laonnois"},
    {"city": "Braye-en-Thiérache"},
    {"city": "Bray-Saint-Christophe"},
    {"city": "Braye"},
    {"city": "Brécy"},
    {"city": "Brenelle"},
    {"city": "Breny"},
    {"city": "Brie"},
    {"city": "Brissay-Choigny"},
    {"city": "Brissy-Hamégicourt"},
    {"city": "Brumetz"},
    {"city": "Brunehamel"},
    {"city": "Bruyères-sur-Fère"},
    {"city": "Bruyères-et-Montbérault"},
    {"city": "Bruys"},
    {"city": "Bucilly"},
    {"city": "Bucy-le-Long"},
    {"city": "Bucy-lès-Cerny"},
    {"city": "Bucy-lès-Pierrepont"},
    {"city": "Buire"},
    {"city": "Buironfosse"},
    {"city": "Burelles"},
    {"city": "Bussiares"},
    {"city": "Buzancy"},
    {"city": "Caillouël-Crépigny"},
    {"city": "Camelin"},
    {"city": "La Capelle"},
    {"city": "Castres"},
    {"city": "Le Catelet"},
    {"city": "Caulaincourt"},
    {"city": "Caumont"},
    {"city": "Celles-lès-Condé"},
    {"city": "Celles-sur-Aisne"},
    {"city": "Cerizy"},
    {"city": "Cerny-en-Laonnois"},
    {"city": "Cerny-lès-Bucy"},
    {"city": "Cerseuil"},
    {"city": "Cessières-Suzy"},
    {"city": "Chacrise"},
    {"city": "Chaillevois"},
    {"city": "Chalandry"},
    {"city": "Chambry"},
    {"city": "Chamouille"},
    {"city": "Champs"},
    {"city": "Chaourse"},
    {"city": "La Chapelle-sur-Chézy"},
    {"city": "Charly-sur-Marne"},
    {"city": "Le Charmel"},
    {"city": "Charmes"},
    {"city": "Chartèves"},
    {"city": "Chassemy"},
    {"city": "Château-Thierry"},
    {"city": "Châtillon-lès-Sons"},
    {"city": "Châtillon-sur-Oise"},
    {"city": "Chaudardes"},
    {"city": "Chaudun"},
    {"city": "Chauny"},
    {"city": "Chavignon"},
    {"city": "Chavigny"},
    {"city": "Chavonne"},
    {"city": "Chérêt"},
    {"city": "Chermizy-Ailles"},
    {"city": "Chéry-Chartreuve"},
    {"city": "Chéry-lès-Pouilly"},
    {"city": "Chéry-lès-Rozoy"},
    {"city": "Chevennes"},
    {"city": "Chevregny"},
    {"city": "Chevresis-Monceau"},
    {"city": "Chézy-en-Orxois"},
    {"city": "Chézy-sur-Marne"},
    {"city": "Chierry"},
    {"city": "Chigny"},
    {"city": "Chivres-en-Laonnois"},
    {"city": "Chivres-Val"},
    {"city": "Chivy-lès-Étouvelles"},
    {"city": "Chouy"},
    {"city": "Cierges"},
    {"city": "Cilly"},
    {"city": "Ciry-Salsogne"},
    {"city": "Clacy-et-Thierret"},
    {"city": "Clairfontaine"},
    {"city": "Clamecy"},
    {"city": "Clastres"},
    {"city": "Clermont-les-Fermes"},
    {"city": "Cœuvres-et-Valsery"},
    {"city": "Coincy"},
    {"city": "Coingt"},
    {"city": "Colligis-Crandelain"},
    {"city": "Colonfay"},
    {"city": "Commenchon"},
    {"city": "Concevreux"},
    {"city": "Condé-en-Brie"},
    {"city": "Condé-sur-Aisne"},
    {"city": "Condé-sur-Suippe"},
    {"city": "Condren"},
    {"city": "Connigis"},
    {"city": "Contescourt"},
    {"city": "Corbeny"},
    {"city": "Corcy"},
    {"city": "Coucy-le-Château-Auffrique"},
    {"city": "Coucy-lès-Eppes"},
    {"city": "Coucy-la-Ville"},
    {"city": "Coulonges-Cohan"},
    {"city": "Coupru"},
    {"city": "Courbes"},
    {"city": "Courboin"},
    {"city": "Courcelles-sur-Vesle"},
    {"city": "Courchamps"},
    {"city": "Courmelles"},
    {"city": "Courmont"},
    {"city": "Courtemont-Varennes"},
    {"city": "Courtrizy-et-Fussigny"},
    {"city": "Couvrelles"},
    {"city": "Couvron-et-Aumencourt"},
    {"city": "Coyolles"},
    {"city": "Cramaille"},
    {"city": "Craonne"},
    {"city": "Craonnelle"},
    {"city": "Crécy-au-Mont"},
    {"city": "Crécy-sur-Serre"},
    {"city": "Crépy"},
    {"city": "Crézancy"},
    {"city": "Croix-Fonsomme"},
    {"city": "La Croix-sur-Ourcq"},
    {"city": "Crouttes-sur-Marne"},
    {"city": "Crouy"},
    {"city": "Crupilly"},
    {"city": "Cuffies"},
    {"city": "Cugny"},
    {"city": "Cuirieux"},
    {"city": "Cuiry-Housse"},
    {"city": "Cuiry-lès-Chaudardes"},
    {"city": "Cuiry-lès-Iviers"},
    {"city": "Cuissy-et-Geny"},
    {"city": "Cuisy-en-Almont"},
    {"city": "Cutry"},
    {"city": "Cys-la-Commune"},
    {"city": "Dagny-Lambercy"},
    {"city": "Dallon"},
    {"city": "Dammard"},
    {"city": "Dampleux"},
    {"city": "Danizy"},
    {"city": "Dercy"},
    {"city": "Deuillet"},
    {"city": "Dhuizel"},
    {"city": "Dizy-le-Gros"},
    {"city": "Dohis"},
    {"city": "Dolignon"},
    {"city": "Dommiers"},
    {"city": "Domptin"},
    {"city": "Dorengt"},
    {"city": "Douchy"},
    {"city": "Dravegny"},
    {"city": "Droizy"},
    {"city": "Dury"},
    {"city": "Ébouleau"},
    {"city": "Effry"},
    {"city": "Englancourt"},
    {"city": "Épagny"},
    {"city": "Éparcy"},
    {"city": "Épaux-Bézu"},
    {"city": "Épieds"},
    {"city": "L'Épine-aux-Bois"},
    {"city": "Eppes"},
    {"city": "Erlon"},
    {"city": "Erloy"},
    {"city": "Esquéhéries"},
    {"city": "Essigny-le-Grand"},
    {"city": "Essigny-le-Petit"},
    {"city": "Essises"},
    {"city": "Essômes-sur-Marne"},
    {"city": "Estrées"},
    {"city": "Étampes-sur-Marne"},
    {"city": "Étaves-et-Bocquiaux"},
    {"city": "Étouvelles"},
    {"city": "Étréaupont"},
    {"city": "Étreillers"},
    {"city": "Étrépilly"},
    {"city": "Étreux"},
    {"city": "Évergnicourt"},
    {"city": "Faverolles"},
    {"city": "Fayet"},
    {"city": "La Fère"},
    {"city": "Fère-en-Tardenois"},
    {"city": "La Ferté-Chevresis"},
    {"city": "La Ferté-Milon"},
    {"city": "Fesmy-le-Sart"},
    {"city": "Festieux"},
    {"city": "Fieulaine"},
    {"city": "Filain"},
    {"city": "La Flamengrie"},
    {"city": "Flavigny-le-Grand-et-Beaurain"},
    {"city": "Flavy-le-Martel"},
    {"city": "Fleury"},
    {"city": "Fluquières"},
    {"city": "Folembray"},
    {"city": "Fonsomme"},
    {"city": "Fontaine-lès-Clercs"},
    {"city": "Fontaine-lès-Vervins"},
    {"city": "Fontaine-Notre-Dame"},
    {"city": "Fontaine-Uterte"},
    {"city": "Fontenelle"},
    {"city": "Fontenoy"},
    {"city": "Foreste"},
    {"city": "Fossoy"},
    {"city": "Fourdrain"},
    {"city": "Francilly-Selency"},
    {"city": "Franqueville"},
    {"city": "Fresnes-en-Tardenois"},
    {"city": "Fresnes-sous-Coucy"},
    {"city": "Fresnoy-le-Grand"},
    {"city": "Fressancourt"},
    {"city": "Frières-Faillouël"},
    {"city": "Froidestrées"},
    {"city": "Froidmont-Cohartille"},
    {"city": "Gandelu"},
    {"city": "Gauchy"},
    {"city": "Gercy"},
    {"city": "Gergny"},
    {"city": "Germaine"},
    {"city": "Gibercourt"},
    {"city": "Gizy"},
    {"city": "Gland"},
    {"city": "Goudelancourt-lès-Berrieux"},
    {"city": "Goudelancourt-lès-Pierrepont"},
    {"city": "Goussancourt"},
    {"city": "Gouy"},
    {"city": "Grandlup-et-Fay"},
    {"city": "Grandrieux"},
    {"city": "Gricourt"},
    {"city": "Grisolles"},
    {"city": "Gronard"},
    {"city": "Grougis"},
    {"city": "Grugies"},
    {"city": "Villeneuve-sur-Aisne"},
    {"city": "Guise"},
    {"city": "Guivry"},
    {"city": "Guny"},
    {"city": "Guyencourt"},
    {"city": "Hannapes"},
    {"city": "Happencourt"},
    {"city": "Haramont"},
    {"city": "Harcigny"},
    {"city": "Hargicourt"},
    {"city": "Harly"},
    {"city": "Hartennes-et-Taux"},
    {"city": "Hary"},
    {"city": "Lehaucourt"},
    {"city": "Hautevesnes"},
    {"city": "Hauteville"},
    {"city": "Haution"},
    {"city": "La Hérie"},
    {"city": "Le Hérie-la-Viéville"},
    {"city": "Hinacourt"},
    {"city": "Hirson"},
    {"city": "Holnon"},
    {"city": "Homblières"},
    {"city": "Houry"},
    {"city": "Housset"},
    {"city": "Iron"},
    {"city": "Itancourt"},
    {"city": "Iviers"},
    {"city": "Jaulgonne"},
    {"city": "Jeancourt"},
    {"city": "Jeantes"},
    {"city": "Joncourt"},
    {"city": "Jouaignes"},
    {"city": "Jumencourt"},
    {"city": "Jumigny"},
    {"city": "Jussy"},
    {"city": "Juvigny"},
    {"city": "Juvincourt-et-Damary"},
    {"city": "Laffaux"},
    {"city": "Laigny"},
    {"city": "Lanchy"},
    {"city": "Landifay-et-Bertaignemont"},
    {"city": "Landouzy-la-Cour"},
    {"city": "Landouzy-la-Ville"},
    {"city": "Landricourt"},
    {"city": "Laniscourt"},
    {"city": "Laon"},
    {"city": "Lappion"},
    {"city": "Largny-sur-Automne"},
    {"city": "Latilly"},
    {"city": "Launoy"},
    {"city": "Laval-en-Laonnois"},
    {"city": "Lavaqueresse"},
    {"city": "Laversine"},
    {"city": "Lemé"},
    {"city": "Lempire"},
    {"city": "Lerzy"},
    {"city": "Leschelle"},
    {"city": "Lesdins"},
    {"city": "Lesges"},
    {"city": "Lesquielles-Saint-Germain"},
    {"city": "Leuilly-sous-Coucy"},
    {"city": "Leury"},
    {"city": "Leuze"},
    {"city": "Levergies"},
    {"city": "Lhuys"},
    {"city": "Licy-Clignon"},
    {"city": "Lierval"},
    {"city": "Liesse-Notre-Dame"},
    {"city": "Liez"},
    {"city": "Limé"},
    {"city": "Lislet"},
    {"city": "Logny-lès-Aubenton"},
    {"city": "Longpont"},
    {"city": "Les Septvallons"},
    {"city": "Lor"},
    {"city": "Louâtre"},
    {"city": "Loupeigne"},
    {"city": "Lucy-le-Bocage"},
    {"city": "Lugny"},
    {"city": "Luzoir"},
    {"city": "Ly-Fontaine"},
    {"city": "Maast-et-Violaine"},
    {"city": "Mâchecourt"},
    {"city": "Macogny"},
    {"city": "Macquigny"},
    {"city": "Magny-la-Fosse"},
    {"city": "Maissemy"},
    {"city": "Maizy"},
    {"city": "La Malmaison"},
    {"city": "Malzy"},
    {"city": "Manicamp"},
    {"city": "Marchais"},
    {"city": "Dhuys et Morin-en-Brie"},
    {"city": "Marcy"},
    {"city": "Marcy-sous-Marle"},
    {"city": "Marest-Dampcourt"},
    {"city": "Mareuil-en-Dôle"},
    {"city": "Marfontaine"},
    {"city": "Margival"},
    {"city": "Marigny-en-Orxois"},
    {"city": "Marizy-Sainte-Geneviève"},
    {"city": "Marizy-Saint-Mard"},
    {"city": "Marle"},
    {"city": "Marly-Gomont"},
    {"city": "Martigny"},
    {"city": "Martigny-Courpierre"},
    {"city": "Mauregny-en-Haye"},
    {"city": "Mayot"},
    {"city": "Mennessis"},
    {"city": "Mennevret"},
    {"city": "Mercin-et-Vaux"},
    {"city": "Merlieux-et-Fouquerolles"},
    {"city": "Mesbrecourt-Richecourt"},
    {"city": "Mesnil-Saint-Laurent"},
    {"city": "Meurival"},
    {"city": "Mézières-sur-Oise"},
    {"city": "Mézy-Moulins"},
    {"city": "Missy-aux-Bois"},
    {"city": "Missy-lès-Pierrepont"},
    {"city": "Missy-sur-Aisne"},
    {"city": "Molain"},
    {"city": "Molinchart"},
    {"city": "Monampteuil"},
    {"city": "Monceau-le-Neuf-et-Faucouzy"},
    {"city": "Monceau-lès-Leups"},
    {"city": "Monceau-le-Waast"},
    {"city": "Monceau-sur-Oise"},
    {"city": "Mondrepuis"},
    {"city": "Monnes"},
    {"city": "Mons-en-Laonnois"},
    {"city": "Montaigu"},
    {"city": "Montbavin"},
    {"city": "Montbrehain"},
    {"city": "Montchâlons"},
    {"city": "Montcornet"},
    {"city": "Mont-d'Origny"},
    {"city": "Montescourt-Lizerolles"},
    {"city": "Montfaucon"},
    {"city": "Montgobert"},
    {"city": "Montgru-Saint-Hilaire"},
    {"city": "Monthenault"},
    {"city": "Monthiers"},
    {"city": "Monthurel"},
    {"city": "Montigny-en-Arrouaise"},
    {"city": "Montigny-l'Allier"},
    {"city": "Montigny-le-Franc"},
    {"city": "Montigny-Lengrain"},
    {"city": "Montigny-lès-Condé"},
    {"city": "Montigny-sous-Marle"},
    {"city": "Montigny-sur-Crécy"},
    {"city": "Montlevon"},
    {"city": "Montloué"},
    {"city": "Mont-Notre-Dame"},
    {"city": "Montreuil-aux-Lions"},
    {"city": "Mont-Saint-Jean"},
    {"city": "Mont-Saint-Martin"},
    {"city": "Mont-Saint-Père"},
    {"city": "Morcourt"},
    {"city": "Morgny-en-Thiérache"},
    {"city": "Morsain"},
    {"city": "Mortefontaine"},
    {"city": "Mortiers"},
    {"city": "Moulins"},
    {"city": "Moussy-Verneuil"},
    {"city": "Moÿ-de-l'Aisne"},
    {"city": "Muret-et-Crouttes"},
    {"city": "Muscourt"},
    {"city": "Nampcelles-la-Cour"},
    {"city": "Nampteuil-sous-Muret"},
    {"city": "Nanteuil-la-Fosse"},
    {"city": "Nanteuil-Notre-Dame"},
    {"city": "Nauroy"},
    {"city": "Nesles-la-Montagne"},
    {"city": "Neufchâtel-sur-Aisne"},
    {"city": "Neuflieux"},
    {"city": "Neuilly-Saint-Front"},
    {"city": "Neuve-Maison"},
    {"city": "La Neuville-Bosmont"},
    {"city": "La Neuville-en-Beine"},
    {"city": "La Neuville-Housset"},
    {"city": "La Neuville-lès-Dorengt"},
    {"city": "Neuville-Saint-Amand"},
    {"city": "Neuville-sur-Ailette"},
    {"city": "Neuville-sur-Margival"},
    {"city": "Neuvillette"},
    {"city": "Nizy-le-Comte"},
    {"city": "Nogentel"},
    {"city": "Nogent-l'Artaud"},
    {"city": "Noircourt"},
    {"city": "Noroy-sur-Ourcq"},
    {"city": "Le Nouvion-en-Thiérache"},
    {"city": "Nouvion-et-Catillon"},
    {"city": "Nouvion-le-Comte"},
    {"city": "Nouvion-le-Vineux"},
    {"city": "Nouvron-Vingré"},
    {"city": "Noyales"},
    {"city": "Noyant-et-Aconin"},
    {"city": "Œuilly"},
    {"city": "Ognes"},
    {"city": "Ohis"},
    {"city": "Oigny-en-Valois"},
    {"city": "Oisy"},
    {"city": "Ollezy"},
    {"city": "Omissy"},
    {"city": "Orainville"},
    {"city": "Orgeval"},
    {"city": "Origny-en-Thiérache"},
    {"city": "Origny-Sainte-Benoite"},
    {"city": "Osly-Courtil"},
    {"city": "Ostel"},
    {"city": "Oulches-la-Vallée-Foulon"},
    {"city": "Oulchy-la-Ville"},
    {"city": "Oulchy-le-Château"},
    {"city": "Paars"},
    {"city": "Paissy"},
    {"city": "Pancy-Courtecon"},
    {"city": "Papleux"},
    {"city": "Parcy-et-Tigny"},
    {"city": "Parfondeval"},
    {"city": "Parfondru"},
    {"city": "Pargnan"},
    {"city": "Pargny-Filain"},
    {"city": "Pargny-la-Dhuys"},
    {"city": "Pargny-les-Bois"},
    {"city": "Parpeville"},
    {"city": "Pasly"},
    {"city": "Passy-en-Valois"},
    {"city": "Passy-sur-Marne"},
    {"city": "Pavant"},
    {"city": "Pernant"},
    {"city": "Pierremande"},
    {"city": "Pierrepont"},
    {"city": "Pignicourt"},
    {"city": "Pinon"},
    {"city": "Pithon"},
    {"city": "Pleine-Selve"},
    {"city": "Le Plessier-Huleu"},
    {"city": "Ploisy"},
    {"city": "Plomion"},
    {"city": "Ployart-et-Vaurseine"},
    {"city": "Pommiers"},
    {"city": "Pont-Arcy"},
    {"city": "Pontavert"},
    {"city": "Pontru"},
    {"city": "Pontruet"},
    {"city": "Pont-Saint-Mard"},
    {"city": "Pouilly-sur-Serre"},
    {"city": "Prémont"},
    {"city": "Prémontré"},
    {"city": "Presles-et-Boves"},
    {"city": "Presles-et-Thierny"},
    {"city": "Priez"},
    {"city": "Prisces"},
    {"city": "Proisy"},
    {"city": "Proix"},
    {"city": "Prouvais"},
    {"city": "Proviseux-et-Plesnoy"},
    {"city": "Puiseux-en-Retz"},
    {"city": "Puisieux-et-Clanlieu"},
    {"city": "Quierzy"},
    {"city": "Quincy-Basse"},
    {"city": "Quincy-sous-le-Mont"},
    {"city": "Raillimont"},
    {"city": "Ramicourt"},
    {"city": "Regny"},
    {"city": "Remaucourt"},
    {"city": "Remies"},
    {"city": "Remigny"},
    {"city": "Renansart"},
    {"city": "Renneval"},
    {"city": "Résigny"},
    {"city": "Ressons-le-Long"},
    {"city": "Retheuil"},
    {"city": "Reuilly-Sauvigny"},
    {"city": "Ribeauville"},
    {"city": "Ribemont"},
    {"city": "Rocourt-Saint-Martin"},
    {"city": "Rocquigny"},
    {"city": "Rogécourt"},
    {"city": "Rogny"},
    {"city": "Romeny-sur-Marne"},
    {"city": "Romery"},
    {"city": "Ronchères"},
    {"city": "Roucy"},
    {"city": "Rougeries"},
    {"city": "Roupy"},
    {"city": "Rouvroy"},
    {"city": "Rouvroy-sur-Serre"},
    {"city": "Royaucourt-et-Chailvet"},
    {"city": "Rozet-Saint-Albin"},
    {"city": "Rozières-sur-Crise"},
    {"city": "Rozoy-Bellevalle"},
    {"city": "Grand-Rozoy"},
    {"city": "Rozoy-sur-Serre"},
    {"city": "Saconin-et-Breuil"},
    {"city": "Sains-Richaumont"},
    {"city": "Saint-Algis"},
    {"city": "Saint-Aubin"},
    {"city": "Saint-Bandry"},
    {"city": "Saint-Christophe-à-Berry"},
    {"city": "Saint-Clément"},
    {"city": "Sainte-Croix"},
    {"city": "Saint-Erme-Outre-et-Ramecourt"},
    {"city": "Saint-Eugène"},
    {"city": "Sainte-Geneviève"},
    {"city": "Saint-Gengoulph"},
    {"city": "Saint-Gobain"},
    {"city": "Saint-Gobert"},
    {"city": "Saint-Mard"},
    {"city": "Saint-Martin-Rivière"},
    {"city": "Saint-Michel"},
    {"city": "Saint-Nicolas-aux-Bois"},
    {"city": "Saint-Paul-aux-Bois"},
    {"city": "Saint-Pierre-Aigle"},
    {"city": "Saint-Pierre-lès-Franqueville"},
    {"city": "Saint-Pierremont"},
    {"city": "Sainte-Preuve"},
    {"city": "Saint-Quentin"},
    {"city": "Saint-Rémy-Blanzy"},
    {"city": "Saint-Simon"},
    {"city": "Saint-Thibaut"},
    {"city": "Saint-Thomas"},
    {"city": "Samoussy"},
    {"city": "Sancy-les-Cheminots"},
    {"city": "Saponay"},
    {"city": "Saulchery"},
    {"city": "Savy"},
    {"city": "Seboncourt"},
    {"city": "Selens"},
    {"city": "La Selve"},
    {"city": "Septmonts"},
    {"city": "Septvaux"},
    {"city": "Sequehart"},
    {"city": "Serain"},
    {"city": "Seraucourt-le-Grand"},
    {"city": "Serches"},
    {"city": "Sergy"},
    {"city": "Seringes-et-Nesles"},
    {"city": "Sermoise"},
    {"city": "Serval"},
    {"city": "Servais"},
    {"city": "Séry-lès-Mézières"},
    {"city": "Silly-la-Poterie"},
    {"city": "Sinceny"},
    {"city": "Sissonne"},
    {"city": "Sissy"},
    {"city": "Soissons"},
    {"city": "Soize"},
    {"city": "Sommelans"},
    {"city": "Sommeron"},
    {"city": "Sommette-Eaucourt"},
    {"city": "Sons-et-Ronchères"},
    {"city": "Sorbais"},
    {"city": "Soucy"},
    {"city": "Soupir"},
    {"city": "Le Sourd"},
    {"city": "Surfontaine"},
    {"city": "Taillefontaine"},
    {"city": "Tannières"},
    {"city": "Tartiers"},
    {"city": "Tavaux-et-Pontséricourt"},
    {"city": "Tergnier"},
    {"city": "Terny-Sorny"},
    {"city": "Thenailles"},
    {"city": "Thenelles"},
    {"city": "Thiernu"},
    {"city": "Le Thuel"},
    {"city": "Torcy-en-Valois"},
    {"city": "Toulis-et-Attencourt"},
    {"city": "Travecy"},
    {"city": "Trefcon"},
    {"city": "Trélou-sur-Marne"},
    {"city": "Troësnes"},
    {"city": "Trosly-Loire"},
    {"city": "Trucy"},
    {"city": "Tugny-et-Pont"},
    {"city": "Tupigny"},
    {"city": "Ugny-le-Gay"},
    {"city": "Urcel"},
    {"city": "Urvillers"},
    {"city": "Vadencourt"},
    {"city": "Vailly-sur-Aisne"},
    {"city": "La Vallée-au-Blé"},
    {"city": "La Vallée-Mulâtre"},
    {"city": "Variscourt"},
    {"city": "Vassens"},
    {"city": "Vasseny"},
    {"city": "Vassogne"},
    {"city": "Vaucelles-et-Beffecourt"},
    {"city": "Vaudesson"},
    {"city": "Vauxrezis"},
    {"city": "Vauxaillon"},
    {"city": "Vaux-Andigny"},
    {"city": "Vauxbuin"},
    {"city": "Vaux-en-Vermandois"},
    {"city": "Vauxtin"},
    {"city": "Vendelles"},
    {"city": "Vendeuil"},
    {"city": "Vendhuile"},
    {"city": "Vendières"},
    {"city": "Vendresse-Beaulne"},
    {"city": "Vénérolles"},
    {"city": "Venizel"},
    {"city": "Verdilly"},
    {"city": "Le Verguier"},
    {"city": "Grand-Verly"},
    {"city": "Petit-Verly"},
    {"city": "Vermand"},
    {"city": "Verneuil-sous-Coucy"},
    {"city": "Verneuil-sur-Serre"},
    {"city": "Versigny"},
    {"city": "Vervins"},
    {"city": "Vesles-et-Caumont"},
    {"city": "Veslud"},
    {"city": "Veuilly-la-Poterie"},
    {"city": "Vézaponin"},
    {"city": "Vézilly"},
    {"city": "Vic-sur-Aisne"},
    {"city": "Vichel-Nanteuil"},
    {"city": "Viel-Arcy"},
    {"city": "Viels-Maisons"},
    {"city": "Vierzy"},
    {"city": "Viffort"},
    {"city": "Vigneux-Hocquet"},
    {"city": "La Ville-aux-Bois-lès-Dizy"},
    {"city": "La Ville-aux-Bois-lès-Pontavert"},
    {"city": "Villemontoire"},
    {"city": "Villeneuve-Saint-Germain"},
    {"city": "Villeneuve-sur-Fère"},
    {"city": "Villequier-Aumont"},
    {"city": "Villeret"},
    {"city": "Villers-Agron-Aiguizy"},
    {"city": "Villers-Cotterêts"},
    {"city": "Villers-Hélon"},
    {"city": "Villers-le-Sec"},
    {"city": "Villers-lès-Guise"},
    {"city": "Villers-Saint-Christophe"},
    {"city": "Villers-sur-Fère"},
    {"city": "Ville-Savoye"},
    {"city": "Villiers-Saint-Denis"},
    {"city": "Vincy-Reuil-et-Magny"},
    {"city": "Viry-Noureuil"},
    {"city": "Vivaise"},
    {"city": "Vivières"},
    {"city": "Voharies"},
    {"city": "Vorges"},
    {"city": "Voulpaix"},
    {"city": "Voyenne"},
    {"city": "Vregny"},
    {"city": "Vuillery"},
    {"city": "Wassigny"},
    {"city": "Watigny"},
    {"city": "Wiège-Faty"},
    {"city": "Wimy"},
    {"city": "Wissignicourt"},
    {"city": "Abrest"},
    {"city": "Agonges"},
    {"city": "Ainay-le-Château"},
    {"city": "Andelaroche"},
    {"city": "Archignat"},
    {"city": "Arfeuilles"},
    {"city": "Arpheuilles-Saint-Priest"},
    {"city": "Arronnes"},
    {"city": "Aubigny"},
    {"city": "Audes"},
    {"city": "Aurouër"},
    {"city": "Autry-Issards"},
    {"city": "Avermes"},
    {"city": "Avrilly"},
    {"city": "Bagneux"},
    {"city": "Barberier"},
    {"city": "Barrais-Bussolles"},
    {"city": "Bayet"},
    {"city": "Beaulon"},
    {"city": "Beaune-d'Allier"},
    {"city": "Bègues"},
    {"city": "Bellenaves"},
    {"city": "Bellerive-sur-Allier"},
    {"city": "Bert"},
    {"city": "Bessay-sur-Allier"},
    {"city": "Besson"},
    {"city": "Bézenet"},
    {"city": "Billezois"},
    {"city": "Billy"},
    {"city": "Biozat"},
    {"city": "Bizeneuille"},
    {"city": "Blomard"},
    {"city": "Bost"},
    {"city": "Boucé"},
    {"city": "Le Bouchaud"},
    {"city": "Bourbon-l'Archambault"},
    {"city": "Braize"},
    {"city": "Bransat"},
    {"city": "Bresnay"},
    {"city": "Bressolles"},
    {"city": "Le Brethon"},
    {"city": "Le Breuil"},
    {"city": "Broût-Vernet"},
    {"city": "Brugheas"},
    {"city": "Busset"},
    {"city": "Buxières-les-Mines"},
    {"city": "La Celle"},
    {"city": "Cérilly"},
    {"city": "Cesset"},
    {"city": "La Chabanne"},
    {"city": "Chambérat"},
    {"city": "Chamblet"},
    {"city": "Chantelle"},
    {"city": "Chapeau"},
    {"city": "La Chapelaude"},
    {"city": "La Chapelle"},
    {"city": "La Chapelle-aux-Chasses"},
    {"city": "Chappes"},
    {"city": "Chareil-Cintrat"},
    {"city": "Charmeil"},
    {"city": "Charmes"},
    {"city": "Charroux"},
    {"city": "Chassenard"},
    {"city": "Château-sur-Allier"},
    {"city": "Châtel-de-Neuvre"},
    {"city": "Châtel-Montagne"},
    {"city": "Châtelperron"},
    {"city": "Châtelus"},
    {"city": "Châtillon"},
    {"city": "Chavenon"},
    {"city": "Chavroches"},
    {"city": "Chazemais"},
    {"city": "Chemilly"},
    {"city": "Chevagnes"},
    {"city": "Chezelle"},
    {"city": "Chézy"},
    {"city": "Chirat-l'Église"},
    {"city": "Chouvigny"},
    {"city": "Cindré"},
    {"city": "Cognat-Lyonne"},
    {"city": "Colombier"},
    {"city": "Commentry"},
    {"city": "Contigny"},
    {"city": "Cosne-d'Allier"},
    {"city": "Coulandon"},
    {"city": "Coulanges"},
    {"city": "Couleuvre"},
    {"city": "Courçais"},
    {"city": "Coutansouze"},
    {"city": "Couzon"},
    {"city": "Créchy"},
    {"city": "Cressanges"},
    {"city": "Creuzier-le-Neuf"},
    {"city": "Creuzier-le-Vieux"},
    {"city": "Cusset"},
    {"city": "Deneuille-lès-Chantelle"},
    {"city": "Deneuille-les-Mines"},
    {"city": "Désertines"},
    {"city": "Deux-Chaises"},
    {"city": "Diou"},
    {"city": "Domérat"},
    {"city": "Dompierre-sur-Besbre"},
    {"city": "Le Donjon"},
    {"city": "Doyet"},
    {"city": "Droiturier"},
    {"city": "Durdat-Larequille"},
    {"city": "Ébreuil"},
    {"city": "Échassières"},
    {"city": "Escurolles"},
    {"city": "Espinasse-Vozelle"},
    {"city": "Estivareilles"},
    {"city": "Étroussat"},
    {"city": "Ferrières-sur-Sichon"},
    {"city": "La Ferté-Hauterive"},
    {"city": "Fleuriel"},
    {"city": "Fourilles"},
    {"city": "Franchesse"},
    {"city": "Gannat"},
    {"city": "Gannay-sur-Loire"},
    {"city": "Garnat-sur-Engièvre"},
    {"city": "Gennetines"},
    {"city": "Gipcy"},
    {"city": "Gouise"},
    {"city": "La Guillermie"},
    {"city": "Hauterive"},
    {"city": "Hérisson"},
    {"city": "Huriel"},
    {"city": "Hyds"},
    {"city": "Isle-et-Bardais"},
    {"city": "Isserpent"},
    {"city": "Jaligny-sur-Besbre"},
    {"city": "Jenzat"},
    {"city": "Laféline"},
    {"city": "Lalizolle"},
    {"city": "Lamaids"},
    {"city": "Langy"},
    {"city": "Lapalisse"},
    {"city": "Laprugne"},
    {"city": "Lavault-Sainte-Anne"},
    {"city": "Lavoine"},
    {"city": "Lenax"},
    {"city": "Lételon"},
    {"city": "Liernolles"},
    {"city": "Lignerolles"},
    {"city": "Limoise"},
    {"city": "Loddes"},
    {"city": "Loriges"},
    {"city": "Louchy-Montfand"},
    {"city": "Louroux-Bourbonnais"},
    {"city": "Louroux-de-Beaune"},
    {"city": "Louroux-de-Bouble"},
    {"city": "Luneau"},
    {"city": "Lurcy-Lévis"},
    {"city": "Lusigny"},
    {"city": "Magnet"},
    {"city": "Haut-Bocage"},
    {"city": "Malicorne"},
    {"city": "Marcenat"},
    {"city": "Marcillat-en-Combraille"},
    {"city": "Marigny"},
    {"city": "Mariol"},
    {"city": "Le Mayet-d'École"},
    {"city": "Le Mayet-de-Montagne"},
    {"city": "Mazerier"},
    {"city": "Mazirat"},
    {"city": "Meaulne-Vitray"},
    {"city": "Meillard"},
    {"city": "Meillers"},
    {"city": "Mercy"},
    {"city": "Mesples"},
    {"city": "Molinet"},
    {"city": "Molles"},
    {"city": "Monestier"},
    {"city": "Monétay-sur-Allier"},
    {"city": "Monétay-sur-Loire"},
    {"city": "Montaiguët-en-Forez"},
    {"city": "Montaigu-le-Blin"},
    {"city": "Montbeugny"},
    {"city": "Montcombroux-les-Mines"},
    {"city": "Monteignet-sur-l'Andelot"},
    {"city": "Le Montet"},
    {"city": "Montilly"},
    {"city": "Montluçon"},
    {"city": "Montmarault"},
    {"city": "Montoldre"},
    {"city": "Montord"},
    {"city": "Montvicq"},
    {"city": "Moulins"},
    {"city": "Murat"},
    {"city": "Nades"},
    {"city": "Nassigny"},
    {"city": "Naves"},
    {"city": "Néris-les-Bains"},
    {"city": "Neuilly-en-Donjon"},
    {"city": "Neuilly-le-Réal"},
    {"city": "Neure"},
    {"city": "Neuvy"},
    {"city": "Nizerolles"},
    {"city": "Noyant-d'Allier"},
    {"city": "Paray-le-Frésil"},
    {"city": "Paray-sous-Briailles"},
    {"city": "Périgny"},
    {"city": "La Petite-Marche"},
    {"city": "Pierrefitte-sur-Loire"},
    {"city": "Le Pin"},
    {"city": "Poëzat"},
    {"city": "Pouzy-Mésangy"},
    {"city": "Prémilhat"},
    {"city": "Quinssaines"},
    {"city": "Reugny"},
    {"city": "Rocles"},
    {"city": "Rongères"},
    {"city": "Ronnet"},
    {"city": "Saint-Angel"},
    {"city": "Saint-Aubin-le-Monial"},
    {"city": "Saint-Bonnet-de-Four"},
    {"city": "Saint-Bonnet-de-Rochefort"},
    {"city": "Saint-Bonnet-Tronçais"},
    {"city": "Saint-Caprais"},
    {"city": "Saint-Christophe"},
    {"city": "Saint-Clément"},
    {"city": "Saint-Désiré"},
    {"city": "Saint-Didier-en-Donjon"},
    {"city": "Saint-Didier-la-Forêt"},
    {"city": "Saint-Éloy-d'Allier"},
    {"city": "Saint-Ennemond"},
    {"city": "Saint-Étienne-de-Vicq"},
    {"city": "Saint-Fargeol"},
    {"city": "Saint-Félix"},
    {"city": "Saint-Genest"},
    {"city": "Saint-Gérand-de-Vaux"},
    {"city": "Saint-Gérand-le-Puy"},
    {"city": "Saint-Germain-des-Fossés"},
    {"city": "Saint-Germain-de-Salles"},
    {"city": "Saint-Hilaire"},
    {"city": "Saint-Léger-sur-Vouzance"},
    {"city": "Saint-Léon"},
    {"city": "Saint-Léopardin-d'Augy"},
    {"city": "Saint-Loup"},
    {"city": "Saint-Marcel-en-Murat"},
    {"city": "Saint-Marcel-en-Marcillat"},
    {"city": "Saint-Martin-des-Lais"},
    {"city": "Saint-Martinien"},
    {"city": "Saint-Menoux"},
    {"city": "Saint-Nicolas-des-Biefs"},
    {"city": "Saint-Palais"},
    {"city": "Saint-Pierre-Laval"},
    {"city": "Saint-Plaisir"},
    {"city": "Saint-Pont"},
    {"city": "Saint-Pourçain-sur-Besbre"},
    {"city": "Saint-Pourçain-sur-Sioule"},
    {"city": "Saint-Priest-d'Andelot"},
    {"city": "Saint-Priest-en-Murat"},
    {"city": "Saint-Prix"},
    {"city": "Saint-Rémy-en-Rollat"},
    {"city": "Saint-Sauvier"},
    {"city": "Saint-Sornin"},
    {"city": "Sainte-Thérence"},
    {"city": "Saint-Victor"},
    {"city": "Saint-Voir"},
    {"city": "Saint-Yorre"},
    {"city": "Saligny-sur-Roudon"},
    {"city": "Sanssat"},
    {"city": "Saulcet"},
    {"city": "Saulzet"},
    {"city": "Sauvagny"},
    {"city": "Sazeret"},
    {"city": "Serbannes"},
    {"city": "Servilly"},
    {"city": "Seuillet"},
    {"city": "Sorbier"},
    {"city": "Souvigny"},
    {"city": "Sussat"},
    {"city": "Target"},
    {"city": "Taxat-Senat"},
    {"city": "Teillet-Argenty"},
    {"city": "Terjat"},
    {"city": "Le Theil"},
    {"city": "Theneuille"},
    {"city": "Thiel-sur-Acolin"},
    {"city": "Thionne"},
    {"city": "Tortezais"},
    {"city": "Toulon-sur-Allier"},
    {"city": "Treban"},
    {"city": "Treignat"},
    {"city": "Treteau"},
    {"city": "Trévol"},
    {"city": "Trézelles"},
    {"city": "Tronget"},
    {"city": "Urçay"},
    {"city": "Ussel-d'Allier"},
    {"city": "Valignat"},
    {"city": "Valigny"},
    {"city": "Vallon-en-Sully"},
    {"city": "Varennes-sur-Allier"},
    {"city": "Varennes-sur-Tèche"},
    {"city": "Vaumas"},
    {"city": "Vaux"},
    {"city": "Veauce"},
    {"city": "Venas"},
    {"city": "Vendat"},
    {"city": "Verneix"},
    {"city": "Le Vernet"},
    {"city": "Verneuil-en-Bourbonnais"},
    {"city": "Vernusse"},
    {"city": "Le Veurdre"},
    {"city": "Vichy"},
    {"city": "Vicq"},
    {"city": "Vieure"},
    {"city": "Le Vilhain"},
    {"city": "Villebret"},
    {"city": "Villefranche-d'Allier"},
    {"city": "Villeneuve-sur-Allier"},
    {"city": "Viplaix"},
    {"city": "Voussac"},
    {"city": "Ygrande"},
    {"city": "Yzeure"},
    {"city": "Aiglun"},
    {"city": "Allemagne-en-Provence"},
    {"city": "Allons"},
    {"city": "Allos"},
    {"city": "Angles"},
    {"city": "Annot"},
    {"city": "Archail"},
    {"city": "Aubenas-les-Alpes"},
    {"city": "Aubignosc"},
    {"city": "Authon"},
    {"city": "Auzet"},
    {"city": "Banon"},
    {"city": "Barcelonnette"},
    {"city": "Barles"},
    {"city": "Barras"},
    {"city": "Barrême"},
    {"city": "Bayons"},
    {"city": "Beaujeu"},
    {"city": "Beauvezer"},
    {"city": "Bellaffaire"},
    {"city": "Bevons"},
    {"city": "Beynes"},
    {"city": "Blieux"},
    {"city": "Bras-d'Asse"},
    {"city": "Braux"},
    {"city": "Ubaye-Serre-Ponçon"},
    {"city": "La Brillanne"},
    {"city": "Brunet"},
    {"city": "Le Brusquet"},
    {"city": "Le Caire"},
    {"city": "Castellane"},
    {"city": "Le Castellard-Mélan"},
    {"city": "Le Castellet"},
    {"city": "Castellet-lès-Sausses"},
    {"city": "Val-de-Chalvagne"},
    {"city": "Céreste"},
    {"city": "Le Chaffaut-Saint-Jurson"},
    {"city": "Champtercier"},
    {"city": "Château-Arnoux-Saint-Auban"},
    {"city": "Châteaufort"},
    {"city": "Châteauneuf-Miravail"},
    {"city": "Châteauneuf-Val-Saint-Donat"},
    {"city": "Châteauredon"},
    {"city": "Chaudon-Norante"},
    {"city": "Clamensane"},
    {"city": "Claret"},
    {"city": "Clumanc"},
    {"city": "Colmars"},
    {"city": "La Condamine-Châtelard"},
    {"city": "Corbières-en-Provence"},
    {"city": "Cruis"},
    {"city": "Curbans"},
    {"city": "Curel"},
    {"city": "Dauphin"},
    {"city": "Demandolx"},
    {"city": "Digne-les-Bains"},
    {"city": "Draix"},
    {"city": "Enchastrayes"},
    {"city": "Entrages"},
    {"city": "Entrepierres"},
    {"city": "Entrevaux"},
    {"city": "Entrevennes"},
    {"city": "L'Escale"},
    {"city": "Esparron-de-Verdon"},
    {"city": "Estoublon"},
    {"city": "Faucon-du-Caire"},
    {"city": "Faucon-de-Barcelonnette"},
    {"city": "Fontienne"},
    {"city": "Forcalquier"},
    {"city": "Le Fugeret"},
    {"city": "Ganagobie"},
    {"city": "La Garde"},
    {"city": "Gigors"},
    {"city": "Gréoux-les-Bains"},
    {"city": "L'Hospitalet"},
    {"city": "Jausiers"},
    {"city": "La Javie"},
    {"city": "Lambruisse"},
    {"city": "Lardiers"},
    {"city": "Le Lauzet-Ubaye"},
    {"city": "Limans"},
    {"city": "Lurs"},
    {"city": "Majastres"},
    {"city": "Malijai"},
    {"city": "Mallefougasse-Augès"},
    {"city": "Mallemoisson"},
    {"city": "Mane"},
    {"city": "Manosque"},
    {"city": "Marcoux"},
    {"city": "Méailles"},
    {"city": "Les Mées"},
    {"city": "Melve"},
    {"city": "Val d'Oronaye"},
    {"city": "Mézel"},
    {"city": "Mirabeau"},
    {"city": "Mison"},
    {"city": "Montagnac-Montpezat"},
    {"city": "Montclar"},
    {"city": "Montfort"},
    {"city": "Montfuron"},
    {"city": "Montjustin"},
    {"city": "Montlaux"},
    {"city": "Montsalier"},
    {"city": "Moriez"},
    {"city": "La Motte-du-Caire"},
    {"city": "Moustiers-Sainte-Marie"},
    {"city": "La Mure-Argens"},
    {"city": "Nibles"},
    {"city": "Niozelles"},
    {"city": "Noyers-sur-Jabron"},
    {"city": "Les Omergues"},
    {"city": "Ongles"},
    {"city": "Oppedette"},
    {"city": "Oraison"},
    {"city": "La Palud-sur-Verdon"},
    {"city": "Peipin"},
    {"city": "Peyroules"},
    {"city": "Peyruis"},
    {"city": "Piégut"},
    {"city": "Pierrerue"},
    {"city": "Pierrevert"},
    {"city": "Pontis"},
    {"city": "Prads-Haute-Bléone"},
    {"city": "Puimichel"},
    {"city": "Puimoisson"},
    {"city": "Quinson"},
    {"city": "Redortiers"},
    {"city": "Reillanne"},
    {"city": "Méolans-Revel"},
    {"city": "Revest-des-Brousses"},
    {"city": "Revest-du-Bion"},
    {"city": "Revest-Saint-Martin"},
    {"city": "Riez"},
    {"city": "La Robine-sur-Galabre"},
    {"city": "La Rochegiron"},
    {"city": "La Rochette"},
    {"city": "Rougon"},
    {"city": "Roumoules"},
    {"city": "Saint-André-les-Alpes"},
    {"city": "Saint-Benoît"},
    {"city": "Sainte-Croix-à-Lauze"},
    {"city": "Sainte-Croix-du-Verdon"},
    {"city": "Hautes-Duyes"},
    {"city": "Saint-Étienne-les-Orgues"},
    {"city": "Saint-Geniez"},
    {"city": "Saint-Jacques"},
    {"city": "Saint-Jeannet"},
    {"city": "Saint-Julien-d'Asse"},
    {"city": "Saint-Julien-du-Verdon"},
    {"city": "Saint-Jurs"},
    {"city": "Saint-Laurent-du-Verdon"},
    {"city": "Saint-Lions"},
    {"city": "Saint-Maime"},
    {"city": "Saint-Martin-de-Brômes"},
    {"city": "Saint-Martin-les-Eaux"},
    {"city": "Saint-Martin-lès-Seyne"},
    {"city": "Saint-Michel-l'Observatoire"},
    {"city": "Saint-Paul-sur-Ubaye"},
    {"city": "Saint-Pierre"},
    {"city": "Saint-Pons"},
    {"city": "Sainte-Tulle"},
    {"city": "Saint-Vincent-sur-Jabron"},
    {"city": "Salignac"},
    {"city": "Saumane"},
    {"city": "Sausses"},
    {"city": "Selonnet"},
    {"city": "Senez"},
    {"city": "Seyne"},
    {"city": "Sigonce"},
    {"city": "Sigoyer"},
    {"city": "Simiane-la-Rotonde"},
    {"city": "Sisteron"},
    {"city": "Soleilhas"},
    {"city": "Sourribes"},
    {"city": "Tartonne"},
    {"city": "Thèze"},
    {"city": "Thoard"},
    {"city": "Thorame-Basse"},
    {"city": "Thorame-Haute"},
    {"city": "Les Thuiles"},
    {"city": "Turriers"},
    {"city": "Ubraye"},
    {"city": "Uvernet-Fours"},
    {"city": "Vachères"},
    {"city": "Valavoire"},
    {"city": "Valbelle"},
    {"city": "Valensole"},
    {"city": "Valernes"},
    {"city": "Vaumeilh"},
    {"city": "Venterol"},
    {"city": "Verdaches"},
    {"city": "Vergons"},
    {"city": "Le Vernet"},
    {"city": "Villars-Colmars"},
    {"city": "Villemus"},
    {"city": "Villeneuve"},
    {"city": "Volonne"},
    {"city": "Volx"},
    {"city": "Abriès-Ristolas"},
    {"city": "Aiguilles"},
    {"city": "Ancelle"},
    {"city": "L'Argentière-la-Bessée"},
    {"city": "Arvieux"},
    {"city": "Aspremont"},
    {"city": "Aspres-lès-Corps"},
    {"city": "Aspres-sur-Buëch"},
    {"city": "Avançon"},
    {"city": "Baratier"},
    {"city": "Barcillonnette"},
    {"city": "Barret-sur-Méouge"},
    {"city": "La Bâtie-Montsaléon"},
    {"city": "La Bâtie-Neuve"},
    {"city": "La Bâtie-Vieille"},
    {"city": "La Beaume"},
    {"city": "Le Bersac"},
    {"city": "Bréziers"},
    {"city": "Briançon"},
    {"city": "Valdoule"},
    {"city": "Buissard"},
    {"city": "Ceillac"},
    {"city": "Cervières"},
    {"city": "Chabestan"},
    {"city": "Chabottes"},
    {"city": "Champcella"},
    {"city": "Champoléon"},
    {"city": "Chanousse"},
    {"city": "Châteauneuf-d'Oze"},
    {"city": "Châteauroux-les-Alpes"},
    {"city": "Châteauvieux"},
    {"city": "Château-Ville-Vieille"},
    {"city": "Aubessagne"},
    {"city": "Chorges"},
    {"city": "Crévoux"},
    {"city": "Crots"},
    {"city": "Embrun"},
    {"city": "Éourres"},
    {"city": "L'Épine"},
    {"city": "Esparron"},
    {"city": "Espinasses"},
    {"city": "Étoile-Saint-Cyrice"},
    {"city": "Eygliers"},
    {"city": "Garde-Colombe"},
    {"city": "La Fare-en-Champsaur"},
    {"city": "La Faurie"},
    {"city": "Forest-Saint-Julien"},
    {"city": "Fouillouse"},
    {"city": "Freissinières"},
    {"city": "La Freissinouse"},
    {"city": "Furmeyer"},
    {"city": "Gap"},
    {"city": "Le Glaizil"},
    {"city": "La Grave"},
    {"city": "La Chapelle-en-Valgaudémar"},
    {"city": "Guillestre"},
    {"city": "La Haute-Beaume"},
    {"city": "Jarjayes"},
    {"city": "Laragne-Montéglin"},
    {"city": "Lardier-et-Valença"},
    {"city": "Laye"},
    {"city": "Lazer"},
    {"city": "Lettret"},
    {"city": "Manteyer"},
    {"city": "Méreuil"},
    {"city": "Molines-en-Queyras"},
    {"city": "Monêtier-Allemont"},
    {"city": "Le Monêtier-les-Bains"},
    {"city": "Montbrand"},
    {"city": "Montclus"},
    {"city": "Mont-Dauphin"},
    {"city": "Montgardin"},
    {"city": "Montgenèvre"},
    {"city": "Montjay"},
    {"city": "Montmaur"},
    {"city": "Montrond"},
    {"city": "La Motte-en-Champsaur"},
    {"city": "Moydans"},
    {"city": "Neffes"},
    {"city": "Névache"},
    {"city": "Nossage-et-Bénévent"},
    {"city": "Le Noyer"},
    {"city": "Orcières"},
    {"city": "Orpierre"},
    {"city": "Les Orres"},
    {"city": "Oze"},
    {"city": "Pelleautier"},
    {"city": "Vallouise-Pelvoux"},
    {"city": "La Piarre"},
    {"city": "Le Poët"},
    {"city": "Poligny"},
    {"city": "Prunières"},
    {"city": "Puy-Saint-André"},
    {"city": "Puy-Saint-Eusèbe"},
    {"city": "Puy-Saint-Pierre"},
    {"city": "Puy-Saint-Vincent"},
    {"city": "Puy-Sanières"},
    {"city": "Rabou"},
    {"city": "Rambaud"},
    {"city": "Réallon"},
    {"city": "Remollon"},
    {"city": "Réotier"},
    {"city": "Ribeyret"},
    {"city": "Val Buëch-Méouge"},
    {"city": "Risoul"},
    {"city": "Rochebrune"},
    {"city": "La Roche-de-Rame"},
    {"city": "La Roche-des-Arnauds"},
    {"city": "La Rochette"},
    {"city": "Rosans"},
    {"city": "Rousset"},
    {"city": "Saint-André-d'Embrun"},
    {"city": "Saint-André-de-Rosans"},
    {"city": "Saint-Apollinaire"},
    {"city": "Saint-Auban-d'Oze"},
    {"city": "Saint-Bonnet-en-Champsaur"},
    {"city": "Saint-Chaffrey"},
    {"city": "Saint-Clément-sur-Durance"},
    {"city": "Sainte-Colombe"},
    {"city": "Saint-Crépin"},
    {"city": "Dévoluy"},
    {"city": "Saint-Étienne-le-Laus"},
    {"city": "Saint-Firmin"},
    {"city": "Saint-Jacques-en-Valgodemard"},
    {"city": "Saint-Jean-Saint-Nicolas"},
    {"city": "Saint-Julien-en-Beauchêne"},
    {"city": "Saint-Julien-en-Champsaur"},
    {"city": "Saint-Laurent-du-Cros"},
    {"city": "Saint-Léger-les-Mélèzes"},
    {"city": "Saint-Martin-de-Queyrières"},
    {"city": "Saint-Maurice-en-Valgodemard"},
    {"city": "Saint-Michel-de-Chaillol"},
    {"city": "Saint-Pierre-d'Argençon"},
    {"city": "Saint-Pierre-Avez"},
    {"city": "Saint-Sauveur"},
    {"city": "Saint-Véran"},
    {"city": "Le Saix"},
    {"city": "Saléon"},
    {"city": "Salérans"},
    {"city": "La Salle-les-Alpes"},
    {"city": "La Saulce"},
    {"city": "Le Sauze-du-Lac"},
    {"city": "Savines-le-Lac"},
    {"city": "Savournon"},
    {"city": "Serres"},
    {"city": "Sigottier"},
    {"city": "Sigoyer"},
    {"city": "Sorbiers"},
    {"city": "Tallard"},
    {"city": "Théus"},
    {"city": "Trescléoux"},
    {"city": "Upaix"},
    {"city": "Val-des-Prés"},
    {"city": "Valserres"},
    {"city": "Vars"},
    {"city": "Ventavon"},
    {"city": "Veynes"},
    {"city": "Les Vigneaux"},
    {"city": "Villar-d'Arêne"},
    {"city": "Villar-Loubière"},
    {"city": "Villar-Saint-Pancrace"},
    {"city": "Vitrolles"},
    {"city": "Aiglun"},
    {"city": "Amirat"},
    {"city": "Andon"},
    {"city": "Antibes"},
    {"city": "Ascros"},
    {"city": "Aspremont"},
    {"city": "Auribeau-sur-Siagne"},
    {"city": "Auvare"},
    {"city": "Bairols"},
    {"city": "Le Bar-sur-Loup"},
    {"city": "Beaulieu-sur-Mer"},
    {"city": "Beausoleil"},
    {"city": "Belvédère"},
    {"city": "Bendejun"},
    {"city": "Berre-les-Alpes"},
    {"city": "Beuil"},
    {"city": "Bézaudun-les-Alpes"},
    {"city": "Biot"},
    {"city": "Blausasc"},
    {"city": "La Bollène-Vésubie"},
    {"city": "Bonson"},
    {"city": "Bouyon"},
    {"city": "Breil-sur-Roya"},
    {"city": "Briançonnet"},
    {"city": "Le Broc"},
    {"city": "Cabris"},
    {"city": "Cagnes-sur-Mer"},
    {"city": "Caille"},
    {"city": "Cannes"},
    {"city": "Le Cannet"},
    {"city": "Cantaron"},
    {"city": "Cap-d'Ail"},
    {"city": "Carros"},
    {"city": "Castagniers"},
    {"city": "Castellar"},
    {"city": "Castillon"},
    {"city": "Caussols"},
    {"city": "Châteauneuf-Grasse"},
    {"city": "Châteauneuf-Villevieille"},
    {"city": "Châteauneuf-d'Entraunes"},
    {"city": "Cipières"},
    {"city": "Clans"},
    {"city": "Coaraze"},
    {"city": "La Colle-sur-Loup"},
    {"city": "Collongues"},
    {"city": "Colomars"},
    {"city": "Conségudes"},
    {"city": "Contes"},
    {"city": "Courmes"},
    {"city": "Coursegoules"},
    {"city": "La Croix-sur-Roudoule"},
    {"city": "Cuébris"},
    {"city": "Daluis"},
    {"city": "Drap"},
    {"city": "Duranus"},
    {"city": "Entraunes"},
    {"city": "L'Escarène"},
    {"city": "Escragnolles"},
    {"city": "Èze"},
    {"city": "Falicon"},
    {"city": "Les Ferres"},
    {"city": "Fontan"},
    {"city": "Gars"},
    {"city": "Gattières"},
    {"city": "La Gaude"},
    {"city": "Gilette"},
    {"city": "Gorbio"},
    {"city": "Gourdon"},
    {"city": "Grasse"},
    {"city": "Gréolières"},
    {"city": "Guillaumes"},
    {"city": "Ilonse"},
    {"city": "Isola"},
    {"city": "Lantosque"},
    {"city": "Levens"},
    {"city": "Lieuche"},
    {"city": "Lucéram"},
    {"city": "Malaussène"},
    {"city": "Mandelieu-la-Napoule"},
    {"city": "Marie"},
    {"city": "Le Mas"},
    {"city": "Massoins"},
    {"city": "Menton"},
    {"city": "Mouans-Sartoux"},
    {"city": "Mougins"},
    {"city": "Moulinet"},
    {"city": "Les Mujouls"},
    {"city": "Nice"},
    {"city": "Opio"},
    {"city": "Pégomas"},
    {"city": "Peille"},
    {"city": "Peillon"},
    {"city": "La Penne"},
    {"city": "Péone"},
    {"city": "Peymeinade"},
    {"city": "Pierlas"},
    {"city": "Pierrefeu"},
    {"city": "Puget-Rostang"},
    {"city": "Puget-Théniers"},
    {"city": "Revest-les-Roches"},
    {"city": "Rigaud"},
    {"city": "Rimplas"},
    {"city": "Roquebillière"},
    {"city": "Roquebrune-Cap-Martin"},
    {"city": "Roquefort-les-Pins"},
    {"city": "Roquestéron"},
    {"city": "La Roque-en-Provence"},
    {"city": "La Roquette-sur-Siagne"},
    {"city": "La Roquette-sur-Var"},
    {"city": "Roubion"},
    {"city": "Roure"},
    {"city": "Le Rouret"},
    {"city": "Sainte-Agnès"},
    {"city": "Saint-André-de-la-Roche"},
    {"city": "Saint-Antonin"},
    {"city": "Saint-Auban"},
    {"city": "Saint-Blaise"},
    {"city": "Saint-Cézaire-sur-Siagne"},
    {"city": "Saint-Dalmas-le-Selvage"},
    {"city": "Saint-Étienne-de-Tinée"},
    {"city": "Saint-Jean-Cap-Ferrat"},
    {"city": "Saint-Jeannet"},
    {"city": "Saint-Laurent-du-Var"},
    {"city": "Saint-Léger"},
    {"city": "Saint-Martin-d'Entraunes"},
    {"city": "Saint-Martin-du-Var"},
    {"city": "Saint-Martin-Vésubie"},
    {"city": "Saint-Paul-de-Vence"},
    {"city": "Saint-Sauveur-sur-Tinée"},
    {"city": "Saint-Vallier-de-Thiey"},
    {"city": "Sallagriffon"},
    {"city": "Saorge"},
    {"city": "Sauze"},
    {"city": "Séranon"},
    {"city": "Sigale"},
    {"city": "Sospel"},
    {"city": "Spéracèdes"},
    {"city": "Théoule-sur-Mer"},
    {"city": "Thiéry"},
    {"city": "Le Tignet"},
    {"city": "Toudon"},
    {"city": "Touët-de-l'Escarène"},
    {"city": "Touët-sur-Var"},
    {"city": "La Tour"},
    {"city": "Tourette-du-Château"},
    {"city": "Tournefort"},
    {"city": "Tourrette-Levens"},
    {"city": "Tourrettes-sur-Loup"},
    {"city": "La Trinité"},
    {"city": "La Turbie"},
    {"city": "Utelle"},
    {"city": "Valbonne"},
    {"city": "Valdeblore"},
    {"city": "Valderoure"},
    {"city": "Vallauris"},
    {"city": "Venanson"},
    {"city": "Vence"},
    {"city": "Villars-sur-Var"},
    {"city": "Villefranche-sur-Mer"},
    {"city": "Villeneuve-d'Entraunes"},
    {"city": "Villeneuve-Loubet"},
    {"city": "La Brigue"},
    {"city": "Tende"},
    {"city": "Accons"},
    {"city": "Ailhon"},
    {"city": "Aizac"},
    {"city": "Ajoux"},
    {"city": "Alba-la-Romaine"},
    {"city": "Albon-d'Ardèche"},
    {"city": "Alboussière"},
    {"city": "Alissas"},
    {"city": "Andance"},
    {"city": "Annonay"},
    {"city": "Vallées-d'Antraigues-Asperjoc"},
    {"city": "Arcens"},
    {"city": "Ardoix"},
    {"city": "Arlebosc"},
    {"city": "Arras-sur-Rhône"},
    {"city": "Les Assions"},
    {"city": "Astet"},
    {"city": "Aubenas"},
    {"city": "Aubignas"},
    {"city": "Baix"},
    {"city": "Balazuc"},
    {"city": "Banne"},
    {"city": "Barnas"},
    {"city": "Le Béage"},
    {"city": "Beauchastel"},
    {"city": "Beaulieu"},
    {"city": "Beaumont"},
    {"city": "Beauvène"},
    {"city": "Berrias-et-Casteljau"},
    {"city": "Berzème"},
    {"city": "Bessas"},
    {"city": "Bidon"},
    {"city": "Boffres"},
    {"city": "Bogy"},
    {"city": "Borée"},
    {"city": "Borne"},
    {"city": "Bozas"},
    {"city": "Boucieu-le-Roi"},
    {"city": "Boulieu-lès-Annonay"},
    {"city": "Bourg-Saint-Andéol"},
    {"city": "Brossainc"},
    {"city": "Burzet"},
    {"city": "Cellier-du-Luc"},
    {"city": "Chalencon"},
    {"city": "Le Chambon"},
    {"city": "Chambonas"},
    {"city": "Champagne"},
    {"city": "Champis"},
    {"city": "Chandolas"},
    {"city": "Chanéac"},
    {"city": "Charmes-sur-Rhône"},
    {"city": "Charnas"},
    {"city": "Chassiers"},
    {"city": "Châteaubourg"},
    {"city": "Châteauneuf-de-Vernoux"},
    {"city": "Chauzon"},
    {"city": "Chazeaux"},
    {"city": "Cheminas"},
    {"city": "Le Cheylard"},
    {"city": "Chirols"},
    {"city": "Chomérac"},
    {"city": "Colombier-le-Cardinal"},
    {"city": "Colombier-le-Jeune"},
    {"city": "Colombier-le-Vieux"},
    {"city": "Cornas"},
    {"city": "Coucouron"},
    {"city": "Coux"},
    {"city": "Le Crestet"},
    {"city": "Creysseilles"},
    {"city": "Cros-de-Géorand"},
    {"city": "Cruas"},
    {"city": "Darbres"},
    {"city": "Davézieux"},
    {"city": "Désaignes"},
    {"city": "Devesset"},
    {"city": "Dompnac"},
    {"city": "Dornas"},
    {"city": "Dunière-sur-Eyrieux"},
    {"city": "Eclassan"},
    {"city": "Empurany"},
    {"city": "Étables"},
    {"city": "Fabras"},
    {"city": "Faugères"},
    {"city": "Félines"},
    {"city": "Flaviac"},
    {"city": "Fons"},
    {"city": "Freyssenet"},
    {"city": "Genestelle"},
    {"city": "Gilhac-et-Bruzac"},
    {"city": "Gilhoc-sur-Ormèze"},
    {"city": "Gluiras"},
    {"city": "Glun"},
    {"city": "Gourdon"},
    {"city": "Gras"},
    {"city": "Gravières"},
    {"city": "Grospierres"},
    {"city": "Guilherand-Granges"},
    {"city": "Saint-Julien-d'Intres"},
    {"city": "Issamoulenc"},
    {"city": "Issanlas"},
    {"city": "Issarlès"},
    {"city": "Jaujac"},
    {"city": "Jaunac"},
    {"city": "Joannas"},
    {"city": "Joyeuse"},
    {"city": "Juvinas"},
    {"city": "Labastide-sur-Bésorgues"},
    {"city": "Labastide-de-Virac"},
    {"city": "Labatie-d'Andaure"},
    {"city": "Labeaume"},
    {"city": "Labégude"},
    {"city": "Lablachère"},
    {"city": "Laboule"},
    {"city": "Le Lac-d'Issarlès"},
    {"city": "Lachamp-Raphaël"},
    {"city": "Lachapelle-Graillouse"},
    {"city": "Lachapelle-sous-Aubenas"},
    {"city": "Lachapelle-sous-Chanéac"},
    {"city": "Lafarre"},
    {"city": "Lagorce"},
    {"city": "Lalevade-d'Ardèche"},
    {"city": "Lalouvesc"},
    {"city": "Lamastre"},
    {"city": "Lanarce"},
    {"city": "Lanas"},
    {"city": "Largentière"},
    {"city": "Larnas"},
    {"city": "Laurac-en-Vivarais"},
    {"city": "Laveyrune"},
    {"city": "Lavillatte"},
    {"city": "Lavilledieu"},
    {"city": "Laviolle"},
    {"city": "Lemps"},
    {"city": "Lentillères"},
    {"city": "Lespéron"},
    {"city": "Limony"},
    {"city": "Loubaresse"},
    {"city": "Lussas"},
    {"city": "Lyas"},
    {"city": "Malarce-sur-la-Thines"},
    {"city": "Malbosc"},
    {"city": "Marcols-les-Eaux"},
    {"city": "Mariac"},
    {"city": "Mars"},
    {"city": "Mauves"},
    {"city": "Mayres"},
    {"city": "Mazan-l'Abbaye"},
    {"city": "Mercuer"},
    {"city": "Meyras"},
    {"city": "Meysse"},
    {"city": "Mézilhac"},
    {"city": "Mirabel"},
    {"city": "Monestier"},
    {"city": "Montpezat-sous-Bauzon"},
    {"city": "Montréal"},
    {"city": "Montselgues"},
    {"city": "Belsentes"},
    {"city": "Nozières"},
    {"city": "Les Ollières-sur-Eyrieux"},
    {"city": "Orgnac-l'Aven"},
    {"city": "Ozon"},
    {"city": "Pailharès"},
    {"city": "Payzac"},
    {"city": "Peaugres"},
    {"city": "Péreyres"},
    {"city": "Peyraud"},
    {"city": "Le Plagnal"},
    {"city": "Planzolles"},
    {"city": "Plats"},
    {"city": "Pont-de-Labeaume"},
    {"city": "Pourchères"},
    {"city": "Le Pouzin"},
    {"city": "Prades"},
    {"city": "Pradons"},
    {"city": "Pranles"},
    {"city": "Préaux"},
    {"city": "Privas"},
    {"city": "Prunet"},
    {"city": "Quintenas"},
    {"city": "Ribes"},
    {"city": "Rochecolombe"},
    {"city": "Rochemaure"},
    {"city": "Rochepaule"},
    {"city": "Rocher"},
    {"city": "Rochessauve"},
    {"city": "La Rochette"},
    {"city": "Rocles"},
    {"city": "Roiffieux"},
    {"city": "Rompon"},
    {"city": "Rosières"},
    {"city": "Le Roux"},
    {"city": "Ruoms"},
    {"city": "Sablières"},
    {"city": "Sagnes-et-Goudoulet"},
    {"city": "Saint-Agrève"},
    {"city": "Saint-Alban-d'Ay"},
    {"city": "Saint-Alban-en-Montagne"},
    {"city": "Saint-Alban-Auriolles"},
    {"city": "Saint-Andéol-de-Berg"},
    {"city": "Saint-Andéol-de-Fourchades"},
    {"city": "Saint-Andéol-de-Vals"},
    {"city": "Saint-André-de-Cruzières"},
    {"city": "Saint-André-en-Vivarais"},
    {"city": "Saint-André-Lachamp"},
    {"city": "Saint-Apollinaire-de-Rias"},
    {"city": "Saint-Barthélemy-le-Meil"},
    {"city": "Saint-Barthélemy-Grozon"},
    {"city": "Saint-Barthélemy-le-Plain"},
    {"city": "Saint-Basile"},
    {"city": "Saint-Bauzile"},
    {"city": "Saint-Christol"},
    {"city": "Saint-Cierge-la-Serre"},
    {"city": "Saint-Cierge-sous-le-Cheylard"},
    {"city": "Saint-Cirgues-de-Prades"},
    {"city": "Saint-Cirgues-en-Montagne"},
    {"city": "Saint-Clair"},
    {"city": "Saint-Clément"},
    {"city": "Saint-Cyr"},
    {"city": "Saint-Désirat"},
    {"city": "Saint-Didier-sous-Aubenas"},
    {"city": "Saint-Étienne-de-Boulogne"},
    {"city": "Saint-Étienne-de-Fontbellon"},
    {"city": "Saint-Étienne-de-Lugdarès"},
    {"city": "Saint-Étienne-de-Serre"},
    {"city": "Saint-Étienne-de-Valoux"},
    {"city": "Sainte-Eulalie"},
    {"city": "Saint-Félicien"},
    {"city": "Saint-Fortunat-sur-Eyrieux"},
    {"city": "Saint-Genest-de-Beauzon"},
    {"city": "Saint-Genest-Lachamp"},
    {"city": "Saint-Georges-les-Bains"},
    {"city": "Saint-Germain"},
    {"city": "Saint-Gineis-en-Coiron"},
    {"city": "Saint-Jacques-d'Atticieux"},
    {"city": "Saint-Jean-Chambre"},
    {"city": "Saint-Jean-de-Muzols"},
    {"city": "Saint-Jean-le-Centenier"},
    {"city": "Saint-Jean-Roure"},
    {"city": "Saint-Jeure-d'Andaure"},
    {"city": "Saint-Jeure-d'Ay"},
    {"city": "Saint-Joseph-des-Bancs"},
    {"city": "Saint-Julien-du-Gua"},
    {"city": "Saint-Julien-du-Serre"},
    {"city": "Saint-Julien-en-Saint-Alban"},
    {"city": "Saint-Julien-le-Roux"},
    {"city": "Saint-Julien-Vocance"},
    {"city": "Saint-Just-d'Ardèche"},
    {"city": "Saint-Lager-Bressac"},
    {"city": "Saint-Laurent-du-Pape"},
    {"city": "Saint-Laurent-les-Bains-Laval-d'Aurelle"},
    {"city": "Saint-Laurent-sous-Coiron"},
    {"city": "Saint-Marcel-d'Ardèche"},
    {"city": "Saint-Marcel-lès-Annonay"},
    {"city": "Sainte-Marguerite-Lafigère"},
    {"city": "Saint-Martial"},
    {"city": "Saint-Martin-d'Ardèche"},
    {"city": "Saint-Martin-de-Valamas"},
    {"city": "Saint-Martin-sur-Lavezon"},
    {"city": "Saint-Maurice-d'Ardèche"},
    {"city": "Saint-Maurice-d'Ibie"},
    {"city": "Saint-Maurice-en-Chalencon"},
    {"city": "Saint-Mélany"},
    {"city": "Saint-Michel-d'Aurance"},
    {"city": "Saint-Michel-de-Boulogne"},
    {"city": "Saint-Michel-de-Chabrillanoux"},
    {"city": "Saint-Montan"},
    {"city": "Saint-Paul-le-Jeune"},
    {"city": "Saint-Péray"},
    {"city": "Saint-Pierre-de-Colombier"},
    {"city": "Saint-Pierre-la-Roche"},
    {"city": "Saint-Pierre-Saint-Jean"},
    {"city": "Saint-Pierre-sur-Doux"},
    {"city": "Saint-Pierreville"},
    {"city": "Saint-Pons"},
    {"city": "Saint-Priest"},
    {"city": "Saint-Privat"},
    {"city": "Saint-Prix"},
    {"city": "Saint-Remèze"},
    {"city": "Saint-Romain-d'Ay"},
    {"city": "Saint-Romain-de-Lerps"},
    {"city": "Saint-Sauveur-de-Cruzières"},
    {"city": "Saint-Sauveur-de-Montagut"},
    {"city": "Saint-Sernin"},
    {"city": "Saint-Sylvestre"},
    {"city": "Saint-Symphorien-sous-Chomérac"},
    {"city": "Saint-Symphorien-de-Mahun"},
    {"city": "Saint-Thomé"},
    {"city": "Saint-Victor"},
    {"city": "Saint-Vincent-de-Barrès"},
    {"city": "Saint-Vincent-de-Durfort"},
    {"city": "Salavas"},
    {"city": "Les Salelles"},
    {"city": "Sampzon"},
    {"city": "Sanilhac"},
    {"city": "Sarras"},
    {"city": "Satillieu"},
    {"city": "Savas"},
    {"city": "Sceautres"},
    {"city": "Sécheras"},
    {"city": "Serrières"},
    {"city": "Silhac"},
    {"city": "La Souche"},
    {"city": "Soyons"},
    {"city": "Talencieux"},
    {"city": "Tauriers"},
    {"city": "Le Teil"},
    {"city": "Thorrenc"},
    {"city": "Thueyts"},
    {"city": "Toulaud"},
    {"city": "Tournon-sur-Rhône"},
    {"city": "Ucel"},
    {"city": "Usclades-et-Rieutord"},
    {"city": "Uzer"},
    {"city": "Vagnas"},
    {"city": "Valgorge"},
    {"city": "Vallon-Pont-d'Arc"},
    {"city": "Vals-les-Bains"},
    {"city": "Valvignères"},
    {"city": "Vanosc"},
    {"city": "Les Vans"},
    {"city": "Vaudevant"},
    {"city": "Vernon"},
    {"city": "Vernosc-lès-Annonay"},
    {"city": "Vernoux-en-Vivarais"},
    {"city": "Vesseaux"},
    {"city": "Veyras"},
    {"city": "Villeneuve-de-Berg"},
    {"city": "Villevocance"},
    {"city": "Vinezac"},
    {"city": "Vinzieux"},
    {"city": "Vion"},
    {"city": "Viviers"},
    {"city": "Vocance"},
    {"city": "Vogüé"},
    {"city": "La Voulte-sur-Rhône"},
    {"city": "Acy-Romance"},
    {"city": "Aiglemont"},
    {"city": "Aire"},
    {"city": "Alincourt"},
    {"city": "Alland'Huy-et-Sausseuil"},
    {"city": "Amagne"},
    {"city": "Ambly-Fleury"},
    {"city": "Anchamps"},
    {"city": "Angecourt"},
    {"city": "Annelles"},
    {"city": "Antheny"},
    {"city": "Aouste"},
    {"city": "Apremont"},
    {"city": "Ardeuil-et-Montfauxelles"},
    {"city": "Les Grandes-Armoises"},
    {"city": "Les Petites-Armoises"},
    {"city": "Arnicourt"},
    {"city": "Arreux"},
    {"city": "Artaise-le-Vivier"},
    {"city": "Asfeld"},
    {"city": "Attigny"},
    {"city": "Aubigny-les-Pothées"},
    {"city": "Auboncourt-Vauzelles"},
    {"city": "Aubrives"},
    {"city": "Auflance"},
    {"city": "Auge"},
    {"city": "Aure"},
    {"city": "Aussonce"},
    {"city": "Authe"},
    {"city": "Autrecourt-et-Pourron"},
    {"city": "Autruche"},
    {"city": "Autry"},
    {"city": "Auvillers-les-Forges"},
    {"city": "Avançon"},
    {"city": "Avaux"},
    {"city": "Les Ayvelles"},
    {"city": "Baâlons"},
    {"city": "Balan"},
    {"city": "Balham"},
    {"city": "Ballay"},
    {"city": "Banogne-Recouvrance"},
    {"city": "Barbaise"},
    {"city": "Barby"},
    {"city": "Bar-lès-Buzancy"},
    {"city": "Bayonville"},
    {"city": "Bazeilles"},
    {"city": "Beaumont-en-Argonne"},
    {"city": "Beffu-et-le-Morthomme"},
    {"city": "Belleville-et-Châtillon-sur-Bar"},
    {"city": "Belval"},
    {"city": "Belval-Bois-des-Dames"},
    {"city": "Bergnicourt"},
    {"city": "La Berlière"},
    {"city": "Bertoncourt"},
    {"city": "La Besace"},
    {"city": "Biermes"},
    {"city": "Bièvres"},
    {"city": "Bignicourt"},
    {"city": "Blagny"},
    {"city": "Blanchefosse-et-Bay"},
    {"city": "Blanzy-la-Salonnaise"},
    {"city": "Blombay"},
    {"city": "Bossus-lès-Rumigny"},
    {"city": "Bouconville"},
    {"city": "Boult-aux-Bois"},
    {"city": "Boulzicourt"},
    {"city": "Bourcq"},
    {"city": "Bourg-Fidèle"},
    {"city": "Bouvellemont"},
    {"city": "Bogny-sur-Meuse"},
    {"city": "Brécy-Brières"},
    {"city": "Brévilly"},
    {"city": "Brienne-sur-Aisne"},
    {"city": "Brieulles-sur-Bar"},
    {"city": "Briquenay"},
    {"city": "Brognon"},
    {"city": "Bulson"},
    {"city": "Buzancy"},
    {"city": "Carignan"},
    {"city": "Cauroy"},
    {"city": "Cernion"},
    {"city": "Chagny"},
    {"city": "Chalandry-Elaire"},
    {"city": "Challerange"},
    {"city": "Champigneulle"},
    {"city": "Champigneul-sur-Vence"},
    {"city": "Champlin"},
    {"city": "La Chapelle"},
    {"city": "Chappes"},
    {"city": "Charbogne"},
    {"city": "Chardeny"},
    {"city": "Charleville-Mézières"},
    {"city": "Charnois"},
    {"city": "Château-Porcien"},
    {"city": "Chatel-Chéhéry"},
    {"city": "Le Châtelet-sur-Sormonne"},
    {"city": "Le Châtelet-sur-Retourne"},
    {"city": "Chaumont-Porcien"},
    {"city": "Chémery-Chéhéry"},
    {"city": "Bairon et ses environs"},
    {"city": "Chesnois-Auboncourt"},
    {"city": "Cheveuges"},
    {"city": "Chevières"},
    {"city": "Chilly"},
    {"city": "Chooz"},
    {"city": "Chuffilly-Roche"},
    {"city": "Clavy-Warby"},
    {"city": "Cliron"},
    {"city": "Condé-lès-Herpy"},
    {"city": "Condé-lès-Autry"},
    {"city": "Contreuve"},
    {"city": "Cornay"},
    {"city": "Corny-Machéroménil"},
    {"city": "Coucy"},
    {"city": "Coulommes-et-Marqueny"},
    {"city": "La Croix-aux-Bois"},
    {"city": "Daigny"},
    {"city": "Damouzy"},
    {"city": "Les Deux-Villes"},
    {"city": "Deville"},
    {"city": "Dom-le-Mesnil"},
    {"city": "Dommery"},
    {"city": "Donchery"},
    {"city": "Doumely-Bégny"},
    {"city": "Doux"},
    {"city": "Douzy"},
    {"city": "Draize"},
    {"city": "Dricourt"},
    {"city": "L'Écaille"},
    {"city": "L'Échelle"},
    {"city": "Écly"},
    {"city": "Écordal"},
    {"city": "Escombres-et-le-Chesnois"},
    {"city": "Estrebay"},
    {"city": "Étalle"},
    {"city": "Éteignières"},
    {"city": "Étrépigny"},
    {"city": "Euilly-et-Lombut"},
    {"city": "Évigny"},
    {"city": "Exermont"},
    {"city": "Fagnon"},
    {"city": "Faissault"},
    {"city": "Falaise"},
    {"city": "Faux"},
    {"city": "Fépin"},
    {"city": "La Férée"},
    {"city": "La Ferté-sur-Chiers"},
    {"city": "Flaignes-Havys"},
    {"city": "Fleigneux"},
    {"city": "Fléville"},
    {"city": "Fligny"},
    {"city": "Flize"},
    {"city": "Floing"},
    {"city": "Foisches"},
    {"city": "Fossé"},
    {"city": "Fraillicourt"},
    {"city": "Francheval"},
    {"city": "La Francheville"},
    {"city": "Le Fréty"},
    {"city": "Fromelennes"},
    {"city": "Fromy"},
    {"city": "Fumay"},
    {"city": "Germont"},
    {"city": "Gernelle"},
    {"city": "Gespunsart"},
    {"city": "Girondelle"},
    {"city": "Givet"},
    {"city": "Givonne"},
    {"city": "Givron"},
    {"city": "Givry"},
    {"city": "Glaire"},
    {"city": "Gomont"},
    {"city": "Grandchamp"},
    {"city": "Grandham"},
    {"city": "Grandpré"},
    {"city": "La Grandville"},
    {"city": "Grivy-Loisy"},
    {"city": "Gruyères"},
    {"city": "Gué-d'Hossus"},
    {"city": "Guignicourt-sur-Vence"},
    {"city": "Guincourt"},
    {"city": "Hagnicourt"},
    {"city": "Ham-les-Moines"},
    {"city": "Ham-sur-Meuse"},
    {"city": "Hannappes"},
    {"city": "Hannogne-Saint-Martin"},
    {"city": "Hannogne-Saint-Rémy"},
    {"city": "Haraucourt"},
    {"city": "Harcy"},
    {"city": "Hargnies"},
    {"city": "Harricourt"},
    {"city": "Haudrecy"},
    {"city": "Haulmé"},
    {"city": "Les Hautes-Rivières"},
    {"city": "Hauteville"},
    {"city": "Hauviné"},
    {"city": "Haybes"},
    {"city": "Herbeuval"},
    {"city": "Herpy-l'Arlésienne"},
    {"city": "Hierges"},
    {"city": "La Horgne"},
    {"city": "Houdilcourt"},
    {"city": "Houldizy"},
    {"city": "Illy"},
    {"city": "Imécourt"},
    {"city": "Inaumont"},
    {"city": "Issancourt-et-Rumel"},
    {"city": "Jandun"},
    {"city": "Joigny-sur-Meuse"},
    {"city": "Jonval"},
    {"city": "Juniville"},
    {"city": "Justine-Herbigny"},
    {"city": "Laifour"},
    {"city": "Lalobbe"},
    {"city": "Lametz"},
    {"city": "Lançon"},
    {"city": "Landres-et-Saint-Georges"},
    {"city": "Landrichamps"},
    {"city": "Launois-sur-Vence"},
    {"city": "Laval-Morency"},
    {"city": "Leffincourt"},
    {"city": "Lépron-les-Vallées"},
    {"city": "Létanne"},
    {"city": "Liart"},
    {"city": "Linay"},
    {"city": "Liry"},
    {"city": "Logny-Bogny"},
    {"city": "Longwé"},
    {"city": "Lonny"},
    {"city": "Lucquy"},
    {"city": "Lumes"},
    {"city": "Machault"},
    {"city": "Maisoncelle-et-Villers"},
    {"city": "Malandry"},
    {"city": "Manre"},
    {"city": "Maranwez"},
    {"city": "Marby"},
    {"city": "Marcq"},
    {"city": "Margny"},
    {"city": "Margut"},
    {"city": "Marlemont"},
    {"city": "Marquigny"},
    {"city": "Mars-sous-Bourcq"},
    {"city": "Marvaux-Vieux"},
    {"city": "Matton-et-Clémency"},
    {"city": "Maubert-Fontaine"},
    {"city": "Mazerny"},
    {"city": "Les Mazures"},
    {"city": "Ménil-Annelles"},
    {"city": "Ménil-Lépinois"},
    {"city": "Mesmont"},
    {"city": "Messincourt"},
    {"city": "Mogues"},
    {"city": "Moiry"},
    {"city": "La Moncelle"},
    {"city": "Mondigny"},
    {"city": "Montcheutin"},
    {"city": "Montcornet"},
    {"city": "Montcy-Notre-Dame"},
    {"city": "Le Mont-Dieu"},
    {"city": "Montgon"},
    {"city": "Monthermé"},
    {"city": "Monthois"},
    {"city": "Montigny-sur-Meuse"},
    {"city": "Montigny-sur-Vence"},
    {"city": "Mont-Laurent"},
    {"city": "Montmeillant"},
    {"city": "Mont-Saint-Martin"},
    {"city": "Mont-Saint-Remy"},
    {"city": "Mouron"},
    {"city": "Mouzon"},
    {"city": "Murtin-et-Bogny"},
    {"city": "Nanteuil-sur-Aisne"},
    {"city": "Neuflize"},
    {"city": "Neufmaison"},
    {"city": "Neufmanil"},
    {"city": "La Neuville-à-Maire"},
    {"city": "La Neuville-aux-Joûtes"},
    {"city": "Neuville-lez-Beaulieu"},
    {"city": "La Neuville-en-Tourne-à-Fuy"},
    {"city": "Neuville-Day"},
    {"city": "Neuville-lès-This"},
    {"city": "La Neuville-lès-Wasigny"},
    {"city": "Neuvizy"},
    {"city": "Noirval"},
    {"city": "Nouart"},
    {"city": "Nouvion-sur-Meuse"},
    {"city": "Nouzonville"},
    {"city": "Novion-Porcien"},
    {"city": "Novy-Chevrières"},
    {"city": "Noyers-Pont-Maugis"},
    {"city": "Oches"},
    {"city": "Olizy-Primat"},
    {"city": "Omicourt"},
    {"city": "Omont"},
    {"city": "Osnes"},
    {"city": "Pauvres"},
    {"city": "Perthes"},
    {"city": "Poilcourt-Sydney"},
    {"city": "Poix-Terron"},
    {"city": "Pouru-aux-Bois"},
    {"city": "Pouru-Saint-Remy"},
    {"city": "Prez"},
    {"city": "Prix-lès-Mézières"},
    {"city": "Puilly-et-Charbeaux"},
    {"city": "Puiseux"},
    {"city": "Pure"},
    {"city": "Quatre-Champs"},
    {"city": "Quilly"},
    {"city": "Raillicourt"},
    {"city": "Rancennes"},
    {"city": "Raucourt-et-Flaba"},
    {"city": "Regniowez"},
    {"city": "Remaucourt"},
    {"city": "Remilly-Aillicourt"},
    {"city": "Remilly-les-Pothées"},
    {"city": "Renneville"},
    {"city": "Renwez"},
    {"city": "Rethel"},
    {"city": "Revin"},
    {"city": "Rilly-sur-Aisne"},
    {"city": "Rimogne"},
    {"city": "Rocquigny"},
    {"city": "Rocroi"},
    {"city": "Roizy"},
    {"city": "La Romagne"},
    {"city": "Rouvroy-sur-Audry"},
    {"city": "Rubigny"},
    {"city": "Rumigny"},
    {"city": "La Sabotterie"},
    {"city": "Sachy"},
    {"city": "Sailly"},
    {"city": "Saint-Aignan"},
    {"city": "Saint-Clément-à-Arnes"},
    {"city": "Saint-Étienne-à-Arnes"},
    {"city": "Saint-Fergeux"},
    {"city": "Saint-Germainmont"},
    {"city": "Saint-Jean-aux-Bois"},
    {"city": "Saint-Juvin"},
    {"city": "Saint-Lambert-et-Mont-de-Jeux"},
    {"city": "Saint-Laurent"},
    {"city": "Saint-Loup-en-Champagne"},
    {"city": "Saint-Loup-Terrier"},
    {"city": "Saint-Marceau"},
    {"city": "Saint-Marcel"},
    {"city": "Sainte-Marie"},
    {"city": "Saint-Menges"},
    {"city": "Saint-Morel"},
    {"city": "Saint-Pierre-à-Arnes"},
    {"city": "Saint-Pierremont"},
    {"city": "Saint-Pierre-sur-Vence"},
    {"city": "Saint-Quentin-le-Petit"},
    {"city": "Saint-Remy-le-Petit"},
    {"city": "Sainte-Vaubourg"},
    {"city": "Sapogne-sur-Marche"},
    {"city": "Sapogne-et-Feuchères"},
    {"city": "Saulces-Champenoises"},
    {"city": "Saulces-Monclin"},
    {"city": "Sault-lès-Rethel"},
    {"city": "Sault-Saint-Remy"},
    {"city": "Sauville"},
    {"city": "Savigny-sur-Aisne"},
    {"city": "Séchault"},
    {"city": "Sécheval"},
    {"city": "Sedan"},
    {"city": "Semide"},
    {"city": "Semuy"},
    {"city": "Senuc"},
    {"city": "Seraincourt"},
    {"city": "Sery"},
    {"city": "Seuil"},
    {"city": "Sévigny-la-Forêt"},
    {"city": "Sévigny-Waleppe"},
    {"city": "Signy-l'Abbaye"},
    {"city": "Signy-le-Petit"},
    {"city": "Signy-Montlibert"},
    {"city": "Singly"},
    {"city": "Sommauthe"},
    {"city": "Sommerance"},
    {"city": "Son"},
    {"city": "Sorbon"},
    {"city": "Sorcy-Bauthémont"},
    {"city": "Sormonne"},
    {"city": "Stonne"},
    {"city": "Sugny"},
    {"city": "Sury"},
    {"city": "Suzanne"},
    {"city": "Sy"},
    {"city": "Tagnon"},
    {"city": "Taillette"},
    {"city": "Tailly"},
    {"city": "Taizy"},
    {"city": "Tannay"},
    {"city": "Tarzy"},
    {"city": "Tétaigne"},
    {"city": "Thelonne"},
    {"city": "Thénorgues"},
    {"city": "Thilay"},
    {"city": "Thin-le-Moutier"},
    {"city": "This"},
    {"city": "Le Thour"},
    {"city": "Thugny-Trugny"},
    {"city": "Toges"},
    {"city": "Touligny"},
    {"city": "Tourcelles-Chaumont"},
    {"city": "Tournavaux"},
    {"city": "Tournes"},
    {"city": "Tourteron"},
    {"city": "Tremblois-lès-Carignan"},
    {"city": "Tremblois-lès-Rocroi"},
    {"city": "Vandy"},
    {"city": "Vaux-Champagne"},
    {"city": "Vaux-en-Dieulet"},
    {"city": "Vaux-lès-Mouron"},
    {"city": "Vaux-lès-Rubigny"},
    {"city": "Vaux-lès-Mouzon"},
    {"city": "Vaux-Montreuil"},
    {"city": "Vaux-Villaine"},
    {"city": "Vendresse"},
    {"city": "Verpel"},
    {"city": "Verrières"},
    {"city": "Viel-Saint-Remy"},
    {"city": "Vieux-lès-Asfeld"},
    {"city": "Villers-devant-le-Thour"},
    {"city": "Villers-devant-Mouzon"},
    {"city": "Villers-le-Tilleul"},
    {"city": "Villers-le-Tourneur"},
    {"city": "Villers-Semeuse"},
    {"city": "Villers-sur-Bar"},
    {"city": "Villers-sur-le-Mont"},
    {"city": "Ville-sur-Lumes"},
    {"city": "Ville-sur-Retourne"},
    {"city": "Villy"},
    {"city": "Vireux-Molhain"},
    {"city": "Vireux-Wallerand"},
    {"city": "Vivier-au-Court"},
    {"city": "Voncq"},
    {"city": "Vouziers"},
    {"city": "Vrigne aux Bois"},
    {"city": "Vrigne-Meuse"},
    {"city": "Wadelincourt"},
    {"city": "Wagnon"},
    {"city": "Warcq"},
    {"city": "Warnécourt"},
    {"city": "Wasigny"},
    {"city": "Wignicourt"},
    {"city": "Williers"},
    {"city": "Yoncq"},
    {"city": "Yvernaumont"},
    {"city": "Aigues-Juntes"},
    {"city": "Aigues-Vives"},
    {"city": "L'Aiguillon"},
    {"city": "Albiès"},
    {"city": "Aleu"},
    {"city": "Alliat"},
    {"city": "Allières"},
    {"city": "Alos"},
    {"city": "Alzen"},
    {"city": "Antras"},
    {"city": "Appy"},
    {"city": "Arabaux"},
    {"city": "Argein"},
    {"city": "Arignac"},
    {"city": "Arnave"},
    {"city": "Arrien-en-Bethmale"},
    {"city": "Arrout"},
    {"city": "Artigat"},
    {"city": "Artigues"},
    {"city": "Artix"},
    {"city": "Arvigna"},
    {"city": "Ascou"},
    {"city": "Aston"},
    {"city": "Aucazein"},
    {"city": "Audressein"},
    {"city": "Augirein"},
    {"city": "Aulus-les-Bains"},
    {"city": "Auzat"},
    {"city": "Axiat"},
    {"city": "Ax-les-Thermes"},
    {"city": "Bagert"},
    {"city": "Balacet"},
    {"city": "Balaguères"},
    {"city": "Barjac"},
    {"city": "La Bastide-de-Besplas"},
    {"city": "La Bastide-de-Bousignac"},
    {"city": "La Bastide-de-Lordat"},
    {"city": "La Bastide-du-Salat"},
    {"city": "La Bastide-de-Sérou"},
    {"city": "La Bastide-sur-l'Hers"},
    {"city": "Baulou"},
    {"city": "Bédeilhac-et-Aynat"},
    {"city": "Bédeille"},
    {"city": "Bélesta"},
    {"city": "Belloc"},
    {"city": "Bénac"},
    {"city": "Benagues"},
    {"city": "Bénaix"},
    {"city": "Besset"},
    {"city": "Bestiac"},
    {"city": "Betchat"},
    {"city": "Bethmale"},
    {"city": "Bézac"},
    {"city": "Biert"},
    {"city": "Bompas"},
    {"city": "Bonac-Irazein"},
    {"city": "Bonnac"},
    {"city": "Les Bordes-sur-Arize"},
    {"city": "Bordes-Uchentein"},
    {"city": "Le Bosc"},
    {"city": "Bouan"},
    {"city": "Boussenac"},
    {"city": "Brassac"},
    {"city": "Brie"},
    {"city": "Burret"},
    {"city": "Buzan"},
    {"city": "Les Cabannes"},
    {"city": "Cadarcet"},
    {"city": "Calzan"},
    {"city": "Camarade"},
    {"city": "Camon"},
    {"city": "Campagne-sur-Arize"},
    {"city": "Canté"},
    {"city": "Capoulet-et-Junac"},
    {"city": "Carcanières"},
    {"city": "Carla-Bayle"},
    {"city": "Carla-de-Roquefort"},
    {"city": "Le Carlaret"},
    {"city": "Castelnau-Durban"},
    {"city": "Castéras"},
    {"city": "Castex"},
    {"city": "Castillon-en-Couserans"},
    {"city": "Caumont"},
    {"city": "Caussou"},
    {"city": "Caychax"},
    {"city": "Cazals-des-Baylès"},
    {"city": "Cazaux"},
    {"city": "Cazavet"},
    {"city": "Cazenave-Serres-et-Allens"},
    {"city": "Celles"},
    {"city": "Cérizols"},
    {"city": "Cescau"},
    {"city": "Château-Verdun"},
    {"city": "Clermont"},
    {"city": "Contrazy"},
    {"city": "Cos"},
    {"city": "Couflens"},
    {"city": "Coussa"},
    {"city": "Coutens"},
    {"city": "Crampagna"},
    {"city": "Dalou"},
    {"city": "Daumazan-sur-Arize"},
    {"city": "Dreuilhe"},
    {"city": "Dun"},
    {"city": "Durban-sur-Arize"},
    {"city": "Durfort"},
    {"city": "Encourtiech"},
    {"city": "Engomer"},
    {"city": "Ercé"},
    {"city": "Erp"},
    {"city": "Esclagne"},
    {"city": "Escosse"},
    {"city": "Esplas"},
    {"city": "Esplas-de-Sérou"},
    {"city": "Eycheil"},
    {"city": "Fabas"},
    {"city": "Ferrières-sur-Ariège"},
    {"city": "Foix"},
    {"city": "Fornex"},
    {"city": "Le Fossat"},
    {"city": "Fougax-et-Barrineuf"},
    {"city": "Freychenet"},
    {"city": "Gabre"},
    {"city": "Gajan"},
    {"city": "Galey"},
    {"city": "Ganac"},
    {"city": "Garanou"},
    {"city": "Gaudiès"},
    {"city": "Génat"},
    {"city": "Gestiès"},
    {"city": "Gourbit"},
    {"city": "Gudas"},
    {"city": "L'Herm"},
    {"city": "L'Hospitalet-près-l'Andorre"},
    {"city": "Ignaux"},
    {"city": "Illartein"},
    {"city": "Ilhat"},
    {"city": "Illier-et-Laramade"},
    {"city": "Les Issards"},
    {"city": "Justiniac"},
    {"city": "Labatut"},
    {"city": "Lacave"},
    {"city": "Lacourt"},
    {"city": "Lagarde"},
    {"city": "Lanoux"},
    {"city": "Lapège"},
    {"city": "Lapenne"},
    {"city": "Larbont"},
    {"city": "Larcat"},
    {"city": "Larnat"},
    {"city": "Laroque-d'Olmes"},
    {"city": "Lasserre"},
    {"city": "Lassur"},
    {"city": "Lavelanet"},
    {"city": "Léran"},
    {"city": "Lercoul"},
    {"city": "Lescousse"},
    {"city": "Lescure"},
    {"city": "Lesparrou"},
    {"city": "Leychert"},
    {"city": "Lézat-sur-Lèze"},
    {"city": "Lieurac"},
    {"city": "Limbrassac"},
    {"city": "Lissac"},
    {"city": "Lordat"},
    {"city": "Loubaut"},
    {"city": "Loubens"},
    {"city": "Loubières"},
    {"city": "Ludiès"},
    {"city": "Luzenac"},
    {"city": "Madière"},
    {"city": "Malegoude"},
    {"city": "Malléon"},
    {"city": "Manses"},
    {"city": "Le Mas-d'Azil"},
    {"city": "Massat"},
    {"city": "Mauvezin-de-Prat"},
    {"city": "Mauvezin-de-Sainte-Croix"},
    {"city": "Mazères"},
    {"city": "Méras"},
    {"city": "Mercenac"},
    {"city": "Mercus-Garrabet"},
    {"city": "Mérens-les-Vals"},
    {"city": "Mérigon"},
    {"city": "Miglos"},
    {"city": "Mijanès"},
    {"city": "Mirepoix"},
    {"city": "Monesple"},
    {"city": "Montagagne"},
    {"city": "Montaillou"},
    {"city": "Montardit"},
    {"city": "Montaut"},
    {"city": "Montbel"},
    {"city": "Montégut-en-Couserans"},
    {"city": "Montégut-Plantaurel"},
    {"city": "Montels"},
    {"city": "Montesquieu-Avantès"},
    {"city": "Montfa"},
    {"city": "Montferrier"},
    {"city": "Montgaillard"},
    {"city": "Montgauch"},
    {"city": "Montjoie-en-Couserans"},
    {"city": "Montoulieu"},
    {"city": "Montségur"},
    {"city": "Montseron"},
    {"city": "Moulin-Neuf"},
    {"city": "Moulis"},
    {"city": "Nalzen"},
    {"city": "Nescus"},
    {"city": "Niaux"},
    {"city": "Orgeix"},
    {"city": "Orgibet"},
    {"city": "Orlu"},
    {"city": "Ornolac-Ussat-les-Bains"},
    {"city": "Orus"},
    {"city": "Oust"},
    {"city": "Pailhès"},
    {"city": "Pamiers"},
    {"city": "Pech"},
    {"city": "Péreille"},
    {"city": "Perles-et-Castelet"},
    {"city": "Le Peyrat"},
    {"city": "Le Pla"},
    {"city": "Le Port"},
    {"city": "Prades"},
    {"city": "Pradettes"},
    {"city": "Pradières"},
    {"city": "Prat-Bonrepaux"},
    {"city": "Prayols"},
    {"city": "Le Puch"},
    {"city": "Les Pujols"},
    {"city": "Quérigut"},
    {"city": "Quié"},
    {"city": "Rabat-les-Trois-Seigneurs"},
    {"city": "Raissac"},
    {"city": "Régat"},
    {"city": "Rieucros"},
    {"city": "Rieux-de-Pelleport"},
    {"city": "Rimont"},
    {"city": "Rivèrenert"},
    {"city": "Roquefixade"},
    {"city": "Roquefort-les-Cascades"},
    {"city": "Roumengoux"},
    {"city": "Rouze"},
    {"city": "Sabarat"},
    {"city": "Saint-Amadou"},
    {"city": "Saint-Amans"},
    {"city": "Saint-Bauzeil"},
    {"city": "Sainte-Croix-Volvestre"},
    {"city": "Saint-Félix-de-Rieutord"},
    {"city": "Saint-Félix-de-Tournegat"},
    {"city": "Sainte-Foi"},
    {"city": "Saint-Girons"},
    {"city": "Saint-Jean-d'Aigues-Vives"},
    {"city": "Saint-Jean-du-Castillonnais"},
    {"city": "Saint-Jean-de-Verges"},
    {"city": "Saint-Jean-du-Falga"},
    {"city": "Saint-Julien-de-Gras-Capou"},
    {"city": "Saint-Lary"},
    {"city": "Saint-Lizier"},
    {"city": "Saint-Martin-de-Caralp"},
    {"city": "Saint-Martin-d'Oydes"},
    {"city": "Saint-Michel"},
    {"city": "Saint-Paul-de-Jarrat"},
    {"city": "Saint-Pierre-de-Rivière"},
    {"city": "Saint-Quentin-la-Tour"},
    {"city": "Saint-Quirc"},
    {"city": "Saint-Victor-Rouzaud"},
    {"city": "Saint-Ybars"},
    {"city": "Salsein"},
    {"city": "Saurat"},
    {"city": "Sautel"},
    {"city": "Saverdun"},
    {"city": "Savignac-les-Ormeaux"},
    {"city": "Ségura"},
    {"city": "Seix"},
    {"city": "Senconac"},
    {"city": "Lorp-Sentaraille"},
    {"city": "Sentein"},
    {"city": "Sentenac-d'Oust"},
    {"city": "Sentenac-de-Sérou"},
    {"city": "Serres-sur-Arget"},
    {"city": "Sieuras"},
    {"city": "Siguer"},
    {"city": "Aulos-Sinsat"},
    {"city": "Sor"},
    {"city": "Sorgeat"},
    {"city": "Soueix-Rogalle"},
    {"city": "Soula"},
    {"city": "Soulan"},
    {"city": "Surba"},
    {"city": "Suzan"},
    {"city": "Tabre"},
    {"city": "Tarascon-sur-Ariège"},
    {"city": "Taurignan-Castet"},
    {"city": "Taurignan-Vieux"},
    {"city": "Teilhet"},
    {"city": "Thouars-sur-Arize"},
    {"city": "Tignac"},
    {"city": "La Tour-du-Crieu"},
    {"city": "Tourtouse"},
    {"city": "Tourtrol"},
    {"city": "Trémoulet"},
    {"city": "Troye-d'Ariège"},
    {"city": "Unac"},
    {"city": "Unzent"},
    {"city": "Urs"},
    {"city": "Ussat"},
    {"city": "Ustou"},
    {"city": "Vals"},
    {"city": "Varilhes"},
    {"city": "Vaychis"},
    {"city": "Vèbre"},
    {"city": "Ventenac"},
    {"city": "Verdun"},
    {"city": "Vernajoul"},
    {"city": "Vernaux"},
    {"city": "Le Vernet"},
    {"city": "Verniolle"},
    {"city": "Val-de-Sos"},
    {"city": "Villeneuve"},
    {"city": "Villeneuve-d'Olmes"},
    {"city": "Villeneuve-du-Latou"},
    {"city": "Villeneuve-du-Paréage"},
    {"city": "Vira"},
    {"city": "Viviès"},
    {"city": "Sainte-Suzanne"},
    {"city": "Ailleville"},
    {"city": "Aix-Villemaur-Pâlis"},
    {"city": "Allibaudières"},
    {"city": "Amance"},
    {"city": "Arcis-sur-Aube"},
    {"city": "Arconville"},
    {"city": "Argançon"},
    {"city": "Arrelles"},
    {"city": "Arrembécourt"},
    {"city": "Arrentières"},
    {"city": "Arsonval"},
    {"city": "Assenay"},
    {"city": "Assencières"},
    {"city": "Aubeterre"},
    {"city": "Aulnay"},
    {"city": "Auxon"},
    {"city": "Val-d'Auzon"},
    {"city": "Avant-lès-Marcilly"},
    {"city": "Avant-lès-Ramerupt"},
    {"city": "Avirey-Lingey"},
    {"city": "Avon-la-Pèze"},
    {"city": "Avreuil"},
    {"city": "Bagneux-la-Fosse"},
    {"city": "Bailly-le-Franc"},
    {"city": "Balignicourt"},
    {"city": "Balnot-la-Grange"},
    {"city": "Balnot-sur-Laignes"},
    {"city": "Barberey-Saint-Sulpice"},
    {"city": "Barbuise"},
    {"city": "Baroville"},
    {"city": "Bar-sur-Aube"},
    {"city": "Bar-sur-Seine"},
    {"city": "Bayel"},
    {"city": "Bercenay-en-Othe"},
    {"city": "Bercenay-le-Hayer"},
    {"city": "Bergères"},
    {"city": "Bernon"},
    {"city": "Bertignolles"},
    {"city": "Bérulle"},
    {"city": "Bessy"},
    {"city": "Bétignicourt"},
    {"city": "Beurey"},
    {"city": "Blaincourt-sur-Aube"},
    {"city": "Blignicourt"},
    {"city": "Bligny"},
    {"city": "Les Bordes-Aumont"},
    {"city": "Bossancourt"},
    {"city": "Bouilly"},
    {"city": "Boulages"},
    {"city": "Bouranton"},
    {"city": "Bourdenay"},
    {"city": "Bourguignons"},
    {"city": "Bouy-Luxembourg"},
    {"city": "Bouy-sur-Orvin"},
    {"city": "Bragelogne-Beauvoir"},
    {"city": "Braux"},
    {"city": "Bréviandes"},
    {"city": "Brévonnes"},
    {"city": "Briel-sur-Barse"},
    {"city": "Brienne-la-Vieille"},
    {"city": "Brienne-le-Château"},
    {"city": "Brillecourt"},
    {"city": "Bucey-en-Othe"},
    {"city": "Buchères"},
    {"city": "Buxeuil"},
    {"city": "Buxières-sur-Arce"},
    {"city": "Celles-sur-Ource"},
    {"city": "Chacenay"},
    {"city": "La Chaise"},
    {"city": "Chalette-sur-Voire"},
    {"city": "Chamoy"},
    {"city": "Champfleury"},
    {"city": "Champignol-lez-Mondeville"},
    {"city": "Champigny-sur-Aube"},
    {"city": "Champ-sur-Barse"},
    {"city": "Channes"},
    {"city": "Chaource"},
    {"city": "La Chapelle-Saint-Luc"},
    {"city": "Chapelle-Vallon"},
    {"city": "Chappes"},
    {"city": "Charmont-sous-Barbuise"},
    {"city": "Charmoy"},
    {"city": "Charny-le-Bachot"},
    {"city": "Chaserey"},
    {"city": "Châtres"},
    {"city": "Chauchigny"},
    {"city": "Chaudrey"},
    {"city": "Chauffour-lès-Bailly"},
    {"city": "Chaumesnil"},
    {"city": "Chavanges"},
    {"city": "Le Chêne"},
    {"city": "Chennegy"},
    {"city": "Chervey"},
    {"city": "Chesley"},
    {"city": "Chessy-les-Prés"},
    {"city": "Clérey"},
    {"city": "Coclois"},
    {"city": "Colombé-la-Fosse"},
    {"city": "Colombé-le-Sec"},
    {"city": "Cormost"},
    {"city": "Courcelles-sur-Voire"},
    {"city": "Courceroy"},
    {"city": "Coursan-en-Othe"},
    {"city": "Courtaoult"},
    {"city": "Courtenot"},
    {"city": "Courteranges"},
    {"city": "Courteron"},
    {"city": "Coussegrey"},
    {"city": "Couvignon"},
    {"city": "Crancey"},
    {"city": "Creney-près-Troyes"},
    {"city": "Crésantignes"},
    {"city": "Crespy-le-Neuf"},
    {"city": "Les Croûtes"},
    {"city": "Cunfin"},
    {"city": "Cussangy"},
    {"city": "Dampierre"},
    {"city": "Davrey"},
    {"city": "Dienville"},
    {"city": "Dierrey-Saint-Julien"},
    {"city": "Dierrey-Saint-Pierre"},
    {"city": "Dolancourt"},
    {"city": "Dommartin-le-Coq"},
    {"city": "Donnement"},
    {"city": "Dosches"},
    {"city": "Dosnon"},
    {"city": "Droupt-Saint-Basle"},
    {"city": "Droupt-Sainte-Marie"},
    {"city": "Eaux-Puiseaux"},
    {"city": "Échemines"},
    {"city": "Éclance"},
    {"city": "Éguilly-sous-Bois"},
    {"city": "Engente"},
    {"city": "Épagne"},
    {"city": "Épothémont"},
    {"city": "Ervy-le-Châtel"},
    {"city": "Essoyes"},
    {"city": "Estissac"},
    {"city": "Étourvy"},
    {"city": "Étrelles-sur-Aube"},
    {"city": "Faux-Villecerf"},
    {"city": "Fay-lès-Marcilly"},
    {"city": "Fays-la-Chapelle"},
    {"city": "Ferreux-Quincey"},
    {"city": "Feuges"},
    {"city": "Fontaine"},
    {"city": "Fontaine-les-Grès"},
    {"city": "Fontaine-Mâcon"},
    {"city": "Fontenay-de-Bossery"},
    {"city": "Fontette"},
    {"city": "Fontvannes"},
    {"city": "La Fosse-Corduan"},
    {"city": "Fouchères"},
    {"city": "Fralignes"},
    {"city": "Fravaux"},
    {"city": "Fresnay"},
    {"city": "Fresnoy-le-Château"},
    {"city": "Fuligny"},
    {"city": "Gélannes"},
    {"city": "Géraudot"},
    {"city": "Les Grandes-Chapelles"},
    {"city": "Grandville"},
    {"city": "Les Granges"},
    {"city": "Gumery"},
    {"city": "Gyé-sur-Seine"},
    {"city": "Hampigny"},
    {"city": "Herbisse"},
    {"city": "Isle-Aumont"},
    {"city": "Isle-Aubigny"},
    {"city": "Jasseines"},
    {"city": "Jaucourt"},
    {"city": "Javernant"},
    {"city": "Jessains"},
    {"city": "Jeugny"},
    {"city": "Joncreuil"},
    {"city": "Jully-sur-Sarce"},
    {"city": "Juvancourt"},
    {"city": "Juvanzé"},
    {"city": "Juzanvigny"},
    {"city": "Lagesse"},
    {"city": "Laines-aux-Bois"},
    {"city": "Landreville"},
    {"city": "Lantages"},
    {"city": "Lassicourt"},
    {"city": "Laubressel"},
    {"city": "Lavau"},
    {"city": "Lentilles"},
    {"city": "Lesmont"},
    {"city": "Lévigny"},
    {"city": "Lhuître"},
    {"city": "Lignières"},
    {"city": "Lignol-le-Château"},
    {"city": "Lirey"},
    {"city": "Loches-sur-Ource"},
    {"city": "La Loge-aux-Chèvres"},
    {"city": "La Loge-Pomblin"},
    {"city": "Les Loges-Margueron"},
    {"city": "Longchamp-sur-Aujon"},
    {"city": "Longeville-sur-Mogne"},
    {"city": "Longpré-le-Sec"},
    {"city": "Longsols"},
    {"city": "Longueville-sur-Aube"},
    {"city": "La Louptière-Thénard"},
    {"city": "Lusigny-sur-Barse"},
    {"city": "Luyères"},
    {"city": "Macey"},
    {"city": "Machy"},
    {"city": "Magnant"},
    {"city": "Magnicourt"},
    {"city": "Magny-Fouchard"},
    {"city": "Mailly-le-Camp"},
    {"city": "Maison-des-Champs"},
    {"city": "Maisons-lès-Chaource"},
    {"city": "Maisons-lès-Soulaines"},
    {"city": "Maizières-la-Grande-Paroisse"},
    {"city": "Maizières-lès-Brienne"},
    {"city": "Maraye-en-Othe"},
    {"city": "Marcilly-le-Hayer"},
    {"city": "Marigny-le-Châtel"},
    {"city": "Marnay-sur-Seine"},
    {"city": "Marolles-lès-Bailly"},
    {"city": "Marolles-sous-Lignières"},
    {"city": "Mathaux"},
    {"city": "Maupas"},
    {"city": "Mergey"},
    {"city": "Le Mériot"},
    {"city": "Merrey-sur-Arce"},
    {"city": "Méry-sur-Seine"},
    {"city": "Mesgrigny"},
    {"city": "Mesnil-la-Comtesse"},
    {"city": "Mesnil-Lettre"},
    {"city": "Mesnil-Saint-Loup"},
    {"city": "Mesnil-Saint-Père"},
    {"city": "Mesnil-Sellières"},
    {"city": "Messon"},
    {"city": "Metz-Robert"},
    {"city": "Meurville"},
    {"city": "Molins-sur-Aube"},
    {"city": "Montaulin"},
    {"city": "Montceaux-lès-Vaudes"},
    {"city": "Montfey"},
    {"city": "Montgueux"},
    {"city": "Montiéramey"},
    {"city": "Montier-en-l'Isle"},
    {"city": "Montigny-les-Monts"},
    {"city": "Montmartin-le-Haut"},
    {"city": "Montmorency-Beaufort"},
    {"city": "Montpothier"},
    {"city": "Montreuil-sur-Barse"},
    {"city": "Montsuzain"},
    {"city": "Morembert"},
    {"city": "Morvilliers"},
    {"city": "La Motte-Tilly"},
    {"city": "Moussey"},
    {"city": "Mussy-sur-Seine"},
    {"city": "Neuville-sur-Seine"},
    {"city": "Neuville-sur-Vanne"},
    {"city": "Noé-les-Mallets"},
    {"city": "Les Noës-près-Troyes"},
    {"city": "Nogent-en-Othe"},
    {"city": "Nogent-sur-Aube"},
    {"city": "Nogent-sur-Seine"},
    {"city": "Nozay"},
    {"city": "Onjon"},
    {"city": "Origny-le-Sec"},
    {"city": "Ormes"},
    {"city": "Ortillon"},
    {"city": "Orvilliers-Saint-Julien"},
    {"city": "Ossey-les-Trois-Maisons"},
    {"city": "Paisy-Cosdon"},
    {"city": "Pargues"},
    {"city": "Pars-lès-Chavanges"},
    {"city": "Pars-lès-Romilly"},
    {"city": "Le Pavillon-Sainte-Julie"},
    {"city": "Payns"},
    {"city": "Pel-et-Der"},
    {"city": "Périgny-la-Rose"},
    {"city": "Perthes-lès-Brienne"},
    {"city": "Petit-Mesnil"},
    {"city": "Piney"},
    {"city": "Plaines-Saint-Lange"},
    {"city": "Plancy-l'Abbaye"},
    {"city": "Planty"},
    {"city": "Plessis-Barbuise"},
    {"city": "Poivres"},
    {"city": "Poligny"},
    {"city": "Polisot"},
    {"city": "Polisy"},
    {"city": "Pont-Sainte-Marie"},
    {"city": "Pont-sur-Seine"},
    {"city": "Pouan-les-Vallées"},
    {"city": "Pougy"},
    {"city": "Pouy-sur-Vannes"},
    {"city": "Praslin"},
    {"city": "Précy-Notre-Dame"},
    {"city": "Précy-Saint-Martin"},
    {"city": "Prémierfait"},
    {"city": "Proverville"},
    {"city": "Prugny"},
    {"city": "Prunay-Belleville"},
    {"city": "Prusy"},
    {"city": "Puits-et-Nuisement"},
    {"city": "Racines"},
    {"city": "Radonvilliers"},
    {"city": "Ramerupt"},
    {"city": "Rances"},
    {"city": "Rhèges"},
    {"city": "Les Riceys"},
    {"city": "Rigny-la-Nonneuse"},
    {"city": "Rigny-le-Ferron"},
    {"city": "Rilly-Sainte-Syre"},
    {"city": "La Rivière-de-Corps"},
    {"city": "Romilly-sur-Seine"},
    {"city": "Roncenay"},
    {"city": "Rosières-près-Troyes"},
    {"city": "Rosnay-l'Hôpital"},
    {"city": "La Rothière"},
    {"city": "Rouilly-Sacey"},
    {"city": "Rouilly-Saint-Loup"},
    {"city": "Rouvres-les-Vignes"},
    {"city": "Rumilly-lès-Vaudes"},
    {"city": "Ruvigny"},
    {"city": "Saint-André-les-Vergers"},
    {"city": "Saint-Aubin"},
    {"city": "Saint-Benoist-sur-Vanne"},
    {"city": "Saint-Benoît-sur-Seine"},
    {"city": "Saint-Christophe-Dodinicourt"},
    {"city": "Saint-Étienne-sous-Barbuise"},
    {"city": "Saint-Flavy"},
    {"city": "Saint-Germain"},
    {"city": "Saint-Hilaire-sous-Romilly"},
    {"city": "Saint-Jean-de-Bonneval"},
    {"city": "Saint-Julien-les-Villas"},
    {"city": "Saint-Léger-près-Troyes"},
    {"city": "Saint-Léger-sous-Brienne"},
    {"city": "Saint-Léger-sous-Margerie"},
    {"city": "Saint-Loup-de-Buffigny"},
    {"city": "Saint-Lupien"},
    {"city": "Saint-Lyé"},
    {"city": "Saint-Mards-en-Othe"},
    {"city": "Saint-Martin-de-Bossenay"},
    {"city": "Sainte-Maure"},
    {"city": "Saint-Mesmin"},
    {"city": "Saint-Nabord-sur-Aube"},
    {"city": "Saint-Nicolas-la-Chapelle"},
    {"city": "Saint-Oulph"},
    {"city": "Saint-Parres-aux-Tertres"},
    {"city": "Saint-Parres-lès-Vaudes"},
    {"city": "Saint-Phal"},
    {"city": "Saint-Pouange"},
    {"city": "Saint-Remy-sous-Barbuise"},
    {"city": "Sainte-Savine"},
    {"city": "Saint-Thibault"},
    {"city": "Saint-Usage"},
    {"city": "Salon"},
    {"city": "Saulcy"},
    {"city": "La Saulsotte"},
    {"city": "Savières"},
    {"city": "Semoine"},
    {"city": "Soligny-les-Étangs"},
    {"city": "Sommeval"},
    {"city": "Soulaines-Dhuys"},
    {"city": "Souligny"},
    {"city": "Spoy"},
    {"city": "Thennelières"},
    {"city": "Thieffrain"},
    {"city": "Thil"},
    {"city": "Thors"},
    {"city": "Torcy-le-Grand"},
    {"city": "Torcy-le-Petit"},
    {"city": "Torvilliers"},
    {"city": "Traînel"},
    {"city": "Trancault"},
    {"city": "Trannes"},
    {"city": "Trouans"},
    {"city": "Troyes"},
    {"city": "Turgy"},
    {"city": "Unienville"},
    {"city": "Urville"},
    {"city": "Vailly"},
    {"city": "Vallant-Saint-Georges"},
    {"city": "Vallentigny"},
    {"city": "Vallières"},
    {"city": "Vanlay"},
    {"city": "Vauchassis"},
    {"city": "Vauchonvilliers"},
    {"city": "Vaucogne"},
    {"city": "Vaudes"},
    {"city": "Vaupoisson"},
    {"city": "Vendeuvre-sur-Barse"},
    {"city": "La Vendue-Mignot"},
    {"city": "Vernonvilliers"},
    {"city": "Verpillières-sur-Ource"},
    {"city": "Verricourt"},
    {"city": "Verrières"},
    {"city": "Viâpres-le-Petit"},
    {"city": "Villacerf"},
    {"city": "Villadin"},
    {"city": "La Ville-aux-Bois"},
    {"city": "Villechétif"},
    {"city": "Villeloup"},
    {"city": "Villemereuil"},
    {"city": "Villemoiron-en-Othe"},
    {"city": "Villemorien"},
    {"city": "Villemoyenne"},
    {"city": "Villenauxe-la-Grande"},
    {"city": "La Villeneuve-au-Châtelot"},
    {"city": "Villeneuve-au-Chemin"},
    {"city": "La Villeneuve-au-Chêne"},
    {"city": "Villeret"},
    {"city": "Villery"},
    {"city": "Ville-sous-la-Ferté"},
    {"city": "Ville-sur-Arce"},
    {"city": "Ville-sur-Terre"},
    {"city": "Villette-sur-Aube"},
    {"city": "Villiers-Herbisse"},
    {"city": "Villiers-le-Bois"},
    {"city": "Villiers-sous-Praslin"},
    {"city": "Villy-en-Trodes"},
    {"city": "Villy-le-Bois"},
    {"city": "Villy-le-Maréchal"},
    {"city": "Vinets"},
    {"city": "Virey-sous-Bar"},
    {"city": "Vitry-le-Croisé"},
    {"city": "Viviers-sur-Artaut"},
    {"city": "Voigny"},
    {"city": "Vosnon"},
    {"city": "Voué"},
    {"city": "Vougrey"},
    {"city": "Vulaines"},
    {"city": "Yèvres-le-Petit"},
    {"city": "Aigues-Vives"},
    {"city": "Airoux"},
    {"city": "Ajac"},
    {"city": "Alaigne"},
    {"city": "Alairac"},
    {"city": "Albas"},
    {"city": "Albières"},
    {"city": "Alet-les-Bains"},
    {"city": "Alzonne"},
    {"city": "Antugnac"},
    {"city": "Aragon"},
    {"city": "Argeliers"},
    {"city": "Argens-Minervois"},
    {"city": "Armissan"},
    {"city": "Arques"},
    {"city": "Arquettes-en-Val"},
    {"city": "Artigues"},
    {"city": "Arzens"},
    {"city": "Aunat"},
    {"city": "Auriac"},
    {"city": "Axat"},
    {"city": "Azille"},
    {"city": "Badens"},
    {"city": "Bages"},
    {"city": "Bagnoles"},
    {"city": "Baraigne"},
    {"city": "Barbaira"},
    {"city": "Belcaire"},
    {"city": "Belcastel-et-Buc"},
    {"city": "Belflou"},
    {"city": "Belfort-sur-Rebenty"},
    {"city": "Bellegarde-du-Razès"},
    {"city": "Belpech"},
    {"city": "Belvèze-du-Razès"},
    {"city": "Belvianes-et-Cavirac"},
    {"city": "Belvis"},
    {"city": "Berriac"},
    {"city": "Bessède-de-Sault"},
    {"city": "La Bezole"},
    {"city": "Bizanet"},
    {"city": "Bize-Minervois"},
    {"city": "Blomac"},
    {"city": "Bouilhonnac"},
    {"city": "Bouisse"},
    {"city": "Bouriège"},
    {"city": "Bourigeole"},
    {"city": "Le Bousquet"},
    {"city": "Boutenac"},
    {"city": "Bram"},
    {"city": "Brézilhac"},
    {"city": "Brousses-et-Villaret"},
    {"city": "Brugairolles"},
    {"city": "Les Brunels"},
    {"city": "Bugarach"},
    {"city": "Cabrespine"},
    {"city": "Cahuzac"},
    {"city": "Cailhau"},
    {"city": "Cailhavel"},
    {"city": "Cailla"},
    {"city": "Cambieure"},
    {"city": "Campagna-de-Sault"},
    {"city": "Campagne-sur-Aude"},
    {"city": "Camplong-d'Aude"},
    {"city": "Camps-sur-l'Agly"},
    {"city": "Camurac"},
    {"city": "Canet"},
    {"city": "Capendu"},
    {"city": "Carcassonne"},
    {"city": "Carlipa"},
    {"city": "Cascastel-des-Corbières"},
    {"city": "La Cassaigne"},
    {"city": "Cassaignes"},
    {"city": "Les Cassés"},
    {"city": "Castans"},
    {"city": "Castelnaudary"},
    {"city": "Castelnau-d'Aude"},
    {"city": "Castelreng"},
    {"city": "Caudebronde"},
    {"city": "Val de Lambronne"},
    {"city": "Caunes-Minervois"},
    {"city": "Caunette-sur-Lauquet"},
    {"city": "Caunettes-en-Val"},
    {"city": "Caux-et-Sauzens"},
    {"city": "Cavanac"},
    {"city": "Caves"},
    {"city": "Cazalrenoux"},
    {"city": "Cazilhac"},
    {"city": "Cenne-Monestiés"},
    {"city": "Cépie"},
    {"city": "Chalabre"},
    {"city": "Citou"},
    {"city": "Le Clat"},
    {"city": "Clermont-sur-Lauquet"},
    {"city": "Comigne"},
    {"city": "Comus"},
    {"city": "Conilhac-Corbières"},
    {"city": "Conques-sur-Orbiel"},
    {"city": "Corbières"},
    {"city": "Coudons"},
    {"city": "Couffoulens"},
    {"city": "Couiza"},
    {"city": "Counozouls"},
    {"city": "Cournanel"},
    {"city": "Coursan"},
    {"city": "Courtauly"},
    {"city": "La Courtète"},
    {"city": "Coustaussa"},
    {"city": "Coustouge"},
    {"city": "Cruscades"},
    {"city": "Cubières-sur-Cinoble"},
    {"city": "Cucugnan"},
    {"city": "Cumiès"},
    {"city": "Cuxac-Cabardès"},
    {"city": "Cuxac-d'Aude"},
    {"city": "Davejean"},
    {"city": "Dernacueillette"},
    {"city": "La Digne-d'Amont"},
    {"city": "La Digne-d'Aval"},
    {"city": "Donazac"},
    {"city": "Douzens"},
    {"city": "Duilhac-sous-Peyrepertuse"},
    {"city": "Durban-Corbières"},
    {"city": "Embres-et-Castelmaure"},
    {"city": "Escales"},
    {"city": "Escouloubre"},
    {"city": "Escueillens-et-Saint-Just-de-Bélengard"},
    {"city": "Espéraza"},
    {"city": "Espezel"},
    {"city": "Val-du-Faby"},
    {"city": "Fabrezan"},
    {"city": "Fajac-en-Val"},
    {"city": "Fajac-la-Relenque"},
    {"city": "La Fajolle"},
    {"city": "Fanjeaux"},
    {"city": "Félines-Termenès"},
    {"city": "Fendeille"},
    {"city": "Fenouillet-du-Razès"},
    {"city": "Ferrals-les-Corbières"},
    {"city": "Ferran"},
    {"city": "Festes-et-Saint-André"},
    {"city": "Feuilla"},
    {"city": "Fitou"},
    {"city": "Fleury"},
    {"city": "Floure"},
    {"city": "Fontanès-de-Sault"},
    {"city": "Fontcouverte"},
    {"city": "Fonters-du-Razès"},
    {"city": "Fontiers-Cabardès"},
    {"city": "Fontiès-d'Aude"},
    {"city": "Fontjoncouse"},
    {"city": "La Force"},
    {"city": "Fournes-Cabardès"},
    {"city": "Fourtou"},
    {"city": "Fraisse-Cabardès"},
    {"city": "Fraissé-des-Corbières"},
    {"city": "Gaja-et-Villedieu"},
    {"city": "Gaja-la-Selve"},
    {"city": "Galinagues"},
    {"city": "Gardie"},
    {"city": "Generville"},
    {"city": "Gincla"},
    {"city": "Ginestas"},
    {"city": "Ginoles"},
    {"city": "Gourvieille"},
    {"city": "Gramazie"},
    {"city": "Granès"},
    {"city": "Greffeil"},
    {"city": "Gruissan"},
    {"city": "Homps"},
    {"city": "Hounoux"},
    {"city": "Les Ilhes"},
    {"city": "Issel"},
    {"city": "Jonquières"},
    {"city": "Joucou"},
    {"city": "Labastide-d'Anjou"},
    {"city": "Labastide-en-Val"},
    {"city": "Labastide-Esparbairenque"},
    {"city": "Labécède-Lauragais"},
    {"city": "Lacombe"},
    {"city": "Ladern-sur-Lauquet"},
    {"city": "Lafage"},
    {"city": "Lagrasse"},
    {"city": "Lairière"},
    {"city": "Lanet"},
    {"city": "La Palme"},
    {"city": "Laprade"},
    {"city": "La Redorte"},
    {"city": "Laroque-de-Fa"},
    {"city": "Lasbordes"},
    {"city": "Lasserre-de-Prouille"},
    {"city": "Lastours"},
    {"city": "Laurabuc"},
    {"city": "Laurac"},
    {"city": "Lauraguel"},
    {"city": "Laure-Minervois"},
    {"city": "Lavalette"},
    {"city": "Lespinassière"},
    {"city": "Leuc"},
    {"city": "Leucate"},
    {"city": "Lézignan-Corbières"},
    {"city": "Lignairolles"},
    {"city": "Limousis"},
    {"city": "Limoux"},
    {"city": "Loupia"},
    {"city": "La Louvière-Lauragais"},
    {"city": "Luc-sur-Aude"},
    {"city": "Luc-sur-Orbieu"},
    {"city": "Magrie"},
    {"city": "Mailhac"},
    {"city": "Maisons"},
    {"city": "Malras"},
    {"city": "Malves-en-Minervois"},
    {"city": "Malviès"},
    {"city": "Marcorignan"},
    {"city": "Marquein"},
    {"city": "Marsa"},
    {"city": "Marseillette"},
    {"city": "Les Martys"},
    {"city": "Mas-Cabardès"},
    {"city": "Mas-des-Cours"},
    {"city": "Massac"},
    {"city": "Mas-Saintes-Puelles"},
    {"city": "Mayreville"},
    {"city": "Mayronnes"},
    {"city": "Mazerolles-du-Razès"},
    {"city": "Mazuby"},
    {"city": "Mérial"},
    {"city": "Mézerville"},
    {"city": "Miraval-Cabardès"},
    {"city": "Mirepeisset"},
    {"city": "Mireval-Lauragais"},
    {"city": "Missègre"},
    {"city": "Molandier"},
    {"city": "Molleville"},
    {"city": "Montauriol"},
    {"city": "Montazels"},
    {"city": "Montbrun-des-Corbières"},
    {"city": "Montclar"},
    {"city": "Montferrand"},
    {"city": "Montfort-sur-Boulzane"},
    {"city": "Montgaillard"},
    {"city": "Montgradail"},
    {"city": "Monthaut"},
    {"city": "Montirat"},
    {"city": "Montjardin"},
    {"city": "Montjoi"},
    {"city": "Val-de-Dagne"},
    {"city": "Montmaur"},
    {"city": "Montolieu"},
    {"city": "Montréal"},
    {"city": "Montredon-des-Corbières"},
    {"city": "Montséret"},
    {"city": "Monze"},
    {"city": "Moussan"},
    {"city": "Moussoulens"},
    {"city": "Mouthoumet"},
    {"city": "Moux"},
    {"city": "Narbonne"},
    {"city": "Nébias"},
    {"city": "Névian"},
    {"city": "Niort-de-Sault"},
    {"city": "Port-la-Nouvelle"},
    {"city": "Ornaisons"},
    {"city": "Orsans"},
    {"city": "Ouveillan"},
    {"city": "Padern"},
    {"city": "Palairac"},
    {"city": "Palaja"},
    {"city": "Paraza"},
    {"city": "Pauligne"},
    {"city": "Payra-sur-l'Hers"},
    {"city": "Paziols"},
    {"city": "Pécharic-et-le-Py"},
    {"city": "Pech-Luna"},
    {"city": "Pennautier"},
    {"city": "Pépieux"},
    {"city": "Pexiora"},
    {"city": "Peyrefitte-du-Razès"},
    {"city": "Peyrefitte-sur-l'Hers"},
    {"city": "Peyrens"},
    {"city": "Peyriac-de-Mer"},
    {"city": "Peyriac-Minervois"},
    {"city": "Peyrolles"},
    {"city": "Pezens"},
    {"city": "Pieusse"},
    {"city": "Plaigne"},
    {"city": "Plavilla"},
    {"city": "La Pomarède"},
    {"city": "Pomas"},
    {"city": "Pomy"},
    {"city": "Portel-des-Corbières"},
    {"city": "Pouzols-Minervois"},
    {"city": "Pradelles-Cabardès"},
    {"city": "Preixan"},
    {"city": "Puginier"},
    {"city": "Puichéric"},
    {"city": "Puilaurens"},
    {"city": "Puivert"},
    {"city": "Quillan"},
    {"city": "Quintillan"},
    {"city": "Quirbajou"},
    {"city": "Raissac-d'Aude"},
    {"city": "Raissac-sur-Lampy"},
    {"city": "Rennes-le-Château"},
    {"city": "Rennes-les-Bains"},
    {"city": "Ribaute"},
    {"city": "Ribouisse"},
    {"city": "Ricaud"},
    {"city": "Rieux-en-Val"},
    {"city": "Rieux-Minervois"},
    {"city": "Rivel"},
    {"city": "Rodome"},
    {"city": "Roquecourbe-Minervois"},
    {"city": "Roquefère"},
    {"city": "Roquefeuil"},
    {"city": "Roquefort-de-Sault"},
    {"city": "Roquefort-des-Corbières"},
    {"city": "Roquetaillade-et-Conilhac"},
    {"city": "Roubia"},
    {"city": "Rouffiac-d'Aude"},
    {"city": "Rouffiac-des-Corbières"},
    {"city": "Roullens"},
    {"city": "Routier"},
    {"city": "Rustiques"},
    {"city": "Saint-Amans"},
    {"city": "Saint-André-de-Roquelongue"},
    {"city": "Saint-Benoît"},
    {"city": "Sainte-Camelle"},
    {"city": "Sainte-Colombe-sur-Guette"},
    {"city": "Sainte-Colombe-sur-l'Hers"},
    {"city": "Saint-Couat-d'Aude"},
    {"city": "Saint-Couat-du-Razès"},
    {"city": "Saint-Denis"},
    {"city": "Sainte-Eulalie"},
    {"city": "Saint-Ferriol"},
    {"city": "Saint-Frichoux"},
    {"city": "Saint-Gaudéric"},
    {"city": "Saint-Hilaire"},
    {"city": "Saint-Jean-de-Barrou"},
    {"city": "Saint-Jean-de-Paracol"},
    {"city": "Saint-Julia-de-Bec"},
    {"city": "Saint-Julien-de-Briola"},
    {"city": "Saint-Just-et-le-Bézu"},
    {"city": "Saint-Laurent-de-la-Cabrerisse"},
    {"city": "Saint-Louis-et-Parahou"},
    {"city": "Saint-Marcel-sur-Aude"},
    {"city": "Saint-Martin-des-Puits"},
    {"city": "Saint-Martin-de-Villereglan"},
    {"city": "Saint-Martin-Lalande"},
    {"city": "Saint-Martin-le-Vieil"},
    {"city": "Saint-Martin-Lys"},
    {"city": "Saint-Michel-de-Lanès"},
    {"city": "Saint-Nazaire-d'Aude"},
    {"city": "Saint-Papoul"},
    {"city": "Saint-Paulet"},
    {"city": "Saint-Pierre-des-Champs"},
    {"city": "Saint-Polycarpe"},
    {"city": "Saint-Sernin"},
    {"city": "Sainte-Valière"},
    {"city": "Saissac"},
    {"city": "Sallèles-Cabardès"},
    {"city": "Sallèles-d'Aude"},
    {"city": "Salles-d'Aude"},
    {"city": "Salles-sur-l'Hers"},
    {"city": "Salsigne"},
    {"city": "Salvezines"},
    {"city": "Salza"},
    {"city": "Seignalens"},
    {"city": "La Serpent"},
    {"city": "Serres"},
    {"city": "Serviès-en-Val"},
    {"city": "Sigean"},
    {"city": "Sonnac-sur-l'Hers"},
    {"city": "Sougraigne"},
    {"city": "Souilhanels"},
    {"city": "Souilhe"},
    {"city": "Soulatgé"},
    {"city": "Soupex"},
    {"city": "Talairan"},
    {"city": "Taurize"},
    {"city": "Termes"},
    {"city": "Terroles"},
    {"city": "Thézan-des-Corbières"},
    {"city": "La Tourette-Cabardès"},
    {"city": "Tournissan"},
    {"city": "Tourouzelle"},
    {"city": "Tourreilles"},
    {"city": "Trassanel"},
    {"city": "Trausse"},
    {"city": "Trèbes"},
    {"city": "Treilles"},
    {"city": "Tréville"},
    {"city": "Tréziers"},
    {"city": "Tuchan"},
    {"city": "Valmigère"},
    {"city": "Ventenac-Cabardès"},
    {"city": "Ventenac-en-Minervois"},
    {"city": "Véraza"},
    {"city": "Verdun-en-Lauragais"},
    {"city": "Verzeille"},
    {"city": "Vignevieille"},
    {"city": "Villalier"},
    {"city": "Villanière"},
    {"city": "Villardebelle"},
    {"city": "Villardonnel"},
    {"city": "Villar-en-Val"},
    {"city": "Villar-Saint-Anselme"},
    {"city": "Villarzel-Cabardès"},
    {"city": "Villarzel-du-Razès"},
    {"city": "Villasavary"},
    {"city": "Villautou"},
    {"city": "Villebazy"},
    {"city": "Villedaigne"},
    {"city": "Villedubert"},
    {"city": "Villefloure"},
    {"city": "Villefort"},
    {"city": "Villegailhenc"},
    {"city": "Villegly"},
    {"city": "Villelongue-d'Aude"},
    {"city": "Villemagne"},
    {"city": "Villemoustaussou"},
    {"city": "Villeneuve-la-Comptal"},
    {"city": "Villeneuve-les-Corbières"},
    {"city": "Villeneuve-lès-Montréal"},
    {"city": "Villeneuve-Minervois"},
    {"city": "Villepinte"},
    {"city": "Villerouge-Termenès"},
    {"city": "Villesèque-des-Corbières"},
    {"city": "Villesèquelande"},
    {"city": "Villesiscle"},
    {"city": "Villespy"},
    {"city": "Villetritouls"},
    {"city": "Vinassan"},
    {"city": "Agen-d'Aveyron"},
    {"city": "Aguessac"},
    {"city": "Les Albres"},
    {"city": "Almont-les-Junies"},
    {"city": "Alrance"},
    {"city": "Ambeyrac"},
    {"city": "Anglars-Saint-Félix"},
    {"city": "Arnac-sur-Dourdou"},
    {"city": "Arques"},
    {"city": "Arvieu"},
    {"city": "Asprières"},
    {"city": "Aubin"},
    {"city": "Auriac-Lagast"},
    {"city": "Auzits"},
    {"city": "Ayssènes"},
    {"city": "Balaguier-d'Olt"},
    {"city": "Balaguier-sur-Rance"},
    {"city": "Le Bas Ségala"},
    {"city": "La Bastide-Pradines"},
    {"city": "La Bastide-Solages"},
    {"city": "Belcastel"},
    {"city": "Belmont-sur-Rance"},
    {"city": "Bertholène"},
    {"city": "Bessuéjouls"},
    {"city": "Boisse-Penchot"},
    {"city": "Bor-et-Bar"},
    {"city": "Bouillac"},
    {"city": "Bournazel"},
    {"city": "Boussac"},
    {"city": "Bozouls"},
    {"city": "Brandonnet"},
    {"city": "Brasc"},
    {"city": "Brommat"},
    {"city": "Broquiès"},
    {"city": "Brousse-le-Château"},
    {"city": "Brusque"},
    {"city": "Cabanès"},
    {"city": "Calmels-et-le-Viala"},
    {"city": "Calmont"},
    {"city": "Camarès"},
    {"city": "Camboulazet"},
    {"city": "Camjac"},
    {"city": "Campagnac"},
    {"city": "Campouriez"},
    {"city": "Campuac"},
    {"city": "Canet-de-Salars"},
    {"city": "Cantoin"},
    {"city": "Capdenac-Gare"},
    {"city": "La Capelle-Balaguier"},
    {"city": "La Capelle-Bleys"},
    {"city": "La Capelle-Bonance"},
    {"city": "Baraqueville"},
    {"city": "Cassagnes-Bégonhès"},
    {"city": "Cassuéjouls"},
    {"city": "Castanet"},
    {"city": "Castelmary"},
    {"city": "Castelnau-de-Mandailles"},
    {"city": "Castelnau-Pégayrols"},
    {"city": "La Cavalerie"},
    {"city": "Le Cayrol"},
    {"city": "Centrès"},
    {"city": "Clairvaux-d'Aveyron"},
    {"city": "Le Clapier"},
    {"city": "Colombiès"},
    {"city": "Combret"},
    {"city": "Compeyre"},
    {"city": "Compolibat"},
    {"city": "Comprégnac"},
    {"city": "Comps-la-Grand-Ville"},
    {"city": "Condom-d'Aubrac"},
    {"city": "Connac"},
    {"city": "Conques-en-Rouergue"},
    {"city": "Cornus"},
    {"city": "Les Costes-Gozon"},
    {"city": "Coubisou"},
    {"city": "Coupiac"},
    {"city": "La Couvertoirade"},
    {"city": "Cransac"},
    {"city": "Creissels"},
    {"city": "Crespin"},
    {"city": "La Cresse"},
    {"city": "Curières"},
    {"city": "Decazeville"},
    {"city": "Druelle Balsac"},
    {"city": "Drulhe"},
    {"city": "Durenque"},
    {"city": "Le Fel"},
    {"city": "Entraygues-sur-Truyère"},
    {"city": "Escandolières"},
    {"city": "Espalion"},
    {"city": "Espeyrac"},
    {"city": "Estaing"},
    {"city": "Fayet"},
    {"city": "Firmi"},
    {"city": "Flagnac"},
    {"city": "Flavin"},
    {"city": "Florentin-la-Capelle"},
    {"city": "Foissac"},
    {"city": "La Fouillade"},
    {"city": "Gabriac"},
    {"city": "Gaillac-d'Aveyron"},
    {"city": "Galgan"},
    {"city": "Gissac"},
    {"city": "Golinhac"},
    {"city": "Goutrens"},
    {"city": "Gramond"},
    {"city": "L'Hospitalet-du-Larzac"},
    {"city": "Huparlac"},
    {"city": "Lacroix-Barrez"},
    {"city": "Laguiole"},
    {"city": "Laissac-Sévérac l'Église"},
    {"city": "Lanuéjouls"},
    {"city": "Lapanouse-de-Cernon"},
    {"city": "Lassouts"},
    {"city": "Laval-Roquecezière"},
    {"city": "Lédergues"},
    {"city": "Lescure-Jaoul"},
    {"city": "Lestrade-et-Thouels"},
    {"city": "Livinhac-le-Haut"},
    {"city": "La Loubière"},
    {"city": "Luc-la-Primaube"},
    {"city": "Lugan"},
    {"city": "Lunac"},
    {"city": "Maleville"},
    {"city": "Manhac"},
    {"city": "Marcillac-Vallon"},
    {"city": "Marnhagues-et-Latour"},
    {"city": "Martiel"},
    {"city": "Martrin"},
    {"city": "Mayran"},
    {"city": "Mélagues"},
    {"city": "Meljac"},
    {"city": "Millau"},
    {"city": "Le Monastère"},
    {"city": "Montagnol"},
    {"city": "Montbazens"},
    {"city": "Montclar"},
    {"city": "Monteils"},
    {"city": "Montézic"},
    {"city": "Montfranc"},
    {"city": "Montjaux"},
    {"city": "Montlaur"},
    {"city": "Fondamente"},
    {"city": "Montpeyroux"},
    {"city": "Montrozier"},
    {"city": "Montsalès"},
    {"city": "Morlhon-le-Haut"},
    {"city": "Mostuéjouls"},
    {"city": "Mouret"},
    {"city": "Moyrazès"},
    {"city": "Murasson"},
    {"city": "Mur-de-Barrez"},
    {"city": "Muret-le-Château"},
    {"city": "Murols"},
    {"city": "Najac"},
    {"city": "Nant"},
    {"city": "Naucelle"},
    {"city": "Naussac"},
    {"city": "Nauviale"},
    {"city": "Le Nayrac"},
    {"city": "Olemps"},
    {"city": "Ols-et-Rinhodes"},
    {"city": "Onet-le-Château"},
    {"city": "Palmas d'Aveyron"},
    {"city": "Paulhe"},
    {"city": "Peux-et-Couffouleux"},
    {"city": "Peyreleau"},
    {"city": "Peyrusse-le-Roc"},
    {"city": "Pierrefiche"},
    {"city": "Plaisance"},
    {"city": "Pomayrols"},
    {"city": "Pont-de-Salars"},
    {"city": "Pousthomy"},
    {"city": "Prades-d'Aubrac"},
    {"city": "Prades-Salars"},
    {"city": "Pradinas"},
    {"city": "Prévinquières"},
    {"city": "Privezac"},
    {"city": "Mounes-Prohencoux"},
    {"city": "Pruines"},
    {"city": "Quins"},
    {"city": "Rebourguil"},
    {"city": "Réquista"},
    {"city": "Rieupeyroux"},
    {"city": "Rignac"},
    {"city": "Rivière-sur-Tarn"},
    {"city": "Rodelle"},
    {"city": "Rodez"},
    {"city": "Roquefort-sur-Soulzon"},
    {"city": "La Roque-Sainte-Marguerite"},
    {"city": "La Rouquette"},
    {"city": "Roussennac"},
    {"city": "Rullac-Saint-Cirq"},
    {"city": "Saint-Affrique"},
    {"city": "Saint-Amans-des-Cots"},
    {"city": "Saint-André-de-Najac"},
    {"city": "Saint-André-de-Vézines"},
    {"city": "Saint-Beaulize"},
    {"city": "Saint-Beauzély"},
    {"city": "Saint-Chély-d'Aubrac"},
    {"city": "Saint-Christophe-Vallon"},
    {"city": "Saint-Côme-d'Olt"},
    {"city": "Sainte-Croix"},
    {"city": "Sainte-Eulalie-d'Olt"},
    {"city": "Sainte-Eulalie-de-Cernon"},
    {"city": "Saint-Félix-de-Lunel"},
    {"city": "Saint-Félix-de-Sorgues"},
    {"city": "Argences en Aubrac"},
    {"city": "Saint Geniez d'Olt et d'Aubrac"},
    {"city": "Saint-Georges-de-Luzençon"},
    {"city": "Saint-Hippolyte"},
    {"city": "Saint-Igest"},
    {"city": "Saint-Izaire"},
    {"city": "Saint-Jean-d'Alcapiès"},
    {"city": "Saint-Jean-Delnous"},
    {"city": "Saint-Jean-du-Bruel"},
    {"city": "Saint-Jean-et-Saint-Paul"},
    {"city": "Saint-Juéry"},
    {"city": "Sainte-Juliette-sur-Viaur"},
    {"city": "Saint-Just-sur-Viaur"},
    {"city": "Saint-Laurent-de-Lévézou"},
    {"city": "Saint-Laurent-d'Olt"},
    {"city": "Saint-Léons"},
    {"city": "Saint-Martin-de-Lenne"},
    {"city": "Saint-Parthem"},
    {"city": "Sainte-Radegonde"},
    {"city": "Saint-Rémy"},
    {"city": "Saint-Rome-de-Cernon"},
    {"city": "Saint-Rome-de-Tarn"},
    {"city": "Saint-Santin"},
    {"city": "Saint-Saturnin-de-Lenne"},
    {"city": "Saint-Sernin-sur-Rance"},
    {"city": "Saint-Sever-du-Moustier"},
    {"city": "Saint-Symphorien-de-Thénières"},
    {"city": "Saint-Victor-et-Melvieu"},
    {"city": "Salles-Courbatiès"},
    {"city": "Salles-Curan"},
    {"city": "Salles-la-Source"},
    {"city": "Salmiech"},
    {"city": "Salvagnac-Cajarc"},
    {"city": "Causse-et-Diège"},
    {"city": "La Salvetat-Peyralès"},
    {"city": "Sanvensa"},
    {"city": "Sauclières"},
    {"city": "Saujac"},
    {"city": "Sauveterre-de-Rouergue"},
    {"city": "Savignac"},
    {"city": "Sébazac-Concourès"},
    {"city": "Sébrazac"},
    {"city": "Ségur"},
    {"city": "La Selve"},
    {"city": "Sénergues"},
    {"city": "La Serre"},
    {"city": "Sévérac d'Aveyron"},
    {"city": "Sonnac"},
    {"city": "Soulages-Bonneval"},
    {"city": "Sylvanès"},
    {"city": "Tauriac-de-Camarès"},
    {"city": "Tauriac-de-Naucelle"},
    {"city": "Taussac"},
    {"city": "Tayrac"},
    {"city": "Thérondels"},
    {"city": "Toulonjac"},
    {"city": "Tournemire"},
    {"city": "Trémouilles"},
    {"city": "Le Truel"},
    {"city": "Vabres-l'Abbaye"},
    {"city": "Vailhourles"},
    {"city": "Valady"},
    {"city": "Valzergues"},
    {"city": "Vaureilles"},
    {"city": "Verrières"},
    {"city": "Versols-et-Lapeyre"},
    {"city": "Veyreau"},
    {"city": "Vézins-de-Lévézou"},
    {"city": "Viala-du-Pas-de-Jaux"},
    {"city": "Viala-du-Tarn"},
    {"city": "Le Vibal"},
    {"city": "Villecomtal"},
    {"city": "Villefranche-de-Panat"},
    {"city": "Villefranche-de-Rouergue"},
    {"city": "Villeneuve"},
    {"city": "Vimenet"},
    {"city": "Viviez"},
    {"city": "Curan"},
    {"city": "Aix-en-Provence"},
    {"city": "Allauch"},
    {"city": "Alleins"},
    {"city": "Arles"},
    {"city": "Aubagne"},
    {"city": "Aureille"},
    {"city": "Auriol"},
    {"city": "Aurons"},
    {"city": "La Barben"},
    {"city": "Barbentane"},
    {"city": "Les Baux-de-Provence"},
    {"city": "Beaurecueil"},
    {"city": "Belcodène"},
    {"city": "Berre-l'Étang"},
    {"city": "Bouc-Bel-Air"},
    {"city": "La Bouilladisse"},
    {"city": "Boulbon"},
    {"city": "Cabannes"},
    {"city": "Cabriès"},
    {"city": "Cadolive"},
    {"city": "Carry-le-Rouet"},
    {"city": "Cassis"},
    {"city": "Ceyreste"},
    {"city": "Charleval"},
    {"city": "Châteauneuf-le-Rouge"},
    {"city": "Châteauneuf-les-Martigues"},
    {"city": "Châteaurenard"},
    {"city": "La Ciotat"},
    {"city": "Cornillon-Confoux"},
    {"city": "Cuges-les-Pins"},
    {"city": "La Destrousse"},
    {"city": "Éguilles"},
    {"city": "Ensuès-la-Redonne"},
    {"city": "Eygalières"},
    {"city": "Eyguières"},
    {"city": "Eyragues"},
    {"city": "La Fare-les-Oliviers"},
    {"city": "Fontvieille"},
    {"city": "Fos-sur-Mer"},
    {"city": "Fuveau"},
    {"city": "Gardanne"},
    {"city": "Gémenos"},
    {"city": "Gignac-la-Nerthe"},
    {"city": "Grans"},
    {"city": "Graveson"},
    {"city": "Gréasque"},
    {"city": "Istres"},
    {"city": "Jouques"},
    {"city": "Lamanon"},
    {"city": "Lambesc"},
    {"city": "Lançon-Provence"},
    {"city": "Maillane"},
    {"city": "Mallemort"},
    {"city": "Marignane"},
    {"city": "Marseille"},
    {"city": "Martigues"},
    {"city": "Mas-Blanc-des-Alpilles"},
    {"city": "Maussane-les-Alpilles"},
    {"city": "Meyrargues"},
    {"city": "Meyreuil"},
    {"city": "Saint-Pierre-de-Mézoargues"},
    {"city": "Mimet"},
    {"city": "Miramas"},
    {"city": "Mollégès"},
    {"city": "Mouriès"},
    {"city": "Noves"},
    {"city": "Orgon"},
    {"city": "Paradou"},
    {"city": "Pélissanne"},
    {"city": "La Penne-sur-Huveaune"},
    {"city": "Les Pennes-Mirabeau"},
    {"city": "Peynier"},
    {"city": "Peypin"},
    {"city": "Peyrolles-en-Provence"},
    {"city": "Plan-de-Cuques"},
    {"city": "Plan-d'Orgon"},
    {"city": "Port-de-Bouc"},
    {"city": "Port-Saint-Louis-du-Rhône"},
    {"city": "Puyloubier"},
    {"city": "Le Puy-Sainte-Réparade"},
    {"city": "Rognac"},
    {"city": "Rognes"},
    {"city": "Rognonas"},
    {"city": "La Roque-d'Anthéron"},
    {"city": "Roquefort-la-Bédoule"},
    {"city": "Roquevaire"},
    {"city": "Rousset"},
    {"city": "Le Rove"},
    {"city": "Saint-Andiol"},
    {"city": "Saint-Antonin-sur-Bayon"},
    {"city": "Saint-Cannat"},
    {"city": "Saint-Chamas"},
    {"city": "Saint-Estève-Janson"},
    {"city": "Saint-Étienne-du-Grès"},
    {"city": "Saint-Marc-Jaumegarde"},
    {"city": "Saintes-Maries-de-la-Mer"},
    {"city": "Saint-Martin-de-Crau"},
    {"city": "Saint-Mitre-les-Remparts"},
    {"city": "Saint-Paul-lès-Durance"},
    {"city": "Saint-Rémy-de-Provence"},
    {"city": "Saint-Savournin"},
    {"city": "Saint-Victoret"},
    {"city": "Salon-de-Provence"},
    {"city": "Sausset-les-Pins"},
    {"city": "Sénas"},
    {"city": "Septèmes-les-Vallons"},
    {"city": "Simiane-Collongue"},
    {"city": "Tarascon"},
    {"city": "Le Tholonet"},
    {"city": "Trets"},
    {"city": "Vauvenargues"},
    {"city": "Velaux"},
    {"city": "Venelles"},
    {"city": "Ventabren"},
    {"city": "Vernègues"},
    {"city": "Verquières"},
    {"city": "Vitrolles"},
    {"city": "Coudoux"},
    {"city": "Carnoux-en-Provence"},
    {"city": "Ablon"},
    {"city": "Agy"},
    {"city": "Valambray"},
    {"city": "Amayé-sur-Orne"},
    {"city": "Amayé-sur-Seulles"},
    {"city": "Amfreville"},
    {"city": "Aurseulles"},
    {"city": "Angerville"},
    {"city": "Colomby-Anguerny"},
    {"city": "Anisy"},
    {"city": "Annebault"},
    {"city": "Arganchy"},
    {"city": "Argences"},
    {"city": "Arromanches-les-Bains"},
    {"city": "Asnelles"},
    {"city": "Asnières-en-Bessin"},
    {"city": "Auberville"},
    {"city": "Aubigny"},
    {"city": "Audrieu"},
    {"city": "Les Monts d'Aunay"},
    {"city": "Authie"},
    {"city": "Les Authieux-sur-Calonne"},
    {"city": "Auvillars"},
    {"city": "Avenay"},
    {"city": "Balleroy-sur-Drôme"},
    {"city": "Banneville-la-Campagne"},
    {"city": "Malherbe-sur-Ajon"},
    {"city": "Banville"},
    {"city": "Barbery"},
    {"city": "Barbeville"},
    {"city": "Barneville-la-Bertran"},
    {"city": "Baron-sur-Odon"},
    {"city": "Barou-en-Auge"},
    {"city": "Basly"},
    {"city": "Basseneville"},
    {"city": "Bavent"},
    {"city": "Bayeux"},
    {"city": "Bazenville"},
    {"city": "La Bazoque"},
    {"city": "Beaumais"},
    {"city": "Beaumesnil"},
    {"city": "Beaumont-en-Auge"},
    {"city": "Bellengreville"},
    {"city": "Benerville-sur-Mer"},
    {"city": "Bénouville"},
    {"city": "Souleuvre en Bocage"},
    {"city": "Bény-sur-Mer"},
    {"city": "Bernesq"},
    {"city": "Bernières-d'Ailly"},
    {"city": "Bernières-sur-Mer"},
    {"city": "Biéville-Beuville"},
    {"city": "Beuvillers"},
    {"city": "Beuvron-en-Auge"},
    {"city": "Blainville-sur-Orne"},
    {"city": "Blangy-le-Château"},
    {"city": "Blay"},
    {"city": "Blonville-sur-Mer"},
    {"city": "Le Bô"},
    {"city": "La Boissière"},
    {"city": "Bonnebosq"},
    {"city": "Bonnemaison"},
    {"city": "Bonneville-la-Louvet"},
    {"city": "Bonneville-sur-Touques"},
    {"city": "Bonnœil"},
    {"city": "Bons-Tassilly"},
    {"city": "Bougy"},
    {"city": "Boulon"},
    {"city": "Bourgeauville"},
    {"city": "Bourguébus"},
    {"city": "Branville"},
    {"city": "Brémoy"},
    {"city": "Bretteville-le-Rabet"},
    {"city": "Thue et Mue"},
    {"city": "Bretteville-sur-Laize"},
    {"city": "Bretteville-sur-Odon"},
    {"city": "Le Breuil-en-Auge"},
    {"city": "Le Breuil-en-Bessin"},
    {"city": "Le Brévedent"},
    {"city": "Bréville-les-Monts"},
    {"city": "Bricqueville"},
    {"city": "Brucourt"},
    {"city": "Bucéels"},
    {"city": "Le Bû-sur-Rouvres"},
    {"city": "Cabourg"},
    {"city": "Caen"},
    {"city": "Cagny"},
    {"city": "Cahagnes"},
    {"city": "Cahagnolles"},
    {"city": "La Caine"},
    {"city": "Cairon"},
    {"city": "La Cambe"},
    {"city": "Cambes-en-Plaine"},
    {"city": "Cambremer"},
    {"city": "Campagnolles"},
    {"city": "Campigny"},
    {"city": "Canapville"},
    {"city": "Canchy"},
    {"city": "Canteloup"},
    {"city": "Carcagny"},
    {"city": "Cardonville"},
    {"city": "Carpiquet"},
    {"city": "Cartigny-l'Épinay"},
    {"city": "Castillon"},
    {"city": "Castillon-en-Auge"},
    {"city": "Caumont-sur-Aure"},
    {"city": "Cauvicourt"},
    {"city": "Cauville"},
    {"city": "Cernay"},
    {"city": "Cesny-aux-Vignes"},
    {"city": "Cesny-les-Sources"},
    {"city": "Chouain"},
    {"city": "Cintheaux"},
    {"city": "Clarbec"},
    {"city": "Clécy"},
    {"city": "Cléville"},
    {"city": "Colleville-sur-Mer"},
    {"city": "Colleville-Montgomery"},
    {"city": "Colombelles"},
    {"city": "Colombières"},
    {"city": "Colombiers-sur-Seulles"},
    {"city": "Combray"},
    {"city": "Commes"},
    {"city": "Condé-sur-Ifs"},
    {"city": "Condé-en-Normandie"},
    {"city": "Condé-sur-Seulles"},
    {"city": "Coquainvilliers"},
    {"city": "Cordebugle"},
    {"city": "Cordey"},
    {"city": "Cormelles-le-Royal"},
    {"city": "Cormolain"},
    {"city": "Cossesseville"},
    {"city": "Cottun"},
    {"city": "Courcy"},
    {"city": "Courseulles-sur-Mer"},
    {"city": "Courtonne-la-Meurdrac"},
    {"city": "Courtonne-les-Deux-Églises"},
    {"city": "Courvaudon"},
    {"city": "Crépon"},
    {"city": "Cresserons"},
    {"city": "Cresseveuille"},
    {"city": "Creully sur Seulles"},
    {"city": "Cricquebœuf"},
    {"city": "Cricqueville-en-Auge"},
    {"city": "Cricqueville-en-Bessin"},
    {"city": "Cristot"},
    {"city": "Crocy"},
    {"city": "Croisilles"},
    {"city": "Crouay"},
    {"city": "Culey-le-Patry"},
    {"city": "Cussy"},
    {"city": "Cuverville"},
    {"city": "Damblainville"},
    {"city": "Danestal"},
    {"city": "Deauville"},
    {"city": "Démouville"},
    {"city": "Le Détroit"},
    {"city": "Deux-Jumeaux"},
    {"city": "Dives-sur-Mer"},
    {"city": "Donnay"},
    {"city": "Douville-en-Auge"},
    {"city": "Douvres-la-Délivrande"},
    {"city": "Dozulé"},
    {"city": "Drubec"},
    {"city": "Beaufour-Druval"},
    {"city": "Ducy-Sainte-Marguerite"},
    {"city": "Ellon"},
    {"city": "Émiéville"},
    {"city": "Englesqueville-en-Auge"},
    {"city": "Englesqueville-la-Percée"},
    {"city": "Épaney"},
    {"city": "Épinay-sur-Odon"},
    {"city": "Épron"},
    {"city": "Équemauville"},
    {"city": "Eraines"},
    {"city": "Ernes"},
    {"city": "Escoville"},
    {"city": "Espins"},
    {"city": "Esquay-Notre-Dame"},
    {"city": "Esquay-sur-Seulles"},
    {"city": "Esson"},
    {"city": "Estrées-la-Campagne"},
    {"city": "Éterville"},
    {"city": "Étréham"},
    {"city": "Évrecy"},
    {"city": "Falaise"},
    {"city": "Fauguernon"},
    {"city": "Le Faulq"},
    {"city": "Feuguerolles-Bully"},
    {"city": "Fierville-les-Parcs"},
    {"city": "Firfol"},
    {"city": "Fleury-sur-Orne"},
    {"city": "La Folie"},
    {"city": "La Folletière-Abenon"},
    {"city": "Fontaine-Étoupefour"},
    {"city": "Fontaine-Henry"},
    {"city": "Fontaine-le-Pin"},
    {"city": "Fontenay-le-Marmion"},
    {"city": "Fontenay-le-Pesnel"},
    {"city": "Formentin"},
    {"city": "Formigny La Bataille"},
    {"city": "Foulognes"},
    {"city": "Fourches"},
    {"city": "Fourneaux-le-Val"},
    {"city": "Le Fournet"},
    {"city": "Fourneville"},
    {"city": "Frénouville"},
    {"city": "Le Fresne-Camilly"},
    {"city": "Fresné-la-Mère"},
    {"city": "Fresney-le-Puceux"},
    {"city": "Fresney-le-Vieux"},
    {"city": "Fumichon"},
    {"city": "Gavrus"},
    {"city": "Géfosse-Fontenay"},
    {"city": "Genneville"},
    {"city": "Gerrots"},
    {"city": "Giberville"},
    {"city": "Glanville"},
    {"city": "Glos"},
    {"city": "Gonneville-sur-Honfleur"},
    {"city": "Gonneville-sur-Mer"},
    {"city": "Gonneville-en-Auge"},
    {"city": "Goustranville"},
    {"city": "Gouvix"},
    {"city": "Grainville-Langannerie"},
    {"city": "Grainville-sur-Odon"},
    {"city": "Grandcamp-Maisy"},
    {"city": "Grangues"},
    {"city": "Graye-sur-Mer"},
    {"city": "Grentheville"},
    {"city": "Grimbosq"},
    {"city": "Guéron"},
    {"city": "Hermanville-sur-Mer"},
    {"city": "Hermival-les-Vaux"},
    {"city": "Hérouville-Saint-Clair"},
    {"city": "Hérouvillette"},
    {"city": "Heuland"},
    {"city": "La Hoguette"},
    {"city": "Honfleur"},
    {"city": "L'Hôtellerie"},
    {"city": "Hotot-en-Auge"},
    {"city": "Hottot-les-Bagues"},
    {"city": "La Houblonnière"},
    {"city": "Houlgate"},
    {"city": "Ifs"},
    {"city": "Isigny-sur-Mer"},
    {"city": "Les Isles-Bardel"},
    {"city": "Janville"},
    {"city": "Jort"},
    {"city": "Juaye-Mondaye"},
    {"city": "Dialan sur Chaîne"},
    {"city": "Juvigny-sur-Seulles"},
    {"city": "Laize-Clinchamps"},
    {"city": "Landelles-et-Coupigny"},
    {"city": "Landes-sur-Ajon"},
    {"city": "Langrune-sur-Mer"},
    {"city": "Ponts sur Seulles"},
    {"city": "Terres de Druance"},
    {"city": "Léaupartie"},
    {"city": "Leffard"},
    {"city": "Lessard-et-le-Chêne"},
    {"city": "Lingèvres"},
    {"city": "Lion-sur-Mer"},
    {"city": "Lisieux"},
    {"city": "Lison"},
    {"city": "Lisores"},
    {"city": "Litteau"},
    {"city": "Le Molay-Littry"},
    {"city": "Livarot-Pays-d'Auge"},
    {"city": "Les Loges"},
    {"city": "Les Loges-Saulces"},
    {"city": "Longues-sur-Mer"},
    {"city": "Longueville"},
    {"city": "Longvillers"},
    {"city": "Loucelles"},
    {"city": "Louvagny"},
    {"city": "Louvigny"},
    {"city": "Luc-sur-Mer"},
    {"city": "Magny-en-Bessin"},
    {"city": "Maisoncelles-Pelvey"},
    {"city": "Maisoncelles-sur-Ajon"},
    {"city": "Maisons"},
    {"city": "Maizet"},
    {"city": "Maizières"},
    {"city": "Maltot"},
    {"city": "Mandeville-en-Bessin"},
    {"city": "Manerbe"},
    {"city": "Manneville-la-Pipard"},
    {"city": "Le Manoir"},
    {"city": "Manvieux"},
    {"city": "Le Marais-la-Chapelle"},
    {"city": "Marolles"},
    {"city": "Martainville"},
    {"city": "Martigny-sur-l'Ante"},
    {"city": "Moulins en Bessin"},
    {"city": "Mathieu"},
    {"city": "May-sur-Orne"},
    {"city": "Merville-Franceville-Plage"},
    {"city": "Méry-Bissières-en-Auge"},
    {"city": "Meslay"},
    {"city": "Le Mesnil-au-Grain"},
    {"city": "Le Mesnil-Eudes"},
    {"city": "Le Mesnil-Guillaume"},
    {"city": "Le Mesnil-Robert"},
    {"city": "Le Mesnil-Simon"},
    {"city": "Le Mesnil-sur-Blangy"},
    {"city": "Le Mesnil-Villement"},
    {"city": "Meuvaines"},
    {"city": "Mézidon Vallée d'Auge"},
    {"city": "Les Monceaux"},
    {"city": "Monceaux-en-Bessin"},
    {"city": "Mondeville"},
    {"city": "Mondrainville"},
    {"city": "Monfréville"},
    {"city": "Montfiquet"},
    {"city": "Montigny"},
    {"city": "Montreuil-en-Auge"},
    {"city": "Monts-en-Bessin"},
    {"city": "Morteaux-Coulibœuf"},
    {"city": "Mosles"},
    {"city": "Mouen"},
    {"city": "Moulines"},
    {"city": "Moult-Chicheboville"},
    {"city": "Les Moutiers-en-Auge"},
    {"city": "Les Moutiers-en-Cinglais"},
    {"city": "Moyaux"},
    {"city": "Mutrécy"},
    {"city": "Nonant"},
    {"city": "Norolles"},
    {"city": "Noron-l'Abbaye"},
    {"city": "Noron-la-Poterie"},
    {"city": "Norrey-en-Auge"},
    {"city": "Notre-Dame-de-Livaye"},
    {"city": "Notre-Dame-d'Estrées-Corbon"},
    {"city": "Val d'Arry"},
    {"city": "Olendon"},
    {"city": "Orbec"},
    {"city": "Osmanville"},
    {"city": "Ouézy"},
    {"city": "Ouffières"},
    {"city": "Ouilly-du-Houley"},
    {"city": "Ouilly-le-Tesson"},
    {"city": "Ouilly-le-Vicomte"},
    {"city": "Ouistreham"},
    {"city": "Parfouru-sur-Odon"},
    {"city": "Pennedepie"},
    {"city": "Périers-en-Auge"},
    {"city": "Périers-sur-le-Dan"},
    {"city": "Périgny"},
    {"city": "Perrières"},
    {"city": "Pertheville-Ners"},
    {"city": "Petiville"},
    {"city": "Pierrefitte-en-Auge"},
    {"city": "Pierrefitte-en-Cinglais"},
    {"city": "Pierrepont"},
    {"city": "Le Pin"},
    {"city": "Planquery"},
    {"city": "Plumetot"},
    {"city": "La Pommeraye"},
    {"city": "Pont-Bellanger"},
    {"city": "Pontécoulant"},
    {"city": "Pont-l'Évêque"},
    {"city": "Port-en-Bessin-Huppain"},
    {"city": "Potigny"},
    {"city": "Préaux-Bocage"},
    {"city": "Le Pré-d'Auge"},
    {"city": "Prêtreville"},
    {"city": "Putot-en-Auge"},
    {"city": "Belle Vie en Auge"},
    {"city": "Quetteville"},
    {"city": "Ranchy"},
    {"city": "Ranville"},
    {"city": "Rapilly"},
    {"city": "Repentigny"},
    {"city": "Reux"},
    {"city": "Reviers"},
    {"city": "La Rivière-Saint-Sauveur"},
    {"city": "Castine-en-Plaine"},
    {"city": "Rocques"},
    {"city": "La Roque-Baignard"},
    {"city": "Rosel"},
    {"city": "Rots"},
    {"city": "Rouvres"},
    {"city": "Rubercy"},
    {"city": "Rumesnil"},
    {"city": "Ryes"},
    {"city": "Le Castelet"},
    {"city": "Saint-André-d'Hébertot"},
    {"city": "Saint-André-sur-Orne"},
    {"city": "Saint-Arnoult"},
    {"city": "Saint-Aubin-d'Arquenay"},
    {"city": "Saint-Aubin-des-Bois"},
    {"city": "Saint-Aubin-sur-Mer"},
    {"city": "Saint-Benoît-d'Hébertot"},
    {"city": "Saint-Côme-de-Fresné"},
    {"city": "Saint-Contest"},
    {"city": "Sainte-Croix-sur-Mer"},
    {"city": "Valorbiquet"},
    {"city": "Saint-Denis-de-Mailloc"},
    {"city": "Saint-Denis-de-Méré"},
    {"city": "Saint-Désir"},
    {"city": "Saint-Étienne-la-Thillaye"},
    {"city": "Val-de-Vie"},
    {"city": "Saint-Gatien-des-Bois"},
    {"city": "Seulline"},
    {"city": "Saint-Germain-de-Livet"},
    {"city": "Saint-Germain-du-Pert"},
    {"city": "Saint-Germain-la-Blanche-Herbe"},
    {"city": "Saint-Germain-Langot"},
    {"city": "Saint-Germain-le-Vasson"},
    {"city": "Sainte-Honorine-de-Ducy"},
    {"city": "Aure sur Mer"},
    {"city": "Sainte-Honorine-du-Fay"},
    {"city": "Saint-Hymer"},
    {"city": "Saint-Jean-de-Livet"},
    {"city": "Saint-Jouin"},
    {"city": "Saint-Julien-sur-Calonne"},
    {"city": "Saint-Lambert"},
    {"city": "Saint-Laurent-de-Condel"},
    {"city": "Saint-Laurent-sur-Mer"},
    {"city": "Saint-Léger-Dubosq"},
    {"city": "Saint-Louet-sur-Seulles"},
    {"city": "Saint-Loup-Hors"},
    {"city": "Saint-Manvieu-Norrey"},
    {"city": "Saint-Marcouf"},
    {"city": "Sainte-Marguerite-d'Elle"},
    {"city": "Sainte-Marie-Outre-l'Eau"},
    {"city": "Saint-Martin-aux-Chartrains"},
    {"city": "Saint-Martin-de-Bienfaite-la-Cressonnière"},
    {"city": "Saint-Martin-de-Blagny"},
    {"city": "Saint-Martin-de-Fontenay"},
    {"city": "Saint-Martin-de-la-Lieue"},
    {"city": "Saint-Martin-de-Mailloc"},
    {"city": "Saint-Martin-de-Mieux"},
    {"city": "Saint-Martin-des-Entrées"},
    {"city": "Saint-Omer"},
    {"city": "Saint-Ouen-du-Mesnil-Oger"},
    {"city": "Saint-Ouen-le-Pin"},
    {"city": "Saint-Pair"},
    {"city": "Saint-Paul-du-Vernay"},
    {"city": "Saint-Philbert-des-Champs"},
    {"city": "Saint-Pierre-Azif"},
    {"city": "Saint-Pierre-Canivet"},
    {"city": "Saint-Pierre-des-Ifs"},
    {"city": "Saint-Pierre-du-Bû"},
    {"city": "Saint-Pierre-du-Fresne"},
    {"city": "Saint-Pierre-du-Jonquet"},
    {"city": "Saint-Pierre-du-Mont"},
    {"city": "Saint-Pierre-en-Auge"},
    {"city": "Saint-Rémy"},
    {"city": "Saint-Samson"},
    {"city": "Noues de Sienne"},
    {"city": "Saint-Sylvain"},
    {"city": "Saint-Vaast-en-Auge"},
    {"city": "Saint-Vaast-sur-Seulles"},
    {"city": "Saint-Vigor-le-Grand"},
    {"city": "Sallen"},
    {"city": "Sallenelles"},
    {"city": "Sannerville"},
    {"city": "Saon"},
    {"city": "Saonnet"},
    {"city": "Sassy"},
    {"city": "Val de Drôme"},
    {"city": "Soignolles"},
    {"city": "Soliers"},
    {"city": "Sommervieu"},
    {"city": "Soulangy"},
    {"city": "Soumont-Saint-Quentin"},
    {"city": "Subles"},
    {"city": "Sully"},
    {"city": "Surrain"},
    {"city": "Surville"},
    {"city": "Tessel"},
    {"city": "Thaon"},
    {"city": "Le Theil-en-Auge"},
    {"city": "Le Hom"},
    {"city": "Tilly-sur-Seulles"},
    {"city": "Le Torquesne"},
    {"city": "Touffréville"},
    {"city": "Touques"},
    {"city": "Tour-en-Bessin"},
    {"city": "Tourgéville"},
    {"city": "Tournières"},
    {"city": "Tourville-en-Auge"},
    {"city": "Tourville-sur-Odon"},
    {"city": "Tracy-Bocage"},
    {"city": "Tracy-sur-Mer"},
    {"city": "Tréprel"},
    {"city": "Trévières"},
    {"city": "Troarn"},
    {"city": "Montillières-sur-Orne"},
    {"city": "Le Tronquay"},
    {"city": "Trouville-sur-Mer"},
    {"city": "Trungy"},
    {"city": "Urville"},
    {"city": "Ussy"},
    {"city": "Vacognes-Neuilly"},
    {"city": "Valsemé"},
    {"city": "Varaville"},
    {"city": "Valdallière"},
    {"city": "Vaucelles"},
    {"city": "Vauville"},
    {"city": "Vaux-sur-Aure"},
    {"city": "Vaux-sur-Seulles"},
    {"city": "Vendes"},
    {"city": "Vendeuvre"},
    {"city": "Versainville"},
    {"city": "Verson"},
    {"city": "Ver-sur-Mer"},
    {"city": "La Vespière-Friardel"},
    {"city": "Le Vey"},
    {"city": "Vicques"},
    {"city": "Victot-Pontfol"},
    {"city": "Vienne-en-Bessin"},
    {"city": "Vierville-sur-Mer"},
    {"city": "Vieux"},
    {"city": "Vieux-Bourg"},
    {"city": "Vignats"},
    {"city": "Villers-Bocage"},
    {"city": "Villers-Canivet"},
    {"city": "Villers-sur-Mer"},
    {"city": "Villerville"},
    {"city": "La Villette"},
    {"city": "Villons-les-Buissons"},
    {"city": "Villy-lez-Falaise"},
    {"city": "Villy-Bocage"},
    {"city": "Vimont"},
    {"city": "Vire Normandie"},
    {"city": "Pont-d'Ouilly"},
    {"city": "Allanche"},
    {"city": "Alleuze"},
    {"city": "Ally"},
    {"city": "Andelat"},
    {"city": "Anglards-de-Saint-Flour"},
    {"city": "Anglards-de-Salers"},
    {"city": "Anterrieux"},
    {"city": "Antignac"},
    {"city": "Apchon"},
    {"city": "Arches"},
    {"city": "Arnac"},
    {"city": "Arpajon-sur-Cère"},
    {"city": "Auriac-l'Église"},
    {"city": "Aurillac"},
    {"city": "Auzers"},
    {"city": "Ayrens"},
    {"city": "Badailhac"},
    {"city": "Barriac-les-Bosquets"},
    {"city": "Bassignac"},
    {"city": "Beaulieu"},
    {"city": "Boisset"},
    {"city": "Bonnac"},
    {"city": "Brageac"},
    {"city": "Albepierre-Bredons"},
    {"city": "Brezons"},
    {"city": "Puycapel"},
    {"city": "Carlat"},
    {"city": "Cassaniouze"},
    {"city": "Cayrols"},
    {"city": "Celoux"},
    {"city": "Cézens"},
    {"city": "Chaliers"},
    {"city": "Chalvignac"},
    {"city": "Champagnac"},
    {"city": "Champs-sur-Tarentaine-Marchal"},
    {"city": "Chanterelle"},
    {"city": "La Chapelle-d'Alagnon"},
    {"city": "La Chapelle-Laurent"},
    {"city": "Charmensac"},
    {"city": "Chaudes-Aigues"},
    {"city": "Chaussenac"},
    {"city": "Chazelles"},
    {"city": "Cheylade"},
    {"city": "Le Claux"},
    {"city": "Clavières"},
    {"city": "Collandres"},
    {"city": "Coltines"},
    {"city": "Condat"},
    {"city": "Coren"},
    {"city": "Crandelles"},
    {"city": "Cros-de-Montvert"},
    {"city": "Cros-de-Ronesque"},
    {"city": "Cussac"},
    {"city": "Deux-Verges"},
    {"city": "Dienne"},
    {"city": "Drugeac"},
    {"city": "Escorailles"},
    {"city": "Espinasse"},
    {"city": "Le Falgoux"},
    {"city": "Le Fau"},
    {"city": "Ferrières-Saint-Mary"},
    {"city": "Fontanges"},
    {"city": "Freix-Anglards"},
    {"city": "Fridefont"},
    {"city": "Giou-de-Mamou"},
    {"city": "Girgols"},
    {"city": "Glénat"},
    {"city": "Gourdièges"},
    {"city": "Jabrun"},
    {"city": "Jaleyrac"},
    {"city": "Joursac"},
    {"city": "Jou-sous-Monjou"},
    {"city": "Junhac"},
    {"city": "Jussac"},
    {"city": "Labesserette"},
    {"city": "Labrousse"},
    {"city": "Lacapelle-Barrès"},
    {"city": "Lacapelle-del-Fraisse"},
    {"city": "Lacapelle-Viescamp"},
    {"city": "Ladinhac"},
    {"city": "Lafeuillade-en-Vézie"},
    {"city": "Landeyrat"},
    {"city": "Lanobre"},
    {"city": "Lapeyrugue"},
    {"city": "Laroquebrou"},
    {"city": "Laroquevieille"},
    {"city": "Lascelle"},
    {"city": "Lastic"},
    {"city": "Laurie"},
    {"city": "Laveissenet"},
    {"city": "Laveissière"},
    {"city": "Lavigerie"},
    {"city": "Leucamp"},
    {"city": "Leynhac"},
    {"city": "Leyvaux"},
    {"city": "Lieutadès"},
    {"city": "Lorcières"},
    {"city": "Val d'Arcomie"},
    {"city": "Lugarde"},
    {"city": "Madic"},
    {"city": "Malbo"},
    {"city": "Mandailles-Saint-Julien"},
    {"city": "Marcenat"},
    {"city": "Marchastel"},
    {"city": "Marcolès"},
    {"city": "Marmanhac"},
    {"city": "Massiac"},
    {"city": "Mauriac"},
    {"city": "Maurines"},
    {"city": "Maurs"},
    {"city": "Méallet"},
    {"city": "Menet"},
    {"city": "Mentières"},
    {"city": "Molèdes"},
    {"city": "Molompize"},
    {"city": "La Monselie"},
    {"city": "Montboudif"},
    {"city": "Montchamp"},
    {"city": "Le Monteil"},
    {"city": "Montgreleix"},
    {"city": "Montmurat"},
    {"city": "Montsalvy"},
    {"city": "Montvert"},
    {"city": "Moussages"},
    {"city": "Murat"},
    {"city": "Narnhac"},
    {"city": "Naucelles"},
    {"city": "Neussargues en Pinatelle"},
    {"city": "Neuvéglise-sur-Truyère"},
    {"city": "Nieudan"},
    {"city": "Omps"},
    {"city": "Pailherols"},
    {"city": "Parlan"},
    {"city": "Paulhac"},
    {"city": "Paulhenc"},
    {"city": "Peyrusse"},
    {"city": "Pierrefort"},
    {"city": "Pleaux"},
    {"city": "Polminhac"},
    {"city": "Pradiers"},
    {"city": "Prunet"},
    {"city": "Quézac"},
    {"city": "Rageade"},
    {"city": "Raulhac"},
    {"city": "Reilhac"},
    {"city": "Rézentières"},
    {"city": "Riom-ès-Montagnes"},
    {"city": "Roannes-Saint-Mary"},
    {"city": "Roffiac"},
    {"city": "Rouffiac"},
    {"city": "Roumégoux"},
    {"city": "Rouziers"},
    {"city": "Ruynes-en-Margeride"},
    {"city": "Saignes"},
    {"city": "Saint-Amandin"},
    {"city": "Saint-Antoine"},
    {"city": "Saint-Bonnet-de-Condat"},
    {"city": "Saint-Bonnet-de-Salers"},
    {"city": "Saint-Cernin"},
    {"city": "Saint-Chamant"},
    {"city": "Saint-Cirgues-de-Jordanne"},
    {"city": "Saint-Cirgues-de-Malbert"},
    {"city": "Saint-Clément"},
    {"city": "Saint-Constant-Fournoulès"},
    {"city": "Saint-Étienne-Cantalès"},
    {"city": "Saint-Étienne-de-Carlat"},
    {"city": "Saint-Étienne-de-Maurs"},
    {"city": "Saint-Étienne-de-Chomeil"},
    {"city": "Sainte-Eulalie"},
    {"city": "Saint-Flour"},
    {"city": "Saint-Georges"},
    {"city": "Saint-Gérons"},
    {"city": "Saint-Hippolyte"},
    {"city": "Saint-Illide"},
    {"city": "Saint-Jacques-des-Blats"},
    {"city": "Saint-Julien-de-Toursac"},
    {"city": "Saint-Mamet-la-Salvetat"},
    {"city": "Sainte-Marie"},
    {"city": "Saint-Martial"},
    {"city": "Saint-Martin-Cantalès"},
    {"city": "Saint-Martin-sous-Vigouroux"},
    {"city": "Saint-Martin-Valmeroux"},
    {"city": "Saint-Mary-le-Plain"},
    {"city": "Saint-Paul-des-Landes"},
    {"city": "Saint-Paul-de-Salers"},
    {"city": "Saint-Pierre"},
    {"city": "Saint-Poncy"},
    {"city": "Saint-Projet-de-Salers"},
    {"city": "Saint-Rémy-de-Chaudes-Aigues"},
    {"city": "Saint-Santin-Cantalès"},
    {"city": "Saint-Santin-de-Maurs"},
    {"city": "Saint-Saturnin"},
    {"city": "Saint-Saury"},
    {"city": "Saint-Simon"},
    {"city": "Saint-Urcize"},
    {"city": "Saint-Victor"},
    {"city": "Saint-Vincent-de-Salers"},
    {"city": "Salers"},
    {"city": "Salins"},
    {"city": "Sansac-de-Marmiesse"},
    {"city": "Sansac-Veinazès"},
    {"city": "Sauvat"},
    {"city": "La Ségalassière"},
    {"city": "Ségur-les-Villas"},
    {"city": "Sénezergues"},
    {"city": "Siran"},
    {"city": "Soulages"},
    {"city": "Sourniac"},
    {"city": "Talizat"},
    {"city": "Tanavelle"},
    {"city": "Teissières-de-Cornet"},
    {"city": "Teissières-lès-Bouliès"},
    {"city": "Les Ternes"},
    {"city": "Thiézac"},
    {"city": "Tiviers"},
    {"city": "Tournemire"},
    {"city": "Trémouille"},
    {"city": "La Trinitat"},
    {"city": "Le Trioulou"},
    {"city": "Trizac"},
    {"city": "Ussel"},
    {"city": "Vabres"},
    {"city": "Valette"},
    {"city": "Valjouze"},
    {"city": "Valuéjols"},
    {"city": "Le Vaulmier"},
    {"city": "Vebret"},
    {"city": "Védrines-Saint-Loup"},
    {"city": "Velzic"},
    {"city": "Vernols"},
    {"city": "Veyrières"},
    {"city": "Vézac"},
    {"city": "Vèze"},
    {"city": "Vezels-Roussy"},
    {"city": "Vic-sur-Cère"},
    {"city": "Vieillespesse"},
    {"city": "Vieillevie"},
    {"city": "Le Vigean"},
    {"city": "Villedieu"},
    {"city": "Virargues"},
    {"city": "Vitrac"},
    {"city": "Ydes"},
    {"city": "Yolet"},
    {"city": "Ytrac"},
    {"city": "Le Rouget-Pers"},
    {"city": "Besse"},
    {"city": "Abzac"},
    {"city": "Les Adjots"},
    {"city": "Agris"},
    {"city": "Aigre"},
    {"city": "Alloue"},
    {"city": "Ambérac"},
    {"city": "Ambernac"},
    {"city": "Ambleville"},
    {"city": "Anais"},
    {"city": "Angeac-Champagne"},
    {"city": "Angeac-Charente"},
    {"city": "Angeduc"},
    {"city": "Angoulême"},
    {"city": "Ansac-sur-Vienne"},
    {"city": "Ars"},
    {"city": "Asnières-sur-Nouère"},
    {"city": "Aubeterre-sur-Dronne"},
    {"city": "Aunac-sur-Charente"},
    {"city": "Aussac-Vadalle"},
    {"city": "Baignes-Sainte-Radegonde"},
    {"city": "Balzac"},
    {"city": "Barbezières"},
    {"city": "Barbezieux-Saint-Hilaire"},
    {"city": "Bardenac"},
    {"city": "Barret"},
    {"city": "Barro"},
    {"city": "Bassac"},
    {"city": "Bazac"},
    {"city": "Beaulieu-sur-Sonnette"},
    {"city": "Bécheresse"},
    {"city": "Bellon"},
    {"city": "Benest"},
    {"city": "Bernac"},
    {"city": "Berneuil"},
    {"city": "Bessac"},
    {"city": "Bessé"},
    {"city": "Bioussac"},
    {"city": "Birac"},
    {"city": "Coteaux-du-Blanzacais"},
    {"city": "Blanzaguet-Saint-Cybard"},
    {"city": "Boisbreteau"},
    {"city": "Bonnes"},
    {"city": "Bonneuil"},
    {"city": "Bors (Canton de Tude-et-Lavalette)"},
    {"city": "Bors (Canton de Charente-Sud)"},
    {"city": "Le Bouchage"},
    {"city": "Bouëx"},
    {"city": "Bourg-Charente"},
    {"city": "Bouteville"},
    {"city": "Boutiers-Saint-Trojan"},
    {"city": "Brettes"},
    {"city": "Bréville"},
    {"city": "Brie"},
    {"city": "Brie-sous-Barbezieux"},
    {"city": "Brie-sous-Chalais"},
    {"city": "Brigueuil"},
    {"city": "Brillac"},
    {"city": "Brossac"},
    {"city": "Bunzac"},
    {"city": "Cellefrouin"},
    {"city": "Cellettes"},
    {"city": "Chabanais"},
    {"city": "Chabrac"},
    {"city": "Chadurie"},
    {"city": "Chalais"},
    {"city": "Challignac"},
    {"city": "Champagne-Vigny"},
    {"city": "Champagne-Mouton"},
    {"city": "Champmillon"},
    {"city": "Champniers"},
    {"city": "Chantillac"},
    {"city": "La Chapelle"},
    {"city": "Boisné-La Tude"},
    {"city": "Charmé"},
    {"city": "Charras"},
    {"city": "Chasseneuil-sur-Bonnieure"},
    {"city": "Chassenon"},
    {"city": "Chassiecq"},
    {"city": "Chassors"},
    {"city": "Châteaubernard"},
    {"city": "Châteauneuf-sur-Charente"},
    {"city": "Châtignac"},
    {"city": "Chazelles"},
    {"city": "Chenon"},
    {"city": "Cherves-Châtelars"},
    {"city": "Cherves-Richemont"},
    {"city": "La Chèvrerie"},
    {"city": "Chillac"},
    {"city": "Chirac"},
    {"city": "Claix"},
    {"city": "Cognac"},
    {"city": "Combiers"},
    {"city": "Condac"},
    {"city": "Condéon"},
    {"city": "Confolens"},
    {"city": "Coulgens"},
    {"city": "Coulonges"},
    {"city": "Courbillac"},
    {"city": "Courcôme"},
    {"city": "Courgeac"},
    {"city": "Courlac"},
    {"city": "La Couronne"},
    {"city": "Couture"},
    {"city": "Criteuil-la-Magdeleine"},
    {"city": "Curac"},
    {"city": "Deviat"},
    {"city": "Dignac"},
    {"city": "Dirac"},
    {"city": "Douzat"},
    {"city": "Ébréon"},
    {"city": "Échallat"},
    {"city": "Écuras"},
    {"city": "Édon"},
    {"city": "Empuré"},
    {"city": "Épenède"},
    {"city": "Les Essards"},
    {"city": "Esse"},
    {"city": "Étagnac"},
    {"city": "Étriac"},
    {"city": "Exideuil-sur-Vienne"},
    {"city": "Eymouthiers"},
    {"city": "La Faye"},
    {"city": "Feuillade"},
    {"city": "Fléac"},
    {"city": "Fleurac"},
    {"city": "Fontclaireau"},
    {"city": "Fontenille"},
    {"city": "La Forêt-de-Tessé"},
    {"city": "Fouquebrune"},
    {"city": "Fouqueure"},
    {"city": "Foussignac"},
    {"city": "Garat"},
    {"city": "Gardes-le-Pontaroux"},
    {"city": "Genac-Bignac"},
    {"city": "Gensac-la-Pallue"},
    {"city": "Genté"},
    {"city": "Gimeux"},
    {"city": "Mainxe-Gondeville"},
    {"city": "Gond-Pontouvre"},
    {"city": "Les Gours"},
    {"city": "Le Grand-Madieu"},
    {"city": "Grassac"},
    {"city": "Guimps"},
    {"city": "Guizengeard"},
    {"city": "Gurat"},
    {"city": "Hiersac"},
    {"city": "Hiesse"},
    {"city": "Houlette"},
    {"city": "L'Isle-d'Espagnac"},
    {"city": "Jarnac"},
    {"city": "Jauldes"},
    {"city": "Javrezac"},
    {"city": "Juignac"},
    {"city": "Juillac-le-Coq"},
    {"city": "Juillé"},
    {"city": "Julienne"},
    {"city": "Val des Vignes"},
    {"city": "Lachaise"},
    {"city": "Ladiville"},
    {"city": "Lagarde-sur-le-Né"},
    {"city": "Laprade"},
    {"city": "Lessac"},
    {"city": "Lesterps"},
    {"city": "Lésignac-Durand"},
    {"city": "Lichères"},
    {"city": "Ligné"},
    {"city": "Lignières-Sonneville"},
    {"city": "Linars"},
    {"city": "Le Lindois"},
    {"city": "Londigny"},
    {"city": "Longré"},
    {"city": "Lonnes"},
    {"city": "Terres-de-Haute-Charente"},
    {"city": "Louzac-Saint-André"},
    {"city": "Lupsault"},
    {"city": "Lussac"},
    {"city": "Luxé"},
    {"city": "La Magdeleine"},
    {"city": "Magnac-Lavalette-Villars"},
    {"city": "Magnac-sur-Touvre"},
    {"city": "Maine-de-Boixe"},
    {"city": "Mainzac"},
    {"city": "Bellevigne"},
    {"city": "Manot"},
    {"city": "Mansle"},
    {"city": "Marcillac-Lanville"},
    {"city": "Mareuil"},
    {"city": "Marillac-le-Franc"},
    {"city": "Marsac"},
    {"city": "Marthon"},
    {"city": "Massignac"},
    {"city": "Mazerolles"},
    {"city": "Médillac"},
    {"city": "Mérignac"},
    {"city": "Merpins"},
    {"city": "Mesnac"},
    {"city": "Les Métairies"},
    {"city": "Mons"},
    {"city": "Montboyer"},
    {"city": "Montbron"},
    {"city": "Montmérac"},
    {"city": "Montembœuf"},
    {"city": "Montignac-Charente"},
    {"city": "Montignac-le-Coq"},
    {"city": "Montjean"},
    {"city": "Montmoreau"},
    {"city": "Montrollet"},
    {"city": "Mornac"},
    {"city": "Mosnac"},
    {"city": "Moulidars"},
    {"city": "Mouthiers-sur-Boëme"},
    {"city": "Mouton"},
    {"city": "Moutonneau"},
    {"city": "Mouzon"},
    {"city": "Nabinaud"},
    {"city": "Nanclars"},
    {"city": "Nanteuil-en-Vallée"},
    {"city": "Nercillac"},
    {"city": "Nersac"},
    {"city": "Nieuil"},
    {"city": "Nonac"},
    {"city": "Oradour"},
    {"city": "Oradour-Fanais"},
    {"city": "Orgedeuil"},
    {"city": "Oriolles"},
    {"city": "Orival"},
    {"city": "Paizay-Naudouin-Embourie"},
    {"city": "Palluaud"},
    {"city": "Parzac"},
    {"city": "Passirac"},
    {"city": "Pérignac"},
    {"city": "Pillac"},
    {"city": "Les Pins"},
    {"city": "Plassac-Rouffiac"},
    {"city": "Pleuville"},
    {"city": "Poullignac"},
    {"city": "Poursac"},
    {"city": "Pranzac"},
    {"city": "Pressignac"},
    {"city": "Puymoyen"},
    {"city": "Puyréaux"},
    {"city": "Raix"},
    {"city": "Ranville-Breuillaud"},
    {"city": "Reignac"},
    {"city": "Réparsac"},
    {"city": "Rioux-Martin"},
    {"city": "Rivières"},
    {"city": "La Rochefoucauld-en-Angoumois"},
    {"city": "La Rochette"},
    {"city": "Ronsenac"},
    {"city": "Rouffiac"},
    {"city": "Rougnac"},
    {"city": "Rouillac"},
    {"city": "Roullet-Saint-Estèphe"},
    {"city": "Roussines"},
    {"city": "Rouzède"},
    {"city": "Ruelle-sur-Touvre"},
    {"city": "Ruffec"},
    {"city": "Saint-Adjutory"},
    {"city": "Saint-Amant-de-Boixe"},
    {"city": "Graves-Saint-Amant"},
    {"city": "Saint-Amant-de-Nouère"},
    {"city": "Val-de-Bonnieure"},
    {"city": "Saint-Aulais-la-Chapelle"},
    {"city": "Saint-Avit"},
    {"city": "Saint-Bonnet"},
    {"city": "Saint-Brice"},
    {"city": "Saint-Christophe"},
    {"city": "Saint-Ciers-sur-Bonnieure"},
    {"city": "Saint-Claud"},
    {"city": "Saint-Coutant"},
    {"city": "Saint-Cybardeaux"},
    {"city": "Saint-Félix"},
    {"city": "Saint-Fort-sur-le-Né"},
    {"city": "Saint-Fraigne"},
    {"city": "Saint-Front"},
    {"city": "Saint-Genis-d'Hiersac"},
    {"city": "Saint-Georges"},
    {"city": "Saint-Germain-de-Montbron"},
    {"city": "Saint-Gourson"},
    {"city": "Saint-Groux"},
    {"city": "Saint-Laurent-de-Céris"},
    {"city": "Saint-Laurent-de-Cognac"},
    {"city": "Saint-Laurent-des-Combes"},
    {"city": "Saint-Martial"},
    {"city": "Saint-Martin-du-Clocher"},
    {"city": "Saint-Mary"},
    {"city": "Saint-Maurice-des-Lions"},
    {"city": "Saint-Médard"},
    {"city": "Val-d'Auge"},
    {"city": "Saint-Même-les-Carrières"},
    {"city": "Saint-Michel"},
    {"city": "Saint-Palais-du-Né"},
    {"city": "Saint-Preuil"},
    {"city": "Saint-Quentin-sur-Charente"},
    {"city": "Saint-Quentin-de-Chalais"},
    {"city": "Saint-Romain"},
    {"city": "Saint-Saturnin"},
    {"city": "Sainte-Sévère"},
    {"city": "Saint-Séverin"},
    {"city": "Saint-Simeux"},
    {"city": "Saint-Simon"},
    {"city": "Saint-Sornin"},
    {"city": "Sainte-Souline"},
    {"city": "Saint-Sulpice-de-Cognac"},
    {"city": "Saint-Sulpice-de-Ruffec"},
    {"city": "Saint-Vallier"},
    {"city": "Saint-Yrieix-sur-Charente"},
    {"city": "Salles-d'Angles"},
    {"city": "Salles-de-Barbezieux"},
    {"city": "Salles-de-Villefagnan"},
    {"city": "Salles-Lavalette"},
    {"city": "Saulgond"},
    {"city": "Sauvagnac"},
    {"city": "Sauvignac"},
    {"city": "Segonzac"},
    {"city": "Sers"},
    {"city": "Sigogne"},
    {"city": "Sireuil"},
    {"city": "Souffrignac"},
    {"city": "Souvigné"},
    {"city": "Soyaux"},
    {"city": "Suaux"},
    {"city": "La Tâche"},
    {"city": "Taizé-Aizie"},
    {"city": "Taponnat-Fleurignac"},
    {"city": "Le Tâtre"},
    {"city": "Theil-Rabier"},
    {"city": "Torsac"},
    {"city": "Tourriers"},
    {"city": "Touvérac"},
    {"city": "Touvre"},
    {"city": "Triac-Lautrait"},
    {"city": "Trois-Palis"},
    {"city": "Turgon"},
    {"city": "Tusson"},
    {"city": "Valence"},
    {"city": "Vars"},
    {"city": "Vaux-Lavalette"},
    {"city": "Vaux-Rouillac"},
    {"city": "Ventouse"},
    {"city": "Verdille"},
    {"city": "Verneuil"},
    {"city": "Verrières"},
    {"city": "Verteuil-sur-Charente"},
    {"city": "Vervant"},
    {"city": "Vibrac"},
    {"city": "Le Vieux-Cérier"},
    {"city": "Vieux-Ruffec"},
    {"city": "Vignolles"},
    {"city": "Moulins-sur-Tardoire"},
    {"city": "Villebois-Lavalette"},
    {"city": "Villefagnan"},
    {"city": "Villejoubert"},
    {"city": "Villiers-le-Roux"},
    {"city": "Villognon"},
    {"city": "Vindelle"},
    {"city": "Vitrac-Saint-Vincent"},
    {"city": "Vœuil-et-Giget"},
    {"city": "Vouharte"},
    {"city": "Voulgézac"},
    {"city": "Vouthon"},
    {"city": "Vouzan"},
    {"city": "Xambes"},
    {"city": "Yviers"},
    {"city": "Yvrac-et-Malleyrand"},
    {"city": "Agudelle"},
    {"city": "Aigrefeuille-d'Aunis"},
    {"city": "Île-d'Aix"},
    {"city": "Allas-Bocage"},
    {"city": "Allas-Champagne"},
    {"city": "Anais"},
    {"city": "Andilly"},
    {"city": "Angliers"},
    {"city": "Angoulins"},
    {"city": "Annepont"},
    {"city": "Annezay"},
    {"city": "Antezant-la-Chapelle"},
    {"city": "Arces"},
    {"city": "Archiac"},
    {"city": "Archingeay"},
    {"city": "Ardillières"},
    {"city": "Ars-en-Ré"},
    {"city": "Arthenac"},
    {"city": "Arvert"},
    {"city": "Asnières-la-Giraud"},
    {"city": "Aujac"},
    {"city": "Aulnay"},
    {"city": "Aumagne"},
    {"city": "Authon-Ébéon"},
    {"city": "Avy"},
    {"city": "Aytré"},
    {"city": "Bagnizeau"},
    {"city": "Balanzac"},
    {"city": "Ballans"},
    {"city": "Ballon"},
    {"city": "La Barde"},
    {"city": "Barzan"},
    {"city": "Bazauges"},
    {"city": "Beaugeay"},
    {"city": "Beauvais-sur-Matha"},
    {"city": "Bedenac"},
    {"city": "Belluire"},
    {"city": "Benon"},
    {"city": "Bercloux"},
    {"city": "Bernay-Saint-Martin"},
    {"city": "Berneuil"},
    {"city": "Beurlay"},
    {"city": "Bignay"},
    {"city": "Biron"},
    {"city": "Blanzac-lès-Matha"},
    {"city": "Blanzay-sur-Boutonne"},
    {"city": "Bois"},
    {"city": "Le Bois-Plage-en-Ré"},
    {"city": "Boisredon"},
    {"city": "Bords"},
    {"city": "Boresse-et-Martron"},
    {"city": "Boscamnant"},
    {"city": "Bougneau"},
    {"city": "Bouhet"},
    {"city": "Bourcefranc-le-Chapus"},
    {"city": "Bourgneuf"},
    {"city": "Boutenac-Touvent"},
    {"city": "Bran"},
    {"city": "Bresdon"},
    {"city": "Breuil-la-Réorte"},
    {"city": "Breuillet"},
    {"city": "Breuil-Magné"},
    {"city": "Brie-sous-Archiac"},
    {"city": "Brie-sous-Matha"},
    {"city": "Brie-sous-Mortagne"},
    {"city": "Brives-sur-Charente"},
    {"city": "Brizambourg"},
    {"city": "La Brousse"},
    {"city": "Burie"},
    {"city": "Bussac-sur-Charente"},
    {"city": "Bussac-Forêt"},
    {"city": "Cabariot"},
    {"city": "Celles"},
    {"city": "Cercoux"},
    {"city": "Chadenac"},
    {"city": "Chaillevette"},
    {"city": "Chambon"},
    {"city": "Chamouillac"},
    {"city": "Champagnac"},
    {"city": "Champagne"},
    {"city": "Champagnolles"},
    {"city": "Champdolent"},
    {"city": "Chaniers"},
    {"city": "Chantemerle-sur-la-Soie"},
    {"city": "La Chapelle-des-Pots"},
    {"city": "Charron"},
    {"city": "Chartuzac"},
    {"city": "Le Château-d'Oléron"},
    {"city": "Châtelaillon-Plage"},
    {"city": "Chatenet"},
    {"city": "Chaunac"},
    {"city": "Le Chay"},
    {"city": "Chenac-Saint-Seurin-d'Uzet"},
    {"city": "Chepniers"},
    {"city": "Chérac"},
    {"city": "Cherbonnières"},
    {"city": "Chermignac"},
    {"city": "Chevanceaux"},
    {"city": "Chives"},
    {"city": "Cierzac"},
    {"city": "Ciré-d'Aunis"},
    {"city": "Clam"},
    {"city": "Clavette"},
    {"city": "Clérac"},
    {"city": "Clion"},
    {"city": "La Clisse"},
    {"city": "La Clotte"},
    {"city": "Coivert"},
    {"city": "Colombiers"},
    {"city": "Consac"},
    {"city": "Contré"},
    {"city": "Corignac"},
    {"city": "Corme-Écluse"},
    {"city": "Corme-Royal"},
    {"city": "La Couarde-sur-Mer"},
    {"city": "Coulonges"},
    {"city": "Courant"},
    {"city": "Courcelles"},
    {"city": "Courcerac"},
    {"city": "Courçon"},
    {"city": "Courcoury"},
    {"city": "Courpignac"},
    {"city": "Coux"},
    {"city": "Cozes"},
    {"city": "Cramchaban"},
    {"city": "Cravans"},
    {"city": "Crazannes"},
    {"city": "Cressé"},
    {"city": "Croix-Chapeau"},
    {"city": "La Croix-Comtesse"},
    {"city": "Dampierre-sur-Boutonne"},
    {"city": "Dœuil-sur-le-Mignon"},
    {"city": "Dolus-d'Oléron"},
    {"city": "Dompierre-sur-Charente"},
    {"city": "Dompierre-sur-Mer"},
    {"city": "Le Douhet"},
    {"city": "Échebrune"},
    {"city": "Échillais"},
    {"city": "Écoyeux"},
    {"city": "Écurat"},
    {"city": "Les Éduts"},
    {"city": "Les Églises-d'Argenteuil"},
    {"city": "L'Éguille"},
    {"city": "Épargnes"},
    {"city": "Esnandes"},
    {"city": "Les Essards"},
    {"city": "Étaules"},
    {"city": "Expiremont"},
    {"city": "Fenioux"},
    {"city": "Ferrières"},
    {"city": "Fléac-sur-Seugne"},
    {"city": "Floirac"},
    {"city": "La Flotte"},
    {"city": "Fontaine-Chalendray"},
    {"city": "Fontaines-d'Ozillac"},
    {"city": "Fontcouverte"},
    {"city": "Fontenet"},
    {"city": "Forges"},
    {"city": "Le Fouilloux"},
    {"city": "Fouras"},
    {"city": "Geay"},
    {"city": "Gémozac"},
    {"city": "La Genétouze"},
    {"city": "Genouillé"},
    {"city": "Germignac"},
    {"city": "Gibourne"},
    {"city": "Le Gicq"},
    {"city": "Givrezac"},
    {"city": "Les Gonds"},
    {"city": "Gourvillette"},
    {"city": "Grandjean"},
    {"city": "La Grève-sur-Mignon"},
    {"city": "Grézac"},
    {"city": "La Gripperie-Saint-Symphorien"},
    {"city": "Le Gua"},
    {"city": "Le Gué-d'Alleré"},
    {"city": "Guitinières"},
    {"city": "Haimps"},
    {"city": "L'Houmeau"},
    {"city": "La Jard"},
    {"city": "Jarnac-Champagne"},
    {"city": "La Jarne"},
    {"city": "La Jarrie"},
    {"city": "La Jarrie-Audouin"},
    {"city": "Jazennes"},
    {"city": "Jonzac"},
    {"city": "Juicq"},
    {"city": "Jussas"},
    {"city": "Lagord"},
    {"city": "La Laigne"},
    {"city": "Landes"},
    {"city": "Landrais"},
    {"city": "Léoville"},
    {"city": "Loire-les-Marais"},
    {"city": "Loiré-sur-Nie"},
    {"city": "Loix"},
    {"city": "Longèves"},
    {"city": "Lonzac"},
    {"city": "Lorignac"},
    {"city": "Loulay"},
    {"city": "Louzignac"},
    {"city": "Lozay"},
    {"city": "Luchat"},
    {"city": "Lussac"},
    {"city": "Lussant"},
    {"city": "Macqueville"},
    {"city": "Marans"},
    {"city": "Marennes-Hiers-Brouage"},
    {"city": "Marignac"},
    {"city": "Marsais"},
    {"city": "Marsilly"},
    {"city": "Massac"},
    {"city": "Matha"},
    {"city": "Les Mathes"},
    {"city": "Mazeray"},
    {"city": "Mazerolles"},
    {"city": "Médis"},
    {"city": "Mérignac"},
    {"city": "Meschers-sur-Gironde"},
    {"city": "Messac"},
    {"city": "Meursac"},
    {"city": "Meux"},
    {"city": "Migré"},
    {"city": "Migron"},
    {"city": "Mirambeau"},
    {"city": "Moëze"},
    {"city": "Mons"},
    {"city": "Montendre"},
    {"city": "Montguyon"},
    {"city": "Montils"},
    {"city": "Montlieu-la-Garde"},
    {"city": "Montpellier-de-Médillan"},
    {"city": "Montroy"},
    {"city": "Moragne"},
    {"city": "Mornac-sur-Seudre"},
    {"city": "Mortagne-sur-Gironde"},
    {"city": "Mortiers"},
    {"city": "Mosnac"},
    {"city": "Le Mung"},
    {"city": "Muron"},
    {"city": "Nachamps"},
    {"city": "Nancras"},
    {"city": "Nantillé"},
    {"city": "Néré"},
    {"city": "Neuillac"},
    {"city": "Neulles"},
    {"city": "Neuvicq"},
    {"city": "Neuvicq-le-Château"},
    {"city": "Nieul-lès-Saintes"},
    {"city": "Nieul-le-Virouil"},
    {"city": "Nieul-sur-Mer"},
    {"city": "Nieulle-sur-Seudre"},
    {"city": "Les Nouillers"},
    {"city": "Nuaillé-d'Aunis"},
    {"city": "Nuaillé-sur-Boutonne"},
    {"city": "Orignolles"},
    {"city": "Ozillac"},
    {"city": "Paillé"},
    {"city": "Pérignac"},
    {"city": "Périgny"},
    {"city": "Pessines"},
    {"city": "Le Pin"},
    {"city": "Essouvert"},
    {"city": "Pisany"},
    {"city": "Plassac"},
    {"city": "Plassay"},
    {"city": "Polignac"},
    {"city": "Pommiers-Moulons"},
    {"city": "Pons"},
    {"city": "Pont-l'Abbé-d'Arnoult"},
    {"city": "Port-d'Envaux"},
    {"city": "Les Portes-en-Ré"},
    {"city": "Pouillac"},
    {"city": "Poursay-Garnaud"},
    {"city": "Préguillac"},
    {"city": "Prignac"},
    {"city": "Puilboreau"},
    {"city": "Puy-du-Lac"},
    {"city": "Puyravault"},
    {"city": "Puyrolland"},
    {"city": "Réaux sur Trèfle"},
    {"city": "Rétaud"},
    {"city": "Rivedoux-Plage"},
    {"city": "Rioux"},
    {"city": "Rochefort"},
    {"city": "La Rochelle"},
    {"city": "Romazières"},
    {"city": "Romegoux"},
    {"city": "La Ronde"},
    {"city": "Rouffiac"},
    {"city": "Rouffignac"},
    {"city": "Royan"},
    {"city": "Sablonceaux"},
    {"city": "Saint-Agnant"},
    {"city": "Saint-Aigulin"},
    {"city": "Saint-André-de-Lidon"},
    {"city": "Saint-Augustin"},
    {"city": "Saint-Bonnet-sur-Gironde"},
    {"city": "Saint-Bris-des-Bois"},
    {"city": "Saint-Césaire"},
    {"city": "Saint-Christophe"},
    {"city": "Saint-Ciers-Champagne"},
    {"city": "Saint-Ciers-du-Taillon"},
    {"city": "Saint-Clément-des-Baleines"},
    {"city": "Sainte-Colombe"},
    {"city": "Saint-Coutant-le-Grand"},
    {"city": "Saint-Crépin"},
    {"city": "Saint-Cyr-du-Doret"},
    {"city": "Saint-Denis-d'Oléron"},
    {"city": "Saint-Dizant-du-Bois"},
    {"city": "Saint-Dizant-du-Gua"},
    {"city": "Saint-Eugène"},
    {"city": "Saint-Félix"},
    {"city": "Saint-Fort-sur-Gironde"},
    {"city": "Saint-Froult"},
    {"city": "Sainte-Gemme"},
    {"city": "Saint-Genis-de-Saintonge"},
    {"city": "Saint-Georges-Antignac"},
    {"city": "Saint-Georges-de-Didonne"},
    {"city": "Saint-Georges-de-Longuepierre"},
    {"city": "Saint-Georges-des-Agoûts"},
    {"city": "Saint-Georges-des-Coteaux"},
    {"city": "Saint-Georges-d'Oléron"},
    {"city": "Saint-Georges-du-Bois"},
    {"city": "Saint-Germain-de-Lusignan"},
    {"city": "Saint-Pierre-La-Noue"},
    {"city": "Saint-Germain-de-Vibrac"},
    {"city": "Saint-Germain-du-Seudre"},
    {"city": "Saint-Grégoire-d'Ardennes"},
    {"city": "Saint-Hilaire-de-Villefranche"},
    {"city": "Saint-Hilaire-du-Bois"},
    {"city": "Saint-Hippolyte"},
    {"city": "Saint-Jean-d'Angély"},
    {"city": "Saint-Jean-d'Angle"},
    {"city": "Saint-Jean-de-Liversay"},
    {"city": "Saint-Julien-de-l'Escap"},
    {"city": "Saint-Just-Luzac"},
    {"city": "Saint-Laurent-de-la-Prée"},
    {"city": "Saint-Léger"},
    {"city": "Sainte-Lheurine"},
    {"city": "Saint-Loup"},
    {"city": "Saint-Maigrin"},
    {"city": "Saint-Mandé-sur-Brédoire"},
    {"city": "Saint-Mard"},
    {"city": "Sainte-Marie-de-Ré"},
    {"city": "Saint-Martial"},
    {"city": "Saint-Martial-de-Mirambeau"},
    {"city": "Saint-Martial-de-Vitaterne"},
    {"city": "Saint-Martial-sur-Né"},
    {"city": "Saint-Martin-d'Ary"},
    {"city": "Saint-Martin-de-Coux"},
    {"city": "Saint-Martin-de-Juillers"},
    {"city": "Saint-Martin-de-Ré"},
    {"city": "Saint-Médard"},
    {"city": "Saint-Médard-d'Aunis"},
    {"city": "Sainte-Même"},
    {"city": "Saint-Nazaire-sur-Charente"},
    {"city": "Saint-Ouen-d'Aunis"},
    {"city": "Saint-Ouen-la-Thène"},
    {"city": "Saint-Palais-de-Négrignac"},
    {"city": "Saint-Palais-de-Phiolin"},
    {"city": "Saint-Palais-sur-Mer"},
    {"city": "Saint-Pardoult"},
    {"city": "Saint-Pierre-d'Amilly"},
    {"city": "Saint-Pierre-de-Juillers"},
    {"city": "Saint-Pierre-de-l'Isle"},
    {"city": "Saint-Pierre-d'Oléron"},
    {"city": "Saint-Pierre-du-Palais"},
    {"city": "Saint-Porchaire"},
    {"city": "Saint-Quantin-de-Rançanne"},
    {"city": "Sainte-Radegonde"},
    {"city": "Sainte-Ramée"},
    {"city": "Saint-Rogatien"},
    {"city": "Saint-Romain-de-Benet"},
    {"city": "Saint-Saturnin-du-Bois"},
    {"city": "Saint-Sauvant"},
    {"city": "Saint-Sauveur-d'Aunis"},
    {"city": "Saint-Savinien"},
    {"city": "Saint-Seurin-de-Palenne"},
    {"city": "Saint-Sever-de-Saintonge"},
    {"city": "Saint-Séverin-sur-Boutonne"},
    {"city": "Saint-Sigismond-de-Clermont"},
    {"city": "Saint-Simon-de-Bordes"},
    {"city": "Saint-Simon-de-Pellouaille"},
    {"city": "Saint-Sorlin-de-Conac"},
    {"city": "Saint-Sornin"},
    {"city": "Sainte-Soulle"},
    {"city": "Saint-Sulpice-d'Arnoult"},
    {"city": "Saint-Sulpice-de-Royan"},
    {"city": "Saint-Thomas-de-Conac"},
    {"city": "Saint-Trojan-les-Bains"},
    {"city": "Saint-Vaize"},
    {"city": "Saint-Vivien"},
    {"city": "Saint-Xandre"},
    {"city": "Saintes"},
    {"city": "Saleignes"},
    {"city": "Salignac-de-Mirambeau"},
    {"city": "Salignac-sur-Charente"},
    {"city": "Salles-sur-Mer"},
    {"city": "Saujon"},
    {"city": "Seigné"},
    {"city": "Semillac"},
    {"city": "Semoussac"},
    {"city": "Semussac"},
    {"city": "Le Seure"},
    {"city": "Siecq"},
    {"city": "Sonnac"},
    {"city": "Soubise"},
    {"city": "Soubran"},
    {"city": "Soulignonne"},
    {"city": "Souméras"},
    {"city": "Sousmoulins"},
    {"city": "Surgères"},
    {"city": "Taillant"},
    {"city": "Taillebourg"},
    {"city": "Talmont-sur-Gironde"},
    {"city": "Tanzac"},
    {"city": "Taugon"},
    {"city": "Ternant"},
    {"city": "Tesson"},
    {"city": "Thaims"},
    {"city": "Thairé"},
    {"city": "Thénac"},
    {"city": "Thézac"},
    {"city": "Thors"},
    {"city": "Le Thou"},
    {"city": "Tonnay-Boutonne"},
    {"city": "Tonnay-Charente"},
    {"city": "Torxé"},
    {"city": "Les Touches-de-Périgny"},
    {"city": "La Tremblade"},
    {"city": "Trizay"},
    {"city": "Tugéras-Saint-Maurice"},
    {"city": "La Vallée"},
    {"city": "La Devise"},
    {"city": "Vanzac"},
    {"city": "Varaize"},
    {"city": "Varzay"},
    {"city": "Vaux-sur-Mer"},
    {"city": "Vénérand"},
    {"city": "Vergeroux"},
    {"city": "Vergné"},
    {"city": "La Vergne"},
    {"city": "Vérines"},
    {"city": "Vervant"},
    {"city": "Vibrac"},
    {"city": "Villars-en-Pons"},
    {"city": "Villars-les-Bois"},
    {"city": "La Villedieu"},
    {"city": "Villedoux"},
    {"city": "Villemorin"},
    {"city": "Villeneuve-la-Comtesse"},
    {"city": "Villexavier"},
    {"city": "Villiers-Couture"},
    {"city": "Vinax"},
    {"city": "Virollet"},
    {"city": "Virson"},
    {"city": "Voissay"},
    {"city": "Vouhé"},
    {"city": "Yves"},
    {"city": "Port-des-Barques"},
    {"city": "Le Grand-Village-Plage"},
    {"city": "La Brée-les-Bains"},
    {"city": "Achères"},
    {"city": "Ainay-le-Vieil"},
    {"city": "Les Aix-d'Angillon"},
    {"city": "Allogny"},
    {"city": "Allouis"},
    {"city": "Annoix"},
    {"city": "Apremont-sur-Allier"},
    {"city": "Arçay"},
    {"city": "Arcomps"},
    {"city": "Ardenais"},
    {"city": "Argent-sur-Sauldre"},
    {"city": "Argenvières"},
    {"city": "Arpheuilles"},
    {"city": "Assigny"},
    {"city": "Aubigny-sur-Nère"},
    {"city": "Aubinges"},
    {"city": "Augy-sur-Aubois"},
    {"city": "Avord"},
    {"city": "Azy"},
    {"city": "Bannay"},
    {"city": "Bannegon"},
    {"city": "Barlieu"},
    {"city": "Baugy"},
    {"city": "Beddes"},
    {"city": "Beffes"},
    {"city": "Belleville-sur-Loire"},
    {"city": "Bengy-sur-Craon"},
    {"city": "Berry-Bouy"},
    {"city": "Bessais-le-Fromental"},
    {"city": "Blancafort"},
    {"city": "Blet"},
    {"city": "Boulleret"},
    {"city": "Bourges"},
    {"city": "Bouzais"},
    {"city": "Brécy"},
    {"city": "Brinay"},
    {"city": "Brinon-sur-Sauldre"},
    {"city": "Bruère-Allichamps"},
    {"city": "Bué"},
    {"city": "Bussy"},
    {"city": "La Celette"},
    {"city": "La Celle"},
    {"city": "La Celle-Condé"},
    {"city": "Cerbois"},
    {"city": "Chalivoy-Milon"},
    {"city": "Chambon"},
    {"city": "La Chapelle-d'Angillon"},
    {"city": "La Chapelle-Hugon"},
    {"city": "La Chapelle-Montlinard"},
    {"city": "La Chapelle-Saint-Ursin"},
    {"city": "La Chapelotte"},
    {"city": "Charenton-du-Cher"},
    {"city": "Charentonnay"},
    {"city": "Charly"},
    {"city": "Chârost"},
    {"city": "Chassy"},
    {"city": "Châteaumeillant"},
    {"city": "Châteauneuf-sur-Cher"},
    {"city": "Le Châtelet"},
    {"city": "Chaumont"},
    {"city": "Chaumoux-Marcilly"},
    {"city": "Le Chautay"},
    {"city": "Chavannes"},
    {"city": "Chéry"},
    {"city": "Chezal-Benoît"},
    {"city": "Civray"},
    {"city": "Clémont"},
    {"city": "Cogny"},
    {"city": "Colombiers"},
    {"city": "Concressault"},
    {"city": "Contres"},
    {"city": "Cornusse"},
    {"city": "Corquoy"},
    {"city": "Couargues"},
    {"city": "Cours-les-Barres"},
    {"city": "Coust"},
    {"city": "Couy"},
    {"city": "Crézançay-sur-Cher"},
    {"city": "Crézancy-en-Sancerre"},
    {"city": "Croisy"},
    {"city": "Crosses"},
    {"city": "Cuffy"},
    {"city": "Culan"},
    {"city": "Dampierre-en-Crot"},
    {"city": "Dampierre-en-Graçay"},
    {"city": "Drevant"},
    {"city": "Dun-sur-Auron"},
    {"city": "Ennordres"},
    {"city": "Épineuil-le-Fleuriel"},
    {"city": "Étréchy"},
    {"city": "Farges-Allichamps"},
    {"city": "Farges-en-Septaine"},
    {"city": "Faverdines"},
    {"city": "Feux"},
    {"city": "Flavigny"},
    {"city": "Foëcy"},
    {"city": "Fussy"},
    {"city": "Gardefort"},
    {"city": "Garigny"},
    {"city": "Genouilly"},
    {"city": "Germigny-l'Exempt"},
    {"city": "Givardon"},
    {"city": "Graçay"},
    {"city": "Groises"},
    {"city": "Gron"},
    {"city": "Grossouvre"},
    {"city": "La Groutte"},
    {"city": "La Guerche-sur-l'Aubois"},
    {"city": "Henrichemont"},
    {"city": "Herry"},
    {"city": "Humbligny"},
    {"city": "Ids-Saint-Roch"},
    {"city": "Ignol"},
    {"city": "Ineuil"},
    {"city": "Ivoy-le-Pré"},
    {"city": "Jalognes"},
    {"city": "Jars"},
    {"city": "Jouet-sur-l'Aubois"},
    {"city": "Jussy-Champagne"},
    {"city": "Jussy-le-Chaudrier"},
    {"city": "Lantan"},
    {"city": "Lapan"},
    {"city": "Lazenay"},
    {"city": "Léré"},
    {"city": "Levet"},
    {"city": "Lignières"},
    {"city": "Limeux"},
    {"city": "Lissay-Lochy"},
    {"city": "Loye-sur-Arnon"},
    {"city": "Lugny-Bourbonnais"},
    {"city": "Lugny-Champagne"},
    {"city": "Lunery"},
    {"city": "Lury-sur-Arnon"},
    {"city": "Maisonnais"},
    {"city": "Marçais"},
    {"city": "Mareuil-sur-Arnon"},
    {"city": "Marmagne"},
    {"city": "Marseilles-lès-Aubigny"},
    {"city": "Massay"},
    {"city": "Mehun-sur-Yèvre"},
    {"city": "Meillant"},
    {"city": "Menetou-Couture"},
    {"city": "Menetou-Râtel"},
    {"city": "Menetou-Salon"},
    {"city": "Ménétréol-sous-Sancerre"},
    {"city": "Ménétréol-sur-Sauldre"},
    {"city": "Méreau"},
    {"city": "Méry-ès-Bois"},
    {"city": "Méry-sur-Cher"},
    {"city": "Montigny"},
    {"city": "Montlouis"},
    {"city": "Morlac"},
    {"city": "Mornay-Berry"},
    {"city": "Mornay-sur-Allier"},
    {"city": "Morogues"},
    {"city": "Morthomiers"},
    {"city": "Moulins-sur-Yèvre"},
    {"city": "Nançay"},
    {"city": "Nérondes"},
    {"city": "Neuilly-en-Dun"},
    {"city": "Neuilly-en-Sancerre"},
    {"city": "Neuvy-Deux-Clochers"},
    {"city": "Neuvy-le-Barrois"},
    {"city": "Neuvy-sur-Barangeon"},
    {"city": "Nohant-en-Goût"},
    {"city": "Nohant-en-Graçay"},
    {"city": "Le Noyer"},
    {"city": "Nozières"},
    {"city": "Oizon"},
    {"city": "Orcenais"},
    {"city": "Orval"},
    {"city": "Osmery"},
    {"city": "Osmoy"},
    {"city": "Ourouer-les-Bourdelins"},
    {"city": "Parassy"},
    {"city": "Parnay"},
    {"city": "La Perche"},
    {"city": "Pigny"},
    {"city": "Plaimpied-Givaudins"},
    {"city": "Plou"},
    {"city": "Poisieux"},
    {"city": "Le Pondy"},
    {"city": "Précy"},
    {"city": "Presly"},
    {"city": "Preuilly"},
    {"city": "Préveranges"},
    {"city": "Primelles"},
    {"city": "Quantilly"},
    {"city": "Quincy"},
    {"city": "Raymond"},
    {"city": "Reigny"},
    {"city": "Rezay"},
    {"city": "Rians"},
    {"city": "Sagonne"},
    {"city": "Saint-Aignan-des-Noyers"},
    {"city": "Saint-Amand-Montrond"},
    {"city": "Saint-Ambroix"},
    {"city": "Saint-Baudel"},
    {"city": "Saint-Bouize"},
    {"city": "Saint-Caprais"},
    {"city": "Saint-Céols"},
    {"city": "Saint-Christophe-le-Chaudry"},
    {"city": "Saint-Denis-de-Palin"},
    {"city": "Saint-Doulchard"},
    {"city": "Saint-Éloy-de-Gy"},
    {"city": "Saint-Florent-sur-Cher"},
    {"city": "Sainte-Gemme-en-Sancerrois"},
    {"city": "Saint-Georges-de-Poisieux"},
    {"city": "Saint-Georges-sur-la-Prée"},
    {"city": "Saint-Georges-sur-Moulon"},
    {"city": "Saint-Germain-des-Bois"},
    {"city": "Saint-Germain-du-Puy"},
    {"city": "Saint-Hilaire-de-Court"},
    {"city": "Saint-Hilaire-de-Gondilly"},
    {"city": "Saint-Hilaire-en-Lignières"},
    {"city": "Saint-Jeanvrin"},
    {"city": "Saint-Just"},
    {"city": "Saint-Laurent"},
    {"city": "Saint-Léger-le-Petit"},
    {"city": "Saint-Loup-des-Chaumes"},
    {"city": "Saint-Martin-d'Auxigny"},
    {"city": "Saint-Martin-des-Champs"},
    {"city": "Saint-Maur"},
    {"city": "Saint-Michel-de-Volangis"},
    {"city": "Sainte-Montaine"},
    {"city": "Saint-Outrille"},
    {"city": "Saint-Palais"},
    {"city": "Saint-Pierre-les-Bois"},
    {"city": "Saint-Pierre-les-Étieux"},
    {"city": "Saint-Priest-la-Marche"},
    {"city": "Saint-Satur"},
    {"city": "Saint-Saturnin"},
    {"city": "Sainte-Solange"},
    {"city": "Saint-Symphorien"},
    {"city": "Sainte-Thorette"},
    {"city": "Saint-Vitte"},
    {"city": "Sancergues"},
    {"city": "Sancerre"},
    {"city": "Sancoins"},
    {"city": "Santranges"},
    {"city": "Saugy"},
    {"city": "Saulzais-le-Potier"},
    {"city": "Savigny-en-Sancerre"},
    {"city": "Savigny-en-Septaine"},
    {"city": "Senneçay"},
    {"city": "Sens-Beaujeu"},
    {"city": "Serruelles"},
    {"city": "Sévry"},
    {"city": "Sidiailles"},
    {"city": "Soulangis"},
    {"city": "Soye-en-Septaine"},
    {"city": "Le Subdray"},
    {"city": "Subligny"},
    {"city": "Sury-près-Léré"},
    {"city": "Sury-en-Vaux"},
    {"city": "Sury-ès-Bois"},
    {"city": "Tendron"},
    {"city": "Thaumiers"},
    {"city": "Thauvenay"},
    {"city": "Thénioux"},
    {"city": "Thou"},
    {"city": "Torteron"},
    {"city": "Touchay"},
    {"city": "Trouy"},
    {"city": "Uzay-le-Venon"},
    {"city": "Vailly-sur-Sauldre"},
    {"city": "Vallenay"},
    {"city": "Vasselay"},
    {"city": "Veaugues"},
    {"city": "Venesmes"},
    {"city": "Verdigny"},
    {"city": "Vereaux"},
    {"city": "Vernais"},
    {"city": "Verneuil"},
    {"city": "Vesdun"},
    {"city": "Vierzon"},
    {"city": "Vignoux-sous-les-Aix"},
    {"city": "Vignoux-sur-Barangeon"},
    {"city": "Villabon"},
    {"city": "Villecelin"},
    {"city": "Villegenon"},
    {"city": "Villeneuve-sur-Cher"},
    {"city": "Villequiers"},
    {"city": "Vinon"},
    {"city": "Vorly"},
    {"city": "Vornay"},
    {"city": "Vouzeron"},
    {"city": "Affieux"},
    {"city": "Aix"},
    {"city": "Albignac"},
    {"city": "Albussac"},
    {"city": "Allassac"},
    {"city": "Alleyrat"},
    {"city": "Altillac"},
    {"city": "Ambrugeat"},
    {"city": "Les Angles-sur-Corrèze"},
    {"city": "Argentat-sur-Dordogne"},
    {"city": "Arnac-Pompadour"},
    {"city": "Astaillac"},
    {"city": "Aubazines"},
    {"city": "Auriac"},
    {"city": "Ayen"},
    {"city": "Bar"},
    {"city": "Bassignac-le-Bas"},
    {"city": "Bassignac-le-Haut"},
    {"city": "Beaulieu-sur-Dordogne"},
    {"city": "Beaumont"},
    {"city": "Bellechassagne"},
    {"city": "Benayes"},
    {"city": "Beynat"},
    {"city": "Beyssac"},
    {"city": "Beyssenac"},
    {"city": "Bilhac"},
    {"city": "Bonnefond"},
    {"city": "Bort-les-Orgues"},
    {"city": "Branceilles"},
    {"city": "Brignac-la-Plaine"},
    {"city": "Brive-la-Gaillarde"},
    {"city": "Bugeat"},
    {"city": "Camps-Saint-Mathurin-Léobazel"},
    {"city": "Chabrignac"},
    {"city": "Chamberet"},
    {"city": "Chamboulive"},
    {"city": "Chameyrat"},
    {"city": "Champagnac-la-Noaille"},
    {"city": "Champagnac-la-Prune"},
    {"city": "Chanac-les-Mines"},
    {"city": "Chanteix"},
    {"city": "La Chapelle-aux-Brocs"},
    {"city": "La Chapelle-aux-Saints"},
    {"city": "La Chapelle-Saint-Géraud"},
    {"city": "Chapelle-Spinasse"},
    {"city": "Chartrier-Ferrière"},
    {"city": "Le Chastang"},
    {"city": "Chasteaux"},
    {"city": "Chauffour-sur-Vell"},
    {"city": "Chaumeil"},
    {"city": "Chavanac"},
    {"city": "Chaveroche"},
    {"city": "Chenailler-Mascheix"},
    {"city": "Chirac-Bellevue"},
    {"city": "Clergoux"},
    {"city": "Collonges-la-Rouge"},
    {"city": "Combressol"},
    {"city": "Concèze"},
    {"city": "Condat-sur-Ganaveix"},
    {"city": "Cornil"},
    {"city": "Corrèze"},
    {"city": "Cosnac"},
    {"city": "Couffy-sur-Sarsonne"},
    {"city": "Courteix"},
    {"city": "Cublac"},
    {"city": "Curemonte"},
    {"city": "Dampniat"},
    {"city": "Darazac"},
    {"city": "Darnets"},
    {"city": "Davignac"},
    {"city": "Donzenac"},
    {"city": "Égletons"},
    {"city": "L'Église-aux-Bois"},
    {"city": "Espagnac"},
    {"city": "Espartignac"},
    {"city": "Estivals"},
    {"city": "Estivaux"},
    {"city": "Eyburie"},
    {"city": "Eygurande"},
    {"city": "Eyrein"},
    {"city": "Favars"},
    {"city": "Feyt"},
    {"city": "Forgès"},
    {"city": "Gimel-les-Cascades"},
    {"city": "Goulles"},
    {"city": "Gourdon-Murat"},
    {"city": "Grandsaigne"},
    {"city": "Gros-Chastang"},
    {"city": "Gumond"},
    {"city": "Hautefage"},
    {"city": "Le Jardin"},
    {"city": "Jugeals-Nazareth"},
    {"city": "Juillac"},
    {"city": "Lacelle"},
    {"city": "Ladignac-sur-Rondelles"},
    {"city": "Lafage-sur-Sombre"},
    {"city": "Lagarde-Marc-la-Tour"},
    {"city": "Lagleygeolle"},
    {"city": "Lagraulière"},
    {"city": "Laguenne-sur-Avalouze"},
    {"city": "Lamazière-Basse"},
    {"city": "Lamazière-Haute"},
    {"city": "Lamongerie"},
    {"city": "Lanteuil"},
    {"city": "Lapleau"},
    {"city": "Larche"},
    {"city": "Laroche-près-Feyt"},
    {"city": "Lascaux"},
    {"city": "Latronche"},
    {"city": "Laval-sur-Luzège"},
    {"city": "Lestards"},
    {"city": "Liginiac"},
    {"city": "Lignareix"},
    {"city": "Ligneyrac"},
    {"city": "Liourdres"},
    {"city": "Lissac-sur-Couze"},
    {"city": "Le Lonzac"},
    {"city": "Lostanges"},
    {"city": "Louignac"},
    {"city": "Lubersac"},
    {"city": "Madranges"},
    {"city": "Malemort"},
    {"city": "Mansac"},
    {"city": "Marcillac-la-Croisille"},
    {"city": "Marcillac-la-Croze"},
    {"city": "Margerides"},
    {"city": "Masseret"},
    {"city": "Maussac"},
    {"city": "Meilhards"},
    {"city": "Ménoire"},
    {"city": "Mercœur"},
    {"city": "Merlines"},
    {"city": "Mestes"},
    {"city": "Meymac"},
    {"city": "Meyrignac-l'Église"},
    {"city": "Meyssac"},
    {"city": "Millevaches"},
    {"city": "Monceaux-sur-Dordogne"},
    {"city": "Monestier-Merlines"},
    {"city": "Monestier-Port-Dieu"},
    {"city": "Montaignac-Saint-Hippolyte"},
    {"city": "Montgibaud"},
    {"city": "Moustier-Ventadour"},
    {"city": "Naves"},
    {"city": "Nespouls"},
    {"city": "Neuvic"},
    {"city": "Neuville"},
    {"city": "Noailhac"},
    {"city": "Noailles"},
    {"city": "Nonards"},
    {"city": "Objat"},
    {"city": "Orgnac-sur-Vézère"},
    {"city": "Orliac-de-Bar"},
    {"city": "Palazinges"},
    {"city": "Palisse"},
    {"city": "Pandrignes"},
    {"city": "Péret-Bel-Air"},
    {"city": "Pérols-sur-Vézère"},
    {"city": "Perpezac-le-Blanc"},
    {"city": "Perpezac-le-Noir"},
    {"city": "Le Pescher"},
    {"city": "Peyrelevade"},
    {"city": "Peyrissac"},
    {"city": "Pierrefitte"},
    {"city": "Confolent-Port-Dieu"},
    {"city": "Pradines"},
    {"city": "Puy-d'Arnac"},
    {"city": "Queyssac-les-Vignes"},
    {"city": "Reygade"},
    {"city": "Rilhac-Treignac"},
    {"city": "Rilhac-Xaintrie"},
    {"city": "La Roche-Canillac"},
    {"city": "Roche-le-Peyroux"},
    {"city": "Rosiers-d'Égletons"},
    {"city": "Rosiers-de-Juillac"},
    {"city": "Sadroc"},
    {"city": "Saillac"},
    {"city": "Saint-Angel"},
    {"city": "Saint-Augustin"},
    {"city": "Saint-Aulaire"},
    {"city": "Saint-Bazile-de-Meyssac"},
    {"city": "Saint-Bonnet-Elvert"},
    {"city": "Saint-Bonnet-la-Rivière"},
    {"city": "Saint-Bonnet-l'Enfantier"},
    {"city": "Saint-Bonnet-les-Tours-de-Merle"},
    {"city": "Saint-Bonnet-près-Bort"},
    {"city": "Saint-Cernin-de-Larche"},
    {"city": "Saint-Chamant"},
    {"city": "Saint-Cirgues-la-Loutre"},
    {"city": "Saint-Clément"},
    {"city": "Saint-Cyprien"},
    {"city": "Saint-Cyr-la-Roche"},
    {"city": "Saint-Éloy-les-Tuileries"},
    {"city": "Saint-Étienne-aux-Clos"},
    {"city": "Saint-Étienne-la-Geneste"},
    {"city": "Saint-Exupéry-les-Roches"},
    {"city": "Sainte-Féréole"},
    {"city": "Sainte-Fortunade"},
    {"city": "Saint-Fréjoux"},
    {"city": "Saint-Geniez-ô-Merle"},
    {"city": "Saint-Germain-Lavolps"},
    {"city": "Saint-Germain-les-Vergnes"},
    {"city": "Saint-Hilaire-Foissac"},
    {"city": "Saint-Hilaire-les-Courbes"},
    {"city": "Saint-Hilaire-Luc"},
    {"city": "Saint-Hilaire-Peyroux"},
    {"city": "Saint-Hilaire-Taurieux"},
    {"city": "Saint-Jal"},
    {"city": "Saint-Julien-aux-Bois"},
    {"city": "Saint-Julien-le-Pèlerin"},
    {"city": "Saint-Julien-le-Vendômois"},
    {"city": "Saint-Julien-Maumont"},
    {"city": "Sainte-Marie-Lapanouze"},
    {"city": "Saint-Martial-de-Gimel"},
    {"city": "Saint-Martial-Entraygues"},
    {"city": "Saint-Martin-la-Méanne"},
    {"city": "Saint-Martin-Sepert"},
    {"city": "Saint-Merd-de-Lapleau"},
    {"city": "Saint-Merd-les-Oussines"},
    {"city": "Saint-Mexant"},
    {"city": "Saint-Pantaléon-de-Lapleau"},
    {"city": "Saint-Pantaléon-de-Larche"},
    {"city": "Saint-Pardoux-Corbier"},
    {"city": "Saint-Pardoux-la-Croisille"},
    {"city": "Saint-Pardoux-le-Neuf"},
    {"city": "Saint-Pardoux-le-Vieux"},
    {"city": "Saint-Pardoux-l'Ortigier"},
    {"city": "Saint-Paul"},
    {"city": "Saint-Priest-de-Gimel"},
    {"city": "Saint-Privat"},
    {"city": "Saint-Rémy"},
    {"city": "Saint-Robert"},
    {"city": "Saint-Salvadour"},
    {"city": "Saint-Setiers"},
    {"city": "Saint-Solve"},
    {"city": "Saint-Sornin-Lavolps"},
    {"city": "Saint-Sulpice-les-Bois"},
    {"city": "Saint-Sylvain"},
    {"city": "Saint-Viance"},
    {"city": "Saint-Victour"},
    {"city": "Saint-Ybard"},
    {"city": "Saint-Yrieix-le-Déjalat"},
    {"city": "Salon-la-Tour"},
    {"city": "Sarran"},
    {"city": "Sarroux - Saint Julien"},
    {"city": "Segonzac"},
    {"city": "Ségur-le-Château"},
    {"city": "Seilhac"},
    {"city": "Sérandon"},
    {"city": "Sérilhac"},
    {"city": "Servières-le-Château"},
    {"city": "Sexcles"},
    {"city": "Sioniac"},
    {"city": "Sornac"},
    {"city": "Soudaine-Lavinadière"},
    {"city": "Soudeilles"},
    {"city": "Soursac"},
    {"city": "Tarnac"},
    {"city": "Thalamy"},
    {"city": "Toy-Viam"},
    {"city": "Treignac"},
    {"city": "Troche"},
    {"city": "Tudeils"},
    {"city": "Tulle"},
    {"city": "Turenne"},
    {"city": "Ussac"},
    {"city": "Ussel"},
    {"city": "Uzerche"},
    {"city": "Valiergues"},
    {"city": "Varetz"},
    {"city": "Vars-sur-Roseix"},
    {"city": "Végennes"},
    {"city": "Veix"},
    {"city": "Veyrières"},
    {"city": "Viam"},
    {"city": "Vigeois"},
    {"city": "Vignols"},
    {"city": "Vitrac-sur-Montane"},
    {"city": "Voutezac"},
    {"city": "Yssandon"},
    {"city": "Agencourt"},
    {"city": "Agey"},
    {"city": "Ahuy"},
    {"city": "Aignay-le-Duc"},
    {"city": "Aiserey"},
    {"city": "Aisey-sur-Seine"},
    {"city": "Aisy-sous-Thil"},
    {"city": "Alise-Sainte-Reine"},
    {"city": "Allerey"},
    {"city": "Aloxe-Corton"},
    {"city": "Ampilly-les-Bordes"},
    {"city": "Ampilly-le-Sec"},
    {"city": "Ancey"},
    {"city": "Antheuil"},
    {"city": "Antigny-la-Ville"},
    {"city": "Arceau"},
    {"city": "Arcenant"},
    {"city": "Arcey"},
    {"city": "Arconcey"},
    {"city": "Arc-sur-Tille"},
    {"city": "Argilly"},
    {"city": "Arnay-le-Duc"},
    {"city": "Arnay-sous-Vitteaux"},
    {"city": "Arrans"},
    {"city": "Asnières-en-Montagne"},
    {"city": "Asnières-lès-Dijon"},
    {"city": "Athée"},
    {"city": "Athie"},
    {"city": "Aubaine"},
    {"city": "Aubigny-en-Plaine"},
    {"city": "Aubigny-la-Ronce"},
    {"city": "Aubigny-lès-Sombernon"},
    {"city": "Autricourt"},
    {"city": "Auvillars-sur-Saône"},
    {"city": "Auxant"},
    {"city": "Auxey-Duresses"},
    {"city": "Auxonne"},
    {"city": "Avelanges"},
    {"city": "Avosnes"},
    {"city": "Avot"},
    {"city": "Bagnot"},
    {"city": "Baigneux-les-Juifs"},
    {"city": "Balot"},
    {"city": "Barbirey-sur-Ouche"},
    {"city": "Bard-le-Régulier"},
    {"city": "Bard-lès-Époisses"},
    {"city": "Barges"},
    {"city": "Barjon"},
    {"city": "Baubigny"},
    {"city": "Baulme-la-Roche"},
    {"city": "Beaulieu"},
    {"city": "Beaumont-sur-Vingeanne"},
    {"city": "Beaune"},
    {"city": "Beaunotte"},
    {"city": "Beire-le-Châtel"},
    {"city": "Beire-le-Fort"},
    {"city": "Belan-sur-Ource"},
    {"city": "Bellefond"},
    {"city": "Belleneuve"},
    {"city": "Bellenod-sur-Seine"},
    {"city": "Bellenot-sous-Pouilly"},
    {"city": "Beneuvre"},
    {"city": "Benoisey"},
    {"city": "Bessey-en-Chaume"},
    {"city": "Bessey-la-Cour"},
    {"city": "Bessey-lès-Cîteaux"},
    {"city": "Beurey-Bauguay"},
    {"city": "Beurizot"},
    {"city": "Bévy"},
    {"city": "Bèze"},
    {"city": "Bézouotte"},
    {"city": "Billey"},
    {"city": "Billy-lès-Chanceaux"},
    {"city": "Binges"},
    {"city": "Bissey-la-Côte"},
    {"city": "Bissey-la-Pierre"},
    {"city": "Blagny-sur-Vingeanne"},
    {"city": "Blaisy-Bas"},
    {"city": "Blaisy-Haut"},
    {"city": "Blancey"},
    {"city": "Blanot"},
    {"city": "Source-Seine"},
    {"city": "Bligny-le-Sec"},
    {"city": "Bligny-lès-Beaune"},
    {"city": "Bligny-sur-Ouche"},
    {"city": "Boncourt-le-Bois"},
    {"city": "Bonnencontre"},
    {"city": "Boudreville"},
    {"city": "Bouhey"},
    {"city": "Bouilland"},
    {"city": "Bouix"},
    {"city": "Bourberain"},
    {"city": "Bousselange"},
    {"city": "Boussenois"},
    {"city": "Boussey"},
    {"city": "Boux-sous-Salmaise"},
    {"city": "Bouze-lès-Beaune"},
    {"city": "Brain"},
    {"city": "Braux"},
    {"city": "Brazey-en-Morvan"},
    {"city": "Brazey-en-Plaine"},
    {"city": "Brémur-et-Vaurois"},
    {"city": "Bressey-sur-Tille"},
    {"city": "Bretenière"},
    {"city": "Bretigny"},
    {"city": "Brianny"},
    {"city": "Brion-sur-Ource"},
    {"city": "Brochon"},
    {"city": "Brognon"},
    {"city": "Broin"},
    {"city": "Broindon"},
    {"city": "Buffon"},
    {"city": "Buncey"},
    {"city": "Bure-les-Templiers"},
    {"city": "Busseaut"},
    {"city": "Busserotte-et-Montenaille"},
    {"city": "Bussières"},
    {"city": "La Bussière-sur-Ouche"},
    {"city": "Bussy-la-Pesle"},
    {"city": "Bussy-le-Grand"},
    {"city": "Buxerolles"},
    {"city": "Censerey"},
    {"city": "Cérilly"},
    {"city": "Cessey-sur-Tille"},
    {"city": "Chaignay"},
    {"city": "Chailly-sur-Armançon"},
    {"city": "Chambain"},
    {"city": "Chambeire"},
    {"city": "Chamblanc"},
    {"city": "Chambœuf"},
    {"city": "Chambolle-Musigny"},
    {"city": "Chamesson"},
    {"city": "Champagne-sur-Vingeanne"},
    {"city": "Champagny"},
    {"city": "Champ-d'Oiseau"},
    {"city": "Champdôtre"},
    {"city": "Champeau-en-Morvan"},
    {"city": "Champignolles"},
    {"city": "Champrenault"},
    {"city": "Chanceaux"},
    {"city": "Channay"},
    {"city": "Charencey"},
    {"city": "Charigny"},
    {"city": "Charmes"},
    {"city": "Charny"},
    {"city": "Charrey-sur-Saône"},
    {"city": "Charrey-sur-Seine"},
    {"city": "Chassagne-Montrachet"},
    {"city": "Chassey"},
    {"city": "Châteauneuf"},
    {"city": "Châtellenot"},
    {"city": "Châtillon-sur-Seine"},
    {"city": "Chaudenay-la-Ville"},
    {"city": "Chaudenay-le-Château"},
    {"city": "Chaugey"},
    {"city": "Chaume-et-Courchamp"},
    {"city": "La Chaume"},
    {"city": "Chaume-lès-Baigneux"},
    {"city": "Chaumont-le-Bois"},
    {"city": "Chaux"},
    {"city": "Chazeuil"},
    {"city": "Chazilly"},
    {"city": "Chemin-d'Aisey"},
    {"city": "Chenôve"},
    {"city": "Cheuge"},
    {"city": "Chevannay"},
    {"city": "Chevannes"},
    {"city": "Chevigny-en-Valière"},
    {"city": "Chevigny-Saint-Sauveur"},
    {"city": "Chivres"},
    {"city": "Chorey-les-Beaune"},
    {"city": "Cirey-lès-Pontailler"},
    {"city": "Civry-en-Montagne"},
    {"city": "Clamerey"},
    {"city": "Valforêt"},
    {"city": "Clénay"},
    {"city": "Cléry"},
    {"city": "Clomot"},
    {"city": "Collonges-lès-Bévy"},
    {"city": "Collonges-et-Premières"},
    {"city": "Colombier"},
    {"city": "Combertault"},
    {"city": "Comblanchien"},
    {"city": "Commarin"},
    {"city": "Corberon"},
    {"city": "Corcelles-les-Arts"},
    {"city": "Corcelles-lès-Cîteaux"},
    {"city": "Corcelles-les-Monts"},
    {"city": "Corgengoux"},
    {"city": "Corgoloin"},
    {"city": "Cormot-Vauchignon"},
    {"city": "Corpeau"},
    {"city": "Corpoyer-la-Chapelle"},
    {"city": "Corrombles"},
    {"city": "Corsaint"},
    {"city": "Couchey"},
    {"city": "Coulmier-le-Sec"},
    {"city": "Courban"},
    {"city": "Courcelles-Frémoy"},
    {"city": "Courcelles-lès-Montbard"},
    {"city": "Courcelles-lès-Semur"},
    {"city": "Courlon"},
    {"city": "Courtivron"},
    {"city": "Couternon"},
    {"city": "Créancey"},
    {"city": "Crécey-sur-Tille"},
    {"city": "Crépand"},
    {"city": "Crugey"},
    {"city": "Cuiserey"},
    {"city": "Culètre"},
    {"city": "Curley"},
    {"city": "Curtil-Saint-Seine"},
    {"city": "Curtil-Vergy"},
    {"city": "Cussey-les-Forges"},
    {"city": "Cussy-la-Colonne"},
    {"city": "Cussy-le-Châtel"},
    {"city": "Daix"},
    {"city": "Dampierre-en-Montagne"},
    {"city": "Dampierre-et-Flée"},
    {"city": "Darcey"},
    {"city": "Darois"},
    {"city": "Détain-et-Bruant"},
    {"city": "Diancey"},
    {"city": "Diénay"},
    {"city": "Dijon"},
    {"city": "Dompierre-en-Morvan"},
    {"city": "Drambon"},
    {"city": "Drée"},
    {"city": "Duesme"},
    {"city": "Ébaty"},
    {"city": "Échalot"},
    {"city": "Échannay"},
    {"city": "Échenon"},
    {"city": "Échevannes"},
    {"city": "Échevronne"},
    {"city": "Échigey"},
    {"city": "Écutigny"},
    {"city": "Éguilly"},
    {"city": "Épagny"},
    {"city": "Épernay-sous-Gevrey"},
    {"city": "Époisses"},
    {"city": "Éringes"},
    {"city": "Esbarres"},
    {"city": "Essarois"},
    {"city": "Essey"},
    {"city": "Étais"},
    {"city": "Étalante"},
    {"city": "L'Étang-Vergy"},
    {"city": "Étaules"},
    {"city": "Étevaux"},
    {"city": "Étormay"},
    {"city": "Étrochey"},
    {"city": "Fain-lès-Montbard"},
    {"city": "Fain-lès-Moutiers"},
    {"city": "Fauverney"},
    {"city": "Faverolles-lès-Lucey"},
    {"city": "Fénay"},
    {"city": "Le Fête"},
    {"city": "Fixin"},
    {"city": "Flacey"},
    {"city": "Flagey-Echézeaux"},
    {"city": "Flagey-lès-Auxonne"},
    {"city": "Flammerans"},
    {"city": "Flavignerot"},
    {"city": "Flavigny-sur-Ozerain"},
    {"city": "Le Val-Larrey"},
    {"city": "Fleurey-sur-Ouche"},
    {"city": "Foissy"},
    {"city": "Foncegrive"},
    {"city": "Fontaines-en-Duesmois"},
    {"city": "Fontaine-Française"},
    {"city": "Fontaine-lès-Dijon"},
    {"city": "Fontaines-les-Sèches"},
    {"city": "Fontangy"},
    {"city": "Fontenelle"},
    {"city": "Forléans"},
    {"city": "Fraignot-et-Vesvrotte"},
    {"city": "Francheville"},
    {"city": "Franxault"},
    {"city": "Frénois"},
    {"city": "Fresnes"},
    {"city": "Frôlois"},
    {"city": "Fussey"},
    {"city": "Gemeaux"},
    {"city": "Genay"},
    {"city": "Genlis"},
    {"city": "Gergueil"},
    {"city": "Gerland"},
    {"city": "Gevrey-Chambertin"},
    {"city": "Gevrolles"},
    {"city": "Gilly-lès-Cîteaux"},
    {"city": "Gissey-le-Vieil"},
    {"city": "Gissey-sous-Flavigny"},
    {"city": "Gissey-sur-Ouche"},
    {"city": "Glanon"},
    {"city": "Gomméville"},
    {"city": "Les Goulles"},
    {"city": "Grancey-le-Château-Neuvelle"},
    {"city": "Grancey-sur-Ource"},
    {"city": "Grenant-lès-Sombernon"},
    {"city": "Grésigny-Sainte-Reine"},
    {"city": "Grignon"},
    {"city": "Griselles"},
    {"city": "Grosbois-en-Montagne"},
    {"city": "Grosbois-lès-Tichey"},
    {"city": "Gurgy-la-Ville"},
    {"city": "Gurgy-le-Château"},
    {"city": "Hauteroche"},
    {"city": "Hauteville-lès-Dijon"},
    {"city": "Heuilley-sur-Saône"},
    {"city": "Is-sur-Tille"},
    {"city": "Izeure"},
    {"city": "Izier"},
    {"city": "Jailly-les-Moulins"},
    {"city": "Jallanges"},
    {"city": "Jancigny"},
    {"city": "Jeux-lès-Bard"},
    {"city": "Jouey"},
    {"city": "Jours-lès-Baigneux"},
    {"city": "Val-Mont"},
    {"city": "Juillenay"},
    {"city": "Juilly"},
    {"city": "Labergement-Foigney"},
    {"city": "Labergement-lès-Auxonne"},
    {"city": "Labergement-lès-Seurre"},
    {"city": "Labruyère"},
    {"city": "Lacanche"},
    {"city": "Lacour-d'Arcenay"},
    {"city": "Laignes"},
    {"city": "Lamarche-sur-Saône"},
    {"city": "Lamargelle"},
    {"city": "Lantenay"},
    {"city": "Lanthes"},
    {"city": "Lantilly"},
    {"city": "Laperrière-sur-Saône"},
    {"city": "Larrey"},
    {"city": "Lechâtelet"},
    {"city": "Léry"},
    {"city": "Leuglay"},
    {"city": "Levernois"},
    {"city": "Licey-sur-Vingeanne"},
    {"city": "Liernais"},
    {"city": "Lignerolles"},
    {"city": "Longchamp"},
    {"city": "Longeault-Pluvault"},
    {"city": "Longecourt-en-Plaine"},
    {"city": "Longecourt-lès-Culêtre"},
    {"city": "Longvic"},
    {"city": "Losne"},
    {"city": "Louesme"},
    {"city": "Lucenay-le-Duc"},
    {"city": "Lucey"},
    {"city": "Lusigny-sur-Ouche"},
    {"city": "Lux"},
    {"city": "Maconge"},
    {"city": "Magnien"},
    {"city": "Magny-Lambert"},
    {"city": "Magny-la-Ville"},
    {"city": "Magny-lès-Aubigny"},
    {"city": "Magny-Montarlot"},
    {"city": "Magny-lès-Villers"},
    {"city": "Magny-Saint-Médard"},
    {"city": "Magny-sur-Tille"},
    {"city": "Les Maillys"},
    {"city": "Maisey-le-Duc"},
    {"city": "Mâlain"},
    {"city": "Maligny"},
    {"city": "Manlay"},
    {"city": "Marandeuil"},
    {"city": "Marcellois"},
    {"city": "Marcenay"},
    {"city": "Marcheseuil"},
    {"city": "Marcigny-sous-Thil"},
    {"city": "Marcilly-et-Dracy"},
    {"city": "Marcilly-Ogny"},
    {"city": "Marcilly-sur-Tille"},
    {"city": "Marey-lès-Fussey"},
    {"city": "Marey-sur-Tille"},
    {"city": "Marigny-le-Cahouët"},
    {"city": "Marigny-lès-Reullée"},
    {"city": "Marliens"},
    {"city": "Marmagne"},
    {"city": "Marsannay-la-Côte"},
    {"city": "Marsannay-le-Bois"},
    {"city": "Martrois"},
    {"city": "Massingy"},
    {"city": "Massingy-lès-Semur"},
    {"city": "Massingy-lès-Vitteaux"},
    {"city": "Mauvilly"},
    {"city": "Mavilly-Mandelot"},
    {"city": "Maxilly-sur-Saône"},
    {"city": "Meilly-sur-Rouvres"},
    {"city": "Le Meix"},
    {"city": "Meloisey"},
    {"city": "Menesble"},
    {"city": "Ménessaire"},
    {"city": "Ménétreux-le-Pitois"},
    {"city": "Merceuil"},
    {"city": "Mesmont"},
    {"city": "Messanges"},
    {"city": "Messigny-et-Vantoux"},
    {"city": "Meuilley"},
    {"city": "Meulson"},
    {"city": "Meursanges"},
    {"city": "Meursault"},
    {"city": "Millery"},
    {"city": "Mimeure"},
    {"city": "Minot"},
    {"city": "Mirebeau-sur-Bèze"},
    {"city": "Missery"},
    {"city": "Moitron"},
    {"city": "Molesme"},
    {"city": "Molinot"},
    {"city": "Moloy"},
    {"city": "Molphey"},
    {"city": "Montagny-lès-Beaune"},
    {"city": "Montagny-lès-Seurre"},
    {"city": "Montbard"},
    {"city": "Montberthault"},
    {"city": "Montceau-et-Écharnant"},
    {"city": "Monthelie"},
    {"city": "Montigny-Montfort"},
    {"city": "Montigny-Saint-Barthélemy"},
    {"city": "Montigny-sur-Armançon"},
    {"city": "Montigny-sur-Aube"},
    {"city": "Montigny-Mornay-Villeneuve-sur-Vingeanne"},
    {"city": "Montlay-en-Auxois"},
    {"city": "Montliot-et-Courcelles"},
    {"city": "Montmain"},
    {"city": "Montmançon"},
    {"city": "Montmoyen"},
    {"city": "Montoillot"},
    {"city": "Montot"},
    {"city": "Mont-Saint-Jean"},
    {"city": "Morey-Saint-Denis"},
    {"city": "Mosson"},
    {"city": "La Motte-Ternant"},
    {"city": "Moutiers-Saint-Jean"},
    {"city": "Musigny"},
    {"city": "Mussy-la-Fosse"},
    {"city": "Nan-sous-Thil"},
    {"city": "Nantoux"},
    {"city": "Nesle-et-Massoult"},
    {"city": "Neuilly-Crimolois"},
    {"city": "Nicey"},
    {"city": "Nod-sur-Seine"},
    {"city": "Nogent-lès-Montbard"},
    {"city": "Noidan"},
    {"city": "Noiron-sous-Gevrey"},
    {"city": "Noiron-sur-Bèze"},
    {"city": "Noiron-sur-Seine"},
    {"city": "Nolay"},
    {"city": "Norges-la-Ville"},
    {"city": "Normier"},
    {"city": "Nuits-Saint-Georges"},
    {"city": "Obtrée"},
    {"city": "Oigny"},
    {"city": "Oisilly"},
    {"city": "Orain"},
    {"city": "Orgeux"},
    {"city": "Origny"},
    {"city": "Orret"},
    {"city": "Orville"},
    {"city": "Ouges"},
    {"city": "Pagny-la-Ville"},
    {"city": "Pagny-le-Château"},
    {"city": "Painblanc"},
    {"city": "Panges"},
    {"city": "Pasques"},
    {"city": "Pellerey"},
    {"city": "Pernand-Vergelesses"},
    {"city": "Perrigny-lès-Dijon"},
    {"city": "Perrigny-sur-l'Ognon"},
    {"city": "Pichanges"},
    {"city": "Planay"},
    {"city": "Plombières-lès-Dijon"},
    {"city": "Pluvet"},
    {"city": "Poinçon-lès-Larrey"},
    {"city": "Poiseul-la-Grange"},
    {"city": "Poiseul-la-Ville-et-Laperrière"},
    {"city": "Poiseul-lès-Saulx"},
    {"city": "Pommard"},
    {"city": "Poncey-lès-Athée"},
    {"city": "Poncey-sur-l'Ignon"},
    {"city": "Pont"},
    {"city": "Pontailler-sur-Saône"},
    {"city": "Pont-et-Massène"},
    {"city": "Posanges"},
    {"city": "Pothières"},
    {"city": "Pouillenay"},
    {"city": "Pouilly-en-Auxois"},
    {"city": "Pouilly-sur-Saône"},
    {"city": "Pouilly-sur-Vingeanne"},
    {"city": "Prâlon"},
    {"city": "Précy-sous-Thil"},
    {"city": "Premeaux-Prissey"},
    {"city": "Prenois"},
    {"city": "Prusly-sur-Ource"},
    {"city": "Puits"},
    {"city": "Puligny-Montrachet"},
    {"city": "Quemigny-sur-Seine"},
    {"city": "Quetigny"},
    {"city": "Quincerot"},
    {"city": "Quincey"},
    {"city": "Quincy-le-Vicomte"},
    {"city": "Recey-sur-Ource"},
    {"city": "Remilly-en-Montagne"},
    {"city": "Remilly-sur-Tille"},
    {"city": "Renève"},
    {"city": "Reulle-Vergy"},
    {"city": "Riel-les-Eaux"},
    {"city": "La Roche-en-Brenil"},
    {"city": "Rochefort-sur-Brévon"},
    {"city": "La Rochepot"},
    {"city": "La Roche-Vanneau"},
    {"city": "Roilly"},
    {"city": "Rougemont"},
    {"city": "Rouvray"},
    {"city": "Rouvres-en-Plaine"},
    {"city": "Rouvres-sous-Meilly"},
    {"city": "Ruffey-lès-Beaune"},
    {"city": "Ruffey-lès-Echirey"},
    {"city": "Sacquenay"},
    {"city": "Saffres"},
    {"city": "Saint-Andeux"},
    {"city": "Saint-Anthot"},
    {"city": "Saint-Apollinaire"},
    {"city": "Saint-Aubin"},
    {"city": "Saint-Bernard"},
    {"city": "Saint-Broing-les-Moines"},
    {"city": "Sainte-Colombe-en-Auxois"},
    {"city": "Sainte-Colombe-sur-Seine"},
    {"city": "Saint-Didier"},
    {"city": "Saint-Euphrône"},
    {"city": "Saint-Germain-de-Modéon"},
    {"city": "Saint-Germain-le-Rocheux"},
    {"city": "Saint-Germain-lès-Senailly"},
    {"city": "Saint-Hélier"},
    {"city": "Saint-Jean-de-Bœuf"},
    {"city": "Saint-Jean-de-Losne"},
    {"city": "Saint-Julien"},
    {"city": "Saint-Léger-Triey"},
    {"city": "Saint-Marc-sur-Seine"},
    {"city": "Sainte-Marie-la-Blanche"},
    {"city": "Sainte-Marie-sur-Ouche"},
    {"city": "Saint-Martin-de-la-Mer"},
    {"city": "Saint-Martin-du-Mont"},
    {"city": "Saint-Maurice-sur-Vingeanne"},
    {"city": "Saint-Mesmin"},
    {"city": "Saint-Nicolas-lès-Cîteaux"},
    {"city": "Saint-Philibert"},
    {"city": "Saint-Pierre-en-Vaux"},
    {"city": "Saint-Prix-lès-Arnay"},
    {"city": "Saint-Rémy"},
    {"city": "Saint-Romain"},
    {"city": "Sainte-Sabine"},
    {"city": "Saint-Sauveur"},
    {"city": "Saint-Seine-en-Bâche"},
    {"city": "Saint-Seine-l'Abbaye"},
    {"city": "Saint-Seine-sur-Vingeanne"},
    {"city": "Saint-Symphorien-sur-Saône"},
    {"city": "Saint-Thibault"},
    {"city": "Saint-Usage"},
    {"city": "Saint-Victor-sur-Ouche"},
    {"city": "Salives"},
    {"city": "Salmaise"},
    {"city": "Samerey"},
    {"city": "Santenay"},
    {"city": "Santosse"},
    {"city": "Saulieu"},
    {"city": "Saulon-la-Chapelle"},
    {"city": "Saulon-la-Rue"},
    {"city": "Saulx-le-Duc"},
    {"city": "Saussey"},
    {"city": "Saussy"},
    {"city": "Savigny-lès-Beaune"},
    {"city": "Savigny-le-Sec"},
    {"city": "Savigny-sous-Mâlain"},
    {"city": "Savilly"},
    {"city": "Savoisy"},
    {"city": "Savolles"},
    {"city": "Savouges"},
    {"city": "Segrois"},
    {"city": "Seigny"},
    {"city": "Selongey"},
    {"city": "Semarey"},
    {"city": "Semezanges"},
    {"city": "Semond"},
    {"city": "Semur-en-Auxois"},
    {"city": "Senailly"},
    {"city": "Sennecey-lès-Dijon"},
    {"city": "Ladoix-Serrigny"},
    {"city": "Seurre"},
    {"city": "Sincey-lès-Rouvray"},
    {"city": "Soirans"},
    {"city": "Soissons-sur-Nacey"},
    {"city": "Sombernon"},
    {"city": "Souhey"},
    {"city": "Soussey-sur-Brionne"},
    {"city": "Spoy"},
    {"city": "Sussey"},
    {"city": "Tailly"},
    {"city": "Talant"},
    {"city": "Talmay"},
    {"city": "Tanay"},
    {"city": "Tarsul"},
    {"city": "Tart-le-Bas"},
    {"city": "Tart"},
    {"city": "Tellecey"},
    {"city": "Ternant"},
    {"city": "Terrefondrée"},
    {"city": "Thenissey"},
    {"city": "Thoires"},
    {"city": "Thoisy-la-Berchère"},
    {"city": "Thoisy-le-Désert"},
    {"city": "Thomirey"},
    {"city": "Thorey-en-Plaine"},
    {"city": "Thorey-sous-Charny"},
    {"city": "Thorey-sur-Ouche"},
    {"city": "Thoste"},
    {"city": "Thury"},
    {"city": "Tichey"},
    {"city": "Til-Châtel"},
    {"city": "Tillenay"},
    {"city": "Torcy-et-Pouligny"},
    {"city": "Touillon"},
    {"city": "Toutry"},
    {"city": "Tréclun"},
    {"city": "Trochères"},
    {"city": "Trouhans"},
    {"city": "Trouhaut"},
    {"city": "Trugny"},
    {"city": "Turcey"},
    {"city": "Uncey-le-Franc"},
    {"city": "Urcy"},
    {"city": "Val-Suzon"},
    {"city": "Vandenesse-en-Auxois"},
    {"city": "Vannaire"},
    {"city": "Vanvey"},
    {"city": "Varanges"},
    {"city": "Varois-et-Chaignot"},
    {"city": "Vaux-Saules"},
    {"city": "Veilly"},
    {"city": "Velars-sur-Ouche"},
    {"city": "Velogny"},
    {"city": "Venarey-les-Laumes"},
    {"city": "Verdonnet"},
    {"city": "Vernois-lès-Vesvres"},
    {"city": "Vernot"},
    {"city": "Véronnes"},
    {"city": "Verrey-sous-Drée"},
    {"city": "Verrey-sous-Salmaise"},
    {"city": "Vertault"},
    {"city": "Vesvres"},
    {"city": "Veuvey-sur-Ouche"},
    {"city": "Veuxhaulles-sur-Aube"},
    {"city": "Vianges"},
    {"city": "Vic-de-Chassenay"},
    {"city": "Vic-des-Prés"},
    {"city": "Vic-sous-Thil"},
    {"city": "Vieilmoulin"},
    {"city": "Vielverge"},
    {"city": "Vieux-Château"},
    {"city": "Viévigne"},
    {"city": "Viévy"},
    {"city": "Vignoles"},
    {"city": "Villaines-en-Duesmois"},
    {"city": "Villaines-les-Prévôtes"},
    {"city": "Villargoix"},
    {"city": "Villars-Fontaine"},
    {"city": "Villars-et-Villenotte"},
    {"city": "Villeberny"},
    {"city": "Villebichot"},
    {"city": "Villecomte"},
    {"city": "Villedieu"},
    {"city": "Villeferry"},
    {"city": "La Villeneuve-les-Convers"},
    {"city": "Villeneuve-sous-Charigny"},
    {"city": "Villers-la-Faye"},
    {"city": "Villers-les-Pots"},
    {"city": "Villers-Patras"},
    {"city": "Villers-Rotin"},
    {"city": "Villey-sur-Tille"},
    {"city": "Villiers-en-Morvan"},
    {"city": "Villiers-le-Duc"},
    {"city": "Villotte-Saint-Seine"},
    {"city": "Villotte-sur-Ource"},
    {"city": "Villy-en-Auxois"},
    {"city": "Villy-le-Moutier"},
    {"city": "Viserny"},
    {"city": "Vitteaux"},
    {"city": "Vix"},
    {"city": "Volnay"},
    {"city": "Vonges"},
    {"city": "Vosne-Romanée"},
    {"city": "Voudenay"},
    {"city": "Vougeot"},
    {"city": "Voulaines-les-Templiers"},
    {"city": "Allineuc"},
    {"city": "Andel"},
    {"city": "Aucaleuc"},
    {"city": "Bégard"},
    {"city": "Belle-Isle-en-Terre"},
    {"city": "Berhet"},
    {"city": "Bobital"},
    {"city": "Le Bodéo"},
    {"city": "Boqueho"},
    {"city": "La Bouillie"},
    {"city": "Bourbriac"},
    {"city": "Bourseul"},
    {"city": "Bréhand"},
    {"city": "Île-de-Bréhat"},
    {"city": "Brélidy"},
    {"city": "Bringolo"},
    {"city": "Broons"},
    {"city": "Brusvily"},
    {"city": "Bulat-Pestivien"},
    {"city": "Calanhel"},
    {"city": "Callac"},
    {"city": "Calorguen"},
    {"city": "Le Cambout"},
    {"city": "Camlez"},
    {"city": "Canihuel"},
    {"city": "Caouënnec-Lanvézéac"},
    {"city": "Carnoët"},
    {"city": "Caulnes"},
    {"city": "Caurel"},
    {"city": "Cavan"},
    {"city": "Les Champs-Géraux"},
    {"city": "La Chapelle-Blanche"},
    {"city": "La Chapelle-Neuve"},
    {"city": "La Chèze"},
    {"city": "Coadout"},
    {"city": "Coatascorn"},
    {"city": "Coatréven"},
    {"city": "Coëtlogon"},
    {"city": "Coëtmieux"},
    {"city": "Cohiniac"},
    {"city": "Le Mené"},
    {"city": "Corlay"},
    {"city": "Corseul"},
    {"city": "Créhen"},
    {"city": "Dinan"},
    {"city": "Duault"},
    {"city": "Éréac"},
    {"city": "Erquy"},
    {"city": "Binic-Étables-sur-Mer"},
    {"city": "Évran"},
    {"city": "Le Faouët"},
    {"city": "Le Fœil"},
    {"city": "Gausson"},
    {"city": "Glomel"},
    {"city": "Gomené"},
    {"city": "Gommenec'h"},
    {"city": "Gouarec"},
    {"city": "Goudelin"},
    {"city": "Grâces"},
    {"city": "Grâce-Uzel"},
    {"city": "Guenroc"},
    {"city": "Guingamp"},
    {"city": "Guitté"},
    {"city": "Gurunhuel"},
    {"city": "La Harmoye"},
    {"city": "Le Haut-Corlay"},
    {"city": "Hémonstoir"},
    {"city": "Hénanbihen"},
    {"city": "Hénansal"},
    {"city": "Hénon"},
    {"city": "Hillion"},
    {"city": "Le Hinglé"},
    {"city": "Illifaut"},
    {"city": "Jugon-les-Lacs - Commune nouvelle"},
    {"city": "Kerbors"},
    {"city": "Kerfot"},
    {"city": "Kergrist-Moëlou"},
    {"city": "Kerien"},
    {"city": "Kermaria-Sulard"},
    {"city": "Kermoroc'h"},
    {"city": "Kerpert"},
    {"city": "Lamballe-Armor"},
    {"city": "Lancieux"},
    {"city": "Landebaëron"},
    {"city": "Landébia"},
    {"city": "La Landec"},
    {"city": "Landéhen"},
    {"city": "Lanfains"},
    {"city": "Langoat"},
    {"city": "Langrolay-sur-Rance"},
    {"city": "Languédias"},
    {"city": "Languenan"},
    {"city": "Langueux"},
    {"city": "Bon Repos sur Blavet"},
    {"city": "Lanleff"},
    {"city": "Lanloup"},
    {"city": "Lanmérin"},
    {"city": "Lanmodez"},
    {"city": "Lannebert"},
    {"city": "Lannion"},
    {"city": "Lanrelas"},
    {"city": "Lanrivain"},
    {"city": "Lanrodec"},
    {"city": "Lantic"},
    {"city": "Lanvallay"},
    {"city": "Lanvellec"},
    {"city": "Lanvollon"},
    {"city": "Laurenan"},
    {"city": "Lescouët-Gouarec"},
    {"city": "Le Leslay"},
    {"city": "Lézardrieux"},
    {"city": "Locarn"},
    {"city": "Loc-Envel"},
    {"city": "Loguivy-Plougras"},
    {"city": "Lohuec"},
    {"city": "Loscouët-sur-Meu"},
    {"city": "Louannec"},
    {"city": "Louargat"},
    {"city": "Loudéac"},
    {"city": "Maël-Carhaix"},
    {"city": "Maël-Pestivien"},
    {"city": "Magoar"},
    {"city": "La Malhoure"},
    {"city": "Mantallot"},
    {"city": "Matignon"},
    {"city": "La Méaugon"},
    {"city": "Mégrit"},
    {"city": "Mellionnec"},
    {"city": "Merdrignac"},
    {"city": "Mérillac"},
    {"city": "Merléac"},
    {"city": "Le Merzer"},
    {"city": "Minihy-Tréguier"},
    {"city": "Moncontour"},
    {"city": "La Motte"},
    {"city": "Moustéru"},
    {"city": "Le Moustoir"},
    {"city": "Guerlédan"},
    {"city": "Noyal"},
    {"city": "Pabu"},
    {"city": "Paimpol"},
    {"city": "Paule"},
    {"city": "Pédernec"},
    {"city": "Penguily"},
    {"city": "Penvénan"},
    {"city": "Perros-Guirec"},
    {"city": "Peumerit-Quintin"},
    {"city": "Plaine-Haute"},
    {"city": "Plaintel"},
    {"city": "Plancoët"},
    {"city": "Pléboulle"},
    {"city": "Plédéliac"},
    {"city": "Plédran"},
    {"city": "Pléguien"},
    {"city": "Pléhédel"},
    {"city": "Fréhel"},
    {"city": "Plélan-le-Petit"},
    {"city": "Plélauff"},
    {"city": "Plélo"},
    {"city": "Plémet"},
    {"city": "Plémy"},
    {"city": "Plénée-Jugon"},
    {"city": "Pléneuf-Val-André"},
    {"city": "Plérin"},
    {"city": "Plerneuf"},
    {"city": "Plésidy"},
    {"city": "Pleslin-Trigavou"},
    {"city": "Plestan"},
    {"city": "Plestin-les-Grèves"},
    {"city": "Pleubian"},
    {"city": "Pleudaniel"},
    {"city": "Pleudihen-sur-Rance"},
    {"city": "Pleumeur-Bodou"},
    {"city": "Pleumeur-Gautier"},
    {"city": "Pléven"},
    {"city": "Plévenon"},
    {"city": "Plévin"},
    {"city": "Plœuc-L'Hermitage"},
    {"city": "Ploëzal"},
    {"city": "Plorec-sur-Arguenon"},
    {"city": "Châtelaudren-Plouagat"},
    {"city": "Plouaret"},
    {"city": "Plouasne"},
    {"city": "Beaussais-sur-Mer"},
    {"city": "Ploubazlanec"},
    {"city": "Ploubezre"},
    {"city": "Plouëc-du-Trieux"},
    {"city": "Plouër-sur-Rance"},
    {"city": "Plouézec"},
    {"city": "Ploufragan"},
    {"city": "Plougonver"},
    {"city": "Plougras"},
    {"city": "Plougrescant"},
    {"city": "Plouguenast-Langast"},
    {"city": "Plouguernével"},
    {"city": "Plouguiel"},
    {"city": "Plouha"},
    {"city": "Plouisy"},
    {"city": "Ploulec'h"},
    {"city": "Ploumagoar"},
    {"city": "Ploumilliau"},
    {"city": "Plounérin"},
    {"city": "Plounévez-Moëdec"},
    {"city": "Plounévez-Quintin"},
    {"city": "Plourac'h"},
    {"city": "Plourhan"},
    {"city": "Plourivo"},
    {"city": "Plouvara"},
    {"city": "Plouzélambre"},
    {"city": "Pludual"},
    {"city": "Pluduno"},
    {"city": "Plufur"},
    {"city": "Plumaudan"},
    {"city": "Plumaugat"},
    {"city": "Plumieux"},
    {"city": "Plurien"},
    {"city": "Plusquellec"},
    {"city": "Plussulien"},
    {"city": "Pluzunet"},
    {"city": "Pommeret"},
    {"city": "Pommerit-le-Vicomte"},
    {"city": "Pont-Melvez"},
    {"city": "Pontrieux"},
    {"city": "Pordic"},
    {"city": "Prat"},
    {"city": "La Prénessaye"},
    {"city": "Quemper-Guézennec"},
    {"city": "Quemperven"},
    {"city": "Quessoy"},
    {"city": "Quévert"},
    {"city": "Le Quillio"},
    {"city": "Quintenic"},
    {"city": "Quintin"},
    {"city": "Le Quiou"},
    {"city": "La Roche-Jaudy"},
    {"city": "Rospez"},
    {"city": "Rostrenen"},
    {"city": "Rouillac"},
    {"city": "Ruca"},
    {"city": "Runan"},
    {"city": "Saint-Adrien"},
    {"city": "Saint-Agathon"},
    {"city": "Saint-Alban"},
    {"city": "Saint-André-des-Eaux"},
    {"city": "Saint-Barnabé"},
    {"city": "Saint-Bihy"},
    {"city": "Saint-Brandan"},
    {"city": "Saint-Brieuc"},
    {"city": "Saint-Caradec"},
    {"city": "Saint-Carné"},
    {"city": "Saint-Carreuc"},
    {"city": "Saint-Cast-le-Guildo"},
    {"city": "Saint-Clet"},
    {"city": "Saint-Connan"},
    {"city": "Saint-Connec"},
    {"city": "Saint-Denoual"},
    {"city": "Saint-Donan"},
    {"city": "Saint-Étienne-du-Gué-de-l'Isle"},
    {"city": "Saint-Fiacre"},
    {"city": "Saint-Gildas"},
    {"city": "Saint-Gilles-les-Bois"},
    {"city": "Saint-Gilles-Pligeaux"},
    {"city": "Saint-Gilles-Vieux-Marché"},
    {"city": "Saint-Glen"},
    {"city": "Saint-Hélen"},
    {"city": "Saint-Hervé"},
    {"city": "Saint-Jacut-de-la-Mer"},
    {"city": "Saint-Jean-Kerdaniel"},
    {"city": "Saint-Jouan-de-l'Isle"},
    {"city": "Saint-Judoce"},
    {"city": "Saint-Julien"},
    {"city": "Saint-Juvat"},
    {"city": "Saint-Launeuc"},
    {"city": "Saint-Laurent"},
    {"city": "Saint-Lormel"},
    {"city": "Saint-Maden"},
    {"city": "Saint-Martin-des-Prés"},
    {"city": "Saint-Maudan"},
    {"city": "Saint-Maudez"},
    {"city": "Saint-Mayeux"},
    {"city": "Saint-Méloir-des-Bois"},
    {"city": "Saint-Michel-de-Plélan"},
    {"city": "Saint-Michel-en-Grève"},
    {"city": "Saint-Nicodème"},
    {"city": "Saint-Nicolas-du-Pélem"},
    {"city": "Saint-Péver"},
    {"city": "Saint-Pôtan"},
    {"city": "Saint-Quay-Perros"},
    {"city": "Saint-Quay-Portrieux"},
    {"city": "Saint-Rieul"},
    {"city": "Saint-Samson-sur-Rance"},
    {"city": "Saint-Servais"},
    {"city": "Saint-Thélo"},
    {"city": "Sainte-Tréphine"},
    {"city": "Saint-Trimoël"},
    {"city": "Saint-Vran"},
    {"city": "Saint-Igeaux"},
    {"city": "Senven-Léhart"},
    {"city": "Sévignac"},
    {"city": "Squiffiec"},
    {"city": "Taden"},
    {"city": "Tonquédec"},
    {"city": "Tramain"},
    {"city": "Trébédan"},
    {"city": "Trébeurden"},
    {"city": "Trébrivan"},
    {"city": "Trébry"},
    {"city": "Trédaniel"},
    {"city": "Trédarzec"},
    {"city": "Trédias"},
    {"city": "Trédrez-Locquémeau"},
    {"city": "Tréduder"},
    {"city": "Treffrin"},
    {"city": "Tréfumel"},
    {"city": "Trégastel"},
    {"city": "Tréglamus"},
    {"city": "Trégomeur"},
    {"city": "Trégonneau"},
    {"city": "Trégrom"},
    {"city": "Trégueux"},
    {"city": "Tréguidel"},
    {"city": "Tréguier"},
    {"city": "Trélévern"},
    {"city": "Trélivan"},
    {"city": "Trémargat"},
    {"city": "Trémel"},
    {"city": "Tréméreuc"},
    {"city": "Trémeur"},
    {"city": "Tréméven"},
    {"city": "Trémorel"},
    {"city": "Trémuson"},
    {"city": "Tréogan"},
    {"city": "Tressignaux"},
    {"city": "Trévé"},
    {"city": "Tréveneuc"},
    {"city": "Trévérec"},
    {"city": "Trévou-Tréguignec"},
    {"city": "Trévron"},
    {"city": "Trézény"},
    {"city": "Troguéry"},
    {"city": "Uzel"},
    {"city": "La Vicomté-sur-Rance"},
    {"city": "Le Vieux-Bourg"},
    {"city": "Le Vieux-Marché"},
    {"city": "Vildé-Guingalan"},
    {"city": "Yffiniac"},
    {"city": "Yvias"},
    {"city": "Yvignac-la-Tour"},
    {"city": "Ahun"},
    {"city": "Ajain"},
    {"city": "Alleyrat"},
    {"city": "Anzême"},
    {"city": "Arfeuille-Châtain"},
    {"city": "Arrènes"},
    {"city": "Ars"},
    {"city": "Aubusson"},
    {"city": "Auge"},
    {"city": "Augères"},
    {"city": "Aulon"},
    {"city": "Auriat"},
    {"city": "Auzances"},
    {"city": "Azat-Châtenet"},
    {"city": "Azerables"},
    {"city": "Banize"},
    {"city": "Basville"},
    {"city": "Bazelat"},
    {"city": "Beissat"},
    {"city": "Bellegarde-en-Marche"},
    {"city": "Bénévent-l'Abbaye"},
    {"city": "Bétête"},
    {"city": "Blaudeix"},
    {"city": "Blessac"},
    {"city": "Bonnat"},
    {"city": "Bord-Saint-Georges"},
    {"city": "Bosmoreau-les-Mines"},
    {"city": "Bosroger"},
    {"city": "Le Bourg-d'Hem"},
    {"city": "Bourganeuf"},
    {"city": "Boussac"},
    {"city": "Boussac-Bourg"},
    {"city": "La Brionne"},
    {"city": "Brousse"},
    {"city": "Budelière"},
    {"city": "Bussière-Dunoise"},
    {"city": "Bussière-Nouvelle"},
    {"city": "Bussière-Saint-Georges"},
    {"city": "La Celle-Dunoise"},
    {"city": "La Celle-sous-Gouzon"},
    {"city": "La Cellette"},
    {"city": "Ceyroux"},
    {"city": "Chamberaud"},
    {"city": "Chambon-Sainte-Croix"},
    {"city": "Chambon-sur-Voueize"},
    {"city": "Chambonchard"},
    {"city": "Chamborand"},
    {"city": "Champagnat"},
    {"city": "Champsanglard"},
    {"city": "La Chapelle-Baloue"},
    {"city": "La Chapelle-Saint-Martial"},
    {"city": "La Chapelle-Taillefert"},
    {"city": "Chard"},
    {"city": "Charron"},
    {"city": "Châtelard"},
    {"city": "Châtelus-le-Marcheix"},
    {"city": "Châtelus-Malvaleix"},
    {"city": "Le Chauchet"},
    {"city": "La Chaussade"},
    {"city": "Chavanat"},
    {"city": "Chénérailles"},
    {"city": "Chéniers"},
    {"city": "Clairavaux"},
    {"city": "Clugnat"},
    {"city": "Colondannes"},
    {"city": "Le Compas"},
    {"city": "La Courtine"},
    {"city": "Cressat"},
    {"city": "Crocq"},
    {"city": "Crozant"},
    {"city": "Croze"},
    {"city": "Domeyrot"},
    {"city": "Dontreix"},
    {"city": "Le Donzeil"},
    {"city": "Dun-le-Palestel"},
    {"city": "Évaux-les-Bains"},
    {"city": "Faux-la-Montagne"},
    {"city": "Faux-Mazuras"},
    {"city": "Felletin"},
    {"city": "Féniers"},
    {"city": "Flayat"},
    {"city": "Fleurat"},
    {"city": "Fontanières"},
    {"city": "La Forêt-du-Temple"},
    {"city": "Fransèches"},
    {"city": "Fresselines"},
    {"city": "Gartempe"},
    {"city": "Genouillac"},
    {"city": "Gentioux-Pigerolles"},
    {"city": "Gioux"},
    {"city": "Glénic"},
    {"city": "Gouzon"},
    {"city": "Le Grand-Bourg"},
    {"city": "Guéret"},
    {"city": "Issoudun-Létrieix"},
    {"city": "Jalesches"},
    {"city": "Janaillat"},
    {"city": "Jarnages"},
    {"city": "Jouillat"},
    {"city": "Ladapeyre"},
    {"city": "Lafat"},
    {"city": "Lavaufranche"},
    {"city": "Lavaveix-les-Mines"},
    {"city": "Lépaud"},
    {"city": "Lépinas"},
    {"city": "Leyrat"},
    {"city": "Linard-Malval"},
    {"city": "Lioux-les-Monges"},
    {"city": "Lizières"},
    {"city": "Lourdoueix-Saint-Pierre"},
    {"city": "Lupersat"},
    {"city": "Lussat"},
    {"city": "Magnat-l'Étrange"},
    {"city": "Mainsat"},
    {"city": "Maison-Feyne"},
    {"city": "Maisonnisses"},
    {"city": "Malleret"},
    {"city": "Malleret-Boussac"},
    {"city": "Mansat-la-Courrière"},
    {"city": "Les Mars"},
    {"city": "Marsac"},
    {"city": "Le Mas-d'Artige"},
    {"city": "Mautes"},
    {"city": "Mazeirat"},
    {"city": "La Mazière-aux-Bons-Hommes"},
    {"city": "Méasnes"},
    {"city": "Mérinchal"},
    {"city": "Montaigut-le-Blanc"},
    {"city": "Montboucher"},
    {"city": "Le Monteil-au-Vicomte"},
    {"city": "Mortroux"},
    {"city": "Mourioux-Vieilleville"},
    {"city": "Moutier-d'Ahun"},
    {"city": "Moutier-Malcard"},
    {"city": "Moutier-Rozeille"},
    {"city": "Naillat"},
    {"city": "Néoux"},
    {"city": "Noth"},
    {"city": "La Nouaille"},
    {"city": "Nouhant"},
    {"city": "Nouzerines"},
    {"city": "Nouzerolles"},
    {"city": "Nouziers"},
    {"city": "Parsac-Rimondeix"},
    {"city": "Peyrabout"},
    {"city": "Peyrat-la-Nonière"},
    {"city": "Pierrefitte"},
    {"city": "Pionnat"},
    {"city": "Pontarion"},
    {"city": "Pontcharraud"},
    {"city": "La Pouge"},
    {"city": "Poussanges"},
    {"city": "Puy-Malsignat"},
    {"city": "Reterre"},
    {"city": "Roches"},
    {"city": "Rougnat"},
    {"city": "Royère-de-Vassivière"},
    {"city": "Sagnat"},
    {"city": "Sannat"},
    {"city": "Sardent"},
    {"city": "La Saunière"},
    {"city": "Savennes"},
    {"city": "Sermur"},
    {"city": "La Serre-Bussière-Vieille"},
    {"city": "Soubrebost"},
    {"city": "Soumans"},
    {"city": "Sous-Parsat"},
    {"city": "La Souterraine"},
    {"city": "Saint-Agnant-de-Versillat"},
    {"city": "Saint-Agnant-près-Crocq"},
    {"city": "Saint-Alpinien"},
    {"city": "Saint-Amand"},
    {"city": "Saint-Amand-Jartoudeix"},
    {"city": "Saint-Avit-de-Tardes"},
    {"city": "Saint-Avit-le-Pauvre"},
    {"city": "Saint-Bard"},
    {"city": "Saint-Chabrais"},
    {"city": "Saint-Christophe"},
    {"city": "Saint-Dizier-la-Tour"},
    {"city": "Saint-Dizier-les-Domaines"},
    {"city": "Saint-Dizier-Masbaraud"},
    {"city": "Saint-Domet"},
    {"city": "Saint-Éloi"},
    {"city": "Fursac"},
    {"city": "Sainte-Feyre"},
    {"city": "Sainte-Feyre-la-Montagne"},
    {"city": "Saint-Fiel"},
    {"city": "Saint-Frion"},
    {"city": "Saint-Georges-la-Pouge"},
    {"city": "Saint-Georges-Nigremont"},
    {"city": "Saint-Germain-Beaupré"},
    {"city": "Saint-Goussaud"},
    {"city": "Saint-Hilaire-la-Plaine"},
    {"city": "Saint-Hilaire-le-Château"},
    {"city": "Saint-Julien-la-Genête"},
    {"city": "Saint-Julien-le-Châtel"},
    {"city": "Saint-Junien-la-Bregère"},
    {"city": "Saint-Laurent"},
    {"city": "Saint-Léger-Bridereix"},
    {"city": "Saint-Léger-le-Guérétois"},
    {"city": "Saint-Loup"},
    {"city": "Saint-Maixant"},
    {"city": "Saint-Marc-à-Frongier"},
    {"city": "Saint-Marc-à-Loubaud"},
    {"city": "Saint-Marien"},
    {"city": "Saint-Martial-le-Mont"},
    {"city": "Saint-Martial-le-Vieux"},
    {"city": "Saint-Martin-Château"},
    {"city": "Saint-Martin-Sainte-Catherine"},
    {"city": "Saint-Maurice-près-Crocq"},
    {"city": "Saint-Maurice-la-Souterraine"},
    {"city": "Saint-Médard-la-Rochette"},
    {"city": "Saint-Merd-la-Breuille"},
    {"city": "Saint-Michel-de-Veisse"},
    {"city": "Saint-Moreil"},
    {"city": "Saint-Oradoux-de-Chirouze"},
    {"city": "Saint-Oradoux-près-Crocq"},
    {"city": "Saint-Pardoux-d'Arnet"},
    {"city": "Saint-Pardoux-Morterolles"},
    {"city": "Saint-Pardoux-le-Neuf"},
    {"city": "Saint-Pardoux-les-Cards"},
    {"city": "Saint-Pierre-Chérignat"},
    {"city": "Saint-Pierre-Bellevue"},
    {"city": "Saint-Pierre-le-Bost"},
    {"city": "Saint-Priest"},
    {"city": "Saint-Priest-la-Feuille"},
    {"city": "Saint-Priest-la-Plaine"},
    {"city": "Saint-Priest-Palus"},
    {"city": "Saint-Quentin-la-Chabanne"},
    {"city": "Saint-Sébastien"},
    {"city": "Saint-Silvain-Bas-le-Roc"},
    {"city": "Saint-Silvain-Bellegarde"},
    {"city": "Saint-Silvain-Montaigut"},
    {"city": "Saint-Silvain-sous-Toulx"},
    {"city": "Saint-Sulpice-le-Dunois"},
    {"city": "Saint-Sulpice-le-Guérétois"},
    {"city": "Saint-Sulpice-les-Champs"},
    {"city": "Saint-Vaury"},
    {"city": "Saint-Victor-en-Marche"},
    {"city": "Saint-Yrieix-la-Montagne"},
    {"city": "Saint-Yrieix-les-Bois"},
    {"city": "Tardes"},
    {"city": "Tercillat"},
    {"city": "Thauron"},
    {"city": "Toulx-Sainte-Croix"},
    {"city": "Trois-Fonds"},
    {"city": "Vallière"},
    {"city": "Vareilles"},
    {"city": "Verneiges"},
    {"city": "Vidaillat"},
    {"city": "Viersat"},
    {"city": "Vigeville"},
    {"city": "Villard"},
    {"city": "La Villedieu"},
    {"city": "La Villeneuve"},
    {"city": "La Villetelle"},
    {"city": "Abjat-sur-Bandiat"},
    {"city": "Agonac"},
    {"city": "Ajat"},
    {"city": "Alles-sur-Dordogne"},
    {"city": "Allas-les-Mines"},
    {"city": "Allemans"},
    {"city": "Angoisse"},
    {"city": "Anlhiac"},
    {"city": "Annesse-et-Beaulieu"},
    {"city": "Antonne-et-Trigonant"},
    {"city": "Archignac"},
    {"city": "Aubas"},
    {"city": "Audrix"},
    {"city": "Augignac"},
    {"city": "Auriac-du-Périgord"},
    {"city": "Azerat"},
    {"city": "La Bachellerie"},
    {"city": "Badefols-d'Ans"},
    {"city": "Badefols-sur-Dordogne"},
    {"city": "Baneuil"},
    {"city": "Bardou"},
    {"city": "Bars"},
    {"city": "Bassillac et Auberoche"},
    {"city": "Bayac"},
    {"city": "Beaumontois en Périgord"},
    {"city": "Beaupouyet"},
    {"city": "Beauregard-de-Terrasson"},
    {"city": "Beauregard-et-Bassac"},
    {"city": "Beauronne"},
    {"city": "Beleymas"},
    {"city": "Pays de Belvès"},
    {"city": "Berbiguières"},
    {"city": "Bergerac"},
    {"city": "Bertric-Burée"},
    {"city": "Besse"},
    {"city": "Beynac-et-Cazenac"},
    {"city": "Biras"},
    {"city": "Biron"},
    {"city": "Boisse"},
    {"city": "Boisseuilh"},
    {"city": "Bonneville-et-Saint-Avit-de-Fumadières"},
    {"city": "Borrèze"},
    {"city": "Bosset"},
    {"city": "Bouillac"},
    {"city": "Boulazac Isle Manoire"},
    {"city": "Bouniagues"},
    {"city": "Bourdeilles"},
    {"city": "Le Bourdeix"},
    {"city": "Bourg-des-Maisons"},
    {"city": "Bourg-du-Bost"},
    {"city": "Bourgnac"},
    {"city": "Bourniquel"},
    {"city": "Bourrou"},
    {"city": "Bouteilles-Saint-Sébastien"},
    {"city": "Bouzic"},
    {"city": "Brantôme en Périgord"},
    {"city": "Brouchaud"},
    {"city": "Le Bugue"},
    {"city": "Le Buisson-de-Cadouin"},
    {"city": "Bussac"},
    {"city": "Busserolles"},
    {"city": "Bussière-Badil"},
    {"city": "Calès"},
    {"city": "Calviac-en-Périgord"},
    {"city": "Campagnac-lès-Quercy"},
    {"city": "Campagne"},
    {"city": "Campsegret"},
    {"city": "Capdrot"},
    {"city": "Carlux"},
    {"city": "Carsac-Aillac"},
    {"city": "Carsac-de-Gurson"},
    {"city": "Carves"},
    {"city": "La Cassagne"},
    {"city": "Castelnaud-la-Chapelle"},
    {"city": "Castels et Bézenac"},
    {"city": "Cause-de-Clérans"},
    {"city": "Cazoulès"},
    {"city": "Celles"},
    {"city": "Cénac-et-Saint-Julien"},
    {"city": "Chalagnac"},
    {"city": "Chalais"},
    {"city": "Champagnac-de-Belair"},
    {"city": "Champagne-et-Fontaine"},
    {"city": "Champcevinel"},
    {"city": "Champniers-et-Reilhac"},
    {"city": "Champs-Romain"},
    {"city": "Chancelade"},
    {"city": "Chantérac"},
    {"city": "Chapdeuil"},
    {"city": "La Chapelle-Aubareil"},
    {"city": "La Chapelle-Faucher"},
    {"city": "La Chapelle-Gonaguet"},
    {"city": "La Chapelle-Grésignac"},
    {"city": "La Chapelle-Montabourlet"},
    {"city": "La Chapelle-Montmoreau"},
    {"city": "La Chapelle-Saint-Jean"},
    {"city": "Chassaignes"},
    {"city": "Château-l'Évêque"},
    {"city": "Châtres"},
    {"city": "Les Coteaux Périgourdins"},
    {"city": "Cherval"},
    {"city": "Cherveix-Cubas"},
    {"city": "Chourgnac"},
    {"city": "Cladech"},
    {"city": "Clermont-de-Beauregard"},
    {"city": "Clermont-d'Excideuil"},
    {"city": "Colombier"},
    {"city": "Comberanche-et-Épeluche"},
    {"city": "Condat-sur-Trincou"},
    {"city": "Condat-sur-Vézère"},
    {"city": "Connezac"},
    {"city": "Conne-de-Labarde"},
    {"city": "La Coquille"},
    {"city": "Corgnac-sur-l'Isle"},
    {"city": "Cornille"},
    {"city": "Coubjours"},
    {"city": "Coulaures"},
    {"city": "Coulounieix-Chamiers"},
    {"city": "Coursac"},
    {"city": "Cours-de-Pile"},
    {"city": "Coutures"},
    {"city": "Coux et Bigaroque-Mouzens"},
    {"city": "Couze-et-Saint-Front"},
    {"city": "Creyssac"},
    {"city": "Creysse"},
    {"city": "Creyssensac-et-Pissot"},
    {"city": "Cubjac-Auvézère-Val d'Ans"},
    {"city": "Cunèges"},
    {"city": "Daglan"},
    {"city": "Doissat"},
    {"city": "Domme"},
    {"city": "La Dornac"},
    {"city": "Douchapt"},
    {"city": "Douville"},
    {"city": "La Douze"},
    {"city": "Douzillac"},
    {"city": "Dussac"},
    {"city": "Échourgnac"},
    {"city": "Église-Neuve-de-Vergt"},
    {"city": "Église-Neuve-d'Issac"},
    {"city": "Escoire"},
    {"city": "Étouars"},
    {"city": "Excideuil"},
    {"city": "Eygurande-et-Gardedeuil"},
    {"city": "Eymet"},
    {"city": "Plaisance"},
    {"city": "Eyzerac"},
    {"city": "Les Eyzies"},
    {"city": "Fanlac"},
    {"city": "Les Farges"},
    {"city": "Faurilles"},
    {"city": "Faux"},
    {"city": "La Feuillade"},
    {"city": "Firbeix"},
    {"city": "Le Fleix"},
    {"city": "Fleurac"},
    {"city": "Florimont-Gaumier"},
    {"city": "Fonroque"},
    {"city": "Fossemagne"},
    {"city": "Fougueyrolles"},
    {"city": "Fouleix"},
    {"city": "Fraisse"},
    {"city": "Gabillou"},
    {"city": "Gageac-et-Rouillac"},
    {"city": "Gardonne"},
    {"city": "Gaugeac"},
    {"city": "Génis"},
    {"city": "Ginestet"},
    {"city": "Gout-Rossignol"},
    {"city": "Grand-Brassac"},
    {"city": "Granges-d'Ans"},
    {"city": "Grignols"},
    {"city": "Grives"},
    {"city": "Groléjac"},
    {"city": "Grun-Bordas"},
    {"city": "Hautefaye"},
    {"city": "Hautefort"},
    {"city": "Issac"},
    {"city": "Issigeac"},
    {"city": "Jaure"},
    {"city": "Javerlhac-et-la-Chapelle-Saint-Robert"},
    {"city": "Jayac"},
    {"city": "La Jemaye-Ponteyraud"},
    {"city": "Journiac"},
    {"city": "Jumilhac-le-Grand"},
    {"city": "Lacropte"},
    {"city": "Rudeau-Ladosse"},
    {"city": "La Force"},
    {"city": "Lalinde"},
    {"city": "Lamonzie-Montastruc"},
    {"city": "Lamonzie-Saint-Martin"},
    {"city": "Lamothe-Montravel"},
    {"city": "Lanouaille"},
    {"city": "Lanquais"},
    {"city": "Le Lardin-Saint-Lazare"},
    {"city": "Larzac"},
    {"city": "Lavalade"},
    {"city": "Lavaur"},
    {"city": "Les Lèches"},
    {"city": "Léguillac-de-l'Auche"},
    {"city": "Lembras"},
    {"city": "Lempzours"},
    {"city": "Limeuil"},
    {"city": "Limeyrat"},
    {"city": "Liorac-sur-Louyre"},
    {"city": "Lisle"},
    {"city": "Lolme"},
    {"city": "Loubejac"},
    {"city": "Lunas"},
    {"city": "Lusignac"},
    {"city": "Lussas-et-Nontronneau"},
    {"city": "Manzac-sur-Vern"},
    {"city": "Marcillac-Saint-Quentin"},
    {"city": "Mareuil en Périgord"},
    {"city": "Marnac"},
    {"city": "Marquay"},
    {"city": "Marsac-sur-l'Isle"},
    {"city": "Marsalès"},
    {"city": "Eyraud-Crempse-Maurens"},
    {"city": "Mauzac-et-Grand-Castang"},
    {"city": "Mauzens-et-Miremont"},
    {"city": "Mayac"},
    {"city": "Mazeyrolles"},
    {"city": "Ménesplet"},
    {"city": "Mensignac"},
    {"city": "Mescoules"},
    {"city": "Meyrals"},
    {"city": "Mialet"},
    {"city": "Milhac-de-Nontron"},
    {"city": "Minzac"},
    {"city": "Molières"},
    {"city": "Monbazillac"},
    {"city": "Monestier"},
    {"city": "Monfaucon"},
    {"city": "Monmadalès"},
    {"city": "Monmarvès"},
    {"city": "Monpazier"},
    {"city": "Monsac"},
    {"city": "Monsaguel"},
    {"city": "Montagnac-d'Auberoche"},
    {"city": "Montagnac-la-Crempse"},
    {"city": "Montagrier"},
    {"city": "Montaut"},
    {"city": "Montazeau"},
    {"city": "Montcaret"},
    {"city": "Montferrand-du-Périgord"},
    {"city": "Montignac"},
    {"city": "Montpeyroux"},
    {"city": "Monplaisant"},
    {"city": "Montpon-Ménestérol"},
    {"city": "Montrem"},
    {"city": "Mouleydier"},
    {"city": "Moulin-Neuf"},
    {"city": "Mussidan"},
    {"city": "Nabirat"},
    {"city": "Nadaillac"},
    {"city": "Nailhac"},
    {"city": "Nanteuil-Auriac-de-Bourzac"},
    {"city": "Nantheuil"},
    {"city": "Nanthiat"},
    {"city": "Nastringues"},
    {"city": "Naussannes"},
    {"city": "Négrondes"},
    {"city": "Neuvic"},
    {"city": "Nontron"},
    {"city": "Sanilhac"},
    {"city": "Orliac"},
    {"city": "Orliaguet"},
    {"city": "Parcoul-Chenaud"},
    {"city": "Paulin"},
    {"city": "Paunat"},
    {"city": "Paussac-et-Saint-Vivien"},
    {"city": "Payzac"},
    {"city": "Pazayac"},
    {"city": "Périgueux"},
    {"city": "Petit-Bersac"},
    {"city": "Peyrignac"},
    {"city": "Peyrillac-et-Millac"},
    {"city": "Peyzac-le-Moustier"},
    {"city": "Pezuls"},
    {"city": "Piégut-Pluviers"},
    {"city": "Le Pizou"},
    {"city": "Plazac"},
    {"city": "Pomport"},
    {"city": "Pontours"},
    {"city": "Port-Sainte-Foy-et-Ponchapt"},
    {"city": "Prats-de-Carlux"},
    {"city": "Prats-du-Périgord"},
    {"city": "Pressignac-Vicq"},
    {"city": "Preyssac-d'Excideuil"},
    {"city": "Prigonrieux"},
    {"city": "Proissans"},
    {"city": "Queyssac"},
    {"city": "Quinsac"},
    {"city": "Rampieux"},
    {"city": "Razac-d'Eymet"},
    {"city": "Razac-de-Saussignac"},
    {"city": "Razac-sur-l'Isle"},
    {"city": "Ribagnac"},
    {"city": "Ribérac"},
    {"city": "La Rochebeaucourt-et-Argentine"},
    {"city": "La Roche-Chalais"},
    {"city": "La Roque-Gageac"},
    {"city": "Rouffignac-Saint-Cernin-de-Reilhac"},
    {"city": "Rouffignac-de-Sigoulès"},
    {"city": "Sadillac"},
    {"city": "Sagelat"},
    {"city": "Saint-Agne"},
    {"city": "Val de Louyre et Caudeau"},
    {"city": "Coly-Saint-Amand"},
    {"city": "Saint-Amand-de-Vergt"},
    {"city": "Saint-André-d'Allas"},
    {"city": "Saint-André-de-Double"},
    {"city": "Saint-Antoine-de-Breuilh"},
    {"city": "Saint-Aquilin"},
    {"city": "Saint-Astier"},
    {"city": "Saint-Aubin-de-Cadelech"},
    {"city": "Saint-Aubin-de-Lanquais"},
    {"city": "Saint-Aubin-de-Nabirat"},
    {"city": "Saint Aulaye-Puymangou"},
    {"city": "Saint-Avit-de-Vialard"},
    {"city": "Saint-Avit-Rivière"},
    {"city": "Saint-Avit-Sénieur"},
    {"city": "Saint-Barthélemy-de-Bellegarde"},
    {"city": "Saint-Barthélemy-de-Bussière"},
    {"city": "Saint-Capraise-de-Lalinde"},
    {"city": "Saint-Capraise-d'Eymet"},
    {"city": "Saint-Cassien"},
    {"city": "Saint-Cernin-de-Labarde"},
    {"city": "Saint-Cernin-de-l'Herm"},
    {"city": "Saint-Chamassy"},
    {"city": "Saint-Crépin-d'Auberoche"},
    {"city": "Saint-Crépin-et-Carlucet"},
    {"city": "Sainte-Croix"},
    {"city": "Sainte-Croix-de-Mareuil"},
    {"city": "Saint-Cybranet"},
    {"city": "Saint-Cyprien"},
    {"city": "Saint-Cyr-les-Champagnes"},
    {"city": "Saint-Estèphe"},
    {"city": "Saint-Étienne-de-Puycorbier"},
    {"city": "Sainte-Eulalie-d'Ans"},
    {"city": "Saint-Félix-de-Bourdeilles"},
    {"city": "Saint-Félix-de-Reillac-et-Mortemart"},
    {"city": "Saint-Félix-de-Villadeix"},
    {"city": "Sainte-Foy-de-Belvès"},
    {"city": "Sainte-Foy-de-Longas"},
    {"city": "Saint-Front-d'Alemps"},
    {"city": "Saint-Front-de-Pradoux"},
    {"city": "Saint-Front-la-Rivière"},
    {"city": "Saint-Front-sur-Nizonne"},
    {"city": "Saint-Geniès"},
    {"city": "Saint-Georges-Blancaneix"},
    {"city": "Saint-Georges-de-Montclard"},
    {"city": "Saint-Géraud-de-Corps"},
    {"city": "Saint-Germain-de-Belvès"},
    {"city": "Saint-Germain-des-Prés"},
    {"city": "Saint-Germain-du-Salembre"},
    {"city": "Saint-Germain-et-Mons"},
    {"city": "Saint-Géry"},
    {"city": "Saint-Geyrac"},
    {"city": "Saint-Hilaire-d'Estissac"},
    {"city": "Saint-Julien-Innocence-Eulalie"},
    {"city": "Saint-Jean-d'Ataux"},
    {"city": "Saint-Jean-de-Côle"},
    {"city": "Saint-Jean-d'Estissac"},
    {"city": "Saint-Jory-de-Chalais"},
    {"city": "Saint-Jory-las-Bloux"},
    {"city": "Saint-Julien-de-Lampon"},
    {"city": "Saint-Just"},
    {"city": "Saint-Laurent-des-Hommes"},
    {"city": "Saint-Laurent-des-Vignes"},
    {"city": "Saint-Laurent-la-Vallée"},
    {"city": "Saint-Léon-d'Issigeac"},
    {"city": "Saint-Léon-sur-l'Isle"},
    {"city": "Saint-Léon-sur-Vézère"},
    {"city": "Saint-Louis-en-l'Isle"},
    {"city": "Saint-Marcel-du-Périgord"},
    {"city": "Saint-Marcory"},
    {"city": "Saint-Martial-d'Albarède"},
    {"city": "Saint-Martial-d'Artenset"},
    {"city": "Saint-Martial-de-Nabirat"},
    {"city": "Saint-Martial-de-Valette"},
    {"city": "Saint-Martial-Viveyrol"},
    {"city": "Saint-Martin-de-Fressengeas"},
    {"city": "Saint-Martin-de-Gurson"},
    {"city": "Saint-Martin-de-Ribérac"},
    {"city": "Saint-Martin-des-Combes"},
    {"city": "Saint-Martin-l'Astier"},
    {"city": "Saint-Martin-le-Pin"},
    {"city": "Saint-Maime-de-Péreyrol"},
    {"city": "Saint-Méard-de-Drône"},
    {"city": "Saint-Méard-de-Gurçon"},
    {"city": "Saint-Médard-de-Mussidan"},
    {"city": "Saint-Médard-d'Excideuil"},
    {"city": "Saint-Mesmin"},
    {"city": "Saint-Michel-de-Double"},
    {"city": "Saint-Michel-de-Montaigne"},
    {"city": "Saint-Michel-de-Villadeix"},
    {"city": "Sainte-Mondane"},
    {"city": "Sainte-Nathalène"},
    {"city": "Saint-Nexans"},
    {"city": "Sainte-Orse"},
    {"city": "Saint-Pancrace"},
    {"city": "Saint-Pantaly-d'Excideuil"},
    {"city": "Saint-Pardoux-de-Drône"},
    {"city": "Saint-Pardoux-et-Vielvic"},
    {"city": "Saint-Pardoux-la-Rivière"},
    {"city": "Saint-Paul-de-Serre"},
    {"city": "Saint-Paul-la-Roche"},
    {"city": "Saint-Paul-Lizonne"},
    {"city": "Saint-Perdoux"},
    {"city": "Saint-Pierre-de-Chignac"},
    {"city": "Saint-Pierre-de-Côle"},
    {"city": "Saint-Pierre-de-Frugie"},
    {"city": "Saint-Pierre-d'Eyraud"},
    {"city": "Saint-Pompont"},
    {"city": "Saint-Priest-les-Fougères"},
    {"city": "Saint Privat en Périgord"},
    {"city": "Saint-Rabier"},
    {"city": "Sainte-Radegonde"},
    {"city": "Saint-Raphaël"},
    {"city": "Saint-Rémy"},
    {"city": "Saint-Romain-de-Monpazier"},
    {"city": "Saint-Romain-et-Saint-Clément"},
    {"city": "Saint-Saud-Lacoussière"},
    {"city": "Saint-Sauveur"},
    {"city": "Saint-Sauveur-Lalande"},
    {"city": "Saint-Seurin-de-Prats"},
    {"city": "Saint-Séverin-d'Estissac"},
    {"city": "Saint-Sulpice-de-Roumagnac"},
    {"city": "Saint-Sulpice-d'Excideuil"},
    {"city": "Sainte-Trie"},
    {"city": "Saint-Victor"},
    {"city": "Saint-Vincent-de-Connezac"},
    {"city": "Saint-Vincent-de-Cosse"},
    {"city": "Saint-Vincent-Jalmoutiers"},
    {"city": "Saint-Vincent-le-Paluel"},
    {"city": "Saint-Vincent-sur-l'Isle"},
    {"city": "Saint-Vivien"},
    {"city": "Salagnac"},
    {"city": "Salignac-Eyvigues"},
    {"city": "Salles-de-Belvès"},
    {"city": "Salon"},
    {"city": "Sarlande"},
    {"city": "Sarlat-la-Canéda"},
    {"city": "Sarliac-sur-l'Isle"},
    {"city": "Sarrazac"},
    {"city": "Saussignac"},
    {"city": "Savignac-de-Miremont"},
    {"city": "Savignac-de-Nontron"},
    {"city": "Savignac-Lédrier"},
    {"city": "Savignac-les-Églises"},
    {"city": "Sceau-Saint-Angel"},
    {"city": "Segonzac"},
    {"city": "Sergeac"},
    {"city": "Serres-et-Montguyard"},
    {"city": "Servanches"},
    {"city": "Sigoulès-et-Flaugeac"},
    {"city": "Simeyrols"},
    {"city": "Singleyrac"},
    {"city": "Siorac-de-Ribérac"},
    {"city": "Siorac-en-Périgord"},
    {"city": "Sorges et Ligueux en Périgord"},
    {"city": "Soudat"},
    {"city": "Soulaures"},
    {"city": "Sourzac"},
    {"city": "Tamniès"},
    {"city": "Teillots"},
    {"city": "Temple-Laguyon"},
    {"city": "Terrasson-Lavilledieu"},
    {"city": "Teyjat"},
    {"city": "Thénac"},
    {"city": "Thenon"},
    {"city": "Thiviers"},
    {"city": "Thonac"},
    {"city": "Tocane-Saint-Apre"},
    {"city": "La Tour-Blanche-Cercles"},
    {"city": "Tourtoirac"},
    {"city": "Trélissac"},
    {"city": "Trémolat"},
    {"city": "Tursac"},
    {"city": "Urval"},
    {"city": "Vallereuil"},
    {"city": "Valojoulx"},
    {"city": "Vanxains"},
    {"city": "Varaignes"},
    {"city": "Varennes"},
    {"city": "Vaunac"},
    {"city": "Vélines"},
    {"city": "Vendoire"},
    {"city": "Verdon"},
    {"city": "Vergt"},
    {"city": "Vergt-de-Biron"},
    {"city": "Verteillac"},
    {"city": "Veyrignac"},
    {"city": "Veyrines-de-Domme"},
    {"city": "Veyrines-de-Vergt"},
    {"city": "Vézac"},
    {"city": "Villac"},
    {"city": "Villamblard"},
    {"city": "Villars"},
    {"city": "Villefranche-de-Lonchat"},
    {"city": "Villefranche-du-Périgord"},
    {"city": "Villetoureix"},
    {"city": "Vitrac"},
    {"city": "Abbans-Dessous"},
    {"city": "Abbans-Dessus"},
    {"city": "Abbenans"},
    {"city": "Abbévillers"},
    {"city": "Accolans"},
    {"city": "Adam-lès-Passavant"},
    {"city": "Adam-lès-Vercel"},
    {"city": "Aibre"},
    {"city": "Aïssey"},
    {"city": "Allenjoie"},
    {"city": "Les Alliés"},
    {"city": "Allondans"},
    {"city": "Amagney"},
    {"city": "Amancey"},
    {"city": "Amathay-Vésigneux"},
    {"city": "Amondans"},
    {"city": "Anteuil"},
    {"city": "Appenans"},
    {"city": "Arbouans"},
    {"city": "Arc-et-Senans"},
    {"city": "Arcey"},
    {"city": "Arçon"},
    {"city": "Arc-sous-Cicon"},
    {"city": "Arc-sous-Montenot"},
    {"city": "Aubonne"},
    {"city": "Audeux"},
    {"city": "Audincourt"},
    {"city": "Autechaux"},
    {"city": "Autechaux-Roide"},
    {"city": "Les Auxons"},
    {"city": "Avanne-Aveney"},
    {"city": "Avilley"},
    {"city": "Avoudrey"},
    {"city": "Badevel"},
    {"city": "Bannans"},
    {"city": "Le Barboux"},
    {"city": "Bart"},
    {"city": "Bartherans"},
    {"city": "Battenans-les-Mines"},
    {"city": "Battenans-Varin"},
    {"city": "Baume-les-Dames"},
    {"city": "Bavans"},
    {"city": "Belfays"},
    {"city": "Le Bélieu"},
    {"city": "Belleherbe"},
    {"city": "Belmont"},
    {"city": "Belvoir"},
    {"city": "Berche"},
    {"city": "Berthelange"},
    {"city": "Besançon"},
    {"city": "Bethoncourt"},
    {"city": "Beure"},
    {"city": "Beutal"},
    {"city": "Bians-les-Usiers"},
    {"city": "Bief"},
    {"city": "Le Bizot"},
    {"city": "Blamont"},
    {"city": "Blarians"},
    {"city": "Blussangeaux"},
    {"city": "Blussans"},
    {"city": "Bolandoz"},
    {"city": "Bondeval"},
    {"city": "Bonnal"},
    {"city": "Bonnay"},
    {"city": "Bonnétage"},
    {"city": "Bonnevaux"},
    {"city": "La Bosse"},
    {"city": "Bouclans"},
    {"city": "Boujailles"},
    {"city": "Bourguignon"},
    {"city": "Bournois"},
    {"city": "Boussières"},
    {"city": "Bouverans"},
    {"city": "Braillans"},
    {"city": "Branne"},
    {"city": "Breconchaux"},
    {"city": "Bremondans"},
    {"city": "Brères"},
    {"city": "Les Bréseux"},
    {"city": "La Bretenière"},
    {"city": "Bretigney"},
    {"city": "Bretigney-Notre-Dame"},
    {"city": "Bretonvillers"},
    {"city": "Brey-et-Maison-du-Bois"},
    {"city": "Brognard"},
    {"city": "Buffard"},
    {"city": "Bugny"},
    {"city": "Bulle"},
    {"city": "Burgille"},
    {"city": "Burnevillers"},
    {"city": "Busy"},
    {"city": "By"},
    {"city": "Byans-sur-Doubs"},
    {"city": "Cademène"},
    {"city": "Cendrey"},
    {"city": "Cernay-l'Église"},
    {"city": "Cessey"},
    {"city": "Chaffois"},
    {"city": "Chalèze"},
    {"city": "Chalezeule"},
    {"city": "Chamesey"},
    {"city": "Chamesol"},
    {"city": "Champagney"},
    {"city": "Champlive"},
    {"city": "Champoux"},
    {"city": "Champvans-les-Moulins"},
    {"city": "Chantrans"},
    {"city": "Chapelle-des-Bois"},
    {"city": "Chapelle-d'Huin"},
    {"city": "Charmauvillers"},
    {"city": "Charmoille"},
    {"city": "Charnay"},
    {"city": "Charquemont"},
    {"city": "Chassagne-Saint-Denis"},
    {"city": "Châteauvieux-les-Fossés"},
    {"city": "Châtelblanc"},
    {"city": "Châtillon-Guyotte"},
    {"city": "Châtillon-le-Duc"},
    {"city": "Châtillon-sur-Lison"},
    {"city": "Chaucenne"},
    {"city": "Les Terres-de-Chaux"},
    {"city": "La Chaux"},
    {"city": "Chaux-lès-Passavant"},
    {"city": "Chaux-Neuve"},
    {"city": "Chay"},
    {"city": "Chazot"},
    {"city": "Chemaudin et Vaux"},
    {"city": "La Chenalotte"},
    {"city": "Chenecey-Buillon"},
    {"city": "Chevigney-sur-l'Ognon"},
    {"city": "Chevigney-lès-Vercel"},
    {"city": "La Chevillotte"},
    {"city": "Chevroz"},
    {"city": "Chouzelot"},
    {"city": "Cléron"},
    {"city": "Pays-de-Clerval"},
    {"city": "La Cluse-et-Mijoux"},
    {"city": "Colombier-Fontaine"},
    {"city": "Les Combes"},
    {"city": "Consolation-Maisonnettes"},
    {"city": "Corcelles-Ferrières"},
    {"city": "Corcelle-Mieslot"},
    {"city": "Corcondray"},
    {"city": "Côtebrune"},
    {"city": "Courcelles-lès-Montbéliard"},
    {"city": "Courcelles"},
    {"city": "Courchapon"},
    {"city": "Cour-Saint-Maurice"},
    {"city": "Courtefontaine"},
    {"city": "Courtetain-et-Salans"},
    {"city": "Courvières"},
    {"city": "Crosey-le-Grand"},
    {"city": "Crosey-le-Petit"},
    {"city": "Le Crouzet"},
    {"city": "Crouzet-Migette"},
    {"city": "Cubrial"},
    {"city": "Cubry"},
    {"city": "Cusance"},
    {"city": "Cuse-et-Adrisans"},
    {"city": "Cussey-sur-Lison"},
    {"city": "Cussey-sur-l'Ognon"},
    {"city": "Dambelin"},
    {"city": "Dambenois"},
    {"city": "Dammartin-les-Templiers"},
    {"city": "Dampierre-les-Bois"},
    {"city": "Dampierre-sur-le-Doubs"},
    {"city": "Dampjoux"},
    {"city": "Damprichard"},
    {"city": "Dannemarie"},
    {"city": "Dannemarie-sur-Crète"},
    {"city": "Dasle"},
    {"city": "Deluz"},
    {"city": "Désandans"},
    {"city": "Déservillers"},
    {"city": "Devecey"},
    {"city": "Dommartin"},
    {"city": "Dompierre-les-Tilleuls"},
    {"city": "Domprel"},
    {"city": "Doubs"},
    {"city": "Dung"},
    {"city": "Durnes"},
    {"city": "Échay"},
    {"city": "Échenans"},
    {"city": "Échevannes"},
    {"city": "École-Valentin"},
    {"city": "Les Écorces"},
    {"city": "Écot"},
    {"city": "L'Écouvotte"},
    {"city": "Écurcey"},
    {"city": "Émagny"},
    {"city": "Épenouse"},
    {"city": "Épenoy"},
    {"city": "Épeugney"},
    {"city": "Esnans"},
    {"city": "Étalans"},
    {"city": "Éternoz"},
    {"city": "Étouvans"},
    {"city": "Étrabonne"},
    {"city": "Étrappe"},
    {"city": "Étray"},
    {"city": "Étupes"},
    {"city": "Évillers"},
    {"city": "Exincourt"},
    {"city": "Eysson"},
    {"city": "Faimbe"},
    {"city": "Fallerans"},
    {"city": "Ferrières-le-Lac"},
    {"city": "Ferrières-les-Bois"},
    {"city": "Fertans"},
    {"city": "Fesches-le-Châtel"},
    {"city": "Fessevillers"},
    {"city": "Feule"},
    {"city": "Les Fins"},
    {"city": "Flagey"},
    {"city": "Flagey-Rigney"},
    {"city": "Flangebouche"},
    {"city": "Fleurey"},
    {"city": "Fontain"},
    {"city": "Fontaine-lès-Clerval"},
    {"city": "Fontenelle-Montby"},
    {"city": "Les Fontenelles"},
    {"city": "Fontenotte"},
    {"city": "Fourbanne"},
    {"city": "Fourcatier-et-Maison-Neuve"},
    {"city": "Fourg"},
    {"city": "Les Fourgs"},
    {"city": "Fournet-Blancheroche"},
    {"city": "Frambouhans"},
    {"city": "Franey"},
    {"city": "Franois"},
    {"city": "Frasne"},
    {"city": "Froidevaux"},
    {"city": "Fuans"},
    {"city": "Gellin"},
    {"city": "Gémonval"},
    {"city": "Geneuille"},
    {"city": "Geney"},
    {"city": "Gennes"},
    {"city": "Germéfontaine"},
    {"city": "Germondans"},
    {"city": "Gevresin"},
    {"city": "Gilley"},
    {"city": "Glamondans"},
    {"city": "Glay"},
    {"city": "Glère"},
    {"city": "Gondenans-Montby"},
    {"city": "Gondenans-les-Moulins"},
    {"city": "Gonsans"},
    {"city": "Gouhelans"},
    {"city": "Goumois"},
    {"city": "Goux-lès-Dambelin"},
    {"city": "Goux-les-Usiers"},
    {"city": "Goux-sous-Landet"},
    {"city": "Grand-Charmont"},
    {"city": "Grand'Combe-Châteleu"},
    {"city": "Grand'Combe-des-Bois"},
    {"city": "Grandfontaine"},
    {"city": "Fournets-Luisans"},
    {"city": "Grandfontaine-sur-Creuse"},
    {"city": "La Grange"},
    {"city": "Granges-Narboz"},
    {"city": "Les Grangettes"},
    {"city": "Les Gras"},
    {"city": "Le Gratteris"},
    {"city": "Grosbois"},
    {"city": "Guillon-les-Bains"},
    {"city": "Guyans-Durnes"},
    {"city": "Guyans-Vennes"},
    {"city": "Hauterive-la-Fresse"},
    {"city": "Hérimoncourt"},
    {"city": "L'Hôpital-du-Grosbois"},
    {"city": "L'Hôpital-Saint-Lieffroy"},
    {"city": "Les Hôpitaux-Neufs"},
    {"city": "Les Hôpitaux-Vieux"},
    {"city": "Houtaud"},
    {"city": "Huanne-Montmartin"},
    {"city": "Hyémondans"},
    {"city": "Hyèvre-Magny"},
    {"city": "Hyèvre-Paroisse"},
    {"city": "Indevillers"},
    {"city": "L'Isle-sur-le-Doubs"},
    {"city": "Issans"},
    {"city": "Jallerange"},
    {"city": "Jougne"},
    {"city": "Labergement-Sainte-Marie"},
    {"city": "Villers-le-Lac"},
    {"city": "Laire"},
    {"city": "Laissey"},
    {"city": "Lanans"},
    {"city": "Landresse"},
    {"city": "Lantenne-Vertière"},
    {"city": "Lanthenans"},
    {"city": "Larnod"},
    {"city": "Laval-le-Prieuré"},
    {"city": "Lavans-Quingey"},
    {"city": "Lavans-Vuillafans"},
    {"city": "Lavernay"},
    {"city": "Laviron"},
    {"city": "Levier"},
    {"city": "Liebvillers"},
    {"city": "Liesle"},
    {"city": "Lizine"},
    {"city": "Lods"},
    {"city": "Lombard"},
    {"city": "Lomont-sur-Crête"},
    {"city": "Longechaux"},
    {"city": "Longemaison"},
    {"city": "Longevelle-lès-Russey"},
    {"city": "Longevelle-sur-Doubs"},
    {"city": "Longeville"},
    {"city": "La Longeville"},
    {"city": "Longevilles-Mont-d'Or"},
    {"city": "Loray"},
    {"city": "Lougres"},
    {"city": "Le Luhier"},
    {"city": "Luxiol"},
    {"city": "Magny-Châtelard"},
    {"city": "Maîche"},
    {"city": "Maisons-du-Bois-Lièvremont"},
    {"city": "Malans"},
    {"city": "Malbrans"},
    {"city": "Malbuisson"},
    {"city": "Malpas"},
    {"city": "Mamirolle"},
    {"city": "Mancenans"},
    {"city": "Mancenans-Lizerne"},
    {"city": "Mandeure"},
    {"city": "Marchaux-Chaudefontaine"},
    {"city": "Marvelise"},
    {"city": "Mathay"},
    {"city": "Mazerolles-le-Salin"},
    {"city": "Médière"},
    {"city": "Le Mémont"},
    {"city": "Mercey-le-Grand"},
    {"city": "Mérey-sous-Montrond"},
    {"city": "Mérey-Vieilley"},
    {"city": "Mésandans"},
    {"city": "Meslières"},
    {"city": "Mesmay"},
    {"city": "Métabief"},
    {"city": "Miserey-Salines"},
    {"city": "Moncey"},
    {"city": "Moncley"},
    {"city": "Mondon"},
    {"city": "Montagney-Servigney"},
    {"city": "Montancy"},
    {"city": "Montandon"},
    {"city": "Montbéliard"},
    {"city": "Montbéliardot"},
    {"city": "Montbenoît"},
    {"city": "Mont-de-Laval"},
    {"city": "Mont-de-Vougney"},
    {"city": "Montécheroux"},
    {"city": "Montenois"},
    {"city": "Montfaucon"},
    {"city": "Montferrand-le-Château"},
    {"city": "Montflovin"},
    {"city": "Montgesoye"},
    {"city": "Montivernage"},
    {"city": "Montjoie-le-Château"},
    {"city": "Montlebon"},
    {"city": "Montmahoux"},
    {"city": "Montperreux"},
    {"city": "Montrond-le-Château"},
    {"city": "Montussaint"},
    {"city": "Morre"},
    {"city": "Morteau"},
    {"city": "Mouthe"},
    {"city": "Le Moutherot"},
    {"city": "Mouthier-Haute-Pierre"},
    {"city": "Myon"},
    {"city": "Naisey-les-Granges"},
    {"city": "Nancray"},
    {"city": "Nans"},
    {"city": "Nans-sous-Sainte-Anne"},
    {"city": "Narbief"},
    {"city": "Neuchâtel-Urtière"},
    {"city": "Les Premiers Sapins"},
    {"city": "Noël-Cerneux"},
    {"city": "Noirefontaine"},
    {"city": "Noironte"},
    {"city": "Nommay"},
    {"city": "Novillars"},
    {"city": "Ollans"},
    {"city": "Onans"},
    {"city": "Orchamps-Vennes"},
    {"city": "Orgeans-Blanchefontaine"},
    {"city": "Ornans"},
    {"city": "Orsans"},
    {"city": "Orve"},
    {"city": "Osse"},
    {"city": "Osselle-Routelle"},
    {"city": "Ougney-Douvot"},
    {"city": "Ouhans"},
    {"city": "Ouvans"},
    {"city": "Oye-et-Pallet"},
    {"city": "Palantine"},
    {"city": "Palise"},
    {"city": "Paroy"},
    {"city": "Passavant"},
    {"city": "Passonfontaine"},
    {"city": "Pelousey"},
    {"city": "Péseux"},
    {"city": "Pessans"},
    {"city": "Petite-Chaux"},
    {"city": "Pierrefontaine-lès-Blamont"},
    {"city": "Pierrefontaine-les-Varans"},
    {"city": "Pirey"},
    {"city": "Placey"},
    {"city": "Plaimbois-du-Miroir"},
    {"city": "Plaimbois-Vennes"},
    {"city": "Les Plains-et-Grands-Essarts"},
    {"city": "La Planée"},
    {"city": "Le Val"},
    {"city": "Pompierre-sur-Doubs"},
    {"city": "Pontarlier"},
    {"city": "Pont-de-Roide-Vermondans"},
    {"city": "Les Pontets"},
    {"city": "Pont-les-Moulins"},
    {"city": "Pouilley-Français"},
    {"city": "Pouilley-les-Vignes"},
    {"city": "Pouligney-Lusans"},
    {"city": "Présentevillers"},
    {"city": "La Prétière"},
    {"city": "Provenchère"},
    {"city": "Puessans"},
    {"city": "Pugey"},
    {"city": "Le Puy"},
    {"city": "Quingey"},
    {"city": "Rahon"},
    {"city": "Rancenay"},
    {"city": "Randevillers"},
    {"city": "Rang"},
    {"city": "Raynans"},
    {"city": "Recologne"},
    {"city": "Reculfoz"},
    {"city": "Rémondans-Vaivre"},
    {"city": "Remoray-Boujeons"},
    {"city": "Renédale"},
    {"city": "Rennes-sur-Loue"},
    {"city": "Reugney"},
    {"city": "Rigney"},
    {"city": "Rignosot"},
    {"city": "Rillans"},
    {"city": "La Rivière-Drugeon"},
    {"city": "Rochejean"},
    {"city": "Roche-lez-Beaupré"},
    {"city": "Roche-lès-Clerval"},
    {"city": "Roches-lès-Blamont"},
    {"city": "Rognon"},
    {"city": "Romain"},
    {"city": "Ronchaux"},
    {"city": "Rondefontaine"},
    {"city": "Roset-Fluans"},
    {"city": "Rosières-sur-Barbèche"},
    {"city": "Rosureux"},
    {"city": "Rougemont"},
    {"city": "Rougemontot"},
    {"city": "Rouhe"},
    {"city": "Roulans"},
    {"city": "Ruffey-le-Château"},
    {"city": "Rurey"},
    {"city": "Le Russey"},
    {"city": "Sainte-Anne"},
    {"city": "Saint-Antoine"},
    {"city": "Sainte-Colombe"},
    {"city": "Saint-Georges-Armont"},
    {"city": "Saint-Gorgon-Main"},
    {"city": "Saint-Hilaire"},
    {"city": "Saint-Hippolyte"},
    {"city": "Saint-Juan"},
    {"city": "Saint-Julien-lès-Montbéliard"},
    {"city": "Saint-Julien-lès-Russey"},
    {"city": "Sainte-Marie"},
    {"city": "Saint-Maurice-Colombier"},
    {"city": "Saint-Point-Lac"},
    {"city": "Sainte-Suzanne"},
    {"city": "Saint-Vit"},
    {"city": "Samson"},
    {"city": "Sancey"},
    {"city": "Saône"},
    {"city": "Saraz"},
    {"city": "Sarrageois"},
    {"city": "Saules"},
    {"city": "Sauvagney"},
    {"city": "Scey-Maisières"},
    {"city": "Séchin"},
    {"city": "Seloncourt"},
    {"city": "Semondans"},
    {"city": "Septfontaines"},
    {"city": "Serre-les-Sapins"},
    {"city": "Servin"},
    {"city": "Silley-Amancey"},
    {"city": "Silley-Bléfond"},
    {"city": "Sochaux"},
    {"city": "Solemont"},
    {"city": "Sombacour"},
    {"city": "La Sommette"},
    {"city": "Soulce-Cernay"},
    {"city": "Sourans"},
    {"city": "Soye"},
    {"city": "Surmont"},
    {"city": "Taillecourt"},
    {"city": "Tallans"},
    {"city": "Tallenay"},
    {"city": "Tarcenay-Foucherans"},
    {"city": "Thiébouhans"},
    {"city": "Thise"},
    {"city": "Thoraise"},
    {"city": "Thulay"},
    {"city": "Thurey-le-Mont"},
    {"city": "Torpes"},
    {"city": "Touillon-et-Loutelet"},
    {"city": "La Tour-de-Sçay"},
    {"city": "Tournans"},
    {"city": "Trépot"},
    {"city": "Tressandans"},
    {"city": "Trévillers"},
    {"city": "Trouvans"},
    {"city": "Urtière"},
    {"city": "Uzelle"},
    {"city": "Vaire"},
    {"city": "Valdahon"},
    {"city": "Val-de-Roulans"},
    {"city": "Valentigney"},
    {"city": "Valleroy"},
    {"city": "Valonne"},
    {"city": "Valoreille"},
    {"city": "Vandoncourt"},
    {"city": "Vaucluse"},
    {"city": "Vauclusotte"},
    {"city": "Vaudrivillers"},
    {"city": "Vaufrey"},
    {"city": "Vaux-et-Chantegrue"},
    {"city": "Velesmes-Essarts"},
    {"city": "Vellerot-lès-Belvoir"},
    {"city": "Vellerot-lès-Vercel"},
    {"city": "Vellevans"},
    {"city": "Venise"},
    {"city": "Vennans"},
    {"city": "Vennes"},
    {"city": "Vercel-Villedieu-le-Camp"},
    {"city": "Vergranne"},
    {"city": "Verne"},
    {"city": "Vernierfontaine"},
    {"city": "Vernois-lès-Belvoir"},
    {"city": "Le Vernoy"},
    {"city": "Verrières-de-Joux"},
    {"city": "La Vèze"},
    {"city": "Vieilley"},
    {"city": "Viéthorey"},
    {"city": "Vieux-Charmont"},
    {"city": "Villars-lès-Blamont"},
    {"city": "Villars-Saint-Georges"},
    {"city": "Villars-sous-Dampjoux"},
    {"city": "Villars-sous-Écot"},
    {"city": "Les Villedieu"},
    {"city": "Ville-du-Pont"},
    {"city": "Villeneuve-d'Amont"},
    {"city": "Villers-Buzon"},
    {"city": "Villers-Chief"},
    {"city": "Villers-Grélot"},
    {"city": "Villers-la-Combe"},
    {"city": "Villers-Saint-Martin"},
    {"city": "Villers-sous-Chalamont"},
    {"city": "Villers-sous-Montrond"},
    {"city": "Voillans"},
    {"city": "Voires"},
    {"city": "Vorges-les-Pins"},
    {"city": "Voujeaucourt"},
    {"city": "Vuillafans"},
    {"city": "Vuillecin"},
    {"city": "Vyt-lès-Belvoir"},
    {"city": "Solaure en Diois"},
    {"city": "Albon"},
    {"city": "Aleyrac"},
    {"city": "Alixan"},
    {"city": "Allan"},
    {"city": "Allex"},
    {"city": "Ambonil"},
    {"city": "Ancône"},
    {"city": "Andancette"},
    {"city": "Anneyron"},
    {"city": "Aouste-sur-Sye"},
    {"city": "Arnayon"},
    {"city": "Arpavon"},
    {"city": "Arthémonay"},
    {"city": "Aubenasson"},
    {"city": "Aubres"},
    {"city": "Aucelon"},
    {"city": "Aulan"},
    {"city": "Aurel"},
    {"city": "La Répara-Auriples"},
    {"city": "Autichamp"},
    {"city": "Ballons"},
    {"city": "Barbières"},
    {"city": "Barcelonne"},
    {"city": "Barnave"},
    {"city": "Barret-de-Lioure"},
    {"city": "Barsac"},
    {"city": "Bathernay"},
    {"city": "La Bâtie-des-Fonds"},
    {"city": "La Bâtie-Rolland"},
    {"city": "La Baume-Cornillane"},
    {"city": "La Baume-de-Transit"},
    {"city": "La Baume-d'Hostun"},
    {"city": "Beaufort-sur-Gervanne"},
    {"city": "Beaumont-en-Diois"},
    {"city": "Beaumont-lès-Valence"},
    {"city": "Beaumont-Monteux"},
    {"city": "Beauregard-Baret"},
    {"city": "Beaurières"},
    {"city": "Beausemblant"},
    {"city": "Beauvallon"},
    {"city": "Beauvoisin"},
    {"city": "La Bégude-de-Mazenc"},
    {"city": "Bellecombe-Tarendol"},
    {"city": "Bellegarde-en-Diois"},
    {"city": "Bénivay-Ollon"},
    {"city": "Bésayes"},
    {"city": "Bésignan"},
    {"city": "Bézaudun-sur-Bîne"},
    {"city": "Bonlieu-sur-Roubion"},
    {"city": "Bouchet"},
    {"city": "Boulc"},
    {"city": "Bourdeaux"},
    {"city": "Bourg-de-Péage"},
    {"city": "Bourg-lès-Valence"},
    {"city": "Bouvante"},
    {"city": "Bouvières"},
    {"city": "Bren"},
    {"city": "Brette"},
    {"city": "Buis-les-Baronnies"},
    {"city": "Chabeuil"},
    {"city": "Chabrillan"},
    {"city": "Le Chaffal"},
    {"city": "Chalancon"},
    {"city": "Le Chalon"},
    {"city": "Chamaloc"},
    {"city": "Chamaret"},
    {"city": "Chanos-Curson"},
    {"city": "Chantemerle-les-Blés"},
    {"city": "Chantemerle-lès-Grignan"},
    {"city": "La Chapelle-en-Vercors"},
    {"city": "La Charce"},
    {"city": "Charens"},
    {"city": "Charmes-sur-l'Herbasse"},
    {"city": "Charols"},
    {"city": "Charpey"},
    {"city": "Chastel-Arnaud"},
    {"city": "Châteaudouble"},
    {"city": "Châteauneuf-de-Bordette"},
    {"city": "Châteauneuf-de-Galaure"},
    {"city": "Châteauneuf-sur-Isère"},
    {"city": "Châteauneuf-du-Rhône"},
    {"city": "Châtillon-en-Diois"},
    {"city": "Châtillon-Saint-Jean"},
    {"city": "Chatuzange-le-Goubet"},
    {"city": "Chaudebonne"},
    {"city": "La Chaudière"},
    {"city": "Chauvac-Laux-Montaux"},
    {"city": "Chavannes"},
    {"city": "Clansayes"},
    {"city": "Claveyson"},
    {"city": "Cléon-d'Andran"},
    {"city": "Clérieux"},
    {"city": "Cliousclat"},
    {"city": "Cobonne"},
    {"city": "Colonzelle"},
    {"city": "Combovin"},
    {"city": "Comps"},
    {"city": "Condillac"},
    {"city": "Condorcet"},
    {"city": "Cornillac"},
    {"city": "Cornillon-sur-l'Oule"},
    {"city": "La Coucourde"},
    {"city": "Crépol"},
    {"city": "Crest"},
    {"city": "Crozes-Hermitage"},
    {"city": "Crupies"},
    {"city": "Curnier"},
    {"city": "Die"},
    {"city": "Dieulefit"},
    {"city": "Divajeu"},
    {"city": "Donzère"},
    {"city": "Échevis"},
    {"city": "Épinouze"},
    {"city": "Érôme"},
    {"city": "Espeluche"},
    {"city": "Espenel"},
    {"city": "Establet"},
    {"city": "Étoile-sur-Rhône"},
    {"city": "Eurre"},
    {"city": "Eygalayes"},
    {"city": "Eygaliers"},
    {"city": "Eygluy-Escoulin"},
    {"city": "Eymeux"},
    {"city": "Eyroles"},
    {"city": "Eyzahut"},
    {"city": "Fay-le-Clos"},
    {"city": "Félines-sur-Rimandoule"},
    {"city": "Ferrassières"},
    {"city": "Val-Maravel"},
    {"city": "Francillon-sur-Roubion"},
    {"city": "La Garde-Adhémar"},
    {"city": "Génissieux"},
    {"city": "Geyssans"},
    {"city": "Gigors-et-Lozeron"},
    {"city": "Glandage"},
    {"city": "Le Grand-Serre"},
    {"city": "Grane"},
    {"city": "Les Granges-Gontardes"},
    {"city": "Grignan"},
    {"city": "Gumiane"},
    {"city": "Hauterives"},
    {"city": "Hostun"},
    {"city": "Izon-la-Bruisse"},
    {"city": "Jonchères"},
    {"city": "Laborel"},
    {"city": "Lachau"},
    {"city": "Lapeyrouse-Mornay"},
    {"city": "Larnage"},
    {"city": "La Laupie"},
    {"city": "Laval-d'Aix"},
    {"city": "Laveyron"},
    {"city": "Lemps"},
    {"city": "Lens-Lestang"},
    {"city": "Léoncel"},
    {"city": "Lesches-en-Diois"},
    {"city": "Livron-sur-Drôme"},
    {"city": "Loriol-sur-Drôme"},
    {"city": "Luc-en-Diois"},
    {"city": "Lus-la-Croix-Haute"},
    {"city": "Malataverne"},
    {"city": "Malissard"},
    {"city": "Manas"},
    {"city": "Manthes"},
    {"city": "Marches"},
    {"city": "Margès"},
    {"city": "Marignac-en-Diois"},
    {"city": "Marsanne"},
    {"city": "Marsaz"},
    {"city": "Menglon"},
    {"city": "Mercurol-Veaunes"},
    {"city": "Mérindol-les-Oliviers"},
    {"city": "Mévouillon"},
    {"city": "Mirabel-aux-Baronnies"},
    {"city": "Mirabel-et-Blacons"},
    {"city": "Mirmande"},
    {"city": "Miscon"},
    {"city": "Mollans-sur-Ouvèze"},
    {"city": "Montauban-sur-l'Ouvèze"},
    {"city": "Montaulieu"},
    {"city": "Montboucher-sur-Jabron"},
    {"city": "Montbrison-sur-Lez"},
    {"city": "Montbrun-les-Bains"},
    {"city": "Montchenu"},
    {"city": "Montclar-sur-Gervanne"},
    {"city": "Montéléger"},
    {"city": "Montélier"},
    {"city": "Montélimar"},
    {"city": "Montferrand-la-Fare"},
    {"city": "Montfroc"},
    {"city": "Montguers"},
    {"city": "Montjoux"},
    {"city": "Montjoyer"},
    {"city": "Montlaur-en-Diois"},
    {"city": "Montmaur-en-Diois"},
    {"city": "Montmeyran"},
    {"city": "Montmiral"},
    {"city": "Montoison"},
    {"city": "Montréal-les-Sources"},
    {"city": "Valherbasse"},
    {"city": "Montségur-sur-Lauzon"},
    {"city": "Montvendre"},
    {"city": "Moras-en-Valloire"},
    {"city": "Mornans"},
    {"city": "La Motte-Chalancon"},
    {"city": "La Motte-de-Galaure"},
    {"city": "La Motte-Fanjas"},
    {"city": "Mours-Saint-Eusèbe"},
    {"city": "Mureils"},
    {"city": "Nyons"},
    {"city": "Omblèze"},
    {"city": "Orcinas"},
    {"city": "Oriol-en-Royans"},
    {"city": "Ourches"},
    {"city": "Parnans"},
    {"city": "Le Pègue"},
    {"city": "Pelonne"},
    {"city": "Pennes-le-Sec"},
    {"city": "La Penne-sur-l'Ouvèze"},
    {"city": "Peyrins"},
    {"city": "Peyrus"},
    {"city": "Piégon"},
    {"city": "Piégros-la-Clastre"},
    {"city": "Pierrelatte"},
    {"city": "Pierrelongue"},
    {"city": "Les Pilles"},
    {"city": "Plaisians"},
    {"city": "Plan-de-Baix"},
    {"city": "Le Poët-Célard"},
    {"city": "Le Poët-en-Percip"},
    {"city": "Le Poët-Laval"},
    {"city": "Le Poët-Sigillat"},
    {"city": "Pommerol"},
    {"city": "Ponet-et-Saint-Auban"},
    {"city": "Ponsas"},
    {"city": "Pontaix"},
    {"city": "Pont-de-Barret"},
    {"city": "Pont-de-l'Isère"},
    {"city": "Portes-en-Valdaine"},
    {"city": "Portes-lès-Valence"},
    {"city": "Poyols"},
    {"city": "Pradelle"},
    {"city": "Les Prés"},
    {"city": "Propiac"},
    {"city": "Puygiron"},
    {"city": "Puy-Saint-Martin"},
    {"city": "Ratières"},
    {"city": "Réauville"},
    {"city": "Recoubeau-Jansac"},
    {"city": "Reilhanette"},
    {"city": "Rémuzat"},
    {"city": "Rimon-et-Savel"},
    {"city": "Rioms"},
    {"city": "Rochebaudin"},
    {"city": "Rochebrune"},
    {"city": "Rochechinard"},
    {"city": "La Roche-de-Glun"},
    {"city": "Rochefort-en-Valdaine"},
    {"city": "Rochefort-Samson"},
    {"city": "Rochefourchat"},
    {"city": "Rochegude"},
    {"city": "Roche-Saint-Secret-Béconne"},
    {"city": "La Roche-sur-Grane"},
    {"city": "La Roche-sur-le-Buis"},
    {"city": "La Rochette-du-Buis"},
    {"city": "Romans-sur-Isère"},
    {"city": "Romeyer"},
    {"city": "Rottier"},
    {"city": "Roussas"},
    {"city": "Rousset-les-Vignes"},
    {"city": "Roussieux"},
    {"city": "Roynac"},
    {"city": "Sahune"},
    {"city": "Saillans"},
    {"city": "Saint-Agnan-en-Vercors"},
    {"city": "Saint-Andéol"},
    {"city": "Saint-Auban-sur-l'Ouvèze"},
    {"city": "Saint-Avit"},
    {"city": "Saint-Bardoux"},
    {"city": "Saint-Barthélemy-de-Vals"},
    {"city": "Saint-Benoit-en-Diois"},
    {"city": "Saint-Christophe-et-le-Laris"},
    {"city": "Sainte-Croix"},
    {"city": "Saint-Dizier-en-Diois"},
    {"city": "Saint-Donat-sur-l'Herbasse"},
    {"city": "Sainte-Eulalie-en-Royans"},
    {"city": "Sainte-Euphémie-sur-Ouvèze"},
    {"city": "Saint-Ferréol-Trente-Pas"},
    {"city": "Saint-Gervais-sur-Roubion"},
    {"city": "Sainte-Jalle"},
    {"city": "Saint-Jean-en-Royans"},
    {"city": "Saint-Julien-en-Quint"},
    {"city": "Saint-Julien-en-Vercors"},
    {"city": "Saint-Laurent-d'Onay"},
    {"city": "Saint-Laurent-en-Royans"},
    {"city": "Saint-Marcel-lès-Sauzet"},
    {"city": "Saint-Marcel-lès-Valence"},
    {"city": "Saint-Martin-d'Août"},
    {"city": "Saint-Martin-en-Vercors"},
    {"city": "Saint-Martin-le-Colonel"},
    {"city": "Saint-Maurice-sur-Eygues"},
    {"city": "Saint-May"},
    {"city": "Saint-Michel-sur-Savasse"},
    {"city": "Saint-Nazaire-en-Royans"},
    {"city": "Saint-Nazaire-le-Désert"},
    {"city": "Saint-Pantaléon-les-Vignes"},
    {"city": "Saint-Paul-lès-Romans"},
    {"city": "Saint-Paul-Trois-Châteaux"},
    {"city": "Saint-Rambert-d'Albon"},
    {"city": "Saint-Restitut"},
    {"city": "Saint-Roman"},
    {"city": "Saint-Sauveur-en-Diois"},
    {"city": "Saint-Sauveur-Gouvernet"},
    {"city": "Saint-Sorlin-en-Valloire"},
    {"city": "Saint-Thomas-en-Royans"},
    {"city": "Saint-Uze"},
    {"city": "Saint-Vallier"},
    {"city": "Salettes"},
    {"city": "Salles-sous-Bois"},
    {"city": "Saou"},
    {"city": "Saulce-sur-Rhône"},
    {"city": "Sauzet"},
    {"city": "Savasse"},
    {"city": "Séderon"},
    {"city": "Serves-sur-Rhône"},
    {"city": "Solérieux"},
    {"city": "Souspierre"},
    {"city": "Soyans"},
    {"city": "Suze-la-Rousse"},
    {"city": "Suze"},
    {"city": "Tain-l'Hermitage"},
    {"city": "Taulignan"},
    {"city": "Tersanne"},
    {"city": "Teyssières"},
    {"city": "Les Tonils"},
    {"city": "La Touche"},
    {"city": "Les Tourrettes"},
    {"city": "Triors"},
    {"city": "Truinas"},
    {"city": "Tulette"},
    {"city": "Upie"},
    {"city": "Vachères-en-Quint"},
    {"city": "Valaurie"},
    {"city": "Valdrôme"},
    {"city": "Valence"},
    {"city": "Valouse"},
    {"city": "Vassieux-en-Vercors"},
    {"city": "Vaunaveys-la-Rochette"},
    {"city": "Venterol"},
    {"city": "Vercheny"},
    {"city": "Verclause"},
    {"city": "Vercoiran"},
    {"city": "Véronne"},
    {"city": "Vers-sur-Méouge"},
    {"city": "Vesc"},
    {"city": "Villebois-les-Pins"},
    {"city": "Villefranche-le-Château"},
    {"city": "Villeperdrix"},
    {"city": "Vinsobres"},
    {"city": "Volvent"},
    {"city": "Granges-les-Beaumont"},
    {"city": "Gervans"},
    {"city": "Jaillans"},
    {"city": "Saint-Vincent-la-Commanderie"},
    {"city": "Aclou"},
    {"city": "Acon"},
    {"city": "Acquigny"},
    {"city": "Aigleville"},
    {"city": "Ailly"},
    {"city": "Aizier"},
    {"city": "Alizay"},
    {"city": "Ambenay"},
    {"city": "Amécourt"},
    {"city": "Amfreville-Saint-Amand"},
    {"city": "Amfreville-les-Champs"},
    {"city": "Amfreville-sous-les-Monts"},
    {"city": "Amfreville-sur-Iton"},
    {"city": "Andé"},
    {"city": "Les Andelys"},
    {"city": "Angerville-la-Campagne"},
    {"city": "Appeville-Annebault"},
    {"city": "Armentières-sur-Avre"},
    {"city": "Arnières-sur-Iton"},
    {"city": "Asnières"},
    {"city": "Le Val d'Hazey"},
    {"city": "Aulnay-sur-Iton"},
    {"city": "Autheuil-Authouillet"},
    {"city": "Authevernes"},
    {"city": "Les Authieux"},
    {"city": "Authou"},
    {"city": "Aviron"},
    {"city": "Chambois"},
    {"city": "Bacquepuis"},
    {"city": "Bacqueville"},
    {"city": "Bailleul-la-Vallée"},
    {"city": "Bâlines"},
    {"city": "Barc"},
    {"city": "Les Barils"},
    {"city": "Barneville-sur-Seine"},
    {"city": "Barquet"},
    {"city": "Barville"},
    {"city": "Les Baux-de-Breteuil"},
    {"city": "Les Baux-Sainte-Croix"},
    {"city": "Bazincourt-sur-Epte"},
    {"city": "Bazoques"},
    {"city": "Beaubray"},
    {"city": "Beauficel-en-Lyons"},
    {"city": "Mesnil-en-Ouche"},
    {"city": "Beaumontel"},
    {"city": "Beaumont-le-Roger"},
    {"city": "Le Bec-Hellouin"},
    {"city": "Le Bec-Thomas"},
    {"city": "Bémécourt"},
    {"city": "Bérengeville-la-Campagne"},
    {"city": "Bernay"},
    {"city": "Bernienville"},
    {"city": "Bernouville"},
    {"city": "Berthouville"},
    {"city": "Les Monts du Roumois"},
    {"city": "Berville-la-Campagne"},
    {"city": "Berville-sur-Mer"},
    {"city": "Beuzeville"},
    {"city": "Bézu-la-Forêt"},
    {"city": "Bézu-Saint-Éloi"},
    {"city": "Bois-Anzeray"},
    {"city": "Bois-Arnault"},
    {"city": "Frenelles-en-Vexin"},
    {"city": "Le Bois-Hellain"},
    {"city": "Bois-Jérôme-Saint-Ouen"},
    {"city": "Bois-le-Roi"},
    {"city": "Boisney"},
    {"city": "Bois-Normand-près-Lyre"},
    {"city": "Boisset-les-Prévanches"},
    {"city": "Boissey-le-Châtel"},
    {"city": "La Boissière"},
    {"city": "Boissy-Lamberville"},
    {"city": "Boncourt"},
    {"city": "La Bonneville-sur-Iton"},
    {"city": "Bonneville-Aptot"},
    {"city": "Flancourt-Crescy-en-Roumois"},
    {"city": "Thénouville"},
    {"city": "Bosroumois"},
    {"city": "Bosgouet"},
    {"city": "Bosquentin"},
    {"city": "Bosrobert"},
    {"city": "Les Bottereaux"},
    {"city": "Bouafles"},
    {"city": "Bouchevilliers"},
    {"city": "Le Boulay-Morin"},
    {"city": "Boulleville"},
    {"city": "Bouquelon"},
    {"city": "Bouquetot"},
    {"city": "Bourg-Achard"},
    {"city": "Bourg-Beaudouin"},
    {"city": "Grand Bourgtheroulde"},
    {"city": "Bournainville-Faverolles"},
    {"city": "Bourneville-Sainte-Croix"},
    {"city": "Bourth"},
    {"city": "Bray"},
    {"city": "Brestot"},
    {"city": "Bretagnolles"},
    {"city": "Breteuil"},
    {"city": "Brétigny"},
    {"city": "Breuilpont"},
    {"city": "Breux-sur-Avre"},
    {"city": "Brionne"},
    {"city": "Broglie"},
    {"city": "Brosville"},
    {"city": "Bueil"},
    {"city": "Burey"},
    {"city": "Caillouet-Orgeville"},
    {"city": "Cailly-sur-Eure"},
    {"city": "Calleville"},
    {"city": "Campigny"},
    {"city": "Canappeville"},
    {"city": "Caorches-Saint-Nicolas"},
    {"city": "Capelle-les-Grands"},
    {"city": "Caugé"},
    {"city": "Caumont"},
    {"city": "Cauverville-en-Roumois"},
    {"city": "Cesseville"},
    {"city": "Chaignes"},
    {"city": "Chaise-Dieu-du-Theil"},
    {"city": "Chamblac"},
    {"city": "Chambord"},
    {"city": "Chambray"},
    {"city": "Champ-Dolent"},
    {"city": "Champenard"},
    {"city": "Champigny-la-Futelaye"},
    {"city": "La Chapelle-Bayvel"},
    {"city": "La Chapelle-du-Bois-des-Faulx"},
    {"city": "La Chapelle-Gauthier"},
    {"city": "La Chapelle-Hareng"},
    {"city": "Charleval"},
    {"city": "Château-sur-Epte"},
    {"city": "Chauvincourt-Provemont"},
    {"city": "Chavigny-Bailleul"},
    {"city": "Chennebrun"},
    {"city": "Chéronvilliers"},
    {"city": "Marbois"},
    {"city": "Cierrey"},
    {"city": "Claville"},
    {"city": "Collandres-Quincarnon"},
    {"city": "Colletot"},
    {"city": "Combon"},
    {"city": "Conches-en-Ouche"},
    {"city": "Condé-sur-Risle"},
    {"city": "Connelles"},
    {"city": "Conteville"},
    {"city": "Cormeilles"},
    {"city": "Le Cormier"},
    {"city": "Corneville-la-Fouquetière"},
    {"city": "Corneville-sur-Risle"},
    {"city": "Coudray"},
    {"city": "Coudres"},
    {"city": "Courbépine"},
    {"city": "Courcelles-sur-Seine"},
    {"city": "Courdemanche"},
    {"city": "Courteilles"},
    {"city": "La Couture-Boussey"},
    {"city": "Crasville"},
    {"city": "Crestot"},
    {"city": "Criquebeuf-la-Campagne"},
    {"city": "Criquebeuf-sur-Seine"},
    {"city": "La Croisille"},
    {"city": "Croisy-sur-Eure"},
    {"city": "Clef Vallée d'Eure"},
    {"city": "Crosville-la-Vieille"},
    {"city": "Croth"},
    {"city": "Cuverville"},
    {"city": "Les Damps"},
    {"city": "Mesnils-sur-Iton"},
    {"city": "Dangu"},
    {"city": "Dardez"},
    {"city": "Daubeuf-la-Campagne"},
    {"city": "Daubeuf-près-Vatteville"},
    {"city": "Douains"},
    {"city": "Doudeauville-en-Vexin"},
    {"city": "Douville-sur-Andelle"},
    {"city": "Droisy"},
    {"city": "Drucourt"},
    {"city": "Duranville"},
    {"city": "Écaquelon"},
    {"city": "Écardenville-la-Campagne"},
    {"city": "Écauville"},
    {"city": "Vexin-sur-Epte"},
    {"city": "Écouis"},
    {"city": "Ecquetot"},
    {"city": "Émalleville"},
    {"city": "Émanville"},
    {"city": "Épaignes"},
    {"city": "Épégard"},
    {"city": "Épieds"},
    {"city": "Épreville-en-Lieuvin"},
    {"city": "Épreville-près-le-Neubourg"},
    {"city": "Étrépagny"},
    {"city": "Étréville"},
    {"city": "Éturqueraye"},
    {"city": "Évreux"},
    {"city": "Ézy-sur-Eure"},
    {"city": "Fains"},
    {"city": "Farceaux"},
    {"city": "Fatouville-Grestain"},
    {"city": "Fauville"},
    {"city": "Faverolles-la-Campagne"},
    {"city": "Le Favril"},
    {"city": "Ferrières-Haut-Clocher"},
    {"city": "Ferrières-Saint-Hilaire"},
    {"city": "La Ferrière-sur-Risle"},
    {"city": "Feuguerolles"},
    {"city": "Le Fidelaire"},
    {"city": "Fiquefleur-Équainville"},
    {"city": "Fleury-la-Forêt"},
    {"city": "Fleury-sur-Andelle"},
    {"city": "Flipou"},
    {"city": "Folleville"},
    {"city": "Fontaine-Bellenger"},
    {"city": "Fontaine-l'Abbé"},
    {"city": "Fontaine-la-Louvet"},
    {"city": "Fontaine-sous-Jouy"},
    {"city": "La Forêt-du-Parc"},
    {"city": "Fort-Moville"},
    {"city": "Foucrainville"},
    {"city": "Foulbec"},
    {"city": "Fouqueville"},
    {"city": "Le Perrey"},
    {"city": "Franqueville"},
    {"city": "Freneuse-sur-Risle"},
    {"city": "Fresne-Cauverville"},
    {"city": "Fresney"},
    {"city": "Gadencourt"},
    {"city": "Gaillon"},
    {"city": "Gamaches-en-Vexin"},
    {"city": "La Baronnie"},
    {"city": "Garennes-sur-Eure"},
    {"city": "Gasny"},
    {"city": "Gauciel"},
    {"city": "Gaudreville-la-Rivière"},
    {"city": "Gauville-la-Campagne"},
    {"city": "Gisors"},
    {"city": "Giverny"},
    {"city": "Giverville"},
    {"city": "Glisolles"},
    {"city": "Glos-sur-Risle"},
    {"city": "La Goulafrière"},
    {"city": "Goupil-Othon"},
    {"city": "Gournay-le-Guérin"},
    {"city": "Val d'Orger"},
    {"city": "Grand-Camp"},
    {"city": "Graveron-Sémerville"},
    {"city": "Gravigny"},
    {"city": "Grosley-sur-Risle"},
    {"city": "Grossœuvre"},
    {"city": "Le Bosc du Theil"},
    {"city": "Guerny"},
    {"city": "Guichainville"},
    {"city": "Guiseniers"},
    {"city": "L'Habit"},
    {"city": "Hacqueville"},
    {"city": "Harcourt"},
    {"city": "Hardencourt-Cocherel"},
    {"city": "La Harengère"},
    {"city": "Harquency"},
    {"city": "Hauville"},
    {"city": "La Haye-Aubrée"},
    {"city": "La Haye-de-Calleville"},
    {"city": "La Haye-de-Routot"},
    {"city": "La Haye-du-Theil"},
    {"city": "La Haye-le-Comte"},
    {"city": "La Haye-Malherbe"},
    {"city": "La Haye-Saint-Sylvestre"},
    {"city": "Hébécourt"},
    {"city": "Hecmanville"},
    {"city": "Hécourt"},
    {"city": "Hectomare"},
    {"city": "Hennezis"},
    {"city": "Herqueville"},
    {"city": "Heubécourt-Haricourt"},
    {"city": "Heudebouville"},
    {"city": "Heudicourt"},
    {"city": "Heudreville-en-Lieuvin"},
    {"city": "Heudreville-sur-Eure"},
    {"city": "La Heunière"},
    {"city": "Heuqueville"},
    {"city": "Les Hogues"},
    {"city": "Hondouville"},
    {"city": "Honguemare-Guenouville"},
    {"city": "L'Hosmes"},
    {"city": "Houetteville"},
    {"city": "Houlbec-Cocherel"},
    {"city": "La Houssaye"},
    {"city": "Houville-en-Vexin"},
    {"city": "Huest"},
    {"city": "Igoville"},
    {"city": "Illeville-sur-Montfort"},
    {"city": "Illiers-l'Évêque"},
    {"city": "Incarville"},
    {"city": "Irreville"},
    {"city": "Iville"},
    {"city": "Ivry-la-Bataille"},
    {"city": "Jouy-sur-Eure"},
    {"city": "Juignettes"},
    {"city": "Jumelles"},
    {"city": "La Lande-Saint-Léger"},
    {"city": "Le Landin"},
    {"city": "Launay"},
    {"city": "Léry"},
    {"city": "Letteguives"},
    {"city": "Lieurey"},
    {"city": "Lignerolles"},
    {"city": "Lilly"},
    {"city": "Lisors"},
    {"city": "Livet-sur-Authou"},
    {"city": "Longchamps"},
    {"city": "Lorleau"},
    {"city": "Louversey"},
    {"city": "Louviers"},
    {"city": "Louye"},
    {"city": "Lyons-la-Forêt"},
    {"city": "La Madeleine-de-Nonancourt"},
    {"city": "Mainneville"},
    {"city": "Malleville-sur-le-Bec"},
    {"city": "Malouy"},
    {"city": "Mandeville"},
    {"city": "Mandres"},
    {"city": "Manneville-la-Raoult"},
    {"city": "Manneville-sur-Risle"},
    {"city": "Le Manoir"},
    {"city": "Marais-Vernier"},
    {"city": "Marbeuf"},
    {"city": "Marcilly-la-Campagne"},
    {"city": "Marcilly-sur-Eure"},
    {"city": "Martagny"},
    {"city": "Martainville"},
    {"city": "Martot"},
    {"city": "Mélicourt"},
    {"city": "Ménesqueville"},
    {"city": "Ménilles"},
    {"city": "Menneval"},
    {"city": "Mercey"},
    {"city": "Merey"},
    {"city": "Le Mesnil-Fuguet"},
    {"city": "Le Mesnil-Jourdain"},
    {"city": "Mesnil-Rousset"},
    {"city": "Mesnil-sous-Vienne"},
    {"city": "Mesnil-sur-l'Estrée"},
    {"city": "Mesnil-Verclives"},
    {"city": "Mézières-en-Vexin"},
    {"city": "Miserey"},
    {"city": "Moisville"},
    {"city": "Terres de Bord"},
    {"city": "Montfort-sur-Risle"},
    {"city": "Montreuil-l'Argillé"},
    {"city": "Morainville-Jouveaux"},
    {"city": "Morgny"},
    {"city": "Morsan"},
    {"city": "Mouettes"},
    {"city": "Mouflaines"},
    {"city": "Mousseaux-Neuville"},
    {"city": "Muids"},
    {"city": "Muzy"},
    {"city": "Nagel-Séez-Mesnil"},
    {"city": "Nassandres sur Risle"},
    {"city": "Neaufles-Saint-Martin"},
    {"city": "Neaufles-Auvergny"},
    {"city": "Le Neubourg"},
    {"city": "Neuilly"},
    {"city": "La Neuve-Grange"},
    {"city": "La Neuve-Lyre"},
    {"city": "La Neuville-du-Bosc"},
    {"city": "Neuville-sur-Authou"},
    {"city": "Noards"},
    {"city": "La Noë-Poulain"},
    {"city": "Nogent-le-Sec"},
    {"city": "Nojeon-en-Vexin"},
    {"city": "Nonancourt"},
    {"city": "Normanville"},
    {"city": "Notre-Dame-de-l'Isle"},
    {"city": "Notre-Dame-d'Épine"},
    {"city": "Notre-Dame-du-Hamel"},
    {"city": "Le Noyer-en-Ouche"},
    {"city": "Noyers"},
    {"city": "Ormes"},
    {"city": "Le Val-Doré"},
    {"city": "Pacy-sur-Eure"},
    {"city": "Parville"},
    {"city": "Perriers-sur-Andelle"},
    {"city": "Perruel"},
    {"city": "Piencourt"},
    {"city": "Pinterville"},
    {"city": "Piseux"},
    {"city": "Pîtres"},
    {"city": "Les Places"},
    {"city": "Plainville"},
    {"city": "Le Planquay"},
    {"city": "Plasnes"},
    {"city": "Le Plessis-Grohan"},
    {"city": "Le Plessis-Hébert"},
    {"city": "Le Plessis-Sainte-Opportune"},
    {"city": "Pont-Audemer"},
    {"city": "Pont-Authou"},
    {"city": "Pont-de-l'Arche"},
    {"city": "Pont-Saint-Pierre"},
    {"city": "Porte-de-Seine"},
    {"city": "Portes"},
    {"city": "Port-Mort"},
    {"city": "Poses"},
    {"city": "La Poterie-Mathieu"},
    {"city": "Les Préaux"},
    {"city": "Pressagny-l'Orgueilleux"},
    {"city": "Prey"},
    {"city": "Puchay"},
    {"city": "Pullay"},
    {"city": "La Pyle"},
    {"city": "Quatremare"},
    {"city": "Quillebeuf-sur-Seine"},
    {"city": "Quittebeuf"},
    {"city": "Radepont"},
    {"city": "Renneville"},
    {"city": "Reuilly"},
    {"city": "Richeville"},
    {"city": "Romilly-la-Puthenaye"},
    {"city": "Romilly-sur-Andelle"},
    {"city": "La Roquette"},
    {"city": "Rosay-sur-Lieure"},
    {"city": "Rougemontiers"},
    {"city": "Rouge-Perriers"},
    {"city": "Routot"},
    {"city": "Rouvray"},
    {"city": "Rugles"},
    {"city": "Sacquenville"},
    {"city": "Saint-Agnan-de-Cernières"},
    {"city": "Saint-André-de-l'Eure"},
    {"city": "Saint-Antonin-de-Sommaire"},
    {"city": "Saint-Aubin-d'Écrosville"},
    {"city": "Saint-Aubin-de-Scellon"},
    {"city": "Saint-Aubin-du-Thenney"},
    {"city": "Treis-Sants-en-Ouche"},
    {"city": "Saint-Aubin-sur-Gaillon"},
    {"city": "Saint-Aubin-sur-Quillebeuf"},
    {"city": "Saint-Benoît-des-Ombres"},
    {"city": "Saint-Christophe-sur-Avre"},
    {"city": "Saint-Christophe-sur-Condé"},
    {"city": "Sainte-Colombe-la-Commanderie"},
    {"city": "Sainte-Colombe-près-Vernon"},
    {"city": "Saint-Cyr-de-Salerne"},
    {"city": "Le Vaudreuil"},
    {"city": "Saint-Cyr-la-Campagne"},
    {"city": "Saint-Denis-d'Augerons"},
    {"city": "Saint-Denis-des-Monts"},
    {"city": "Saint-Denis-le-Ferment"},
    {"city": "Saint-Didier-des-Bois"},
    {"city": "Saint-Élier"},
    {"city": "Saint-Éloi-de-Fourques"},
    {"city": "Saint-Étienne-du-Vauvray"},
    {"city": "Saint-Étienne-l'Allier"},
    {"city": "Saint-Étienne-sous-Bailleul"},
    {"city": "Sainte-Geneviève-lès-Gasny"},
    {"city": "Le Mesnil-Saint-Jean"},
    {"city": "Saint-Georges-du-Vièvre"},
    {"city": "Saint-Georges-Motel"},
    {"city": "Saint-Germain-de-Fresney"},
    {"city": "Saint-Germain-de-Pasquier"},
    {"city": "Saint-Germain-des-Angles"},
    {"city": "Saint-Germain-la-Campagne"},
    {"city": "Saint-Germain-sur-Avre"},
    {"city": "Saint-Grégoire-du-Vièvre"},
    {"city": "Saint-Jean-du-Thenney"},
    {"city": "Saint-Julien-de-la-Liègue"},
    {"city": "La Chapelle-Longueville"},
    {"city": "Saint-Laurent-des-Bois"},
    {"city": "Saint-Laurent-du-Tencement"},
    {"city": "Saint-Léger-de-Rôtes"},
    {"city": "Saint-Léger-du-Gennetey"},
    {"city": "Saint-Luc"},
    {"city": "Saint-Maclou"},
    {"city": "Saint-Marcel"},
    {"city": "Saint-Mards-de-Blacarville"},
    {"city": "Saint-Mards-de-Fresne"},
    {"city": "Le Lesme"},
    {"city": "Sainte-Marie-de-Vatimesnil"},
    {"city": "Sainte-Marthe"},
    {"city": "Saint-Martin-du-Tilleul"},
    {"city": "Saint-Martin-la-Campagne"},
    {"city": "Saint-Martin-Saint-Firmin"},
    {"city": "Saint-Meslin-du-Bosc"},
    {"city": "Sainte-Opportune-du-Bosc"},
    {"city": "Sainte-Opportune-la-Mare"},
    {"city": "Sainte-Marie-d'Attez"},
    {"city": "Saint-Ouen-de-Pontcheuil"},
    {"city": "Saint-Ouen-de-Thouberville"},
    {"city": "Saint-Ouen-du-Tilleul"},
    {"city": "Saint-Paul-de-Fourques"},
    {"city": "Saint-Philbert-sur-Boissey"},
    {"city": "Saint-Philbert-sur-Risle"},
    {"city": "Saint-Pierre-de-Bailleul"},
    {"city": "Saint-Pierre-de-Cernières"},
    {"city": "Saint-Pierre-de-Cormeilles"},
    {"city": "Saint-Pierre-de-Salerne"},
    {"city": "Saint-Pierre-des-Fleurs"},
    {"city": "Saint-Pierre-des-Ifs"},
    {"city": "Saint-Pierre-du-Bosguérard"},
    {"city": "Saint-Pierre-du-Val"},
    {"city": "Saint-Pierre-du-Vauvray"},
    {"city": "Saint-Pierre-la-Garenne"},
    {"city": "Saint-Samson-de-la-Roque"},
    {"city": "Saint-Sébastien-de-Morsent"},
    {"city": "Saint-Siméon"},
    {"city": "Saint-Sulpice-de-Grimbouville"},
    {"city": "Saint-Sylvestre-de-Cormeilles"},
    {"city": "Saint-Symphorien"},
    {"city": "Saint-Victor-de-Chrétienville"},
    {"city": "Saint-Victor-d'Épine"},
    {"city": "Saint-Victor-sur-Avre"},
    {"city": "Saint-Vigor"},
    {"city": "Saint-Vincent-des-Bois"},
    {"city": "Saint-Vincent-du-Boulay"},
    {"city": "Sancourt"},
    {"city": "Sassey"},
    {"city": "La Saussaye"},
    {"city": "Saussay-la-Campagne"},
    {"city": "Sébécourt"},
    {"city": "Selles"},
    {"city": "Serez"},
    {"city": "Serquigny"},
    {"city": "Surtauville"},
    {"city": "Surville"},
    {"city": "Suzay"},
    {"city": "Le Theil-Nolent"},
    {"city": "Thiberville"},
    {"city": "Thibouville"},
    {"city": "Thierville"},
    {"city": "Le Thil"},
    {"city": "Les Thilliers-en-Vexin"},
    {"city": "Le Thuit"},
    {"city": "Le Thuit de l'Oison"},
    {"city": "Tilleul-Dame-Agnès"},
    {"city": "Le Tilleul-Lambert"},
    {"city": "Tillières-sur-Avre"},
    {"city": "Tilly"},
    {"city": "Tocqueville"},
    {"city": "Le Torpt"},
    {"city": "Touffreville"},
    {"city": "Tournedos-Bois-Hubert"},
    {"city": "Tourneville"},
    {"city": "Tourville-la-Campagne"},
    {"city": "Tourville-sur-Pont-Audemer"},
    {"city": "Toutainville"},
    {"city": "Le Tremblay-Omonville"},
    {"city": "La Trinité"},
    {"city": "La Trinité-de-Réville"},
    {"city": "La Trinité-de-Thouberville"},
    {"city": "Triqueville"},
    {"city": "Le Troncq"},
    {"city": "Le Tronquay"},
    {"city": "Trouville-la-Haule"},
    {"city": "La Vacherie"},
    {"city": "Valailles"},
    {"city": "Le Val-David"},
    {"city": "Valletot"},
    {"city": "Vandrimare"},
    {"city": "Vannecrocq"},
    {"city": "Vascœuil"},
    {"city": "Vatteville"},
    {"city": "Vaux-sur-Eure"},
    {"city": "Les Trois Lacs"},
    {"city": "Venon"},
    {"city": "Les Ventes"},
    {"city": "Verneuil d'Avre et d'Iton"},
    {"city": "Verneusses"},
    {"city": "Vernon"},
    {"city": "Vesly"},
    {"city": "Vézillon"},
    {"city": "Le Vieil-Évreux"},
    {"city": "La Vieille-Lyre"},
    {"city": "Vieux-Port"},
    {"city": "Villegats"},
    {"city": "Villers-en-Vexin"},
    {"city": "Villers-sur-le-Roule"},
    {"city": "Villettes"},
    {"city": "Sylvains-Lès-Moulins"},
    {"city": "Villez-sous-Bailleul"},
    {"city": "Villez-sur-le-Neubourg"},
    {"city": "Villiers-en-Désœuvre"},
    {"city": "Vironvay"},
    {"city": "Vitot"},
    {"city": "Voiscreville"},
    {"city": "Vraiville"},
    {"city": "Val-de-Reuil"},
    {"city": "Abondant"},
    {"city": "Allainville"},
    {"city": "Allonnes"},
    {"city": "Alluyes"},
    {"city": "Amilly"},
    {"city": "Anet"},
    {"city": "Ardelles"},
    {"city": "Ardelu"},
    {"city": "Argenvilliers"},
    {"city": "Commune nouvelle d'Arrou"},
    {"city": "Aunay-sous-Auneau"},
    {"city": "Aunay-sous-Crécy"},
    {"city": "Auneau-Bleury-Saint-Symphorien"},
    {"city": "Les Autels-Villevillon"},
    {"city": "Authon-du-Perche"},
    {"city": "Baigneaux"},
    {"city": "Bailleau-le-Pin"},
    {"city": "Bailleau-l'Évêque"},
    {"city": "Bailleau-Armenonville"},
    {"city": "Barjouville"},
    {"city": "Barmainville"},
    {"city": "Baudreville"},
    {"city": "La Bazoche-Gouet"},
    {"city": "Bazoches-en-Dunois"},
    {"city": "Bazoches-les-Hautes"},
    {"city": "Beauche"},
    {"city": "Beaumont-les-Autels"},
    {"city": "Beauvilliers"},
    {"city": "Belhomert-Guéhouville"},
    {"city": "Berchères-Saint-Germain"},
    {"city": "Berchères-les-Pierres"},
    {"city": "Berchères-sur-Vesgre"},
    {"city": "Bérou-la-Mulotière"},
    {"city": "Béthonvilliers"},
    {"city": "Béville-le-Comte"},
    {"city": "Billancelles"},
    {"city": "Blandainville"},
    {"city": "Boissy-en-Drouais"},
    {"city": "Boissy-lès-Perche"},
    {"city": "Boisville-la-Saint-Père"},
    {"city": "La Bourdinière-Saint-Loup"},
    {"city": "Boncé"},
    {"city": "Boncourt"},
    {"city": "Bonneval"},
    {"city": "Bouglainval"},
    {"city": "Le Boullay-les-Deux-Églises"},
    {"city": "Le Boullay-Mivoye"},
    {"city": "Le Boullay-Thierry"},
    {"city": "Boutigny-Prouais"},
    {"city": "Bouville"},
    {"city": "Bréchamps"},
    {"city": "Brezolles"},
    {"city": "Briconville"},
    {"city": "Brou"},
    {"city": "Broué"},
    {"city": "Bû"},
    {"city": "Bullainville"},
    {"city": "Cernay"},
    {"city": "Challet"},
    {"city": "Champhol"},
    {"city": "Champrond-en-Gâtine"},
    {"city": "Champrond-en-Perchet"},
    {"city": "Champseru"},
    {"city": "La Chapelle-d'Aunainville"},
    {"city": "La Chapelle-du-Noyer"},
    {"city": "La Chapelle-Forainvilliers"},
    {"city": "La Chapelle-Fortin"},
    {"city": "Chapelle-Guillaume"},
    {"city": "Chapelle-Royale"},
    {"city": "Charbonnières"},
    {"city": "Charonville"},
    {"city": "Charpont"},
    {"city": "Chartainvilliers"},
    {"city": "Chartres"},
    {"city": "Chassant"},
    {"city": "Châtaincourt"},
    {"city": "Châteaudun"},
    {"city": "Châteauneuf-en-Thymerais"},
    {"city": "Les Châtelets"},
    {"city": "Les Châtelliers-Notre-Dame"},
    {"city": "Châtenay"},
    {"city": "Chaudon"},
    {"city": "Chauffours"},
    {"city": "La Chaussée-d'Ivry"},
    {"city": "Cherisy"},
    {"city": "Chuisnes"},
    {"city": "Cintray"},
    {"city": "Clévilliers"},
    {"city": "Cloyes-les-Trois-Rivières"},
    {"city": "Coltainville"},
    {"city": "Combres"},
    {"city": "Conie-Molitard"},
    {"city": "Corancez"},
    {"city": "Cormainville"},
    {"city": "Les Corvées-les-Yys"},
    {"city": "Le Coudray"},
    {"city": "Coudray-au-Perche"},
    {"city": "Coulombs"},
    {"city": "Courbehaye"},
    {"city": "Courville-sur-Eure"},
    {"city": "Crécy-Couvé"},
    {"city": "Croisilles"},
    {"city": "La Croix-du-Perche"},
    {"city": "Crucey-Villages"},
    {"city": "Dambron"},
    {"city": "Dammarie"},
    {"city": "Dampierre-sous-Brou"},
    {"city": "Dampierre-sur-Avre"},
    {"city": "Dancy"},
    {"city": "Dangeau"},
    {"city": "Dangers"},
    {"city": "Denonville"},
    {"city": "Digny"},
    {"city": "Donnemain-Saint-Mamès"},
    {"city": "Dreux"},
    {"city": "Droue-sur-Drouette"},
    {"city": "Écluzelles"},
    {"city": "Écrosnes"},
    {"city": "Épeautrolles"},
    {"city": "Épernon"},
    {"city": "Ermenonville-la-Grande"},
    {"city": "Ermenonville-la-Petite"},
    {"city": "Escorpain"},
    {"city": "Les Étilleux"},
    {"city": "Faverolles"},
    {"city": "Favières"},
    {"city": "Le Favril"},
    {"city": "La Ferté-Vidame"},
    {"city": "Fessanvilliers-Mattanvilliers"},
    {"city": "Flacey"},
    {"city": "Fontaine-la-Guyon"},
    {"city": "Fontaine-les-Ribouts"},
    {"city": "Fontaine-Simon"},
    {"city": "Fontenay-sur-Conie"},
    {"city": "Fontenay-sur-Eure"},
    {"city": "La Framboisière"},
    {"city": "Francourville"},
    {"city": "Frazé"},
    {"city": "Fresnay-le-Comte"},
    {"city": "Fresnay-le-Gilmert"},
    {"city": "Fresnay-l'Évêque"},
    {"city": "Friaize"},
    {"city": "Fruncé"},
    {"city": "Gallardon"},
    {"city": "Garancières-en-Beauce"},
    {"city": "Garancières-en-Drouais"},
    {"city": "Garnay"},
    {"city": "Gas"},
    {"city": "Gasville-Oisème"},
    {"city": "La Gaudaine"},
    {"city": "Le Gault-Saint-Denis"},
    {"city": "Gellainville"},
    {"city": "Germainville"},
    {"city": "Gilles"},
    {"city": "Gohory"},
    {"city": "Gommerville"},
    {"city": "Gouillons"},
    {"city": "Goussainville"},
    {"city": "Guainville"},
    {"city": "Le Gué-de-Longroi"},
    {"city": "Guilleville"},
    {"city": "Guillonville"},
    {"city": "Hanches"},
    {"city": "Happonvilliers"},
    {"city": "Havelu"},
    {"city": "Houville-la-Branche"},
    {"city": "Houx"},
    {"city": "Illiers-Combray"},
    {"city": "Intréville"},
    {"city": "Jallans"},
    {"city": "Janville-en-Beauce"},
    {"city": "Jaudrais"},
    {"city": "Jouy"},
    {"city": "Lamblore"},
    {"city": "Landelles"},
    {"city": "Laons"},
    {"city": "Léthuin"},
    {"city": "Levainville"},
    {"city": "Lèves"},
    {"city": "Levesville-la-Chenard"},
    {"city": "Logron"},
    {"city": "Loigny-la-Bataille"},
    {"city": "Lormaye"},
    {"city": "La Loupe"},
    {"city": "Louville-la-Chenard"},
    {"city": "Louvilliers-en-Drouais"},
    {"city": "Louvilliers-lès-Perche"},
    {"city": "Lucé"},
    {"city": "Luigny"},
    {"city": "Luisant"},
    {"city": "Lumeau"},
    {"city": "Luplanté"},
    {"city": "Luray"},
    {"city": "Magny"},
    {"city": "Maillebois"},
    {"city": "Maintenon"},
    {"city": "Mainvilliers"},
    {"city": "Maisons"},
    {"city": "La Mancelière"},
    {"city": "Manou"},
    {"city": "Marboué"},
    {"city": "Marchéville"},
    {"city": "Marchezais"},
    {"city": "Arcisses"},
    {"city": "Marolles-les-Buis"},
    {"city": "Marville-Moutiers-Brûlé"},
    {"city": "Meaucé"},
    {"city": "Méréglise"},
    {"city": "Mérouville"},
    {"city": "Meslay-le-Grenet"},
    {"city": "Meslay-le-Vidame"},
    {"city": "Le Mesnil-Simon"},
    {"city": "Le Mesnil-Thomas"},
    {"city": "Mévoisins"},
    {"city": "Mézières-en-Drouais"},
    {"city": "Miermaigne"},
    {"city": "Mignières"},
    {"city": "Mittainvilliers-Vérigny"},
    {"city": "Moinville-la-Jeulin"},
    {"city": "Moléans"},
    {"city": "Mondonville-Saint-Jean"},
    {"city": "Montboissier"},
    {"city": "Montharville"},
    {"city": "Montigny-le-Chartif"},
    {"city": "Montigny-sur-Avre"},
    {"city": "Montireau"},
    {"city": "Montlandon"},
    {"city": "Montreuil"},
    {"city": "Morainville"},
    {"city": "Morancez"},
    {"city": "Moriers"},
    {"city": "Morvilliers"},
    {"city": "Mottereau"},
    {"city": "Moulhard"},
    {"city": "Moutiers"},
    {"city": "Néron"},
    {"city": "Neuvy-en-Beauce"},
    {"city": "Neuvy-en-Dunois"},
    {"city": "Nogent-le-Phaye"},
    {"city": "Nogent-le-Roi"},
    {"city": "Nogent-le-Rotrou"},
    {"city": "Nogent-sur-Eure"},
    {"city": "Nonvilliers-Grandhoux"},
    {"city": "Nottonville"},
    {"city": "Oinville-Saint-Liphard"},
    {"city": "Oinville-sous-Auneau"},
    {"city": "Ollé"},
    {"city": "Orgères-en-Beauce"},
    {"city": "Ormoy"},
    {"city": "Orrouer"},
    {"city": "Ouarville"},
    {"city": "Ouerre"},
    {"city": "Oulins"},
    {"city": "Oysonville"},
    {"city": "Péronville"},
    {"city": "Pierres"},
    {"city": "Les Pinthières"},
    {"city": "Poinville"},
    {"city": "Poisvilliers"},
    {"city": "Pontgouin"},
    {"city": "Poupry"},
    {"city": "Prasville"},
    {"city": "Pré-Saint-Évroult"},
    {"city": "Pré-Saint-Martin"},
    {"city": "Prudemanche"},
    {"city": "Prunay-le-Gillon"},
    {"city": "La Puisaye"},
    {"city": "Puiseux"},
    {"city": "Réclainville"},
    {"city": "Les Ressuintes"},
    {"city": "Revercourt"},
    {"city": "Rohaire"},
    {"city": "Roinville"},
    {"city": "Rouvray-Saint-Denis"},
    {"city": "Rouvres"},
    {"city": "Rueil-la-Gadelière"},
    {"city": "Saint-Ange-et-Torçay"},
    {"city": "Saint-Arnoult-des-Bois"},
    {"city": "Saint-Aubin-des-Bois"},
    {"city": "Saint-Avit-les-Guespières"},
    {"city": "Saint-Bomer"},
    {"city": "Saint-Christophe"},
    {"city": "Villemaury"},
    {"city": "Saintigny"},
    {"city": "Sainte-Gemme-Moronval"},
    {"city": "Saint-Denis-des-Puits"},
    {"city": "Saint-Denis-Lanneray"},
    {"city": "Saint-Éliph"},
    {"city": "Saint-Éman"},
    {"city": "Saint-Georges-sur-Eure"},
    {"city": "Saint-Germain-le-Gaillard"},
    {"city": "Saint-Jean-de-Rebervilliers"},
    {"city": "Saint-Jean-Pierre-Fixte"},
    {"city": "Saint-Laurent-la-Gâtine"},
    {"city": "Saint-Léger-des-Aubées"},
    {"city": "Saint-Lubin-de-Cravant"},
    {"city": "Saint-Lubin-de-la-Haye"},
    {"city": "Saint-Lubin-des-Joncherets"},
    {"city": "Saint-Lucien"},
    {"city": "Saint-Luperce"},
    {"city": "Saint-Maixme-Hauterive"},
    {"city": "Saint-Martin-de-Nigelles"},
    {"city": "Saint-Maur-sur-le-Loir"},
    {"city": "Saint-Maurice-Saint-Germain"},
    {"city": "Saint-Ouen-Marchefroy"},
    {"city": "Saint-Piat"},
    {"city": "Saint-Prest"},
    {"city": "Saint-Rémy-sur-Avre"},
    {"city": "Saint-Sauveur-Marville"},
    {"city": "Saint-Victor-de-Buthon"},
    {"city": "Sainville"},
    {"city": "Sancheville"},
    {"city": "Sandarville"},
    {"city": "Santeuil"},
    {"city": "Santilly"},
    {"city": "La Saucelle"},
    {"city": "Saulnières"},
    {"city": "Saumeray"},
    {"city": "Saussay"},
    {"city": "Senantes"},
    {"city": "Senonches"},
    {"city": "Serazereux"},
    {"city": "Serville"},
    {"city": "Sorel-Moussel"},
    {"city": "Souancé-au-Perche"},
    {"city": "Soulaires"},
    {"city": "Sours"},
    {"city": "Terminiers"},
    {"city": "Theuville"},
    {"city": "Le Thieulin"},
    {"city": "Thimert-Gâtelles"},
    {"city": "Thiron-Gardais"},
    {"city": "Thivars"},
    {"city": "Thiville"},
    {"city": "Tillay-le-Péneux"},
    {"city": "Toury"},
    {"city": "Trancrainville"},
    {"city": "Tremblay-les-Villages"},
    {"city": "Tréon"},
    {"city": "Trizay-Coutretot-Saint-Serge"},
    {"city": "Trizay-lès-Bonneval"},
    {"city": "Umpeau"},
    {"city": "Unverre"},
    {"city": "Varize"},
    {"city": "Vaupillon"},
    {"city": "Ver-lès-Chartres"},
    {"city": "Vernouillet"},
    {"city": "Vert-en-Drouais"},
    {"city": "Éole-en-Beauce"},
    {"city": "Vichères"},
    {"city": "Vierville"},
    {"city": "Vieuvicq"},
    {"city": "Villampuy"},
    {"city": "Villars"},
    {"city": "Villebon"},
    {"city": "Villemeux-sur-Eure"},
    {"city": "Villiers-le-Morhier"},
    {"city": "Villiers-Saint-Orien"},
    {"city": "Vitray-en-Beauce"},
    {"city": "Voise"},
    {"city": "Les Villages Vovéens"},
    {"city": "Yermenonville"},
    {"city": "Yèvres"},
    {"city": "Ymeray"},
    {"city": "Ymonville"},
    {"city": "Argol"},
    {"city": "Arzano"},
    {"city": "Audierne"},
    {"city": "Bannalec"},
    {"city": "Baye"},
    {"city": "Bénodet"},
    {"city": "Berrien"},
    {"city": "Beuzec-Cap-Sizun"},
    {"city": "Bodilis"},
    {"city": "Bohars"},
    {"city": "Bolazec"},
    {"city": "Botmeur"},
    {"city": "Botsorhel"},
    {"city": "Bourg-Blanc"},
    {"city": "Brasparts"},
    {"city": "Brélès"},
    {"city": "Brennilis"},
    {"city": "Brest"},
    {"city": "Briec"},
    {"city": "Plounéour-Brignogan-plages"},
    {"city": "Camaret-sur-Mer"},
    {"city": "Carantec"},
    {"city": "Carhaix-Plouguer"},
    {"city": "Cast"},
    {"city": "Châteaulin"},
    {"city": "Châteauneuf-du-Faou"},
    {"city": "Cléden-Cap-Sizun"},
    {"city": "Cléden-Poher"},
    {"city": "Cléder"},
    {"city": "Clohars-Carnoët"},
    {"city": "Clohars-Fouesnant"},
    {"city": "Le Cloître-Pleyben"},
    {"city": "Le Cloître-Saint-Thégonnec"},
    {"city": "Coat-Méal"},
    {"city": "Collorec"},
    {"city": "Combrit"},
    {"city": "Commana"},
    {"city": "Concarneau"},
    {"city": "Le Conquet"},
    {"city": "Coray"},
    {"city": "Crozon"},
    {"city": "Daoulas"},
    {"city": "Dinéault"},
    {"city": "Dirinon"},
    {"city": "Douarnenez"},
    {"city": "Le Drennec"},
    {"city": "Edern"},
    {"city": "Elliant"},
    {"city": "Ergué-Gabéric"},
    {"city": "Le Faou"},
    {"city": "La Feuillée"},
    {"city": "Le Folgoët"},
    {"city": "La Forest-Landerneau"},
    {"city": "La Forêt-Fouesnant"},
    {"city": "Fouesnant"},
    {"city": "Garlan"},
    {"city": "Gouesnach"},
    {"city": "Gouesnou"},
    {"city": "Gouézec"},
    {"city": "Goulien"},
    {"city": "Goulven"},
    {"city": "Gourlizon"},
    {"city": "Guengat"},
    {"city": "Guerlesquin"},
    {"city": "Guiclan"},
    {"city": "Guilers"},
    {"city": "Guiler-sur-Goyen"},
    {"city": "Guilligomarc'h"},
    {"city": "Guilvinec"},
    {"city": "Guimaëc"},
    {"city": "Guimiliau"},
    {"city": "Guipavas"},
    {"city": "Milizac-Guipronvel"},
    {"city": "Guissény"},
    {"city": "Hanvec"},
    {"city": "Henvic"},
    {"city": "Hôpital-Camfrout"},
    {"city": "Huelgoat"},
    {"city": "Île-de-Batz"},
    {"city": "Île-de-Sein"},
    {"city": "Île-Molène"},
    {"city": "Île-Tudy"},
    {"city": "Irvillac"},
    {"city": "Le Juch"},
    {"city": "Kergloff"},
    {"city": "Kerlaz"},
    {"city": "Kerlouan"},
    {"city": "Kernilis"},
    {"city": "Kernouës"},
    {"city": "Kersaint-Plabennec"},
    {"city": "Lampaul-Guimiliau"},
    {"city": "Lampaul-Plouarzel"},
    {"city": "Lampaul-Ploudalmézeau"},
    {"city": "Lanarvily"},
    {"city": "Landéda"},
    {"city": "Landeleau"},
    {"city": "Landerneau"},
    {"city": "Landévennec"},
    {"city": "Landivisiau"},
    {"city": "Landrévarzec"},
    {"city": "Landudal"},
    {"city": "Landudec"},
    {"city": "Landunvez"},
    {"city": "Langolen"},
    {"city": "Lanhouarneau"},
    {"city": "Lanildut"},
    {"city": "Lanmeur"},
    {"city": "Lannéanou"},
    {"city": "Lannédern"},
    {"city": "Lanneuffret"},
    {"city": "Lannilis"},
    {"city": "Lanrivoaré"},
    {"city": "Lanvéoc"},
    {"city": "Laz"},
    {"city": "Lennon"},
    {"city": "Lesneven"},
    {"city": "Leuhan"},
    {"city": "Loc-Brévalaire"},
    {"city": "Loc-Eguiner"},
    {"city": "Locmaria-Plouzané"},
    {"city": "Locmélar"},
    {"city": "Locquénolé"},
    {"city": "Locquirec"},
    {"city": "Locronan"},
    {"city": "Loctudy"},
    {"city": "Locunolé"},
    {"city": "Logonna-Daoulas"},
    {"city": "Lopérec"},
    {"city": "Loperhet"},
    {"city": "Loqueffret"},
    {"city": "Lothey"},
    {"city": "Mahalon"},
    {"city": "La Martyre"},
    {"city": "Confort-Meilars"},
    {"city": "Melgven"},
    {"city": "Mellac"},
    {"city": "Mespaul"},
    {"city": "Moëlan-sur-Mer"},
    {"city": "Morlaix"},
    {"city": "Motreff"},
    {"city": "Névez"},
    {"city": "Ouessant"},
    {"city": "Pencran"},
    {"city": "Penmarch"},
    {"city": "Peumerit"},
    {"city": "Plabennec"},
    {"city": "Pleuven"},
    {"city": "Pleyben"},
    {"city": "Pleyber-Christ"},
    {"city": "Plobannalec-Lesconil"},
    {"city": "Ploéven"},
    {"city": "Plogastel-Saint-Germain"},
    {"city": "Plogoff"},
    {"city": "Plogonnec"},
    {"city": "Plomelin"},
    {"city": "Plomeur"},
    {"city": "Plomodiern"},
    {"city": "Plonéis"},
    {"city": "Plonéour-Lanvern"},
    {"city": "Plonévez-du-Faou"},
    {"city": "Plonévez-Porzay"},
    {"city": "Plouarzel"},
    {"city": "Ploudalmézeau"},
    {"city": "Ploudaniel"},
    {"city": "Ploudiry"},
    {"city": "Plouédern"},
    {"city": "Plouégat-Guérand"},
    {"city": "Plouégat-Moysan"},
    {"city": "Plouénan"},
    {"city": "Plouescat"},
    {"city": "Plouezoc'h"},
    {"city": "Plougar"},
    {"city": "Plougasnou"},
    {"city": "Plougastel-Daoulas"},
    {"city": "Plougonvelin"},
    {"city": "Plougonven"},
    {"city": "Plougoulm"},
    {"city": "Plougourvest"},
    {"city": "Plouguerneau"},
    {"city": "Plouguin"},
    {"city": "Plouhinec"},
    {"city": "Plouider"},
    {"city": "Plouigneau"},
    {"city": "Ploumoguer"},
    {"city": "Plounéour-Ménez"},
    {"city": "Plounéventer"},
    {"city": "Plounévézel"},
    {"city": "Plounévez-Lochrist"},
    {"city": "Plourin-lès-Morlaix"},
    {"city": "Plourin"},
    {"city": "Plouvien"},
    {"city": "Plouvorn"},
    {"city": "Plouyé"},
    {"city": "Plouzané"},
    {"city": "Plouzévédé"},
    {"city": "Plovan"},
    {"city": "Plozévet"},
    {"city": "Pluguffan"},
    {"city": "Pont-Aven"},
    {"city": "Pont-Croix"},
    {"city": "Pont-l'Abbé"},
    {"city": "Porspoder"},
    {"city": "Port-Launay"},
    {"city": "Pouldergat"},
    {"city": "Pouldreuzic"},
    {"city": "Poullan-sur-Mer"},
    {"city": "Poullaouen"},
    {"city": "Primelin"},
    {"city": "Quéménéven"},
    {"city": "Querrien"},
    {"city": "Quimper"},
    {"city": "Quimperlé"},
    {"city": "Rédené"},
    {"city": "Le Relecq-Kerhuon"},
    {"city": "Riec-sur-Bélon"},
    {"city": "La Roche-Maurice"},
    {"city": "Roscanvel"},
    {"city": "Roscoff"},
    {"city": "Rosnoën"},
    {"city": "Rosporden"},
    {"city": "Saint-Coulitz"},
    {"city": "Saint-Derrien"},
    {"city": "Saint-Divy"},
    {"city": "Saint-Eloy"},
    {"city": "Saint-Évarzec"},
    {"city": "Saint-Frégant"},
    {"city": "Saint-Goazec"},
    {"city": "Saint-Hernin"},
    {"city": "Saint-Jean-du-Doigt"},
    {"city": "Saint-Jean-Trolimon"},
    {"city": "Saint-Martin-des-Champs"},
    {"city": "Saint-Méen"},
    {"city": "Saint-Nic"},
    {"city": "Saint-Pabu"},
    {"city": "Saint-Pol-de-Léon"},
    {"city": "Saint-Renan"},
    {"city": "Saint-Rivoal"},
    {"city": "Saint-Sauveur"},
    {"city": "Saint-Ségal"},
    {"city": "Saint-Servais"},
    {"city": "Sainte-Sève"},
    {"city": "Saint-Thégonnec Loc-Eguiner"},
    {"city": "Saint-Thois"},
    {"city": "Saint-Thonan"},
    {"city": "Saint-Thurien"},
    {"city": "Saint-Urbain"},
    {"city": "Saint-Vougay"},
    {"city": "Saint-Yvi"},
    {"city": "Santec"},
    {"city": "Scaër"},
    {"city": "Scrignac"},
    {"city": "Sibiril"},
    {"city": "Sizun"},
    {"city": "Spézet"},
    {"city": "Taulé"},
    {"city": "Telgruc-sur-Mer"},
    {"city": "Tourch"},
    {"city": "Trébabu"},
    {"city": "Treffiagat"},
    {"city": "Tréflaouénan"},
    {"city": "Tréflévénez"},
    {"city": "Tréflez"},
    {"city": "Trégarantec"},
    {"city": "Trégarvan"},
    {"city": "Tréglonou"},
    {"city": "Trégourez"},
    {"city": "Tréguennec"},
    {"city": "Trégunc"},
    {"city": "Le Tréhou"},
    {"city": "Trémaouézan"},
    {"city": "Tréméoc"},
    {"city": "Tréméven"},
    {"city": "Tréogat"},
    {"city": "Tréouergat"},
    {"city": "Le Trévoux"},
    {"city": "Trézilidé"},
    {"city": "Pont-de-Buis-lès-Quimerch"},
    {"department": "2A", "city": "Afa"},
    {"department": "2A", "city": "Ajaccio"},
    {"department": "2A", "city": "Alata"},
    {"department": "2A", "city": "Albitreccia"},
    {"department": "2A", "city": "Altagène"},
    {"department": "2A", "city": "Ambiegna"},
    {"department": "2A", "city": "Appietto"},
    {"department": "2A", "city": "Arbellara"},
    {"department": "2A", "city": "Arbori"},
    {"department": "2A", "city": "Argiusta-Moriccio"},
    {"department": "2A", "city": "Arro"},
    {"department": "2A", "city": "Aullène"},
    {"department": "2A", "city": "Azilone-Ampaza"},
    {"department": "2A", "city": "Azzana"},
    {"department": "2A", "city": "Balogna"},
    {"department": "2A", "city": "Bastelica"},
    {"department": "2A", "city": "Bastelicaccia"},
    {"department": "2A", "city": "Belvédère-Campomoro"},
    {"department": "2A", "city": "Bilia"},
    {"department": "2A", "city": "Bocognano"},
    {"department": "2A", "city": "Bonifacio"},
    {"department": "2A", "city": "Calcatoggio"},
    {"department": "2A", "city": "Campo"},
    {"department": "2A", "city": "Cannelle"},
    {"department": "2A", "city": "Carbini"},
    {"department": "2A", "city": "Carbuccia"},
    {"department": "2A", "city": "Cardo-Torgia"},
    {"department": "2A", "city": "Cargèse"},
    {"department": "2A", "city": "Cargiaca"},
    {"department": "2A", "city": "Casaglione"},
    {"department": "2A", "city": "Casalabriva"},
    {"department": "2A", "city": "Cauro"},
    {"department": "2A", "city": "Ciamannacce"},
    {"department": "2A", "city": "Coggia"},
    {"department": "2A", "city": "Cognocoli-Monticchi"},
    {"department": "2A", "city": "Conca"},
    {"department": "2A", "city": "Corrano"},
    {"department": "2A", "city": "Coti-Chiavari"},
    {"department": "2A", "city": "Cozzano"},
    {"department": "2A", "city": "Cristinacce"},
    {"department": "2A", "city": "Cuttoli-Corticchiato"},
    {"department": "2A", "city": "Eccica-Suarella"},
    {"department": "2A", "city": "Évisa"},
    {"department": "2A", "city": "Figari"},
    {"department": "2A", "city": "Foce"},
    {"department": "2A", "city": "Forciolo"},
    {"department": "2A", "city": "Fozzano"},
    {"department": "2A", "city": "Frasseto"},
    {"department": "2A", "city": "Giuncheto"},
    {"department": "2A", "city": "Granace"},
    {"department": "2A", "city": "Grossa"},
    {"department": "2A", "city": "Grosseto-Prugna"},
    {"department": "2A", "city": "Guagno"},
    {"department": "2A", "city": "Guargualé"},
    {"department": "2A", "city": "Guitera-les-Bains"},
    {"department": "2A", "city": "Lecci"},
    {"department": "2A", "city": "Letia"},
    {"department": "2A", "city": "Levie"},
    {"department": "2A", "city": "Lopigna"},
    {"department": "2A", "city": "Loreto-di-Tallano"},
    {"department": "2A", "city": "Marignana"},
    {"department": "2A", "city": "Mela"},
    {"department": "2A", "city": "Moca-Croce"},
    {"department": "2A", "city": "Monacia-d'Aullène"},
    {"department": "2A", "city": "Murzo"},
    {"department": "2A", "city": "Ocana"},
    {"department": "2A", "city": "Olivese"},
    {"department": "2A", "city": "Olmeto"},
    {"department": "2A", "city": "Olmiccia"},
    {"department": "2A", "city": "Orto"},
    {"department": "2A", "city": "Osani"},
    {"department": "2A", "city": "Ota"},
    {"department": "2A", "city": "Palneca"},
    {"department": "2A", "city": "Partinello"},
    {"department": "2A", "city": "Pastricciola"},
    {"department": "2A", "city": "Peri"},
    {"department": "2A", "city": "Petreto-Bicchisano"},
    {"department": "2A", "city": "Piana"},
    {"department": "2A", "city": "Pianottoli-Caldarello"},
    {"department": "2A", "city": "Pietrosella"},
    {"department": "2A", "city": "Pila-Canale"},
    {"department": "2A", "city": "Poggiolo"},
    {"department": "2A", "city": "Porto-Vecchio"},
    {"department": "2A", "city": "Propriano"},
    {"department": "2A", "city": "Quasquara"},
    {"department": "2A", "city": "Quenza"},
    {"department": "2A", "city": "Renno"},
    {"department": "2A", "city": "Rezza"},
    {"department": "2A", "city": "Rosazia"},
    {"department": "2A", "city": "Salice"},
    {"department": "2A", "city": "Sampolo"},
    {"department": "2A", "city": "Sari-Solenzara"},
    {"department": "2A", "city": "Sari-d'Orcino"},
    {"department": "2A", "city": "Sarrola-Carcopino"},
    {"department": "2A", "city": "Sartène"},
    {"department": "2A", "city": "Serra-di-Ferro"},
    {"department": "2A", "city": "Serra-di-Scopamène"},
    {"department": "2A", "city": "Serriera"},
    {"department": "2A", "city": "Soccia"},
    {"department": "2A", "city": "Sollacaro"},
    {"department": "2A", "city": "Sorbollano"},
    {"department": "2A", "city": "Sotta"},
    {"department": "2A", "city": "Sant'Andréa-d'Orcino"},
    {"department": "2A", "city": "San-Gavino-di-Carbini"},
    {"department": "2A", "city": "Sainte-Lucie-de-Tallano"},
    {"department": "2A", "city": "Santa-Maria-Figaniella"},
    {"department": "2A", "city": "Santa-Maria-Siché"},
    {"department": "2A", "city": "Tasso"},
    {"department": "2A", "city": "Tavaco"},
    {"department": "2A", "city": "Tavera"},
    {"department": "2A", "city": "Tolla"},
    {"department": "2A", "city": "Ucciani"},
    {"department": "2A", "city": "Urbalacone"},
    {"department": "2A", "city": "Valle-di-Mezzana"},
    {"department": "2A", "city": "Vero"},
    {"department": "2A", "city": "Vico"},
    {"department": "2A", "city": "Viggianello"},
    {"department": "2A", "city": "Villanova"},
    {"department": "2A", "city": "Zérubia"},
    {"department": "2A", "city": "Zévaco"},
    {"department": "2A", "city": "Zicavo"},
    {"department": "2A", "city": "Zigliara"},
    {"department": "2A", "city": "Zonza"},
    {"department": "2A", "city": "Zoza"},
    {"department": "2B", "city": "Aghione"},
    {"department": "2B", "city": "Aiti"},
    {"department": "2B", "city": "Alando"},
    {"department": "2B", "city": "Albertacce"},
    {"department": "2B", "city": "Aléria"},
    {"department": "2B", "city": "Algajola"},
    {"department": "2B", "city": "Altiani"},
    {"department": "2B", "city": "Alzi"},
    {"department": "2B", "city": "Ampriani"},
    {"department": "2B", "city": "Antisanti"},
    {"department": "2B", "city": "Aregno"},
    {"department": "2B", "city": "Asco"},
    {"department": "2B", "city": "Avapessa"},
    {"department": "2B", "city": "Barbaggio"},
    {"department": "2B", "city": "Barrettali"},
    {"department": "2B", "city": "Bastia"},
    {"department": "2B", "city": "Belgodère"},
    {"department": "2B", "city": "Bigorno"},
    {"department": "2B", "city": "Biguglia"},
    {"department": "2B", "city": "Bisinchi"},
    {"department": "2B", "city": "Borgo"},
    {"department": "2B", "city": "Brando"},
    {"department": "2B", "city": "Bustanico"},
    {"department": "2B", "city": "Cagnano"},
    {"department": "2B", "city": "Calacuccia"},
    {"department": "2B", "city": "Calenzana"},
    {"department": "2B", "city": "Calvi"},
    {"department": "2B", "city": "Cambia"},
    {"department": "2B", "city": "Campana"},
    {"department": "2B", "city": "Campi"},
    {"department": "2B", "city": "Campile"},
    {"department": "2B", "city": "Campitello"},
    {"department": "2B", "city": "Canale-di-Verde"},
    {"department": "2B", "city": "Canari"},
    {"department": "2B", "city": "Canavaggia"},
    {"department": "2B", "city": "Carcheto-Brustico"},
    {"department": "2B", "city": "Carpineto"},
    {"department": "2B", "city": "Carticasi"},
    {"department": "2B", "city": "Casabianca"},
    {"department": "2B", "city": "Casalta"},
    {"department": "2B", "city": "Casamaccioli"},
    {"department": "2B", "city": "Casanova"},
    {"department": "2B", "city": "Casevecchie"},
    {"department": "2B", "city": "Castellare-di-Casinca"},
    {"department": "2B", "city": "Castellare-di-Mercurio"},
    {"department": "2B", "city": "Castello-di-Rostino"},
    {"department": "2B", "city": "Castifao"},
    {"department": "2B", "city": "Castiglione"},
    {"department": "2B", "city": "Castineta"},
    {"department": "2B", "city": "Castirla"},
    {"department": "2B", "city": "Cateri"},
    {"department": "2B", "city": "Centuri"},
    {"department": "2B", "city": "Cervione"},
    {"department": "2B", "city": "Chiatra"},
    {"department": "2B", "city": "Corbara"},
    {"department": "2B", "city": "Corscia"},
    {"department": "2B", "city": "Corte"},
    {"department": "2B", "city": "Costa"},
    {"department": "2B", "city": "Croce"},
    {"department": "2B", "city": "Crocicchia"},
    {"department": "2B", "city": "Erbajolo"},
    {"department": "2B", "city": "Érone"},
    {"department": "2B", "city": "Ersa"},
    {"department": "2B", "city": "Farinole"},
    {"department": "2B", "city": "Favalello"},
    {"department": "2B", "city": "Felce"},
    {"department": "2B", "city": "Feliceto"},
    {"department": "2B", "city": "Ficaja"},
    {"department": "2B", "city": "Focicchia"},
    {"department": "2B", "city": "Furiani"},
    {"department": "2B", "city": "Galéria"},
    {"department": "2B", "city": "Gavignano"},
    {"department": "2B", "city": "Ghisonaccia"},
    {"department": "2B", "city": "Ghisoni"},
    {"department": "2B", "city": "Giocatojo"},
    {"department": "2B", "city": "Giuncaggio"},
    {"department": "2B", "city": "L'Île-Rousse"},
    {"department": "2B", "city": "Isolaccio-di-Fiumorbo"},
    {"department": "2B", "city": "Lama"},
    {"department": "2B", "city": "Lano"},
    {"department": "2B", "city": "Lavatoggio"},
    {"department": "2B", "city": "Lento"},
    {"department": "2B", "city": "Linguizzetta"},
    {"department": "2B", "city": "Loreto-di-Casinca"},
    {"department": "2B", "city": "Lozzi"},
    {"department": "2B", "city": "Lucciana"},
    {"department": "2B", "city": "Lugo-di-Nazza"},
    {"department": "2B", "city": "Lumio"},
    {"department": "2B", "city": "Luri"},
    {"department": "2B", "city": "Manso"},
    {"department": "2B", "city": "Matra"},
    {"department": "2B", "city": "Mausoléo"},
    {"department": "2B", "city": "Mazzola"},
    {"department": "2B", "city": "Meria"},
    {"department": "2B", "city": "Moïta"},
    {"department": "2B", "city": "Moltifao"},
    {"department": "2B", "city": "Monacia-d'Orezza"},
    {"department": "2B", "city": "Moncale"},
    {"department": "2B", "city": "Monte"},
    {"department": "2B", "city": "Montegrosso"},
    {"department": "2B", "city": "Monticello"},
    {"department": "2B", "city": "Morosaglia"},
    {"department": "2B", "city": "Morsiglia"},
    {"department": "2B", "city": "Muracciole"},
    {"department": "2B", "city": "Murato"},
    {"department": "2B", "city": "Muro"},
    {"department": "2B", "city": "Nessa"},
    {"department": "2B", "city": "Nocario"},
    {"department": "2B", "city": "Noceta"},
    {"department": "2B", "city": "Nonza"},
    {"department": "2B", "city": "Novale"},
    {"department": "2B", "city": "Novella"},
    {"department": "2B", "city": "Occhiatana"},
    {"department": "2B", "city": "Ogliastro"},
    {"department": "2B", "city": "Olcani"},
    {"department": "2B", "city": "Oletta"},
    {"department": "2B", "city": "Olmeta-di-Capocorso"},
    {"department": "2B", "city": "Olmeta-di-Tuda"},
    {"department": "2B", "city": "Olmi-Cappella"},
    {"department": "2B", "city": "Olmo"},
    {"department": "2B", "city": "Omessa"},
    {"department": "2B", "city": "Ortale"},
    {"department": "2B", "city": "Ortiporio"},
    {"department": "2B", "city": "Palasca"},
    {"department": "2B", "city": "Pancheraccia"},
    {"department": "2B", "city": "Parata"},
    {"department": "2B", "city": "Patrimonio"},
    {"department": "2B", "city": "Penta-Acquatella"},
    {"department": "2B", "city": "Penta-di-Casinca"},
    {"department": "2B", "city": "Perelli"},
    {"department": "2B", "city": "Pero-Casevecchie"},
    {"department": "2B", "city": "Pianello"},
    {"department": "2B", "city": "Piano"},
    {"department": "2B", "city": "Piazzali"},
    {"department": "2B", "city": "Piazzole"},
    {"department": "2B", "city": "Piedicorte-di-Gaggio"},
    {"department": "2B", "city": "Piedicroce"},
    {"department": "2B", "city": "Piedigriggio"},
    {"department": "2B", "city": "Piedipartino"},
    {"department": "2B", "city": "Pie-d'Orezza"},
    {"department": "2B", "city": "Pietralba"},
    {"department": "2B", "city": "Pietracorbara"},
    {"department": "2B", "city": "Pietra-di-Verde"},
    {"department": "2B", "city": "Pietraserena"},
    {"department": "2B", "city": "Pietricaggio"},
    {"department": "2B", "city": "Pietroso"},
    {"department": "2B", "city": "Piève"},
    {"department": "2B", "city": "Pigna"},
    {"department": "2B", "city": "Pino"},
    {"department": "2B", "city": "Piobetta"},
    {"department": "2B", "city": "Pioggiola"},
    {"department": "2B", "city": "Poggio-di-Nazza"},
    {"department": "2B", "city": "Poggio-di-Venaco"},
    {"department": "2B", "city": "Poggio-d'Oletta"},
    {"department": "2B", "city": "Poggio-Marinaccio"},
    {"department": "2B", "city": "Poggio-Mezzana"},
    {"department": "2B", "city": "Polveroso"},
    {"department": "2B", "city": "Popolasca"},
    {"department": "2B", "city": "Porri"},
    {"department": "2B", "city": "La Porta"},
    {"department": "2B", "city": "Prato-di-Giovellina"},
    {"department": "2B", "city": "Prunelli-di-Casacconi"},
    {"department": "2B", "city": "Prunelli-di-Fiumorbo"},
    {"department": "2B", "city": "Pruno"},
    {"department": "2B", "city": "Quercitello"},
    {"department": "2B", "city": "Rapaggio"},
    {"department": "2B", "city": "Rapale"},
    {"department": "2B", "city": "Riventosa"},
    {"department": "2B", "city": "Rogliano"},
    {"department": "2B", "city": "Rospigliani"},
    {"department": "2B", "city": "Rusio"},
    {"department": "2B", "city": "Rutali"},
    {"department": "2B", "city": "Saliceto"},
    {"department": "2B", "city": "Scata"},
    {"department": "2B", "city": "Scolca"},
    {"department": "2B", "city": "Sermano"},
    {"department": "2B", "city": "Serra-di-Fiumorbo"},
    {"department": "2B", "city": "Silvareccio"},
    {"department": "2B", "city": "Sisco"},
    {"department": "2B", "city": "Solaro"},
    {"department": "2B", "city": "Sorbo-Ocagnano"},
    {"department": "2B", "city": "Sorio"},
    {"department": "2B", "city": "Soveria"},
    {"department": "2B", "city": "Speloncato"},
    {"department": "2B", "city": "Stazzona"},
    {"department": "2B", "city": "Sant'Andréa-di-Bozio"},
    {"department": "2B", "city": "Sant'Andréa-di-Cotone"},
    {"department": "2B", "city": "Sant'Antonino"},
    {"department": "2B", "city": "San-Damiano"},
    {"department": "2B", "city": "Saint-Florent"},
    {"department": "2B", "city": "San-Gavino-d'Ampugnani"},
    {"department": "2B", "city": "San-Gavino-di-Tenda"},
    {"department": "2B", "city": "San-Giovanni-di-Moriani"},
    {"department": "2B", "city": "San-Giuliano"},
    {"department": "2B", "city": "San-Lorenzo"},
    {"department": "2B", "city": "San-Martino-di-Lota"},
    {"department": "2B", "city": "Santa-Lucia-di-Mercurio"},
    {"department": "2B", "city": "Santa-Lucia-di-Moriani"},
    {"department": "2B", "city": "Santa-Maria-di-Lota"},
    {"department": "2B", "city": "Santa-Maria-Poggio"},
    {"department": "2B", "city": "San-Nicolao"},
    {"department": "2B", "city": "Santo-Pietro-di-Tenda"},
    {"department": "2B", "city": "Santo-Pietro-di-Venaco"},
    {"department": "2B", "city": "Santa-Reparata-di-Balagna"},
    {"department": "2B", "city": "Santa-Reparata-di-Moriani"},
    {"department": "2B", "city": "Taglio-Isolaccio"},
    {"department": "2B", "city": "Talasani"},
    {"department": "2B", "city": "Tallone"},
    {"department": "2B", "city": "Tarrano"},
    {"department": "2B", "city": "Tomino"},
    {"department": "2B", "city": "Tox"},
    {"department": "2B", "city": "Tralonca"},
    {"department": "2B", "city": "Urtaca"},
    {"department": "2B", "city": "Vallecalle"},
    {"department": "2B", "city": "Valle-d'Alesani"},
    {"department": "2B", "city": "Valle-di-Campoloro"},
    {"department": "2B", "city": "Valle-di-Rostino"},
    {"department": "2B", "city": "Valle-d'Orezza"},
    {"department": "2B", "city": "Vallica"},
    {"department": "2B", "city": "Velone-Orneto"},
    {"department": "2B", "city": "Venaco"},
    {"department": "2B", "city": "Ventiseri"},
    {"department": "2B", "city": "Venzolasca"},
    {"department": "2B", "city": "Verdèse"},
    {"department": "2B", "city": "Vescovato"},
    {"department": "2B", "city": "Vezzani"},
    {"department": "2B", "city": "Vignale"},
    {"department": "2B", "city": "Ville-di-Paraso"},
    {"department": "2B", "city": "Ville-di-Pietrabugno"},
    {"department": "2B", "city": "Vivario"},
    {"department": "2B", "city": "Volpajola"},
    {"department": "2B", "city": "Zalana"},
    {"department": "2B", "city": "Zilia"},
    {"department": "2B", "city": "Zuani"},
    {"department": "2B", "city": "San-Gavino-di-Fiumorbo"},
    {"department": "2B", "city": "Chisa"},
    {"city": "Aigaliers"},
    {"city": "Aigremont"},
    {"city": "Aigues-Mortes"},
    {"city": "Aigues-Vives"},
    {"city": "Aiguèze"},
    {"city": "Aimargues"},
    {"city": "Alès"},
    {"city": "Allègre-les-Fumades"},
    {"city": "Alzon"},
    {"city": "Anduze"},
    {"city": "Les Angles"},
    {"city": "Aramon"},
    {"city": "Argilliers"},
    {"city": "Arpaillargues-et-Aureillac"},
    {"city": "Arphy"},
    {"city": "Arre"},
    {"city": "Arrigas"},
    {"city": "Aspères"},
    {"city": "Aubais"},
    {"city": "Aubord"},
    {"city": "Aubussargues"},
    {"city": "Aujac"},
    {"city": "Aujargues"},
    {"city": "Aulas"},
    {"city": "Aumessas"},
    {"city": "Avèze"},
    {"city": "Bagard"},
    {"city": "Bagnols-sur-Cèze"},
    {"city": "Barjac"},
    {"city": "Baron"},
    {"city": "La Bastide-d'Engras"},
    {"city": "Beaucaire"},
    {"city": "Beauvoisin"},
    {"city": "Bellegarde"},
    {"city": "Belvézet"},
    {"city": "Bernis"},
    {"city": "Bessèges"},
    {"city": "Bez-et-Esparon"},
    {"city": "Bezouce"},
    {"city": "Blandas"},
    {"city": "Blauzac"},
    {"city": "Boisset-et-Gaujac"},
    {"city": "Boissières"},
    {"city": "Bonnevaux"},
    {"city": "Bordezac"},
    {"city": "Boucoiran-et-Nozières"},
    {"city": "Bouillargues"},
    {"city": "Bouquet"},
    {"city": "Bourdic"},
    {"city": "Bragassargues"},
    {"city": "Branoux-les-Taillades"},
    {"city": "Bréau-Mars"},
    {"city": "Brignon"},
    {"city": "Brouzet-lès-Quissac"},
    {"city": "Brouzet-lès-Alès"},
    {"city": "La Bruguière"},
    {"city": "Cabrières"},
    {"city": "La Cadière-et-Cambo"},
    {"city": "Le Cailar"},
    {"city": "Caissargues"},
    {"city": "La Calmette"},
    {"city": "Calvisson"},
    {"city": "Campestre-et-Luc"},
    {"city": "Canaules-et-Argentières"},
    {"city": "Cannes-et-Clairan"},
    {"city": "La Capelle-et-Masmolène"},
    {"city": "Cardet"},
    {"city": "Carnas"},
    {"city": "Carsan"},
    {"city": "Cassagnoles"},
    {"city": "Castelnau-Valence"},
    {"city": "Castillon-du-Gard"},
    {"city": "Causse-Bégon"},
    {"city": "Caveirac"},
    {"city": "Cavillargues"},
    {"city": "Cendras"},
    {"city": "Chambon"},
    {"city": "Chamborigaud"},
    {"city": "Chusclan"},
    {"city": "Clarensac"},
    {"city": "Codognan"},
    {"city": "Codolet"},
    {"city": "Collias"},
    {"city": "Collorgues"},
    {"city": "Colognac"},
    {"city": "Combas"},
    {"city": "Comps"},
    {"city": "Concoules"},
    {"city": "Congénies"},
    {"city": "Connaux"},
    {"city": "Conqueyrac"},
    {"city": "Corbès"},
    {"city": "Corconne"},
    {"city": "Cornillon"},
    {"city": "Courry"},
    {"city": "Crespian"},
    {"city": "Cros"},
    {"city": "Cruviers-Lascours"},
    {"city": "Deaux"},
    {"city": "Dions"},
    {"city": "Domazan"},
    {"city": "Domessargues"},
    {"city": "Dourbies"},
    {"city": "Durfort-et-Saint-Martin-de-Sossenac"},
    {"city": "Estézargues"},
    {"city": "L'Estréchure"},
    {"city": "Euzet"},
    {"city": "Flaux"},
    {"city": "Foissac"},
    {"city": "Fons"},
    {"city": "Fons-sur-Lussan"},
    {"city": "Fontanès"},
    {"city": "Fontarèches"},
    {"city": "Fournès"},
    {"city": "Fourques"},
    {"city": "Fressac"},
    {"city": "Gagnières"},
    {"city": "Gailhan"},
    {"city": "Gajan"},
    {"city": "Gallargues-le-Montueux"},
    {"city": "Le Garn"},
    {"city": "Garons"},
    {"city": "Garrigues-Sainte-Eulalie"},
    {"city": "Gaujac"},
    {"city": "Générac"},
    {"city": "Générargues"},
    {"city": "Génolhac"},
    {"city": "Goudargues"},
    {"city": "La Grand-Combe"},
    {"city": "Le Grau-du-Roi"},
    {"city": "Issirac"},
    {"city": "Jonquières-Saint-Vincent"},
    {"city": "Junas"},
    {"city": "Lamelouze"},
    {"city": "Langlade"},
    {"city": "Lanuéjols"},
    {"city": "Lasalle"},
    {"city": "Laudun-l'Ardoise"},
    {"city": "Laval-Pradel"},
    {"city": "Laval-Saint-Roman"},
    {"city": "Lecques"},
    {"city": "Lédenon"},
    {"city": "Lédignan"},
    {"city": "Lézan"},
    {"city": "Liouc"},
    {"city": "Lirac"},
    {"city": "Logrian-Florian"},
    {"city": "Lussan"},
    {"city": "Les Mages"},
    {"city": "Malons-et-Elze"},
    {"city": "Mandagout"},
    {"city": "Manduel"},
    {"city": "Marguerittes"},
    {"city": "Martignargues"},
    {"city": "Le Martinet"},
    {"city": "Maruéjols-lès-Gardon"},
    {"city": "Massanes"},
    {"city": "Massillargues-Attuech"},
    {"city": "Mauressargues"},
    {"city": "Méjannes-le-Clap"},
    {"city": "Méjannes-lès-Alès"},
    {"city": "Meynes"},
    {"city": "Meyrannes"},
    {"city": "Mialet"},
    {"city": "Milhaud"},
    {"city": "Molières-Cavaillac"},
    {"city": "Molières-sur-Cèze"},
    {"city": "Monoblet"},
    {"city": "Mons"},
    {"city": "Montaren-et-Saint-Médiers"},
    {"city": "Montclus"},
    {"city": "Montdardier"},
    {"city": "Monteils"},
    {"city": "Montfaucon"},
    {"city": "Montfrin"},
    {"city": "Montignargues"},
    {"city": "Montmirat"},
    {"city": "Montpezat"},
    {"city": "Moulézan"},
    {"city": "Moussac"},
    {"city": "Mus"},
    {"city": "Nages-et-Solorgues"},
    {"city": "Navacelles"},
    {"city": "Ners"},
    {"city": "Nîmes"},
    {"city": "Orsan"},
    {"city": "Orthoux-Sérignac-Quilhan"},
    {"city": "Parignargues"},
    {"city": "Peyremale"},
    {"city": "Peyrolles"},
    {"city": "Le Pin"},
    {"city": "Les Plans"},
    {"city": "Les Plantiers"},
    {"city": "Pommiers"},
    {"city": "Pompignan"},
    {"city": "Ponteils-et-Brésis"},
    {"city": "Pont-Saint-Esprit"},
    {"city": "Portes"},
    {"city": "Potelières"},
    {"city": "Pougnadoresse"},
    {"city": "Poulx"},
    {"city": "Pouzilhac"},
    {"city": "Puechredon"},
    {"city": "Pujaut"},
    {"city": "Quissac"},
    {"city": "Redessan"},
    {"city": "Remoulins"},
    {"city": "Revens"},
    {"city": "Ribaute-les-Tavernes"},
    {"city": "Rivières"},
    {"city": "Robiac-Rochessadoule"},
    {"city": "Rochefort-du-Gard"},
    {"city": "Rochegude"},
    {"city": "Rogues"},
    {"city": "Roquedur"},
    {"city": "Roquemaure"},
    {"city": "La Roque-sur-Cèze"},
    {"city": "Rousson"},
    {"city": "La Rouvière"},
    {"city": "Sabran"},
    {"city": "Saint-Alexandre"},
    {"city": "Saint-Ambroix"},
    {"city": "Sainte-Anastasie"},
    {"city": "Saint-André-de-Majencoules"},
    {"city": "Saint-André-de-Roquepertuis"},
    {"city": "Saint-André-de-Valborgne"},
    {"city": "Saint-André-d'Olérargues"},
    {"city": "Saint-Bauzély"},
    {"city": "Saint-Bénézet"},
    {"city": "Saint-Bonnet-du-Gard"},
    {"city": "Saint-Bonnet-de-Salendrinque"},
    {"city": "Saint-Brès"},
    {"city": "Saint-Bresson"},
    {"city": "Sainte-Cécile-d'Andorge"},
    {"city": "Saint-Césaire-de-Gauzignan"},
    {"city": "Saint-Chaptes"},
    {"city": "Saint-Christol-de-Rodières"},
    {"city": "Saint-Christol-lez-Alès"},
    {"city": "Saint-Clément"},
    {"city": "Saint-Côme-et-Maruéjols"},
    {"city": "Sainte-Croix-de-Caderle"},
    {"city": "Saint-Denis"},
    {"city": "Saint-Dézéry"},
    {"city": "Saint-Dionisy"},
    {"city": "Saint-Étienne-de-l'Olm"},
    {"city": "Saint-Étienne-des-Sorts"},
    {"city": "Saint-Félix-de-Pallières"},
    {"city": "Saint-Florent-sur-Auzonnet"},
    {"city": "Saint-Geniès-de-Comolas"},
    {"city": "Saint-Geniès-de-Malgoirès"},
    {"city": "Saint-Gervais"},
    {"city": "Saint-Gervasy"},
    {"city": "Saint-Gilles"},
    {"city": "Saint-Hilaire-de-Brethmas"},
    {"city": "Saint-Hilaire-d'Ozilhan"},
    {"city": "Saint-Hippolyte-de-Caton"},
    {"city": "Saint-Hippolyte-de-Montaigu"},
    {"city": "Saint-Hippolyte-du-Fort"},
    {"city": "Saint-Jean-de-Ceyrargues"},
    {"city": "Saint-Jean-de-Crieulon"},
    {"city": "Saint-Jean-de-Maruéjols-et-Avéjan"},
    {"city": "Saint-Jean-de-Serres"},
    {"city": "Saint-Jean-de-Valériscle"},
    {"city": "Saint-Jean-du-Gard"},
    {"city": "Saint-Jean-du-Pin"},
    {"city": "Saint-Julien-de-Cassagnas"},
    {"city": "Saint-Julien-de-la-Nef"},
    {"city": "Saint-Julien-de-Peyrolas"},
    {"city": "Saint-Julien-les-Rosiers"},
    {"city": "Saint-Just-et-Vacquières"},
    {"city": "Saint-Laurent-d'Aigouze"},
    {"city": "Saint-Laurent-de-Carnols"},
    {"city": "Saint-Laurent-des-Arbres"},
    {"city": "Saint-Laurent-la-Vernède"},
    {"city": "Saint-Laurent-le-Minier"},
    {"city": "Saint-Mamert-du-Gard"},
    {"city": "Saint-Marcel-de-Careiret"},
    {"city": "Saint-Martial"},
    {"city": "Saint-Martin-de-Valgalgues"},
    {"city": "Saint-Maurice-de-Cazevieille"},
    {"city": "Saint-Maximin"},
    {"city": "Saint-Michel-d'Euzet"},
    {"city": "Saint-Nazaire"},
    {"city": "Saint-Nazaire-des-Gardies"},
    {"city": "Saint-Paulet-de-Caisson"},
    {"city": "Saint-Paul-la-Coste"},
    {"city": "Saint-Pons-la-Calm"},
    {"city": "Saint-Privat-de-Champclos"},
    {"city": "Saint-Privat-des-Vieux"},
    {"city": "Saint-Quentin-la-Poterie"},
    {"city": "Saint-Roman-de-Codières"},
    {"city": "Saint-Sauveur-Camprieu"},
    {"city": "Saint-Sébastien-d'Aigrefeuille"},
    {"city": "Saint-Siffret"},
    {"city": "Saint-Théodorit"},
    {"city": "Saint-Victor-des-Oules"},
    {"city": "Saint-Victor-la-Coste"},
    {"city": "Saint-Victor-de-Malcap"},
    {"city": "Salazac"},
    {"city": "Salindres"},
    {"city": "Salinelles"},
    {"city": "Les Salles-du-Gardon"},
    {"city": "Sanilhac-Sagriès"},
    {"city": "Sardan"},
    {"city": "Saumane"},
    {"city": "Sauve"},
    {"city": "Sauveterre"},
    {"city": "Sauzet"},
    {"city": "Savignargues"},
    {"city": "Saze"},
    {"city": "Sénéchas"},
    {"city": "Sernhac"},
    {"city": "Servas"},
    {"city": "Serviers-et-Labaume"},
    {"city": "Seynes"},
    {"city": "Sommières"},
    {"city": "Soudorgues"},
    {"city": "Soustelle"},
    {"city": "Souvignargues"},
    {"city": "Sumène"},
    {"city": "Tavel"},
    {"city": "Tharaux"},
    {"city": "Théziers"},
    {"city": "Thoiras"},
    {"city": "Tornac"},
    {"city": "Tresques"},
    {"city": "Trèves"},
    {"city": "Uchaud"},
    {"city": "Uzès"},
    {"city": "Vabres"},
    {"city": "Vallabrègues"},
    {"city": "Vallabrix"},
    {"city": "Vallérargues"},
    {"city": "Val-d'Aigoual"},
    {"city": "Valliguières"},
    {"city": "Vauvert"},
    {"city": "Vénéjan"},
    {"city": "Verfeuil"},
    {"city": "Vergèze"},
    {"city": "La Vernarède"},
    {"city": "Vers-Pont-du-Gard"},
    {"city": "Vestric-et-Candiac"},
    {"city": "Vézénobres"},
    {"city": "Vic-le-Fesq"},
    {"city": "Le Vigan"},
    {"city": "Villeneuve-lès-Avignon"},
    {"city": "Villevieille"},
    {"city": "Vissec"},
    {"city": "Montagnac"},
    {"city": "Saint-Paul-les-Fonts"},
    {"city": "Rodilhan"},
    {"city": "Agassac"},
    {"city": "Aignes"},
    {"city": "Aigrefeuille"},
    {"city": "Ayguesvives"},
    {"city": "Alan"},
    {"city": "Albiac"},
    {"city": "Ambax"},
    {"city": "Anan"},
    {"city": "Antichan-de-Frontignes"},
    {"city": "Antignac"},
    {"city": "Arbas"},
    {"city": "Arbon"},
    {"city": "Ardiège"},
    {"city": "Arguenos"},
    {"city": "Argut-Dessous"},
    {"city": "Arlos"},
    {"city": "Arnaud-Guilhem"},
    {"city": "Artigue"},
    {"city": "Aspet"},
    {"city": "Aspret-Sarrat"},
    {"city": "Aucamville"},
    {"city": "Aulon"},
    {"city": "Auragne"},
    {"city": "Aureville"},
    {"city": "Auriac-sur-Vendinelle"},
    {"city": "Auribail"},
    {"city": "Aurignac"},
    {"city": "Aurin"},
    {"city": "Ausseing"},
    {"city": "Ausson"},
    {"city": "Aussonne"},
    {"city": "Auterive"},
    {"city": "Auzas"},
    {"city": "Auzeville-Tolosane"},
    {"city": "Auzielle"},
    {"city": "Avignonet-Lauragais"},
    {"city": "Azas"},
    {"city": "Bachas"},
    {"city": "Bachos"},
    {"city": "Bagiry"},
    {"city": "Bagnères-de-Luchon"},
    {"city": "Balesta"},
    {"city": "Balma"},
    {"city": "Barbazan"},
    {"city": "Baren"},
    {"city": "Bax"},
    {"city": "Baziège"},
    {"city": "Bazus"},
    {"city": "Beauchalot"},
    {"city": "Beaufort"},
    {"city": "Beaumont-sur-Lèze"},
    {"city": "Beaupuy"},
    {"city": "Beauteville"},
    {"city": "Beauville"},
    {"city": "Beauzelle"},
    {"city": "Belberaud"},
    {"city": "Belbèze-de-Lauragais"},
    {"city": "Belbèze-en-Comminges"},
    {"city": "Bélesta-en-Lauragais"},
    {"city": "Bellegarde-Sainte-Marie"},
    {"city": "Bellesserre"},
    {"city": "Benque"},
    {"city": "Benque-Dessous-et-Dessus"},
    {"city": "Bérat"},
    {"city": "Bessières"},
    {"city": "Bezins-Garraux"},
    {"city": "Billière"},
    {"city": "Blagnac"},
    {"city": "Blajan"},
    {"city": "Bois-de-la-Pierre"},
    {"city": "Boissède"},
    {"city": "Bondigoux"},
    {"city": "Bonrepos-Riquet"},
    {"city": "Bonrepos-sur-Aussonnelle"},
    {"city": "Bordes-de-Rivière"},
    {"city": "Le Born"},
    {"city": "Boudrac"},
    {"city": "Bouloc"},
    {"city": "Boulogne-sur-Gesse"},
    {"city": "Bourg-d'Oueil"},
    {"city": "Bourg-Saint-Bernard"},
    {"city": "Boussan"},
    {"city": "Boussens"},
    {"city": "Boutx"},
    {"city": "Bouzin"},
    {"city": "Bragayrac"},
    {"city": "Brax"},
    {"city": "Bretx"},
    {"city": "Brignemont"},
    {"city": "Bruguières"},
    {"city": "Burgalays"},
    {"city": "Le Burgaud"},
    {"city": "Buzet-sur-Tarn"},
    {"city": "Cabanac-Cazaux"},
    {"city": "Cabanac-Séguenville"},
    {"city": "Le Cabanial"},
    {"city": "Cadours"},
    {"city": "Caignac"},
    {"city": "Calmont"},
    {"city": "Cambernard"},
    {"city": "Cambiac"},
    {"city": "Canens"},
    {"city": "Capens"},
    {"city": "Caragoudes"},
    {"city": "Caraman"},
    {"city": "Carbonne"},
    {"city": "Cardeilhac"},
    {"city": "Cassagnabère-Tournas"},
    {"city": "Cassagne"},
    {"city": "Castagnac"},
    {"city": "Castagnède"},
    {"city": "Castanet-Tolosan"},
    {"city": "Castelbiague"},
    {"city": "Castelgaillard"},
    {"city": "Castelginest"},
    {"city": "Castelmaurou"},
    {"city": "Castelnau-d'Estrétefonds"},
    {"city": "Castelnau-Picampeau"},
    {"city": "Le Castéra"},
    {"city": "Castéra-Vignoles"},
    {"city": "Casties-Labrande"},
    {"city": "Castillon-de-Larboust"},
    {"city": "Castillon-de-Saint-Martory"},
    {"city": "Cathervielle"},
    {"city": "Caubiac"},
    {"city": "Caubous"},
    {"city": "Caujac"},
    {"city": "Cazarilh-Laspènes"},
    {"city": "Cazaril-Tambourès"},
    {"city": "Cazaunous"},
    {"city": "Cazaux-Layrisse"},
    {"city": "Cazeaux-de-Larboust"},
    {"city": "Cazeneuve-Montaut"},
    {"city": "Cazères"},
    {"city": "Cépet"},
    {"city": "Cessales"},
    {"city": "Charlas"},
    {"city": "Chaum"},
    {"city": "Chein-Dessus"},
    {"city": "Ciadoux"},
    {"city": "Cier-de-Luchon"},
    {"city": "Cier-de-Rivière"},
    {"city": "Cierp-Gaud"},
    {"city": "Cintegabelle"},
    {"city": "Cirès"},
    {"city": "Clarac"},
    {"city": "Clermont-le-Fort"},
    {"city": "Colomiers"},
    {"city": "Cornebarrieu"},
    {"city": "Corronsac"},
    {"city": "Coueilles"},
    {"city": "Couladère"},
    {"city": "Couret"},
    {"city": "Cox"},
    {"city": "Cugnaux"},
    {"city": "Cuguron"},
    {"city": "Le Cuing"},
    {"city": "Daux"},
    {"city": "Deyme"},
    {"city": "Donneville"},
    {"city": "Drémil-Lafage"},
    {"city": "Drudas"},
    {"city": "Eaunes"},
    {"city": "Empeaux"},
    {"city": "Encausse-les-Thermes"},
    {"city": "Eoux"},
    {"city": "Escalquens"},
    {"city": "Escanecrabe"},
    {"city": "Espanès"},
    {"city": "Esparron"},
    {"city": "Esperce"},
    {"city": "Estadens"},
    {"city": "Estancarbon"},
    {"city": "Esténos"},
    {"city": "Eup"},
    {"city": "Fabas"},
    {"city": "Le Faget"},
    {"city": "Falga"},
    {"city": "Le Fauga"},
    {"city": "Fenouillet"},
    {"city": "Figarol"},
    {"city": "Flourens"},
    {"city": "Folcarde"},
    {"city": "Fonbeauzard"},
    {"city": "Fonsorbes"},
    {"city": "Fontenilles"},
    {"city": "Forgues"},
    {"city": "Fos"},
    {"city": "Fougaron"},
    {"city": "Fourquevaux"},
    {"city": "Le Fousseret"},
    {"city": "Francarville"},
    {"city": "Francazal"},
    {"city": "Francon"},
    {"city": "Franquevielle"},
    {"city": "Le Fréchet"},
    {"city": "Fronsac"},
    {"city": "Frontignan-de-Comminges"},
    {"city": "Frontignan-Savès"},
    {"city": "Fronton"},
    {"city": "Frouzins"},
    {"city": "Fustignac"},
    {"city": "Gagnac-sur-Garonne"},
    {"city": "Gaillac-Toulza"},
    {"city": "Galié"},
    {"city": "Ganties"},
    {"city": "Garac"},
    {"city": "Gardouch"},
    {"city": "Gargas"},
    {"city": "Garidech"},
    {"city": "Garin"},
    {"city": "Gauré"},
    {"city": "Gémil"},
    {"city": "Génos"},
    {"city": "Gensac-de-Boulogne"},
    {"city": "Gensac-sur-Garonne"},
    {"city": "Gibel"},
    {"city": "Gouaux-de-Larboust"},
    {"city": "Gouaux-de-Luchon"},
    {"city": "Goudex"},
    {"city": "Gourdan-Polignan"},
    {"city": "Goutevernisse"},
    {"city": "Gouzens"},
    {"city": "Goyrans"},
    {"city": "Gragnague"},
    {"city": "Gratens"},
    {"city": "Gratentour"},
    {"city": "Grazac"},
    {"city": "Grenade"},
    {"city": "Grépiac"},
    {"city": "Le Grès"},
    {"city": "Guran"},
    {"city": "Herran"},
    {"city": "His"},
    {"city": "Huos"},
    {"city": "L'Isle-en-Dodon"},
    {"city": "Issus"},
    {"city": "Izaut-de-l'Hôtel"},
    {"city": "Jurvielle"},
    {"city": "Juzes"},
    {"city": "Juzet-de-Luchon"},
    {"city": "Juzet-d'Izaut"},
    {"city": "Labarthe-Inard"},
    {"city": "Labarthe-Rivière"},
    {"city": "Labarthe-sur-Lèze"},
    {"city": "Labastide-Beauvoir"},
    {"city": "Labastide-Clermont"},
    {"city": "Labastide-Paumès"},
    {"city": "Labastide-Saint-Sernin"},
    {"city": "Labastidette"},
    {"city": "Labège"},
    {"city": "Labroquère"},
    {"city": "Labruyère-Dorsa"},
    {"city": "Lacaugne"},
    {"city": "Lacroix-Falgarde"},
    {"city": "Laffite-Toupière"},
    {"city": "Lafitte-Vigordane"},
    {"city": "Lagarde"},
    {"city": "Lagardelle-sur-Lèze"},
    {"city": "Lagrâce-Dieu"},
    {"city": "Lagraulet-Saint-Nicolas"},
    {"city": "Lahage"},
    {"city": "Lahitère"},
    {"city": "Lalouret-Laffiteau"},
    {"city": "Lamasquère"},
    {"city": "Landorthe"},
    {"city": "Lanta"},
    {"city": "Lapeyrère"},
    {"city": "Lapeyrouse-Fossat"},
    {"city": "Larcan"},
    {"city": "Laréole"},
    {"city": "Larroque"},
    {"city": "Lasserre-Pradère"},
    {"city": "Latoue"},
    {"city": "Latour"},
    {"city": "Latrape"},
    {"city": "Launac"},
    {"city": "Launaguet"},
    {"city": "Lautignac"},
    {"city": "Lauzerville"},
    {"city": "Lavalette"},
    {"city": "Lavelanet-de-Comminges"},
    {"city": "Lavernose-Lacasse"},
    {"city": "Layrac-sur-Tarn"},
    {"city": "Lécussan"},
    {"city": "Lège"},
    {"city": "Léguevin"},
    {"city": "Lescuns"},
    {"city": "Lespinasse"},
    {"city": "Lespiteau"},
    {"city": "Lespugue"},
    {"city": "Lestelle-de-Saint-Martory"},
    {"city": "Lévignac"},
    {"city": "Lherm"},
    {"city": "Lieoux"},
    {"city": "Lilhac"},
    {"city": "Lodes"},
    {"city": "Longages"},
    {"city": "Loubens-Lauragais"},
    {"city": "Loudet"},
    {"city": "Lourde"},
    {"city": "Luscan"},
    {"city": "Lussan-Adeilhac"},
    {"city": "Lux"},
    {"city": "La Magdelaine-sur-Tarn"},
    {"city": "Mailholas"},
    {"city": "Malvezie"},
    {"city": "Mancioux"},
    {"city": "Mane"},
    {"city": "Marignac"},
    {"city": "Marignac-Lasclares"},
    {"city": "Marignac-Laspeyres"},
    {"city": "Marliac"},
    {"city": "Marquefave"},
    {"city": "Marsoulas"},
    {"city": "Martisserre"},
    {"city": "Martres-de-Rivière"},
    {"city": "Martres-Tolosane"},
    {"city": "Mascarville"},
    {"city": "Massabrac"},
    {"city": "Mauran"},
    {"city": "Mauremont"},
    {"city": "Maurens"},
    {"city": "Mauressac"},
    {"city": "Maureville"},
    {"city": "Mauvaisin"},
    {"city": "Mauvezin"},
    {"city": "Mauzac"},
    {"city": "Mayrègne"},
    {"city": "Mazères-sur-Salat"},
    {"city": "Melles"},
    {"city": "Menville"},
    {"city": "Mérenvielle"},
    {"city": "Mervilla"},
    {"city": "Merville"},
    {"city": "Milhas"},
    {"city": "Mirambeau"},
    {"city": "Miramont-de-Comminges"},
    {"city": "Miremont"},
    {"city": "Mirepoix-sur-Tarn"},
    {"city": "Molas"},
    {"city": "Moncaup"},
    {"city": "Mondavezan"},
    {"city": "Mondilhan"},
    {"city": "Mondonville"},
    {"city": "Mondouzil"},
    {"city": "Monès"},
    {"city": "Monestrol"},
    {"city": "Mons"},
    {"city": "Montaigut-sur-Save"},
    {"city": "Montastruc-de-Salies"},
    {"city": "Montastruc-la-Conseillère"},
    {"city": "Montastruc-Savès"},
    {"city": "Montauban-de-Luchon"},
    {"city": "Montaut"},
    {"city": "Montberaud"},
    {"city": "Montbernard"},
    {"city": "Montberon"},
    {"city": "Montbrun-Bocage"},
    {"city": "Montbrun-Lauragais"},
    {"city": "Montclar-de-Comminges"},
    {"city": "Montclar-Lauragais"},
    {"city": "Mont-de-Galié"},
    {"city": "Montégut-Bourjac"},
    {"city": "Montégut-Lauragais"},
    {"city": "Montespan"},
    {"city": "Montesquieu-Guittaut"},
    {"city": "Montesquieu-Lauragais"},
    {"city": "Montesquieu-Volvestre"},
    {"city": "Montgaillard-de-Salies"},
    {"city": "Montgaillard-Lauragais"},
    {"city": "Montgaillard-sur-Save"},
    {"city": "Montgazin"},
    {"city": "Montgeard"},
    {"city": "Montgiscard"},
    {"city": "Montgras"},
    {"city": "Montjoire"},
    {"city": "Montlaur"},
    {"city": "Montmaurin"},
    {"city": "Montoulieu-Saint-Bernard"},
    {"city": "Montoussin"},
    {"city": "Montpitol"},
    {"city": "Montrabé"},
    {"city": "Montréjeau"},
    {"city": "Montsaunès"},
    {"city": "Mourvilles-Basses"},
    {"city": "Mourvilles-Hautes"},
    {"city": "Moustajon"},
    {"city": "Muret"},
    {"city": "Nailloux"},
    {"city": "Nénigan"},
    {"city": "Nizan-Gesse"},
    {"city": "Noé"},
    {"city": "Nogaret"},
    {"city": "Noueilles"},
    {"city": "Odars"},
    {"city": "Ondes"},
    {"city": "Oô"},
    {"city": "Ore"},
    {"city": "Palaminy"},
    {"city": "Paulhac"},
    {"city": "Payssous"},
    {"city": "Péchabou"},
    {"city": "Pechbonnieu"},
    {"city": "Pechbusque"},
    {"city": "Péguilhan"},
    {"city": "Pelleport"},
    {"city": "Peyrissas"},
    {"city": "Peyrouzet"},
    {"city": "Peyssies"},
    {"city": "Pibrac"},
    {"city": "Pin-Balma"},
    {"city": "Le Pin-Murelet"},
    {"city": "Pinsaguel"},
    {"city": "Pins-Justaret"},
    {"city": "Plagne"},
    {"city": "Plagnole"},
    {"city": "Plaisance-du-Touch"},
    {"city": "Le Plan"},
    {"city": "Pointis-de-Rivière"},
    {"city": "Pointis-Inard"},
    {"city": "Polastron"},
    {"city": "Pompertuzat"},
    {"city": "Ponlat-Taillebourg"},
    {"city": "Portet-d'Aspet"},
    {"city": "Portet-de-Luchon"},
    {"city": "Portet-sur-Garonne"},
    {"city": "Poubeau"},
    {"city": "Poucharramet"},
    {"city": "Pouy-de-Touges"},
    {"city": "Pouze"},
    {"city": "Préserville"},
    {"city": "Proupiary"},
    {"city": "Prunet"},
    {"city": "Puydaniel"},
    {"city": "Puymaurin"},
    {"city": "Puysségur"},
    {"city": "Quint-Fonsegrives"},
    {"city": "Ramonville-Saint-Agne"},
    {"city": "Razecueillé"},
    {"city": "Rebigue"},
    {"city": "Régades"},
    {"city": "Renneville"},
    {"city": "Revel"},
    {"city": "Rieucazé"},
    {"city": "Rieumajou"},
    {"city": "Rieumes"},
    {"city": "Rieux-Volvestre"},
    {"city": "Riolas"},
    {"city": "Roquefort-sur-Garonne"},
    {"city": "Roques"},
    {"city": "Roquesérière"},
    {"city": "Roquettes"},
    {"city": "Rouède"},
    {"city": "Rouffiac-Tolosan"},
    {"city": "Roumens"},
    {"city": "Sabonnères"},
    {"city": "Saccourvielle"},
    {"city": "Saiguède"},
    {"city": "Saint-Alban"},
    {"city": "Saint-André"},
    {"city": "Saint-Araille"},
    {"city": "Saint-Aventin"},
    {"city": "Saint-Béat-Lez"},
    {"city": "Saint-Bertrand-de-Comminges"},
    {"city": "Saint-Cézert"},
    {"city": "Saint-Christaud"},
    {"city": "Saint-Clar-de-Rivière"},
    {"city": "Saint-Élix-le-Château"},
    {"city": "Saint-Élix-Séglan"},
    {"city": "Saint-Félix-Lauragais"},
    {"city": "Saint-Ferréol-de-Comminges"},
    {"city": "Sainte-Foy-d'Aigrefeuille"},
    {"city": "Sainte-Foy-de-Peyrolières"},
    {"city": "Saint-Frajou"},
    {"city": "Saint-Gaudens"},
    {"city": "Saint-Geniès-Bellevue"},
    {"city": "Saint-Germier"},
    {"city": "Saint-Hilaire"},
    {"city": "Saint-Ignan"},
    {"city": "Saint-Jean"},
    {"city": "Saint-Jean-Lherm"},
    {"city": "Saint-Jory"},
    {"city": "Saint-Julia"},
    {"city": "Saint-Julien-sur-Garonne"},
    {"city": "Saint-Lary-Boujean"},
    {"city": "Saint-Laurent"},
    {"city": "Saint-Léon"},
    {"city": "Sainte-Livrade"},
    {"city": "Saint-Loup-Cammas"},
    {"city": "Saint-Loup-en-Comminges"},
    {"city": "Saint-Lys"},
    {"city": "Saint-Mamet"},
    {"city": "Saint-Marcel-Paulel"},
    {"city": "Saint-Marcet"},
    {"city": "Saint-Martory"},
    {"city": "Saint-Médard"},
    {"city": "Saint-Michel"},
    {"city": "Saint-Orens-de-Gameville"},
    {"city": "Saint-Paul-sur-Save"},
    {"city": "Saint-Paul-d'Oueil"},
    {"city": "Saint-Pé-d'Ardet"},
    {"city": "Saint-Pé-Delbosc"},
    {"city": "Saint-Pierre"},
    {"city": "Saint-Pierre-de-Lages"},
    {"city": "Saint-Plancard"},
    {"city": "Saint-Rome"},
    {"city": "Saint-Rustice"},
    {"city": "Saint-Sauveur"},
    {"city": "Saint-Sulpice-sur-Lèze"},
    {"city": "Saint-Thomas"},
    {"city": "Saint-Vincent"},
    {"city": "Sajas"},
    {"city": "Saleich"},
    {"city": "Salerm"},
    {"city": "Salies-du-Salat"},
    {"city": "Salles-et-Pratviel"},
    {"city": "Salles-sur-Garonne"},
    {"city": "La Salvetat-Saint-Gilles"},
    {"city": "La Salvetat-Lauragais"},
    {"city": "Saman"},
    {"city": "Samouillan"},
    {"city": "Sana"},
    {"city": "Sarrecave"},
    {"city": "Sarremezan"},
    {"city": "Saubens"},
    {"city": "Saussens"},
    {"city": "Sauveterre-de-Comminges"},
    {"city": "Saux-et-Pomarède"},
    {"city": "Savarthès"},
    {"city": "Savères"},
    {"city": "Sédeilhac"},
    {"city": "Ségreville"},
    {"city": "Seilh"},
    {"city": "Seilhan"},
    {"city": "Sénarens"},
    {"city": "Sengouagnet"},
    {"city": "Sepx"},
    {"city": "Seyre"},
    {"city": "Seysses"},
    {"city": "Signac"},
    {"city": "Sode"},
    {"city": "Soueich"},
    {"city": "Tarabel"},
    {"city": "Terrebasse"},
    {"city": "Thil"},
    {"city": "Touille"},
    {"city": "Toulouse"},
    {"city": "Les Tourreilles"},
    {"city": "Tournefeuille"},
    {"city": "Toutens"},
    {"city": "Trébons-de-Luchon"},
    {"city": "Trébons-sur-la-Grasse"},
    {"city": "L'Union"},
    {"city": "Urau"},
    {"city": "Vacquiers"},
    {"city": "Valcabrère"},
    {"city": "Valentine"},
    {"city": "Vallègue"},
    {"city": "Vallesvilles"},
    {"city": "Varennes"},
    {"city": "Vaudreuille"},
    {"city": "Vaux"},
    {"city": "Vendine"},
    {"city": "Venerque"},
    {"city": "Verfeil"},
    {"city": "Vernet"},
    {"city": "Vieille-Toulouse"},
    {"city": "Vieillevigne"},
    {"city": "Vignaux"},
    {"city": "Vigoulet-Auzil"},
    {"city": "Villariès"},
    {"city": "Villate"},
    {"city": "Villaudric"},
    {"city": "Villefranche-de-Lauragais"},
    {"city": "Villematier"},
    {"city": "Villemur-sur-Tarn"},
    {"city": "Villeneuve-de-Rivière"},
    {"city": "Villeneuve-Lécussan"},
    {"city": "Villeneuve-lès-Bouloc"},
    {"city": "Villeneuve-Tolosane"},
    {"city": "Villenouvelle"},
    {"city": "Binos"},
    {"city": "Escoulis"},
    {"city": "Larra"},
    {"city": "Cazac"},
    {"city": "Aignan"},
    {"city": "Ansan"},
    {"city": "Antras"},
    {"city": "Arblade-le-Bas"},
    {"city": "Arblade-le-Haut"},
    {"city": "Ardizas"},
    {"city": "Armentieux"},
    {"city": "Armous-et-Cau"},
    {"city": "Arrouède"},
    {"city": "Aubiet"},
    {"city": "Auch"},
    {"city": "Augnax"},
    {"city": "Aujan-Mournède"},
    {"city": "Auradé"},
    {"city": "Aurensan"},
    {"city": "Aurimont"},
    {"city": "Auterive"},
    {"city": "Aux-Aussat"},
    {"city": "Avensac"},
    {"city": "Avéron-Bergelle"},
    {"city": "Avezan"},
    {"city": "Ayguetinte"},
    {"city": "Ayzieu"},
    {"city": "Bajonnette"},
    {"city": "Barcelonne-du-Gers"},
    {"city": "Barcugnan"},
    {"city": "Barran"},
    {"city": "Bars"},
    {"city": "Bascous"},
    {"city": "Bassoues"},
    {"city": "Bazian"},
    {"city": "Bazugues"},
    {"city": "Beaucaire"},
    {"city": "Beaumarchés"},
    {"city": "Beaumont"},
    {"city": "Beaupuy"},
    {"city": "Beccas"},
    {"city": "Bédéchan"},
    {"city": "Bellegarde"},
    {"city": "Belloc-Saint-Clamens"},
    {"city": "Belmont"},
    {"city": "Béraut"},
    {"city": "Berdoues"},
    {"city": "Bernède"},
    {"city": "Berrac"},
    {"city": "Betcave-Aguin"},
    {"city": "Bétous"},
    {"city": "Betplan"},
    {"city": "Bézéril"},
    {"city": "Bezolles"},
    {"city": "Bézues-Bajon"},
    {"city": "Biran"},
    {"city": "Bivès"},
    {"city": "Blanquefort"},
    {"city": "Blaziert"},
    {"city": "Blousson-Sérian"},
    {"city": "Bonas"},
    {"city": "Boucagnères"},
    {"city": "Boulaur"},
    {"city": "Bourrouillan"},
    {"city": "Bouzon-Gellenave"},
    {"city": "Bretagne-d'Armagnac"},
    {"city": "Le Brouilh-Monbert"},
    {"city": "Brugnens"},
    {"city": "Cabas-Loumassès"},
    {"city": "Cadeilhan"},
    {"city": "Cadeillan"},
    {"city": "Cahuzac-sur-Adour"},
    {"city": "Caillavet"},
    {"city": "Callian"},
    {"city": "Campagne-d'Armagnac"},
    {"city": "Cassaigne"},
    {"city": "Castelnau-Barbarens"},
    {"city": "Castelnau-d'Anglès"},
    {"city": "Castelnau-d'Arbieu"},
    {"city": "Castelnau d'Auzan Labarrère"},
    {"city": "Castelnau-sur-l'Auvignon"},
    {"city": "Castelnavet"},
    {"city": "Castéra-Lectourois"},
    {"city": "Castéra-Verduzan"},
    {"city": "Castéron"},
    {"city": "Castet-Arrouy"},
    {"city": "Castex"},
    {"city": "Castex-d'Armagnac"},
    {"city": "Castillon-Debats"},
    {"city": "Castillon-Massas"},
    {"city": "Castillon-Savès"},
    {"city": "Castin"},
    {"city": "Catonvielle"},
    {"city": "Caumont"},
    {"city": "Caupenne-d'Armagnac"},
    {"city": "Caussens"},
    {"city": "Cazaubon"},
    {"city": "Cazaux-d'Anglès"},
    {"city": "Cazaux-Savès"},
    {"city": "Cazaux-Villecomtal"},
    {"city": "Cazeneuve"},
    {"city": "Céran"},
    {"city": "Cézan"},
    {"city": "Chélan"},
    {"city": "Clermont-Pouyguillès"},
    {"city": "Clermont-Savès"},
    {"city": "Cologne"},
    {"city": "Condom"},
    {"city": "Corneillan"},
    {"city": "Couloumé-Mondebat"},
    {"city": "Courrensan"},
    {"city": "Courties"},
    {"city": "Crastes"},
    {"city": "Cravencères"},
    {"city": "Cuélas"},
    {"city": "Dému"},
    {"city": "Duffort"},
    {"city": "Duran"},
    {"city": "Durban"},
    {"city": "Eauze"},
    {"city": "Encausse"},
    {"city": "Endoufielle"},
    {"city": "Esclassan-Labastide"},
    {"city": "Escornebœuf"},
    {"city": "Espaon"},
    {"city": "Espas"},
    {"city": "Estampes"},
    {"city": "Estang"},
    {"city": "Estipouy"},
    {"city": "Estramiac"},
    {"city": "Faget-Abbatial"},
    {"city": "Flamarens"},
    {"city": "Fleurance"},
    {"city": "Fourcès"},
    {"city": "Frégouville"},
    {"city": "Fustérouau"},
    {"city": "Galiax"},
    {"city": "Garravet"},
    {"city": "Gaudonville"},
    {"city": "Gaujac"},
    {"city": "Gaujan"},
    {"city": "Gavarret-sur-Aulouste"},
    {"city": "Gazaupouy"},
    {"city": "Gazax-et-Baccarisse"},
    {"city": "Gée-Rivière"},
    {"city": "Gimbrède"},
    {"city": "Gimont"},
    {"city": "Giscaro"},
    {"city": "Gondrin"},
    {"city": "Goutz"},
    {"city": "Goux"},
    {"city": "Haget"},
    {"city": "Haulies"},
    {"city": "Homps"},
    {"city": "Le Houga"},
    {"city": "Idrac-Respaillès"},
    {"city": "L'Isle-Arné"},
    {"city": "L'Isle-Bouzon"},
    {"city": "L'Isle-de-Noé"},
    {"city": "L'Isle-Jourdain"},
    {"city": "Izotges"},
    {"city": "Jegun"},
    {"city": "Jû-Belloc"},
    {"city": "Juillac"},
    {"city": "Juilles"},
    {"city": "Justian"},
    {"city": "Laas"},
    {"city": "Labarthe"},
    {"city": "Labarthète"},
    {"city": "Labastide-Savès"},
    {"city": "Labéjan"},
    {"city": "Labrihe"},
    {"city": "Ladevèze-Rivière"},
    {"city": "Ladevèze-Ville"},
    {"city": "Lagarde"},
    {"city": "Lagarde-Hachan"},
    {"city": "Lagardère"},
    {"city": "Lagraulet-du-Gers"},
    {"city": "Laguian-Mazous"},
    {"city": "Lahas"},
    {"city": "Lahitte"},
    {"city": "Lalanne"},
    {"city": "Lalanne-Arqué"},
    {"city": "Lamaguère"},
    {"city": "Lamazère"},
    {"city": "Lamothe-Goas"},
    {"city": "Lannemaignan"},
    {"city": "Lannepax"},
    {"city": "Lanne-Soubiran"},
    {"city": "Lannux"},
    {"city": "Larée"},
    {"city": "Larressingle"},
    {"city": "Larroque-Engalin"},
    {"city": "Larroque-Saint-Sernin"},
    {"city": "Larroque-sur-l'Osse"},
    {"city": "Lartigue"},
    {"city": "Lasserade"},
    {"city": "Lasséran"},
    {"city": "Lasseube-Propre"},
    {"city": "Laujuzan"},
    {"city": "Lauraët"},
    {"city": "Lavardens"},
    {"city": "Laveraët"},
    {"city": "Laymont"},
    {"city": "Leboulin"},
    {"city": "Lectoure"},
    {"city": "Lelin-Lapujolle"},
    {"city": "Lias"},
    {"city": "Lias-d'Armagnac"},
    {"city": "Ligardes"},
    {"city": "Lombez"},
    {"city": "Loubédat"},
    {"city": "Loubersan"},
    {"city": "Lourties-Monbrun"},
    {"city": "Louslitges"},
    {"city": "Loussous-Débat"},
    {"city": "Lupiac"},
    {"city": "Luppé-Violles"},
    {"city": "Lussan"},
    {"city": "Magnan"},
    {"city": "Magnas"},
    {"city": "Maignaut-Tauzia"},
    {"city": "Malabat"},
    {"city": "Manas-Bastanous"},
    {"city": "Manciet"},
    {"city": "Manent-Montané"},
    {"city": "Mansempuy"},
    {"city": "Mansencôme"},
    {"city": "Marambat"},
    {"city": "Maravat"},
    {"city": "Marciac"},
    {"city": "Marestaing"},
    {"city": "Margouët-Meymes"},
    {"city": "Marguestau"},
    {"city": "Marsan"},
    {"city": "Marseillan"},
    {"city": "Marsolan"},
    {"city": "Mascaras"},
    {"city": "Mas-d'Auvignon"},
    {"city": "Masseube"},
    {"city": "Mauléon-d'Armagnac"},
    {"city": "Maulichères"},
    {"city": "Maumusson-Laguian"},
    {"city": "Maupas"},
    {"city": "Maurens"},
    {"city": "Mauroux"},
    {"city": "Mauvezin"},
    {"city": "Meilhan"},
    {"city": "Mérens"},
    {"city": "Miélan"},
    {"city": "Miradoux"},
    {"city": "Miramont-d'Astarac"},
    {"city": "Miramont-Latour"},
    {"city": "Mirande"},
    {"city": "Mirannes"},
    {"city": "Mirepoix"},
    {"city": "Monbardon"},
    {"city": "Monblanc"},
    {"city": "Monbrun"},
    {"city": "Moncassin"},
    {"city": "Monclar"},
    {"city": "Monclar-sur-Losse"},
    {"city": "Moncorneil-Grazan"},
    {"city": "Monferran-Plavès"},
    {"city": "Monferran-Savès"},
    {"city": "Monfort"},
    {"city": "Mongausy"},
    {"city": "Monguilhem"},
    {"city": "Monlaur-Bernet"},
    {"city": "Monlezun"},
    {"city": "Monlezun-d'Armagnac"},
    {"city": "Monpardiac"},
    {"city": "Montadet"},
    {"city": "Montamat"},
    {"city": "Montaut"},
    {"city": "Montaut-les-Créneaux"},
    {"city": "Mont-d'Astarac"},
    {"city": "Mont-de-Marrast"},
    {"city": "Montégut"},
    {"city": "Montégut-Arros"},
    {"city": "Montégut-Savès"},
    {"city": "Montesquiou"},
    {"city": "Montestruc-sur-Gers"},
    {"city": "Monties"},
    {"city": "Montiron"},
    {"city": "Montpézat"},
    {"city": "Montréal"},
    {"city": "Mormès"},
    {"city": "Mouchan"},
    {"city": "Mouchès"},
    {"city": "Mourède"},
    {"city": "Nizas"},
    {"city": "Nogaro"},
    {"city": "Noilhan"},
    {"city": "Nougaroulet"},
    {"city": "Noulens"},
    {"city": "Orbessan"},
    {"city": "Ordan-Larroque"},
    {"city": "Ornézan"},
    {"city": "Pallanne"},
    {"city": "Panassac"},
    {"city": "Panjas"},
    {"city": "Pauilhac"},
    {"city": "Pavie"},
    {"city": "Pébées"},
    {"city": "Pellefigue"},
    {"city": "Perchède"},
    {"city": "Pergain-Taillac"},
    {"city": "Pessan"},
    {"city": "Pessoulens"},
    {"city": "Peyrecave"},
    {"city": "Peyrusse-Grande"},
    {"city": "Peyrusse-Massas"},
    {"city": "Peyrusse-Vieille"},
    {"city": "Pis"},
    {"city": "Plaisance"},
    {"city": "Plieux"},
    {"city": "Polastron"},
    {"city": "Pompiac"},
    {"city": "Ponsampère"},
    {"city": "Ponsan-Soubiran"},
    {"city": "Pouydraguin"},
    {"city": "Pouylebon"},
    {"city": "Pouy-Loubrin"},
    {"city": "Pouy-Roquelaure"},
    {"city": "Préchac"},
    {"city": "Préchac-sur-Adour"},
    {"city": "Preignan"},
    {"city": "Préneron"},
    {"city": "Projan"},
    {"city": "Pujaudran"},
    {"city": "Puycasquier"},
    {"city": "Puylausic"},
    {"city": "Puységur"},
    {"city": "Ramouzens"},
    {"city": "Razengues"},
    {"city": "Réans"},
    {"city": "Réjaumont"},
    {"city": "Ricourt"},
    {"city": "Riguepeu"},
    {"city": "Riscle"},
    {"city": "La Romieu"},
    {"city": "Roquebrune"},
    {"city": "Roquefort"},
    {"city": "Roquelaure"},
    {"city": "Roquelaure-Saint-Aubin"},
    {"city": "Roquepine"},
    {"city": "Roques"},
    {"city": "Rozès"},
    {"city": "Sabaillan"},
    {"city": "Sabazan"},
    {"city": "Sadeillan"},
    {"city": "Saint-André"},
    {"city": "Sainte-Anne"},
    {"city": "Saint-Antoine"},
    {"city": "Saint-Antonin"},
    {"city": "Saint-Arailles"},
    {"city": "Saint-Arroman"},
    {"city": "Saint-Aunix-Lengros"},
    {"city": "Sainte-Aurence-Cazaux"},
    {"city": "Saint-Avit-Frandat"},
    {"city": "Saint-Blancard"},
    {"city": "Saint-Brès"},
    {"city": "Saint-Christaud"},
    {"city": "Sainte-Christie"},
    {"city": "Sainte-Christie-d'Armagnac"},
    {"city": "Saint-Clar"},
    {"city": "Saint-Créac"},
    {"city": "Saint-Cricq"},
    {"city": "Sainte-Dode"},
    {"city": "Saint-Élix-d'Astarac"},
    {"city": "Saint-Élix-Theux"},
    {"city": "Sainte-Gemme"},
    {"city": "Saint-Georges"},
    {"city": "Saint-Germé"},
    {"city": "Saint-Germier"},
    {"city": "Saint-Griède"},
    {"city": "Saint-Jean-le-Comtal"},
    {"city": "Saint-Jean-Poutge"},
    {"city": "Saint-Justin"},
    {"city": "Saint-Lary"},
    {"city": "Saint-Léonard"},
    {"city": "Saint-Lizier-du-Planté"},
    {"city": "Saint-Loube"},
    {"city": "Sainte-Marie"},
    {"city": "Saint-Martin"},
    {"city": "Saint-Martin-d'Armagnac"},
    {"city": "Saint-Martin-de-Goyne"},
    {"city": "Saint-Martin-Gimois"},
    {"city": "Saint-Maur"},
    {"city": "Saint-Médard"},
    {"city": "Sainte-Mère"},
    {"city": "Saint-Mézard"},
    {"city": "Saint-Michel"},
    {"city": "Saint-Mont"},
    {"city": "Saint-Orens"},
    {"city": "Saint-Orens-Pouy-Petit"},
    {"city": "Saint-Ost"},
    {"city": "Saint-Paul-de-Baïse"},
    {"city": "Saint-Pierre-d'Aubézies"},
    {"city": "Saint-Puy"},
    {"city": "Sainte-Radegonde"},
    {"city": "Saint-Sauvy"},
    {"city": "Saint-Soulan"},
    {"city": "Salles-d'Armagnac"},
    {"city": "Samaran"},
    {"city": "Samatan"},
    {"city": "Sansan"},
    {"city": "Saramon"},
    {"city": "Sarcos"},
    {"city": "Sarragachies"},
    {"city": "Sarraguzan"},
    {"city": "Sarrant"},
    {"city": "La Sauvetat"},
    {"city": "Sauveterre"},
    {"city": "Sauviac"},
    {"city": "Sauvimont"},
    {"city": "Savignac-Mona"},
    {"city": "Scieurac-et-Flourès"},
    {"city": "Séailles"},
    {"city": "Ségos"},
    {"city": "Ségoufielle"},
    {"city": "Seissan"},
    {"city": "Sembouès"},
    {"city": "Sémézies-Cachan"},
    {"city": "Sempesserre"},
    {"city": "Sère"},
    {"city": "Sérempuy"},
    {"city": "Seysses-Savès"},
    {"city": "Simorre"},
    {"city": "Sion"},
    {"city": "Sirac"},
    {"city": "Solomiac"},
    {"city": "Sorbets"},
    {"city": "Tachoires"},
    {"city": "Tarsac"},
    {"city": "Tasque"},
    {"city": "Taybosc"},
    {"city": "Terraube"},
    {"city": "Termes-d'Armagnac"},
    {"city": "Thoux"},
    {"city": "Tieste-Uragnoux"},
    {"city": "Tillac"},
    {"city": "Tirent-Pontéjac"},
    {"city": "Touget"},
    {"city": "Toujouse"},
    {"city": "Tourdun"},
    {"city": "Tournan"},
    {"city": "Tournecoupe"},
    {"city": "Tourrenquets"},
    {"city": "Traversères"},
    {"city": "Troncens"},
    {"city": "Tudelle"},
    {"city": "Urdens"},
    {"city": "Urgosse"},
    {"city": "Valence-sur-Baïse"},
    {"city": "Vergoignan"},
    {"city": "Verlus"},
    {"city": "Vic-Fezensac"},
    {"city": "Viella"},
    {"city": "Villecomtal-sur-Arros"},
    {"city": "Villefranche"},
    {"city": "Viozan"},
    {"city": "Saint-Caprais"},
    {"city": "Aussos"},
    {"city": "Abzac"},
    {"city": "Aillas"},
    {"city": "Ambarès-et-Lagrave"},
    {"city": "Ambès"},
    {"city": "Andernos-les-Bains"},
    {"city": "Anglade"},
    {"city": "Arbanats"},
    {"city": "Porte-de-Benauge"},
    {"city": "Arcachon"},
    {"city": "Arcins"},
    {"city": "Arès"},
    {"city": "Arsac"},
    {"city": "Artigues-près-Bordeaux"},
    {"city": "Les Artigues-de-Lussac"},
    {"city": "Arveyres"},
    {"city": "Asques"},
    {"city": "Aubiac"},
    {"city": "Val de Virvée"},
    {"city": "Audenge"},
    {"city": "Auriolles"},
    {"city": "Auros"},
    {"city": "Avensan"},
    {"city": "Ayguemorte-les-Graves"},
    {"city": "Bagas"},
    {"city": "Baigneaux"},
    {"city": "Balizac"},
    {"city": "Barie"},
    {"city": "Baron"},
    {"city": "Le Barp"},
    {"city": "Barsac"},
    {"city": "Bassanne"},
    {"city": "Bassens"},
    {"city": "Baurech"},
    {"city": "Bayas"},
    {"city": "Bayon-sur-Gironde"},
    {"city": "Bazas"},
    {"city": "Beautiran"},
    {"city": "Bégadan"},
    {"city": "Bègles"},
    {"city": "Béguey"},
    {"city": "Belin-Béliet"},
    {"city": "Bellebat"},
    {"city": "Bellefond"},
    {"city": "Belvès-de-Castillon"},
    {"city": "Bernos-Beaulac"},
    {"city": "Berson"},
    {"city": "Berthez"},
    {"city": "Beychac-et-Caillau"},
    {"city": "Bieujac"},
    {"city": "Biganos"},
    {"city": "Les Billaux"},
    {"city": "Birac"},
    {"city": "Blaignac"},
    {"city": "Blaignan-Prignac"},
    {"city": "Blanquefort"},
    {"city": "Blasimon"},
    {"city": "Blaye"},
    {"city": "Blésignac"},
    {"city": "Bommes"},
    {"city": "Bonnetan"},
    {"city": "Bonzac"},
    {"city": "Bordeaux"},
    {"city": "Bossugan"},
    {"city": "Bouliac"},
    {"city": "Bourdelles"},
    {"city": "Bourg"},
    {"city": "Bourideys"},
    {"city": "Le Bouscat"},
    {"city": "Brach"},
    {"city": "Branne"},
    {"city": "Brannens"},
    {"city": "Braud-et-Saint-Louis"},
    {"city": "Brouqueyran"},
    {"city": "Bruges"},
    {"city": "Budos"},
    {"city": "Cabanac-et-Villagrains"},
    {"city": "Cabara"},
    {"city": "Cadarsac"},
    {"city": "Cadaujac"},
    {"city": "Cadillac"},
    {"city": "Cadillac-en-Fronsadais"},
    {"city": "Camarsac"},
    {"city": "Cambes"},
    {"city": "Camblanes-et-Meynac"},
    {"city": "Camiac-et-Saint-Denis"},
    {"city": "Camiran"},
    {"city": "Camps-sur-l'Isle"},
    {"city": "Campugnan"},
    {"city": "Canéjan"},
    {"city": "Capian"},
    {"city": "Caplong"},
    {"city": "Captieux"},
    {"city": "Carbon-Blanc"},
    {"city": "Carcans"},
    {"city": "Cardan"},
    {"city": "Carignan-de-Bordeaux"},
    {"city": "Cars"},
    {"city": "Cartelègue"},
    {"city": "Casseuil"},
    {"city": "Castelmoron-d'Albret"},
    {"city": "Castelnau-de-Médoc"},
    {"city": "Castelviel"},
    {"city": "Castets et Castillon"},
    {"city": "Castillon-la-Bataille"},
    {"city": "Castres-Gironde"},
    {"city": "Caudrot"},
    {"city": "Caumont"},
    {"city": "Cauvignac"},
    {"city": "Cavignac"},
    {"city": "Cazalis"},
    {"city": "Cazats"},
    {"city": "Cazaugitat"},
    {"city": "Cénac"},
    {"city": "Cenon"},
    {"city": "Cérons"},
    {"city": "Cessac"},
    {"city": "Cestas"},
    {"city": "Cézac"},
    {"city": "Chamadelle"},
    {"city": "Cissac-Médoc"},
    {"city": "Civrac-de-Blaye"},
    {"city": "Civrac-sur-Dordogne"},
    {"city": "Civrac-en-Médoc"},
    {"city": "Cleyrac"},
    {"city": "Coimères"},
    {"city": "Coirac"},
    {"city": "Comps"},
    {"city": "Coubeyrac"},
    {"city": "Couquèques"},
    {"city": "Courpiac"},
    {"city": "Cours-de-Monségur"},
    {"city": "Cours-les-Bains"},
    {"city": "Coutras"},
    {"city": "Coutures"},
    {"city": "Créon"},
    {"city": "Croignon"},
    {"city": "Cubnezais"},
    {"city": "Cubzac-les-Ponts"},
    {"city": "Cudos"},
    {"city": "Cursan"},
    {"city": "Cussac-Fort-Médoc"},
    {"city": "Daignac"},
    {"city": "Dardenac"},
    {"city": "Daubèze"},
    {"city": "Dieulivol"},
    {"city": "Donnezac"},
    {"city": "Donzac"},
    {"city": "Doulezon"},
    {"city": "Les Églisottes-et-Chalaures"},
    {"city": "Escaudes"},
    {"city": "Escoussans"},
    {"city": "Espiet"},
    {"city": "Les Esseintes"},
    {"city": "Étauliers"},
    {"city": "Eynesse"},
    {"city": "Eyrans"},
    {"city": "Eysines"},
    {"city": "Faleyras"},
    {"city": "Fargues"},
    {"city": "Fargues-Saint-Hilaire"},
    {"city": "Le Fieu"},
    {"city": "Floirac"},
    {"city": "Flaujagues"},
    {"city": "Floudès"},
    {"city": "Fontet"},
    {"city": "Fossès-et-Baleyssac"},
    {"city": "Fours"},
    {"city": "Francs"},
    {"city": "Fronsac"},
    {"city": "Frontenac"},
    {"city": "Gabarnac"},
    {"city": "Gaillan-en-Médoc"},
    {"city": "Gajac"},
    {"city": "Galgon"},
    {"city": "Gans"},
    {"city": "Gardegan-et-Tourtirac"},
    {"city": "Gauriac"},
    {"city": "Gauriaguet"},
    {"city": "Générac"},
    {"city": "Génissac"},
    {"city": "Gensac"},
    {"city": "Gironde-sur-Dropt"},
    {"city": "Giscos"},
    {"city": "Gornac"},
    {"city": "Goualade"},
    {"city": "Gours"},
    {"city": "Gradignan"},
    {"city": "Grayan-et-l'Hôpital"},
    {"city": "Grézillac"},
    {"city": "Grignols"},
    {"city": "Guillac"},
    {"city": "Guillos"},
    {"city": "Guîtres"},
    {"city": "Gujan-Mestras"},
    {"city": "Le Haillan"},
    {"city": "Haux"},
    {"city": "Hostens"},
    {"city": "Hourtin"},
    {"city": "Hure"},
    {"city": "Illats"},
    {"city": "Isle-Saint-Georges"},
    {"city": "Izon"},
    {"city": "Jau-Dignac-et-Loirac"},
    {"city": "Jugazan"},
    {"city": "Juillac"},
    {"city": "Labarde"},
    {"city": "Labescau"},
    {"city": "La Brède"},
    {"city": "Lacanau"},
    {"city": "Ladaux"},
    {"city": "Lados"},
    {"city": "Lagorce"},
    {"city": "La Lande-de-Fronsac"},
    {"city": "Lamarque"},
    {"city": "Lamothe-Landerron"},
    {"city": "Lalande-de-Pomerol"},
    {"city": "Landerrouat"},
    {"city": "Landerrouet-sur-Ségur"},
    {"city": "Landiras"},
    {"city": "Langoiran"},
    {"city": "Langon"},
    {"city": "Lansac"},
    {"city": "Lanton"},
    {"city": "Lapouyade"},
    {"city": "Laroque"},
    {"city": "Lartigue"},
    {"city": "Laruscade"},
    {"city": "Latresne"},
    {"city": "Lavazan"},
    {"city": "Lège-Cap-Ferret"},
    {"city": "Léogeats"},
    {"city": "Léognan"},
    {"city": "Lerm-et-Musset"},
    {"city": "Lesparre-Médoc"},
    {"city": "Lestiac-sur-Garonne"},
    {"city": "Les Lèves-et-Thoumeyragues"},
    {"city": "Libourne"},
    {"city": "Lignan-de-Bazas"},
    {"city": "Lignan-de-Bordeaux"},
    {"city": "Ligueux"},
    {"city": "Listrac-de-Durèze"},
    {"city": "Listrac-Médoc"},
    {"city": "Lormont"},
    {"city": "Loubens"},
    {"city": "Louchats"},
    {"city": "Loupes"},
    {"city": "Loupiac"},
    {"city": "Loupiac-de-la-Réole"},
    {"city": "Lucmau"},
    {"city": "Ludon-Médoc"},
    {"city": "Lugaignac"},
    {"city": "Lugasson"},
    {"city": "Lugon-et-l'Île-du-Carnay"},
    {"city": "Lugos"},
    {"city": "Lussac"},
    {"city": "Macau"},
    {"city": "Madirac"},
    {"city": "Maransin"},
    {"city": "Marcenais"},
    {"city": "Margaux-Cantenac"},
    {"city": "Margueron"},
    {"city": "Marimbault"},
    {"city": "Marions"},
    {"city": "Marsas"},
    {"city": "Martignas-sur-Jalle"},
    {"city": "Martillac"},
    {"city": "Martres"},
    {"city": "Masseilles"},
    {"city": "Massugas"},
    {"city": "Mauriac"},
    {"city": "Mazères"},
    {"city": "Mazion"},
    {"city": "Mérignac"},
    {"city": "Mérignas"},
    {"city": "Mesterrieux"},
    {"city": "Mios"},
    {"city": "Mombrier"},
    {"city": "Mongauzy"},
    {"city": "Monprimblanc"},
    {"city": "Monségur"},
    {"city": "Montagne"},
    {"city": "Montagoudin"},
    {"city": "Montignac"},
    {"city": "Montussan"},
    {"city": "Morizès"},
    {"city": "Mouillac"},
    {"city": "Mouliets-et-Villemartin"},
    {"city": "Moulis-en-Médoc"},
    {"city": "Moulon"},
    {"city": "Mourens"},
    {"city": "Naujac-sur-Mer"},
    {"city": "Naujan-et-Postiac"},
    {"city": "Néac"},
    {"city": "Nérigean"},
    {"city": "Neuffons"},
    {"city": "Le Nizan"},
    {"city": "Noaillac"},
    {"city": "Noaillan"},
    {"city": "Omet"},
    {"city": "Ordonnac"},
    {"city": "Origne"},
    {"city": "Paillet"},
    {"city": "Parempuyre"},
    {"city": "Pauillac"},
    {"city": "Les Peintures"},
    {"city": "Pellegrue"},
    {"city": "Périssac"},
    {"city": "Pessac"},
    {"city": "Pessac-sur-Dordogne"},
    {"city": "Petit-Palais-et-Cornemps"},
    {"city": "Peujard"},
    {"city": "Le Pian-Médoc"},
    {"city": "Le Pian-sur-Garonne"},
    {"city": "Pineuilh"},
    {"city": "Plassac"},
    {"city": "Pleine-Selve"},
    {"city": "Podensac"},
    {"city": "Pomerol"},
    {"city": "Pompéjac"},
    {"city": "Pompignac"},
    {"city": "Pondaurat"},
    {"city": "Porchères"},
    {"city": "Le Porge"},
    {"city": "Portets"},
    {"city": "Le Pout"},
    {"city": "Préchac"},
    {"city": "Preignac"},
    {"city": "Prignac-et-Marcamps"},
    {"city": "Pugnac"},
    {"city": "Puisseguin"},
    {"city": "Pujols-sur-Ciron"},
    {"city": "Pujols"},
    {"city": "Le Puy"},
    {"city": "Puybarban"},
    {"city": "Puynormand"},
    {"city": "Queyrac"},
    {"city": "Quinsac"},
    {"city": "Rauzan"},
    {"city": "Reignac"},
    {"city": "La Réole"},
    {"city": "Rimons"},
    {"city": "Riocaud"},
    {"city": "Rions"},
    {"city": "La Rivière"},
    {"city": "Roaillan"},
    {"city": "Romagne"},
    {"city": "Roquebrune"},
    {"city": "La Roquille"},
    {"city": "Ruch"},
    {"city": "Sablons"},
    {"city": "Sadirac"},
    {"city": "Saillans"},
    {"city": "Saint-Aignan"},
    {"city": "Saint-André-de-Cubzac"},
    {"city": "Saint-André-du-Bois"},
    {"city": "Saint-André-et-Appelles"},
    {"city": "Saint-Androny"},
    {"city": "Saint-Antoine-du-Queyret"},
    {"city": "Saint-Antoine-sur-l'Isle"},
    {"city": "Saint-Aubin-de-Blaye"},
    {"city": "Saint-Aubin-de-Branne"},
    {"city": "Saint-Aubin-de-Médoc"},
    {"city": "Saint-Avit-de-Soulège"},
    {"city": "Saint-Avit-Saint-Nazaire"},
    {"city": "Saint-Brice"},
    {"city": "Val-de-Livenne"},
    {"city": "Saint-Caprais-de-Bordeaux"},
    {"city": "Saint-Christoly-de-Blaye"},
    {"city": "Saint-Christoly-Médoc"},
    {"city": "Saint-Christophe-des-Bardes"},
    {"city": "Saint-Christophe-de-Double"},
    {"city": "Saint-Cibard"},
    {"city": "Saint-Ciers-d'Abzac"},
    {"city": "Saint-Ciers-de-Canesse"},
    {"city": "Saint-Ciers-sur-Gironde"},
    {"city": "Sainte-Colombe"},
    {"city": "Saint-Côme"},
    {"city": "Sainte-Croix-du-Mont"},
    {"city": "Saint-Denis-de-Pile"},
    {"city": "Saint-Émilion"},
    {"city": "Saint-Estèphe"},
    {"city": "Saint-Étienne-de-Lisse"},
    {"city": "Sainte-Eulalie"},
    {"city": "Saint-Exupéry"},
    {"city": "Saint-Félix-de-Foncaude"},
    {"city": "Saint-Ferme"},
    {"city": "Sainte-Florence"},
    {"city": "Sainte-Foy-la-Grande"},
    {"city": "Sainte-Foy-la-Longue"},
    {"city": "Sainte-Gemme"},
    {"city": "Saint-Genès-de-Blaye"},
    {"city": "Saint-Genès-de-Castillon"},
    {"city": "Saint-Genès-de-Fronsac"},
    {"city": "Saint-Genès-de-Lombaud"},
    {"city": "Saint-Genis-du-Bois"},
    {"city": "Saint-Germain-de-Grave"},
    {"city": "Saint-Germain-d'Esteuil"},
    {"city": "Saint-Germain-du-Puch"},
    {"city": "Saint-Germain-de-la-Rivière"},
    {"city": "Saint-Gervais"},
    {"city": "Saint-Girons-d'Aiguevives"},
    {"city": "Sainte-Hélène"},
    {"city": "Saint-Hilaire-de-la-Noaille"},
    {"city": "Saint-Hilaire-du-Bois"},
    {"city": "Saint-Hippolyte"},
    {"city": "Saint-Jean-de-Blaignac"},
    {"city": "Saint-Jean-d'Illac"},
    {"city": "Saint-Julien-Beychevelle"},
    {"city": "Saint-Laurent-Médoc"},
    {"city": "Saint-Laurent-d'Arce"},
    {"city": "Saint-Laurent-des-Combes"},
    {"city": "Saint-Laurent-du-Bois"},
    {"city": "Saint-Laurent-du-Plan"},
    {"city": "Saint-Léger-de-Balson"},
    {"city": "Saint-Léon"},
    {"city": "Saint-Loubert"},
    {"city": "Saint-Loubès"},
    {"city": "Saint-Louis-de-Montferrand"},
    {"city": "Saint-Macaire"},
    {"city": "Saint-Magne"},
    {"city": "Saint-Magne-de-Castillon"},
    {"city": "Saint-Maixant"},
    {"city": "Saint-Mariens"},
    {"city": "Saint-Martial"},
    {"city": "Saint-Martin-Lacaussade"},
    {"city": "Saint-Martin-de-Laye"},
    {"city": "Saint-Martin-de-Lerm"},
    {"city": "Saint-Martin-de-Sescas"},
    {"city": "Saint-Martin-du-Bois"},
    {"city": "Saint-Martin-du-Puy"},
    {"city": "Saint-Médard-de-Guizières"},
    {"city": "Saint-Médard-d'Eyrans"},
    {"city": "Saint-Médard-en-Jalles"},
    {"city": "Saint-Michel-de-Castelnau"},
    {"city": "Saint-Michel-de-Fronsac"},
    {"city": "Saint-Michel-de-Rieufret"},
    {"city": "Saint-Michel-de-Lapujade"},
    {"city": "Saint-Morillon"},
    {"city": "Saint-Palais"},
    {"city": "Saint-Pardon-de-Conques"},
    {"city": "Saint-Paul"},
    {"city": "Saint-Pey-d'Armens"},
    {"city": "Saint-Pey-de-Castets"},
    {"city": "Saint-Philippe-d'Aiguille"},
    {"city": "Saint-Philippe-du-Seignal"},
    {"city": "Saint-Pierre-d'Aurillac"},
    {"city": "Saint-Pierre-de-Bat"},
    {"city": "Saint-Pierre-de-Mons"},
    {"city": "Saint-Quentin-de-Baron"},
    {"city": "Saint-Quentin-de-Caplong"},
    {"city": "Sainte-Radegonde"},
    {"city": "Saint-Romain-la-Virvée"},
    {"city": "Saint-Sauveur"},
    {"city": "Saint-Sauveur-de-Puynormand"},
    {"city": "Saint-Savin"},
    {"city": "Saint-Selve"},
    {"city": "Saint-Seurin-de-Bourg"},
    {"city": "Saint-Seurin-de-Cadourne"},
    {"city": "Saint-Seurin-de-Cursac"},
    {"city": "Saint-Seurin-sur-l'Isle"},
    {"city": "Saint-Sève"},
    {"city": "Saint-Sulpice-de-Faleyrens"},
    {"city": "Saint-Sulpice-de-Guilleragues"},
    {"city": "Saint-Sulpice-de-Pommiers"},
    {"city": "Saint-Sulpice-et-Cameyrac"},
    {"city": "Saint-Symphorien"},
    {"city": "Sainte-Terre"},
    {"city": "Saint-Trojan"},
    {"city": "Saint-Vincent-de-Paul"},
    {"city": "Saint-Vincent-de-Pertignas"},
    {"city": "Saint-Vivien-de-Blaye"},
    {"city": "Saint-Vivien-de-Médoc"},
    {"city": "Saint-Vivien-de-Monségur"},
    {"city": "Saint-Yzan-de-Soudiac"},
    {"city": "Saint-Yzans-de-Médoc"},
    {"city": "Salaunes"},
    {"city": "Sallebœuf"},
    {"city": "Salles"},
    {"city": "Les Salles-de-Castillon"},
    {"city": "Samonac"},
    {"city": "Saucats"},
    {"city": "Saugon"},
    {"city": "Saumos"},
    {"city": "Sauternes"},
    {"city": "La Sauve"},
    {"city": "Sauveterre-de-Guyenne"},
    {"city": "Sauviac"},
    {"city": "Savignac"},
    {"city": "Savignac-de-l'Isle"},
    {"city": "Semens"},
    {"city": "Sendets"},
    {"city": "Sigalens"},
    {"city": "Sillas"},
    {"city": "Soulac-sur-Mer"},
    {"city": "Soulignac"},
    {"city": "Soussac"},
    {"city": "Soussans"},
    {"city": "Tabanac"},
    {"city": "Le Taillan-Médoc"},
    {"city": "Taillecavat"},
    {"city": "Talais"},
    {"city": "Talence"},
    {"city": "Targon"},
    {"city": "Tarnès"},
    {"city": "Tauriac"},
    {"city": "Tayac"},
    {"city": "Le Teich"},
    {"city": "Le Temple"},
    {"city": "La Teste-de-Buch"},
    {"city": "Teuillac"},
    {"city": "Tizac-de-Curton"},
    {"city": "Tizac-de-Lapouyade"},
    {"city": "Toulenne"},
    {"city": "Le Tourne"},
    {"city": "Tresses"},
    {"city": "Le Tuzan"},
    {"city": "Uzeste"},
    {"city": "Valeyrac"},
    {"city": "Vayres"},
    {"city": "Vendays-Montalivet"},
    {"city": "Vensac"},
    {"city": "Vérac"},
    {"city": "Verdelais"},
    {"city": "Le Verdon-sur-Mer"},
    {"city": "Vertheuil"},
    {"city": "Vignonet"},
    {"city": "Villandraut"},
    {"city": "Villegouge"},
    {"city": "Villenave-de-Rions"},
    {"city": "Villenave-d'Ornon"},
    {"city": "Villeneuve"},
    {"city": "Virelade"},
    {"city": "Virsac"},
    {"city": "Yvrac"},
    {"city": "Marcheprime"},
    {"city": "Abeilhan"},
    {"city": "Adissan"},
    {"city": "Agde"},
    {"city": "Agel"},
    {"city": "Agonès"},
    {"city": "Aigne"},
    {"city": "Aigues-Vives"},
    {"city": "Les Aires"},
    {"city": "Alignan-du-Vent"},
    {"city": "Aniane"},
    {"city": "Arboras"},
    {"city": "Argelliers"},
    {"city": "Aspiran"},
    {"city": "Assas"},
    {"city": "Assignan"},
    {"city": "Aumelas"},
    {"city": "Aumes"},
    {"city": "Autignac"},
    {"city": "Avène"},
    {"city": "Azillanet"},
    {"city": "Babeau-Bouldoux"},
    {"city": "Baillargues"},
    {"city": "Balaruc-les-Bains"},
    {"city": "Balaruc-le-Vieux"},
    {"city": "Bassan"},
    {"city": "Beaufort"},
    {"city": "Beaulieu"},
    {"city": "Bédarieux"},
    {"city": "Bélarga"},
    {"city": "Berlou"},
    {"city": "Bessan"},
    {"city": "Béziers"},
    {"city": "Boisseron"},
    {"city": "Boisset"},
    {"city": "La Boissière"},
    {"city": "Le Bosc"},
    {"city": "Boujan-sur-Libron"},
    {"city": "Le Bousquet-d'Orb"},
    {"city": "Bouzigues"},
    {"city": "Brenas"},
    {"city": "Brignac"},
    {"city": "Brissac"},
    {"city": "Buzignargues"},
    {"city": "Cabrerolles"},
    {"city": "Cabrières"},
    {"city": "Cambon-et-Salvergues"},
    {"city": "Campagnan"},
    {"city": "Campagne"},
    {"city": "Camplong"},
    {"city": "Candillargues"},
    {"city": "Canet"},
    {"city": "Capestang"},
    {"city": "Carlencas-et-Levas"},
    {"city": "Cassagnoles"},
    {"city": "Castanet-le-Haut"},
    {"city": "Castelnau-de-Guers"},
    {"city": "Castelnau-le-Lez"},
    {"city": "Castries"},
    {"city": "La Caunette"},
    {"city": "Causse-de-la-Selle"},
    {"city": "Causses-et-Veyran"},
    {"city": "Caussiniojouls"},
    {"city": "Caux"},
    {"city": "Le Caylar"},
    {"city": "Cazedarnes"},
    {"city": "Cazevieille"},
    {"city": "Cazilhac"},
    {"city": "Cazouls-d'Hérault"},
    {"city": "Cazouls-lès-Béziers"},
    {"city": "Cébazan"},
    {"city": "Ceilhes-et-Rocozels"},
    {"city": "Celles"},
    {"city": "Cers"},
    {"city": "Cessenon-sur-Orb"},
    {"city": "Cesseras"},
    {"city": "Ceyras"},
    {"city": "Clapiers"},
    {"city": "Claret"},
    {"city": "Clermont-l'Hérault"},
    {"city": "Colombières-sur-Orb"},
    {"city": "Colombiers"},
    {"city": "Combaillaux"},
    {"city": "Combes"},
    {"city": "Corneilhan"},
    {"city": "Coulobres"},
    {"city": "Courniou"},
    {"city": "Cournonsec"},
    {"city": "Cournonterral"},
    {"city": "Creissan"},
    {"city": "Le Crès"},
    {"city": "Le Cros"},
    {"city": "Cruzy"},
    {"city": "Dio-et-Valquières"},
    {"city": "Espondeilhan"},
    {"city": "Fabrègues"},
    {"city": "Faugères"},
    {"city": "Félines-Minervois"},
    {"city": "Ferrals-les-Montagnes"},
    {"city": "Ferrières-les-Verreries"},
    {"city": "Ferrières-Poussarou"},
    {"city": "Florensac"},
    {"city": "Fontanès"},
    {"city": "Fontès"},
    {"city": "Fos"},
    {"city": "Fouzilhon"},
    {"city": "Fozières"},
    {"city": "Fraisse-sur-Agout"},
    {"city": "Frontignan"},
    {"city": "Gabian"},
    {"city": "Galargues"},
    {"city": "Ganges"},
    {"city": "Garrigues"},
    {"city": "Gigean"},
    {"city": "Gignac"},
    {"city": "Gorniès"},
    {"city": "Grabels"},
    {"city": "Graissessac"},
    {"city": "Guzargues"},
    {"city": "Hérépian"},
    {"city": "Jacou"},
    {"city": "Joncels"},
    {"city": "Jonquières"},
    {"city": "Juvignac"},
    {"city": "Lacoste"},
    {"city": "Lagamas"},
    {"city": "Lamalou-les-Bains"},
    {"city": "Lansargues"},
    {"city": "Laroque"},
    {"city": "Lattes"},
    {"city": "Laurens"},
    {"city": "Lauret"},
    {"city": "Lauroux"},
    {"city": "Lavalette"},
    {"city": "Lavérune"},
    {"city": "Lespignan"},
    {"city": "Lézignan-la-Cèbe"},
    {"city": "Liausson"},
    {"city": "Lieuran-Cabrières"},
    {"city": "Lieuran-lès-Béziers"},
    {"city": "Lignan-sur-Orb"},
    {"city": "La Livinière"},
    {"city": "Lodève"},
    {"city": "Loupian"},
    {"city": "Lunas"},
    {"city": "Lunel"},
    {"city": "Lunel-Viel"},
    {"city": "Magalas"},
    {"city": "Maraussan"},
    {"city": "Margon"},
    {"city": "Marseillan"},
    {"city": "Marsillargues"},
    {"city": "Mas-de-Londres"},
    {"city": "Les Matelles"},
    {"city": "Mauguio"},
    {"city": "Maureilhan"},
    {"city": "Mérifons"},
    {"city": "Mèze"},
    {"city": "Minerve"},
    {"city": "Mireval"},
    {"city": "Mons"},
    {"city": "Montady"},
    {"city": "Montagnac"},
    {"city": "Montarnaud"},
    {"city": "Montaud"},
    {"city": "Montbazin"},
    {"city": "Montblanc"},
    {"city": "Montels"},
    {"city": "Montesquieu"},
    {"city": "Montferrier-sur-Lez"},
    {"city": "Montouliers"},
    {"city": "Montoulieu"},
    {"city": "Montpellier"},
    {"city": "Montpeyroux"},
    {"city": "Moulès-et-Baucels"},
    {"city": "Mourèze"},
    {"city": "Mudaison"},
    {"city": "Murles"},
    {"city": "Murviel-lès-Béziers"},
    {"city": "Murviel-lès-Montpellier"},
    {"city": "Nébian"},
    {"city": "Neffiès"},
    {"city": "Nézignan-l'Évêque"},
    {"city": "Nissan-lez-Enserune"},
    {"city": "Nizas"},
    {"city": "Notre-Dame-de-Londres"},
    {"city": "Octon"},
    {"city": "Olargues"},
    {"city": "Olmet-et-Villecun"},
    {"city": "Olonzac"},
    {"city": "Oupia"},
    {"city": "Pailhès"},
    {"city": "Palavas-les-Flots"},
    {"city": "Pardailhan"},
    {"city": "Paulhan"},
    {"city": "Pégairolles-de-Buèges"},
    {"city": "Pégairolles-de-l'Escalette"},
    {"city": "Péret"},
    {"city": "Pérols"},
    {"city": "Pézenas"},
    {"city": "Pézènes-les-Mines"},
    {"city": "Pierrerue"},
    {"city": "Pignan"},
    {"city": "Pinet"},
    {"city": "Plaissan"},
    {"city": "Les Plans"},
    {"city": "Poilhes"},
    {"city": "Pomérols"},
    {"city": "Popian"},
    {"city": "Portiragnes"},
    {"city": "Le Pouget"},
    {"city": "Le Poujol-sur-Orb"},
    {"city": "Poujols"},
    {"city": "Poussan"},
    {"city": "Pouzolles"},
    {"city": "Pouzols"},
    {"city": "Le Pradal"},
    {"city": "Prades-le-Lez"},
    {"city": "Prades-sur-Vernazobre"},
    {"city": "Prémian"},
    {"city": "Le Puech"},
    {"city": "Puéchabon"},
    {"city": "Puilacher"},
    {"city": "Puimisson"},
    {"city": "Puissalicon"},
    {"city": "Puisserguier"},
    {"city": "Quarante"},
    {"city": "Restinclières"},
    {"city": "Rieussec"},
    {"city": "Riols"},
    {"city": "Les Rives"},
    {"city": "Romiguières"},
    {"city": "Roquebrun"},
    {"city": "Roqueredonde"},
    {"city": "Roquessels"},
    {"city": "Rosis"},
    {"city": "Rouet"},
    {"city": "Roujan"},
    {"city": "Saint-André-de-Buèges"},
    {"city": "Saint-André-de-Sangonis"},
    {"city": "Saint-Aunès"},
    {"city": "Saint-Bauzille-de-la-Sylve"},
    {"city": "Saint-Bauzille-de-Montmel"},
    {"city": "Saint-Bauzille-de-Putois"},
    {"city": "Saint-Brès"},
    {"city": "Saint-Chinian"},
    {"city": "Entre-Vignes"},
    {"city": "Saint-Clément-de-Rivière"},
    {"city": "Sainte-Croix-de-Quintillargues"},
    {"city": "Saint-Drézéry"},
    {"city": "Saint-Étienne-d'Albagnan"},
    {"city": "Saint-Étienne-de-Gourgas"},
    {"city": "Saint-Étienne-Estréchoux"},
    {"city": "Saint-Félix-de-l'Héras"},
    {"city": "Saint-Félix-de-Lodez"},
    {"city": "Saint-Gély-du-Fesc"},
    {"city": "Saint-Geniès-des-Mourgues"},
    {"city": "Saint-Geniès-de-Varensal"},
    {"city": "Saint-Geniès-de-Fontedit"},
    {"city": "Saint-Georges-d'Orques"},
    {"city": "Saint-Gervais-sur-Mare"},
    {"city": "Saint-Guilhem-le-Désert"},
    {"city": "Saint-Guiraud"},
    {"city": "Saint-Hilaire-de-Beauvoir"},
    {"city": "Saint-Jean-de-Buèges"},
    {"city": "Saint-Jean-de-Cornies"},
    {"city": "Saint-Jean-de-Cuculles"},
    {"city": "Saint-Jean-de-Fos"},
    {"city": "Saint-Jean-de-la-Blaquière"},
    {"city": "Saint-Jean-de-Minervois"},
    {"city": "Saint-Jean-de-Védas"},
    {"city": "Saint-Julien"},
    {"city": "Saint-Just"},
    {"city": "Saint-Martin-de-l'Arçon"},
    {"city": "Saint-Martin-de-Londres"},
    {"city": "Saint-Mathieu-de-Tréviers"},
    {"city": "Saint-Maurice-Navacelles"},
    {"city": "Saint-Michel"},
    {"city": "Saint-Nazaire-de-Ladarez"},
    {"city": "Saint-Nazaire-de-Pézan"},
    {"city": "Saint-Pargoire"},
    {"city": "Saint-Paul-et-Valmalle"},
    {"city": "Saint-Pierre-de-la-Fage"},
    {"city": "Saint-Pons-de-Thomières"},
    {"city": "Saint-Pons-de-Mauchiens"},
    {"city": "Saint-Privat"},
    {"city": "Saint-Saturnin-de-Lucian"},
    {"city": "Saint-Sériès"},
    {"city": "Saint-Thibéry"},
    {"city": "Saint-Vincent-de-Barbeyrargues"},
    {"city": "Saint-Vincent-d'Olargues"},
    {"city": "Salasc"},
    {"city": "La Salvetat-sur-Agout"},
    {"city": "Saturargues"},
    {"city": "Saussan"},
    {"city": "Saussines"},
    {"city": "Sauteyrargues"},
    {"city": "Sauvian"},
    {"city": "Sérignan"},
    {"city": "Servian"},
    {"city": "Sète"},
    {"city": "Siran"},
    {"city": "Sorbs"},
    {"city": "Soubès"},
    {"city": "Le Soulié"},
    {"city": "Soumont"},
    {"city": "Sussargues"},
    {"city": "Taussac-la-Billière"},
    {"city": "Teyran"},
    {"city": "Thézan-lès-Béziers"},
    {"city": "Tourbes"},
    {"city": "La Tour-sur-Orb"},
    {"city": "Tressan"},
    {"city": "Le Triadou"},
    {"city": "Usclas-d'Hérault"},
    {"city": "Usclas-du-Bosc"},
    {"city": "La Vacquerie-et-Saint-Martin-de-Castries"},
    {"city": "Vacquières"},
    {"city": "Vailhan"},
    {"city": "Vailhauquès"},
    {"city": "Valergues"},
    {"city": "Valflaunès"},
    {"city": "Valmascle"},
    {"city": "Valras-Plage"},
    {"city": "Valros"},
    {"city": "Vélieux"},
    {"city": "Vendargues"},
    {"city": "Vendémian"},
    {"city": "Vendres"},
    {"city": "Verreries-de-Moussans"},
    {"city": "Vias"},
    {"city": "Vic-la-Gardiole"},
    {"city": "Vieussan"},
    {"city": "Villemagne-l'Argentière"},
    {"city": "Villeneuve-lès-Béziers"},
    {"city": "Villeneuve-lès-Maguelone"},
    {"city": "Villeneuvette"},
    {"city": "Villespassans"},
    {"city": "Villetelle"},
    {"city": "Villeveyrac"},
    {"city": "Viols-en-Laval"},
    {"city": "Viols-le-Fort"},
    {"city": "La Grande-Motte"},
    {"city": "Acigné"},
    {"city": "Amanlis"},
    {"city": "Andouillé-Neuville"},
    {"city": "Val-Couesnon"},
    {"city": "Arbrissel"},
    {"city": "Argentré-du-Plessis"},
    {"city": "Aubigné"},
    {"city": "Availles-sur-Seiche"},
    {"city": "Baguer-Morvan"},
    {"city": "Baguer-Pican"},
    {"city": "Bain-de-Bretagne"},
    {"city": "Bains-sur-Oust"},
    {"city": "Bais"},
    {"city": "Balazé"},
    {"city": "Baulon"},
    {"city": "La Baussaine"},
    {"city": "La Bazouge-du-Désert"},
    {"city": "Bazouges-la-Pérouse"},
    {"city": "Beaucé"},
    {"city": "Bécherel"},
    {"city": "Bédée"},
    {"city": "Betton"},
    {"city": "Billé"},
    {"city": "Bléruais"},
    {"city": "Boisgervilly"},
    {"city": "Boistrudan"},
    {"city": "Bonnemain"},
    {"city": "La Bosse-de-Bretagne"},
    {"city": "La Bouëxière"},
    {"city": "Bourgbarré"},
    {"city": "Bourg-des-Comptes"},
    {"city": "La Boussac"},
    {"city": "Bovel"},
    {"city": "Bréal-sous-Montfort"},
    {"city": "Bréal-sous-Vitré"},
    {"city": "Brécé"},
    {"city": "Breteil"},
    {"city": "Brie"},
    {"city": "Brielles"},
    {"city": "Broualan"},
    {"city": "Bruc-sur-Aff"},
    {"city": "Les Brulais"},
    {"city": "Bruz"},
    {"city": "Cancale"},
    {"city": "Cardroc"},
    {"city": "Cesson-Sévigné"},
    {"city": "Champeaux"},
    {"city": "Chanteloup"},
    {"city": "Chantepie"},
    {"city": "La Chapelle-aux-Filtzméens"},
    {"city": "La Chapelle-Bouëxic"},
    {"city": "La Chapelle-Chaussée"},
    {"city": "La Chapelle-des-Fougeretz"},
    {"city": "La Chapelle du Lou du Lac"},
    {"city": "La Chapelle-Erbrée"},
    {"city": "La Chapelle-Janson"},
    {"city": "La Chapelle-Saint-Aubert"},
    {"city": "La Chapelle-de-Brain"},
    {"city": "La Chapelle-Thouarault"},
    {"city": "Chartres-de-Bretagne"},
    {"city": "Chasné-sur-Illet"},
    {"city": "Châteaubourg"},
    {"city": "Châteaugiron"},
    {"city": "Châteauneuf-d'Ille-et-Vilaine"},
    {"city": "Le Châtellier"},
    {"city": "Châtillon-en-Vendelais"},
    {"city": "Chauvigné"},
    {"city": "Chavagne"},
    {"city": "Chelun"},
    {"city": "Cherrueix"},
    {"city": "Chevaigné"},
    {"city": "Cintré"},
    {"city": "Clayes"},
    {"city": "Coësmes"},
    {"city": "Comblessac"},
    {"city": "Combourg"},
    {"city": "Combourtillé"},
    {"city": "Cornillé"},
    {"city": "Corps-Nuds"},
    {"city": "La Couyère"},
    {"city": "Crevin"},
    {"city": "Le Crouais"},
    {"city": "Cuguen"},
    {"city": "Dinard"},
    {"city": "Dingé"},
    {"city": "Dol-de-Bretagne"},
    {"city": "Domagné"},
    {"city": "Domalain"},
    {"city": "La Dominelais"},
    {"city": "Domloup"},
    {"city": "Dourdain"},
    {"city": "Drouges"},
    {"city": "Eancé"},
    {"city": "Epiniac"},
    {"city": "Erbrée"},
    {"city": "Ercé-en-Lamée"},
    {"city": "Ercé-près-Liffré"},
    {"city": "Essé"},
    {"city": "Étrelles"},
    {"city": "Feins"},
    {"city": "Le Ferré"},
    {"city": "Fleurigné"},
    {"city": "Forges-la-Forêt"},
    {"city": "Fougères"},
    {"city": "La Fresnais"},
    {"city": "Gaël"},
    {"city": "Gahard"},
    {"city": "Gennes-sur-Seiche"},
    {"city": "Gévezé"},
    {"city": "Gosné"},
    {"city": "La Gouesnière"},
    {"city": "Goven"},
    {"city": "Grand-Fougeray"},
    {"city": "La Guerche-de-Bretagne"},
    {"city": "Guichen"},
    {"city": "Guignen"},
    {"city": "Guipel"},
    {"city": "Hédé-Bazouges"},
    {"city": "L'Hermitage"},
    {"city": "Hirel"},
    {"city": "Iffendic"},
    {"city": "Les Iffs"},
    {"city": "Irodouër"},
    {"city": "Janzé"},
    {"city": "Javené"},
    {"city": "Laignelet"},
    {"city": "Laillé"},
    {"city": "Lalleu"},
    {"city": "Landavran"},
    {"city": "Landéan"},
    {"city": "Landujan"},
    {"city": "Langan"},
    {"city": "Langon"},
    {"city": "Langouet"},
    {"city": "Lanrigan"},
    {"city": "Lassy"},
    {"city": "Lécousse"},
    {"city": "Lieuron"},
    {"city": "Liffré"},
    {"city": "Lillemer"},
    {"city": "Livré-sur-Changeon"},
    {"city": "Lohéac"},
    {"city": "Longaulnay"},
    {"city": "Le Loroux"},
    {"city": "Lourmais"},
    {"city": "Loutehel"},
    {"city": "Louvigné-de-Bais"},
    {"city": "Louvigné-du-Désert"},
    {"city": "Luitré-Dompierre"},
    {"city": "Marcillé-Raoul"},
    {"city": "Marcillé-Robert"},
    {"city": "Marpiré"},
    {"city": "Martigné-Ferchaud"},
    {"city": "Val d'Anast"},
    {"city": "Maxent"},
    {"city": "Mecé"},
    {"city": "Médréac"},
    {"city": "Meillac"},
    {"city": "Melesse"},
    {"city": "Mellé"},
    {"city": "Mernel"},
    {"city": "Guipry-Messac"},
    {"city": "La Mézière"},
    {"city": "Mézières-sur-Couesnon"},
    {"city": "Miniac-Morvan"},
    {"city": "Miniac-sous-Bécherel"},
    {"city": "Le Minihic-sur-Rance"},
    {"city": "Mondevert"},
    {"city": "Montauban-de-Bretagne"},
    {"city": "Montautour"},
    {"city": "Mont-Dol"},
    {"city": "Monterfil"},
    {"city": "Montfort-sur-Meu"},
    {"city": "Montgermont"},
    {"city": "Monthault"},
    {"city": "Les Portes du Coglais"},
    {"city": "Montreuil-des-Landes"},
    {"city": "Montreuil-le-Gast"},
    {"city": "Montreuil-sous-Pérouse"},
    {"city": "Montreuil-sur-Ille"},
    {"city": "Mordelles"},
    {"city": "Mouazé"},
    {"city": "Moulins"},
    {"city": "Moussé"},
    {"city": "Moutiers"},
    {"city": "Muel"},
    {"city": "La Noë-Blanche"},
    {"city": "La Nouaye"},
    {"city": "Nouvoitou"},
    {"city": "Noyal-sous-Bazouges"},
    {"city": "Noyal-Châtillon-sur-Seiche"},
    {"city": "Noyal-sur-Vilaine"},
    {"city": "Orgères"},
    {"city": "Pacé"},
    {"city": "Paimpont"},
    {"city": "Pancé"},
    {"city": "Parcé"},
    {"city": "Parigné"},
    {"city": "Parthenay-de-Bretagne"},
    {"city": "Le Pertre"},
    {"city": "Le Petit-Fougeray"},
    {"city": "Pipriac"},
    {"city": "Piré-Chancé"},
    {"city": "Pléchâtel"},
    {"city": "Pleine-Fougères"},
    {"city": "Plélan-le-Grand"},
    {"city": "Plerguer"},
    {"city": "Plesder"},
    {"city": "Pleugueneuc"},
    {"city": "Pleumeleuc"},
    {"city": "Pleurtuit"},
    {"city": "Pocé-les-Bois"},
    {"city": "Poilley"},
    {"city": "Poligné"},
    {"city": "Princé"},
    {"city": "Québriac"},
    {"city": "Quédillac"},
    {"city": "Rannée"},
    {"city": "Redon"},
    {"city": "Renac"},
    {"city": "Rennes"},
    {"city": "Retiers"},
    {"city": "Le Rheu"},
    {"city": "La Richardais"},
    {"city": "Rimou"},
    {"city": "Romagné"},
    {"city": "Romazy"},
    {"city": "Romillé"},
    {"city": "Roz-Landrieux"},
    {"city": "Roz-sur-Couesnon"},
    {"city": "Sains"},
    {"city": "Sainte-Anne-sur-Vilaine"},
    {"city": "Saint-Armel"},
    {"city": "Saint-Aubin-d'Aubigné"},
    {"city": "Saint-Aubin-des-Landes"},
    {"city": "Saint-Aubin-du-Cormier"},
    {"city": "Saint-Benoît-des-Ondes"},
    {"city": "Saint-Briac-sur-Mer"},
    {"city": "Maen Roch"},
    {"city": "Saint-Brieuc-des-Iffs"},
    {"city": "Saint-Broladre"},
    {"city": "Saint-Christophe-des-Bois"},
    {"city": "Saint-Christophe-de-Valains"},
    {"city": "Sainte-Colombe"},
    {"city": "Saint-Coulomb"},
    {"city": "Saint-Didier"},
    {"city": "Saint-Domineuc"},
    {"city": "Saint-Erblon"},
    {"city": "Saint-Ganton"},
    {"city": "Saint-Georges-de-Gréhaigne"},
    {"city": "Saint-Georges-de-Reintembault"},
    {"city": "Saint-Germain-du-Pinel"},
    {"city": "Saint-Germain-en-Coglès"},
    {"city": "Saint-Germain-sur-Ille"},
    {"city": "Saint-Gilles"},
    {"city": "Saint-Gondran"},
    {"city": "Saint-Gonlay"},
    {"city": "Saint-Grégoire"},
    {"city": "Saint-Guinoux"},
    {"city": "Saint-Hilaire-des-Landes"},
    {"city": "Saint-Jacques-de-la-Lande"},
    {"city": "Rives-du-Couesnon"},
    {"city": "Saint-Jean-sur-Vilaine"},
    {"city": "Saint-Jouan-des-Guérets"},
    {"city": "Saint-Just"},
    {"city": "Saint-Léger-des-Prés"},
    {"city": "Saint-Lunaire"},
    {"city": "Saint-Malo"},
    {"city": "Saint-Malo-de-Phily"},
    {"city": "Saint-Malon-sur-Mel"},
    {"city": "Saint-Marcan"},
    {"city": "Saint-Marc-le-Blanc"},
    {"city": "Sainte-Marie"},
    {"city": "Saint-Maugan"},
    {"city": "Saint-Médard-sur-Ille"},
    {"city": "Saint-Méen-le-Grand"},
    {"city": "Saint-Méloir-des-Ondes"},
    {"city": "Saint-M'Hervé"},
    {"city": "Saint-Onen-la-Chapelle"},
    {"city": "Saint-Ouen-des-Alleux"},
    {"city": "Saint-Péran"},
    {"city": "Saint-Père-Marc-en-Poulet"},
    {"city": "Saint-Pern"},
    {"city": "Mesnil-Roc'h"},
    {"city": "Saint-Rémy-du-Plain"},
    {"city": "Saint-Sauveur-des-Landes"},
    {"city": "Saint-Séglin"},
    {"city": "Saint-Senoux"},
    {"city": "Saint-Suliac"},
    {"city": "Saint-Sulpice-la-Forêt"},
    {"city": "Saint-Sulpice-des-Landes"},
    {"city": "Saint-Symphorien"},
    {"city": "Saint-Thual"},
    {"city": "Saint-Thurial"},
    {"city": "Saint-Uniac"},
    {"city": "Saulnières"},
    {"city": "Le Sel-de-Bretagne"},
    {"city": "La Selle-en-Luitré"},
    {"city": "La Selle-Guerchaise"},
    {"city": "Sens-de-Bretagne"},
    {"city": "Servon-sur-Vilaine"},
    {"city": "Sixt-sur-Aff"},
    {"city": "Sougéal"},
    {"city": "Taillis"},
    {"city": "Talensac"},
    {"city": "Teillay"},
    {"city": "Le Theil-de-Bretagne"},
    {"city": "Thorigné-Fouillard"},
    {"city": "Thourie"},
    {"city": "Le Tiercent"},
    {"city": "Tinténiac"},
    {"city": "Torcé"},
    {"city": "Trans-la-Forêt"},
    {"city": "Treffendel"},
    {"city": "Trémeheuc"},
    {"city": "Tresbœuf"},
    {"city": "Trévérien"},
    {"city": "Trimer"},
    {"city": "Val-d'Izé"},
    {"city": "Vergéal"},
    {"city": "Le Verger"},
    {"city": "Vern-sur-Seiche"},
    {"city": "Vezin-le-Coquet"},
    {"city": "Vieux-Viel"},
    {"city": "Vieux-Vy-sur-Couesnon"},
    {"city": "Vignoc"},
    {"city": "Villamée"},
    {"city": "La Ville-ès-Nonais"},
    {"city": "Visseiche"},
    {"city": "Vitré"},
    {"city": "Le Vivier-sur-Mer"},
    {"city": "Le Tronchet"},
    {"city": "Pont-Péan"},
    {"city": "Aigurande"},
    {"city": "Aize"},
    {"city": "Ambrault"},
    {"city": "Anjouin"},
    {"city": "Ardentes"},
    {"city": "Argenton-sur-Creuse"},
    {"city": "Argy"},
    {"city": "Arpheuilles"},
    {"city": "Arthon"},
    {"city": "Azay-le-Ferron"},
    {"city": "Bagneux"},
    {"city": "Baraize"},
    {"city": "Baudres"},
    {"city": "Bazaiges"},
    {"city": "Beaulieu"},
    {"city": "Bélâbre"},
    {"city": "La Berthenoux"},
    {"city": "Le Blanc"},
    {"city": "Bommiers"},
    {"city": "Bonneuil"},
    {"city": "Les Bordes"},
    {"city": "Bouesse"},
    {"city": "Bouges-le-Château"},
    {"city": "Bretagne"},
    {"city": "Briantes"},
    {"city": "Brion"},
    {"city": "Brives"},
    {"city": "La Buxerette"},
    {"city": "Buxeuil"},
    {"city": "Buxières-d'Aillac"},
    {"city": "Buzançais"},
    {"city": "Ceaulmont"},
    {"city": "Celon"},
    {"city": "Chabris"},
    {"city": "Chaillac"},
    {"city": "Chalais"},
    {"city": "La Champenoise"},
    {"city": "Champillet"},
    {"city": "La Chapelle-Orthemale"},
    {"city": "La Chapelle-Saint-Laurian"},
    {"city": "Chasseneuil"},
    {"city": "Chassignolles"},
    {"city": "Châteauroux"},
    {"city": "Châtillon-sur-Indre"},
    {"city": "La Châtre"},
    {"city": "La Châtre-Langlin"},
    {"city": "Chavin"},
    {"city": "Chazelet"},
    {"city": "Chezelles"},
    {"city": "Chitray"},
    {"city": "Chouday"},
    {"city": "Ciron"},
    {"city": "Cléré-du-Bois"},
    {"city": "Clion"},
    {"city": "Cluis"},
    {"city": "Coings"},
    {"city": "Concremiers"},
    {"city": "Condé"},
    {"city": "Crevant"},
    {"city": "Crozon-sur-Vauvre"},
    {"city": "Cuzion"},
    {"city": "Déols"},
    {"city": "Diors"},
    {"city": "Diou"},
    {"city": "Douadic"},
    {"city": "Dunet"},
    {"city": "Dun-le-Poëlier"},
    {"city": "Écueillé"},
    {"city": "Éguzon-Chantôme"},
    {"city": "Étrechet"},
    {"city": "Feusines"},
    {"city": "Fléré-la-Rivière"},
    {"city": "Fontenay"},
    {"city": "Fontgombault"},
    {"city": "Fontguenand"},
    {"city": "Fougerolles"},
    {"city": "Francillon"},
    {"city": "Frédille"},
    {"city": "Gargilesse-Dampierre"},
    {"city": "Gehée"},
    {"city": "Giroux"},
    {"city": "Gournay"},
    {"city": "Guilly"},
    {"city": "Heugnes"},
    {"city": "Ingrandes"},
    {"city": "Issoudun"},
    {"city": "Jeu-les-Bois"},
    {"city": "Jeu-Maloches"},
    {"city": "Lacs"},
    {"city": "Langé"},
    {"city": "Levroux"},
    {"city": "Lignac"},
    {"city": "Lignerolles"},
    {"city": "Lingé"},
    {"city": "Liniez"},
    {"city": "Lizeray"},
    {"city": "Lourdoueix-Saint-Michel"},
    {"city": "Lourouer-Saint-Laurent"},
    {"city": "Luant"},
    {"city": "Luçay-le-Libre"},
    {"city": "Luçay-le-Mâle"},
    {"city": "Lurais"},
    {"city": "Lureuil"},
    {"city": "Luzeret"},
    {"city": "Lye"},
    {"city": "Lys-Saint-Georges"},
    {"city": "Le Magny"},
    {"city": "Maillet"},
    {"city": "Malicornay"},
    {"city": "Mâron"},
    {"city": "Martizay"},
    {"city": "Mauvières"},
    {"city": "Menetou-sur-Nahon"},
    {"city": "Ménétréols-sous-Vatan"},
    {"city": "Le Menoux"},
    {"city": "Méobecq"},
    {"city": "Mérigny"},
    {"city": "Mers-sur-Indre"},
    {"city": "Meunet-Planches"},
    {"city": "Meunet-sur-Vatan"},
    {"city": "Mézières-en-Brenne"},
    {"city": "Migné"},
    {"city": "Migny"},
    {"city": "Montchevrier"},
    {"city": "Montgivray"},
    {"city": "Montierchaume"},
    {"city": "Montipouret"},
    {"city": "Montlevicq"},
    {"city": "Mosnay"},
    {"city": "La Motte-Feuilly"},
    {"city": "Mouhers"},
    {"city": "Mouhet"},
    {"city": "Moulins-sur-Céphons"},
    {"city": "Murs"},
    {"city": "Néons-sur-Creuse"},
    {"city": "Néret"},
    {"city": "Neuillay-les-Bois"},
    {"city": "Neuvy-Pailloux"},
    {"city": "Neuvy-Saint-Sépulchre"},
    {"city": "Niherne"},
    {"city": "Nohant-Vic"},
    {"city": "Nuret-le-Ferron"},
    {"city": "Obterre"},
    {"city": "Orsennes"},
    {"city": "Orville"},
    {"city": "Oulches"},
    {"city": "Palluau-sur-Indre"},
    {"city": "Parnac"},
    {"city": "Paudy"},
    {"city": "Paulnay"},
    {"city": "Le Pêchereau"},
    {"city": "Pellevoisin"},
    {"city": "Pérassay"},
    {"city": "La Pérouille"},
    {"city": "Badecon-le-Pin"},
    {"city": "Le Poinçonnet"},
    {"city": "Pommiers"},
    {"city": "Le Pont-Chrétien-Chabenet"},
    {"city": "Poulaines"},
    {"city": "Pouligny-Notre-Dame"},
    {"city": "Pouligny-Saint-Martin"},
    {"city": "Pouligny-Saint-Pierre"},
    {"city": "Préaux"},
    {"city": "Preuilly-la-Ville"},
    {"city": "Prissac"},
    {"city": "Pruniers"},
    {"city": "Reboursin"},
    {"city": "Reuilly"},
    {"city": "Rivarennes"},
    {"city": "Rosnay"},
    {"city": "Roussines"},
    {"city": "Rouvres-les-Bois"},
    {"city": "Ruffec"},
    {"city": "Sacierges-Saint-Martin"},
    {"city": "Saint-Aigny"},
    {"city": "Saint-Aoustrille"},
    {"city": "Saint-Août"},
    {"city": "Saint-Aubin"},
    {"city": "Saint-Benoît-du-Sault"},
    {"city": "Saint-Chartier"},
    {"city": "Saint-Christophe-en-Bazelle"},
    {"city": "Saint-Christophe-en-Boucherie"},
    {"city": "Saint-Civran"},
    {"city": "Saint-Cyran-du-Jambot"},
    {"city": "Saint-Denis-de-Jouhet"},
    {"city": "Sainte-Fauste"},
    {"city": "Saint-Florentin"},
    {"city": "Saint-Gaultier"},
    {"city": "Sainte-Gemme"},
    {"city": "Saint-Genou"},
    {"city": "Saint-Georges-sur-Arnon"},
    {"city": "Saint-Gilles"},
    {"city": "Saint-Hilaire-sur-Benaize"},
    {"city": "Saint-Lactencin"},
    {"city": "Sainte-Lizaigne"},
    {"city": "Saint-Marcel"},
    {"city": "Saint-Maur"},
    {"city": "Saint-Médard"},
    {"city": "Saint-Michel-en-Brenne"},
    {"city": "Saint-Pierre-de-Jards"},
    {"city": "Saint-Plantaire"},
    {"city": "Sainte-Sévère-sur-Indre"},
    {"city": "Saint-Valentin"},
    {"city": "Sarzay"},
    {"city": "Sassierges-Saint-Germain"},
    {"city": "Saulnay"},
    {"city": "Sauzelles"},
    {"city": "Sazeray"},
    {"city": "Ségry"},
    {"city": "Selles-sur-Nahon"},
    {"city": "Sembleçay"},
    {"city": "Sougé"},
    {"city": "Tendu"},
    {"city": "Thenay"},
    {"city": "Thevet-Saint-Julien"},
    {"city": "Thizay"},
    {"city": "Tilly"},
    {"city": "Tournon-Saint-Martin"},
    {"city": "Le Tranger"},
    {"city": "Tranzault"},
    {"city": "Urciers"},
    {"city": "Valençay"},
    {"city": "Val-Fouzon"},
    {"city": "Vatan"},
    {"city": "Velles"},
    {"city": "Vendœuvres"},
    {"city": "La Vernelle"},
    {"city": "Verneuil-sur-Igneraie"},
    {"city": "Veuil"},
    {"city": "Vicq-Exemplet"},
    {"city": "Vicq-sur-Nahon"},
    {"city": "Vigoulant"},
    {"city": "Vigoux"},
    {"city": "Vijon"},
    {"city": "Villedieu-sur-Indre"},
    {"city": "Villegongis"},
    {"city": "Villegouin"},
    {"city": "Villentrois-Faverolles-en-Berry"},
    {"city": "Villiers"},
    {"city": "Vineuil"},
    {"city": "Vouillon"},
    {"city": "Abilly"},
    {"city": "Ambillou"},
    {"city": "Amboise"},
    {"city": "Anché"},
    {"city": "Antogny-le-Tillac"},
    {"city": "Artannes-sur-Indre"},
    {"city": "Assay"},
    {"city": "Athée-sur-Cher"},
    {"city": "Autrèche"},
    {"city": "Auzouer-en-Touraine"},
    {"city": "Avoine"},
    {"city": "Avon-les-Roches"},
    {"city": "Avrillé-les-Ponceaux"},
    {"city": "Azay-le-Rideau"},
    {"city": "Azay-sur-Cher"},
    {"city": "Azay-sur-Indre"},
    {"city": "Ballan-Miré"},
    {"city": "Barrou"},
    {"city": "Beaulieu-lès-Loches"},
    {"city": "Beaumont-Louestault"},
    {"city": "Beaumont-en-Véron"},
    {"city": "Beaumont-Village"},
    {"city": "Benais"},
    {"city": "Berthenay"},
    {"city": "Betz-le-Château"},
    {"city": "Bléré"},
    {"city": "Bossay-sur-Claise"},
    {"city": "Bossée"},
    {"city": "Le Boulay"},
    {"city": "Bourgueil"},
    {"city": "Bournan"},
    {"city": "Boussay"},
    {"city": "Braslou"},
    {"city": "Braye-sous-Faye"},
    {"city": "Braye-sur-Maulne"},
    {"city": "Brèches"},
    {"city": "Bréhémont"},
    {"city": "Bridoré"},
    {"city": "Brizay"},
    {"city": "Bueil-en-Touraine"},
    {"city": "Candes-Saint-Martin"},
    {"city": "Cangey"},
    {"city": "La Celle-Guenand"},
    {"city": "La Celle-Saint-Avant"},
    {"city": "Céré-la-Ronde"},
    {"city": "Cerelles"},
    {"city": "Chambon"},
    {"city": "Chambourg-sur-Indre"},
    {"city": "Chambray-lès-Tours"},
    {"city": "Champigny-sur-Veude"},
    {"city": "Chançay"},
    {"city": "Chanceaux-près-Loches"},
    {"city": "Chanceaux-sur-Choisille"},
    {"city": "Channay-sur-Lathan"},
    {"city": "La Chapelle-aux-Naux"},
    {"city": "La Chapelle-Blanche-Saint-Martin"},
    {"city": "La Chapelle-sur-Loire"},
    {"city": "Charentilly"},
    {"city": "Chargé"},
    {"city": "Charnizay"},
    {"city": "Château-la-Vallière"},
    {"city": "Château-Renault"},
    {"city": "Chaumussay"},
    {"city": "Chaveignes"},
    {"city": "Chédigny"},
    {"city": "Cheillé"},
    {"city": "Chemillé-sur-Dême"},
    {"city": "Chemillé-sur-Indrois"},
    {"city": "Chenonceaux"},
    {"city": "Chezelles"},
    {"city": "Chinon"},
    {"city": "Chisseaux"},
    {"city": "Chouzé-sur-Loire"},
    {"city": "Cigogné"},
    {"city": "Cinais"},
    {"city": "Cinq-Mars-la-Pile"},
    {"city": "Ciran"},
    {"city": "Civray-de-Touraine"},
    {"city": "Civray-sur-Esves"},
    {"city": "Cléré-les-Pins"},
    {"city": "Continvoir"},
    {"city": "Cormery"},
    {"city": "Couesmes"},
    {"city": "Courçay"},
    {"city": "Courcelles-de-Touraine"},
    {"city": "Courcoué"},
    {"city": "Couziers"},
    {"city": "Cravant-les-Côteaux"},
    {"city": "Crissay-sur-Manse"},
    {"city": "La Croix-en-Touraine"},
    {"city": "Crotelles"},
    {"city": "Crouzilles"},
    {"city": "Cussay"},
    {"city": "Dame-Marie-les-Bois"},
    {"city": "Dierre"},
    {"city": "Dolus-le-Sec"},
    {"city": "Draché"},
    {"city": "Druye"},
    {"city": "Épeigné-les-Bois"},
    {"city": "Épeigné-sur-Dême"},
    {"city": "Esves-le-Moutier"},
    {"city": "Esvres"},
    {"city": "Faye-la-Vineuse"},
    {"city": "La Ferrière"},
    {"city": "Ferrière-Larçon"},
    {"city": "Ferrière-sur-Beaulieu"},
    {"city": "Fondettes"},
    {"city": "Francueil"},
    {"city": "Genillé"},
    {"city": "Gizeux"},
    {"city": "Le Grand-Pressigny"},
    {"city": "La Guerche"},
    {"city": "Descartes"},
    {"city": "Les Hermites"},
    {"city": "Hommes"},
    {"city": "Huismes"},
    {"city": "L'Île-Bouchard"},
    {"city": "Jaulnay"},
    {"city": "Joué-lès-Tours"},
    {"city": "Langeais"},
    {"city": "Larçay"},
    {"city": "Lémeré"},
    {"city": "Lerné"},
    {"city": "Le Liège"},
    {"city": "Lignières-de-Touraine"},
    {"city": "Ligré"},
    {"city": "Ligueil"},
    {"city": "Limeray"},
    {"city": "Loches"},
    {"city": "Loché-sur-Indrois"},
    {"city": "Louans"},
    {"city": "Le Louroux"},
    {"city": "Lublé"},
    {"city": "Lussault-sur-Loire"},
    {"city": "Luynes"},
    {"city": "Luzé"},
    {"city": "Luzillé"},
    {"city": "Maillé"},
    {"city": "Manthelan"},
    {"city": "Marçay"},
    {"city": "Marcé-sur-Esves"},
    {"city": "Marcilly-sur-Maulne"},
    {"city": "Marcilly-sur-Vienne"},
    {"city": "Marigny-Marmande"},
    {"city": "Marray"},
    {"city": "Mazières-de-Touraine"},
    {"city": "La Membrolle-sur-Choisille"},
    {"city": "Mettray"},
    {"city": "Monnaie"},
    {"city": "Montbazon"},
    {"city": "Monthodon"},
    {"city": "Montlouis-sur-Loire"},
    {"city": "Montrésor"},
    {"city": "Montreuil-en-Touraine"},
    {"city": "Monts"},
    {"city": "Morand"},
    {"city": "Mosnes"},
    {"city": "Mouzay"},
    {"city": "Nazelles-Négron"},
    {"city": "Neuil"},
    {"city": "Neuillé-le-Lierre"},
    {"city": "Neuillé-Pont-Pierre"},
    {"city": "Neuilly-le-Brignon"},
    {"city": "Neuville-sur-Brenne"},
    {"city": "Neuvy-le-Roi"},
    {"city": "Noizay"},
    {"city": "Notre-Dame-d'Oé"},
    {"city": "Nouans-les-Fontaines"},
    {"city": "Nouâtre"},
    {"city": "Nouzilly"},
    {"city": "Noyant-de-Touraine"},
    {"city": "Orbigny"},
    {"city": "Panzoult"},
    {"city": "Parçay-Meslay"},
    {"city": "Parçay-sur-Vienne"},
    {"city": "Paulmy"},
    {"city": "Pernay"},
    {"city": "Perrusson"},
    {"city": "Le Petit-Pressigny"},
    {"city": "Pocé-sur-Cisse"},
    {"city": "Pont-de-Ruan"},
    {"city": "Ports"},
    {"city": "Pouzay"},
    {"city": "Preuilly-sur-Claise"},
    {"city": "Pussigny"},
    {"city": "Razines"},
    {"city": "Reignac-sur-Indre"},
    {"city": "Restigné"},
    {"city": "Reugny"},
    {"city": "La Riche"},
    {"city": "Richelieu"},
    {"city": "Rigny-Ussé"},
    {"city": "Rillé"},
    {"city": "Rilly-sur-Vienne"},
    {"city": "Rivarennes"},
    {"city": "Rivière"},
    {"city": "La Roche-Clermault"},
    {"city": "Rochecorbon"},
    {"city": "Rouziers-de-Touraine"},
    {"city": "Saché"},
    {"city": "Saint-Antoine-du-Rocher"},
    {"city": "Saint-Aubin-le-Dépeint"},
    {"city": "Saint-Avertin"},
    {"city": "Saint-Benoît-la-Forêt"},
    {"city": "Saint-Branchs"},
    {"city": "Sainte-Catherine-de-Fierbois"},
    {"city": "Saint-Christophe-sur-le-Nais"},
    {"city": "Saint-Cyr-sur-Loire"},
    {"city": "Saint-Épain"},
    {"city": "Saint-Étienne-de-Chigny"},
    {"city": "Saint-Flovier"},
    {"city": "Saint-Genouph"},
    {"city": "Saint-Germain-sur-Vienne"},
    {"city": "Saint-Hippolyte"},
    {"city": "Saint-Jean-Saint-Germain"},
    {"city": "Saint-Laurent-de-Lin"},
    {"city": "Saint-Laurent-en-Gâtines"},
    {"city": "Saint-Martin-le-Beau"},
    {"city": "Sainte-Maure-de-Touraine"},
    {"city": "Saint-Nicolas-de-Bourgueil"},
    {"city": "Saint-Nicolas-des-Motets"},
    {"city": "Saint-Ouen-les-Vignes"},
    {"city": "Saint-Paterne-Racan"},
    {"city": "Coteaux-sur-Loire"},
    {"city": "Saint-Pierre-des-Corps"},
    {"city": "Saint-Quentin-sur-Indrois"},
    {"city": "Saint-Règle"},
    {"city": "Saint-Roch"},
    {"city": "Saint-Senoch"},
    {"city": "Saunay"},
    {"city": "Savigné-sur-Lathan"},
    {"city": "Savigny-en-Véron"},
    {"city": "Savonnières"},
    {"city": "Sazilly"},
    {"city": "Semblançay"},
    {"city": "Sennevières"},
    {"city": "Sepmes"},
    {"city": "Seuilly"},
    {"city": "Sonzay"},
    {"city": "Sorigny"},
    {"city": "Souvigné"},
    {"city": "Souvigny-de-Touraine"},
    {"city": "Sublaines"},
    {"city": "Tauxigny-Saint-Bauld"},
    {"city": "Tavant"},
    {"city": "Theneuil"},
    {"city": "Thilouze"},
    {"city": "Thizay"},
    {"city": "Tournon-Saint-Pierre"},
    {"city": "La Tour-Saint-Gelin"},
    {"city": "Tours"},
    {"city": "Trogues"},
    {"city": "Truyes"},
    {"city": "Vallères"},
    {"city": "Varennes"},
    {"city": "Veigné"},
    {"city": "Véretz"},
    {"city": "Verneuil-le-Château"},
    {"city": "Verneuil-sur-Indre"},
    {"city": "Vernou-sur-Brenne"},
    {"city": "Villaines-les-Rochers"},
    {"city": "Villandry"},
    {"city": "La Ville-aux-Dames"},
    {"city": "Villebourg"},
    {"city": "Villedômain"},
    {"city": "Villedômer"},
    {"city": "Villeloin-Coulangé"},
    {"city": "Villeperdue"},
    {"city": "Villiers-au-Bouin"},
    {"city": "Vou"},
    {"city": "Vouvray"},
    {"city": "Yzeures-sur-Creuse"},
    {"city": "Les Abrets en Dauphiné"},
    {"city": "Les Adrets"},
    {"city": "Agnin"},
    {"city": "L'Albenc"},
    {"city": "Allemond"},
    {"city": "Allevard"},
    {"city": "Ambel"},
    {"city": "Anjou"},
    {"city": "Annoisin-Chatelans"},
    {"city": "Anthon"},
    {"city": "Aoste"},
    {"city": "Apprieu"},
    {"city": "Artas"},
    {"city": "Assieu"},
    {"city": "Auberives-en-Royans"},
    {"city": "Auberives-sur-Varèze"},
    {"city": "Auris"},
    {"city": "Les Avenières Veyrins-Thuellin"},
    {"city": "Avignonet"},
    {"city": "La Balme-les-Grottes"},
    {"city": "Barraux"},
    {"city": "La Bâtie-Montgascon"},
    {"city": "Beaucroissant"},
    {"city": "Beaufin"},
    {"city": "Beaufort"},
    {"city": "Beaulieu"},
    {"city": "Beaurepaire"},
    {"city": "Beauvoir-de-Marc"},
    {"city": "Beauvoir-en-Royans"},
    {"city": "Bellegarde-Poussieu"},
    {"city": "Belmont"},
    {"city": "Bernin"},
    {"city": "Besse"},
    {"city": "Bessins"},
    {"city": "Bévenais"},
    {"city": "Bilieu"},
    {"city": "Biol"},
    {"city": "Biviers"},
    {"city": "Bizonnes"},
    {"city": "Blandin"},
    {"city": "Bonnefamille"},
    {"city": "Bossieu"},
    {"city": "Le Bouchage"},
    {"city": "Bougé-Chambalud"},
    {"city": "Le Bourg-d'Oisans"},
    {"city": "Bourgoin-Jallieu"},
    {"city": "Bouvesse-Quirieu"},
    {"city": "Brangues"},
    {"city": "Bressieux"},
    {"city": "Bresson"},
    {"city": "Brézins"},
    {"city": "Brié-et-Angonnes"},
    {"city": "Brion"},
    {"city": "La Buisse"},
    {"city": "La Buissière"},
    {"city": "Burcin"},
    {"city": "Cessieu"},
    {"city": "Châbons"},
    {"city": "Chalon"},
    {"city": "Chamagnieu"},
    {"city": "Champagnier"},
    {"city": "Champier"},
    {"city": "Le Champ-près-Froges"},
    {"city": "Champ-sur-Drac"},
    {"city": "Chanas"},
    {"city": "Chantepérier"},
    {"city": "Chantesse"},
    {"city": "Chapareillan"},
    {"city": "La Chapelle-de-la-Tour"},
    {"city": "La Chapelle-de-Surieu"},
    {"city": "La Chapelle-du-Bard"},
    {"city": "Charancieu"},
    {"city": "Charantonnay"},
    {"city": "Charavines"},
    {"city": "Charette"},
    {"city": "Charnècles"},
    {"city": "Charvieu-Chavagneux"},
    {"city": "Chasselay"},
    {"city": "Chasse-sur-Rhône"},
    {"city": "Chassignieu"},
    {"city": "Château-Bernard"},
    {"city": "Châteauvilain"},
    {"city": "Châtelus"},
    {"city": "Châtenay"},
    {"city": "Châtonnay"},
    {"city": "Chatte"},
    {"city": "Chavanoz"},
    {"city": "Chélieu"},
    {"city": "Chevrières"},
    {"city": "Le Cheylas"},
    {"city": "Cheyssieu"},
    {"city": "Chèzeneuve"},
    {"city": "Chichilianne"},
    {"city": "Chimilin"},
    {"city": "Chirens"},
    {"city": "Cholonge"},
    {"city": "Chonas-l'Amballan"},
    {"city": "Choranche"},
    {"city": "Chozeau"},
    {"city": "Chuzelles"},
    {"city": "Claix"},
    {"city": "Clavans-en-Haut-Oisans"},
    {"city": "Clelles"},
    {"city": "Clonas-sur-Varèze"},
    {"city": "Saint-Martin-de-la-Cluze"},
    {"city": "Cognet"},
    {"city": "Cognin-les-Gorges"},
    {"city": "Colombe"},
    {"city": "La Combe-de-Lancey"},
    {"city": "Corbelin"},
    {"city": "Corenc"},
    {"city": "Cornillon-en-Trièves"},
    {"city": "Corps"},
    {"city": "Corrençon-en-Vercors"},
    {"city": "La Côte-Saint-André"},
    {"city": "Les Côtes-d'Arey"},
    {"city": "Les Côtes-de-Corps"},
    {"city": "Coublevie"},
    {"city": "Cour-et-Buis"},
    {"city": "Courtenay"},
    {"city": "Crachier"},
    {"city": "Cras"},
    {"city": "Crémieu"},
    {"city": "Creys-Mépieu"},
    {"city": "Crolles"},
    {"city": "Culin"},
    {"city": "Diémoz"},
    {"city": "Dizimieu"},
    {"city": "Doissin"},
    {"city": "Dolomieu"},
    {"city": "Domarin"},
    {"city": "Domène"},
    {"city": "Échirolles"},
    {"city": "Eclose-Badinières"},
    {"city": "Engins"},
    {"city": "Entraigues"},
    {"city": "Entre-deux-Guiers"},
    {"city": "Les Éparres"},
    {"city": "Estrablin"},
    {"city": "Eybens"},
    {"city": "Eydoche"},
    {"city": "Eyzin-Pinet"},
    {"city": "Faramans"},
    {"city": "Faverges-de-la-Tour"},
    {"city": "Le Haut-Bréda"},
    {"city": "La Flachère"},
    {"city": "Flachères"},
    {"city": "Fontaine"},
    {"city": "Fontanil-Cornillon"},
    {"city": "La Forteresse"},
    {"city": "Four"},
    {"city": "Le Freney-d'Oisans"},
    {"city": "La Frette"},
    {"city": "Froges"},
    {"city": "Frontonas"},
    {"city": "La Garde"},
    {"city": "Gières"},
    {"city": "Gillonnay"},
    {"city": "Goncelin"},
    {"city": "Le Grand-Lemps"},
    {"city": "Granieu"},
    {"city": "Grenay"},
    {"city": "Grenoble"},
    {"city": "Gresse-en-Vercors"},
    {"city": "Le Gua"},
    {"city": "Herbeys"},
    {"city": "Heyrieux"},
    {"city": "Hières-sur-Amby"},
    {"city": "Huez"},
    {"city": "Hurtières"},
    {"city": "L'Isle-d'Abeau"},
    {"city": "Izeaux"},
    {"city": "Izeron"},
    {"city": "Janneyrias"},
    {"city": "Jarcieu"},
    {"city": "Jardin"},
    {"city": "Jarrie"},
    {"city": "Laffrey"},
    {"city": "Lalley"},
    {"city": "Lans-en-Vercors"},
    {"city": "Laval"},
    {"city": "Lavaldens"},
    {"city": "Lavars"},
    {"city": "Lentiol"},
    {"city": "Leyrieu"},
    {"city": "Lieudieu"},
    {"city": "Livet-et-Gavet"},
    {"city": "Longechenal"},
    {"city": "Lumbin"},
    {"city": "Luzinay"},
    {"city": "Malleval-en-Vercors"},
    {"city": "Marcieu"},
    {"city": "Marcilloles"},
    {"city": "Marcollin"},
    {"city": "Marnans"},
    {"city": "Massieu"},
    {"city": "Maubec"},
    {"city": "Mayres-Savel"},
    {"city": "Autrans-Méaudre en Vercors"},
    {"city": "Mens"},
    {"city": "Merlas"},
    {"city": "Meylan"},
    {"city": "Meyrié"},
    {"city": "Meyrieu-les-Étangs"},
    {"city": "Meyssiez"},
    {"city": "Miribel-Lanchâtre"},
    {"city": "Miribel-les-Échelles"},
    {"city": "Mizoën"},
    {"city": "Moidieu-Détourbe"},
    {"city": "Moirans"},
    {"city": "Moissieu-sur-Dolon"},
    {"city": "Monestier-d'Ambel"},
    {"city": "Monestier-de-Clermont"},
    {"city": "Le Monestier-du-Percy"},
    {"city": "Monsteroux-Milieu"},
    {"city": "Montagne"},
    {"city": "Montagnieu"},
    {"city": "Montalieu-Vercieu"},
    {"city": "Montaud"},
    {"city": "Montbonnot-Saint-Martin"},
    {"city": "Montcarra"},
    {"city": "Montchaboud"},
    {"city": "Les Deux Alpes"},
    {"city": "Monteynard"},
    {"city": "Montfalcon"},
    {"city": "Montferrat"},
    {"city": "Montrevel"},
    {"city": "Mont-Saint-Martin"},
    {"city": "Montseveroux"},
    {"city": "Moras"},
    {"city": "Morestel"},
    {"city": "Morette"},
    {"city": "La Morte"},
    {"city": "La Motte-d'Aveillans"},
    {"city": "La Motte-Saint-Martin"},
    {"city": "Mottier"},
    {"city": "Le Moutaret"},
    {"city": "La Mure"},
    {"city": "La Murette"},
    {"city": "Murianette"},
    {"city": "Murinais"},
    {"city": "Nantes-en-Ratier"},
    {"city": "Serre-Nerpol"},
    {"city": "Nivolas-Vermelle"},
    {"city": "Notre-Dame-de-Commiers"},
    {"city": "Notre-Dame-de-l'Osier"},
    {"city": "Notre-Dame-de-Mésage"},
    {"city": "Notre-Dame-de-Vaulx"},
    {"city": "Noyarey"},
    {"city": "Optevoz"},
    {"city": "Oris-en-Rattier"},
    {"city": "Ornacieux-Balbins"},
    {"city": "Ornon"},
    {"city": "Oulles"},
    {"city": "Oyeu"},
    {"city": "Oytier-Saint-Oblas"},
    {"city": "Oz"},
    {"city": "Pact"},
    {"city": "Pajay"},
    {"city": "Villages du Lac de Paladru"},
    {"city": "Panossas"},
    {"city": "Parmilieu"},
    {"city": "Le Passage"},
    {"city": "Arandon-Passins"},
    {"city": "Le Péage-de-Roussillon"},
    {"city": "Pellafol"},
    {"city": "Penol"},
    {"city": "Percy"},
    {"city": "La Pierre"},
    {"city": "Pierre-Châtel"},
    {"city": "Pisieu"},
    {"city": "Plan"},
    {"city": "Poisat"},
    {"city": "Poliénas"},
    {"city": "Pommier-de-Beaurepaire"},
    {"city": "Ponsonnas"},
    {"city": "Pontcharra"},
    {"city": "Le Pont-de-Beauvoisin"},
    {"city": "Pont-de-Chéruy"},
    {"city": "Le Pont-de-Claix"},
    {"city": "Pont-Évêque"},
    {"city": "Pont-en-Royans"},
    {"city": "Porcieu-Amblagnieu"},
    {"city": "Prébois"},
    {"city": "Presles"},
    {"city": "Pressins"},
    {"city": "Primarette"},
    {"city": "Proveysieux"},
    {"city": "Prunières"},
    {"city": "Quaix-en-Chartreuse"},
    {"city": "Quet-en-Beaumont"},
    {"city": "Quincieu"},
    {"city": "Réaumont"},
    {"city": "Renage"},
    {"city": "Rencurel"},
    {"city": "Revel"},
    {"city": "Revel-Tourdan"},
    {"city": "Reventin-Vaugris"},
    {"city": "Rives"},
    {"city": "La Rivière"},
    {"city": "Roche"},
    {"city": "Les Roches-de-Condrieu"},
    {"city": "Rochetoirin"},
    {"city": "Roissard"},
    {"city": "Romagnieu"},
    {"city": "Roussillon"},
    {"city": "Rovon"},
    {"city": "Royas"},
    {"city": "Roybon"},
    {"city": "Ruy-Montceau"},
    {"city": "Sablons"},
    {"city": "Sainte-Agnès"},
    {"city": "Saint-Agnin-sur-Bion"},
    {"city": "Saint-Alban-de-Roche"},
    {"city": "Saint-Alban-du-Rhône"},
    {"city": "Saint-Albin-de-Vaulserre"},
    {"city": "Saint-Andéol"},
    {"city": "Saint-André-en-Royans"},
    {"city": "Saint-André-le-Gaz"},
    {"city": "Sainte-Anne-sur-Gervonde"},
    {"city": "Saint Antoine l'Abbaye"},
    {"city": "Saint-Appolinard"},
    {"city": "Saint-Arey"},
    {"city": "Saint-Aupre"},
    {"city": "Saint-Barthélemy"},
    {"city": "Saint-Barthélemy-de-Séchilienne"},
    {"city": "Saint-Baudille-de-la-Tour"},
    {"city": "Saint-Baudille-et-Pipet"},
    {"city": "Saint-Blaise-du-Buis"},
    {"city": "Sainte-Blandine"},
    {"city": "Saint-Bonnet-de-Chavagne"},
    {"city": "Saint-Bueil"},
    {"city": "Saint-Cassien"},
    {"city": "Saint-Chef"},
    {"city": "Saint-Christophe-en-Oisans"},
    {"city": "Saint-Christophe-sur-Guiers"},
    {"city": "Saint-Clair-de-la-Tour"},
    {"city": "Saint-Clair-du-Rhône"},
    {"city": "Saint-Clair-sur-Galaure"},
    {"city": "Saint-Didier-de-Bizonnes"},
    {"city": "Saint-Didier-de-la-Tour"},
    {"city": "Saint-Égrève"},
    {"city": "Saint-Étienne-de-Crossey"},
    {"city": "Saint-Étienne-de-Saint-Geoirs"},
    {"city": "Saint-Geoire-en-Valdaine"},
    {"city": "Saint-Geoirs"},
    {"city": "Saint-Georges-de-Commiers"},
    {"city": "Saint-Georges-d'Espéranche"},
    {"city": "Saint-Gervais"},
    {"city": "Saint-Guillaume"},
    {"city": "Saint-Hilaire-de-Brens"},
    {"city": "Saint-Hilaire-de-la-Côte"},
    {"city": "Saint-Hilaire-du-Rosier"},
    {"city": "Plateau-des-Petites-Roches"},
    {"city": "Saint-Honoré"},
    {"city": "Saint-Ismier"},
    {"city": "Saint-Jean-d'Avelanne"},
    {"city": "Saint-Jean-de-Bournay"},
    {"city": "Saint-Jean-de-Moirans"},
    {"city": "Saint-Jean-de-Soudain"},
    {"city": "Saint-Jean-de-Vaulx"},
    {"city": "Saint-Jean-d'Hérans"},
    {"city": "Saint-Jean-le-Vieux"},
    {"city": "Saint-Joseph-de-Rivière"},
    {"city": "Saint-Julien-de-l'Herms"},
    {"city": "La Sure en Chartreuse"},
    {"city": "Saint-Just-Chaleyssin"},
    {"city": "Saint-Just-de-Claix"},
    {"city": "Saint-Lattier"},
    {"city": "Saint-Laurent-du-Pont"},
    {"city": "Saint-Laurent-en-Beaumont"},
    {"city": "Sainte-Luce"},
    {"city": "Saint-Marcel-Bel-Accueil"},
    {"city": "Saint-Marcellin"},
    {"city": "Sainte-Marie-d'Alloix"},
    {"city": "Sainte-Marie-du-Mont"},
    {"city": "Saint-Martin-de-Clelles"},
    {"city": "Saint-Martin-de-Vaulserre"},
    {"city": "Saint-Martin-d'Hères"},
    {"city": "Saint-Martin-d'Uriage"},
    {"city": "Saint-Martin-le-Vinoux"},
    {"city": "Saint-Maurice-en-Trièves"},
    {"city": "Saint-Maurice-l'Exil"},
    {"city": "Saint-Maximin"},
    {"city": "Saint-Michel-de-Saint-Geoirs"},
    {"city": "Saint-Michel-en-Beaumont"},
    {"city": "Saint-Michel-les-Portes"},
    {"city": "Saint-Mury-Monteymond"},
    {"city": "Saint-Nazaire-les-Eymes"},
    {"city": "Saint-Nicolas-de-Macherin"},
    {"city": "Saint-Nizier-du-Moucherotte"},
    {"city": "Saint-Ondras"},
    {"city": "Saint-Paul-de-Varces"},
    {"city": "Saint-Paul-d'Izeaux"},
    {"city": "Saint-Paul-lès-Monestier"},
    {"city": "Crêts en Belledonne"},
    {"city": "Saint-Pierre-de-Bressieux"},
    {"city": "Saint-Pierre-de-Chartreuse"},
    {"city": "Saint-Pierre-de-Chérennes"},
    {"city": "Saint-Pierre-de-Méaroz"},
    {"city": "Saint-Pierre-de-Mésage"},
    {"city": "Saint-Pierre-d'Entremont"},
    {"city": "Saint-Prim"},
    {"city": "Saint-Quentin-Fallavier"},
    {"city": "Saint-Quentin-sur-Isère"},
    {"city": "Saint-Romain-de-Jalionas"},
    {"city": "Saint-Romain-de-Surieu"},
    {"city": "Saint-Romans"},
    {"city": "Saint-Sauveur"},
    {"city": "Saint-Savin"},
    {"city": "Châtel-en-Trièves"},
    {"city": "Saint-Siméon-de-Bressieux"},
    {"city": "Saint-Sorlin-de-Morestel"},
    {"city": "Saint-Sorlin-de-Vienne"},
    {"city": "Saint-Sulpice-des-Rivoires"},
    {"city": "Saint-Théoffrey"},
    {"city": "Saint-Vérand"},
    {"city": "Saint-Victor-de-Cessieu"},
    {"city": "Saint-Victor-de-Morestel"},
    {"city": "Saint-Vincent-de-Mercuze"},
    {"city": "Salagnon"},
    {"city": "Salaise-sur-Sanne"},
    {"city": "La Salette-Fallavaux"},
    {"city": "La Salle-en-Beaumont"},
    {"city": "Le Sappey-en-Chartreuse"},
    {"city": "Sarcenas"},
    {"city": "Sardieu"},
    {"city": "Sassenage"},
    {"city": "Satolas-et-Bonce"},
    {"city": "Savas-Mépin"},
    {"city": "Séchilienne"},
    {"city": "Porte-des-Bonnevaux"},
    {"city": "Septème"},
    {"city": "Sérézin-de-la-Tour"},
    {"city": "Sermérieu"},
    {"city": "Serpaize"},
    {"city": "Seyssinet-Pariset"},
    {"city": "Seyssins"},
    {"city": "Seyssuel"},
    {"city": "Siccieu-Saint-Julien-et-Carisieu"},
    {"city": "Siévoz"},
    {"city": "Sillans"},
    {"city": "Sinard"},
    {"city": "Soleymieu"},
    {"city": "La Sône"},
    {"city": "Sonnay"},
    {"city": "Sousville"},
    {"city": "Succieu"},
    {"city": "Susville"},
    {"city": "Têche"},
    {"city": "Tencin"},
    {"city": "La Terrasse"},
    {"city": "Theys"},
    {"city": "Thodure"},
    {"city": "Tignieu-Jameyzieu"},
    {"city": "Torchefelon"},
    {"city": "La Tour-du-Pin"},
    {"city": "Le Touvet"},
    {"city": "Tramolé"},
    {"city": "Treffort"},
    {"city": "Tréminis"},
    {"city": "Trept"},
    {"city": "La Tronche"},
    {"city": "Tullins"},
    {"city": "Valbonnais"},
    {"city": "Valencin"},
    {"city": "Valencogne"},
    {"city": "La Valette"},
    {"city": "Valjouffrey"},
    {"city": "Varacieux"},
    {"city": "Varces-Allières-et-Risset"},
    {"city": "Vasselin"},
    {"city": "Vatilieu"},
    {"city": "Vaujany"},
    {"city": "Vaulnaveys-le-Bas"},
    {"city": "Vaulnaveys-le-Haut"},
    {"city": "Vaulx-Milieu"},
    {"city": "Velanne"},
    {"city": "Vénérieu"},
    {"city": "Venon"},
    {"city": "Vernas"},
    {"city": "Vernioz"},
    {"city": "La Verpillière"},
    {"city": "Le Versoud"},
    {"city": "Vertrieu"},
    {"city": "Veurey-Voroize"},
    {"city": "Veyssilieu"},
    {"city": "Vézeronce-Curtin"},
    {"city": "Vienne"},
    {"city": "Vif"},
    {"city": "Vignieu"},
    {"city": "Villard-Bonnot"},
    {"city": "Villard-de-Lans"},
    {"city": "Villard-Notre-Dame"},
    {"city": "Villard-Reculas"},
    {"city": "Villard-Reymond"},
    {"city": "Villard-Saint-Christophe"},
    {"city": "Villefontaine"},
    {"city": "Villemoirieu"},
    {"city": "Villeneuve-de-Marc"},
    {"city": "Ville-sous-Anjou"},
    {"city": "Villette-d'Anthon"},
    {"city": "Villette-de-Vienne"},
    {"city": "Vinay"},
    {"city": "Val-de-Virieu"},
    {"city": "Viriville"},
    {"city": "Vizille"},
    {"city": "Voiron"},
    {"city": "Voissant"},
    {"city": "Voreppe"},
    {"city": "Vourey"},
    {"city": "Chamrousse"},
    {"city": "Abergement-la-Ronce"},
    {"city": "Abergement-le-Grand"},
    {"city": "Abergement-le-Petit"},
    {"city": "Abergement-lès-Thésy"},
    {"city": "Aiglepierre"},
    {"city": "Alièze"},
    {"city": "Amange"},
    {"city": "Andelot-en-Montagne"},
    {"city": "Andelot-Morval"},
    {"city": "Annoire"},
    {"city": "Arbois"},
    {"city": "Archelange"},
    {"city": "Ardon"},
    {"city": "Arinthod"},
    {"city": "Arlay"},
    {"city": "Aromas"},
    {"city": "Les Arsures"},
    {"city": "Arsure-Arsurette"},
    {"city": "La Chailleuse"},
    {"city": "Asnans-Beauvoisin"},
    {"city": "Audelange"},
    {"city": "Augea"},
    {"city": "Augerans"},
    {"city": "Augisey"},
    {"city": "Aumont"},
    {"city": "Aumur"},
    {"city": "Authume"},
    {"city": "Auxange"},
    {"city": "Avignon-lès-Saint-Claude"},
    {"city": "Balaiseaux"},
    {"city": "Balanod"},
    {"city": "Bans"},
    {"city": "Barésia-sur-l'Ain"},
    {"city": "La Barre"},
    {"city": "Barretaine"},
    {"city": "Baume-les-Messieurs"},
    {"city": "Baverans"},
    {"city": "Beaufort-Orbagna"},
    {"city": "Beffia"},
    {"city": "Bellecombe"},
    {"city": "Bellefontaine"},
    {"city": "Belmont"},
    {"city": "Bersaillin"},
    {"city": "Besain"},
    {"city": "Biarne"},
    {"city": "Bief-des-Maisons"},
    {"city": "Bief-du-Fourg"},
    {"city": "Biefmorin"},
    {"city": "Billecul"},
    {"city": "Bletterans"},
    {"city": "Blois-sur-Seille"},
    {"city": "Blye"},
    {"city": "Bois-d'Amont"},
    {"city": "Bois-de-Gand"},
    {"city": "Boissia"},
    {"city": "La Boissière"},
    {"city": "Bonlieu"},
    {"city": "Bonnefontaine"},
    {"city": "Bornay"},
    {"city": "Les Bouchoux"},
    {"city": "Bourg-de-Sirod"},
    {"city": "Bracon"},
    {"city": "Brainans"},
    {"city": "Brans"},
    {"city": "La Bretenière"},
    {"city": "Bretenières"},
    {"city": "Brevans"},
    {"city": "Briod"},
    {"city": "Broissia"},
    {"city": "Buvilly"},
    {"city": "Censeau"},
    {"city": "Cernans"},
    {"city": "Cerniébaud"},
    {"city": "Cernon"},
    {"city": "Cesancey"},
    {"city": "Chaînée-des-Coupis"},
    {"city": "Les Chalesmes"},
    {"city": "Chambéria"},
    {"city": "Chamblay"},
    {"city": "Chamole"},
    {"city": "Champagne-sur-Loue"},
    {"city": "Champagney"},
    {"city": "Champagnole"},
    {"city": "Champdivers"},
    {"city": "Champrougier"},
    {"city": "Champvans"},
    {"city": "Chancia"},
    {"city": "La Chapelle-sur-Furieuse"},
    {"city": "Chapelle-Voland"},
    {"city": "Chapois"},
    {"city": "Charchilla"},
    {"city": "Charcier"},
    {"city": "Charency"},
    {"city": "Charézier"},
    {"city": "La Charme"},
    {"city": "Charnod"},
    {"city": "La Chassagne"},
    {"city": "Château-Chalon"},
    {"city": "La Châtelaine"},
    {"city": "Chatelay"},
    {"city": "Châtel-de-Joux"},
    {"city": "Le Chateley"},
    {"city": "Châtelneuf"},
    {"city": "Châtenois"},
    {"city": "Châtillon"},
    {"city": "Chaumergy"},
    {"city": "La Chaumusse"},
    {"city": "Chaussenans"},
    {"city": "Chaussin"},
    {"city": "Chaux-des-Crotenay"},
    {"city": "Nanchez"},
    {"city": "La Chaux-du-Dombief"},
    {"city": "La Chaux-en-Bresse"},
    {"city": "Chaux-Champagny"},
    {"city": "Chavéria"},
    {"city": "Chemenot"},
    {"city": "Saint-Hymetière-sur-Valouse"},
    {"city": "Chemin"},
    {"city": "Chêne-Bernard"},
    {"city": "Chêne-Sec"},
    {"city": "Chevigny"},
    {"city": "Chevreaux"},
    {"city": "Chevrotaine"},
    {"city": "Chille"},
    {"city": "Chilly-le-Vignoble"},
    {"city": "Chilly-sur-Salins"},
    {"city": "Chissey-sur-Loue"},
    {"city": "Choisey"},
    {"city": "Choux"},
    {"city": "Cize"},
    {"city": "Clairvaux-les-Lacs"},
    {"city": "Clucy"},
    {"city": "Cogna"},
    {"city": "Coiserette"},
    {"city": "Colonne"},
    {"city": "Commenailles"},
    {"city": "Condamine"},
    {"city": "Condes"},
    {"city": "Conliège"},
    {"city": "Conte"},
    {"city": "Cornod"},
    {"city": "Cosges"},
    {"city": "Courbette"},
    {"city": "Courbouzon"},
    {"city": "Courlans"},
    {"city": "Courlaoux"},
    {"city": "Courtefontaine"},
    {"city": "Cousance"},
    {"city": "Coyrière"},
    {"city": "Coyron"},
    {"city": "Cramans"},
    {"city": "Hauteroche"},
    {"city": "Crans"},
    {"city": "Crenans"},
    {"city": "Cressia"},
    {"city": "Crissey"},
    {"city": "Crotenay"},
    {"city": "Les Crozets"},
    {"city": "Cuisia"},
    {"city": "Cuvier"},
    {"city": "Dammartin-Marpain"},
    {"city": "Damparis"},
    {"city": "Dampierre"},
    {"city": "Darbonnay"},
    {"city": "Denezières"},
    {"city": "Le Deschaux"},
    {"city": "Desnes"},
    {"city": "Les Deux-Fays"},
    {"city": "Digna"},
    {"city": "Dole"},
    {"city": "Domblans"},
    {"city": "Dompierre-sur-Mont"},
    {"city": "Doucier"},
    {"city": "Dournon"},
    {"city": "Doye"},
    {"city": "Dramelay"},
    {"city": "Éclans-Nenon"},
    {"city": "Écleux"},
    {"city": "Écrille"},
    {"city": "Entre-deux-Monts"},
    {"city": "Val-d'Épy"},
    {"city": "Équevillon"},
    {"city": "Les Essards-Taignevaux"},
    {"city": "Esserval-Tartre"},
    {"city": "Étival"},
    {"city": "L'Étoile"},
    {"city": "Étrepigney"},
    {"city": "Évans"},
    {"city": "Falletans"},
    {"city": "La Favière"},
    {"city": "Fay-en-Montagne"},
    {"city": "La Ferté"},
    {"city": "Le Fied"},
    {"city": "Foncine-le-Bas"},
    {"city": "Foncine-le-Haut"},
    {"city": "Fontainebrux"},
    {"city": "Fontenu"},
    {"city": "Fort-du-Plasne"},
    {"city": "Foucherans"},
    {"city": "Foulenay"},
    {"city": "Fraisans"},
    {"city": "Francheville"},
    {"city": "Fraroz"},
    {"city": "Frasne-les-Meulières"},
    {"city": "La Frasnée"},
    {"city": "Le Frasnois"},
    {"city": "Frébuans"},
    {"city": "Frontenay"},
    {"city": "Gatey"},
    {"city": "Gendrey"},
    {"city": "Genod"},
    {"city": "Geraise"},
    {"city": "Germigney"},
    {"city": "Geruge"},
    {"city": "Gevingey"},
    {"city": "Gevry"},
    {"city": "Gigny"},
    {"city": "Gillois"},
    {"city": "Gizia"},
    {"city": "Grande-Rivière Château"},
    {"city": "Grange-de-Vaivre"},
    {"city": "Graye-et-Charnay"},
    {"city": "Gredisans"},
    {"city": "Grozon"},
    {"city": "Hautecour"},
    {"city": "Les Hays"},
    {"city": "Ivory"},
    {"city": "Ivrey"},
    {"city": "Jeurre"},
    {"city": "Jouhe"},
    {"city": "Lac-des-Rouges-Truites"},
    {"city": "Ladoye-sur-Seille"},
    {"city": "Montlainsia"},
    {"city": "Lajoux"},
    {"city": "Lamoura"},
    {"city": "Le Larderet"},
    {"city": "Largillay-Marsonnay"},
    {"city": "Larnaud"},
    {"city": "Larrivoire"},
    {"city": "Le Latet"},
    {"city": "La Latette"},
    {"city": "Lavancia-Epercy"},
    {"city": "Lavangeot"},
    {"city": "Lavans-lès-Dole"},
    {"city": "Lavans-lès-Saint-Claude"},
    {"city": "Lavigny"},
    {"city": "Lect"},
    {"city": "Valzin en Petite Montagne"},
    {"city": "Lemuy"},
    {"city": "Lent"},
    {"city": "Leschères"},
    {"city": "Loisia"},
    {"city": "Lombard"},
    {"city": "Longchaumois"},
    {"city": "Longcochon"},
    {"city": "Longwy-sur-le-Doubs"},
    {"city": "Lons-le-Saunier"},
    {"city": "Loulle"},
    {"city": "Louvatange"},
    {"city": "Le Louverot"},
    {"city": "La Loye"},
    {"city": "Macornay"},
    {"city": "Maisod"},
    {"city": "Malange"},
    {"city": "Mantry"},
    {"city": "Marigna-sur-Valouse"},
    {"city": "Marigny"},
    {"city": "Marnézia"},
    {"city": "Marnoz"},
    {"city": "La Marre"},
    {"city": "Martigna"},
    {"city": "Mathenay"},
    {"city": "Maynal"},
    {"city": "Menétru-le-Vignoble"},
    {"city": "Menétrux-en-Joux"},
    {"city": "Menotey"},
    {"city": "Mérona"},
    {"city": "Mesnay"},
    {"city": "Mesnois"},
    {"city": "Messia-sur-Sorne"},
    {"city": "Meussia"},
    {"city": "Mièges"},
    {"city": "Miéry"},
    {"city": "Mignovillard"},
    {"city": "Moirans-en-Montagne"},
    {"city": "Moiron"},
    {"city": "Moissey"},
    {"city": "Molain"},
    {"city": "Molamboz"},
    {"city": "Molay"},
    {"city": "Chassal-Molinges"},
    {"city": "Monay"},
    {"city": "Monnetay"},
    {"city": "Monnet-la-Ville"},
    {"city": "Monnières"},
    {"city": "Montagna-le-Reconduit"},
    {"city": "Montaigu"},
    {"city": "Montain"},
    {"city": "Montbarrey"},
    {"city": "Montcusel"},
    {"city": "Monteplain"},
    {"city": "Montfleur"},
    {"city": "Montholier"},
    {"city": "Montigny-lès-Arsures"},
    {"city": "Montigny-sur-l'Ain"},
    {"city": "Montmarlon"},
    {"city": "Montmirey-la-Ville"},
    {"city": "Montmirey-le-Château"},
    {"city": "Montmorot"},
    {"city": "Montrevel"},
    {"city": "Montrond"},
    {"city": "Mont-sous-Vaudrey"},
    {"city": "Mont-sur-Monnet"},
    {"city": "Morbier"},
    {"city": "Hauts de Bienne"},
    {"city": "Mouchard"},
    {"city": "Mournans-Charbonny"},
    {"city": "Les Moussières"},
    {"city": "Moutonne"},
    {"city": "Moutoux"},
    {"city": "Mutigney"},
    {"city": "Les Trois-Châteaux"},
    {"city": "Nance"},
    {"city": "Nancuise"},
    {"city": "Les Nans"},
    {"city": "Neublans-Abergement"},
    {"city": "Neuvilley"},
    {"city": "Nevy-lès-Dole"},
    {"city": "Nevy-sur-Seille"},
    {"city": "Ney"},
    {"city": "Nogna"},
    {"city": "Nozeroy"},
    {"city": "Offlanges"},
    {"city": "Onglières"},
    {"city": "Onoz"},
    {"city": "Orchamps"},
    {"city": "Orgelet"},
    {"city": "Ougney"},
    {"city": "Ounans"},
    {"city": "Our"},
    {"city": "Oussières"},
    {"city": "Pagney"},
    {"city": "Pagnoz"},
    {"city": "Pannessières"},
    {"city": "Parcey"},
    {"city": "Le Pasquier"},
    {"city": "Passenans"},
    {"city": "Patornay"},
    {"city": "Peintre"},
    {"city": "Perrigny"},
    {"city": "Peseux"},
    {"city": "La Pesse"},
    {"city": "Petit-Noir"},
    {"city": "Picarreau"},
    {"city": "Pillemoine"},
    {"city": "Pimorin"},
    {"city": "Le Pin"},
    {"city": "Plainoiseau"},
    {"city": "Plaisia"},
    {"city": "Les Planches-en-Montagne"},
    {"city": "Les Planches-près-Arbois"},
    {"city": "Plasne"},
    {"city": "Plénise"},
    {"city": "Plénisette"},
    {"city": "Pleure"},
    {"city": "Plumont"},
    {"city": "Poids-de-Fiole"},
    {"city": "Pointre"},
    {"city": "Poligny"},
    {"city": "Pont-de-Poitte"},
    {"city": "Pont-d'Héry"},
    {"city": "Pont-du-Navoy"},
    {"city": "Port-Lesney"},
    {"city": "Prémanon"},
    {"city": "Présilly"},
    {"city": "Pretin"},
    {"city": "Publy"},
    {"city": "Pupillin"},
    {"city": "Quintigny"},
    {"city": "Rahon"},
    {"city": "Rainans"},
    {"city": "Ranchot"},
    {"city": "Rans"},
    {"city": "Ravilloles"},
    {"city": "Recanoz"},
    {"city": "Reithouse"},
    {"city": "Relans"},
    {"city": "Les Repôts"},
    {"city": "Revigny"},
    {"city": "La Rixouse"},
    {"city": "Rix"},
    {"city": "Rochefort-sur-Nenon"},
    {"city": "Rogna"},
    {"city": "Romain"},
    {"city": "Romange"},
    {"city": "Rosay"},
    {"city": "Rotalier"},
    {"city": "Rothonay"},
    {"city": "Rouffange"},
    {"city": "Les Rousses"},
    {"city": "Ruffey-sur-Seille"},
    {"city": "Rye"},
    {"city": "Saffloz"},
    {"city": "Sainte-Agnès"},
    {"city": "Saint-Amour"},
    {"city": "Saint-Aubin"},
    {"city": "Saint-Baraing"},
    {"city": "Saint-Claude"},
    {"city": "Saint-Cyr-Montmalin"},
    {"city": "Saint-Didier"},
    {"city": "Saint-Germain-en-Montagne"},
    {"city": "Val Suran"},
    {"city": "Saint-Lamain"},
    {"city": "Saint-Laurent-en-Grandvaux"},
    {"city": "Saint-Lothain"},
    {"city": "Saint-Loup"},
    {"city": "Coteaux du Lizon"},
    {"city": "Saint-Maur"},
    {"city": "Saint-Maurice-Crillat"},
    {"city": "Saint-Pierre"},
    {"city": "Saint-Thiébaud"},
    {"city": "Saizenay"},
    {"city": "Salans"},
    {"city": "Saligney"},
    {"city": "Salins-les-Bains"},
    {"city": "Sampans"},
    {"city": "Santans"},
    {"city": "Sapois"},
    {"city": "Sarrogna"},
    {"city": "Saugeot"},
    {"city": "Séligney"},
    {"city": "Sellières"},
    {"city": "Septmoncel les Molunes"},
    {"city": "Sergenaux"},
    {"city": "Sergenon"},
    {"city": "Sermange"},
    {"city": "Serre-les-Moulières"},
    {"city": "Sirod"},
    {"city": "Songeson"},
    {"city": "Soucia"},
    {"city": "Souvans"},
    {"city": "Supt"},
    {"city": "Syam"},
    {"city": "Tassenières"},
    {"city": "Tavaux"},
    {"city": "Taxenne"},
    {"city": "Thervay"},
    {"city": "Thésy"},
    {"city": "Thoirette-Coisia"},
    {"city": "Thoiria"},
    {"city": "Thoissia"},
    {"city": "Toulouse-le-Château"},
    {"city": "La Tour-du-Meix"},
    {"city": "Tourmont"},
    {"city": "Trenal"},
    {"city": "Uxelles"},
    {"city": "Vadans"},
    {"city": "Valempoulières"},
    {"city": "Vannoz"},
    {"city": "Le Vaudioux"},
    {"city": "Vaudrey"},
    {"city": "Vaux-lès-Saint-Claude"},
    {"city": "Vaux-sur-Poligny"},
    {"city": "Verges"},
    {"city": "Véria"},
    {"city": "Vernantois"},
    {"city": "Le Vernois"},
    {"city": "Vers-en-Montagne"},
    {"city": "Vers-sous-Sellières"},
    {"city": "Vertamboz"},
    {"city": "Vescles"},
    {"city": "Vevy"},
    {"city": "La Vieille-Loye"},
    {"city": "Villard-Saint-Sauveur"},
    {"city": "Villards-d'Héria"},
    {"city": "Villeneuve-d'Aval"},
    {"city": "Villeneuve-sous-Pymont"},
    {"city": "Villerserine"},
    {"city": "Villers-Farlay"},
    {"city": "Villers-les-Bois"},
    {"city": "Villers-Robert"},
    {"city": "Villette-lès-Arbois"},
    {"city": "Villette-lès-Dole"},
    {"city": "Villevieux"},
    {"city": "Le Villey"},
    {"city": "Val-Sonnette"},
    {"city": "Vincent-Froideville"},
    {"city": "Viry"},
    {"city": "Vitreux"},
    {"city": "Voiteur"},
    {"city": "Vosbles-Valfin"},
    {"city": "Vriange"},
    {"city": "Vulvoz"},
    {"city": "Aresches"},
    {"city": "Aire-sur-l'Adour"},
    {"city": "Amou"},
    {"city": "Angoumé"},
    {"city": "Angresse"},
    {"city": "Arboucave"},
    {"city": "Arengosse"},
    {"city": "Argelos"},
    {"city": "Argelouse"},
    {"city": "Arsague"},
    {"city": "Artassenx"},
    {"city": "Arthez-d'Armagnac"},
    {"city": "Arue"},
    {"city": "Arx"},
    {"city": "Aubagnan"},
    {"city": "Audignon"},
    {"city": "Audon"},
    {"city": "Aureilhan"},
    {"city": "Aurice"},
    {"city": "Azur"},
    {"city": "Bahus-Soubiran"},
    {"city": "Baigts"},
    {"city": "Banos"},
    {"city": "Bascons"},
    {"city": "Bas-Mauco"},
    {"city": "Bassercles"},
    {"city": "Bastennes"},
    {"city": "Bats"},
    {"city": "Baudignan"},
    {"city": "Bégaar"},
    {"city": "Belhade"},
    {"city": "Bélis"},
    {"city": "Bélus"},
    {"city": "Bénesse-lès-Dax"},
    {"city": "Bénesse-Maremne"},
    {"city": "Benquet"},
    {"city": "Bergouey"},
    {"city": "Betbezer-d'Armagnac"},
    {"city": "Beylongue"},
    {"city": "Beyries"},
    {"city": "Biarrotte"},
    {"city": "Bias"},
    {"city": "Biaudos"},
    {"city": "Biscarrosse"},
    {"city": "Bonnegarde"},
    {"city": "Bordères-et-Lamensans"},
    {"city": "Bostens"},
    {"city": "Bougue"},
    {"city": "Bourdalat"},
    {"city": "Bourriot-Bergonce"},
    {"city": "Brassempouy"},
    {"city": "Bretagne-de-Marsan"},
    {"city": "Brocas"},
    {"city": "Buanes"},
    {"city": "Cachen"},
    {"city": "Cagnotte"},
    {"city": "Callen"},
    {"city": "Campagne"},
    {"city": "Campet-et-Lamolère"},
    {"city": "Candresse"},
    {"city": "Canenx-et-Réaut"},
    {"city": "Capbreton"},
    {"city": "Carcarès-Sainte-Croix"},
    {"city": "Carcen-Ponson"},
    {"city": "Cassen"},
    {"city": "Castaignos-Souslens"},
    {"city": "Castandet"},
    {"city": "Castelnau-Chalosse"},
    {"city": "Castelnau-Tursan"},
    {"city": "Castelner"},
    {"city": "Castel-Sarrazin"},
    {"city": "Castets"},
    {"city": "Cauna"},
    {"city": "Cauneille"},
    {"city": "Caupenne"},
    {"city": "Cazalis"},
    {"city": "Cazères-sur-l'Adour"},
    {"city": "Cère"},
    {"city": "Classun"},
    {"city": "Clèdes"},
    {"city": "Clermont"},
    {"city": "Commensacq"},
    {"city": "Coudures"},
    {"city": "Créon-d'Armagnac"},
    {"city": "Dax"},
    {"city": "Doazit"},
    {"city": "Donzacq"},
    {"city": "Duhort-Bachen"},
    {"city": "Dumes"},
    {"city": "Escalans"},
    {"city": "Escource"},
    {"city": "Estibeaux"},
    {"city": "Estigarde"},
    {"city": "Eugénie-les-Bains"},
    {"city": "Eyres-Moncube"},
    {"city": "Fargues"},
    {"city": "Le Frêche"},
    {"city": "Gaas"},
    {"city": "Gabarret"},
    {"city": "Gaillères"},
    {"city": "Gamarde-les-Bains"},
    {"city": "Garein"},
    {"city": "Garrey"},
    {"city": "Gastes"},
    {"city": "Gaujacq"},
    {"city": "Geaune"},
    {"city": "Geloux"},
    {"city": "Gibret"},
    {"city": "Goos"},
    {"city": "Gourbera"},
    {"city": "Gousse"},
    {"city": "Gouts"},
    {"city": "Grenade-sur-l'Adour"},
    {"city": "Habas"},
    {"city": "Hagetmau"},
    {"city": "Hastingues"},
    {"city": "Hauriet"},
    {"city": "Haut-Mauco"},
    {"city": "Herm"},
    {"city": "Herré"},
    {"city": "Heugas"},
    {"city": "Hinx"},
    {"city": "Hontanx"},
    {"city": "Horsarrieu"},
    {"city": "Josse"},
    {"city": "Labastide-Chalosse"},
    {"city": "Labastide-d'Armagnac"},
    {"city": "Labatut"},
    {"city": "Labenne"},
    {"city": "Labouheyre"},
    {"city": "Labrit"},
    {"city": "Lacajunte"},
    {"city": "Lacquy"},
    {"city": "Lacrabe"},
    {"city": "Laglorieuse"},
    {"city": "Lagrange"},
    {"city": "Lahosse"},
    {"city": "Laluque"},
    {"city": "Lamothe"},
    {"city": "Larbey"},
    {"city": "Larrivière-Saint-Savin"},
    {"city": "Latrille"},
    {"city": "Laurède"},
    {"city": "Lauret"},
    {"city": "Lencouacq"},
    {"city": "Léon"},
    {"city": "Lesgor"},
    {"city": "Lesperon"},
    {"city": "Le Leuy"},
    {"city": "Lévignacq"},
    {"city": "Linxe"},
    {"city": "Liposthey"},
    {"city": "Lit-et-Mixe"},
    {"city": "Losse"},
    {"city": "Louer"},
    {"city": "Lourquen"},
    {"city": "Lubbon"},
    {"city": "Lucbardez-et-Bargues"},
    {"city": "Lüe"},
    {"city": "Retjons"},
    {"city": "Luglon"},
    {"city": "Lussagnet"},
    {"city": "Luxey"},
    {"city": "Magescq"},
    {"city": "Maillas"},
    {"city": "Maillères"},
    {"city": "Mano"},
    {"city": "Mant"},
    {"city": "Marpaps"},
    {"city": "Mauries"},
    {"city": "Maurrin"},
    {"city": "Mauvezin-d'Armagnac"},
    {"city": "Maylis"},
    {"city": "Mazerolles"},
    {"city": "Mées"},
    {"city": "Meilhan"},
    {"city": "Messanges"},
    {"city": "Mézos"},
    {"city": "Mimbaste"},
    {"city": "Mimizan"},
    {"city": "Miramont-Sensacq"},
    {"city": "Misson"},
    {"city": "Moliets-et-Maa"},
    {"city": "Momuy"},
    {"city": "Monget"},
    {"city": "Monségur"},
    {"city": "Montaut"},
    {"city": "Mont-de-Marsan"},
    {"city": "Montégut"},
    {"city": "Montfort-en-Chalosse"},
    {"city": "Montgaillard"},
    {"city": "Montsoué"},
    {"city": "Morcenx-la-Nouvelle"},
    {"city": "Morganx"},
    {"city": "Mouscardès"},
    {"city": "Moustey"},
    {"city": "Mugron"},
    {"city": "Narrosse"},
    {"city": "Nassiet"},
    {"city": "Nerbis"},
    {"city": "Nousse"},
    {"city": "Oeyregave"},
    {"city": "Oeyreluy"},
    {"city": "Onard"},
    {"city": "Ondres"},
    {"city": "Onesse-Laharie"},
    {"city": "Orist"},
    {"city": "Orthevielle"},
    {"city": "Orx"},
    {"city": "Ossages"},
    {"city": "Ousse-Suzan"},
    {"city": "Ozourt"},
    {"city": "Parentis-en-Born"},
    {"city": "Parleboscq"},
    {"city": "Payros-Cazautets"},
    {"city": "Pécorade"},
    {"city": "Perquie"},
    {"city": "Pey"},
    {"city": "Peyre"},
    {"city": "Peyrehorade"},
    {"city": "Philondenx"},
    {"city": "Pimbo"},
    {"city": "Pissos"},
    {"city": "Pomarez"},
    {"city": "Pontenx-les-Forges"},
    {"city": "Pontonx-sur-l'Adour"},
    {"city": "Port-de-Lanne"},
    {"city": "Poudenx"},
    {"city": "Pouillon"},
    {"city": "Pouydesseaux"},
    {"city": "Poyanne"},
    {"city": "Poyartin"},
    {"city": "Préchacq-les-Bains"},
    {"city": "Pujo-le-Plan"},
    {"city": "Puyol-Cazalet"},
    {"city": "Renung"},
    {"city": "Rimbez-et-Baudiets"},
    {"city": "Rion-des-Landes"},
    {"city": "Rivière-Saas-et-Gourby"},
    {"city": "Roquefort"},
    {"city": "Sabres"},
    {"city": "Saint-Agnet"},
    {"city": "Saint-André-de-Seignanx"},
    {"city": "Saint-Aubin"},
    {"city": "Saint-Avit"},
    {"city": "Saint-Barthélemy"},
    {"city": "Sainte-Colombe"},
    {"city": "Saint-Cricq-Chalosse"},
    {"city": "Saint-Cricq-du-Gave"},
    {"city": "Saint-Cricq-Villeneuve"},
    {"city": "Saint-Étienne-d'Orthe"},
    {"city": "Sainte-Eulalie-en-Born"},
    {"city": "Sainte-Foy"},
    {"city": "Saint-Gein"},
    {"city": "Saint-Geours-d'Auribat"},
    {"city": "Saint-Geours-de-Maremne"},
    {"city": "Saint-Gor"},
    {"city": "Saint-Jean-de-Lier"},
    {"city": "Saint-Jean-de-Marsacq"},
    {"city": "Saint-Julien-d'Armagnac"},
    {"city": "Saint-Julien-en-Born"},
    {"city": "Saint-Justin"},
    {"city": "Saint-Laurent-de-Gosse"},
    {"city": "Saint-Lon-les-Mines"},
    {"city": "Saint-Loubouer"},
    {"city": "Sainte-Marie-de-Gosse"},
    {"city": "Saint-Martin-de-Hinx"},
    {"city": "Saint-Martin-de-Seignanx"},
    {"city": "Saint-Martin-d'Oney"},
    {"city": "Saint-Maurice-sur-Adour"},
    {"city": "Saint-Michel-Escalus"},
    {"city": "Saint-Pandelon"},
    {"city": "Saint-Paul-en-Born"},
    {"city": "Saint-Paul-lès-Dax"},
    {"city": "Saint-Perdon"},
    {"city": "Saint-Pierre-du-Mont"},
    {"city": "Saint-Sever"},
    {"city": "Saint-Vincent-de-Paul"},
    {"city": "Saint-Vincent-de-Tyrosse"},
    {"city": "Saint-Yaguen"},
    {"city": "Samadet"},
    {"city": "Sanguinet"},
    {"city": "Sarbazan"},
    {"city": "Sarraziet"},
    {"city": "Sarron"},
    {"city": "Saubion"},
    {"city": "Saubrigues"},
    {"city": "Saubusse"},
    {"city": "Saugnac-et-Cambran"},
    {"city": "Saugnacq-et-Muret"},
    {"city": "Seignosse"},
    {"city": "Le Sen"},
    {"city": "Serres-Gaston"},
    {"city": "Serreslous-et-Arribans"},
    {"city": "Seyresse"},
    {"city": "Siest"},
    {"city": "Solférino"},
    {"city": "Soorts-Hossegor"},
    {"city": "Sorbets"},
    {"city": "Sorde-l'Abbaye"},
    {"city": "Sore"},
    {"city": "Sort-en-Chalosse"},
    {"city": "Souprosse"},
    {"city": "Soustons"},
    {"city": "Taller"},
    {"city": "Tarnos"},
    {"city": "Tartas"},
    {"city": "Tercis-les-Bains"},
    {"city": "Téthieu"},
    {"city": "Tilh"},
    {"city": "Tosse"},
    {"city": "Toulouzette"},
    {"city": "Trensacq"},
    {"city": "Uchacq-et-Parentis"},
    {"city": "Urgons"},
    {"city": "Uza"},
    {"city": "Vert"},
    {"city": "Vicq-d'Auribat"},
    {"city": "Vielle-Tursan"},
    {"city": "Vielle-Saint-Girons"},
    {"city": "Vielle-Soubiran"},
    {"city": "Vieux-Boucau-les-Bains"},
    {"city": "Le Vignau"},
    {"city": "Villenave"},
    {"city": "Villeneuve-de-Marsan"},
    {"city": "Ychoux"},
    {"city": "Ygos-Saint-Saturnin"},
    {"city": "Yzosse"},
    {"city": "Ambloy"},
    {"city": "Angé"},
    {"city": "Areines"},
    {"city": "Artins"},
    {"city": "Autainville"},
    {"city": "Authon"},
    {"city": "Avaray"},
    {"city": "Averdon"},
    {"city": "Azé"},
    {"city": "Baillou"},
    {"city": "Bauzy"},
    {"city": "Beauchêne"},
    {"city": "Billy"},
    {"city": "Binas"},
    {"city": "Blois"},
    {"city": "Boisseau"},
    {"city": "Bonneveau"},
    {"city": "Bouffry"},
    {"city": "Boursay"},
    {"city": "Bracieux"},
    {"city": "Brévainville"},
    {"city": "Briou"},
    {"city": "Busloup"},
    {"city": "Candé-sur-Beuvron"},
    {"city": "Cellé"},
    {"city": "Cellettes"},
    {"city": "Chailles"},
    {"city": "Chambord"},
    {"city": "Champigny-en-Beauce"},
    {"city": "Chaon"},
    {"city": "La Chapelle-Enchérie"},
    {"city": "La Chapelle-Montmartin"},
    {"city": "La Chapelle-Saint-Martin-en-Plaine"},
    {"city": "La Chapelle-Vendômoise"},
    {"city": "La Chapelle-Vicomtesse"},
    {"city": "Châteauvieux"},
    {"city": "Châtillon-sur-Cher"},
    {"city": "Châtres-sur-Cher"},
    {"city": "Chaumont-sur-Loire"},
    {"city": "Chaumont-sur-Tharonne"},
    {"city": "La Chaussée-Saint-Victor"},
    {"city": "Chauvigny-du-Perche"},
    {"city": "Chémery"},
    {"city": "Cheverny"},
    {"city": "Chissay-en-Touraine"},
    {"city": "Chitenay"},
    {"city": "Choue"},
    {"city": "Choussy"},
    {"city": "Valloire-sur-Cisse"},
    {"city": "Conan"},
    {"city": "Concriers"},
    {"city": "Le Controis-en-Sologne"},
    {"city": "Cormenon"},
    {"city": "Cormeray"},
    {"city": "Couddes"},
    {"city": "Couffy"},
    {"city": "Coulommiers-la-Tour"},
    {"city": "Courbouzon"},
    {"city": "Cour-Cheverny"},
    {"city": "Courmemin"},
    {"city": "Cour-sur-Loire"},
    {"city": "Vallée-de-Ronsard"},
    {"city": "Crouy-sur-Cosson"},
    {"city": "Crucheray"},
    {"city": "Danzé"},
    {"city": "Dhuizon"},
    {"city": "Droué"},
    {"city": "Épiais"},
    {"city": "Épuisay"},
    {"city": "Les Essarts"},
    {"city": "Faverolles-sur-Cher"},
    {"city": "Faye"},
    {"city": "La Ferté-Beauharnais"},
    {"city": "La Ferté-Imbault"},
    {"city": "La Ferté-Saint-Cyr"},
    {"city": "Fontaines-en-Sologne"},
    {"city": "Fontaine-les-Coteaux"},
    {"city": "Fontaine-Raoul"},
    {"city": "La Fontenelle"},
    {"city": "Fortan"},
    {"city": "Fossé"},
    {"city": "Françay"},
    {"city": "Fresnes"},
    {"city": "Fréteval"},
    {"city": "Le Gault-du-Perche"},
    {"city": "Gièvres"},
    {"city": "Gombergean"},
    {"city": "Gy-en-Sologne"},
    {"city": "Les Hayes"},
    {"city": "Herbault"},
    {"city": "Houssay"},
    {"city": "Huisseau-en-Beauce"},
    {"city": "Huisseau-sur-Cosson"},
    {"city": "Josnes"},
    {"city": "Lamotte-Beuvron"},
    {"city": "Lancé"},
    {"city": "Lancôme"},
    {"city": "Landes-le-Gaulois"},
    {"city": "Langon-sur-Cher"},
    {"city": "Lassay-sur-Croisne"},
    {"city": "Lavardin"},
    {"city": "Lestiou"},
    {"city": "Lignières"},
    {"city": "Lisle"},
    {"city": "Loreux"},
    {"city": "Lorges"},
    {"city": "Lunay"},
    {"city": "La Madeleine-Villefrouin"},
    {"city": "Maray"},
    {"city": "Marchenoir"},
    {"city": "Marcilly-en-Beauce"},
    {"city": "Marcilly-en-Gault"},
    {"city": "Mareuil-sur-Cher"},
    {"city": "La Marolle-en-Sologne"},
    {"city": "Marolles"},
    {"city": "Maslives"},
    {"city": "Maves"},
    {"city": "Mazangé"},
    {"city": "Méhers"},
    {"city": "Menars"},
    {"city": "Mennetou-sur-Cher"},
    {"city": "Mer"},
    {"city": "Mesland"},
    {"city": "Meslay"},
    {"city": "Meusnes"},
    {"city": "Millançay"},
    {"city": "Moisy"},
    {"city": "Valencisse"},
    {"city": "Mondoubleau"},
    {"city": "Monteaux"},
    {"city": "Monthou-sur-Bièvre"},
    {"city": "Monthou-sur-Cher"},
    {"city": "Les Montils"},
    {"city": "Montlivault"},
    {"city": "Montoire-sur-le-Loir"},
    {"city": "Mont-près-Chambord"},
    {"city": "Montrichard Val de Cher"},
    {"city": "Montrieux-en-Sologne"},
    {"city": "Montrouveau"},
    {"city": "Morée"},
    {"city": "Muides-sur-Loire"},
    {"city": "Mulsans"},
    {"city": "Mur-de-Sologne"},
    {"city": "Naveil"},
    {"city": "Neung-sur-Beuvron"},
    {"city": "Neuvy"},
    {"city": "Nouan-le-Fuzelier"},
    {"city": "Nourray"},
    {"city": "Noyers-sur-Cher"},
    {"city": "Oisly"},
    {"city": "Veuzain-sur-Loire"},
    {"city": "Orçay"},
    {"city": "Oucques La Nouvelle"},
    {"city": "Ouzouer-le-Doyen"},
    {"city": "Beauce la Romaine"},
    {"city": "Périgny"},
    {"city": "Pezou"},
    {"city": "Pierrefitte-sur-Sauldre"},
    {"city": "Le Plessis-Dorin"},
    {"city": "Le Plessis-l'Échelle"},
    {"city": "Le Poislay"},
    {"city": "Pontlevoy"},
    {"city": "Pouillé"},
    {"city": "Pray"},
    {"city": "Prunay-Cassereau"},
    {"city": "Pruniers-en-Sologne"},
    {"city": "Rahart"},
    {"city": "Renay"},
    {"city": "Rhodon"},
    {"city": "Rilly-sur-Loire"},
    {"city": "Rocé"},
    {"city": "Roches"},
    {"city": "Les Roches-l'Évêque"},
    {"city": "Romilly"},
    {"city": "Romorantin-Lanthenay"},
    {"city": "Rougeou"},
    {"city": "Ruan-sur-Egvonne"},
    {"city": "Saint-Aignan"},
    {"city": "Saint-Amand-Longpré"},
    {"city": "Sainte-Anne"},
    {"city": "Saint-Arnoult"},
    {"city": "Saint-Bohaire"},
    {"city": "Saint-Claude-de-Diray"},
    {"city": "Saint-Cyr-du-Gault"},
    {"city": "Saint-Denis-sur-Loire"},
    {"city": "Saint-Dyé-sur-Loire"},
    {"city": "Saint-Étienne-des-Guérets"},
    {"city": "Saint-Firmin-des-Prés"},
    {"city": "Saint-Georges-sur-Cher"},
    {"city": "Saint-Gervais-la-Forêt"},
    {"city": "Saint-Gourgon"},
    {"city": "Saint-Hilaire-la-Gravelle"},
    {"city": "Saint-Jacques-des-Guérets"},
    {"city": "Saint-Jean-Froidmentel"},
    {"city": "Saint-Julien-de-Chédon"},
    {"city": "Saint-Julien-sur-Cher"},
    {"city": "Saint-Laurent-des-Bois"},
    {"city": "Saint-Laurent-Nouan"},
    {"city": "Saint-Léonard-en-Beauce"},
    {"city": "Saint-Loup"},
    {"city": "Saint-Lubin-en-Vergonnois"},
    {"city": "Saint-Marc-du-Cor"},
    {"city": "Saint-Martin-des-Bois"},
    {"city": "Saint-Ouen"},
    {"city": "Saint-Rimay"},
    {"city": "Saint-Romain-sur-Cher"},
    {"city": "Saint-Sulpice-de-Pommeray"},
    {"city": "Saint-Viâtre"},
    {"city": "Salbris"},
    {"city": "Sambin"},
    {"city": "Santenay"},
    {"city": "Sargé-sur-Braye"},
    {"city": "Sasnières"},
    {"city": "Sassay"},
    {"city": "Savigny-sur-Braye"},
    {"city": "Seigy"},
    {"city": "Selles-Saint-Denis"},
    {"city": "Selles-sur-Cher"},
    {"city": "Selommes"},
    {"city": "Séris"},
    {"city": "Seur"},
    {"city": "Soings-en-Sologne"},
    {"city": "Couëtron-au-Perche"},
    {"city": "Souesmes"},
    {"city": "Sougé"},
    {"city": "Souvigny-en-Sologne"},
    {"city": "Suèvres"},
    {"city": "Talcy"},
    {"city": "Le Temple"},
    {"city": "Ternay"},
    {"city": "Theillay"},
    {"city": "Thésée"},
    {"city": "Thoré-la-Rochette"},
    {"city": "Thoury"},
    {"city": "Tourailles"},
    {"city": "Tour-en-Sologne"},
    {"city": "Troo"},
    {"city": "Valaire"},
    {"city": "Vallières-les-Grandes"},
    {"city": "Veilleins"},
    {"city": "Vendôme"},
    {"city": "Vernou-en-Sologne"},
    {"city": "Vievy-le-Rayé"},
    {"city": "Villavard"},
    {"city": "La Ville-aux-Clercs"},
    {"city": "Villebarou"},
    {"city": "Villebout"},
    {"city": "Villechauve"},
    {"city": "Villedieu-le-Château"},
    {"city": "Villefranche-sur-Cher"},
    {"city": "Villefrancœur"},
    {"city": "Villeherviers"},
    {"city": "Villemardy"},
    {"city": "Villeneuve-Frouville"},
    {"city": "Villeny"},
    {"city": "Villeporcher"},
    {"city": "Villerable"},
    {"city": "Villerbon"},
    {"city": "Villermain"},
    {"city": "Villeromain"},
    {"city": "Villetrun"},
    {"city": "Villexanton"},
    {"city": "Villiersfaux"},
    {"city": "Villiers-sur-Loir"},
    {"city": "Vineuil"},
    {"city": "Vouzon"},
    {"city": "Yvoy-le-Marron"},
    {"city": "Aboën"},
    {"city": "Ailleux"},
    {"city": "Ambierle"},
    {"city": "Andrézieux-Bouthéon"},
    {"city": "Apinac"},
    {"city": "Arcinges"},
    {"city": "Arcon"},
    {"city": "Arthun"},
    {"city": "Aveizieux"},
    {"city": "Balbigny"},
    {"city": "Bard"},
    {"city": "Bellegarde-en-Forez"},
    {"city": "Belleroche"},
    {"city": "Belmont-de-la-Loire"},
    {"city": "La Bénisson-Dieu"},
    {"city": "Le Bessat"},
    {"city": "Bessey"},
    {"city": "Boën-sur-Lignon"},
    {"city": "Boisset-lès-Montrond"},
    {"city": "Boisset-Saint-Priest"},
    {"city": "Bonson"},
    {"city": "Bourg-Argental"},
    {"city": "Boyer"},
    {"city": "Briennon"},
    {"city": "Bully"},
    {"city": "Burdignes"},
    {"city": "Bussières"},
    {"city": "Bussy-Albieux"},
    {"city": "Caloire"},
    {"city": "Cellieu"},
    {"city": "Le Cergne"},
    {"city": "Cervières"},
    {"city": "Cezay"},
    {"city": "Chagnon"},
    {"city": "Chalain-d'Uzore"},
    {"city": "Chalain-le-Comtal"},
    {"city": "Chalmazel-Jeansagnière"},
    {"city": "La Chamba"},
    {"city": "Chambéon"},
    {"city": "Chambles"},
    {"city": "Chambœuf"},
    {"city": "Le Chambon-Feugerolles"},
    {"city": "La Chambonie"},
    {"city": "Champdieu"},
    {"city": "Champoly"},
    {"city": "Chandon"},
    {"city": "Changy"},
    {"city": "La Chapelle-en-Lafaye"},
    {"city": "La Chapelle-Villars"},
    {"city": "Charlieu"},
    {"city": "Châteauneuf"},
    {"city": "Châtelneuf"},
    {"city": "Châtelus"},
    {"city": "Chavanay"},
    {"city": "Chazelles-sur-Lavieu"},
    {"city": "Chazelles-sur-Lyon"},
    {"city": "Chenereilles"},
    {"city": "Cherier"},
    {"city": "Chevrières"},
    {"city": "Chirassimont"},
    {"city": "Chuyer"},
    {"city": "Civens"},
    {"city": "Cleppé"},
    {"city": "Colombier"},
    {"city": "Combre"},
    {"city": "Commelle-Vernay"},
    {"city": "Cordelle"},
    {"city": "Le Coteau"},
    {"city": "La Côte-en-Couzan"},
    {"city": "Cottance"},
    {"city": "Coutouvre"},
    {"city": "Craintilleux"},
    {"city": "Cremeaux"},
    {"city": "Croizet-sur-Gand"},
    {"city": "Le Crozet"},
    {"city": "Cuinzier"},
    {"city": "Cuzieu"},
    {"city": "Dargoire"},
    {"city": "Débats-Rivière-d'Orpra"},
    {"city": "Doizieux"},
    {"city": "Écoche"},
    {"city": "Écotay-l'Olme"},
    {"city": "Épercieux-Saint-Paul"},
    {"city": "Essertines-en-Châtelneuf"},
    {"city": "Essertines-en-Donzy"},
    {"city": "Estivareilles"},
    {"city": "L'Étrat"},
    {"city": "Farnay"},
    {"city": "Feurs"},
    {"city": "Firminy"},
    {"city": "Fontanès"},
    {"city": "La Fouillouse"},
    {"city": "Fourneaux"},
    {"city": "Fraisses"},
    {"city": "La Gimond"},
    {"city": "Graix"},
    {"city": "Grammond"},
    {"city": "La Grand-Croix"},
    {"city": "La Gresle"},
    {"city": "Grézieux-le-Fromental"},
    {"city": "Grézolles"},
    {"city": "Gumières"},
    {"city": "L'Hôpital-le-Grand"},
    {"city": "L'Hôpital-sous-Rochefort"},
    {"city": "L'Horme"},
    {"city": "Jarnosse"},
    {"city": "Jas"},
    {"city": "Jonzieux"},
    {"city": "Juré"},
    {"city": "Lavieu"},
    {"city": "Lay"},
    {"city": "Leigneux"},
    {"city": "Lentigny"},
    {"city": "Lérigneux"},
    {"city": "Lézigneux"},
    {"city": "Lorette"},
    {"city": "Lupé"},
    {"city": "Luré"},
    {"city": "Luriecq"},
    {"city": "Mably"},
    {"city": "Machézal"},
    {"city": "Maclas"},
    {"city": "Magneux-Haute-Rive"},
    {"city": "Maizilly"},
    {"city": "Malleval"},
    {"city": "Marcenod"},
    {"city": "Marcilly-le-Châtel"},
    {"city": "Marclopt"},
    {"city": "Marcoux"},
    {"city": "Margerie-Chantagret"},
    {"city": "Maringes"},
    {"city": "Marlhes"},
    {"city": "Marols"},
    {"city": "Mars"},
    {"city": "Merle-Leignec"},
    {"city": "Mizérieux"},
    {"city": "Montagny"},
    {"city": "Montarcher"},
    {"city": "Montbrison"},
    {"city": "Montchal"},
    {"city": "Montrond-les-Bains"},
    {"city": "Montverdun"},
    {"city": "Mornand-en-Forez"},
    {"city": "Nandax"},
    {"city": "Neaux"},
    {"city": "Néronde"},
    {"city": "Nervieux"},
    {"city": "Neulise"},
    {"city": "Noailly"},
    {"city": "Les Noës"},
    {"city": "Noirétable"},
    {"city": "Nollieux"},
    {"city": "Notre-Dame-de-Boisset"},
    {"city": "Ouches"},
    {"city": "La Pacaudière"},
    {"city": "Palogneux"},
    {"city": "Panissières"},
    {"city": "Parigny"},
    {"city": "Pavezin"},
    {"city": "Pélussin"},
    {"city": "Périgneux"},
    {"city": "Perreux"},
    {"city": "Pinay"},
    {"city": "Planfoy"},
    {"city": "Pommiers"},
    {"city": "Poncins"},
    {"city": "Pouilly-lès-Feurs"},
    {"city": "Pouilly-les-Nonains"},
    {"city": "Pouilly-sous-Charlieu"},
    {"city": "Pradines"},
    {"city": "Pralong"},
    {"city": "Précieux"},
    {"city": "Régny"},
    {"city": "Renaison"},
    {"city": "La Ricamarie"},
    {"city": "Riorges"},
    {"city": "Rivas"},
    {"city": "Rive-de-Gier"},
    {"city": "Roanne"},
    {"city": "Roche"},
    {"city": "Roche-la-Molière"},
    {"city": "Roisey"},
    {"city": "Rozier-Côtes-d'Aurec"},
    {"city": "Rozier-en-Donzy"},
    {"city": "Sail-les-Bains"},
    {"city": "Sail-sous-Couzan"},
    {"city": "Sainte-Agathe-en-Donzy"},
    {"city": "Sainte-Agathe-la-Bouteresse"},
    {"city": "Saint-Alban-les-Eaux"},
    {"city": "Saint-André-d'Apchon"},
    {"city": "Saint-André-le-Puy"},
    {"city": "Saint-Appolinard"},
    {"city": "Saint-Barthélemy-Lestra"},
    {"city": "Saint-Bonnet-des-Quarts"},
    {"city": "Saint-Bonnet-le-Château"},
    {"city": "Saint-Bonnet-le-Courreau"},
    {"city": "Saint-Bonnet-les-Oules"},
    {"city": "Saint-Chamond"},
    {"city": "Saint-Christo-en-Jarez"},
    {"city": "Sainte-Colombe-sur-Gand"},
    {"city": "Sainte-Croix-en-Jarez"},
    {"city": "Saint-Cyprien"},
    {"city": "Saint-Cyr-de-Favières"},
    {"city": "Saint-Cyr-de-Valorges"},
    {"city": "Saint-Cyr-les-Vignes"},
    {"city": "Saint-Denis-de-Cabanne"},
    {"city": "Saint-Denis-sur-Coise"},
    {"city": "Saint-Didier-sur-Rochefort"},
    {"city": "Saint-Étienne"},
    {"city": "Saint-Étienne-le-Molard"},
    {"city": "Saint-Forgeux-Lespinasse"},
    {"city": "Sainte-Foy-Saint-Sulpice"},
    {"city": "Saint-Galmier"},
    {"city": "Saint-Genest-Lerpt"},
    {"city": "Saint-Genest-Malifaux"},
    {"city": "Genilac"},
    {"city": "Saint-Georges-de-Baroille"},
    {"city": "Saint-Georges-en-Couzan"},
    {"city": "Saint-Georges-Haute-Ville"},
    {"city": "Saint-Germain-la-Montagne"},
    {"city": "Saint-Germain-Laval"},
    {"city": "Saint-Germain-Lespinasse"},
    {"city": "Saint-Haon-le-Châtel"},
    {"city": "Saint-Haon-le-Vieux"},
    {"city": "Saint-Héand"},
    {"city": "Saint-Hilaire-Cusson-la-Valmitte"},
    {"city": "Saint-Hilaire-sous-Charlieu"},
    {"city": "Saint-Jean-Bonnefonds"},
    {"city": "Saint-Jean-la-Vêtre"},
    {"city": "Saint-Jean-Saint-Maurice-sur-Loire"},
    {"city": "Saint-Jean-Soleymieux"},
    {"city": "Saint-Jodard"},
    {"city": "Saint-Joseph"},
    {"city": "Saint-Julien-d'Oddes"},
    {"city": "Vêtre-sur-Anzon"},
    {"city": "Saint-Julien-Molin-Molette"},
    {"city": "Saint-Just-en-Bas"},
    {"city": "Saint-Just-en-Chevalet"},
    {"city": "Saint-Just-la-Pendue"},
    {"city": "Saint-Laurent-la-Conche"},
    {"city": "Saint-Laurent-Rochefort"},
    {"city": "Saint-Léger-sur-Roanne"},
    {"city": "Saint-Marcel-de-Félines"},
    {"city": "Saint-Marcel-d'Urfé"},
    {"city": "Saint-Marcellin-en-Forez"},
    {"city": "Saint-Martin-d'Estréaux"},
    {"city": "Saint-Martin-la-Plaine"},
    {"city": "Saint-Martin-la-Sauveté"},
    {"city": "Saint-Martin-Lestra"},
    {"city": "Saint-Maurice-en-Gourgois"},
    {"city": "Saint-Médard-en-Forez"},
    {"city": "Saint-Michel-sur-Rhône"},
    {"city": "Saint-Nizier-de-Fornas"},
    {"city": "Saint-Nizier-sous-Charlieu"},
    {"city": "Vézelin-sur-Loire"},
    {"city": "Saint-Paul-d'Uzore"},
    {"city": "Saint-Paul-en-Cornillon"},
    {"city": "Saint-Paul-en-Jarez"},
    {"city": "Saint-Pierre-de-Bœuf"},
    {"city": "Saint-Pierre-la-Noaille"},
    {"city": "Saint-Polgues"},
    {"city": "Saint-Priest-en-Jarez"},
    {"city": "Saint-Priest-la-Prugne"},
    {"city": "Saint-Priest-la-Roche"},
    {"city": "Saint-Priest-la-Vêtre"},
    {"city": "Saint-Just-Saint-Rambert"},
    {"city": "Saint-Régis-du-Coin"},
    {"city": "Saint-Rirand"},
    {"city": "Saint-Romain-d'Urfé"},
    {"city": "Saint-Romain-en-Jarez"},
    {"city": "Saint-Romain-la-Motte"},
    {"city": "Saint-Romain-le-Puy"},
    {"city": "Saint-Romain-les-Atheux"},
    {"city": "Saint-Sauveur-en-Rue"},
    {"city": "Saint-Sixte"},
    {"city": "Saint-Symphorien-de-Lay"},
    {"city": "Saint-Thomas-la-Garde"},
    {"city": "Saint-Victor-sur-Rhins"},
    {"city": "Saint-Vincent-de-Boisset"},
    {"city": "Les Salles"},
    {"city": "Salt-en-Donzy"},
    {"city": "Salvizinet"},
    {"city": "Sauvain"},
    {"city": "Savigneux"},
    {"city": "Sevelinges"},
    {"city": "Soleymieux"},
    {"city": "Sorbiers"},
    {"city": "Souternon"},
    {"city": "Sury-le-Comtal"},
    {"city": "La Talaudière"},
    {"city": "Tarentaise"},
    {"city": "Tartaras"},
    {"city": "La Terrasse-sur-Dorlay"},
    {"city": "Thélis-la-Combe"},
    {"city": "La Tour-en-Jarez"},
    {"city": "La Tourette"},
    {"city": "Trelins"},
    {"city": "La Tuilière"},
    {"city": "Unias"},
    {"city": "Unieux"},
    {"city": "Urbise"},
    {"city": "Usson-en-Forez"},
    {"city": "Valeille"},
    {"city": "Valfleury"},
    {"city": "La Valla-sur-Rochefort"},
    {"city": "La Valla-en-Gier"},
    {"city": "Veauche"},
    {"city": "Veauchette"},
    {"city": "Vendranges"},
    {"city": "Véranne"},
    {"city": "Vérin"},
    {"city": "Verrières-en-Forez"},
    {"city": "La Versanne"},
    {"city": "Villars"},
    {"city": "Villemontais"},
    {"city": "Villerest"},
    {"city": "Villers"},
    {"city": "Violay"},
    {"city": "Viricelles"},
    {"city": "Virigneux"},
    {"city": "Vivans"},
    {"city": "Vougy"},
    {"city": "Chausseterre"},
    {"city": "Agnat"},
    {"city": "Aiguilhe"},
    {"city": "Allègre"},
    {"city": "Alleyrac"},
    {"city": "Alleyras"},
    {"city": "Ally"},
    {"city": "Araules"},
    {"city": "Arlempdes"},
    {"city": "Arlet"},
    {"city": "Arsac-en-Velay"},
    {"city": "Aubazat"},
    {"city": "Aurec-sur-Loire"},
    {"city": "Vissac-Auteyrac"},
    {"city": "Autrac"},
    {"city": "Auvers"},
    {"city": "Auzon"},
    {"city": "Azérat"},
    {"city": "Bains"},
    {"city": "Barges"},
    {"city": "Bas-en-Basset"},
    {"city": "Beaulieu"},
    {"city": "Beaumont"},
    {"city": "Beaune-sur-Arzon"},
    {"city": "Beaux"},
    {"city": "Beauzac"},
    {"city": "Bellevue-la-Montagne"},
    {"city": "Berbezit"},
    {"city": "Bessamorel"},
    {"city": "La Besseyre-Saint-Mary"},
    {"city": "Blanzac"},
    {"city": "Blassac"},
    {"city": "Blavozy"},
    {"city": "Blesle"},
    {"city": "Boisset"},
    {"city": "Bonneval"},
    {"city": "Borne"},
    {"city": "Le Bouchet-Saint-Nicolas"},
    {"city": "Bournoncle-Saint-Pierre"},
    {"city": "Le Brignon"},
    {"city": "Brioude"},
    {"city": "Brives-Charensac"},
    {"city": "Cayres"},
    {"city": "Céaux-d'Allègre"},
    {"city": "Cerzat"},
    {"city": "Ceyssac"},
    {"city": "Chadrac"},
    {"city": "Chadron"},
    {"city": "La Chaise-Dieu"},
    {"city": "Chamalières-sur-Loire"},
    {"city": "Chambezon"},
    {"city": "Le Chambon-sur-Lignon"},
    {"city": "Champagnac-le-Vieux"},
    {"city": "Champclause"},
    {"city": "Chanaleilles"},
    {"city": "Chaniat"},
    {"city": "Chanteuges"},
    {"city": "La Chapelle-Bertin"},
    {"city": "La Chapelle-d'Aurec"},
    {"city": "La Chapelle-Geneste"},
    {"city": "Charraix"},
    {"city": "Chaspinhac"},
    {"city": "Chaspuzac"},
    {"city": "Chassagnes"},
    {"city": "Chassignolles"},
    {"city": "Chastel"},
    {"city": "Chaudeyrolles"},
    {"city": "Chavaniac-Lafayette"},
    {"city": "Chazelles"},
    {"city": "Chenereilles"},
    {"city": "Chilhac"},
    {"city": "Chomelix"},
    {"city": "La Chomette"},
    {"city": "Cistrières"},
    {"city": "Cohade"},
    {"city": "Collat"},
    {"city": "Connangles"},
    {"city": "Costaros"},
    {"city": "Coubon"},
    {"city": "Couteuges"},
    {"city": "Craponne-sur-Arzon"},
    {"city": "Cronce"},
    {"city": "Cubelles"},
    {"city": "Cussac-sur-Loire"},
    {"city": "Desges"},
    {"city": "Domeyrat"},
    {"city": "Dunières"},
    {"city": "Espalem"},
    {"city": "Espaly-Saint-Marcel"},
    {"city": "Esplantas-Vazeilles"},
    {"city": "Les Estables"},
    {"city": "Fay-sur-Lignon"},
    {"city": "Félines"},
    {"city": "Ferrussac"},
    {"city": "Fix-Saint-Geneys"},
    {"city": "Fontannes"},
    {"city": "Freycenet-la-Cuche"},
    {"city": "Freycenet-la-Tour"},
    {"city": "Frugerès-les-Mines"},
    {"city": "Frugières-le-Pin"},
    {"city": "Goudet"},
    {"city": "Grazac"},
    {"city": "Grenier-Montgon"},
    {"city": "Grèzes"},
    {"city": "Javaugues"},
    {"city": "Jax"},
    {"city": "Josat"},
    {"city": "Jullianges"},
    {"city": "Lafarre"},
    {"city": "Lamothe"},
    {"city": "Landos"},
    {"city": "Langeac"},
    {"city": "Lantriac"},
    {"city": "Lapte"},
    {"city": "Laussonne"},
    {"city": "Laval-sur-Doulon"},
    {"city": "Lavaudieu"},
    {"city": "Lavoûte-Chilhac"},
    {"city": "Lavoûte-sur-Loire"},
    {"city": "Lempdes-sur-Allagnon"},
    {"city": "Léotoing"},
    {"city": "Lissac"},
    {"city": "Lorlanges"},
    {"city": "Loudes"},
    {"city": "Lubilhac"},
    {"city": "Malrevers"},
    {"city": "Malvalette"},
    {"city": "Malvières"},
    {"city": "Le Mas-de-Tence"},
    {"city": "Mazet-Saint-Voy"},
    {"city": "Mazerat-Aurouze"},
    {"city": "Mazeyrat-d'Allier"},
    {"city": "Mercœur"},
    {"city": "Mézères"},
    {"city": "Le Monastier-sur-Gazeille"},
    {"city": "Monistrol-d'Allier"},
    {"city": "Monistrol-sur-Loire"},
    {"city": "Monlet"},
    {"city": "Montclard"},
    {"city": "Le Monteil"},
    {"city": "Montfaucon-en-Velay"},
    {"city": "Montregard"},
    {"city": "Montusclat"},
    {"city": "Moudeyres"},
    {"city": "Ouides"},
    {"city": "Paulhac"},
    {"city": "Paulhaguet"},
    {"city": "Pébrac"},
    {"city": "Le Pertuis"},
    {"city": "Pinols"},
    {"city": "Polignac"},
    {"city": "Pont-Salomon"},
    {"city": "Pradelles"},
    {"city": "Prades"},
    {"city": "Présailles"},
    {"city": "Le Puy-en-Velay"},
    {"city": "Queyrières"},
    {"city": "Raucoules"},
    {"city": "Rauret"},
    {"city": "Retournac"},
    {"city": "Riotord"},
    {"city": "Roche-en-Régnier"},
    {"city": "Rosières"},
    {"city": "Saint-André-de-Chalencon"},
    {"city": "Saint-Arcons-d'Allier"},
    {"city": "Saint-Arcons-de-Barges"},
    {"city": "Saint-Austremoine"},
    {"city": "Saint-Beauzire"},
    {"city": "Saint-Bérain"},
    {"city": "Saint-Bonnet-le-Froid"},
    {"city": "Saint-Christophe-d'Allier"},
    {"city": "Saint-Christophe-sur-Dolaison"},
    {"city": "Saint-Cirgues"},
    {"city": "Saint-Didier-en-Velay"},
    {"city": "Saint-Didier-sur-Doulon"},
    {"city": "Saint-Étienne-du-Vigan"},
    {"city": "Saint-Étienne-Lardeyrol"},
    {"city": "Saint-Étienne-sur-Blesle"},
    {"city": "Sainte-Eugénie-de-Villeneuve"},
    {"city": "Saint-Ferréol-d'Auroure"},
    {"city": "Sainte-Florine"},
    {"city": "Saint-Front"},
    {"city": "Saint-Geneys-près-Saint-Paulien"},
    {"city": "Saint-Georges-d'Aurac"},
    {"city": "Saint-Georges-Lagricol"},
    {"city": "Saint-Germain-Laprade"},
    {"city": "Saint-Géron"},
    {"city": "Saint-Haon"},
    {"city": "Saint-Hilaire"},
    {"city": "Saint-Hostien"},
    {"city": "Saint-Ilpize"},
    {"city": "Saint-Jean-d'Aubrigoux"},
    {"city": "Saint-Jean-de-Nay"},
    {"city": "Saint-Jean-Lachalm"},
    {"city": "Saint-Jeures"},
    {"city": "Saint-Julien-Chapteuil"},
    {"city": "Saint-Julien-d'Ance"},
    {"city": "Saint-Julien-des-Chazes"},
    {"city": "Saint-Julien-du-Pinet"},
    {"city": "Saint-Julien-Molhesabate"},
    {"city": "Saint-Just-Malmont"},
    {"city": "Saint-Just-près-Brioude"},
    {"city": "Saint-Laurent-Chabreuges"},
    {"city": "Sainte-Marguerite"},
    {"city": "Saint-Martin-de-Fugères"},
    {"city": "Saint-Maurice-de-Lignon"},
    {"city": "Saint-Pal-de-Chalencon"},
    {"city": "Saint-Pal-de-Mons"},
    {"city": "Saint-Pal-de-Senouire"},
    {"city": "Saint-Paul-de-Tartas"},
    {"city": "Saint-Paulien"},
    {"city": "Saint-Pierre-du-Champ"},
    {"city": "Saint-Pierre-Eynac"},
    {"city": "Saint-Préjet-Armandon"},
    {"city": "Saint-Préjet-d'Allier"},
    {"city": "Saint-Privat-d'Allier"},
    {"city": "Saint-Privat-du-Dragon"},
    {"city": "Saint-Romain-Lachalm"},
    {"city": "Sainte-Sigolène"},
    {"city": "Saint-Vénérand"},
    {"city": "Saint-Vert"},
    {"city": "Saint-Victor-Malescours"},
    {"city": "Saint-Victor-sur-Arlanc"},
    {"city": "Saint-Vidal"},
    {"city": "Saint-Vincent"},
    {"city": "Salettes"},
    {"city": "Salzuit"},
    {"city": "Sanssac-l'Église"},
    {"city": "Saugues"},
    {"city": "La Séauve-sur-Semène"},
    {"city": "Sembadel"},
    {"city": "Séneujols"},
    {"city": "Siaugues-Sainte-Marie"},
    {"city": "Solignac-sous-Roche"},
    {"city": "Solignac-sur-Loire"},
    {"city": "Tailhac"},
    {"city": "Tence"},
    {"city": "Thoras"},
    {"city": "Tiranges"},
    {"city": "Torsiac"},
    {"city": "Valprivas"},
    {"city": "Vals-le-Chastel"},
    {"city": "Vals-près-le-Puy"},
    {"city": "Varennes-Saint-Honorat"},
    {"city": "Les Vastres"},
    {"city": "Vazeilles-Limandre"},
    {"city": "Venteuges"},
    {"city": "Vergezac"},
    {"city": "Vergongheon"},
    {"city": "Vernassal"},
    {"city": "Le Vernet"},
    {"city": "Vézézoux"},
    {"city": "Vieille-Brioude"},
    {"city": "Vielprat"},
    {"city": "Villeneuve-d'Allier"},
    {"city": "Les Villettes"},
    {"city": "Vorey"},
    {"city": "Yssingeaux"},
    {"city": "Abbaretz"},
    {"city": "Aigrefeuille-sur-Maine"},
    {"city": "Ancenis-Saint-Géréon"},
    {"city": "Chaumes-en-Retz"},
    {"city": "Assérac"},
    {"city": "Avessac"},
    {"city": "Basse-Goulaine"},
    {"city": "Batz-sur-Mer"},
    {"city": "La Bernerie-en-Retz"},
    {"city": "Besné"},
    {"city": "Le Bignon"},
    {"city": "Blain"},
    {"city": "La Boissière-du-Doré"},
    {"city": "Bouaye"},
    {"city": "Bouée"},
    {"city": "Bouguenais"},
    {"city": "Villeneuve-en-Retz"},
    {"city": "Boussay"},
    {"city": "Bouvron"},
    {"city": "Brains"},
    {"city": "Campbon"},
    {"city": "Carquefou"},
    {"city": "Casson"},
    {"city": "Le Cellier"},
    {"city": "Divatte-sur-Loire"},
    {"city": "La Chapelle-des-Marais"},
    {"city": "La Chapelle-Glain"},
    {"city": "La Chapelle-Heulin"},
    {"city": "La Chapelle-Launay"},
    {"city": "La Chapelle-sur-Erdre"},
    {"city": "Châteaubriant"},
    {"city": "Château-Thébaud"},
    {"city": "Chauvé"},
    {"city": "Cheix-en-Retz"},
    {"city": "La Chevrolière"},
    {"city": "Clisson"},
    {"city": "Conquereuil"},
    {"city": "Cordemais"},
    {"city": "Corsept"},
    {"city": "Couëron"},
    {"city": "Couffé"},
    {"city": "Le Croisic"},
    {"city": "Crossac"},
    {"city": "Derval"},
    {"city": "Donges"},
    {"city": "Drefféac"},
    {"city": "Erbray"},
    {"city": "La Baule-Escoublac"},
    {"city": "Fay-de-Bretagne"},
    {"city": "Fégréac"},
    {"city": "Fercé"},
    {"city": "Frossay"},
    {"city": "Le Gâvre"},
    {"city": "Gétigné"},
    {"city": "Gorges"},
    {"city": "Grand-Auverné"},
    {"city": "Grandchamps-des-Fontaines"},
    {"city": "Guémené-Penfao"},
    {"city": "Guenrouet"},
    {"city": "Guérande"},
    {"city": "La Haie-Fouassière"},
    {"city": "Haute-Goulaine"},
    {"city": "Herbignac"},
    {"city": "Héric"},
    {"city": "Indre"},
    {"city": "Issé"},
    {"city": "Jans"},
    {"city": "Joué-sur-Erdre"},
    {"city": "Juigné-des-Moutiers"},
    {"city": "Le Landreau"},
    {"city": "Lavau-sur-Loire"},
    {"city": "Legé"},
    {"city": "Ligné"},
    {"city": "La Limouzinière"},
    {"city": "Le Loroux-Bottereau"},
    {"city": "Louisfert"},
    {"city": "Lusanger"},
    {"city": "Machecoul-Saint-Même"},
    {"city": "Maisdon-sur-Sèvre"},
    {"city": "Malville"},
    {"city": "La Marne"},
    {"city": "Marsac-sur-Don"},
    {"city": "Massérac"},
    {"city": "Mauves-sur-Loire"},
    {"city": "La Meilleraye-de-Bretagne"},
    {"city": "Mésanger"},
    {"city": "Mesquer"},
    {"city": "Missillac"},
    {"city": "Moisdon-la-Rivière"},
    {"city": "Monnières"},
    {"city": "La Montagne"},
    {"city": "Montbert"},
    {"city": "Montoir-de-Bretagne"},
    {"city": "Montrelais"},
    {"city": "Mouais"},
    {"city": "Les Moutiers-en-Retz"},
    {"city": "Mouzeil"},
    {"city": "Mouzillon"},
    {"city": "Nantes"},
    {"city": "Nort-sur-Erdre"},
    {"city": "Notre-Dame-des-Landes"},
    {"city": "Noyal-sur-Brutz"},
    {"city": "Nozay"},
    {"city": "Orvault"},
    {"city": "Oudon"},
    {"city": "Paimbœuf"},
    {"city": "Le Pallet"},
    {"city": "Pannecé"},
    {"city": "Paulx"},
    {"city": "Le Pellerin"},
    {"city": "Petit-Auverné"},
    {"city": "Petit-Mars"},
    {"city": "Pierric"},
    {"city": "Le Pin"},
    {"city": "Piriac-sur-Mer"},
    {"city": "La Plaine-sur-Mer"},
    {"city": "La Planche"},
    {"city": "Plessé"},
    {"city": "Pontchâteau"},
    {"city": "Pont-Saint-Martin"},
    {"city": "Pornic"},
    {"city": "Pornichet"},
    {"city": "Port-Saint-Père"},
    {"city": "Pouillé-les-Côteaux"},
    {"city": "Le Pouliguen"},
    {"city": "Préfailles"},
    {"city": "Prinquiau"},
    {"city": "Puceul"},
    {"city": "Quilly"},
    {"city": "La Regrippière"},
    {"city": "La Remaudière"},
    {"city": "Remouillé"},
    {"city": "Rezé"},
    {"city": "Riaillé"},
    {"city": "Rouans"},
    {"city": "Rougé"},
    {"city": "Ruffigné"},
    {"city": "Saffré"},
    {"city": "Saint-Aignan-Grandlieu"},
    {"city": "Saint-André-des-Eaux"},
    {"city": "Sainte-Anne-sur-Brivet"},
    {"city": "Saint-Aubin-des-Châteaux"},
    {"city": "Saint-Brevin-les-Pins"},
    {"city": "Saint-Colomban"},
    {"city": "Corcoué-sur-Logne"},
    {"city": "Saint-Étienne-de-Mer-Morte"},
    {"city": "Saint-Étienne-de-Montluc"},
    {"city": "Saint-Fiacre-sur-Maine"},
    {"city": "Saint-Gildas-des-Bois"},
    {"city": "Saint-Herblain"},
    {"city": "Vair-sur-Loire"},
    {"city": "Saint-Hilaire-de-Chaléons"},
    {"city": "Saint-Hilaire-de-Clisson"},
    {"city": "Saint-Jean-de-Boiseau"},
    {"city": "Saint-Joachim"},
    {"city": "Saint-Julien-de-Concelles"},
    {"city": "Saint-Julien-de-Vouvantes"},
    {"city": "Saint-Léger-les-Vignes"},
    {"city": "Sainte-Luce-sur-Loire"},
    {"city": "Saint-Lumine-de-Clisson"},
    {"city": "Saint-Lumine-de-Coutais"},
    {"city": "Saint-Lyphard"},
    {"city": "Saint-Malo-de-Guersac"},
    {"city": "Saint-Mars-de-Coutais"},
    {"city": "Saint-Mars-du-Désert"},
    {"city": "Vallons-de-l'Erdre"},
    {"city": "Saint-Michel-Chef-Chef"},
    {"city": "Saint-Molf"},
    {"city": "Saint-Nazaire"},
    {"city": "Saint-Nicolas-de-Redon"},
    {"city": "Sainte-Pazanne"},
    {"city": "Saint-Père-en-Retz"},
    {"city": "Saint-Philbert-de-Grand-Lieu"},
    {"city": "Sainte-Reine-de-Bretagne"},
    {"city": "Saint-Sébastien-sur-Loire"},
    {"city": "Saint-Viaud"},
    {"city": "Saint-Vincent-des-Landes"},
    {"city": "Sautron"},
    {"city": "Savenay"},
    {"city": "Sévérac"},
    {"city": "Sion-les-Mines"},
    {"city": "Les Sorinières"},
    {"city": "Soudan"},
    {"city": "Soulvache"},
    {"city": "Sucé-sur-Erdre"},
    {"city": "Teillé"},
    {"city": "Le Temple-de-Bretagne"},
    {"city": "Thouaré-sur-Loire"},
    {"city": "Les Touches"},
    {"city": "Touvois"},
    {"city": "Trans-sur-Erdre"},
    {"city": "Treffieux"},
    {"city": "Treillières"},
    {"city": "Trignac"},
    {"city": "La Turballe"},
    {"city": "Vallet"},
    {"city": "Loireauxence"},
    {"city": "Vay"},
    {"city": "Vertou"},
    {"city": "Vieillevigne"},
    {"city": "Vigneux-de-Bretagne"},
    {"city": "Villepot"},
    {"city": "Vue"},
    {"city": "La Chevallerais"},
    {"city": "La Roche-Blanche"},
    {"city": "Geneston"},
    {"city": "La Grigonnais"},
    {"city": "Adon"},
    {"city": "Aillant-sur-Milleron"},
    {"city": "Amilly"},
    {"city": "Andonville"},
    {"city": "Ardon"},
    {"city": "Artenay"},
    {"city": "Aschères-le-Marché"},
    {"city": "Ascoux"},
    {"city": "Attray"},
    {"city": "Audeville"},
    {"city": "Augerville-la-Rivière"},
    {"city": "Aulnay-la-Rivière"},
    {"city": "Autruy-sur-Juine"},
    {"city": "Autry-le-Châtel"},
    {"city": "Auvilliers-en-Gâtinais"},
    {"city": "Auxy"},
    {"city": "Baccon"},
    {"city": "Le Bardon"},
    {"city": "Barville-en-Gâtinais"},
    {"city": "Batilly-en-Gâtinais"},
    {"city": "Batilly-en-Puisaye"},
    {"city": "Baule"},
    {"city": "Bazoches-les-Gallerandes"},
    {"city": "Bazoches-sur-le-Betz"},
    {"city": "Beauchamps-sur-Huillard"},
    {"city": "Beaugency"},
    {"city": "Beaulieu-sur-Loire"},
    {"city": "Beaune-la-Rolande"},
    {"city": "Bellegarde"},
    {"city": "Le Bignon-Mirabeau"},
    {"city": "Boësses"},
    {"city": "Boigny-sur-Bionne"},
    {"city": "Boiscommun"},
    {"city": "Boismorand"},
    {"city": "Boisseaux"},
    {"city": "Bondaroy"},
    {"city": "Bonnée"},
    {"city": "Bonny-sur-Loire"},
    {"city": "Bordeaux-en-Gâtinais"},
    {"city": "Les Bordes"},
    {"city": "Bou"},
    {"city": "Bougy-lez-Neuville"},
    {"city": "Bouilly-en-Gâtinais"},
    {"city": "Boulay-les-Barres"},
    {"city": "Bouzonville-aux-Bois"},
    {"city": "Bouzy-la-Forêt"},
    {"city": "Boynes"},
    {"city": "Bray-Saint-Aignan"},
    {"city": "Breteau"},
    {"city": "Briare"},
    {"city": "Briarres-sur-Essonne"},
    {"city": "Bricy"},
    {"city": "Bromeilles"},
    {"city": "Bucy-le-Roi"},
    {"city": "Bucy-Saint-Liphard"},
    {"city": "La Bussière"},
    {"city": "Cepoy"},
    {"city": "Cercottes"},
    {"city": "Cerdon"},
    {"city": "Cernoy-en-Berry"},
    {"city": "Césarville-Dossainville"},
    {"city": "Chailly-en-Gâtinais"},
    {"city": "Chaingy"},
    {"city": "Châlette-sur-Loing"},
    {"city": "Chambon-la-Forêt"},
    {"city": "Champoulet"},
    {"city": "Chanteau"},
    {"city": "Chantecoq"},
    {"city": "La Chapelle-Onzerain"},
    {"city": "La Chapelle-Saint-Mesmin"},
    {"city": "La Chapelle-Saint-Sépulcre"},
    {"city": "La Chapelle-sur-Aveyron"},
    {"city": "Chapelon"},
    {"city": "Le Charme"},
    {"city": "Charmont-en-Beauce"},
    {"city": "Charsonville"},
    {"city": "Châteauneuf-sur-Loire"},
    {"city": "Château-Renard"},
    {"city": "Châtenoy"},
    {"city": "Châtillon-Coligny"},
    {"city": "Châtillon-le-Roi"},
    {"city": "Châtillon-sur-Loire"},
    {"city": "Chaussy"},
    {"city": "Chécy"},
    {"city": "Chevannes"},
    {"city": "Chevillon-sur-Huillard"},
    {"city": "Chevilly"},
    {"city": "Chevry-sous-le-Bignon"},
    {"city": "Chilleurs-aux-Bois"},
    {"city": "Les Choux"},
    {"city": "Chuelles"},
    {"city": "Cléry-Saint-André"},
    {"city": "Coinces"},
    {"city": "Combleux"},
    {"city": "Combreux"},
    {"city": "Conflans-sur-Loing"},
    {"city": "Corbeilles"},
    {"city": "Corquilleroy"},
    {"city": "Cortrat"},
    {"city": "Coudroy"},
    {"city": "Coullons"},
    {"city": "Coulmiers"},
    {"city": "Courcelles-le-Roi"},
    {"city": "Courcy-aux-Loges"},
    {"city": "La Cour-Marigny"},
    {"city": "Courtemaux"},
    {"city": "Courtempierre"},
    {"city": "Courtenay"},
    {"city": "Cravant"},
    {"city": "Crottes-en-Pithiverais"},
    {"city": "Dadonville"},
    {"city": "Dammarie-en-Puisaye"},
    {"city": "Dammarie-sur-Loing"},
    {"city": "Dampierre-en-Burly"},
    {"city": "Darvoy"},
    {"city": "Desmonts"},
    {"city": "Dimancheville"},
    {"city": "Donnery"},
    {"city": "Dordives"},
    {"city": "Douchy-Montcorbon"},
    {"city": "Dry"},
    {"city": "Échilleuses"},
    {"city": "Égry"},
    {"city": "Engenville"},
    {"city": "Épieds-en-Beauce"},
    {"city": "Erceville"},
    {"city": "Ervauville"},
    {"city": "Escrennes"},
    {"city": "Escrignelles"},
    {"city": "Estouy"},
    {"city": "Faverelles"},
    {"city": "Fay-aux-Loges"},
    {"city": "Feins-en-Gâtinais"},
    {"city": "Férolles"},
    {"city": "Ferrières-en-Gâtinais"},
    {"city": "La Ferté-Saint-Aubin"},
    {"city": "Fleury-les-Aubrais"},
    {"city": "Fontenay-sur-Loing"},
    {"city": "Foucherolles"},
    {"city": "Fréville-du-Gâtinais"},
    {"city": "Gaubertin"},
    {"city": "Gémigny"},
    {"city": "Germigny-des-Prés"},
    {"city": "Gidy"},
    {"city": "Gien"},
    {"city": "Girolles"},
    {"city": "Givraines"},
    {"city": "Gondreville"},
    {"city": "Grangermont"},
    {"city": "Greneville-en-Beauce"},
    {"city": "Griselles"},
    {"city": "Guigneville"},
    {"city": "Guilly"},
    {"city": "Gy-les-Nonains"},
    {"city": "Huêtre"},
    {"city": "Huisseau-sur-Mauves"},
    {"city": "Ingrannes"},
    {"city": "Ingré"},
    {"city": "Intville-la-Guétard"},
    {"city": "Isdes"},
    {"city": "Jargeau"},
    {"city": "Jouy-en-Pithiverais"},
    {"city": "Jouy-le-Potier"},
    {"city": "Juranville"},
    {"city": "Laas"},
    {"city": "Ladon"},
    {"city": "Lailly-en-Val"},
    {"city": "Langesse"},
    {"city": "Léouville"},
    {"city": "Ligny-le-Ribault"},
    {"city": "Lion-en-Beauce"},
    {"city": "Lion-en-Sullias"},
    {"city": "Lombreuil"},
    {"city": "Lorcy"},
    {"city": "Lorris"},
    {"city": "Loury"},
    {"city": "Louzouer"},
    {"city": "Le Malesherbois"},
    {"city": "Marcilly-en-Villette"},
    {"city": "Mardié"},
    {"city": "Mareau-aux-Bois"},
    {"city": "Mareau-aux-Prés"},
    {"city": "Marigny-les-Usages"},
    {"city": "Marsainvilliers"},
    {"city": "Melleroy"},
    {"city": "Ménestreau-en-Villette"},
    {"city": "Mérinville"},
    {"city": "Messas"},
    {"city": "Meung-sur-Loire"},
    {"city": "Mézières-lez-Cléry"},
    {"city": "Mézières-en-Gâtinais"},
    {"city": "Mignères"},
    {"city": "Mignerette"},
    {"city": "Montargis"},
    {"city": "Montbarrois"},
    {"city": "Montbouy"},
    {"city": "Montcresson"},
    {"city": "Montereau"},
    {"city": "Montigny"},
    {"city": "Montliard"},
    {"city": "Mormant-sur-Vernisson"},
    {"city": "Morville-en-Beauce"},
    {"city": "Le Moulinet-sur-Solin"},
    {"city": "Moulon"},
    {"city": "Nancray-sur-Rimarde"},
    {"city": "Nargis"},
    {"city": "Nesploy"},
    {"city": "Neuville-aux-Bois"},
    {"city": "La Neuville-sur-Essonne"},
    {"city": "Neuvy-en-Sullias"},
    {"city": "Nevoy"},
    {"city": "Nibelle"},
    {"city": "Nogent-sur-Vernisson"},
    {"city": "Noyers"},
    {"city": "Oison"},
    {"city": "Olivet"},
    {"city": "Ondreville-sur-Essonne"},
    {"city": "Orléans"},
    {"city": "Ormes"},
    {"city": "Orville"},
    {"city": "Ousson-sur-Loire"},
    {"city": "Oussoy-en-Gâtinais"},
    {"city": "Outarville"},
    {"city": "Ouvrouer-les-Champs"},
    {"city": "Ouzouer-des-Champs"},
    {"city": "Ouzouer-sous-Bellegarde"},
    {"city": "Ouzouer-sur-Loire"},
    {"city": "Ouzouer-sur-Trézée"},
    {"city": "Pannecières"},
    {"city": "Pannes"},
    {"city": "Patay"},
    {"city": "Paucourt"},
    {"city": "Pers-en-Gâtinais"},
    {"city": "Pierrefitte-ès-Bois"},
    {"city": "Pithiviers"},
    {"city": "Pithiviers-le-Vieil"},
    {"city": "Poilly-lez-Gien"},
    {"city": "Préfontaines"},
    {"city": "Presnoy"},
    {"city": "Pressigny-les-Pins"},
    {"city": "Puiseaux"},
    {"city": "Quiers-sur-Bézonde"},
    {"city": "Ramoulu"},
    {"city": "Rebréchien"},
    {"city": "Rouvray-Sainte-Croix"},
    {"city": "Rouvres-Saint-Jean"},
    {"city": "Rozières-en-Beauce"},
    {"city": "Rozoy-le-Vieil"},
    {"city": "Ruan"},
    {"city": "Saint-Aignan-le-Jaillard"},
    {"city": "Saint-Ay"},
    {"city": "Saint-Benoît-sur-Loire"},
    {"city": "Saint-Brisson-sur-Loire"},
    {"city": "Saint-Cyr-en-Val"},
    {"city": "Saint-Denis-de-l'Hôtel"},
    {"city": "Saint-Denis-en-Val"},
    {"city": "Saint-Firmin-des-Bois"},
    {"city": "Saint-Firmin-sur-Loire"},
    {"city": "Saint-Florent"},
    {"city": "Sainte-Geneviève-des-Bois"},
    {"city": "Saint-Germain-des-Prés"},
    {"city": "Saint-Gondon"},
    {"city": "Saint-Hilaire-les-Andrésis"},
    {"city": "Saint-Hilaire-Saint-Mesmin"},
    {"city": "Saint-Hilaire-sur-Puiseaux"},
    {"city": "Saint-Jean-de-Braye"},
    {"city": "Saint-Jean-de-la-Ruelle"},
    {"city": "Saint-Jean-le-Blanc"},
    {"city": "Saint-Loup-des-Vignes"},
    {"city": "Saint-Lyé-la-Forêt"},
    {"city": "Saint-Martin-d'Abbat"},
    {"city": "Saint-Martin-sur-Ocre"},
    {"city": "Saint-Maurice-sur-Aveyron"},
    {"city": "Saint-Maurice-sur-Fessard"},
    {"city": "Saint-Michel"},
    {"city": "Saint-Péravy-la-Colombe"},
    {"city": "Saint-Père-sur-Loire"},
    {"city": "Saint-Pryvé-Saint-Mesmin"},
    {"city": "Saint-Sigismond"},
    {"city": "Sandillon"},
    {"city": "Santeau"},
    {"city": "Saran"},
    {"city": "Sceaux-du-Gâtinais"},
    {"city": "Seichebrières"},
    {"city": "La Selle-en-Hermoy"},
    {"city": "La Selle-sur-le-Bied"},
    {"city": "Semoy"},
    {"city": "Sennely"},
    {"city": "Sermaises"},
    {"city": "Sigloy"},
    {"city": "Solterre"},
    {"city": "Sougy"},
    {"city": "Sully-la-Chapelle"},
    {"city": "Sully-sur-Loire"},
    {"city": "Sury-aux-Bois"},
    {"city": "Tavers"},
    {"city": "Thignonville"},
    {"city": "Thimory"},
    {"city": "Thorailles"},
    {"city": "Thou"},
    {"city": "Tigy"},
    {"city": "Tivernon"},
    {"city": "Tournoisis"},
    {"city": "Traînou"},
    {"city": "Treilles-en-Gâtinais"},
    {"city": "Triguères"},
    {"city": "Trinay"},
    {"city": "Vannes-sur-Cosson"},
    {"city": "Varennes-Changy"},
    {"city": "Vennecy"},
    {"city": "Vieilles-Maisons-sur-Joudry"},
    {"city": "Vienne-en-Val"},
    {"city": "Viglain"},
    {"city": "Villamblain"},
    {"city": "Villemandeur"},
    {"city": "Villemoutiers"},
    {"city": "Villemurlin"},
    {"city": "Villeneuve-sur-Conie"},
    {"city": "Villereau"},
    {"city": "Villevoques"},
    {"city": "Villorceau"},
    {"city": "Vimory"},
    {"city": "Vitry-aux-Loges"},
    {"city": "Vrigny"},
    {"city": "Yèvre-la-Ville"},
    {"city": "Albas"},
    {"city": "Albiac"},
    {"city": "Alvignac"},
    {"city": "Anglars"},
    {"city": "Anglars-Juillac"},
    {"city": "Anglars-Nozac"},
    {"city": "Arcambal"},
    {"city": "Les Arques"},
    {"city": "Assier"},
    {"city": "Aujols"},
    {"city": "Autoire"},
    {"city": "Aynac"},
    {"city": "Bach"},
    {"city": "Bagnac-sur-Célé"},
    {"city": "Baladou"},
    {"city": "Bannes"},
    {"city": "Le Bastit"},
    {"city": "Beauregard"},
    {"city": "Béduer"},
    {"city": "Bélaye"},
    {"city": "Belfort-du-Quercy"},
    {"city": "Belmont-Bretenoux"},
    {"city": "Belmont-Sainte-Foi"},
    {"city": "Berganty"},
    {"city": "Bétaille"},
    {"city": "Biars-sur-Cère"},
    {"city": "Bio"},
    {"city": "Blars"},
    {"city": "Boissières"},
    {"city": "Porte-du-Quercy"},
    {"city": "Le Bourg"},
    {"city": "Boussac"},
    {"city": "Le Bouyssou"},
    {"city": "Bouziès"},
    {"city": "Bretenoux"},
    {"city": "Brengues"},
    {"city": "Cabrerets"},
    {"city": "Cadrieu"},
    {"city": "Cahors"},
    {"city": "Cahus"},
    {"city": "Caillac"},
    {"city": "Cajarc"},
    {"city": "Calamane"},
    {"city": "Calès"},
    {"city": "Calvignac"},
    {"city": "Cambayrac"},
    {"city": "Cambes"},
    {"city": "Camboulit"},
    {"city": "Camburat"},
    {"city": "Caniac-du-Causse"},
    {"city": "Capdenac"},
    {"city": "Carayac"},
    {"city": "Cardaillac"},
    {"city": "Carennac"},
    {"city": "Carlucet"},
    {"city": "Carnac-Rouffiac"},
    {"city": "Cassagnes"},
    {"city": "Castelfranc"},
    {"city": "Castelnau Montratier-Sainte Alauzie"},
    {"city": "Catus"},
    {"city": "Cavagnac"},
    {"city": "Cazals"},
    {"city": "Cénevières"},
    {"city": "Cézac"},
    {"city": "Cieurac"},
    {"city": "Concorès"},
    {"city": "Concots"},
    {"city": "Condat"},
    {"city": "Corn"},
    {"city": "Cornac"},
    {"city": "Couzou"},
    {"city": "Cras"},
    {"city": "Crayssac"},
    {"city": "Crégols"},
    {"city": "Cremps"},
    {"city": "Cressensac-Sarrazac"},
    {"city": "Creysse"},
    {"city": "Cuzac"},
    {"city": "Cuzance"},
    {"city": "Dégagnac"},
    {"city": "Douelle"},
    {"city": "Duravel"},
    {"city": "Durbans"},
    {"city": "Escamps"},
    {"city": "Esclauzels"},
    {"city": "Espagnac-Sainte-Eulalie"},
    {"city": "Espédaillac"},
    {"city": "Espère"},
    {"city": "Espeyroux"},
    {"city": "Estal"},
    {"city": "Fajoles"},
    {"city": "Faycelles"},
    {"city": "Felzins"},
    {"city": "Figeac"},
    {"city": "Saint-Paul-Flaugnac"},
    {"city": "Flaujac-Gare"},
    {"city": "Flaujac-Poujols"},
    {"city": "Floirac"},
    {"city": "Floressas"},
    {"city": "Fons"},
    {"city": "Fontanes"},
    {"city": "Fourmagnac"},
    {"city": "Francoulès"},
    {"city": "Frayssinet"},
    {"city": "Frayssinet-le-Gélat"},
    {"city": "Frayssinhes"},
    {"city": "Frontenac"},
    {"city": "Gagnac-sur-Cère"},
    {"city": "Gignac"},
    {"city": "Gigouzac"},
    {"city": "Gindou"},
    {"city": "Ginouillac"},
    {"city": "Gintrac"},
    {"city": "Girac"},
    {"city": "Glanes"},
    {"city": "Gorses"},
    {"city": "Goujounac"},
    {"city": "Gourdon"},
    {"city": "Gramat"},
    {"city": "Gréalou"},
    {"city": "Grézels"},
    {"city": "Grèzes"},
    {"city": "Issendolus"},
    {"city": "Issepts"},
    {"city": "Les Junies"},
    {"city": "Labastide-du-Haut-Mont"},
    {"city": "Labastide-du-Vert"},
    {"city": "Labastide-Marnhac"},
    {"city": "Cœur de Causse"},
    {"city": "Labathude"},
    {"city": "Laburgade"},
    {"city": "Lacapelle-Cabanac"},
    {"city": "Lacapelle-Marival"},
    {"city": "Lacave"},
    {"city": "Lachapelle-Auzac"},
    {"city": "Ladirat"},
    {"city": "Lagardelle"},
    {"city": "Lalbenque"},
    {"city": "Lamagdelaine"},
    {"city": "Lamothe-Cassel"},
    {"city": "Lamothe-Fénelon"},
    {"city": "Lanzac"},
    {"city": "Laramière"},
    {"city": "Larnagol"},
    {"city": "Bellefont-La Rauze"},
    {"city": "Larroque-Toirac"},
    {"city": "Latouille-Lentillac"},
    {"city": "Latronquière"},
    {"city": "Lauresses"},
    {"city": "Lauzès"},
    {"city": "Laval-de-Cère"},
    {"city": "Lavercantière"},
    {"city": "Lavergne"},
    {"city": "Lentillac-du-Causse"},
    {"city": "Lentillac-Saint-Blaise"},
    {"city": "Léobard"},
    {"city": "Leyme"},
    {"city": "Lherm"},
    {"city": "Lhospitalet"},
    {"city": "Limogne-en-Quercy"},
    {"city": "Linac"},
    {"city": "Lissac-et-Mouret"},
    {"city": "Livernon"},
    {"city": "Loubressac"},
    {"city": "Loupiac"},
    {"city": "Lugagnac"},
    {"city": "Lunan"},
    {"city": "Lunegarde"},
    {"city": "Luzech"},
    {"city": "Marcilhac-sur-Célé"},
    {"city": "Marminiac"},
    {"city": "Martel"},
    {"city": "Masclat"},
    {"city": "Mauroux"},
    {"city": "Maxou"},
    {"city": "Mayrinhac-Lentour"},
    {"city": "Mechmont"},
    {"city": "Mercuès"},
    {"city": "Meyronne"},
    {"city": "Miers"},
    {"city": "Milhac"},
    {"city": "Molières"},
    {"city": "Montamel"},
    {"city": "Le Montat"},
    {"city": "Montbrun"},
    {"city": "Montcabrier"},
    {"city": "Montcléra"},
    {"city": "Montcuq-en-Quercy-Blanc"},
    {"city": "Montdoumerc"},
    {"city": "Montet-et-Bouxal"},
    {"city": "Montfaucon"},
    {"city": "Montgesty"},
    {"city": "Montlauzun"},
    {"city": "Montredon"},
    {"city": "Montvalent"},
    {"city": "Nadaillac-de-Rouge"},
    {"city": "Nadillac"},
    {"city": "Nuzéjouls"},
    {"city": "Orniac"},
    {"city": "Padirac"},
    {"city": "Parnac"},
    {"city": "Payrac"},
    {"city": "Payrignac"},
    {"city": "Pern"},
    {"city": "Pescadoires"},
    {"city": "Peyrilles"},
    {"city": "Pinsac"},
    {"city": "Planioles"},
    {"city": "Pomarède"},
    {"city": "Pontcirq"},
    {"city": "Pradines"},
    {"city": "Prayssac"},
    {"city": "Prendeignes"},
    {"city": "Promilhanes"},
    {"city": "Prudhomat"},
    {"city": "Puybrun"},
    {"city": "Puyjourdes"},
    {"city": "Puy-l'Évêque"},
    {"city": "Le Vignon-en-Quercy"},
    {"city": "Quissac"},
    {"city": "Rampoux"},
    {"city": "Reilhac"},
    {"city": "Reilhaguet"},
    {"city": "Reyrevignes"},
    {"city": "Rignac"},
    {"city": "Le Roc"},
    {"city": "Rocamadour"},
    {"city": "Rouffilhac"},
    {"city": "Rudelle"},
    {"city": "Rueyres"},
    {"city": "Sabadel-Latronquière"},
    {"city": "Sabadel-Lauzès"},
    {"city": "Saignes"},
    {"city": "Saillac"},
    {"city": "Saint-Bressou"},
    {"city": "Saint-Caprais"},
    {"city": "Saint-Céré"},
    {"city": "Les Pechs du Vers"},
    {"city": "Saint-Chamarand"},
    {"city": "Saint-Chels"},
    {"city": "Saint-Cirgues"},
    {"city": "Saint-Cirq-Lapopie"},
    {"city": "Saint-Cirq-Madelon"},
    {"city": "Saint-Cirq-Souillaguet"},
    {"city": "Saint-Clair"},
    {"city": "Sainte-Colombe"},
    {"city": "Lendou-en-Quercy"},
    {"city": "Barguelonne-en-Quercy"},
    {"city": "Saint-Denis-Catus"},
    {"city": "Saint-Denis-lès-Martel"},
    {"city": "Saint-Félix"},
    {"city": "Saint-Germain-du-Bel-Air"},
    {"city": "Saint Géry-Vers"},
    {"city": "Saint-Hilaire"},
    {"city": "Saint-Jean-de-Laur"},
    {"city": "Saint-Jean-Lespinasse"},
    {"city": "Saint-Jean-Mirabel"},
    {"city": "Saint-Laurent-les-Tours"},
    {"city": "Saint-Martin-Labouval"},
    {"city": "Saint-Martin-le-Redon"},
    {"city": "Saint-Maurice-en-Quercy"},
    {"city": "Saint-Médard"},
    {"city": "Saint-Médard-de-Presque"},
    {"city": "Saint-Médard-Nicourby"},
    {"city": "Saint-Michel-de-Bannières"},
    {"city": "Saint-Michel-Loubéjou"},
    {"city": "Saint-Paul-de-Vern"},
    {"city": "Saint-Perdoux"},
    {"city": "Saint-Pierre-Toirac"},
    {"city": "Saint-Projet"},
    {"city": "Saint-Simon"},
    {"city": "Saint-Sozy"},
    {"city": "Saint-Sulpice"},
    {"city": "Saint-Vincent-du-Pendit"},
    {"city": "Saint-Vincent-Rive-d'Olt"},
    {"city": "Salviac"},
    {"city": "Sauliac-sur-Célé"},
    {"city": "Sauzet"},
    {"city": "Sénaillac-Latronquière"},
    {"city": "Sénaillac-Lauzès"},
    {"city": "Séniergues"},
    {"city": "Sérignac"},
    {"city": "Sonac"},
    {"city": "Soturac"},
    {"city": "Soucirac"},
    {"city": "Souillac"},
    {"city": "Soulomès"},
    {"city": "Sousceyrac-en-Quercy"},
    {"city": "Strenquels"},
    {"city": "Tauriac"},
    {"city": "Terrou"},
    {"city": "Teyssieu"},
    {"city": "Thédirac"},
    {"city": "Thégra"},
    {"city": "Thémines"},
    {"city": "Théminettes"},
    {"city": "Tour-de-Faure"},
    {"city": "Touzac"},
    {"city": "Trespoux-Rassiels"},
    {"city": "Ussel"},
    {"city": "Uzech"},
    {"city": "Varaire"},
    {"city": "Vaylats"},
    {"city": "Vayrac"},
    {"city": "Viazac"},
    {"city": "Vidaillac"},
    {"city": "Le Vigan"},
    {"city": "Villesèque"},
    {"city": "Vire-sur-Lot"},
    {"city": "Mayrac"},
    {"city": "Bessonies"},
    {"city": "Saint-Jean-Lagineste"},
    {"city": "Saint-Pierre-Lafeuille"},
    {"city": "Agen"},
    {"city": "Agmé"},
    {"city": "Agnac"},
    {"city": "Aiguillon"},
    {"city": "Allemans-du-Dropt"},
    {"city": "Allez-et-Cazeneuve"},
    {"city": "Allons"},
    {"city": "Ambrus"},
    {"city": "Andiran"},
    {"city": "Antagnac"},
    {"city": "Anthé"},
    {"city": "Anzex"},
    {"city": "Argenton"},
    {"city": "Armillac"},
    {"city": "Astaffort"},
    {"city": "Aubiac"},
    {"city": "Auradou"},
    {"city": "Auriac-sur-Dropt"},
    {"city": "Bajamont"},
    {"city": "Baleyssagues"},
    {"city": "Barbaste"},
    {"city": "Bazens"},
    {"city": "Beaugas"},
    {"city": "Beaupuy"},
    {"city": "Beauville"},
    {"city": "Beauziac"},
    {"city": "Bias"},
    {"city": "Birac-sur-Trec"},
    {"city": "Blanquefort-sur-Briolance"},
    {"city": "Blaymont"},
    {"city": "Boé"},
    {"city": "Bon-Encontre"},
    {"city": "Boudy-de-Beauregard"},
    {"city": "Bouglon"},
    {"city": "Bourgougnague"},
    {"city": "Bourlens"},
    {"city": "Bournel"},
    {"city": "Bourran"},
    {"city": "Boussès"},
    {"city": "Brax"},
    {"city": "Bruch"},
    {"city": "Brugnac"},
    {"city": "Buzet-sur-Baïse"},
    {"city": "Cahuzac"},
    {"city": "Calignac"},
    {"city": "Calonges"},
    {"city": "Cambes"},
    {"city": "Cancon"},
    {"city": "Casseneuil"},
    {"city": "Cassignas"},
    {"city": "Castelculier"},
    {"city": "Casteljaloux"},
    {"city": "Castella"},
    {"city": "Castelmoron-sur-Lot"},
    {"city": "Castelnaud-de-Gratecambe"},
    {"city": "Castelnau-sur-Gupie"},
    {"city": "Castillonnès"},
    {"city": "Caubeyres"},
    {"city": "Caubon-Saint-Sauveur"},
    {"city": "Caudecoste"},
    {"city": "Caumont-sur-Garonne"},
    {"city": "Cauzac"},
    {"city": "Cavarc"},
    {"city": "Cazideroque"},
    {"city": "Clairac"},
    {"city": "Clermont-Dessous"},
    {"city": "Clermont-Soubiran"},
    {"city": "Cocumont"},
    {"city": "Colayrac-Saint-Cirq"},
    {"city": "Condezaygues"},
    {"city": "Coulx"},
    {"city": "Courbiac"},
    {"city": "Cours"},
    {"city": "Couthures-sur-Garonne"},
    {"city": "La Croix-Blanche"},
    {"city": "Cuq"},
    {"city": "Cuzorn"},
    {"city": "Damazan"},
    {"city": "Dausse"},
    {"city": "Dévillac"},
    {"city": "Dolmayrac"},
    {"city": "Dondas"},
    {"city": "Doudrac"},
    {"city": "Douzains"},
    {"city": "Durance"},
    {"city": "Duras"},
    {"city": "Engayrac"},
    {"city": "Escassefort"},
    {"city": "Esclottes"},
    {"city": "Espiens"},
    {"city": "Estillac"},
    {"city": "Fals"},
    {"city": "Fargues-sur-Ourbise"},
    {"city": "Fauguerolles"},
    {"city": "Fauillet"},
    {"city": "Ferrensac"},
    {"city": "Feugarolles"},
    {"city": "Fieux"},
    {"city": "Fongrave"},
    {"city": "Foulayronnes"},
    {"city": "Fourques-sur-Garonne"},
    {"city": "Francescas"},
    {"city": "Fréchou"},
    {"city": "Frégimont"},
    {"city": "Frespech"},
    {"city": "Fumel"},
    {"city": "Galapian"},
    {"city": "Gaujac"},
    {"city": "Gavaudun"},
    {"city": "Gontaud-de-Nogaret"},
    {"city": "Granges-sur-Lot"},
    {"city": "Grateloup-Saint-Gayrand"},
    {"city": "Grayssas"},
    {"city": "Grézet-Cavagnan"},
    {"city": "Guérin"},
    {"city": "Hautefage-la-Tour"},
    {"city": "Hautesvignes"},
    {"city": "Houeillès"},
    {"city": "Jusix"},
    {"city": "Labastide-Castel-Amouroux"},
    {"city": "Labretonie"},
    {"city": "Lacapelle-Biron"},
    {"city": "Lacaussade"},
    {"city": "Lacépède"},
    {"city": "Lachapelle"},
    {"city": "Lafitte-sur-Lot"},
    {"city": "Lafox"},
    {"city": "Lagarrigue"},
    {"city": "Lagruère"},
    {"city": "Lagupie"},
    {"city": "Lalandusse"},
    {"city": "Lamontjoie"},
    {"city": "Lannes"},
    {"city": "Laparade"},
    {"city": "Laperche"},
    {"city": "Laplume"},
    {"city": "Laroque-Timbaut"},
    {"city": "Lasserre"},
    {"city": "Laugnac"},
    {"city": "Laussou"},
    {"city": "Lauzun"},
    {"city": "Lavardac"},
    {"city": "Lavergne"},
    {"city": "Layrac"},
    {"city": "Lédat"},
    {"city": "Lévignac-de-Guyenne"},
    {"city": "Leyritz-Moncassin"},
    {"city": "Longueville"},
    {"city": "Loubès-Bernac"},
    {"city": "Lougratte"},
    {"city": "Lusignan-Petit"},
    {"city": "Madaillan"},
    {"city": "Marcellus"},
    {"city": "Marmande"},
    {"city": "Marmont-Pachas"},
    {"city": "Le Mas-d'Agenais"},
    {"city": "Masquières"},
    {"city": "Massels"},
    {"city": "Massoulès"},
    {"city": "Mauvezin-sur-Gupie"},
    {"city": "Mazières-Naresse"},
    {"city": "Meilhan-sur-Garonne"},
    {"city": "Mézin"},
    {"city": "Miramont-de-Guyenne"},
    {"city": "Moirax"},
    {"city": "Monbahus"},
    {"city": "Monbalen"},
    {"city": "Moncaut"},
    {"city": "Monclar"},
    {"city": "Moncrabeau"},
    {"city": "Monflanquin"},
    {"city": "Mongaillard"},
    {"city": "Monheurt"},
    {"city": "Monségur"},
    {"city": "Monsempron-Libos"},
    {"city": "Montagnac-sur-Auvignon"},
    {"city": "Montagnac-sur-Lède"},
    {"city": "Montastruc"},
    {"city": "Montauriol"},
    {"city": "Montaut"},
    {"city": "Montayral"},
    {"city": "Montesquieu"},
    {"city": "Monteton"},
    {"city": "Montignac-de-Lauzun"},
    {"city": "Montignac-Toupinerie"},
    {"city": "Montpezat"},
    {"city": "Montpouillan"},
    {"city": "Monviel"},
    {"city": "Moulinet"},
    {"city": "Moustier"},
    {"city": "Nérac"},
    {"city": "Nicole"},
    {"city": "Nomdieu"},
    {"city": "Pailloles"},
    {"city": "Pardaillan"},
    {"city": "Parranquet"},
    {"city": "Le Passage"},
    {"city": "Paulhiac"},
    {"city": "Penne-d'Agenais"},
    {"city": "Peyrière"},
    {"city": "Pindères"},
    {"city": "Pinel-Hauterive"},
    {"city": "Pompiey"},
    {"city": "Pompogne"},
    {"city": "Pont-du-Casse"},
    {"city": "Port-Sainte-Marie"},
    {"city": "Poudenas"},
    {"city": "Poussignac"},
    {"city": "Prayssas"},
    {"city": "Puch-d'Agenais"},
    {"city": "Pujols"},
    {"city": "Puymiclan"},
    {"city": "Puymirol"},
    {"city": "Puysserampion"},
    {"city": "Rayet"},
    {"city": "Razimet"},
    {"city": "Réaup-Lisse"},
    {"city": "La Réunion"},
    {"city": "Rives"},
    {"city": "Romestaing"},
    {"city": "Roquefort"},
    {"city": "Roumagne"},
    {"city": "Ruffiac"},
    {"city": "Saint-Antoine-de-Ficalba"},
    {"city": "Saint-Astier"},
    {"city": "Saint-Aubin"},
    {"city": "Saint-Avit"},
    {"city": "Saint-Barthélemy-d'Agenais"},
    {"city": "Sainte-Bazeille"},
    {"city": "Saint-Caprais-de-Lerm"},
    {"city": "Saint-Colomb-de-Lauzun"},
    {"city": "Sainte-Colombe-de-Duras"},
    {"city": "Sainte-Colombe-de-Villeneuve"},
    {"city": "Sainte-Colombe-en-Bruilhois"},
    {"city": "Saint-Étienne-de-Fougères"},
    {"city": "Saint-Étienne-de-Villeréal"},
    {"city": "Saint-Eutrope-de-Born"},
    {"city": "Saint-Front-sur-Lémance"},
    {"city": "Sainte-Gemme-Martaillac"},
    {"city": "Saint-Géraud"},
    {"city": "Saint-Hilaire-de-Lusignan"},
    {"city": "Saint-Jean-de-Duras"},
    {"city": "Saint-Jean-de-Thurac"},
    {"city": "Saint-Laurent"},
    {"city": "Saint-Léger"},
    {"city": "Saint-Léon"},
    {"city": "Sainte-Livrade-sur-Lot"},
    {"city": "Sainte-Marthe"},
    {"city": "Saint-Martin-Curton"},
    {"city": "Saint-Martin-de-Beauville"},
    {"city": "Saint-Martin-de-Villeréal"},
    {"city": "Saint-Martin-Petit"},
    {"city": "Sainte-Maure-de-Peyriac"},
    {"city": "Saint-Maurice-de-Lestapel"},
    {"city": "Saint-Maurin"},
    {"city": "Saint-Nicolas-de-la-Balerme"},
    {"city": "Saint-Pardoux-du-Breuil"},
    {"city": "Saint-Pardoux-Isaac"},
    {"city": "Saint-Pastour"},
    {"city": "Saint-Pé-Saint-Simon"},
    {"city": "Saint-Pierre-de-Buzet"},
    {"city": "Saint-Pierre-de-Clairac"},
    {"city": "Saint-Pierre-sur-Dropt"},
    {"city": "Saint-Quentin-du-Dropt"},
    {"city": "Saint-Robert"},
    {"city": "Saint-Romain-le-Noble"},
    {"city": "Saint-Salvy"},
    {"city": "Saint-Sardos"},
    {"city": "Saint-Sauveur-de-Meilhan"},
    {"city": "Saint-Sernin"},
    {"city": "Saint-Sixte"},
    {"city": "Saint-Sylvestre-sur-Lot"},
    {"city": "Saint-Urcisse"},
    {"city": "Saint-Vincent-de-Lamontjoie"},
    {"city": "Saint-Vite"},
    {"city": "Salles"},
    {"city": "Samazan"},
    {"city": "Sauméjan"},
    {"city": "Saumont"},
    {"city": "Sauvagnas"},
    {"city": "La Sauvetat-de-Savères"},
    {"city": "La Sauvetat-du-Dropt"},
    {"city": "La Sauvetat-sur-Lède"},
    {"city": "Sauveterre-la-Lémance"},
    {"city": "Sauveterre-Saint-Denis"},
    {"city": "Savignac-de-Duras"},
    {"city": "Savignac-sur-Leyze"},
    {"city": "Ségalas"},
    {"city": "Sembas"},
    {"city": "Sénestis"},
    {"city": "Sérignac-Péboudou"},
    {"city": "Sérignac-sur-Garonne"},
    {"city": "Seyches"},
    {"city": "Sos"},
    {"city": "Soumensac"},
    {"city": "Taillebourg"},
    {"city": "Tayrac"},
    {"city": "Le Temple-sur-Lot"},
    {"city": "Thézac"},
    {"city": "Thouars-sur-Garonne"},
    {"city": "Tombebœuf"},
    {"city": "Tonneins"},
    {"city": "Tourliac"},
    {"city": "Tournon-d'Agenais"},
    {"city": "Tourtrès"},
    {"city": "Trémons"},
    {"city": "Trentels"},
    {"city": "Varès"},
    {"city": "Verteuil-d'Agenais"},
    {"city": "Vianne"},
    {"city": "Villebramar"},
    {"city": "Villefranche-du-Queyran"},
    {"city": "Villeneuve-de-Duras"},
    {"city": "Villeneuve-sur-Lot"},
    {"city": "Villeréal"},
    {"city": "Villeton"},
    {"city": "Virazeil"},
    {"city": "Xaintrailles"},
    {"city": "Saint-Georges"},
    {"city": "Albaret-le-Comtal"},
    {"city": "Albaret-Sainte-Marie"},
    {"city": "Allenc"},
    {"city": "Altier"},
    {"city": "Antrenas"},
    {"city": "Arzenc-d'Apcher"},
    {"city": "Arzenc-de-Randon"},
    {"city": "Peyre en Aubrac"},
    {"city": "Auroux"},
    {"city": "Les Monts-Verts"},
    {"city": "Badaroux"},
    {"city": "Pied-de-Borne"},
    {"city": "Balsièges"},
    {"city": "Banassac-Canilhac"},
    {"city": "Barjac"},
    {"city": "Barre-des-Cévennes"},
    {"city": "Bassurels"},
    {"city": "La Bastide-Puylaurent"},
    {"city": "Les Bessons"},
    {"city": "Blavignac"},
    {"city": "Mont Lozère et Goulet"},
    {"city": "Les Bondons"},
    {"city": "Le Born"},
    {"city": "Brenoux"},
    {"city": "Brion"},
    {"city": "Le Buisson"},
    {"city": "La Canourgue"},
    {"city": "Cassagnas"},
    {"city": "Chadenet"},
    {"city": "Bel-Air-Val-d'Ance"},
    {"city": "Chanac"},
    {"city": "Chastanier"},
    {"city": "Chastel-Nouvel"},
    {"city": "Châteauneuf-de-Randon"},
    {"city": "Chauchailles"},
    {"city": "Chaudeyrac"},
    {"city": "Chaulhac"},
    {"city": "Cheylard-l'Évêque"},
    {"city": "Bédouès-Cocurès"},
    {"city": "Le Collet-de-Dèze"},
    {"city": "Cubières"},
    {"city": "Cubiérettes"},
    {"city": "Cultures"},
    {"city": "Esclanèdes"},
    {"city": "La Fage-Montivernoux"},
    {"city": "La Fage-Saint-Julien"},
    {"city": "Florac Trois Rivières"},
    {"city": "Fontans"},
    {"city": "Fournels"},
    {"city": "Fraissinet-de-Fourques"},
    {"city": "Gabriac"},
    {"city": "Gabrias"},
    {"city": "Gatuzières"},
    {"city": "Grandrieu"},
    {"city": "Grandvals"},
    {"city": "Grèzes"},
    {"city": "Les Hermaux"},
    {"city": "Hures-la-Parade"},
    {"city": "Ispagnac"},
    {"city": "Julianges"},
    {"city": "Lajo"},
    {"city": "Langogne"},
    {"city": "Lanuéjols"},
    {"city": "Laubert"},
    {"city": "Les Laubies"},
    {"city": "Laval-du-Tarn"},
    {"city": "Luc"},
    {"city": "Prinsuéjols-Malbouzon"},
    {"city": "La Malène"},
    {"city": "Le Malzieu-Forain"},
    {"city": "Le Malzieu-Ville"},
    {"city": "Marchastel"},
    {"city": "Marvejols"},
    {"city": "Massegros Causses Gorges"},
    {"city": "Mende"},
    {"city": "Meyrueis"},
    {"city": "Moissac-Vallée-Française"},
    {"city": "Molezon"},
    {"city": "Bourgs sur Colagne"},
    {"city": "Montbel"},
    {"city": "Montrodat"},
    {"city": "Nasbinals"},
    {"city": "Naussac-Fontanes"},
    {"city": "Noalhac"},
    {"city": "Palhers"},
    {"city": "La Panouse"},
    {"city": "Paulhac-en-Margeride"},
    {"city": "Pelouse"},
    {"city": "Pierrefiche"},
    {"city": "Le Pompidou"},
    {"city": "Pont de Montvert - Sud Mont Lozère"},
    {"city": "Pourcharesses"},
    {"city": "Prévenchères"},
    {"city": "Prunières"},
    {"city": "Recoules-d'Aubrac"},
    {"city": "Recoules-de-Fumas"},
    {"city": "Lachamp-Ribennes"},
    {"city": "Monts-de-Randon"},
    {"city": "Rimeize"},
    {"city": "Rocles"},
    {"city": "Rousses"},
    {"city": "Le Rozier"},
    {"city": "Saint-Alban-sur-Limagnole"},
    {"city": "Saint-André-Capcèze"},
    {"city": "Saint-André-de-Lancize"},
    {"city": "Saint-Bauzile"},
    {"city": "Saint-Bonnet-de-Chirac"},
    {"city": "Saint Bonnet-Laval"},
    {"city": "Saint-Chély-d'Apcher"},
    {"city": "Mas-Saint-Chély"},
    {"city": "Sainte-Croix-Vallée-Française"},
    {"city": "Saint-Denis-en-Margeride"},
    {"city": "Gorges du Tarn Causses"},
    {"city": "Saint-Étienne-du-Valdonnez"},
    {"city": "Saint-Étienne-Vallée-Française"},
    {"city": "Sainte-Eulalie"},
    {"city": "Saint-Flour-de-Mercoire"},
    {"city": "Saint-Frézal-d'Albuges"},
    {"city": "Ventalon en Cévennes"},
    {"city": "Saint-Gal"},
    {"city": "Saint-Germain-de-Calberte"},
    {"city": "Saint-Germain-du-Teil"},
    {"city": "Sainte-Hélène"},
    {"city": "Saint-Hilaire-de-Lavit"},
    {"city": "Saint-Jean-la-Fouillouse"},
    {"city": "Saint-Juéry"},
    {"city": "Saint-Julien-des-Points"},
    {"city": "Saint-Laurent-de-Muret"},
    {"city": "Cans et Cévennes"},
    {"city": "Saint-Laurent-de-Veyrès"},
    {"city": "Saint-Léger-de-Peyre"},
    {"city": "Saint-Léger-du-Malzieu"},
    {"city": "Saint-Martin-de-Boubaux"},
    {"city": "Saint-Martin-de-Lansuscle"},
    {"city": "Saint-Michel-de-Dèze"},
    {"city": "Saint-Paul-le-Froid"},
    {"city": "Saint-Pierre-de-Nogaret"},
    {"city": "Saint-Pierre-des-Tripiers"},
    {"city": "Saint-Pierre-le-Vieux"},
    {"city": "Saint-Privat-de-Vallongue"},
    {"city": "Saint-Privat-du-Fau"},
    {"city": "Saint-Saturnin"},
    {"city": "Saint-Sauveur-de-Ginestoux"},
    {"city": "Les Salelles"},
    {"city": "Les Salces"},
    {"city": "Serverette"},
    {"city": "Termes"},
    {"city": "La Tieule"},
    {"city": "Trélans"},
    {"city": "Vebron"},
    {"city": "Vialas"},
    {"city": "Villefort"},
    {"city": "Allonnes"},
    {"city": "Tuffalun"},
    {"city": "Angers"},
    {"city": "Angrie"},
    {"city": "Antoigné"},
    {"city": "Armaillé"},
    {"city": "Artannes-sur-Thouet"},
    {"city": "Aubigné-sur-Layon"},
    {"city": "Avrillé"},
    {"city": "Baracé"},
    {"city": "Baugé-en-Anjou"},
    {"city": "Beaucouzé"},
    {"city": "Beaufort-en-Anjou"},
    {"city": "Beaulieu-sur-Layon"},
    {"city": "Beaupréau-en-Mauges"},
    {"city": "Bécon-les-Granits"},
    {"city": "Bégrolles-en-Mauges"},
    {"city": "Béhuard"},
    {"city": "Blaison-Saint-Sulpice"},
    {"city": "Blou"},
    {"city": "Bouchemaine"},
    {"city": "Bouillé-Ménard"},
    {"city": "Bourg-l'Évêque"},
    {"city": "Brain-sur-Allonnes"},
    {"city": "La Breille-les-Pins"},
    {"city": "Briollay"},
    {"city": "Brissac Loire Aubance"},
    {"city": "Brossay"},
    {"city": "Candé"},
    {"city": "Cantenay-Épinard"},
    {"city": "Carbay"},
    {"city": "Cernusson"},
    {"city": "Les Cerqueux"},
    {"city": "Bellevigne-les-Châteaux"},
    {"city": "Challain-la-Potherie"},
    {"city": "Chalonnes-sur-Loire"},
    {"city": "Chambellay"},
    {"city": "Chenillé-Champteussé"},
    {"city": "Champtocé-sur-Loire"},
    {"city": "Orée d'Anjou"},
    {"city": "Chanteloup-les-Bois"},
    {"city": "La Chapelle-Saint-Laud"},
    {"city": "Les Hauts-d'Anjou"},
    {"city": "Chaudefonds-sur-Layon"},
    {"city": "Terranjou"},
    {"city": "Chazé-sur-Argos"},
    {"city": "Cheffes"},
    {"city": "Chemillé-en-Anjou"},
    {"city": "Cholet"},
    {"city": "Cizay-la-Madeleine"},
    {"city": "Cléré-sur-Layon"},
    {"city": "Cornillé-les-Caves"},
    {"city": "Coron"},
    {"city": "Corzé"},
    {"city": "Le Coudray-Macouard"},
    {"city": "Courchamps"},
    {"city": "Courléon"},
    {"city": "Denée"},
    {"city": "Dénezé-sous-Doué"},
    {"city": "Distré"},
    {"city": "Doué-en-Anjou"},
    {"city": "Durtal"},
    {"city": "Écouflant"},
    {"city": "Écuillé"},
    {"city": "Épieds"},
    {"city": "Étriché"},
    {"city": "Feneu"},
    {"city": "Les Bois d'Anjou"},
    {"city": "Fontevraud-l'Abbaye"},
    {"city": "Grez-Neuville"},
    {"city": "Ingrandes-Le Fresne sur Loire"},
    {"city": "La Jaille-Yvon"},
    {"city": "Jarzé Villages"},
    {"city": "Les Garennes sur Loire"},
    {"city": "Juvardeil"},
    {"city": "La Lande-Chasles"},
    {"city": "Huillé-Lézigné"},
    {"city": "Le Lion-d'Angers"},
    {"city": "Loiré"},
    {"city": "Longué-Jumelles"},
    {"city": "Louresse-Rochemenier"},
    {"city": "Val d'Erdre-Auxence"},
    {"city": "Marcé"},
    {"city": "Maulévrier"},
    {"city": "Le May-sur-Èvre"},
    {"city": "Mazé-Milon"},
    {"city": "Mazières-en-Mauges"},
    {"city": "Longuenée-en-Anjou"},
    {"city": "La Ménitré"},
    {"city": "Miré"},
    {"city": "Montigné-lès-Rairies"},
    {"city": "Montilliers"},
    {"city": "Montreuil-Juigné"},
    {"city": "Montreuil-Bellay"},
    {"city": "Montreuil-sur-Loir"},
    {"city": "Montreuil-sur-Maine"},
    {"city": "Montrevault-sur-Èvre"},
    {"city": "Montsoreau"},
    {"city": "Morannes sur Sarthe-Daumeray"},
    {"city": "Mouliherne"},
    {"city": "Mozé-sur-Louet"},
    {"city": "Mûrs-Erigné"},
    {"city": "Neuillé"},
    {"city": "Noyant-Villages"},
    {"city": "Nuaillé"},
    {"city": "Parnay"},
    {"city": "Passavant-sur-Layon"},
    {"city": "La Pellerine"},
    {"city": "La Plaine"},
    {"city": "Le Plessis-Grammoire"},
    {"city": "Mauges-sur-Loire"},
    {"city": "Les Ponts-de-Cé"},
    {"city": "La Possonnière"},
    {"city": "Ombrée d'Anjou"},
    {"city": "Le Puy-Notre-Dame"},
    {"city": "Les Rairies"},
    {"city": "Rochefort-sur-Loire"},
    {"city": "La Romagne"},
    {"city": "Gennes-Val-de-Loire"},
    {"city": "Rou-Marson"},
    {"city": "Saint-Augustin-des-Bois"},
    {"city": "Saint-Barthélemy-d'Anjou"},
    {"city": "Saint-Christophe-du-Bois"},
    {"city": "Saint-Clément-de-la-Place"},
    {"city": "Saint-Clément-des-Levées"},
    {"city": "Sainte-Gemmes-sur-Loire"},
    {"city": "Saint-Georges-sur-Loire"},
    {"city": "Saint-Germain-des-Prés"},
    {"city": "Saint-Jean-de-la-Croix"},
    {"city": "Saint-Just-sur-Dive"},
    {"city": "Val-du-Layon"},
    {"city": "Saint-Lambert-la-Potherie"},
    {"city": "Saint-Léger-de-Linières"},
    {"city": "Saint-Léger-sous-Cholet"},
    {"city": "Sèvremoine"},
    {"city": "Saint-Macaire-du-Bois"},
    {"city": "Saint-Martin-du-Fouilloux"},
    {"city": "Loire-Authion"},
    {"city": "Saint-Melaine-sur-Aubance"},
    {"city": "Saint-Paul-du-Bois"},
    {"city": "Saint-Philbert-du-Peuple"},
    {"city": "Saint-Sigismond"},
    {"city": "Verrières-en-Anjou"},
    {"city": "Sarrigné"},
    {"city": "Saumur"},
    {"city": "Savennières"},
    {"city": "Sceaux-d'Anjou"},
    {"city": "Segré-en-Anjou Bleu"},
    {"city": "La Séguinière"},
    {"city": "Seiches-sur-le-Loir"},
    {"city": "Sermaise"},
    {"city": "Somloire"},
    {"city": "Soulaines-sur-Aubance"},
    {"city": "Soulaire-et-Bourg"},
    {"city": "Souzay-Champigny"},
    {"city": "La Tessoualle"},
    {"city": "Thorigné-d'Anjou"},
    {"city": "Bellevigne-en-Layon"},
    {"city": "Tiercé"},
    {"city": "Toutlemonde"},
    {"city": "Trélazé"},
    {"city": "Trémentines"},
    {"city": "Turquant"},
    {"city": "Les Ulmes"},
    {"city": "Varennes-sur-Loire"},
    {"city": "Varrains"},
    {"city": "Vaudelnay"},
    {"city": "Erdre-en-Anjou"},
    {"city": "Vernantes"},
    {"city": "Vernoil-le-Fourrier"},
    {"city": "Verrie"},
    {"city": "Vezins"},
    {"city": "Lys-Haut-Layon"},
    {"city": "Villebernier"},
    {"city": "Rives-du-Loir-en-Anjou"},
    {"city": "Vivy"},
    {"city": "Yzernay"},
    {"city": "Agneaux"},
    {"city": "Agon-Coutainville"},
    {"city": "Airel"},
    {"city": "Amigny"},
    {"city": "Anctoville-sur-Boscq"},
    {"city": "Anneville-en-Saire"},
    {"city": "Annoville"},
    {"city": "Appeville"},
    {"city": "Aucey-la-Plaine"},
    {"city": "Audouville-la-Hubert"},
    {"city": "Aumeville-Lestre"},
    {"city": "Auvers"},
    {"city": "Auxais"},
    {"city": "Avranches"},
    {"city": "Azeville"},
    {"city": "Bacilly"},
    {"city": "La Baleine"},
    {"city": "Barenton"},
    {"city": "Barfleur"},
    {"city": "Barneville-Carteret"},
    {"city": "La Barre-de-Semilly"},
    {"city": "Baubigny"},
    {"city": "Baudre"},
    {"city": "Baupte"},
    {"city": "Beauchamps"},
    {"city": "Beaucoudray"},
    {"city": "Beauficel"},
    {"city": "La Hague"},
    {"city": "Beauvoir"},
    {"city": "Belval"},
    {"city": "Benoîtville"},
    {"city": "Bérigny"},
    {"city": "Beslon"},
    {"city": "Besneville"},
    {"city": "Beuvrigny"},
    {"city": "Beuzeville-la-Bastille"},
    {"city": "Biéville"},
    {"city": "Biniville"},
    {"city": "Blainville-sur-Mer"},
    {"city": "Blosville"},
    {"city": "La Bloutière"},
    {"city": "Boisyvon"},
    {"city": "La Bonneville"},
    {"city": "Jullouville"},
    {"city": "Bourguenolles"},
    {"city": "Boutteville"},
    {"city": "Brainville"},
    {"city": "Brécey"},
    {"city": "Bréhal"},
    {"city": "Bretteville"},
    {"city": "Bretteville-sur-Ay"},
    {"city": "Breuville"},
    {"city": "Bréville-sur-Mer"},
    {"city": "Bricquebec-en-Cotentin"},
    {"city": "Bricquebosq"},
    {"city": "Bricqueville-la-Blouette"},
    {"city": "Bricqueville-sur-Mer"},
    {"city": "Brillevast"},
    {"city": "Brix"},
    {"city": "Brouains"},
    {"city": "Buais-Les-Monts"},
    {"city": "Cambernon"},
    {"city": "Cametours"},
    {"city": "Camprond"},
    {"city": "Canisy"},
    {"city": "Canteloup"},
    {"city": "Canville-la-Rocque"},
    {"city": "Carantilly"},
    {"city": "Carentan-les-Marais"},
    {"city": "Carneville"},
    {"city": "Carolles"},
    {"city": "Catteville"},
    {"city": "Cavigny"},
    {"city": "Céaux"},
    {"city": "Cérences"},
    {"city": "Cerisy-la-Forêt"},
    {"city": "Cerisy-la-Salle"},
    {"city": "La Chaise-Baudouin"},
    {"city": "Le Grippon"},
    {"city": "Champeaux"},
    {"city": "Champrepus"},
    {"city": "Chanteloup"},
    {"city": "La Chapelle-Cécelin"},
    {"city": "La Chapelle-Urée"},
    {"city": "Chavoy"},
    {"city": "Cherbourg-en-Cotentin"},
    {"city": "Chérencé-le-Héron"},
    {"city": "Clitourps"},
    {"city": "La Colombe"},
    {"city": "Colomby"},
    {"city": "Condé-sur-Vire"},
    {"city": "Vicq-sur-Mer"},
    {"city": "Coudeville-sur-Mer"},
    {"city": "Coulouvray-Boisbenâtre"},
    {"city": "Courcy"},
    {"city": "Courtils"},
    {"city": "Coutances"},
    {"city": "Couvains"},
    {"city": "Couville"},
    {"city": "Crasville"},
    {"city": "Créances"},
    {"city": "Les Cresnays"},
    {"city": "Crollon"},
    {"city": "Crosville-sur-Douve"},
    {"city": "Cuves"},
    {"city": "Dangy"},
    {"city": "Le Dézert"},
    {"city": "Digosville"},
    {"city": "Domjean"},
    {"city": "Donville-les-Bains"},
    {"city": "Doville"},
    {"city": "Dragey-Ronthon"},
    {"city": "Ducey-Les Chéris"},
    {"city": "Écausseville"},
    {"city": "Émondeville"},
    {"city": "Équilly"},
    {"city": "Éroudeville"},
    {"city": "L'Étang-Bertrand"},
    {"city": "Étienville"},
    {"city": "Fermanville"},
    {"city": "Feugères"},
    {"city": "La Feuillie"},
    {"city": "Fierville-les-Mines"},
    {"city": "Flamanville"},
    {"city": "Fleury"},
    {"city": "Flottemanville"},
    {"city": "Folligny"},
    {"city": "Fontenay-sur-Mer"},
    {"city": "Fourneaux"},
    {"city": "Le Fresne-Poret"},
    {"city": "Fresville"},
    {"city": "Gathemo"},
    {"city": "Gatteville-le-Phare"},
    {"city": "Gavray-sur-Sienne"},
    {"city": "Geffosses"},
    {"city": "Genêts"},
    {"city": "Ger"},
    {"city": "La Godefroy"},
    {"city": "Golleville"},
    {"city": "Gonfreville"},
    {"city": "Gonneville-Le Theil"},
    {"city": "Gorges"},
    {"city": "Gouvets"},
    {"city": "Gouville-sur-Mer"},
    {"city": "Graignes-Mesnil-Angot"},
    {"city": "Le Grand-Celland"},
    {"city": "Granville"},
    {"city": "Gratot"},
    {"city": "Grimesnil"},
    {"city": "Grosville"},
    {"city": "Le Guislain"},
    {"city": "Le Ham"},
    {"city": "Hambye"},
    {"city": "Hamelin"},
    {"city": "Hardinvast"},
    {"city": "Hauteville-sur-Mer"},
    {"city": "Hauteville-la-Guichard"},
    {"city": "Hautteville-Bocage"},
    {"city": "La Haye-Bellefond"},
    {"city": "La Haye-d'Ectot"},
    {"city": "La Haye"},
    {"city": "La Haye-Pesnel"},
    {"city": "Héauville"},
    {"city": "Thèreval"},
    {"city": "Helleville"},
    {"city": "Hémevez"},
    {"city": "Heugueville-sur-Sienne"},
    {"city": "Hiesville"},
    {"city": "Hocquigny"},
    {"city": "Huberville"},
    {"city": "Hudimesnil"},
    {"city": "Huisnes-sur-Mer"},
    {"city": "Isigny-le-Buat"},
    {"city": "Joganville"},
    {"city": "Juilley"},
    {"city": "Juvigny les Vallées"},
    {"city": "Lamberville"},
    {"city": "La Lande-d'Airou"},
    {"city": "Lapenty"},
    {"city": "Laulne"},
    {"city": "Lengronne"},
    {"city": "Lessay"},
    {"city": "Lestre"},
    {"city": "Liesville-sur-Douve"},
    {"city": "Lieusaint"},
    {"city": "Lingeard"},
    {"city": "Lingreville"},
    {"city": "Montsenelle"},
    {"city": "Les Loges-Marchis"},
    {"city": "Les Loges-sur-Brécey"},
    {"city": "Lolif"},
    {"city": "Longueville"},
    {"city": "Le Loreur"},
    {"city": "Le Lorey"},
    {"city": "La Lucerne-d'Outremer"},
    {"city": "Le Luot"},
    {"city": "La Luzerne"},
    {"city": "Magneville"},
    {"city": "Marcey-les-Grèves"},
    {"city": "Marchésieux"},
    {"city": "Marcilly"},
    {"city": "Margueray"},
    {"city": "Marigny-Le-Lozon"},
    {"city": "Martinvast"},
    {"city": "Maupertuis"},
    {"city": "Maupertus-sur-Mer"},
    {"city": "La Meauffe"},
    {"city": "Méautis"},
    {"city": "Le Mesnil"},
    {"city": "Le Mesnil-Adelée"},
    {"city": "Le Mesnil-Amey"},
    {"city": "Le Mesnil-Aubert"},
    {"city": "Le Mesnil-au-Val"},
    {"city": "Le Mesnil-Eury"},
    {"city": "Le Mesnil-Garnier"},
    {"city": "Le Mesnil-Gilbert"},
    {"city": "Le Mesnillard"},
    {"city": "Le Mesnil-Ozenne"},
    {"city": "Le Mesnil-Rouxelin"},
    {"city": "Le Mesnil-Véneron"},
    {"city": "Le Mesnil-Villeman"},
    {"city": "La Meurdraquière"},
    {"city": "Millières"},
    {"city": "Les Moitiers-d'Allonne"},
    {"city": "Montabot"},
    {"city": "Montaigu-la-Brisette"},
    {"city": "Montaigu-les-Bois"},
    {"city": "Montbray"},
    {"city": "Montcuit"},
    {"city": "Montebourg"},
    {"city": "Montfarville"},
    {"city": "Monthuchon"},
    {"city": "Montjoie-Saint-Martin"},
    {"city": "Montmartin-sur-Mer"},
    {"city": "Montpinchon"},
    {"city": "Montrabot"},
    {"city": "Montreuil-sur-Lozon"},
    {"city": "Le Mont-Saint-Michel"},
    {"city": "Moon-sur-Elle"},
    {"city": "Morigny"},
    {"city": "Mortain-Bocage"},
    {"city": "Morville"},
    {"city": "La Mouche"},
    {"city": "Moulines"},
    {"city": "Moyon Villages"},
    {"city": "Muneville-le-Bingard"},
    {"city": "Muneville-sur-Mer"},
    {"city": "Nay"},
    {"city": "Négreville"},
    {"city": "Néhou"},
    {"city": "Le Neufbourg"},
    {"city": "Neufmesnil"},
    {"city": "Neuville-au-Plain"},
    {"city": "Neuville-en-Beaumont"},
    {"city": "Nicorps"},
    {"city": "Notre-Dame-de-Cenilly"},
    {"city": "Notre-Dame-de-Livoye"},
    {"city": "Nouainville"},
    {"city": "Octeville-l'Avenel"},
    {"city": "Orglandes"},
    {"city": "Orval sur Sienne"},
    {"city": "Ouville"},
    {"city": "Ozeville"},
    {"city": "Grandparigny"},
    {"city": "Percy-en-Normandie"},
    {"city": "Périers"},
    {"city": "La Pernelle"},
    {"city": "Perriers-en-Beauficel"},
    {"city": "Le Perron"},
    {"city": "Le Petit-Celland"},
    {"city": "Picauville"},
    {"city": "Pierreville"},
    {"city": "Les Pieux"},
    {"city": "Pirou"},
    {"city": "Le Plessis-Lastelle"},
    {"city": "Poilley"},
    {"city": "Pontaubault"},
    {"city": "Pont-Hébert"},
    {"city": "Pontorson"},
    {"city": "Ponts"},
    {"city": "Port-Bail-sur-Mer"},
    {"city": "Précey"},
    {"city": "Quettehou"},
    {"city": "Quettreville-sur-Sienne"},
    {"city": "Quibou"},
    {"city": "Quinéville"},
    {"city": "Raids"},
    {"city": "Rampan"},
    {"city": "Rauville-la-Bigot"},
    {"city": "Rauville-la-Place"},
    {"city": "Reffuveille"},
    {"city": "Regnéville-sur-Mer"},
    {"city": "Reigneville-Bocage"},
    {"city": "Remilly Les Marais"},
    {"city": "Réville"},
    {"city": "Rocheville"},
    {"city": "Romagny Fontenay"},
    {"city": "Roncey"},
    {"city": "Le Rozel"},
    {"city": "Sacey"},
    {"city": "Saint-Amand-Villages"},
    {"city": "Saint-André-de-Bohon"},
    {"city": "Saint-André-de-l'Épine"},
    {"city": "Saint-Aubin-des-Préaux"},
    {"city": "Saint-Aubin-de-Terregatte"},
    {"city": "Saint-Barthélemy"},
    {"city": "Saint-Brice"},
    {"city": "Saint-Brice-de-Landelles"},
    {"city": "Sainte-Cécile"},
    {"city": "Saint-Christophe-du-Foc"},
    {"city": "Saint-Clair-sur-l'Elle"},
    {"city": "Saint-Clément-Rancoudray"},
    {"city": "Sainte-Colombe"},
    {"city": "Saint-Cyr"},
    {"city": "Saint-Cyr-du-Bailleul"},
    {"city": "Saint-Denis-le-Gast"},
    {"city": "Saint-Denis-le-Vêtu"},
    {"city": "Saint-Floxel"},
    {"city": "Saint-Fromond"},
    {"city": "Sainte-Geneviève"},
    {"city": "Saint-Georges-de-la-Rivière"},
    {"city": "Saint-Georges-de-Livoye"},
    {"city": "Saint-Georges-d'Elle"},
    {"city": "Saint-Georges-de-Rouelley"},
    {"city": "Saint-Georges-Montcocq"},
    {"city": "Saint-Germain-d'Elle"},
    {"city": "Saint-Germain-de-Tournebut"},
    {"city": "Saint-Germain-de-Varreville"},
    {"city": "Saint-Germain-le-Gaillard"},
    {"city": "Saint-Germain-sur-Ay"},
    {"city": "Saint-Germain-sur-Sèves"},
    {"city": "Saint-Gilles"},
    {"city": "Saint-Hilaire-du-Harcouët"},
    {"city": "Saint-Jacques-de-Néhou"},
    {"city": "Saint-James"},
    {"city": "Saint-Jean-de-Daye"},
    {"city": "Saint-Jean-de-la-Haize"},
    {"city": "Saint-Jean-de-la-Rivière"},
    {"city": "Saint-Jean-de-Savigny"},
    {"city": "Saint-Jean-d'Elle"},
    {"city": "Saint-Jean-des-Champs"},
    {"city": "Saint-Jean-du-Corail-des-Bois"},
    {"city": "Saint-Jean-le-Thomas"},
    {"city": "Saint-Joseph"},
    {"city": "Saint-Laurent-de-Cuves"},
    {"city": "Saint-Laurent-de-Terregatte"},
    {"city": "Saint-Lô"},
    {"city": "Saint-Louet-sur-Vire"},
    {"city": "Saint-Loup"},
    {"city": "Saint-Malo-de-la-Lande"},
    {"city": "Saint-Marcouf"},
    {"city": "Sainte-Marie-du-Mont"},
    {"city": "Saint-Martin-d'Aubigny"},
    {"city": "Saint-Martin-d'Audouville"},
    {"city": "Saint-Martin-de-Bonfossé"},
    {"city": "Saint-Martin-de-Cenilly"},
    {"city": "Chaulieu"},
    {"city": "Saint-Martin-de-Varreville"},
    {"city": "Saint-Martin-le-Bouillant"},
    {"city": "Saint-Martin-le-Gréard"},
    {"city": "Saint-Maur-des-Bois"},
    {"city": "Saint-Maurice-en-Cotentin"},
    {"city": "Sainte-Mère-Église"},
    {"city": "Saint-Michel-de-Montjoie"},
    {"city": "Saint-Nicolas-de-Pierrepont"},
    {"city": "Saint-Nicolas-des-Bois"},
    {"city": "Saint-Ovin"},
    {"city": "Saint-Pair-sur-Mer"},
    {"city": "Saint-Patrice-de-Claids"},
    {"city": "Le Parc"},
    {"city": "Saint-Pierre-d'Arthéglise"},
    {"city": "Saint-Pierre-de-Coutances"},
    {"city": "Saint-Pierre-de-Semilly"},
    {"city": "Saint-Pierre-Église"},
    {"city": "Saint-Pierre-Langers"},
    {"city": "Saint-Planchers"},
    {"city": "Saint-Pois"},
    {"city": "Saint-Quentin-sur-le-Homme"},
    {"city": "Bourgvallées"},
    {"city": "Saint-Sauveur-de-Pierrepont"},
    {"city": "Saint-Sauveur-la-Pommeraye"},
    {"city": "Saint-Sauveur-Villages"},
    {"city": "Saint-Sauveur-le-Vicomte"},
    {"city": "Saint-Sébastien-de-Raids"},
    {"city": "Saint-Senier-de-Beuvron"},
    {"city": "Saint-Senier-sous-Avranches"},
    {"city": "Sainte-Suzanne-sur-Vire"},
    {"city": "Saint-Vaast-la-Hougue"},
    {"city": "Saint-Vigor-des-Monts"},
    {"city": "Terre-et-Marais"},
    {"city": "Sartilly-Baie-Bocage"},
    {"city": "Saussemesnil"},
    {"city": "Saussey"},
    {"city": "Savigny"},
    {"city": "Savigny-le-Vieux"},
    {"city": "Sébeville"},
    {"city": "Sénoville"},
    {"city": "Servon"},
    {"city": "Sideville"},
    {"city": "Siouville-Hague"},
    {"city": "Sortosville-en-Beaumont"},
    {"city": "Sortosville"},
    {"city": "Sottevast"},
    {"city": "Sotteville"},
    {"city": "Sourdeval"},
    {"city": "Subligny"},
    {"city": "Surtainville"},
    {"city": "Taillepied"},
    {"city": "Tamerville"},
    {"city": "Tanis"},
    {"city": "Le Tanu"},
    {"city": "Le Teilleul"},
    {"city": "Tessy-Bocage"},
    {"city": "Teurthéville-Bocage"},
    {"city": "Teurthéville-Hague"},
    {"city": "Théville"},
    {"city": "Tirepied-sur-Sée"},
    {"city": "Tocqueville"},
    {"city": "Tollevast"},
    {"city": "Torigny-les-Villes"},
    {"city": "Tourville-sur-Sienne"},
    {"city": "Tréauville"},
    {"city": "Tribehou"},
    {"city": "La Trinité"},
    {"city": "Turqueville"},
    {"city": "Urville"},
    {"city": "Vains"},
    {"city": "Valcanville"},
    {"city": "Valognes"},
    {"city": "Le Val-Saint-Père"},
    {"city": "Varenguebec"},
    {"city": "Varouville"},
    {"city": "Le Vast"},
    {"city": "Vaudreville"},
    {"city": "La Vendelée"},
    {"city": "Ver"},
    {"city": "Vernix"},
    {"city": "Vesly"},
    {"city": "Le Vicel"},
    {"city": "Videcosville"},
    {"city": "Villebaudon"},
    {"city": "Villedieu-les-Poêles-Rouffigny"},
    {"city": "Villiers-Fossard"},
    {"city": "Virandeville"},
    {"city": "Yquelon"},
    {"city": "Yvetot-Bocage"},
    {"city": "Ablancourt"},
    {"city": "Saint-Martin-d'Ablois"},
    {"city": "Aigny"},
    {"city": "Allemanche-Launay-et-Soyer"},
    {"city": "Allemant"},
    {"city": "Alliancelles"},
    {"city": "Ambonnay"},
    {"city": "Ambrières"},
    {"city": "Anglure"},
    {"city": "Angluzelles-et-Courcelles"},
    {"city": "Anthenay"},
    {"city": "Aougny"},
    {"city": "Arcis-le-Ponsart"},
    {"city": "Argers"},
    {"city": "Arrigny"},
    {"city": "Arzillières-Neuville"},
    {"city": "Athis"},
    {"city": "Aubérive"},
    {"city": "Aubilly"},
    {"city": "Aulnay-l'Aître"},
    {"city": "Aulnay-sur-Marne"},
    {"city": "Auménancourt"},
    {"city": "Auve"},
    {"city": "Avenay-Val-d'Or"},
    {"city": "Avize"},
    {"city": "Aÿ-Champagne"},
    {"city": "Baconnes"},
    {"city": "Bagneux"},
    {"city": "Le Baizil"},
    {"city": "Bannay"},
    {"city": "Bannes"},
    {"city": "Barbonne-Fayel"},
    {"city": "Baslieux-lès-Fismes"},
    {"city": "Baslieux-sous-Châtillon"},
    {"city": "Bassu"},
    {"city": "Bassuet"},
    {"city": "Baudement"},
    {"city": "Baye"},
    {"city": "Bazancourt"},
    {"city": "Beaumont-sur-Vesle"},
    {"city": "Beaunay"},
    {"city": "Beine-Nauroy"},
    {"city": "Belval-en-Argonne"},
    {"city": "Belval-sous-Châtillon"},
    {"city": "Bergères-lès-Vertus"},
    {"city": "Bergères-sous-Montmirail"},
    {"city": "Berméricourt"},
    {"city": "Berru"},
    {"city": "Berzieux"},
    {"city": "Bétheniville"},
    {"city": "Bétheny"},
    {"city": "Bethon"},
    {"city": "Bettancourt-la-Longue"},
    {"city": "Bezannes"},
    {"city": "Bignicourt-sur-Marne"},
    {"city": "Bignicourt-sur-Saulx"},
    {"city": "Billy-le-Grand"},
    {"city": "Binarville"},
    {"city": "Binson-et-Orquigny"},
    {"city": "Blacy"},
    {"city": "Blaise-sous-Arzillières"},
    {"city": "Blesme"},
    {"city": "Bligny"},
    {"city": "Boissy-le-Repos"},
    {"city": "Bouchy-Saint-Genest"},
    {"city": "Bouilly"},
    {"city": "Bouleuse"},
    {"city": "Boult-sur-Suippe"},
    {"city": "Bourgogne-Fresne"},
    {"city": "Boursault"},
    {"city": "Bouvancourt"},
    {"city": "Bouy"},
    {"city": "Bouzy"},
    {"city": "Brandonvillers"},
    {"city": "Branscourt"},
    {"city": "Braux-Sainte-Cohière"},
    {"city": "Braux-Saint-Remy"},
    {"city": "Bréban"},
    {"city": "Le Breuil"},
    {"city": "Breuil-sur-Vesle"},
    {"city": "Breuvery-sur-Coole"},
    {"city": "Brimont"},
    {"city": "Brouillet"},
    {"city": "Broussy-le-Grand"},
    {"city": "Broussy-le-Petit"},
    {"city": "Broyes"},
    {"city": "Brugny-Vaudancourt"},
    {"city": "Brusson"},
    {"city": "Le Buisson"},
    {"city": "Bussy-le-Château"},
    {"city": "Bussy-le-Repos"},
    {"city": "Bussy-Lettrée"},
    {"city": "La Caure"},
    {"city": "Caurel"},
    {"city": "Cauroy-lès-Hermonville"},
    {"city": "La Celle-sous-Chantemerle"},
    {"city": "Cernay-en-Dormois"},
    {"city": "Cernay-lès-Reims"},
    {"city": "Cernon"},
    {"city": "Chaintrix-Bierges"},
    {"city": "Châlons-en-Champagne"},
    {"city": "Châlons-sur-Vesle"},
    {"city": "Chaltrait"},
    {"city": "Chambrecy"},
    {"city": "Chamery"},
    {"city": "Champaubert"},
    {"city": "Champfleury"},
    {"city": "Champguyon"},
    {"city": "Champigneul-Champagne"},
    {"city": "Champigny"},
    {"city": "Champillon"},
    {"city": "Champlat-et-Boujacourt"},
    {"city": "Champvoisy"},
    {"city": "Changy"},
    {"city": "Chantemerle"},
    {"city": "Chapelaine"},
    {"city": "La Chapelle-Felcourt"},
    {"city": "La Chapelle-Lasson"},
    {"city": "La Chapelle-sous-Orbais"},
    {"city": "Charleville"},
    {"city": "Charmont"},
    {"city": "Les Charmontois"},
    {"city": "Le Châtelier"},
    {"city": "Châtelraould-Saint-Louvent"},
    {"city": "Châtillon-sur-Broué"},
    {"city": "Châtillon-sur-Marne"},
    {"city": "Châtillon-sur-Morin"},
    {"city": "Châtrices"},
    {"city": "Chaudefontaine"},
    {"city": "Chaumuzy"},
    {"city": "La Chaussée-sur-Marne"},
    {"city": "Chavot-Courcourt"},
    {"city": "Le Chemin"},
    {"city": "Cheminon"},
    {"city": "Chenay"},
    {"city": "Cheniers"},
    {"city": "La Cheppe"},
    {"city": "Cheppes-la-Prairie"},
    {"city": "Chepy"},
    {"city": "Cherville"},
    {"city": "Chichey"},
    {"city": "Chigny-les-Roses"},
    {"city": "Chouilly"},
    {"city": "Clamanges"},
    {"city": "Clesles"},
    {"city": "Cloyes-sur-Marne"},
    {"city": "Coizard-Joches"},
    {"city": "Val-des-Marais"},
    {"city": "Compertrix"},
    {"city": "Condé-sur-Marne"},
    {"city": "Conflans-sur-Seine"},
    {"city": "Congy"},
    {"city": "Connantray-Vaurefroy"},
    {"city": "Connantre"},
    {"city": "Contault"},
    {"city": "Coole"},
    {"city": "Coolus"},
    {"city": "Corbeil"},
    {"city": "Corfélix"},
    {"city": "Cormicy"},
    {"city": "Cormontreuil"},
    {"city": "Cormoyeux"},
    {"city": "Corribert"},
    {"city": "Corrobert"},
    {"city": "Corroy"},
    {"city": "Coulommes-la-Montagne"},
    {"city": "Coupetz"},
    {"city": "Coupéville"},
    {"city": "Courcelles-Sapicourt"},
    {"city": "Courcemain"},
    {"city": "Courcy"},
    {"city": "Courdemanges"},
    {"city": "Courgivaux"},
    {"city": "Courjeonnet"},
    {"city": "Courlandon"},
    {"city": "Courmas"},
    {"city": "Courtagnon"},
    {"city": "Courtémont"},
    {"city": "Courthiézy"},
    {"city": "Courtisols"},
    {"city": "Courville"},
    {"city": "Couvrot"},
    {"city": "Cramant"},
    {"city": "La Croix-en-Champagne"},
    {"city": "Crugny"},
    {"city": "Cuchery"},
    {"city": "Cuis"},
    {"city": "Cuisles"},
    {"city": "Cumières"},
    {"city": "Cuperly"},
    {"city": "Damery"},
    {"city": "Dampierre-au-Temple"},
    {"city": "Dampierre-le-Château"},
    {"city": "Dampierre-sur-Moivre"},
    {"city": "Dizy"},
    {"city": "Dommartin-Dampierre"},
    {"city": "Dommartin-Lettrée"},
    {"city": "Dommartin-sous-Hans"},
    {"city": "Dommartin-Varimont"},
    {"city": "Dompremy"},
    {"city": "Dontrien"},
    {"city": "Dormans"},
    {"city": "Val-de-Vière"},
    {"city": "Drosnay"},
    {"city": "Drouilly"},
    {"city": "Éclaires"},
    {"city": "Écollemont"},
    {"city": "Écriennes"},
    {"city": "Écueil"},
    {"city": "Écury-le-Repos"},
    {"city": "Écury-sur-Coole"},
    {"city": "Élise-Daucourt"},
    {"city": "Épense"},
    {"city": "Épernay"},
    {"city": "L'Épine"},
    {"city": "Époye"},
    {"city": "Escardes"},
    {"city": "Esclavolles-Lurey"},
    {"city": "Les Essarts-lès-Sézanne"},
    {"city": "Les Essarts-le-Vicomte"},
    {"city": "Esternay"},
    {"city": "Étoges"},
    {"city": "Étréchy"},
    {"city": "Étrepy"},
    {"city": "Euvy"},
    {"city": "Fagnières"},
    {"city": "Faux-Fresnay"},
    {"city": "Faux-Vésigneul"},
    {"city": "Faverolles-et-Coëmy"},
    {"city": "Favresse"},
    {"city": "Fèrebrianges"},
    {"city": "Fère-Champenoise"},
    {"city": "Festigny"},
    {"city": "Fismes"},
    {"city": "Flavigny"},
    {"city": "Fleury-la-Rivière"},
    {"city": "Florent-en-Argonne"},
    {"city": "Fontaine-Denis-Nuisy"},
    {"city": "Fontaine-en-Dormois"},
    {"city": "Fontaine-sur-Ay"},
    {"city": "La Forestière"},
    {"city": "Francheville"},
    {"city": "Le Fresne"},
    {"city": "Frignicourt"},
    {"city": "Fromentières"},
    {"city": "Le Gault-Soigny"},
    {"city": "Gaye"},
    {"city": "Germaine"},
    {"city": "Germigny"},
    {"city": "Germinon"},
    {"city": "Giffaumont-Champaubert"},
    {"city": "Gigny-Bussy"},
    {"city": "Givry-en-Argonne"},
    {"city": "Givry-lès-Loisy"},
    {"city": "Gizaucourt"},
    {"city": "Glannes"},
    {"city": "Gourgançon"},
    {"city": "Sainte-Marie-du-Lac-Nuisement"},
    {"city": "Les Grandes-Loges"},
    {"city": "Granges-sur-Aube"},
    {"city": "Gratreuil"},
    {"city": "Grauves"},
    {"city": "Gueux"},
    {"city": "Hans"},
    {"city": "Haussignémont"},
    {"city": "Haussimont"},
    {"city": "Hauteville"},
    {"city": "Hautvillers"},
    {"city": "Heiltz-le-Hutier"},
    {"city": "Heiltz-le-Maurupt"},
    {"city": "Heiltz-l'Évêque"},
    {"city": "Hermonville"},
    {"city": "Herpont"},
    {"city": "Heutrégiville"},
    {"city": "Hourges"},
    {"city": "Huiron"},
    {"city": "Humbauville"},
    {"city": "Igny-Comblizy"},
    {"city": "Isles-sur-Suippe"},
    {"city": "Isle-sur-Marne"},
    {"city": "Isse"},
    {"city": "Les Istres-et-Bury"},
    {"city": "Jâlons"},
    {"city": "Janvilliers"},
    {"city": "Janvry"},
    {"city": "Joiselle"},
    {"city": "Jonchery-sur-Suippe"},
    {"city": "Jonchery-sur-Vesle"},
    {"city": "Jonquery"},
    {"city": "Jouy-lès-Reims"},
    {"city": "Jussecourt-Minecourt"},
    {"city": "Juvigny"},
    {"city": "Lachy"},
    {"city": "Lagery"},
    {"city": "Landricourt"},
    {"city": "Larzicourt"},
    {"city": "Laval-sur-Tourbe"},
    {"city": "Lavannes"},
    {"city": "Lenharrée"},
    {"city": "Leuvrigny"},
    {"city": "Lhéry"},
    {"city": "Lignon"},
    {"city": "Linthelles"},
    {"city": "Linthes"},
    {"city": "Lisse-en-Champagne"},
    {"city": "Livry-Louvercy"},
    {"city": "Loisy-en-Brie"},
    {"city": "Loisy-sur-Marne"},
    {"city": "Loivre"},
    {"city": "Ludes"},
    {"city": "Luxémont-et-Villotte"},
    {"city": "Maffrécourt"},
    {"city": "Magneux"},
    {"city": "Mailly-Champagne"},
    {"city": "Mairy-sur-Marne"},
    {"city": "Maisons-en-Champagne"},
    {"city": "Malmy"},
    {"city": "Mancy"},
    {"city": "Marcilly-sur-Seine"},
    {"city": "Mardeuil"},
    {"city": "Mareuil-en-Brie"},
    {"city": "Mareuil-le-Port"},
    {"city": "Marfaux"},
    {"city": "Margerie-Hancourt"},
    {"city": "Margny"},
    {"city": "Marigny"},
    {"city": "Marolles"},
    {"city": "Marsangis"},
    {"city": "Marson"},
    {"city": "Massiges"},
    {"city": "Matignicourt-Goncourt"},
    {"city": "Matougues"},
    {"city": "Maurupt-le-Montois"},
    {"city": "Mécringes"},
    {"city": "Le Meix-Saint-Epoing"},
    {"city": "Le Meix-Tiercelin"},
    {"city": "Merfy"},
    {"city": "Merlaut"},
    {"city": "Méry-Prémecy"},
    {"city": "Les Mesneux"},
    {"city": "Le Mesnil-sur-Oger"},
    {"city": "Minaucourt-le-Mesnil-lès-Hurlus"},
    {"city": "Mœurs-Verdey"},
    {"city": "Moiremont"},
    {"city": "Moivre"},
    {"city": "Moncetz-Longevas"},
    {"city": "Moncetz-l'Abbaye"},
    {"city": "Mondement-Montgivroux"},
    {"city": "Montbré"},
    {"city": "Montgenost"},
    {"city": "Montépreux"},
    {"city": "Monthelon"},
    {"city": "Montigny-sur-Vesle"},
    {"city": "Montmirail"},
    {"city": "Montmort-Lucy"},
    {"city": "Mont-sur-Courville"},
    {"city": "Morangis"},
    {"city": "Morsains"},
    {"city": "Moslins"},
    {"city": "Mourmelon-le-Grand"},
    {"city": "Mourmelon-le-Petit"},
    {"city": "Moussy"},
    {"city": "Muizon"},
    {"city": "Mutigny"},
    {"city": "Nanteuil-la-Forêt"},
    {"city": "Nesle-la-Reposte"},
    {"city": "Nesle-le-Repons"},
    {"city": "La Neuville-aux-Bois"},
    {"city": "La Neuville-aux-Larris"},
    {"city": "La Neuville-au-Pont"},
    {"city": "Neuvy"},
    {"city": "Nogent-l'Abbesse"},
    {"city": "Noirlieu"},
    {"city": "Norrois"},
    {"city": "La Noue"},
    {"city": "Nuisement-sur-Coole"},
    {"city": "Œuilly"},
    {"city": "Ognes"},
    {"city": "Oiry"},
    {"city": "Olizy"},
    {"city": "Omey"},
    {"city": "Orbais-l'Abbaye"},
    {"city": "Orconte"},
    {"city": "Ormes"},
    {"city": "Outines"},
    {"city": "Outrepont"},
    {"city": "Oyes"},
    {"city": "Pargny-lès-Reims"},
    {"city": "Pargny-sur-Saulx"},
    {"city": "Passavant-en-Argonne"},
    {"city": "Passy-Grigny"},
    {"city": "Péas"},
    {"city": "Les Petites-Loges"},
    {"city": "Pévy"},
    {"city": "Pierre-Morains"},
    {"city": "Pierry"},
    {"city": "Pleurs"},
    {"city": "Plichancourt"},
    {"city": "Plivot"},
    {"city": "Pocancy"},
    {"city": "Pogny"},
    {"city": "Poilly"},
    {"city": "Poix"},
    {"city": "Pomacle"},
    {"city": "Pontfaverger-Moronvilliers"},
    {"city": "Ponthion"},
    {"city": "Possesse"},
    {"city": "Potangis"},
    {"city": "Pouillon"},
    {"city": "Pourcy"},
    {"city": "Pringy"},
    {"city": "Prosnes"},
    {"city": "Prouilly"},
    {"city": "Prunay"},
    {"city": "Puisieulx"},
    {"city": "Queudes"},
    {"city": "Rapsécourt"},
    {"city": "Recy"},
    {"city": "Reims"},
    {"city": "Reims-la-Brûlée"},
    {"city": "Remicourt"},
    {"city": "Reuil"},
    {"city": "Reuves"},
    {"city": "Réveillon"},
    {"city": "Rieux"},
    {"city": "Rilly-la-Montagne"},
    {"city": "Les Rivières-Henruel"},
    {"city": "Romain"},
    {"city": "Romery"},
    {"city": "Romigny"},
    {"city": "Rosnay"},
    {"city": "Rouffy"},
    {"city": "Rouvroy-Ripont"},
    {"city": "Sacy"},
    {"city": "Saint-Amand-sur-Fion"},
    {"city": "Saint-Bon"},
    {"city": "Saint-Brice-Courcelles"},
    {"city": "Saint-Chéron"},
    {"city": "Saint-Étienne-au-Temple"},
    {"city": "Saint-Étienne-sur-Suippe"},
    {"city": "Saint-Eulien"},
    {"city": "Saint-Euphraise-et-Clairizet"},
    {"city": "Sainte-Gemme"},
    {"city": "Saint-Germain-la-Ville"},
    {"city": "Saint-Gibrien"},
    {"city": "Saint-Gilles"},
    {"city": "Saint-Hilaire-au-Temple"},
    {"city": "Saint-Hilaire-le-Grand"},
    {"city": "Saint-Hilaire-le-Petit"},
    {"city": "Saint-Imoges"},
    {"city": "Saint-Jean-devant-Possesse"},
    {"city": "Saint-Jean-sur-Moivre"},
    {"city": "Saint-Jean-sur-Tourbe"},
    {"city": "Saint-Just-Sauvage"},
    {"city": "Saint-Léonard"},
    {"city": "Saint-Loup"},
    {"city": "Saint-Lumier-en-Champagne"},
    {"city": "Saint-Lumier-la-Populeuse"},
    {"city": "Saint-Mard-sur-Auve"},
    {"city": "Saint-Mard-lès-Rouffy"},
    {"city": "Saint-Mard-sur-le-Mont"},
    {"city": "Sainte-Marie-à-Py"},
    {"city": "Saint-Martin-aux-Champs"},
    {"city": "Saint-Martin-l'Heureux"},
    {"city": "Saint-Martin-sur-le-Pré"},
    {"city": "Saint-Masmes"},
    {"city": "Saint-Memmie"},
    {"city": "Sainte-Menehould"},
    {"city": "Saint-Ouen-Domprot"},
    {"city": "Saint-Pierre"},
    {"city": "Saint-Quentin-les-Marais"},
    {"city": "Saint-Quentin-le-Verger"},
    {"city": "Saint-Quentin-sur-Coole"},
    {"city": "Saint-Remy-en-Bouzemont-Saint-Genest-et-Isson"},
    {"city": "Saint-Remy-sous-Broyes"},
    {"city": "Saint-Remy-sur-Bussy"},
    {"city": "Saint-Saturnin"},
    {"city": "Saint-Souplet-sur-Py"},
    {"city": "Saint-Thierry"},
    {"city": "Saint-Thomas-en-Argonne"},
    {"city": "Saint-Utin"},
    {"city": "Saint-Vrain"},
    {"city": "Sapignicourt"},
    {"city": "Sarcy"},
    {"city": "Saron-sur-Aube"},
    {"city": "Sarry"},
    {"city": "Saudoy"},
    {"city": "Savigny-sur-Ardres"},
    {"city": "Scrupt"},
    {"city": "Selles"},
    {"city": "Sept-Saulx"},
    {"city": "Sermaize-les-Bains"},
    {"city": "Sermiers"},
    {"city": "Servon-Melzicourt"},
    {"city": "Serzy-et-Prin"},
    {"city": "Sézanne"},
    {"city": "Sillery"},
    {"city": "Sivry-Ante"},
    {"city": "Sogny-aux-Moulins"},
    {"city": "Sogny-en-l'Angle"},
    {"city": "Soizy-aux-Bois"},
    {"city": "Somme-Bionne"},
    {"city": "Sommepy-Tahure"},
    {"city": "Sommesous"},
    {"city": "Somme-Suippe"},
    {"city": "Somme-Tourbe"},
    {"city": "Somme-Vesle"},
    {"city": "Somme-Yèvre"},
    {"city": "Sompuis"},
    {"city": "Somsois"},
    {"city": "Songy"},
    {"city": "Souain-Perthes-lès-Hurlus"},
    {"city": "Soudé"},
    {"city": "Soudron"},
    {"city": "Soulanges"},
    {"city": "Soulières"},
    {"city": "Suippes"},
    {"city": "Suizy-le-Franc"},
    {"city": "Taissy"},
    {"city": "Talus-Saint-Prix"},
    {"city": "Val de Livre"},
    {"city": "Thaas"},
    {"city": "Thibie"},
    {"city": "Thiéblemont-Farémont"},
    {"city": "Thil"},
    {"city": "Thillois"},
    {"city": "Le Thoult-Trosnay"},
    {"city": "Val-de-Vesle"},
    {"city": "Tilloy-et-Bellay"},
    {"city": "Tinqueux"},
    {"city": "Togny-aux-Bœufs"},
    {"city": "Tours-sur-Marne"},
    {"city": "Tramery"},
    {"city": "Trécon"},
    {"city": "Tréfols"},
    {"city": "Trépail"},
    {"city": "Treslon"},
    {"city": "Trigny"},
    {"city": "Trois-Fontaines-l'Abbaye"},
    {"city": "Trois-Puits"},
    {"city": "Troissy"},
    {"city": "Unchair"},
    {"city": "Vadenay"},
    {"city": "Valmy"},
    {"city": "Vanault-le-Châtel"},
    {"city": "Vanault-les-Dames"},
    {"city": "Vandeuil"},
    {"city": "Vandières"},
    {"city": "Vassimont-et-Chapelaine"},
    {"city": "Vatry"},
    {"city": "Vauchamps"},
    {"city": "Vauciennes"},
    {"city": "Vauclerc"},
    {"city": "Vaudemange"},
    {"city": "Vaudesincourt"},
    {"city": "Vavray-le-Grand"},
    {"city": "Vavray-le-Petit"},
    {"city": "Vélye"},
    {"city": "Ventelay"},
    {"city": "Venteuil"},
    {"city": "Verdon"},
    {"city": "Vernancourt"},
    {"city": "Verneuil"},
    {"city": "Verrières"},
    {"city": "Vert-Toulon"},
    {"city": "Blancs-Coteaux"},
    {"city": "Verzenay"},
    {"city": "Verzy"},
    {"city": "Vésigneul-sur-Marne"},
    {"city": "La Veuve"},
    {"city": "Le Vézier"},
    {"city": "Le Vieil-Dampierre"},
    {"city": "Vienne-la-Ville"},
    {"city": "Vienne-le-Château"},
    {"city": "Ville-Dommange"},
    {"city": "Ville-en-Selve"},
    {"city": "Ville-en-Tardenois"},
    {"city": "Villeneuve-la-Lionne"},
    {"city": "La Villeneuve-lès-Charleville"},
    {"city": "Villeneuve-Renneville-Chevigny"},
    {"city": "Villeneuve-Saint-Vistre-et-Villevotte"},
    {"city": "Villers-Allerand"},
    {"city": "Villers-aux-Bois"},
    {"city": "Villers-aux-Nœuds"},
    {"city": "Villers-en-Argonne"},
    {"city": "Villers-Franqueux"},
    {"city": "Villers-le-Château"},
    {"city": "Villers-le-Sec"},
    {"city": "Villers-Marmery"},
    {"city": "Villers-sous-Châtillon"},
    {"city": "Villeseneux"},
    {"city": "La Ville-sous-Orbais"},
    {"city": "Ville-sur-Tourbe"},
    {"city": "Villevenard"},
    {"city": "Villiers-aux-Corneilles"},
    {"city": "Vinay"},
    {"city": "Vincelles"},
    {"city": "Vindey"},
    {"city": "Virginy"},
    {"city": "Vitry-en-Perthois"},
    {"city": "Vitry-la-Ville"},
    {"city": "Vitry-le-François"},
    {"city": "Voilemont"},
    {"city": "Vouarces"},
    {"city": "Vouillers"},
    {"city": "Vouzy"},
    {"city": "Vraux"},
    {"city": "Vrigny"},
    {"city": "Vroil"},
    {"city": "Wargemoulin-Hurlus"},
    {"city": "Warmeriville"},
    {"city": "Witry-lès-Reims"},
    {"city": "Magenta"},
    {"city": "Ageville"},
    {"city": "Aigremont"},
    {"city": "Aillianville"},
    {"city": "Aingoulaincourt"},
    {"city": "Aizanville"},
    {"city": "Allichamps"},
    {"city": "Ambonville"},
    {"city": "Andelot-Blancheville"},
    {"city": "Andilly-en-Bassigny"},
    {"city": "Annéville-la-Prairie"},
    {"city": "Annonville"},
    {"city": "Anrosey"},
    {"city": "Aprey"},
    {"city": "Arbigny-sous-Varennes"},
    {"city": "Arbot"},
    {"city": "Arc-en-Barrois"},
    {"city": "Arnancourt"},
    {"city": "Attancourt"},
    {"city": "Aubepierre-sur-Aube"},
    {"city": "Auberive"},
    {"city": "Audeloncourt"},
    {"city": "Aujeurres"},
    {"city": "Aulnoy-sur-Aube"},
    {"city": "Autigny-le-Grand"},
    {"city": "Autigny-le-Petit"},
    {"city": "Autreville-sur-la-Renne"},
    {"city": "Avrecourt"},
    {"city": "Bailly-aux-Forges"},
    {"city": "Baissey"},
    {"city": "Bannes"},
    {"city": "Bassoncourt"},
    {"city": "Baudrecourt"},
    {"city": "Bay-sur-Aube"},
    {"city": "Beauchemin"},
    {"city": "Belmont"},
    {"city": "Roches-Bettaincourt"},
    {"city": "Bettancourt-la-Ferrée"},
    {"city": "Beurville"},
    {"city": "Biesles"},
    {"city": "Bize"},
    {"city": "Blaisy"},
    {"city": "Blécourt"},
    {"city": "Blessonville"},
    {"city": "Blumeray"},
    {"city": "Bologne"},
    {"city": "Bonnecourt"},
    {"city": "Bourbonne-les-Bains"},
    {"city": "Bourdons-sur-Rognon"},
    {"city": "Bourg"},
    {"city": "Bourg-Sainte-Marie"},
    {"city": "Bourmont-entre-Meuse-et-Mouzon"},
    {"city": "Bouzancourt"},
    {"city": "Brachay"},
    {"city": "Brainville-sur-Meuse"},
    {"city": "Braux-le-Châtel"},
    {"city": "Brennes"},
    {"city": "Brethenay"},
    {"city": "Breuvannes-en-Bassigny"},
    {"city": "Briaucourt"},
    {"city": "Bricon"},
    {"city": "Brousseval"},
    {"city": "Bugnières"},
    {"city": "Champsevraine"},
    {"city": "Busson"},
    {"city": "Buxières-lès-Clefmont"},
    {"city": "Buxières-lès-Villiers"},
    {"city": "Ceffonds"},
    {"city": "Celles-en-Bassigny"},
    {"city": "Celsoy"},
    {"city": "Cerisières"},
    {"city": "Chalancey"},
    {"city": "Chalindrey"},
    {"city": "Vals-des-Tilles"},
    {"city": "Chalvraines"},
    {"city": "Chambroncourt"},
    {"city": "Chamouilley"},
    {"city": "Champigneulles-en-Bassigny"},
    {"city": "Champigny-lès-Langres"},
    {"city": "Champigny-sous-Varennes"},
    {"city": "Chancenay"},
    {"city": "Changey"},
    {"city": "Chanoy"},
    {"city": "Chantraines"},
    {"city": "Charmes"},
    {"city": "Charmes-en-l'Angle"},
    {"city": "Charmes-la-Grande"},
    {"city": "Chassigny"},
    {"city": "Châteauvillain"},
    {"city": "Chatenay-Mâcheron"},
    {"city": "Chatenay-Vaudin"},
    {"city": "Chatonrupt-Sommermont"},
    {"city": "Chaudenay"},
    {"city": "Chauffourt"},
    {"city": "Chaumont"},
    {"city": "Chaumont-la-Ville"},
    {"city": "Chevillon"},
    {"city": "Chézeaux"},
    {"city": "Chamarandes-Choignes"},
    {"city": "Choilley-Dardenay"},
    {"city": "Choiseul"},
    {"city": "Cirey-lès-Mareilles"},
    {"city": "Cirey-sur-Blaise"},
    {"city": "Cirfontaines-en-Azois"},
    {"city": "Cirfontaines-en-Ornois"},
    {"city": "Clefmont"},
    {"city": "Clinchamp"},
    {"city": "Cohons"},
    {"city": "Coiffy-le-Bas"},
    {"city": "Coiffy-le-Haut"},
    {"city": "Colmier-le-Bas"},
    {"city": "Colmier-le-Haut"},
    {"city": "Colombey les Deux Églises"},
    {"city": "Condes"},
    {"city": "Consigny"},
    {"city": "Coublanc"},
    {"city": "Coupray"},
    {"city": "Courcelles-en-Montagne"},
    {"city": "Courcelles-sur-Blaise"},
    {"city": "Cour-l'Évêque"},
    {"city": "Culmont"},
    {"city": "Curel"},
    {"city": "Curmont"},
    {"city": "Cusey"},
    {"city": "Cuves"},
    {"city": "Daillancourt"},
    {"city": "Daillecourt"},
    {"city": "Dammartin-sur-Meuse"},
    {"city": "Dampierre"},
    {"city": "Damrémont"},
    {"city": "Dancevoir"},
    {"city": "Darmannes"},
    {"city": "Dinteville"},
    {"city": "Domblain"},
    {"city": "Dommarien"},
    {"city": "Dommartin-le-Franc"},
    {"city": "Dommartin-le-Saint-Père"},
    {"city": "Domremy-Landéville"},
    {"city": "Doncourt-sur-Meuse"},
    {"city": "Donjeux"},
    {"city": "Doulaincourt-Saucourt"},
    {"city": "Doulevant-le-Château"},
    {"city": "Doulevant-le-Petit"},
    {"city": "Échenay"},
    {"city": "Éclaron-Braucourt-Sainte-Livière"},
    {"city": "Ecot-la-Combe"},
    {"city": "Effincourt"},
    {"city": "Enfonvelle"},
    {"city": "Épizon"},
    {"city": "Le Val-d'Esnoms"},
    {"city": "Esnouveaux"},
    {"city": "Euffigneix"},
    {"city": "Eurville-Bienville"},
    {"city": "Farincourt"},
    {"city": "Faverolles"},
    {"city": "Fayl-Billot"},
    {"city": "Fays"},
    {"city": "Ferrière-et-Lafolie"},
    {"city": "Flagey"},
    {"city": "Flammerécourt"},
    {"city": "Fontaines-sur-Marne"},
    {"city": "Forcey"},
    {"city": "Foulain"},
    {"city": "Frampas"},
    {"city": "Frécourt"},
    {"city": "Fresnes-sur-Apance"},
    {"city": "Froncles"},
    {"city": "Fronville"},
    {"city": "Genevrières"},
    {"city": "La Genevroye"},
    {"city": "Germaines"},
    {"city": "Germainvilliers"},
    {"city": "Germay"},
    {"city": "Germisay"},
    {"city": "Giey-sur-Aujon"},
    {"city": "Gillancourt"},
    {"city": "Gillaumé"},
    {"city": "Gilley"},
    {"city": "Graffigny-Chemin"},
    {"city": "Grandchamp"},
    {"city": "Grenant"},
    {"city": "Gudmont-Villiers"},
    {"city": "Guindrecourt-aux-Ormes"},
    {"city": "Guindrecourt-sur-Blaise"},
    {"city": "Guyonvelle"},
    {"city": "Hâcourt"},
    {"city": "Hallignicourt"},
    {"city": "Harréville-les-Chanteurs"},
    {"city": "Heuilley-le-Grand"},
    {"city": "Haute-Amance"},
    {"city": "Huilliécourt"},
    {"city": "Humbécourt"},
    {"city": "Humberville"},
    {"city": "Humes-Jorquenay"},
    {"city": "Illoud"},
    {"city": "Is-en-Bassigny"},
    {"city": "Isômes"},
    {"city": "Joinville"},
    {"city": "Jonchery"},
    {"city": "Juzennecourt"},
    {"city": "Lachapelle-en-Blaisy"},
    {"city": "Lafauche"},
    {"city": "Laferté-sur-Amance"},
    {"city": "Laferté-sur-Aube"},
    {"city": "Lamancine"},
    {"city": "Laneuvelle"},
    {"city": "Bayard-sur-Marne"},
    {"city": "Laneuville-à-Rémy"},
    {"city": "Laneuville-au-Pont"},
    {"city": "Langres"},
    {"city": "Lanques-sur-Rognon"},
    {"city": "Lanty-sur-Aube"},
    {"city": "Larivière-Arnoncourt"},
    {"city": "Latrecey-Ormoy-sur-Aube"},
    {"city": "Lavernoy"},
    {"city": "Laville-aux-Bois"},
    {"city": "Lavilleneuve"},
    {"city": "Lavilleneuve-au-Roi"},
    {"city": "Lecey"},
    {"city": "Leffonds"},
    {"city": "Leschères-sur-le-Blaiseron"},
    {"city": "Leuchey"},
    {"city": "Leurville"},
    {"city": "Levécourt"},
    {"city": "Lezéville"},
    {"city": "Liffol-le-Petit"},
    {"city": "Les Loges"},
    {"city": "Longchamp"},
    {"city": "Longeau-Percey"},
    {"city": "Louvemont"},
    {"city": "Louvières"},
    {"city": "Luzy-sur-Marne"},
    {"city": "Maâtz"},
    {"city": "Magneux"},
    {"city": "Maisoncelles"},
    {"city": "Maizières"},
    {"city": "Maizières-sur-Amance"},
    {"city": "Malaincourt-sur-Meuse"},
    {"city": "Mandres-la-Côte"},
    {"city": "Manois"},
    {"city": "Marac"},
    {"city": "Maranville"},
    {"city": "Marbéville"},
    {"city": "Marcilly-en-Bassigny"},
    {"city": "Mardor"},
    {"city": "Mareilles"},
    {"city": "Marnay-sur-Marne"},
    {"city": "Mathons"},
    {"city": "Melay"},
    {"city": "Mennouveaux"},
    {"city": "Merrey"},
    {"city": "Mertrud"},
    {"city": "Meures"},
    {"city": "Millières"},
    {"city": "Mirbel"},
    {"city": "Moëslains"},
    {"city": "Montcharvot"},
    {"city": "Montheries"},
    {"city": "La Porte du Der"},
    {"city": "Val-de-Meuse"},
    {"city": "Montot-sur-Rognon"},
    {"city": "Montreuil-sur-Blaise"},
    {"city": "Montreuil-sur-Thonnance"},
    {"city": "Morancourt"},
    {"city": "Morionvilliers"},
    {"city": "Mouilleron"},
    {"city": "Mussey-sur-Marne"},
    {"city": "Narcy"},
    {"city": "Neuilly-l'Évêque"},
    {"city": "Neuilly-sur-Suize"},
    {"city": "Neuvelle-lès-Voisey"},
    {"city": "Ninville"},
    {"city": "Nogent"},
    {"city": "Noidant-Chatenoy"},
    {"city": "Noidant-le-Rocheux"},
    {"city": "Nomécourt"},
    {"city": "Noncourt-sur-le-Rongeant"},
    {"city": "Noyers"},
    {"city": "Nully"},
    {"city": "Occey"},
    {"city": "Orbigny-au-Mont"},
    {"city": "Orbigny-au-Val"},
    {"city": "Orcevaux"},
    {"city": "Orges"},
    {"city": "Ormancey"},
    {"city": "Ormoy-lès-Sexfontaines"},
    {"city": "Orquevaux"},
    {"city": "Osne-le-Val"},
    {"city": "Oudincourt"},
    {"city": "Outremécourt"},
    {"city": "Ozières"},
    {"city": "Le Pailly"},
    {"city": "Palaiseul"},
    {"city": "Pansey"},
    {"city": "Parnoy-en-Bassigny"},
    {"city": "Paroy-sur-Saulx"},
    {"city": "Peigney"},
    {"city": "Perrancey-les-Vieux-Moulins"},
    {"city": "Perrogney-les-Fontaines"},
    {"city": "Perrusse"},
    {"city": "Perthes"},
    {"city": "Pierremont-sur-Amance"},
    {"city": "Pisseloup"},
    {"city": "Planrupt"},
    {"city": "Plesnoy"},
    {"city": "Poinsenot"},
    {"city": "Poinson-lès-Fayl"},
    {"city": "Poinson-lès-Grancey"},
    {"city": "Poinson-lès-Nogent"},
    {"city": "Poiseul"},
    {"city": "Poissons"},
    {"city": "Pont-la-Ville"},
    {"city": "Le Châtelet-sur-Meuse"},
    {"city": "Poulangy"},
    {"city": "Praslay"},
    {"city": "Le Montsaugeonnais"},
    {"city": "Pressigny"},
    {"city": "Prez-sous-Lafauche"},
    {"city": "Rives Dervoises"},
    {"city": "Rachecourt-Suzémont"},
    {"city": "Rachecourt-sur-Marne"},
    {"city": "Rançonnières"},
    {"city": "Rangecourt"},
    {"city": "Rennepont"},
    {"city": "Reynel"},
    {"city": "Riaucourt"},
    {"city": "Richebourg"},
    {"city": "Rimaucourt"},
    {"city": "Rivières-le-Bois"},
    {"city": "Rivière-les-Fosses"},
    {"city": "Rizaucourt-Buchey"},
    {"city": "Rochefort-sur-la-Côte"},
    {"city": "Roches-sur-Marne"},
    {"city": "Rochetaillée"},
    {"city": "Rolampont"},
    {"city": "Romain-sur-Meuse"},
    {"city": "Rouécourt"},
    {"city": "Rouelles"},
    {"city": "Rougeux"},
    {"city": "Rouvres-sur-Aube"},
    {"city": "Rouvroy-sur-Marne"},
    {"city": "Rupt"},
    {"city": "Sailly"},
    {"city": "Saint-Blin"},
    {"city": "Saint-Broingt-le-Bois"},
    {"city": "Saint-Broingt-les-Fosses"},
    {"city": "Saint-Ciergues"},
    {"city": "Saint-Dizier"},
    {"city": "Saints-Geosmes"},
    {"city": "Saint-Loup-sur-Aujon"},
    {"city": "Saint-Martin-lès-Langres"},
    {"city": "Saint-Maurice"},
    {"city": "Saint-Thiébault"},
    {"city": "Saint-Urbain-Maconcourt"},
    {"city": "Saint-Vallier-sur-Marne"},
    {"city": "Sarcey"},
    {"city": "Sarrey"},
    {"city": "Saudron"},
    {"city": "Saulles"},
    {"city": "Saulxures"},
    {"city": "Savigny"},
    {"city": "Semilly"},
    {"city": "Semoutiers-Montsaon"},
    {"city": "Serqueux"},
    {"city": "Sexfontaines"},
    {"city": "Signéville"},
    {"city": "Silvarouvres"},
    {"city": "Sommancourt"},
    {"city": "Sommerécourt"},
    {"city": "Sommevoire"},
    {"city": "Soncourt-sur-Marne"},
    {"city": "Soulaucourt-sur-Mouzon"},
    {"city": "Soyers"},
    {"city": "Suzannecourt"},
    {"city": "Ternat"},
    {"city": "Thilleux"},
    {"city": "Thivet"},
    {"city": "Thol-lès-Millières"},
    {"city": "Thonnance-lès-Joinville"},
    {"city": "Thonnance-les-Moulins"},
    {"city": "Torcenay"},
    {"city": "Tornay"},
    {"city": "Treix"},
    {"city": "Trémilly"},
    {"city": "Troisfontaines-la-Ville"},
    {"city": "Vaillant"},
    {"city": "Valcourt"},
    {"city": "Valleret"},
    {"city": "Valleroy"},
    {"city": "Varennes-sur-Amance"},
    {"city": "Vaudrecourt"},
    {"city": "Vaudrémont"},
    {"city": "Vauxbons"},
    {"city": "Vaux-sur-Blaise"},
    {"city": "Vaux-sur-Saint-Urbain"},
    {"city": "Vecqueville"},
    {"city": "Velles"},
    {"city": "Verbiesles"},
    {"city": "Verseilles-le-Bas"},
    {"city": "Verseilles-le-Haut"},
    {"city": "Vesaignes-sous-Lafauche"},
    {"city": "Vesaignes-sur-Marne"},
    {"city": "Vesvres-sous-Chalancey"},
    {"city": "Vicq"},
    {"city": "Viéville"},
    {"city": "Vignes-la-Côte"},
    {"city": "Vignory"},
    {"city": "Villars-en-Azois"},
    {"city": "Villars-Santenoge"},
    {"city": "Ville-en-Blaisois"},
    {"city": "Villegusien-le-Lac"},
    {"city": "Villiers-en-Lieu"},
    {"city": "Villiers-le-Sec"},
    {"city": "Villiers-lès-Aprey"},
    {"city": "Villiers-sur-Suize"},
    {"city": "Violot"},
    {"city": "Vitry-en-Montagne"},
    {"city": "Vitry-lès-Nogent"},
    {"city": "Vivey"},
    {"city": "Voillecomte"},
    {"city": "Voisey"},
    {"city": "Voisines"},
    {"city": "Voncourt"},
    {"city": "Vouécourt"},
    {"city": "Vraincourt"},
    {"city": "Vroncourt-la-Côte"},
    {"city": "Wassy"},
    {"city": "Ahuillé"},
    {"city": "Alexain"},
    {"city": "Ambrières-les-Vallées"},
    {"city": "Andouillé"},
    {"city": "Argentré"},
    {"city": "Aron"},
    {"city": "Arquenay"},
    {"city": "Assé-le-Bérenger"},
    {"city": "Astillé"},
    {"city": "Athée"},
    {"city": "Averton"},
    {"city": "La Baconnière"},
    {"city": "Bais"},
    {"city": "Val-du-Maine"},
    {"city": "Ballots"},
    {"city": "Bannes"},
    {"city": "La Bazoge-Montpinçon"},
    {"city": "La Bazouge-de-Chemeré"},
    {"city": "La Bazouge-des-Alleux"},
    {"city": "Bazougers"},
    {"city": "Beaulieu-sur-Oudon"},
    {"city": "Beaumont-Pied-de-Bœuf"},
    {"city": "Belgeard"},
    {"city": "Bierné-les-Villages"},
    {"city": "Le Bignon-du-Maine"},
    {"city": "La Bigottière"},
    {"city": "La Boissière"},
    {"city": "Bonchamp-lès-Laval"},
    {"city": "Bouchamps-lès-Craon"},
    {"city": "Bouère"},
    {"city": "Bouessay"},
    {"city": "Boulay-les-Ifs"},
    {"city": "Le Bourgneuf-la-Forêt"},
    {"city": "Bourgon"},
    {"city": "Brains-sur-les-Marches"},
    {"city": "Brecé"},
    {"city": "Brée"},
    {"city": "La Brûlatte"},
    {"city": "Le Buret"},
    {"city": "Carelles"},
    {"city": "Chailland"},
    {"city": "Châlons-du-Maine"},
    {"city": "Champéon"},
    {"city": "Champfrémont"},
    {"city": "Champgenéteux"},
    {"city": "Changé"},
    {"city": "Chantrigné"},
    {"city": "La Chapelle-Anthenaise"},
    {"city": "La Chapelle-au-Riboul"},
    {"city": "La Chapelle-Craonnaise"},
    {"city": "La Chapelle-Rainsouin"},
    {"city": "Charchigné"},
    {"city": "Château-Gontier-sur-Mayenne"},
    {"city": "Châtelain"},
    {"city": "Châtillon-sur-Colmont"},
    {"city": "Chemazé"},
    {"city": "Chémeré-le-Roi"},
    {"city": "Chérancé"},
    {"city": "Chevaigné-du-Maine"},
    {"city": "Colombiers-du-Plessis"},
    {"city": "Commer"},
    {"city": "Congrier"},
    {"city": "Contest"},
    {"city": "Cosmes"},
    {"city": "Cossé-en-Champagne"},
    {"city": "Cossé-le-Vivien"},
    {"city": "Coudray"},
    {"city": "Couesmes-Vaucé"},
    {"city": "Couptrain"},
    {"city": "Courbeveille"},
    {"city": "Courcité"},
    {"city": "Craon"},
    {"city": "Crennes-sur-Fraubée"},
    {"city": "La Croixille"},
    {"city": "La Cropte"},
    {"city": "Cuillé"},
    {"city": "Daon"},
    {"city": "Denazé"},
    {"city": "Désertines"},
    {"city": "La Dorée"},
    {"city": "Entrammes"},
    {"city": "Ernée"},
    {"city": "Évron"},
    {"city": "Fontaine-Couverte"},
    {"city": "Forcé"},
    {"city": "Fougerolles-du-Plessis"},
    {"city": "Fromentières"},
    {"city": "Gastines"},
    {"city": "Le Genest-Saint-Isle"},
    {"city": "Gennes-Longuefuye"},
    {"city": "Gesnes"},
    {"city": "Gesvres"},
    {"city": "Gorron"},
    {"city": "La Gravelle"},
    {"city": "Grazay"},
    {"city": "Grez-en-Bouère"},
    {"city": "La Haie-Traversaine"},
    {"city": "Le Ham"},
    {"city": "Hambers"},
    {"city": "Hardanges"},
    {"city": "Hercé"},
    {"city": "Le Horps"},
    {"city": "Houssay"},
    {"city": "Le Housseau-Brétignolles"},
    {"city": "L'Huisserie"},
    {"city": "Izé"},
    {"city": "Javron-les-Chapelles"},
    {"city": "Jublains"},
    {"city": "Juvigné"},
    {"city": "Prée-d'Anjou"},
    {"city": "Landivy"},
    {"city": "Larchamp"},
    {"city": "Lassay-les-Châteaux"},
    {"city": "Laubrières"},
    {"city": "Launay-Villiers"},
    {"city": "Laval"},
    {"city": "Lesbois"},
    {"city": "Levaré"},
    {"city": "Lignières-Orgères"},
    {"city": "Livet"},
    {"city": "Livré-la-Touche"},
    {"city": "La Roche-Neuville"},
    {"city": "Loiron-Ruillé"},
    {"city": "Loupfougères"},
    {"city": "Louverné"},
    {"city": "Louvigné"},
    {"city": "Madré"},
    {"city": "Maisoncelles-du-Maine"},
    {"city": "Marcillé-la-Ville"},
    {"city": "Marigné-Peuton"},
    {"city": "Martigné-sur-Mayenne"},
    {"city": "Mayenne"},
    {"city": "Mée"},
    {"city": "Ménil"},
    {"city": "Méral"},
    {"city": "Meslay-du-Maine"},
    {"city": "Mézangers"},
    {"city": "Montaudin"},
    {"city": "Montenay"},
    {"city": "Montflours"},
    {"city": "Montigné-le-Brillant"},
    {"city": "Montjean"},
    {"city": "Montreuil-Poulay"},
    {"city": "Montsûrs"},
    {"city": "Moulay"},
    {"city": "Neau"},
    {"city": "Neuilly-le-Vendin"},
    {"city": "Niafles"},
    {"city": "Nuillé-sur-Vicoin"},
    {"city": "Olivet"},
    {"city": "Oisseau"},
    {"city": "Origné"},
    {"city": "La Pallu"},
    {"city": "Parigné-sur-Braye"},
    {"city": "Parné-sur-Roc"},
    {"city": "Le Pas"},
    {"city": "La Pellerine"},
    {"city": "Peuton"},
    {"city": "Placé"},
    {"city": "Pommerieux"},
    {"city": "Pontmain"},
    {"city": "Port-Brillet"},
    {"city": "Préaux"},
    {"city": "Pré-en-Pail-Saint-Samson"},
    {"city": "Quelaines-Saint-Gault"},
    {"city": "Ravigny"},
    {"city": "Renazé"},
    {"city": "Rennes-en-Grenouilles"},
    {"city": "Le Ribay"},
    {"city": "La Roë"},
    {"city": "La Rouaudière"},
    {"city": "Ruillé-Froid-Fonds"},
    {"city": "Sacé"},
    {"city": "Saint-Aignan-de-Couptrain"},
    {"city": "Saint-Aignan-sur-Roë"},
    {"city": "Saint-Aubin-du-Désert"},
    {"city": "Saint-Aubin-Fosse-Louvain"},
    {"city": "Saint-Baudelle"},
    {"city": "Saint-Berthevin"},
    {"city": "Saint-Berthevin-la-Tannière"},
    {"city": "Saint-Brice"},
    {"city": "Saint-Calais-du-Désert"},
    {"city": "Saint-Charles-la-Forêt"},
    {"city": "Saint-Cyr-en-Pail"},
    {"city": "Saint-Cyr-le-Gravelais"},
    {"city": "Saint-Denis-d'Anjou"},
    {"city": "Saint-Denis-de-Gastines"},
    {"city": "Saint-Denis-du-Maine"},
    {"city": "Saint-Ellier-du-Maine"},
    {"city": "Saint-Erblon"},
    {"city": "Saint-Fraimbault-de-Prières"},
    {"city": "Sainte-Gemmes-le-Robert"},
    {"city": "Saint-Georges-Buttavent"},
    {"city": "Saint-Georges-le-Fléchard"},
    {"city": "Saint-Georges-sur-Erve"},
    {"city": "Saint-Germain-d'Anxure"},
    {"city": "Saint-Germain-de-Coulamer"},
    {"city": "Saint-Germain-le-Fouilloux"},
    {"city": "Saint-Germain-le-Guillaume"},
    {"city": "Saint-Hilaire-du-Maine"},
    {"city": "Blandouet-Saint Jean"},
    {"city": "Saint-Jean-sur-Mayenne"},
    {"city": "Saint-Julien-du-Terroux"},
    {"city": "Saint-Léger"},
    {"city": "Saint-Loup-du-Dorat"},
    {"city": "Saint-Loup-du-Gast"},
    {"city": "Sainte-Marie-du-Bois"},
    {"city": "Saint-Mars-du-Désert"},
    {"city": "Saint-Mars-sur-Colmont"},
    {"city": "Saint-Mars-sur-la-Futaie"},
    {"city": "Saint-Martin-de-Connée"},
    {"city": "Saint-Martin-du-Limet"},
    {"city": "Saint-Michel-de-la-Roë"},
    {"city": "Saint-Ouën-des-Toits"},
    {"city": "Saint-Pierre-des-Landes"},
    {"city": "Saint-Pierre-des-Nids"},
    {"city": "Saint-Pierre-la-Cour"},
    {"city": "Saint-Pierre-sur-Erve"},
    {"city": "Saint-Pierre-sur-Orthe"},
    {"city": "Saint-Poix"},
    {"city": "Saint-Quentin-les-Anges"},
    {"city": "Saint-Saturnin-du-Limet"},
    {"city": "Sainte-Suzanne-et-Chammes"},
    {"city": "Saint-Thomas-de-Courceriers"},
    {"city": "Saulges"},
    {"city": "La Selle-Craonnaise"},
    {"city": "Senonnes"},
    {"city": "Simplé"},
    {"city": "Soucé"},
    {"city": "Soulgé-sur-Ouette"},
    {"city": "Thubœuf"},
    {"city": "Thorigné-en-Charnie"},
    {"city": "Torcé-Viviers-en-Charnie"},
    {"city": "Trans"},
    {"city": "Vaiges"},
    {"city": "Vautorte"},
    {"city": "Vieuvy"},
    {"city": "Villaines-la-Juhel"},
    {"city": "Villepail"},
    {"city": "Villiers-Charlemagne"},
    {"city": "Vimarcé"},
    {"city": "Voutré"},
    {"city": "Abaucourt"},
    {"city": "Abbéville-lès-Conflans"},
    {"city": "Aboncourt"},
    {"city": "Affléville"},
    {"city": "Affracourt"},
    {"city": "Agincourt"},
    {"city": "Aingeray"},
    {"city": "Allain"},
    {"city": "Allamont"},
    {"city": "Allamps"},
    {"city": "Allondrelle-la-Malmaison"},
    {"city": "Amance"},
    {"city": "Amenoncourt"},
    {"city": "Ancerviller"},
    {"city": "Anderny"},
    {"city": "Andilly"},
    {"city": "Angomont"},
    {"city": "Anoux"},
    {"city": "Ansauville"},
    {"city": "Anthelupt"},
    {"city": "Armaucourt"},
    {"city": "Arnaville"},
    {"city": "Arracourt"},
    {"city": "Arraye-et-Han"},
    {"city": "Art-sur-Meurthe"},
    {"city": "Athienville"},
    {"city": "Atton"},
    {"city": "Auboué"},
    {"city": "Audun-le-Roman"},
    {"city": "Autrepierre"},
    {"city": "Autreville-sur-Moselle"},
    {"city": "Autrey"},
    {"city": "Avillers"},
    {"city": "Avrainville"},
    {"city": "Avricourt"},
    {"city": "Avril"},
    {"city": "Azelot"},
    {"city": "Azerailles"},
    {"city": "Baccarat"},
    {"city": "Badonviller"},
    {"city": "Bagneux"},
    {"city": "Bainville-aux-Miroirs"},
    {"city": "Bainville-sur-Madon"},
    {"city": "Barbas"},
    {"city": "Barbonville"},
    {"city": "Barisey-au-Plain"},
    {"city": "Barisey-la-Côte"},
    {"city": "Les Baroches"},
    {"city": "Baslieux"},
    {"city": "Bathelémont"},
    {"city": "Batilly"},
    {"city": "Battigny"},
    {"city": "Bauzemont"},
    {"city": "Bayon"},
    {"city": "Bayonville-sur-Mad"},
    {"city": "Bazailles"},
    {"city": "Beaumont"},
    {"city": "Béchamps"},
    {"city": "Belleau"},
    {"city": "Belleville"},
    {"city": "Bénaménil"},
    {"city": "Benney"},
    {"city": "Bernécourt"},
    {"city": "Bertrambois"},
    {"city": "Bertrichamps"},
    {"city": "Bettainvillers"},
    {"city": "Beuveille"},
    {"city": "Beuvezin"},
    {"city": "Beuvillers"},
    {"city": "Bey-sur-Seille"},
    {"city": "Bezange-la-Grande"},
    {"city": "Bezaumont"},
    {"city": "Bicqueley"},
    {"city": "Bienville-la-Petite"},
    {"city": "Bionville"},
    {"city": "Blainville-sur-l'Eau"},
    {"city": "Blâmont"},
    {"city": "Blémerey"},
    {"city": "Blénod-lès-Pont-à-Mousson"},
    {"city": "Blénod-lès-Toul"},
    {"city": "Boismont"},
    {"city": "Boncourt"},
    {"city": "Bonviller"},
    {"city": "Mont-Bonvillers"},
    {"city": "Borville"},
    {"city": "Boucq"},
    {"city": "Bouillonville"},
    {"city": "Bouvron"},
    {"city": "Bouxières-aux-Chênes"},
    {"city": "Bouxières-aux-Dames"},
    {"city": "Bouxières-sous-Froidmont"},
    {"city": "Bouzanville"},
    {"city": "Brainville"},
    {"city": "Bralleville"},
    {"city": "Bratte"},
    {"city": "Bréhain-la-Ville"},
    {"city": "Bréménil"},
    {"city": "Brémoncourt"},
    {"city": "Val de Briey"},
    {"city": "Brin-sur-Seille"},
    {"city": "Brouville"},
    {"city": "Bruley"},
    {"city": "Bruville"},
    {"city": "Buissoncourt"},
    {"city": "Bulligny"},
    {"city": "Bures"},
    {"city": "Buriville"},
    {"city": "Burthecourt-aux-Chênes"},
    {"city": "Ceintrey"},
    {"city": "Cerville"},
    {"city": "Chaligny"},
    {"city": "Chambley-Bussières"},
    {"city": "Champenoux"},
    {"city": "Champey-sur-Moselle"},
    {"city": "Champigneulles"},
    {"city": "Chanteheux"},
    {"city": "Chaouilley"},
    {"city": "Charency-Vezin"},
    {"city": "Charey"},
    {"city": "Charmes-la-Côte"},
    {"city": "Charmois"},
    {"city": "Chaudeney-sur-Moselle"},
    {"city": "Chavigny"},
    {"city": "Chazelles-sur-Albe"},
    {"city": "Chenevières"},
    {"city": "Chenicourt"},
    {"city": "Chenières"},
    {"city": "Choloy-Ménillot"},
    {"city": "Cirey-sur-Vezouze"},
    {"city": "Clayeures"},
    {"city": "Clémery"},
    {"city": "Clérey-sur-Brenon"},
    {"city": "Coincourt"},
    {"city": "Colmey"},
    {"city": "Colombey-les-Belles"},
    {"city": "Conflans-en-Jarnisy"},
    {"city": "Cons-la-Grandville"},
    {"city": "Cosnes-et-Romain"},
    {"city": "Courbesseaux"},
    {"city": "Courcelles"},
    {"city": "Coyviller"},
    {"city": "Crantenoy"},
    {"city": "Crépey"},
    {"city": "Crévéchamps"},
    {"city": "Crévic"},
    {"city": "Crézilles"},
    {"city": "Crion"},
    {"city": "Croismare"},
    {"city": "Crusnes"},
    {"city": "Custines"},
    {"city": "Cutry"},
    {"city": "Damelevières"},
    {"city": "Dampvitoux"},
    {"city": "Deneuvre"},
    {"city": "Deuxville"},
    {"city": "Diarville"},
    {"city": "Dieulouard"},
    {"city": "Dolcourt"},
    {"city": "Dombasle-sur-Meurthe"},
    {"city": "Domèvre-en-Haye"},
    {"city": "Domèvre-sur-Vezouze"},
    {"city": "Domgermain"},
    {"city": "Domjevin"},
    {"city": "Dommarie-Eulmont"},
    {"city": "Dommartemont"},
    {"city": "Dommartin-la-Chaussée"},
    {"city": "Dommartin-lès-Toul"},
    {"city": "Dommartin-sous-Amance"},
    {"city": "Domprix"},
    {"city": "Domptail-en-l'Air"},
    {"city": "Doncourt-lès-Conflans"},
    {"city": "Doncourt-lès-Longuyon"},
    {"city": "Drouville"},
    {"city": "Écrouves"},
    {"city": "Einvaux"},
    {"city": "Einville-au-Jard"},
    {"city": "Emberménil"},
    {"city": "Épiez-sur-Chiers"},
    {"city": "Éply"},
    {"city": "Erbéviller-sur-Amezule"},
    {"city": "Errouville"},
    {"city": "Essey-et-Maizerais"},
    {"city": "Essey-la-Côte"},
    {"city": "Essey-lès-Nancy"},
    {"city": "Étreval"},
    {"city": "Eulmont"},
    {"city": "Euvezin"},
    {"city": "Faulx"},
    {"city": "Favières"},
    {"city": "Fécocourt"},
    {"city": "Fenneviller"},
    {"city": "Ferrières"},
    {"city": "Fey-en-Haye"},
    {"city": "Fillières"},
    {"city": "Flainval"},
    {"city": "Flavigny-sur-Moselle"},
    {"city": "Fléville-devant-Nancy"},
    {"city": "Fléville-Lixières"},
    {"city": "Flin"},
    {"city": "Flirey"},
    {"city": "Fontenoy-la-Joûte"},
    {"city": "Fontenoy-sur-Moselle"},
    {"city": "Forcelles-Saint-Gorgon"},
    {"city": "Forcelles-sous-Gugney"},
    {"city": "Foug"},
    {"city": "Fraimbois"},
    {"city": "Fraisnes-en-Saintois"},
    {"city": "Francheville"},
    {"city": "Franconville"},
    {"city": "Fréménil"},
    {"city": "Frémonville"},
    {"city": "Fresnois-la-Montagne"},
    {"city": "Friauville"},
    {"city": "Frolois"},
    {"city": "Frouard"},
    {"city": "Froville"},
    {"city": "Gélacourt"},
    {"city": "Gélaucourt"},
    {"city": "Gellenoncourt"},
    {"city": "Gémonville"},
    {"city": "Gerbécourt-et-Haplemont"},
    {"city": "Gerbéviller"},
    {"city": "Germiny"},
    {"city": "Germonville"},
    {"city": "Gézoncourt"},
    {"city": "Gibeaumeix"},
    {"city": "Giraumont"},
    {"city": "Giriviller"},
    {"city": "Glonville"},
    {"city": "Gogney"},
    {"city": "Gondrecourt-Aix"},
    {"city": "Gondreville"},
    {"city": "Gondrexon"},
    {"city": "Gorcy"},
    {"city": "Goviller"},
    {"city": "Grand-Failly"},
    {"city": "Grimonviller"},
    {"city": "Gripport"},
    {"city": "Griscourt"},
    {"city": "Grosrouvres"},
    {"city": "Gugney"},
    {"city": "Gye"},
    {"city": "Hablainville"},
    {"city": "Hagéville"},
    {"city": "Haigneville"},
    {"city": "Halloville"},
    {"city": "Hammeville"},
    {"city": "Hamonville"},
    {"city": "Hannonville-Suzémont"},
    {"city": "Haraucourt"},
    {"city": "Harbouey"},
    {"city": "Haroué"},
    {"city": "Hatrize"},
    {"city": "Haucourt-Moulaine"},
    {"city": "Haudonville"},
    {"city": "Haussonville"},
    {"city": "Heillecourt"},
    {"city": "Hénaménil"},
    {"city": "Herbéviller"},
    {"city": "Hériménil"},
    {"city": "Herserange"},
    {"city": "Hoéville"},
    {"city": "Homécourt"},
    {"city": "Houdelmont"},
    {"city": "Houdemont"},
    {"city": "Houdreville"},
    {"city": "Housséville"},
    {"city": "Hudiviller"},
    {"city": "Hussigny-Godbrange"},
    {"city": "Igney"},
    {"city": "Jaillon"},
    {"city": "Jarny"},
    {"city": "Jarville-la-Malgrange"},
    {"city": "Jaulny"},
    {"city": "Jeandelaincourt"},
    {"city": "Jeandelize"},
    {"city": "Jevoncourt"},
    {"city": "Jezainville"},
    {"city": "Jœuf"},
    {"city": "Jolivet"},
    {"city": "Joppécourt"},
    {"city": "Jouaville"},
    {"city": "Joudreville"},
    {"city": "Juvrecourt"},
    {"city": "Labry"},
    {"city": "Lachapelle"},
    {"city": "Lagney"},
    {"city": "Laître-sous-Amance"},
    {"city": "Laix"},
    {"city": "Lalœuf"},
    {"city": "Lamath"},
    {"city": "Landécourt"},
    {"city": "Landremont"},
    {"city": "Landres"},
    {"city": "Laneuvelotte"},
    {"city": "Laneuveville-aux-Bois"},
    {"city": "Laneuveville-derrière-Foug"},
    {"city": "Laneuveville-devant-Bayon"},
    {"city": "Laneuveville-devant-Nancy"},
    {"city": "Lanfroicourt"},
    {"city": "Lantéfontaine"},
    {"city": "Laronxe"},
    {"city": "Laxou"},
    {"city": "Lay-Saint-Christophe"},
    {"city": "Lay-Saint-Remy"},
    {"city": "Lebeuville"},
    {"city": "Leintrey"},
    {"city": "Lemainville"},
    {"city": "Leménil-Mitry"},
    {"city": "Lenoncourt"},
    {"city": "Lesménils"},
    {"city": "Létricourt"},
    {"city": "Lexy"},
    {"city": "Leyr"},
    {"city": "Limey-Remenauville"},
    {"city": "Lironville"},
    {"city": "Liverdun"},
    {"city": "Loisy"},
    {"city": "Longlaville"},
    {"city": "Longuyon"},
    {"city": "Longwy"},
    {"city": "Lorey"},
    {"city": "Loromontzey"},
    {"city": "Lubey"},
    {"city": "Lucey"},
    {"city": "Ludres"},
    {"city": "Lunéville"},
    {"city": "Lupcourt"},
    {"city": "Magnières"},
    {"city": "Maidières"},
    {"city": "Mailly-sur-Seille"},
    {"city": "Mairy-Mainville"},
    {"city": "Maixe"},
    {"city": "Maizières"},
    {"city": "Malavillers"},
    {"city": "Malleloy"},
    {"city": "Malzéville"},
    {"city": "Mamey"},
    {"city": "Mandres-aux-Quatre-Tours"},
    {"city": "Mangonville"},
    {"city": "Manoncourt-en-Vermois"},
    {"city": "Manoncourt-en-Woëvre"},
    {"city": "Manonville"},
    {"city": "Manonviller"},
    {"city": "Marainviller"},
    {"city": "Marbache"},
    {"city": "Maron"},
    {"city": "Mars-la-Tour"},
    {"city": "Marthemont"},
    {"city": "Martincourt"},
    {"city": "Mattexey"},
    {"city": "Maxéville"},
    {"city": "Mazerulles"},
    {"city": "Méhoncourt"},
    {"city": "Ménil-la-Tour"},
    {"city": "Mercy-le-Bas"},
    {"city": "Mercy-le-Haut"},
    {"city": "Méréville"},
    {"city": "Merviller"},
    {"city": "Messein"},
    {"city": "Mexy"},
    {"city": "Mignéville"},
    {"city": "Millery"},
    {"city": "Minorville"},
    {"city": "Moineville"},
    {"city": "Moivrons"},
    {"city": "Moncel-lès-Lunéville"},
    {"city": "Moncel-sur-Seille"},
    {"city": "Montauville"},
    {"city": "Montenoy"},
    {"city": "Montigny"},
    {"city": "Montigny-sur-Chiers"},
    {"city": "Mont-l'Étroit"},
    {"city": "Mont-le-Vignoble"},
    {"city": "Montreux"},
    {"city": "Mont-Saint-Martin"},
    {"city": "Mont-sur-Meurthe"},
    {"city": "Morfontaine"},
    {"city": "Moriviller"},
    {"city": "Morville-sur-Seille"},
    {"city": "Mouacourt"},
    {"city": "Mouaville"},
    {"city": "Mousson"},
    {"city": "Moutiers"},
    {"city": "Moutrot"},
    {"city": "Moyen"},
    {"city": "Murville"},
    {"city": "Nancy"},
    {"city": "Neufmaisons"},
    {"city": "Neuves-Maisons"},
    {"city": "Neuviller-lès-Badonviller"},
    {"city": "Neuviller-sur-Moselle"},
    {"city": "Nomeny"},
    {"city": "Nonhigny"},
    {"city": "Norroy-le-Sec"},
    {"city": "Norroy-lès-Pont-à-Mousson"},
    {"city": "Noviant-aux-Prés"},
    {"city": "Ochey"},
    {"city": "Ogéviller"},
    {"city": "Ognéville"},
    {"city": "Olley"},
    {"city": "Omelmont"},
    {"city": "Onville"},
    {"city": "Ormes-et-Ville"},
    {"city": "Othe"},
    {"city": "Ozerailles"},
    {"city": "Pagney-derrière-Barine"},
    {"city": "Pagny-sur-Moselle"},
    {"city": "Pannes"},
    {"city": "Parey-Saint-Césaire"},
    {"city": "Parroy"},
    {"city": "Parux"},
    {"city": "Petit-Failly"},
    {"city": "Petitmont"},
    {"city": "Pettonville"},
    {"city": "Pexonne"},
    {"city": "Phlin"},
    {"city": "Piennes"},
    {"city": "Pierre-la-Treiche"},
    {"city": "Pierre-Percée"},
    {"city": "Pierrepont"},
    {"city": "Pierreville"},
    {"city": "Pompey"},
    {"city": "Pont-à-Mousson"},
    {"city": "Pont-Saint-Vincent"},
    {"city": "Port-sur-Seille"},
    {"city": "Praye"},
    {"city": "Prény"},
    {"city": "Preutin-Higny"},
    {"city": "Pulligny"},
    {"city": "Pulney"},
    {"city": "Pulnoy"},
    {"city": "Puxe"},
    {"city": "Puxieux"},
    {"city": "Quevilloncourt"},
    {"city": "Raon-lès-Leau"},
    {"city": "Raucourt"},
    {"city": "Raville-sur-Sânon"},
    {"city": "Réchicourt-la-Petite"},
    {"city": "Réclonville"},
    {"city": "Rehainviller"},
    {"city": "Reherrey"},
    {"city": "Réhon"},
    {"city": "Reillon"},
    {"city": "Rembercourt-sur-Mad"},
    {"city": "Remenoville"},
    {"city": "Réméréville"},
    {"city": "Remoncourt"},
    {"city": "Repaix"},
    {"city": "Richardménil"},
    {"city": "Rogéville"},
    {"city": "Romain"},
    {"city": "Rosières-aux-Salines"},
    {"city": "Rosières-en-Haye"},
    {"city": "Rouves"},
    {"city": "Roville-devant-Bayon"},
    {"city": "Royaumeix"},
    {"city": "Rozelieures"},
    {"city": "Saffais"},
    {"city": "Saint-Ail"},
    {"city": "Saint-Baussant"},
    {"city": "Saint-Boingt"},
    {"city": "Saint-Clément"},
    {"city": "Saint-Firmin"},
    {"city": "Sainte-Geneviève"},
    {"city": "Saint-Germain"},
    {"city": "Saint-Jean-lès-Longuyon"},
    {"city": "Saint-Julien-lès-Gorze"},
    {"city": "Saint-Marcel"},
    {"city": "Saint-Mard"},
    {"city": "Saint-Martin"},
    {"city": "Saint-Maurice-aux-Forges"},
    {"city": "Saint-Max"},
    {"city": "Saint-Nicolas-de-Port"},
    {"city": "Sainte-Pôle"},
    {"city": "Saint-Pancré"},
    {"city": "Saint-Remimont"},
    {"city": "Saint-Rémy-aux-Bois"},
    {"city": "Saint-Sauveur"},
    {"city": "Saint-Supplet"},
    {"city": "Saizerais"},
    {"city": "Sancy"},
    {"city": "Sanzey"},
    {"city": "Saulnes"},
    {"city": "Saulxerotte"},
    {"city": "Saulxures-lès-Nancy"},
    {"city": "Saulxures-lès-Vannes"},
    {"city": "Saxon-Sion"},
    {"city": "Seichamps"},
    {"city": "Seicheprey"},
    {"city": "Selaincourt"},
    {"city": "Seranville"},
    {"city": "Serres"},
    {"city": "Serrouville"},
    {"city": "Sexey-aux-Forges"},
    {"city": "Sionviller"},
    {"city": "Sivry"},
    {"city": "Sommerviller"},
    {"city": "Sornéville"},
    {"city": "Sponville"},
    {"city": "Tanconville"},
    {"city": "Tantonville"},
    {"city": "Tellancourt"},
    {"city": "Thélod"},
    {"city": "They-sous-Vaudemont"},
    {"city": "Thézey-Saint-Martin"},
    {"city": "Thiaucourt-Regniéville"},
    {"city": "Thiaville-sur-Meurthe"},
    {"city": "Thiébauménil"},
    {"city": "Thil"},
    {"city": "Thorey-Lyautey"},
    {"city": "Thuilley-aux-Groseilles"},
    {"city": "Thumeréville"},
    {"city": "Tiercelet"},
    {"city": "Tomblaine"},
    {"city": "Tonnoy"},
    {"city": "Toul"},
    {"city": "Tramont-Émy"},
    {"city": "Tramont-Lassus"},
    {"city": "Tramont-Saint-André"},
    {"city": "Tremblecourt"},
    {"city": "Trieux"},
    {"city": "Trondes"},
    {"city": "Tronville"},
    {"city": "Tucquegnieux"},
    {"city": "Ugny"},
    {"city": "Uruffe"},
    {"city": "Vacqueville"},
    {"city": "Val-et-Châtillon"},
    {"city": "Valhey"},
    {"city": "Valleroy"},
    {"city": "Vallois"},
    {"city": "Vandelainville"},
    {"city": "Vandeléville"},
    {"city": "Vandières"},
    {"city": "Vandœuvre-lès-Nancy"},
    {"city": "Vannes-le-Châtel"},
    {"city": "Varangéville"},
    {"city": "Vathiménil"},
    {"city": "Vaucourt"},
    {"city": "Vaudémont"},
    {"city": "Vaudeville"},
    {"city": "Vaudigny"},
    {"city": "Vaxainville"},
    {"city": "Vého"},
    {"city": "Bois-de-Haye"},
    {"city": "Velaine-sous-Amance"},
    {"city": "Velle-sur-Moselle"},
    {"city": "Veney"},
    {"city": "Vennezey"},
    {"city": "Verdenal"},
    {"city": "Vézelise"},
    {"city": "Viéville-en-Haye"},
    {"city": "Vigneulles"},
    {"city": "Vilcey-sur-Trey"},
    {"city": "Villacourt"},
    {"city": "Ville-au-Montois"},
    {"city": "Ville-au-Val"},
    {"city": "Villecey-sur-Mad"},
    {"city": "Ville-en-Vermois"},
    {"city": "Ville-Houdlémont"},
    {"city": "Villers-en-Haye"},
    {"city": "Villers-la-Chèvre"},
    {"city": "Villers-la-Montagne"},
    {"city": "Villers-le-Rond"},
    {"city": "Villers-lès-Moivrons"},
    {"city": "Villers-lès-Nancy"},
    {"city": "Villers-sous-Prény"},
    {"city": "Villerupt"},
    {"city": "Ville-sur-Yron"},
    {"city": "Villette"},
    {"city": "Villey-le-Sec"},
    {"city": "Villey-Saint-Étienne"},
    {"city": "Virecourt"},
    {"city": "Viterne"},
    {"city": "Vitrey"},
    {"city": "Vitrimont"},
    {"city": "Vittonville"},
    {"city": "Viviers-sur-Chiers"},
    {"city": "Voinémont"},
    {"city": "Vroncourt"},
    {"city": "Waville"},
    {"city": "Xammes"},
    {"city": "Xermaménil"},
    {"city": "Xeuilley"},
    {"city": "Xirocourt"},
    {"city": "Xivry-Circourt"},
    {"city": "Xonville"},
    {"city": "Xousse"},
    {"city": "Xures"},
    {"city": "Han-devant-Pierrepont"},
    {"city": "Abainville"},
    {"city": "Abaucourt-Hautecourt"},
    {"city": "Aincreville"},
    {"city": "Amanty"},
    {"city": "Ambly-sur-Meuse"},
    {"city": "Amel-sur-l'Étang"},
    {"city": "Ancemont"},
    {"city": "Ancerville"},
    {"city": "Andernay"},
    {"city": "Apremont-la-Forêt"},
    {"city": "Arrancy-sur-Crusne"},
    {"city": "Aubréville"},
    {"city": "Aulnois-en-Perthois"},
    {"city": "Autrécourt-sur-Aire"},
    {"city": "Autréville-Saint-Lambert"},
    {"city": "Avillers-Sainte-Croix"},
    {"city": "Avioth"},
    {"city": "Avocourt"},
    {"city": "Azannes-et-Soumazannes"},
    {"city": "Baâlon"},
    {"city": "Badonvilliers-Gérauvilliers"},
    {"city": "Bannoncourt"},
    {"city": "Bantheville"},
    {"city": "Bar-le-Duc"},
    {"city": "Baudonvilliers"},
    {"city": "Baudrémont"},
    {"city": "Baulny"},
    {"city": "Bazeilles-sur-Othain"},
    {"city": "Bazincourt-sur-Saulx"},
    {"city": "Beauclair"},
    {"city": "Beaufort-en-Argonne"},
    {"city": "Beaulieu-en-Argonne"},
    {"city": "Beaumont-en-Verdunois"},
    {"city": "Beausite"},
    {"city": "Behonne"},
    {"city": "Belleray"},
    {"city": "Belleville-sur-Meuse"},
    {"city": "Belrain"},
    {"city": "Belrupt-en-Verdunois"},
    {"city": "Beney-en-Woëvre"},
    {"city": "Béthelainville"},
    {"city": "Béthincourt"},
    {"city": "Beurey-sur-Saulx"},
    {"city": "Bezonvaux"},
    {"city": "Biencourt-sur-Orge"},
    {"city": "Billy-sous-Mangiennes"},
    {"city": "Bislée"},
    {"city": "Blanzée"},
    {"city": "Boinville-en-Woëvre"},
    {"city": "Boncourt-sur-Meuse"},
    {"city": "Bonnet"},
    {"city": "Bonzée"},
    {"city": "Le Bouchon-sur-Saulx"},
    {"city": "Bouconville-sur-Madt"},
    {"city": "Bouligny"},
    {"city": "Bouquemont"},
    {"city": "Boureuilles"},
    {"city": "Bovée-sur-Barboure"},
    {"city": "Boviolles"},
    {"city": "Brabant-en-Argonne"},
    {"city": "Brabant-le-Roi"},
    {"city": "Brabant-sur-Meuse"},
    {"city": "Brandeville"},
    {"city": "Braquis"},
    {"city": "Bras-sur-Meuse"},
    {"city": "Brauvilliers"},
    {"city": "Bréhéville"},
    {"city": "Breux"},
    {"city": "Brieulles-sur-Meuse"},
    {"city": "Brillon-en-Barrois"},
    {"city": "Brixey-aux-Chanoines"},
    {"city": "Brizeaux"},
    {"city": "Brocourt-en-Argonne"},
    {"city": "Brouennes"},
    {"city": "Broussey-en-Blois"},
    {"city": "Broussey-Raulecourt"},
    {"city": "Bure"},
    {"city": "Burey-en-Vaux"},
    {"city": "Burey-la-Côte"},
    {"city": "Buxières-sous-les-Côtes"},
    {"city": "Buzy-Darmont"},
    {"city": "Cesse"},
    {"city": "Chaillon"},
    {"city": "Chalaines"},
    {"city": "Champneuville"},
    {"city": "Champougny"},
    {"city": "Chardogne"},
    {"city": "Charny-sur-Meuse"},
    {"city": "Charpentry"},
    {"city": "Chassey-Beaupré"},
    {"city": "Châtillon-sous-les-Côtes"},
    {"city": "Chattancourt"},
    {"city": "Chaumont-devant-Damvillers"},
    {"city": "Chaumont-sur-Aire"},
    {"city": "Chauvency-le-Château"},
    {"city": "Chauvency-Saint-Hubert"},
    {"city": "Chauvoncourt"},
    {"city": "Cheppy"},
    {"city": "Chonville-Malaumont"},
    {"city": "Cierges-sous-Montfaucon"},
    {"city": "Le Claon"},
    {"city": "Clermont-en-Argonne"},
    {"city": "Cléry-le-Grand"},
    {"city": "Cléry-le-Petit"},
    {"city": "Combles-en-Barrois"},
    {"city": "Combres-sous-les-Côtes"},
    {"city": "Commercy"},
    {"city": "Les Hauts-de-Chée"},
    {"city": "Consenvoye"},
    {"city": "Contrisson"},
    {"city": "Courcelles-en-Barrois"},
    {"city": "Courcelles-sur-Aire"},
    {"city": "Courouvre"},
    {"city": "Cousances-les-Forges"},
    {"city": "Couvertpuis"},
    {"city": "Couvonges"},
    {"city": "Cuisy"},
    {"city": "Culey"},
    {"city": "Cumières-le-Mort-Homme"},
    {"city": "Cunel"},
    {"city": "Dagonville"},
    {"city": "Dainville-Bertheléville"},
    {"city": "Damloup"},
    {"city": "Dammarie-sur-Saulx"},
    {"city": "Damvillers"},
    {"city": "Dannevoux"},
    {"city": "Delouze-Rosières"},
    {"city": "Delut"},
    {"city": "Demange-Baudignécourt"},
    {"city": "Dieppe-sous-Douaumont"},
    {"city": "Dieue-sur-Meuse"},
    {"city": "Dombasle-en-Argonne"},
    {"city": "Dombras"},
    {"city": "Dommartin-la-Montagne"},
    {"city": "Dommary-Baroncourt"},
    {"city": "Dompcevrin"},
    {"city": "Dompierre-aux-Bois"},
    {"city": "Domremy-la-Canne"},
    {"city": "Doncourt-aux-Templiers"},
    {"city": "Doulcon"},
    {"city": "Dugny-sur-Meuse"},
    {"city": "Dun-sur-Meuse"},
    {"city": "Duzey"},
    {"city": "Écouviez"},
    {"city": "Écurey-en-Verdunois"},
    {"city": "Eix"},
    {"city": "Les Éparges"},
    {"city": "Épiez-sur-Meuse"},
    {"city": "Épinonville"},
    {"city": "Érize-la-Brûlée"},
    {"city": "Érize-la-Petite"},
    {"city": "Érize-Saint-Dizier"},
    {"city": "Erneville-aux-Bois"},
    {"city": "Esnes-en-Argonne"},
    {"city": "Étain"},
    {"city": "Éton"},
    {"city": "Étraye"},
    {"city": "Euville"},
    {"city": "Èvres"},
    {"city": "Fains-Véel"},
    {"city": "Flassigny"},
    {"city": "Fleury-devant-Douaumont"},
    {"city": "Foameix-Ornel"},
    {"city": "Fontaines-Saint-Clair"},
    {"city": "Forges-sur-Meuse"},
    {"city": "Foucaucourt-sur-Thabas"},
    {"city": "Fouchères-aux-Bois"},
    {"city": "Frémeréville-sous-les-Côtes"},
    {"city": "Fresnes-au-Mont"},
    {"city": "Fresnes-en-Woëvre"},
    {"city": "Froidos"},
    {"city": "Fromeréville-les-Vallons"},
    {"city": "Fromezey"},
    {"city": "Futeau"},
    {"city": "Génicourt-sur-Meuse"},
    {"city": "Gercourt-et-Drillancourt"},
    {"city": "Géry"},
    {"city": "Gesnes-en-Argonne"},
    {"city": "Gimécourt"},
    {"city": "Gincrey"},
    {"city": "Girauvoisin"},
    {"city": "Givrauval"},
    {"city": "Gondrecourt-le-Château"},
    {"city": "Gouraincourt"},
    {"city": "Goussaincourt"},
    {"city": "Gremilly"},
    {"city": "Grimaucourt-en-Woëvre"},
    {"city": "Grimaucourt-près-Sampigny"},
    {"city": "Guerpont"},
    {"city": "Gussainville"},
    {"city": "Haironville"},
    {"city": "Halles-sous-les-Côtes"},
    {"city": "Han-lès-Juvigny"},
    {"city": "Hannonville-sous-les-Côtes"},
    {"city": "Han-sur-Meuse"},
    {"city": "Harville"},
    {"city": "Haudainville"},
    {"city": "Haudiomont"},
    {"city": "Haumont-près-Samogneux"},
    {"city": "Heippes"},
    {"city": "Hennemont"},
    {"city": "Herbeuville"},
    {"city": "Herméville-en-Woëvre"},
    {"city": "Heudicourt-sous-les-Côtes"},
    {"city": "Hévilliers"},
    {"city": "Horville-en-Ornois"},
    {"city": "Houdelaincourt"},
    {"city": "Inor"},
    {"city": "Ippécourt"},
    {"city": "Iré-le-Sec"},
    {"city": "Les Islettes"},
    {"city": "Les Trois-Domaines"},
    {"city": "Jametz"},
    {"city": "Jonville-en-Woëvre"},
    {"city": "Jouy-en-Argonne"},
    {"city": "Geville"},
    {"city": "Julvécourt"},
    {"city": "Juvigny-en-Perthois"},
    {"city": "Juvigny-sur-Loison"},
    {"city": "Kœur-la-Grande"},
    {"city": "Kœur-la-Petite"},
    {"city": "Labeuville"},
    {"city": "Lachalade"},
    {"city": "Lachaussée"},
    {"city": "Lacroix-sur-Meuse"},
    {"city": "Lahaymeix"},
    {"city": "Lahayville"},
    {"city": "Laheycourt"},
    {"city": "Laimont"},
    {"city": "Lamorville"},
    {"city": "Lamouilly"},
    {"city": "Landrecourt-Lempire"},
    {"city": "Laneuville-au-Rupt"},
    {"city": "Laneuville-sur-Meuse"},
    {"city": "Lanhères"},
    {"city": "Latour-en-Woëvre"},
    {"city": "Lavallée"},
    {"city": "Lavincourt"},
    {"city": "Lavoye"},
    {"city": "Lemmes"},
    {"city": "Lérouville"},
    {"city": "Levoncourt"},
    {"city": "Lignières-sur-Aire"},
    {"city": "Ligny-en-Barrois"},
    {"city": "Liny-devant-Dun"},
    {"city": "Lion-devant-Dun"},
    {"city": "Lisle-en-Barrois"},
    {"city": "L'Isle-en-Rigault"},
    {"city": "Lissey"},
    {"city": "Loisey"},
    {"city": "Loison"},
    {"city": "Longeaux"},
    {"city": "Longchamps-sur-Aire"},
    {"city": "Longeville-en-Barrois"},
    {"city": "Loupmont"},
    {"city": "Louppy-le-Château"},
    {"city": "Louppy-sur-Loison"},
    {"city": "Louvemont-Côte-du-Poivre"},
    {"city": "Luzy-Saint-Martin"},
    {"city": "Maizeray"},
    {"city": "Maizey"},
    {"city": "Malancourt"},
    {"city": "Mandres-en-Barrois"},
    {"city": "Mangiennes"},
    {"city": "Manheulles"},
    {"city": "Marchéville-en-Woëvre"},
    {"city": "Marre"},
    {"city": "Marson-sur-Barboure"},
    {"city": "Martincourt-sur-Meuse"},
    {"city": "Marville"},
    {"city": "Maucourt-sur-Orne"},
    {"city": "Maulan"},
    {"city": "Mauvages"},
    {"city": "Maxey-sur-Vaise"},
    {"city": "Mécrin"},
    {"city": "Méligny-le-Grand"},
    {"city": "Méligny-le-Petit"},
    {"city": "Menaucourt"},
    {"city": "Ménil-aux-Bois"},
    {"city": "Ménil-la-Horgne"},
    {"city": "Ménil-sur-Saulx"},
    {"city": "Merles-sur-Loison"},
    {"city": "Milly-sur-Bradon"},
    {"city": "Mogeville"},
    {"city": "Mognéville"},
    {"city": "Moirey-Flabas-Crépion"},
    {"city": "Montblainville"},
    {"city": "Montbras"},
    {"city": "Mont-devant-Sassey"},
    {"city": "Montfaucon-d'Argonne"},
    {"city": "Les Monthairons"},
    {"city": "Montiers-sur-Saulx"},
    {"city": "Montigny-devant-Sassey"},
    {"city": "Montigny-lès-Vaucouleurs"},
    {"city": "Montmédy"},
    {"city": "Montplonne"},
    {"city": "Montsec"},
    {"city": "Montzéville"},
    {"city": "Moranville"},
    {"city": "Morgemoulin"},
    {"city": "Chanteraine"},
    {"city": "Morley"},
    {"city": "Mouilly"},
    {"city": "Moulainville"},
    {"city": "Moulins-Saint-Hubert"},
    {"city": "Moulotte"},
    {"city": "Mouzay"},
    {"city": "Murvaux"},
    {"city": "Val-d'Ornain"},
    {"city": "Muzeray"},
    {"city": "Naives-en-Blois"},
    {"city": "Naives-Rosières"},
    {"city": "Naix-aux-Forges"},
    {"city": "Nançois-le-Grand"},
    {"city": "Nançois-sur-Ornain"},
    {"city": "Nant-le-Grand"},
    {"city": "Nant-le-Petit"},
    {"city": "Nantillois"},
    {"city": "Nantois"},
    {"city": "Nepvant"},
    {"city": "Nettancourt"},
    {"city": "Le Neufour"},
    {"city": "Neuville-en-Verdunois"},
    {"city": "Neuville-lès-Vaucouleurs"},
    {"city": "Neuville-sur-Ornain"},
    {"city": "Neuvilly-en-Argonne"},
    {"city": "Nicey-sur-Aire"},
    {"city": "Nixéville-Blercourt"},
    {"city": "Nonsard-Lamarche"},
    {"city": "Nouillonpont"},
    {"city": "Noyers-Auzécourt"},
    {"city": "Nubécourt"},
    {"city": "Olizy-sur-Chiers"},
    {"city": "Ornes"},
    {"city": "Osches"},
    {"city": "Ourches-sur-Meuse"},
    {"city": "Pagny-la-Blanche-Côte"},
    {"city": "Pagny-sur-Meuse"},
    {"city": "Pareid"},
    {"city": "Parfondrupt"},
    {"city": "Les Paroches"},
    {"city": "Peuvillers"},
    {"city": "Pierrefitte-sur-Aire"},
    {"city": "Pillon"},
    {"city": "Pintheville"},
    {"city": "Pont-sur-Meuse"},
    {"city": "Pouilly-sur-Meuse"},
    {"city": "Pretz-en-Argonne"},
    {"city": "Quincy-Landzécourt"},
    {"city": "Rambluzin-et-Benoite-Vaux"},
    {"city": "Rambucourt"},
    {"city": "Rancourt-sur-Ornain"},
    {"city": "Ranzières"},
    {"city": "Rarécourt"},
    {"city": "Récicourt"},
    {"city": "Récourt-le-Creux"},
    {"city": "Reffroy"},
    {"city": "Regnéville-sur-Meuse"},
    {"city": "Rembercourt-Sommaisne"},
    {"city": "Remennecourt"},
    {"city": "Remoiville"},
    {"city": "Resson"},
    {"city": "Revigny-sur-Ornain"},
    {"city": "Réville-aux-Bois"},
    {"city": "Riaville"},
    {"city": "Ribeaucourt"},
    {"city": "Richecourt"},
    {"city": "Rigny-la-Salle"},
    {"city": "Rigny-Saint-Martin"},
    {"city": "Robert-Espagne"},
    {"city": "Les Roises"},
    {"city": "Romagne-sous-les-Côtes"},
    {"city": "Romagne-sous-Montfaucon"},
    {"city": "Ronvaux"},
    {"city": "Raival"},
    {"city": "Rouvres-en-Woëvre"},
    {"city": "Rouvrois-sur-Meuse"},
    {"city": "Rouvrois-sur-Othain"},
    {"city": "Rumont"},
    {"city": "Rupt-aux-Nonains"},
    {"city": "Rupt-devant-Saint-Mihiel"},
    {"city": "Rupt-en-Woëvre"},
    {"city": "Rupt-sur-Othain"},
    {"city": "Saint-Amand-sur-Ornain"},
    {"city": "Saint-André-en-Barrois"},
    {"city": "Saint-Aubin-sur-Aire"},
    {"city": "Saint-Germain-sur-Meuse"},
    {"city": "Saint-Hilaire-en-Woëvre"},
    {"city": "Saint-Jean-lès-Buzy"},
    {"city": "Saint-Joire"},
    {"city": "Saint-Julien-sous-les-Côtes"},
    {"city": "Saint-Laurent-sur-Othain"},
    {"city": "Saint-Maurice-sous-les-Côtes"},
    {"city": "Saint-Mihiel"},
    {"city": "Saint-Pierrevillers"},
    {"city": "Saint-Remy-la-Calonne"},
    {"city": "Salmagne"},
    {"city": "Sampigny"},
    {"city": "Samogneux"},
    {"city": "Sassey-sur-Meuse"},
    {"city": "Saudrupt"},
    {"city": "Saulmory-Villefranche"},
    {"city": "Saulvaux"},
    {"city": "Saulx-lès-Champlon"},
    {"city": "Sauvigny"},
    {"city": "Sauvoy"},
    {"city": "Savonnières-devant-Bar"},
    {"city": "Savonnières-en-Perthois"},
    {"city": "Seigneulles"},
    {"city": "Senon"},
    {"city": "Senoncourt-les-Maujouy"},
    {"city": "Septsarges"},
    {"city": "Sepvigny"},
    {"city": "Seuzey"},
    {"city": "Silmont"},
    {"city": "Sivry-la-Perche"},
    {"city": "Sivry-sur-Meuse"},
    {"city": "Sommedieue"},
    {"city": "Sommeilles"},
    {"city": "Sommelonne"},
    {"city": "Sorbey"},
    {"city": "Sorcy-Saint-Martin"},
    {"city": "Les Souhesmes-Rampont"},
    {"city": "Souilly"},
    {"city": "Spincourt"},
    {"city": "Stainville"},
    {"city": "Stenay"},
    {"city": "Taillancourt"},
    {"city": "Tannois"},
    {"city": "Thierville-sur-Meuse"},
    {"city": "Thillombois"},
    {"city": "Thillot"},
    {"city": "Thonne-la-Long"},
    {"city": "Thonne-le-Thil"},
    {"city": "Thonne-les-Près"},
    {"city": "Thonnelle"},
    {"city": "Tilly-sur-Meuse"},
    {"city": "Trémont-sur-Saulx"},
    {"city": "Trésauvaux"},
    {"city": "Tréveray"},
    {"city": "Seuil-d'Argonne"},
    {"city": "Cousances-lès-Triconville"},
    {"city": "Tronville-en-Barrois"},
    {"city": "Troussey"},
    {"city": "Troyon"},
    {"city": "Ugny-sur-Meuse"},
    {"city": "Vacherauville"},
    {"city": "Vadelaincourt"},
    {"city": "Vadonville"},
    {"city": "Varennes-en-Argonne"},
    {"city": "Varnéville"},
    {"city": "Valbois"},
    {"city": "Vassincourt"},
    {"city": "Vaubecourt"},
    {"city": "Vaucouleurs"},
    {"city": "Vaudeville-le-Haut"},
    {"city": "Vaudoncourt"},
    {"city": "Vauquois"},
    {"city": "Douaumont-Vaux"},
    {"city": "Vaux-lès-Palameix"},
    {"city": "Vavincourt"},
    {"city": "Velaines"},
    {"city": "Velosnes"},
    {"city": "Verdun"},
    {"city": "Verneuil-Grand"},
    {"city": "Verneuil-Petit"},
    {"city": "Véry"},
    {"city": "Vigneulles-lès-Hattonchâtel"},
    {"city": "Vigneul-sous-Montmédy"},
    {"city": "Vignot"},
    {"city": "Villécloye"},
    {"city": "Ville-devant-Belrain"},
    {"city": "Ville-devant-Chaumont"},
    {"city": "Ville-en-Woëvre"},
    {"city": "Villeroy-sur-Méholle"},
    {"city": "Villers-aux-Vents"},
    {"city": "Villers-devant-Dun"},
    {"city": "Villers-le-Sec"},
    {"city": "Villers-lès-Mangiennes"},
    {"city": "Villers-sous-Pareid"},
    {"city": "Villers-sur-Meuse"},
    {"city": "Ville-sur-Cousances"},
    {"city": "Ville-sur-Saulx"},
    {"city": "Villotte-devant-Louppy"},
    {"city": "Villotte-sur-Aire"},
    {"city": "Vilosnes-Haraumont"},
    {"city": "Vittarville"},
    {"city": "Void-Vacon"},
    {"city": "Vouthon-Bas"},
    {"city": "Vouthon-Haut"},
    {"city": "Waly"},
    {"city": "Warcq"},
    {"city": "Watronville"},
    {"city": "Wavrille"},
    {"city": "Willeroncourt"},
    {"city": "Wiseppe"},
    {"city": "Woël"},
    {"city": "Woimbey"},
    {"city": "Xivray-et-Marvoisin"},
    {"city": "Allaire"},
    {"city": "Ambon"},
    {"city": "Arradon"},
    {"city": "Arzal"},
    {"city": "Arzon"},
    {"city": "Augan"},
    {"city": "Auray"},
    {"city": "Baden"},
    {"city": "Bangor"},
    {"city": "Baud"},
    {"city": "Béganne"},
    {"city": "Beignon"},
    {"city": "Belz"},
    {"city": "Berné"},
    {"city": "Berric"},
    {"city": "Bignan"},
    {"city": "Billiers"},
    {"city": "Billio"},
    {"city": "Bohal"},
    {"city": "Brandérion"},
    {"city": "Brandivy"},
    {"city": "Brech"},
    {"city": "Bréhan"},
    {"city": "Brignac"},
    {"city": "Bubry"},
    {"city": "Buléon"},
    {"city": "Caden"},
    {"city": "Calan"},
    {"city": "Camoël"},
    {"city": "Camors"},
    {"city": "Campénéac"},
    {"city": "Carentoir"},
    {"city": "Carnac"},
    {"city": "Caro"},
    {"city": "Caudan"},
    {"city": "La Chapelle-Neuve"},
    {"city": "Cléguer"},
    {"city": "Cléguérec"},
    {"city": "Colpo"},
    {"city": "Concoret"},
    {"city": "Cournon"},
    {"city": "Le Cours"},
    {"city": "Crach"},
    {"city": "Crédin"},
    {"city": "Le Croisty"},
    {"city": "Croixanvec"},
    {"city": "La Croix-Helléan"},
    {"city": "Cruguel"},
    {"city": "Damgan"},
    {"city": "Elven"},
    {"city": "Erdeven"},
    {"city": "Étel"},
    {"city": "Évriguet"},
    {"city": "Le Faouët"},
    {"city": "Férel"},
    {"city": "Les Fougerêts"},
    {"city": "La Gacilly"},
    {"city": "Gâvres"},
    {"city": "Gestel"},
    {"city": "Gourhel"},
    {"city": "Gourin"},
    {"city": "Grand-Champ"},
    {"city": "La Grée-Saint-Laurent"},
    {"city": "Groix"},
    {"city": "Guégon"},
    {"city": "Guéhenno"},
    {"city": "Gueltas"},
    {"city": "Guémené-sur-Scorff"},
    {"city": "Guénin"},
    {"city": "Guer"},
    {"city": "Guern"},
    {"city": "Le Guerno"},
    {"city": "Guidel"},
    {"city": "Guillac"},
    {"city": "Guilliers"},
    {"city": "Guiscriff"},
    {"city": "Helléan"},
    {"city": "Hennebont"},
    {"city": "Le Hézo"},
    {"city": "Hœdic"},
    {"city": "Île-d'Houat"},
    {"city": "Île-aux-Moines"},
    {"city": "Île-d'Arz"},
    {"city": "Inguiniel"},
    {"city": "Inzinzac-Lochrist"},
    {"city": "Josselin"},
    {"city": "Kerfourn"},
    {"city": "Kergrist"},
    {"city": "Kervignac"},
    {"city": "Landaul"},
    {"city": "Landévant"},
    {"city": "Lanester"},
    {"city": "Langoëlan"},
    {"city": "Langonnet"},
    {"city": "Languidic"},
    {"city": "Forges de Lanouée"},
    {"city": "Lantillac"},
    {"city": "Lanvaudan"},
    {"city": "Lanvénégen"},
    {"city": "Larmor-Baden"},
    {"city": "Larmor-Plage"},
    {"city": "Larré"},
    {"city": "Lauzach"},
    {"city": "Lignol"},
    {"city": "Limerzel"},
    {"city": "Lizio"},
    {"city": "Locmalo"},
    {"city": "Locmaria"},
    {"city": "Locmaria-Grand-Champ"},
    {"city": "Locmariaquer"},
    {"city": "Locminé"},
    {"city": "Locmiquélic"},
    {"city": "Locoal-Mendon"},
    {"city": "Locqueltas"},
    {"city": "Lorient"},
    {"city": "Loyat"},
    {"city": "Malansac"},
    {"city": "Malestroit"},
    {"city": "Malguénac"},
    {"city": "Marzan"},
    {"city": "Mauron"},
    {"city": "Melrand"},
    {"city": "Ménéac"},
    {"city": "Merlevenez"},
    {"city": "Meslan"},
    {"city": "Meucon"},
    {"city": "Missiriac"},
    {"city": "Mohon"},
    {"city": "Molac"},
    {"city": "Monteneuf"},
    {"city": "Monterblanc"},
    {"city": "Montertelot"},
    {"city": "Moréac"},
    {"city": "Moustoir-Ac"},
    {"city": "Muzillac"},
    {"city": "Évellys"},
    {"city": "Néant-sur-Yvel"},
    {"city": "Neulliac"},
    {"city": "Nivillac"},
    {"city": "Nostang"},
    {"city": "Noyal-Muzillac"},
    {"city": "Noyal-Pontivy"},
    {"city": "Le Palais"},
    {"city": "Péaule"},
    {"city": "Peillac"},
    {"city": "Pénestin"},
    {"city": "Persquen"},
    {"city": "Plaudren"},
    {"city": "Plescop"},
    {"city": "Pleucadeuc"},
    {"city": "Pleugriffet"},
    {"city": "Ploemel"},
    {"city": "Ploemeur"},
    {"city": "Ploërdut"},
    {"city": "Ploeren"},
    {"city": "Ploërmel"},
    {"city": "Plouay"},
    {"city": "Plougoumelen"},
    {"city": "Plouharnel"},
    {"city": "Plouhinec"},
    {"city": "Plouray"},
    {"city": "Pluherlin"},
    {"city": "Plumelec"},
    {"city": "Pluméliau-Bieuzy"},
    {"city": "Plumelin"},
    {"city": "Plumergat"},
    {"city": "Pluneret"},
    {"city": "Pluvigner"},
    {"city": "Pontivy"},
    {"city": "Pont-Scorff"},
    {"city": "Porcaro"},
    {"city": "Port-Louis"},
    {"city": "Priziac"},
    {"city": "Questembert"},
    {"city": "Quéven"},
    {"city": "Quiberon"},
    {"city": "Quistinic"},
    {"city": "Radenac"},
    {"city": "Réguiny"},
    {"city": "Réminiac"},
    {"city": "Riantec"},
    {"city": "Rieux"},
    {"city": "La Roche-Bernard"},
    {"city": "Rochefort-en-Terre"},
    {"city": "Val d'Oust"},
    {"city": "Rohan"},
    {"city": "Roudouallec"},
    {"city": "Ruffiac"},
    {"city": "Le Saint"},
    {"city": "Saint-Abraham"},
    {"city": "Saint-Aignan"},
    {"city": "Saint-Allouestre"},
    {"city": "Saint-Armel"},
    {"city": "Saint-Avé"},
    {"city": "Saint-Barthélemy"},
    {"city": "Saint-Brieuc-de-Mauron"},
    {"city": "Sainte-Brigitte"},
    {"city": "Saint-Caradec-Trégomel"},
    {"city": "Saint-Congard"},
    {"city": "Saint-Dolay"},
    {"city": "Saint-Gérand"},
    {"city": "Saint-Gildas-de-Rhuys"},
    {"city": "Saint-Gonnery"},
    {"city": "Saint-Gorgon"},
    {"city": "Saint-Gravé"},
    {"city": "Saint-Guyomard"},
    {"city": "Sainte-Hélène"},
    {"city": "Saint-Jacut-les-Pins"},
    {"city": "Saint-Jean-Brévelay"},
    {"city": "Saint-Jean-la-Poterie"},
    {"city": "Saint-Laurent-sur-Oust"},
    {"city": "Saint-Léry"},
    {"city": "Saint-Malo-de-Beignon"},
    {"city": "Saint-Malo-des-Trois-Fontaines"},
    {"city": "Saint-Marcel"},
    {"city": "Saint-Martin-sur-Oust"},
    {"city": "Saint-Nicolas-du-Tertre"},
    {"city": "Saint-Nolff"},
    {"city": "Saint-Perreux"},
    {"city": "Saint-Philibert"},
    {"city": "Saint-Pierre-Quiberon"},
    {"city": "Saint-Servant"},
    {"city": "Saint-Thuriau"},
    {"city": "Saint-Tugdual"},
    {"city": "Saint-Vincent-sur-Oust"},
    {"city": "Sarzeau"},
    {"city": "Sauzon"},
    {"city": "Séglien"},
    {"city": "Séné"},
    {"city": "Sérent"},
    {"city": "Silfiac"},
    {"city": "Le Sourn"},
    {"city": "Sulniac"},
    {"city": "Surzur"},
    {"city": "Taupont"},
    {"city": "Théhillac"},
    {"city": "Theix-Noyalo"},
    {"city": "Le Tour-du-Parc"},
    {"city": "Tréal"},
    {"city": "Trédion"},
    {"city": "Treffléan"},
    {"city": "Tréhorenteuc"},
    {"city": "La Trinité-Porhoët"},
    {"city": "La Trinité-sur-Mer"},
    {"city": "La Trinité-Surzur"},
    {"city": "Vannes"},
    {"city": "La Vraie-Croix"},
    {"city": "Bono"},
    {"city": "Sainte-Anne-d'Auray"},
    {"city": "Kernascléden"},
    {"city": "Aboncourt"},
    {"city": "Aboncourt-sur-Seille"},
    {"city": "Abreschviller"},
    {"city": "Achain"},
    {"city": "Achen"},
    {"city": "Adaincourt"},
    {"city": "Adelange"},
    {"city": "Ajoncourt"},
    {"city": "Alaincourt-la-Côte"},
    {"city": "Albestroff"},
    {"city": "Algrange"},
    {"city": "Alsting"},
    {"city": "Altrippe"},
    {"city": "Altviller"},
    {"city": "Alzing"},
    {"city": "Amanvillers"},
    {"city": "Amelécourt"},
    {"city": "Amnéville"},
    {"city": "Ancerville"},
    {"city": "Ancy-Dornot"},
    {"city": "Angevillers"},
    {"city": "Antilly"},
    {"city": "Anzeling"},
    {"city": "Apach"},
    {"city": "Arraincourt"},
    {"city": "Argancy"},
    {"city": "Arriance"},
    {"city": "Arry"},
    {"city": "Ars-Laquenexy"},
    {"city": "Ars-sur-Moselle"},
    {"city": "Arzviller"},
    {"city": "Aspach"},
    {"city": "Assenoncourt"},
    {"city": "Attilloncourt"},
    {"city": "Aube"},
    {"city": "Audun-le-Tiche"},
    {"city": "Augny"},
    {"city": "Aulnois-sur-Seille"},
    {"city": "Aumetz"},
    {"city": "Avricourt"},
    {"city": "Ay-sur-Moselle"},
    {"city": "Azoudange"},
    {"city": "Bacourt"},
    {"city": "Baerenthal"},
    {"city": "Bambiderstroff"},
    {"city": "Bannay"},
    {"city": "Le Ban-Saint-Martin"},
    {"city": "Barchain"},
    {"city": "Baronville"},
    {"city": "Barst"},
    {"city": "Bassing"},
    {"city": "Baudrecourt"},
    {"city": "Bazoncourt"},
    {"city": "Bébing"},
    {"city": "Béchy"},
    {"city": "Behren-lès-Forbach"},
    {"city": "Bellange"},
    {"city": "Bénestroff"},
    {"city": "Béning-lès-Saint-Avold"},
    {"city": "Berg-sur-Moselle"},
    {"city": "Bérig-Vintrange"},
    {"city": "Berling"},
    {"city": "Bermering"},
    {"city": "Berthelming"},
    {"city": "Bertrange"},
    {"city": "Berviller-en-Moselle"},
    {"city": "Bettange"},
    {"city": "Bettborn"},
    {"city": "Bettelainville"},
    {"city": "Betting"},
    {"city": "Bettviller"},
    {"city": "Beux"},
    {"city": "Beyren-lès-Sierck"},
    {"city": "Bezange-la-Petite"},
    {"city": "Bibiche"},
    {"city": "Bickenholtz"},
    {"city": "Bidestroff"},
    {"city": "Biding"},
    {"city": "Bining"},
    {"city": "Bioncourt"},
    {"city": "Bionville-sur-Nied"},
    {"city": "Belles-Forêts"},
    {"city": "Bisten-en-Lorraine"},
    {"city": "Bistroff"},
    {"city": "Bitche"},
    {"city": "Blanche-Église"},
    {"city": "Bliesbruck"},
    {"city": "Blies-Ébersing"},
    {"city": "Blies-Guersviller"},
    {"city": "Boucheporn"},
    {"city": "Boulange"},
    {"city": "Boulay-Moselle"},
    {"city": "Bourgaltroff"},
    {"city": "Bourdonnay"},
    {"city": "Bourscheid"},
    {"city": "Bousbach"},
    {"city": "Bousse"},
    {"city": "Bousseviller"},
    {"city": "Boust"},
    {"city": "Boustroff"},
    {"city": "Bouzonville"},
    {"city": "Bréhain"},
    {"city": "Breidenbach"},
    {"city": "Breistroff-la-Grande"},
    {"city": "Brettnach"},
    {"city": "Bronvaux"},
    {"city": "Brouck"},
    {"city": "Brouderdorff"},
    {"city": "Brouviller"},
    {"city": "Brulange"},
    {"city": "Buchy"},
    {"city": "Buding"},
    {"city": "Budling"},
    {"city": "Buhl-Lorraine"},
    {"city": "Burlioncourt"},
    {"city": "Burtoncourt"},
    {"city": "Cappel"},
    {"city": "Carling"},
    {"city": "Cattenom"},
    {"city": "Chailly-lès-Ennery"},
    {"city": "Chambrey"},
    {"city": "Chanville"},
    {"city": "Charleville-sous-Bois"},
    {"city": "Charly-Oradour"},
    {"city": "Château-Bréhain"},
    {"city": "Château-Rouge"},
    {"city": "Château-Salins"},
    {"city": "Château-Voué"},
    {"city": "Châtel-Saint-Germain"},
    {"city": "Chémery-les-Deux"},
    {"city": "Cheminot"},
    {"city": "Chenois"},
    {"city": "Chérisey"},
    {"city": "Chesny"},
    {"city": "Chicourt"},
    {"city": "Chieulles"},
    {"city": "Clouange"},
    {"city": "Cocheren"},
    {"city": "Coincy"},
    {"city": "Coin-lès-Cuvry"},
    {"city": "Coin-sur-Seille"},
    {"city": "Colligny-Maizery"},
    {"city": "Colmen"},
    {"city": "Condé-Northen"},
    {"city": "Conthil"},
    {"city": "Contz-les-Bains"},
    {"city": "Corny-sur-Moselle"},
    {"city": "Coume"},
    {"city": "Courcelles-Chaussy"},
    {"city": "Courcelles-sur-Nied"},
    {"city": "Craincourt"},
    {"city": "Créhange"},
    {"city": "Creutzwald"},
    {"city": "Cutting"},
    {"city": "Cuvry"},
    {"city": "Dabo"},
    {"city": "Dalem"},
    {"city": "Dalhain"},
    {"city": "Dalstein"},
    {"city": "Danne-et-Quatre-Vents"},
    {"city": "Dannelbourg"},
    {"city": "Delme"},
    {"city": "Denting"},
    {"city": "Desseling"},
    {"city": "Destry"},
    {"city": "Diane-Capelle"},
    {"city": "Diebling"},
    {"city": "Dieuze"},
    {"city": "Diffembach-lès-Hellimer"},
    {"city": "Distroff"},
    {"city": "Dolving"},
    {"city": "Domnom-lès-Dieuze"},
    {"city": "Donjeux"},
    {"city": "Donnelay"},
    {"city": "Ébersviller"},
    {"city": "Éblange"},
    {"city": "Éguelshardt"},
    {"city": "Eincheville"},
    {"city": "Elvange"},
    {"city": "Elzange"},
    {"city": "Enchenberg"},
    {"city": "Ennery"},
    {"city": "Entrange"},
    {"city": "Epping"},
    {"city": "Erching"},
    {"city": "Ernestviller"},
    {"city": "Erstroff"},
    {"city": "Escherange"},
    {"city": "Les Étangs"},
    {"city": "Etting"},
    {"city": "Etzling"},
    {"city": "Évrange"},
    {"city": "Failly"},
    {"city": "Falck"},
    {"city": "Fameck"},
    {"city": "Farébersviller"},
    {"city": "Farschviller"},
    {"city": "Faulquemont"},
    {"city": "Fénétrange"},
    {"city": "Fèves"},
    {"city": "Féy"},
    {"city": "Filstroff"},
    {"city": "Fixem"},
    {"city": "Flastroff"},
    {"city": "Fleisheim"},
    {"city": "Flétrange"},
    {"city": "Fleury"},
    {"city": "Flévy"},
    {"city": "Flocourt"},
    {"city": "Florange"},
    {"city": "Folkling"},
    {"city": "Folschviller"},
    {"city": "Fonteny"},
    {"city": "Fontoy"},
    {"city": "Forbach"},
    {"city": "Fossieux"},
    {"city": "Foulcrey"},
    {"city": "Fouligny"},
    {"city": "Foville"},
    {"city": "Francaltroff"},
    {"city": "Fraquelfing"},
    {"city": "Frauenberg"},
    {"city": "Freistroff"},
    {"city": "Frémery"},
    {"city": "Frémestroff"},
    {"city": "Fresnes-en-Saulnois"},
    {"city": "Freybouse"},
    {"city": "Freyming-Merlebach"},
    {"city": "Fribourg"},
    {"city": "Gandrange"},
    {"city": "Garrebourg"},
    {"city": "Gavisse"},
    {"city": "Gelucourt"},
    {"city": "Gerbécourt"},
    {"city": "Givrycourt"},
    {"city": "Glatigny"},
    {"city": "Goetzenbruck"},
    {"city": "Goin"},
    {"city": "Gomelange"},
    {"city": "Gondrexange"},
    {"city": "Gorze"},
    {"city": "Gosselming"},
    {"city": "Gravelotte"},
    {"city": "Grémecey"},
    {"city": "Gréning"},
    {"city": "Grindorff-Bizing"},
    {"city": "Grosbliederstroff"},
    {"city": "Gros-Réderching"},
    {"city": "Grostenquin"},
    {"city": "Grundviller"},
    {"city": "Guebenhouse"},
    {"city": "Guébestroff"},
    {"city": "Guéblange-lès-Dieuze"},
    {"city": "Le Val-de-Guéblange"},
    {"city": "Guébling"},
    {"city": "Guénange"},
    {"city": "Val-de-Bride"},
    {"city": "Guenviller"},
    {"city": "Guermange"},
    {"city": "Guerstling"},
    {"city": "Guerting"},
    {"city": "Guessling-Hémering"},
    {"city": "Guinglange"},
    {"city": "Guinkirchen"},
    {"city": "Guinzeling"},
    {"city": "Guntzviller"},
    {"city": "Haboudange"},
    {"city": "Hagen"},
    {"city": "Hagondange"},
    {"city": "Hallering"},
    {"city": "Halstroff"},
    {"city": "Basse-Ham"},
    {"city": "Ham-sous-Varsberg"},
    {"city": "Hambach"},
    {"city": "Hampont"},
    {"city": "Hangviller"},
    {"city": "Hannocourt"},
    {"city": "Han-sur-Nied"},
    {"city": "Hanviller"},
    {"city": "Haraucourt-sur-Seille"},
    {"city": "Hargarten-aux-Mines"},
    {"city": "Harprich"},
    {"city": "Harreberg"},
    {"city": "Hartzviller"},
    {"city": "Haselbourg"},
    {"city": "Haspelschiedt"},
    {"city": "Hattigny"},
    {"city": "Hauconcourt"},
    {"city": "Haut-Clocher"},
    {"city": "Havange"},
    {"city": "Hayange"},
    {"city": "Hayes"},
    {"city": "Hazembourg"},
    {"city": "Heining-lès-Bouzonville"},
    {"city": "Hellering-lès-Fénétrange"},
    {"city": "Hellimer"},
    {"city": "Helstroff"},
    {"city": "Hémilly"},
    {"city": "Héming"},
    {"city": "Henridorff"},
    {"city": "Henriville"},
    {"city": "Hérange"},
    {"city": "Hermelange"},
    {"city": "Herny"},
    {"city": "Hertzing"},
    {"city": "Hesse"},
    {"city": "Hestroff"},
    {"city": "Hettange-Grande"},
    {"city": "Hilbesheim"},
    {"city": "Hilsprich"},
    {"city": "Hinckange"},
    {"city": "Holacourt"},
    {"city": "Holling"},
    {"city": "Holving"},
    {"city": "Hombourg-Budange"},
    {"city": "Hombourg-Haut"},
    {"city": "Hommarting"},
    {"city": "Hommert"},
    {"city": "Honskirch"},
    {"city": "L'Hôpital"},
    {"city": "Hoste"},
    {"city": "Hottviller"},
    {"city": "Hultehouse"},
    {"city": "Hundling"},
    {"city": "Hunting"},
    {"city": "Ibigny"},
    {"city": "Illange"},
    {"city": "Imling"},
    {"city": "Inglange"},
    {"city": "Insming"},
    {"city": "Insviller"},
    {"city": "Ippling"},
    {"city": "Jallaucourt"},
    {"city": "Jouy-aux-Arches"},
    {"city": "Jury"},
    {"city": "Jussy"},
    {"city": "Juvelize"},
    {"city": "Juville"},
    {"city": "Kalhausen"},
    {"city": "Kanfen"},
    {"city": "Kappelkinger"},
    {"city": "Kédange-sur-Canner"},
    {"city": "Kemplich"},
    {"city": "Kerbach"},
    {"city": "Kerling-lès-Sierck"},
    {"city": "Kerprich-aux-Bois"},
    {"city": "Kirsch-lès-Sierck"},
    {"city": "Kirschnaumen"},
    {"city": "Kirviller"},
    {"city": "Klang"},
    {"city": "Knutange"},
    {"city": "Kœnigsmacker"},
    {"city": "Haute-Kontz"},
    {"city": "Kuntzig"},
    {"city": "Lachambre"},
    {"city": "Lafrimbolle"},
    {"city": "Lagarde"},
    {"city": "Lambach"},
    {"city": "Landange"},
    {"city": "Landroff"},
    {"city": "Laneuveville-lès-Lorquin"},
    {"city": "Laneuveville-en-Saulnois"},
    {"city": "Langatte"},
    {"city": "Languimberg"},
    {"city": "Laning"},
    {"city": "Laquenexy"},
    {"city": "Laudrefang"},
    {"city": "Laumesfeld"},
    {"city": "Launstroff"},
    {"city": "Lelling"},
    {"city": "Lemberg"},
    {"city": "Lemoncourt"},
    {"city": "Lemud"},
    {"city": "Lengelsheim"},
    {"city": "Léning"},
    {"city": "Lesse"},
    {"city": "Lessy"},
    {"city": "Ley"},
    {"city": "Leyviller"},
    {"city": "Lezey"},
    {"city": "Lidrezing"},
    {"city": "Liederschiedt"},
    {"city": "Liéhon"},
    {"city": "Lindre-Basse"},
    {"city": "Lindre-Haute"},
    {"city": "Liocourt"},
    {"city": "Lixheim"},
    {"city": "Lixing-lès-Rouhling"},
    {"city": "Lixing-lès-Saint-Avold"},
    {"city": "Lhor"},
    {"city": "Lommerange"},
    {"city": "Longeville-lès-Metz"},
    {"city": "Longeville-lès-Saint-Avold"},
    {"city": "Lorquin"},
    {"city": "Lorry-lès-Metz"},
    {"city": "Lorry-Mardigny"},
    {"city": "Lostroff"},
    {"city": "Loudrefing"},
    {"city": "Loupershouse"},
    {"city": "Loutzviller"},
    {"city": "Louvigny"},
    {"city": "Lubécourt"},
    {"city": "Lucy"},
    {"city": "Luppy"},
    {"city": "Luttange"},
    {"city": "Lutzelbourg"},
    {"city": "Macheren"},
    {"city": "Mainvillers"},
    {"city": "Maizeroy"},
    {"city": "Maizières-lès-Metz"},
    {"city": "Maizières-lès-Vic"},
    {"city": "Malaucourt-sur-Seille"},
    {"city": "Malling"},
    {"city": "Malroy"},
    {"city": "Manderen-Ritzing"},
    {"city": "Manhoué"},
    {"city": "Manom"},
    {"city": "Many"},
    {"city": "Marange-Silvange"},
    {"city": "Marange-Zondrange"},
    {"city": "Marieulles"},
    {"city": "Marimont-lès-Bénestroff"},
    {"city": "Marly"},
    {"city": "Marsal"},
    {"city": "Marsilly"},
    {"city": "Marthille"},
    {"city": "La Maxe"},
    {"city": "Maxstadt"},
    {"city": "Mécleuves"},
    {"city": "Mégange"},
    {"city": "Meisenthal"},
    {"city": "Menskirch"},
    {"city": "Merschweiller"},
    {"city": "Merten"},
    {"city": "Métairies-Saint-Quirin"},
    {"city": "Metting"},
    {"city": "Metz"},
    {"city": "Metzeresche"},
    {"city": "Metzervisse"},
    {"city": "Metzing"},
    {"city": "Mey"},
    {"city": "Mittelbronn"},
    {"city": "Mittersheim"},
    {"city": "Molring"},
    {"city": "Momerstroff"},
    {"city": "Moncheux"},
    {"city": "Moncourt"},
    {"city": "Mondelange"},
    {"city": "Mondorff"},
    {"city": "Monneren"},
    {"city": "Montbronn"},
    {"city": "Montdidier"},
    {"city": "Montenach"},
    {"city": "Montigny-lès-Metz"},
    {"city": "Montois-la-Montagne"},
    {"city": "Ogy-Montoy-Flanville"},
    {"city": "Morhange"},
    {"city": "Morsbach"},
    {"city": "Morville-lès-Vic"},
    {"city": "Morville-sur-Nied"},
    {"city": "Moulins-lès-Metz"},
    {"city": "Moussey"},
    {"city": "Mouterhouse"},
    {"city": "Moyenvic"},
    {"city": "Moyeuvre-Grande"},
    {"city": "Moyeuvre-Petite"},
    {"city": "Mulcey"},
    {"city": "Munster"},
    {"city": "Narbéfontaine"},
    {"city": "Nébing"},
    {"city": "Nelling"},
    {"city": "Neufchef"},
    {"city": "Neufgrange"},
    {"city": "Neufmoulins"},
    {"city": "Neufvillage"},
    {"city": "Neunkirchen-lès-Bouzonville"},
    {"city": "Niderhoff"},
    {"city": "Niderviller"},
    {"city": "Niederstinzel"},
    {"city": "Niedervisse"},
    {"city": "Nilvange"},
    {"city": "Nitting"},
    {"city": "Noisseville"},
    {"city": "Norroy-le-Veneur"},
    {"city": "Nouilly"},
    {"city": "Nousseviller-lès-Bitche"},
    {"city": "Nousseviller-Saint-Nabor"},
    {"city": "Novéant-sur-Moselle"},
    {"city": "Oberdorff"},
    {"city": "Obergailbach"},
    {"city": "Oberstinzel"},
    {"city": "Obervisse"},
    {"city": "Obreck"},
    {"city": "Œting"},
    {"city": "Ommeray"},
    {"city": "Oriocourt"},
    {"city": "Ormersviller"},
    {"city": "Orny"},
    {"city": "Oron"},
    {"city": "Ottange"},
    {"city": "Ottonville"},
    {"city": "Oudrenne"},
    {"city": "Pagny-lès-Goin"},
    {"city": "Pange"},
    {"city": "Peltre"},
    {"city": "Petit-Réderching"},
    {"city": "Petit-Tenquin"},
    {"city": "Petite-Rosselle"},
    {"city": "Pettoncourt"},
    {"city": "Pévange"},
    {"city": "Phalsbourg"},
    {"city": "Philippsbourg"},
    {"city": "Piblange"},
    {"city": "Pierrevillers"},
    {"city": "Plaine-de-Walsch"},
    {"city": "Plappeville"},
    {"city": "Plesnois"},
    {"city": "Pommérieux"},
    {"city": "Pontoy"},
    {"city": "Pontpierre"},
    {"city": "Porcelette"},
    {"city": "Postroff"},
    {"city": "Pouilly"},
    {"city": "Pournoy-la-Chétive"},
    {"city": "Pournoy-la-Grasse"},
    {"city": "Prévocourt"},
    {"city": "Puttelange-aux-Lacs"},
    {"city": "Puttelange-lès-Thionville"},
    {"city": "Puttigny"},
    {"city": "Puzieux"},
    {"city": "Racrange"},
    {"city": "Rahling"},
    {"city": "Ranguevaux"},
    {"city": "Raville"},
    {"city": "Réchicourt-le-Château"},
    {"city": "Rédange"},
    {"city": "Réding"},
    {"city": "Rémelfang"},
    {"city": "Rémelfing"},
    {"city": "Rémeling"},
    {"city": "Rémering"},
    {"city": "Rémering-lès-Puttelange"},
    {"city": "Rémilly"},
    {"city": "Réning"},
    {"city": "Basse-Rentgen"},
    {"city": "Retonfey"},
    {"city": "Rettel"},
    {"city": "Reyersviller"},
    {"city": "Rezonville-Vionville"},
    {"city": "Rhodes"},
    {"city": "Riche"},
    {"city": "Richeling"},
    {"city": "Richemont"},
    {"city": "Richeval"},
    {"city": "Rimling"},
    {"city": "Rochonvillers"},
    {"city": "Rodalbe"},
    {"city": "Rodemack"},
    {"city": "Rohrbach-lès-Bitche"},
    {"city": "Rolbing"},
    {"city": "Rombas"},
    {"city": "Romelfing"},
    {"city": "Roncourt"},
    {"city": "Roppeviller"},
    {"city": "Rorbach-lès-Dieuze"},
    {"city": "Rosbruck"},
    {"city": "Rosselange"},
    {"city": "Rouhling"},
    {"city": "Roupeldange"},
    {"city": "Roussy-le-Village"},
    {"city": "Rozérieulles"},
    {"city": "Rurange-lès-Thionville"},
    {"city": "Russange"},
    {"city": "Rustroff"},
    {"city": "Sailly-Achâtel"},
    {"city": "Saint-Avold"},
    {"city": "Sainte-Barbe"},
    {"city": "Saint-Epvre"},
    {"city": "Saint-François-Lacroix"},
    {"city": "Saint-Georges"},
    {"city": "Saint-Hubert"},
    {"city": "Saint-Jean-de-Bassel"},
    {"city": "Saint-Jean-Kourtzerode"},
    {"city": "Saint-Jean-Rohrbach"},
    {"city": "Saint-Julien-lès-Metz"},
    {"city": "Saint-Jure"},
    {"city": "Saint-Louis"},
    {"city": "Saint-Louis-lès-Bitche"},
    {"city": "Sainte-Marie-aux-Chênes"},
    {"city": "Saint-Médard"},
    {"city": "Saint-Privat-la-Montagne"},
    {"city": "Saint-Quirin"},
    {"city": "Sainte-Ruffine"},
    {"city": "Salonnes"},
    {"city": "Sanry-lès-Vigy"},
    {"city": "Sanry-sur-Nied"},
    {"city": "Sarralbe"},
    {"city": "Sarraltroff"},
    {"city": "Sarrebourg"},
    {"city": "Sarreguemines"},
    {"city": "Sarreinsming"},
    {"city": "Saulny"},
    {"city": "Schalbach"},
    {"city": "Schmittviller"},
    {"city": "Schneckenbusch"},
    {"city": "Schœneck"},
    {"city": "Schorbach"},
    {"city": "Schwerdorff"},
    {"city": "Schweyen"},
    {"city": "Scy-Chazelles"},
    {"city": "Secourt"},
    {"city": "Seingbouse"},
    {"city": "Semécourt"},
    {"city": "Serémange-Erzange"},
    {"city": "Servigny-lès-Raville"},
    {"city": "Servigny-lès-Sainte-Barbe"},
    {"city": "Sierck-les-Bains"},
    {"city": "Siersthal"},
    {"city": "Sillegny"},
    {"city": "Silly-en-Saulnois"},
    {"city": "Silly-sur-Nied"},
    {"city": "Solgne"},
    {"city": "Sorbey"},
    {"city": "Sotzeling"},
    {"city": "Soucht"},
    {"city": "Spicheren"},
    {"city": "Stiring-Wendel"},
    {"city": "Sturzelbronn"},
    {"city": "Suisse"},
    {"city": "Talange"},
    {"city": "Tarquimpol"},
    {"city": "Tenteling"},
    {"city": "Terville"},
    {"city": "Téterchen"},
    {"city": "Teting-sur-Nied"},
    {"city": "Théding"},
    {"city": "Thicourt"},
    {"city": "Thimonville"},
    {"city": "Thionville"},
    {"city": "Thonville"},
    {"city": "Tincry"},
    {"city": "Torcheville"},
    {"city": "Tragny"},
    {"city": "Trémery"},
    {"city": "Tressange"},
    {"city": "Tritteling-Redlach"},
    {"city": "Troisfontaines"},
    {"city": "Tromborn"},
    {"city": "Turquestein-Blancrupt"},
    {"city": "Uckange"},
    {"city": "Vahl-Ebersing"},
    {"city": "Vahl-lès-Bénestroff"},
    {"city": "Vahl-lès-Faulquemont"},
    {"city": "Vallerange"},
    {"city": "Valmestroff"},
    {"city": "Valmont"},
    {"city": "Valmunster"},
    {"city": "Vannecourt"},
    {"city": "Vantoux"},
    {"city": "Vany"},
    {"city": "Varize-Vaudoncourt"},
    {"city": "Varsberg"},
    {"city": "Vasperviller"},
    {"city": "Vatimont"},
    {"city": "Vaudreching"},
    {"city": "Vaux"},
    {"city": "Vaxy"},
    {"city": "Veckersviller"},
    {"city": "Veckring"},
    {"city": "Velving"},
    {"city": "Vergaville"},
    {"city": "Vernéville"},
    {"city": "Verny"},
    {"city": "Vescheim"},
    {"city": "Vibersviller"},
    {"city": "Vic-sur-Seille"},
    {"city": "Vieux-Lixheim"},
    {"city": "Haute-Vigneulles"},
    {"city": "Vigny"},
    {"city": "Vigy"},
    {"city": "Viller"},
    {"city": "Villers-Stoncourt"},
    {"city": "Villers-sur-Nied"},
    {"city": "Villing"},
    {"city": "Vilsberg"},
    {"city": "Virming"},
    {"city": "Vitry-sur-Orne"},
    {"city": "Vittersbourg"},
    {"city": "Vittoncourt"},
    {"city": "Viviers"},
    {"city": "Voimhaut"},
    {"city": "Volmerange-lès-Boulay"},
    {"city": "Volmerange-les-Mines"},
    {"city": "Volmunster"},
    {"city": "Volstroff"},
    {"city": "Voyer"},
    {"city": "Vry"},
    {"city": "Vulmont"},
    {"city": "Waldhouse"},
    {"city": "Waldweistroff"},
    {"city": "Waldwisse"},
    {"city": "Walschbronn"},
    {"city": "Walscheid"},
    {"city": "Waltembourg"},
    {"city": "Wiesviller"},
    {"city": "Willerwald"},
    {"city": "Wintersbourg"},
    {"city": "Wittring"},
    {"city": "Vœlfling-lès-Bouzonville"},
    {"city": "Wœlfling-lès-Sarreguemines"},
    {"city": "Woippy"},
    {"city": "Woustviller"},
    {"city": "Wuisse"},
    {"city": "Xanrey"},
    {"city": "Xocourt"},
    {"city": "Xouaxange"},
    {"city": "Yutz"},
    {"city": "Zarbeling"},
    {"city": "Zetting"},
    {"city": "Zilling"},
    {"city": "Zimming"},
    {"city": "Zommange"},
    {"city": "Zoufftgen"},
    {"city": "Diesen"},
    {"city": "Stuckange"},
    {"city": "Achun"},
    {"city": "Alligny-Cosne"},
    {"city": "Alligny-en-Morvan"},
    {"city": "Alluy"},
    {"city": "Amazy"},
    {"city": "Anlezy"},
    {"city": "Annay"},
    {"city": "Anthien"},
    {"city": "Arbourse"},
    {"city": "Arleuf"},
    {"city": "Armes"},
    {"city": "Arquian"},
    {"city": "Arthel"},
    {"city": "Arzembouy"},
    {"city": "Asnan"},
    {"city": "Asnois"},
    {"city": "Aunay-en-Bazois"},
    {"city": "Authiou"},
    {"city": "Avrée"},
    {"city": "Avril-sur-Loire"},
    {"city": "Azy-le-Vif"},
    {"city": "Bazoches"},
    {"city": "Bazolles"},
    {"city": "Béard"},
    {"city": "Beaulieu"},
    {"city": "Beaumont-la-Ferrière"},
    {"city": "Beaumont-Sardolles"},
    {"city": "Beuvron"},
    {"city": "Biches"},
    {"city": "Billy-Chevannes"},
    {"city": "Billy-sur-Oisy"},
    {"city": "Bitry"},
    {"city": "Blismes"},
    {"city": "Bona"},
    {"city": "Bouhy"},
    {"city": "Brassy"},
    {"city": "Breugnon"},
    {"city": "Brèves"},
    {"city": "Brinay"},
    {"city": "Brinon-sur-Beuvron"},
    {"city": "Bulcy"},
    {"city": "Bussy-la-Pesle"},
    {"city": "La Celle-sur-Loire"},
    {"city": "La Celle-sur-Nièvre"},
    {"city": "Cercy-la-Tour"},
    {"city": "Cervon"},
    {"city": "Cessy-les-Bois"},
    {"city": "Chalaux"},
    {"city": "Challement"},
    {"city": "Challuy"},
    {"city": "Champallement"},
    {"city": "Champlemy"},
    {"city": "Champlin"},
    {"city": "Champvert"},
    {"city": "Champvoux"},
    {"city": "Chantenay-Saint-Imbert"},
    {"city": "La Chapelle-Saint-André"},
    {"city": "La Charité-sur-Loire"},
    {"city": "Charrin"},
    {"city": "Chasnay"},
    {"city": "Château-Chinon (Ville)"},
    {"city": "Château-Chinon (Campagne)"},
    {"city": "Châteauneuf-Val-de-Bargis"},
    {"city": "Châtillon-en-Bazois"},
    {"city": "Châtin"},
    {"city": "Chaulgnes"},
    {"city": "Chaumard"},
    {"city": "Chaumot"},
    {"city": "Chazeuil"},
    {"city": "Chevannes-Changy"},
    {"city": "Chevenon"},
    {"city": "Chevroches"},
    {"city": "Chiddes"},
    {"city": "Chitry-les-Mines"},
    {"city": "Chougny"},
    {"city": "Ciez"},
    {"city": "Cizely"},
    {"city": "Clamecy"},
    {"city": "La Collancelle"},
    {"city": "Colméry"},
    {"city": "Corancy"},
    {"city": "Corbigny"},
    {"city": "Corvol-d'Embernard"},
    {"city": "Corvol-l'Orgueilleux"},
    {"city": "Cosne-Cours-sur-Loire"},
    {"city": "Cossaye"},
    {"city": "Coulanges-lès-Nevers"},
    {"city": "Couloutre"},
    {"city": "Courcelles"},
    {"city": "Crux-la-Ville"},
    {"city": "Cuncy-lès-Varzy"},
    {"city": "Dampierre-sous-Bouhy"},
    {"city": "Decize"},
    {"city": "Devay"},
    {"city": "Diennes-Aubigny"},
    {"city": "Dirol"},
    {"city": "Dommartin"},
    {"city": "Dompierre-sur-Nièvre"},
    {"city": "Donzy"},
    {"city": "Dornecy"},
    {"city": "Dornes"},
    {"city": "Druy-Parigny"},
    {"city": "Dun-les-Places"},
    {"city": "Dun-sur-Grandry"},
    {"city": "Empury"},
    {"city": "Entrains-sur-Nohain"},
    {"city": "Epiry"},
    {"city": "Fâchin"},
    {"city": "La Fermeté"},
    {"city": "Fertrève"},
    {"city": "Fléty"},
    {"city": "Fleury-sur-Loire"},
    {"city": "Flez-Cuzy"},
    {"city": "Fourchambault"},
    {"city": "Fours"},
    {"city": "Frasnay-Reugny"},
    {"city": "Gâcogne"},
    {"city": "Garchizy"},
    {"city": "Garchy"},
    {"city": "Germenay"},
    {"city": "Germigny-sur-Loire"},
    {"city": "Gien-sur-Cure"},
    {"city": "Gimouille"},
    {"city": "Giry"},
    {"city": "Glux-en-Glenne"},
    {"city": "Gouloux"},
    {"city": "Grenois"},
    {"city": "Guérigny"},
    {"city": "Guipy"},
    {"city": "Héry"},
    {"city": "Imphy"},
    {"city": "Isenay"},
    {"city": "Jailly"},
    {"city": "Lamenay-sur-Loire"},
    {"city": "Langeron"},
    {"city": "Lanty"},
    {"city": "Larochemillay"},
    {"city": "Lavault-de-Frétoy"},
    {"city": "Limanton"},
    {"city": "Limon"},
    {"city": "Livry"},
    {"city": "Lormes"},
    {"city": "Lucenay-lès-Aix"},
    {"city": "Lurcy-le-Bourg"},
    {"city": "Luthenay-Uxeloup"},
    {"city": "Luzy"},
    {"city": "Lys"},
    {"city": "La Machine"},
    {"city": "Magny-Cours"},
    {"city": "Magny-Lormes"},
    {"city": "La Maison-Dieu"},
    {"city": "La Marche"},
    {"city": "Marcy"},
    {"city": "Marigny-l'Église"},
    {"city": "Mars-sur-Allier"},
    {"city": "Marigny-sur-Yonne"},
    {"city": "Marzy"},
    {"city": "Maux"},
    {"city": "Menestreau"},
    {"city": "Menou"},
    {"city": "Mesves-sur-Loire"},
    {"city": "Metz-le-Comte"},
    {"city": "Mhère"},
    {"city": "Millay"},
    {"city": "Moissy-Moulinot"},
    {"city": "Monceaux-le-Comte"},
    {"city": "Montapas"},
    {"city": "Montambert"},
    {"city": "Montaron"},
    {"city": "Montenoison"},
    {"city": "Mont-et-Marré"},
    {"city": "Montigny-aux-Amognes"},
    {"city": "Montigny-en-Morvan"},
    {"city": "Montigny-sur-Canne"},
    {"city": "Montreuillon"},
    {"city": "Montsauche-les-Settons"},
    {"city": "Moraches"},
    {"city": "Moulins-Engilbert"},
    {"city": "Mouron-sur-Yonne"},
    {"city": "Moussy"},
    {"city": "Moux-en-Morvan"},
    {"city": "Murlin"},
    {"city": "Myennes"},
    {"city": "Nannay"},
    {"city": "Narcy"},
    {"city": "Neuffontaines"},
    {"city": "Neuilly"},
    {"city": "Neuville-lès-Decize"},
    {"city": "Neuvy-sur-Loire"},
    {"city": "Nevers"},
    {"city": "La Nocle-Maulaix"},
    {"city": "Nolay"},
    {"city": "Nuars"},
    {"city": "Oisy"},
    {"city": "Onlay"},
    {"city": "Ouagne"},
    {"city": "Oudan"},
    {"city": "Ougny"},
    {"city": "Oulon"},
    {"city": "Vaux d'Amognes"},
    {"city": "Ouroux-en-Morvan"},
    {"city": "Parigny-la-Rose"},
    {"city": "Parigny-les-Vaux"},
    {"city": "Pazy"},
    {"city": "Perroy"},
    {"city": "Planchez"},
    {"city": "Poil"},
    {"city": "Poiseux"},
    {"city": "Pougny"},
    {"city": "Pougues-les-Eaux"},
    {"city": "Pouilly-sur-Loire"},
    {"city": "Pouques-Lormes"},
    {"city": "Pousseaux"},
    {"city": "Prémery"},
    {"city": "Préporché"},
    {"city": "Raveau"},
    {"city": "Rémilly"},
    {"city": "Rix"},
    {"city": "Rouy"},
    {"city": "Ruages"},
    {"city": "Saincaize-Meauce"},
    {"city": "Saint-Agnan"},
    {"city": "Saint-Amand-en-Puisaye"},
    {"city": "Saint-Andelain"},
    {"city": "Saint-André-en-Morvan"},
    {"city": "Saint-Aubin-des-Chaumes"},
    {"city": "Saint-Aubin-les-Forges"},
    {"city": "Saint-Benin-d'Azy"},
    {"city": "Saint-Benin-des-Bois"},
    {"city": "Saint-Bonnot"},
    {"city": "Saint-Brisson"},
    {"city": "Sainte-Colombe-des-Bois"},
    {"city": "Saint-Didier"},
    {"city": "Saint-Éloi"},
    {"city": "Saint-Firmin"},
    {"city": "Saint-Franchy"},
    {"city": "Saint-Germain-Chassenay"},
    {"city": "Saint-Germain-des-Bois"},
    {"city": "Saint-Gratien-Savigny"},
    {"city": "Saint-Hilaire-en-Morvan"},
    {"city": "Saint-Hilaire-Fontaine"},
    {"city": "Saint-Honoré-les-Bains"},
    {"city": "Saint-Jean-aux-Amognes"},
    {"city": "Saint-Laurent-l'Abbaye"},
    {"city": "Saint-Léger-de-Fougeret"},
    {"city": "Saint-Léger-des-Vignes"},
    {"city": "Saint-Loup"},
    {"city": "Saint-Malo-en-Donziois"},
    {"city": "Sainte-Marie"},
    {"city": "Saint-Martin-d'Heuille"},
    {"city": "Saint-Martin-du-Puy"},
    {"city": "Saint-Martin-sur-Nohain"},
    {"city": "Saint-Maurice"},
    {"city": "Saint-Ouen-sur-Loire"},
    {"city": "Saint-Parize-en-Viry"},
    {"city": "Saint-Parize-le-Châtel"},
    {"city": "Saint-Père"},
    {"city": "Saint-Péreuse"},
    {"city": "Saint-Pierre-du-Mont"},
    {"city": "Saint-Pierre-le-Moûtier"},
    {"city": "Saint-Quentin-sur-Nohain"},
    {"city": "Saint-Révérien"},
    {"city": "Saint-Saulge"},
    {"city": "Saint-Seine"},
    {"city": "Saint-Sulpice"},
    {"city": "Saint-Vérain"},
    {"city": "Saizy"},
    {"city": "Sardy-lès-Épiry"},
    {"city": "Sauvigny-les-Bois"},
    {"city": "Savigny-Poil-Fol"},
    {"city": "Saxi-Bourdon"},
    {"city": "Sémelay"},
    {"city": "Sermages"},
    {"city": "Sermoise-sur-Loire"},
    {"city": "Sichamps"},
    {"city": "Sougy-sur-Loire"},
    {"city": "Suilly-la-Tour"},
    {"city": "Surgy"},
    {"city": "Taconnay"},
    {"city": "Talon"},
    {"city": "Tamnay-en-Bazois"},
    {"city": "Tannay"},
    {"city": "Tazilly"},
    {"city": "Teigny"},
    {"city": "Ternant"},
    {"city": "Thaix"},
    {"city": "Thianges"},
    {"city": "Tintury"},
    {"city": "Toury-Lurcy"},
    {"city": "Toury-sur-Jour"},
    {"city": "Tracy-sur-Loire"},
    {"city": "Tresnay"},
    {"city": "Trois-Vèvres"},
    {"city": "Tronsanges"},
    {"city": "Trucy-l'Orgueilleux"},
    {"city": "Urzy"},
    {"city": "Vandenesse"},
    {"city": "Varennes-lès-Narcy"},
    {"city": "Varennes-Vauzelles"},
    {"city": "Varzy"},
    {"city": "Vauclaix"},
    {"city": "Verneuil"},
    {"city": "Vielmanay"},
    {"city": "Vignol"},
    {"city": "Villapourçon"},
    {"city": "Villiers-le-Sec"},
    {"city": "Ville-Langy"},
    {"city": "Villiers-sur-Yonne"},
    {"city": "Vitry-Laché"},
    {"city": "Abancourt"},
    {"city": "Abscon"},
    {"city": "Aibes"},
    {"city": "Aix-en-Pévèle"},
    {"city": "Allennes-les-Marais"},
    {"city": "Amfroipret"},
    {"city": "Anhiers"},
    {"city": "Aniche"},
    {"city": "Villeneuve-d'Ascq"},
    {"city": "Anneux"},
    {"city": "Annœullin"},
    {"city": "Anor"},
    {"city": "Anstaing"},
    {"city": "Anzin"},
    {"city": "Arleux"},
    {"city": "Armbouts-Cappel"},
    {"city": "Armentières"},
    {"city": "Arnèke"},
    {"city": "Artres"},
    {"city": "Assevent"},
    {"city": "Attiches"},
    {"city": "Aubencheul-au-Bac"},
    {"city": "Auberchicourt"},
    {"city": "Aubers"},
    {"city": "Aubigny-au-Bac"},
    {"city": "Aubry-du-Hainaut"},
    {"city": "Auby"},
    {"city": "Auchy-lez-Orchies"},
    {"city": "Audignies"},
    {"city": "Aulnoy-lez-Valenciennes"},
    {"city": "Aulnoye-Aymeries"},
    {"city": "Avelin"},
    {"city": "Avesnelles"},
    {"city": "Avesnes-sur-Helpe"},
    {"city": "Avesnes-les-Aubert"},
    {"city": "Avesnes-le-Sec"},
    {"city": "Awoingt"},
    {"city": "Bachant"},
    {"city": "Bachy"},
    {"city": "Bailleul"},
    {"city": "Baisieux"},
    {"city": "Baives"},
    {"city": "Bambecque"},
    {"city": "Banteux"},
    {"city": "Bantigny"},
    {"city": "Bantouzelle"},
    {"city": "Bas-Lieu"},
    {"city": "La Bassée"},
    {"city": "Bauvin"},
    {"city": "Bavay"},
    {"city": "Bavinchove"},
    {"city": "Bazuel"},
    {"city": "Beaucamps-Ligny"},
    {"city": "Beaudignies"},
    {"city": "Beaufort"},
    {"city": "Beaumont-en-Cambrésis"},
    {"city": "Beaurain"},
    {"city": "Beaurepaire-sur-Sambre"},
    {"city": "Beaurieux"},
    {"city": "Beauvois-en-Cambrésis"},
    {"city": "Bellaing"},
    {"city": "Bellignies"},
    {"city": "Bérelles"},
    {"city": "Bergues"},
    {"city": "Berlaimont"},
    {"city": "Bermerain"},
    {"city": "Bermeries"},
    {"city": "Bersée"},
    {"city": "Bersillies"},
    {"city": "Berthen"},
    {"city": "Bertry"},
    {"city": "Béthencourt"},
    {"city": "Bettignies"},
    {"city": "Bettrechies"},
    {"city": "Beugnies"},
    {"city": "Beuvrages"},
    {"city": "Beuvry-la-Forêt"},
    {"city": "Bévillers"},
    {"city": "Bierne"},
    {"city": "Bissezeele"},
    {"city": "Blaringhem"},
    {"city": "Blécourt"},
    {"city": "Boeschepe"},
    {"city": "Boëseghem"},
    {"city": "Bois-Grenier"},
    {"city": "Bollezeele"},
    {"city": "Bondues"},
    {"city": "Borre"},
    {"city": "Bouchain"},
    {"city": "Boulogne-sur-Helpe"},
    {"city": "Bourbourg"},
    {"city": "Bourghelles"},
    {"city": "Boursies"},
    {"city": "Bousbecque"},
    {"city": "Bousies"},
    {"city": "Bousignies"},
    {"city": "Bousignies-sur-Roc"},
    {"city": "Boussières-en-Cambrésis"},
    {"city": "Boussières-sur-Sambre"},
    {"city": "Boussois"},
    {"city": "Bouvignies"},
    {"city": "Bouvines"},
    {"city": "Bray-Dunes"},
    {"city": "Briastre"},
    {"city": "Brillon"},
    {"city": "Brouckerque"},
    {"city": "Broxeele"},
    {"city": "Bruay-sur-l'Escaut"},
    {"city": "Bruille-lez-Marchiennes"},
    {"city": "Bruille-Saint-Amand"},
    {"city": "Brunémont"},
    {"city": "Bry"},
    {"city": "Bugnicourt"},
    {"city": "Busigny"},
    {"city": "Buysscheure"},
    {"city": "Caëstre"},
    {"city": "Cagnoncles"},
    {"city": "Cambrai"},
    {"city": "Camphin-en-Carembault"},
    {"city": "Camphin-en-Pévèle"},
    {"city": "Cantaing-sur-Escaut"},
    {"city": "Cantin"},
    {"city": "Capelle"},
    {"city": "Capinghem"},
    {"city": "Cappelle-en-Pévèle"},
    {"city": "Cappelle-Brouck"},
    {"city": "Cappelle-la-Grande"},
    {"city": "Carnières"},
    {"city": "Carnin"},
    {"city": "Cartignies"},
    {"city": "Cassel"},
    {"city": "Le Cateau-Cambrésis"},
    {"city": "Catillon-sur-Sambre"},
    {"city": "Cattenières"},
    {"city": "Caudry"},
    {"city": "Caullery"},
    {"city": "Cauroir"},
    {"city": "Cerfontaine"},
    {"city": "La Chapelle-d'Armentières"},
    {"city": "Château-l'Abbaye"},
    {"city": "Chemy"},
    {"city": "Chéreng"},
    {"city": "Choisies"},
    {"city": "Clairfayts"},
    {"city": "Clary"},
    {"city": "Cobrieux"},
    {"city": "Colleret"},
    {"city": "Comines"},
    {"city": "Condé-sur-l'Escaut"},
    {"city": "Coudekerque-Branche"},
    {"city": "Courchelettes"},
    {"city": "Cousolre"},
    {"city": "Coutiches"},
    {"city": "Craywick"},
    {"city": "Crespin"},
    {"city": "Crèvecœur-sur-l'Escaut"},
    {"city": "Crochte"},
    {"city": "Croix"},
    {"city": "Croix-Caluyau"},
    {"city": "Cuincy"},
    {"city": "Curgies"},
    {"city": "Cuvillers"},
    {"city": "Cysoing"},
    {"city": "Damousies"},
    {"city": "Dechy"},
    {"city": "Dehéries"},
    {"city": "Denain"},
    {"city": "Deûlémont"},
    {"city": "Dimechaux"},
    {"city": "Dimont"},
    {"city": "Doignies"},
    {"city": "Dompierre-sur-Helpe"},
    {"city": "Douai"},
    {"city": "Douchy-les-Mines"},
    {"city": "Le Doulieu"},
    {"city": "Dourlers"},
    {"city": "Drincham"},
    {"city": "Dunkerque"},
    {"city": "Ebblinghem"},
    {"city": "Écaillon"},
    {"city": "Eccles"},
    {"city": "Éclaibes"},
    {"city": "Écuélin"},
    {"city": "Eecke"},
    {"city": "Élesmes"},
    {"city": "Élincourt"},
    {"city": "Émerchicourt"},
    {"city": "Emmerin"},
    {"city": "Englefontaine"},
    {"city": "Englos"},
    {"city": "Ennetières-en-Weppes"},
    {"city": "Ennevelin"},
    {"city": "Eppe-Sauvage"},
    {"city": "Erchin"},
    {"city": "Eringhem"},
    {"city": "Erquinghem-le-Sec"},
    {"city": "Erquinghem-Lys"},
    {"city": "Erre"},
    {"city": "Escarmain"},
    {"city": "Escaudain"},
    {"city": "Escaudœuvres"},
    {"city": "Escautpont"},
    {"city": "Escobecques"},
    {"city": "Esnes"},
    {"city": "Esquelbecq"},
    {"city": "Esquerchin"},
    {"city": "Estaires"},
    {"city": "Estourmel"},
    {"city": "Estrées"},
    {"city": "Estreux"},
    {"city": "Eswars"},
    {"city": "Eth"},
    {"city": "Étrœungt"},
    {"city": "Estrun"},
    {"city": "Faches-Thumesnil"},
    {"city": "Famars"},
    {"city": "Faumont"},
    {"city": "Le Favril"},
    {"city": "Féchain"},
    {"city": "Feignies"},
    {"city": "Felleries"},
    {"city": "Fenain"},
    {"city": "Férin"},
    {"city": "Féron"},
    {"city": "Ferrière-la-Grande"},
    {"city": "Ferrière-la-Petite"},
    {"city": "La Flamengrie"},
    {"city": "Flaumont-Waudrechies"},
    {"city": "Flers-en-Escrebieux"},
    {"city": "Flesquières"},
    {"city": "Flêtre"},
    {"city": "Flines-lès-Mortagne"},
    {"city": "Flines-lez-Raches"},
    {"city": "Floursies"},
    {"city": "Floyon"},
    {"city": "Fontaine-au-Bois"},
    {"city": "Fontaine-au-Pire"},
    {"city": "Fontaine-Notre-Dame"},
    {"city": "Forest-en-Cambrésis"},
    {"city": "Forest-sur-Marque"},
    {"city": "Fourmies"},
    {"city": "Fournes-en-Weppes"},
    {"city": "Frasnoy"},
    {"city": "Frelinghien"},
    {"city": "Fresnes-sur-Escaut"},
    {"city": "Fressain"},
    {"city": "Fressies"},
    {"city": "Fretin"},
    {"city": "Fromelles"},
    {"city": "Genech"},
    {"city": "Ghissignies"},
    {"city": "Ghyvelde"},
    {"city": "Glageon"},
    {"city": "Godewaersvelde"},
    {"city": "Gœulzin"},
    {"city": "Gognies-Chaussée"},
    {"city": "Gommegnies"},
    {"city": "Gondecourt"},
    {"city": "Gonnelieu"},
    {"city": "La Gorgue"},
    {"city": "Gouzeaucourt"},
    {"city": "Grand-Fayt"},
    {"city": "Grande-Synthe"},
    {"city": "Grand-Fort-Philippe"},
    {"city": "Gravelines"},
    {"city": "La Groise"},
    {"city": "Gruson"},
    {"city": "Guesnain"},
    {"city": "Gussignies"},
    {"city": "Hallennes-lez-Haubourdin"},
    {"city": "Halluin"},
    {"city": "Hamel"},
    {"city": "Hantay"},
    {"city": "Hardifort"},
    {"city": "Hargnies"},
    {"city": "Hasnon"},
    {"city": "Haspres"},
    {"city": "Haubourdin"},
    {"city": "Haucourt-en-Cambrésis"},
    {"city": "Haulchin"},
    {"city": "Haussy"},
    {"city": "Haut-Lieu"},
    {"city": "Hautmont"},
    {"city": "Haveluy"},
    {"city": "Haverskerque"},
    {"city": "Haynecourt"},
    {"city": "Hazebrouck"},
    {"city": "Hecq"},
    {"city": "Hélesmes"},
    {"city": "Hem"},
    {"city": "Hem-Lenglet"},
    {"city": "Hergnies"},
    {"city": "Hérin"},
    {"city": "Herlies"},
    {"city": "Herrin"},
    {"city": "Herzeele"},
    {"city": "Hestrud"},
    {"city": "Holque"},
    {"city": "Hondeghem"},
    {"city": "Hondschoote"},
    {"city": "Hon-Hergies"},
    {"city": "Honnechy"},
    {"city": "Honnecourt-sur-Escaut"},
    {"city": "Hordain"},
    {"city": "Hornaing"},
    {"city": "Houdain-lez-Bavay"},
    {"city": "Houplin-Ancoisne"},
    {"city": "Houplines"},
    {"city": "Houtkerque"},
    {"city": "Hoymille"},
    {"city": "Illies"},
    {"city": "Inchy"},
    {"city": "Iwuy"},
    {"city": "Jenlain"},
    {"city": "Jeumont"},
    {"city": "Jolimetz"},
    {"city": "Killem"},
    {"city": "Lallaing"},
    {"city": "Lambersart"},
    {"city": "Lambres-lez-Douai"},
    {"city": "Landas"},
    {"city": "Landrecies"},
    {"city": "Lannoy"},
    {"city": "Larouillies"},
    {"city": "Lauwin-Planque"},
    {"city": "Lecelles"},
    {"city": "Lécluse"},
    {"city": "Lederzeele"},
    {"city": "Ledringhem"},
    {"city": "Leers"},
    {"city": "Leffrinckoucke"},
    {"city": "Lesdain"},
    {"city": "Lez-Fontaine"},
    {"city": "Lesquin"},
    {"city": "Leval"},
    {"city": "Lewarde"},
    {"city": "Lezennes"},
    {"city": "Liessies"},
    {"city": "Lieu-Saint-Amand"},
    {"city": "Ligny-en-Cambrésis"},
    {"city": "Lille"},
    {"city": "Limont-Fontaine"},
    {"city": "Linselles"},
    {"city": "Locquignol"},
    {"city": "Loffre"},
    {"city": "Lompret"},
    {"city": "La Longueville"},
    {"city": "Looberghe"},
    {"city": "Loon-Plage"},
    {"city": "Loos"},
    {"city": "Lourches"},
    {"city": "Louvignies-Quesnoy"},
    {"city": "Louvil"},
    {"city": "Louvroil"},
    {"city": "Lynde"},
    {"city": "Lys-lez-Lannoy"},
    {"city": "La Madeleine"},
    {"city": "Maing"},
    {"city": "Mairieux"},
    {"city": "Le Maisnil"},
    {"city": "Malincourt"},
    {"city": "Marbaix"},
    {"city": "Marchiennes"},
    {"city": "Marcoing"},
    {"city": "Marcq-en-Barœul"},
    {"city": "Marcq-en-Ostrevent"},
    {"city": "Maresches"},
    {"city": "Maretz"},
    {"city": "Marly"},
    {"city": "Maroilles"},
    {"city": "Marpent"},
    {"city": "Marquette-lez-Lille"},
    {"city": "Marquette-en-Ostrevant"},
    {"city": "Marquillies"},
    {"city": "Masnières"},
    {"city": "Masny"},
    {"city": "Mastaing"},
    {"city": "Maubeuge"},
    {"city": "Maulde"},
    {"city": "Maurois"},
    {"city": "Mazinghien"},
    {"city": "Mecquignies"},
    {"city": "Merckeghem"},
    {"city": "Mérignies"},
    {"city": "Merris"},
    {"city": "Merville"},
    {"city": "Méteren"},
    {"city": "Millam"},
    {"city": "Millonfosse"},
    {"city": "Mœuvres"},
    {"city": "Monceau-Saint-Waast"},
    {"city": "Monchaux-sur-Écaillon"},
    {"city": "Moncheaux"},
    {"city": "Monchecourt"},
    {"city": "Mons-en-Barœul"},
    {"city": "Mons-en-Pévèle"},
    {"city": "Montay"},
    {"city": "Montigny-en-Cambrésis"},
    {"city": "Montigny-en-Ostrevent"},
    {"city": "Montrécourt"},
    {"city": "Morbecque"},
    {"city": "Mortagne-du-Nord"},
    {"city": "Mouchin"},
    {"city": "Moustier-en-Fagne"},
    {"city": "Mouvaux"},
    {"city": "Naves"},
    {"city": "Neuf-Berquin"},
    {"city": "Neuf-Mesnil"},
    {"city": "Neuville-en-Avesnois"},
    {"city": "Neuville-en-Ferrain"},
    {"city": "La Neuville"},
    {"city": "Neuville-Saint-Rémy"},
    {"city": "Neuville-sur-Escaut"},
    {"city": "Neuvilly"},
    {"city": "Nieppe"},
    {"city": "Niergnies"},
    {"city": "Nieurlet"},
    {"city": "Nivelle"},
    {"city": "Nomain"},
    {"city": "Noordpeene"},
    {"city": "Noyelles-lès-Seclin"},
    {"city": "Noyelles-sur-Escaut"},
    {"city": "Noyelles-sur-Sambre"},
    {"city": "Noyelles-sur-Selle"},
    {"city": "Obies"},
    {"city": "Obrechies"},
    {"city": "Ochtezeele"},
    {"city": "Odomez"},
    {"city": "Ohain"},
    {"city": "Oisy"},
    {"city": "Onnaing"},
    {"city": "Oost-Cappel"},
    {"city": "Orchies"},
    {"city": "Ors"},
    {"city": "Orsinval"},
    {"city": "Ostricourt"},
    {"city": "Oudezeele"},
    {"city": "Oxelaëre"},
    {"city": "Paillencourt"},
    {"city": "Pecquencourt"},
    {"city": "Pérenchies"},
    {"city": "Péronne-en-Mélantois"},
    {"city": "Petite-Forêt"},
    {"city": "Petit-Fayt"},
    {"city": "Phalempin"},
    {"city": "Pitgam"},
    {"city": "Poix-du-Nord"},
    {"city": "Pommereuil"},
    {"city": "Pont-à-Marcq"},
    {"city": "Pont-sur-Sambre"},
    {"city": "Potelle"},
    {"city": "Pradelles"},
    {"city": "Prémesques"},
    {"city": "Préseau"},
    {"city": "Preux-au-Bois"},
    {"city": "Preux-au-Sart"},
    {"city": "Prisches"},
    {"city": "Prouvy"},
    {"city": "Proville"},
    {"city": "Provin"},
    {"city": "Quaëdypre"},
    {"city": "Quarouble"},
    {"city": "Quérénaing"},
    {"city": "Le Quesnoy"},
    {"city": "Quesnoy-sur-Deûle"},
    {"city": "Quiévelon"},
    {"city": "Quiévrechain"},
    {"city": "Quiévy"},
    {"city": "Râches"},
    {"city": "Radinghem-en-Weppes"},
    {"city": "Raillencourt-Sainte-Olle"},
    {"city": "Raimbeaucourt"},
    {"city": "Rainsars"},
    {"city": "Raismes"},
    {"city": "Ramillies"},
    {"city": "Ramousies"},
    {"city": "Raucourt-au-Bois"},
    {"city": "Recquignies"},
    {"city": "Rejet-de-Beaulieu"},
    {"city": "Renescure"},
    {"city": "Reumont"},
    {"city": "Rexpoëde"},
    {"city": "Ribécourt-la-Tour"},
    {"city": "Rieulay"},
    {"city": "Rieux-en-Cambrésis"},
    {"city": "Robersart"},
    {"city": "Rœulx"},
    {"city": "Rombies-et-Marchipont"},
    {"city": "Romeries"},
    {"city": "Ronchin"},
    {"city": "Roncq"},
    {"city": "Roost-Warendin"},
    {"city": "Rosult"},
    {"city": "Roubaix"},
    {"city": "Roucourt"},
    {"city": "Rousies"},
    {"city": "Rouvignies"},
    {"city": "Rubrouck"},
    {"city": "Les Rues-des-Vignes"},
    {"city": "Ruesnes"},
    {"city": "Rumegies"},
    {"city": "Rumilly-en-Cambrésis"},
    {"city": "Sailly-lez-Cambrai"},
    {"city": "Sailly-lez-Lannoy"},
    {"city": "Sainghin-en-Mélantois"},
    {"city": "Sainghin-en-Weppes"},
    {"city": "Sains-du-Nord"},
    {"city": "Saint-Amand-les-Eaux"},
    {"city": "Saint-André-lez-Lille"},
    {"city": "Saint-Aubert"},
    {"city": "Saint-Aubin"},
    {"city": "Saint-Aybert"},
    {"city": "Saint-Benin"},
    {"city": "Saint-Georges-sur-l'Aa"},
    {"city": "Saint-Hilaire-lez-Cambrai"},
    {"city": "Saint-Hilaire-sur-Helpe"},
    {"city": "Saint-Jans-Cappel"},
    {"city": "Sainte-Marie-Cappel"},
    {"city": "Saint-Martin-sur-Écaillon"},
    {"city": "Saint-Momelin"},
    {"city": "Saint-Pierre-Brouck"},
    {"city": "Saint-Python"},
    {"city": "Saint-Remy-Chaussée"},
    {"city": "Saint-Remy-du-Nord"},
    {"city": "Saint-Saulve"},
    {"city": "Saint-Souplet"},
    {"city": "Saint-Sylvestre-Cappel"},
    {"city": "Saint-Vaast-en-Cambrésis"},
    {"city": "Saint-Waast"},
    {"city": "Salesches"},
    {"city": "Salomé"},
    {"city": "Saméon"},
    {"city": "Sancourt"},
    {"city": "Santes"},
    {"city": "Sars-et-Rosières"},
    {"city": "Sars-Poteries"},
    {"city": "Sassegnies"},
    {"city": "Saultain"},
    {"city": "Saulzoir"},
    {"city": "Sebourg"},
    {"city": "Seclin"},
    {"city": "Sémeries"},
    {"city": "Semousies"},
    {"city": "La Sentinelle"},
    {"city": "Sepmeries"},
    {"city": "Sequedin"},
    {"city": "Séranvillers-Forenville"},
    {"city": "Sercus"},
    {"city": "Sin-le-Noble"},
    {"city": "Socx"},
    {"city": "Solesmes"},
    {"city": "Solre-le-Château"},
    {"city": "Solrinnes"},
    {"city": "Somain"},
    {"city": "Sommaing"},
    {"city": "Spycker"},
    {"city": "Staple"},
    {"city": "Steenbecque"},
    {"city": "Steene"},
    {"city": "Steenvoorde"},
    {"city": "Steenwerck"},
    {"city": "Strazeele"},
    {"city": "Taisnières-en-Thiérache"},
    {"city": "Taisnières-sur-Hon"},
    {"city": "Templemars"},
    {"city": "Templeuve-en-Pévèle"},
    {"city": "Terdeghem"},
    {"city": "Téteghem-Coudekerque-Village"},
    {"city": "Thiant"},
    {"city": "Thiennes"},
    {"city": "Thivencelle"},
    {"city": "Thumeries"},
    {"city": "Thun-l'Évêque"},
    {"city": "Thun-Saint-Amand"},
    {"city": "Thun-Saint-Martin"},
    {"city": "Tilloy-lez-Marchiennes"},
    {"city": "Tilloy-lez-Cambrai"},
    {"city": "Toufflers"},
    {"city": "Tourcoing"},
    {"city": "Tourmignies"},
    {"city": "Trélon"},
    {"city": "Tressin"},
    {"city": "Trith-Saint-Léger"},
    {"city": "Troisvilles"},
    {"city": "Uxem"},
    {"city": "Valenciennes"},
    {"city": "Vendegies-au-Bois"},
    {"city": "Vendegies-sur-Écaillon"},
    {"city": "Vendeville"},
    {"city": "Verchain-Maugré"},
    {"city": "Verlinghem"},
    {"city": "Vertain"},
    {"city": "Vicq"},
    {"city": "Viesly"},
    {"city": "Vieux-Berquin"},
    {"city": "Vieux-Condé"},
    {"city": "Vieux-Mesnil"},
    {"city": "Vieux-Reng"},
    {"city": "Villereau"},
    {"city": "Villers-au-Tertre"},
    {"city": "Villers-en-Cauchies"},
    {"city": "Villers-Guislain"},
    {"city": "Villers-Outréaux"},
    {"city": "Villers-Plouich"},
    {"city": "Villers-Pol"},
    {"city": "Villers-Sire-Nicole"},
    {"city": "Volckerinckhove"},
    {"city": "Vred"},
    {"city": "Wahagnies"},
    {"city": "Walincourt-Selvigny"},
    {"city": "Wallers"},
    {"city": "Wallers-en-Fagne"},
    {"city": "Wallon-Cappel"},
    {"city": "Wambaix"},
    {"city": "Wambrechies"},
    {"city": "Wandignies-Hamage"},
    {"city": "Wannehain"},
    {"city": "Wargnies-le-Grand"},
    {"city": "Wargnies-le-Petit"},
    {"city": "Warhem"},
    {"city": "Warlaing"},
    {"city": "Warneton"},
    {"city": "Wasnes-au-Bac"},
    {"city": "Wasquehal"},
    {"city": "Watten"},
    {"city": "Wattignies"},
    {"city": "Wattignies-la-Victoire"},
    {"city": "Wattrelos"},
    {"city": "Wavrechain-sous-Denain"},
    {"city": "Wavrechain-sous-Faulx"},
    {"city": "Wavrin"},
    {"city": "Waziers"},
    {"city": "Wemaers-Cappel"},
    {"city": "Wervicq-Sud"},
    {"city": "West-Cappel"},
    {"city": "Wicres"},
    {"city": "Wignehies"},
    {"city": "Willems"},
    {"city": "Willies"},
    {"city": "Winnezeele"},
    {"city": "Wormhout"},
    {"city": "Wulverdinghe"},
    {"city": "Wylder"},
    {"city": "Zegerscappel"},
    {"city": "Zermezeele"},
    {"city": "Zuydcoote"},
    {"city": "Zuytpeene"},
    {"city": "Don"},
    {"city": "Abancourt"},
    {"city": "Abbecourt"},
    {"city": "Abbeville-Saint-Lucien"},
    {"city": "Achy"},
    {"city": "Acy-en-Multien"},
    {"city": "Les Ageux"},
    {"city": "Agnetz"},
    {"city": "Airion"},
    {"city": "Allonne"},
    {"city": "Amblainville"},
    {"city": "Amy"},
    {"city": "Andeville"},
    {"city": "Angicourt"},
    {"city": "Angivillers"},
    {"city": "Angy"},
    {"city": "Ansacq"},
    {"city": "Ansauvillers"},
    {"city": "Antheuil-Portes"},
    {"city": "Antilly"},
    {"city": "Appilly"},
    {"city": "Apremont"},
    {"city": "Armancourt"},
    {"city": "Arsy"},
    {"city": "Attichy"},
    {"city": "Auchy-la-Montagne"},
    {"city": "Auger-Saint-Vincent"},
    {"city": "Aumont-en-Halatte"},
    {"city": "Auneuil"},
    {"city": "Auteuil"},
    {"city": "Autheuil-en-Valois"},
    {"city": "Autrêches"},
    {"city": "Avilly-Saint-Léonard"},
    {"city": "Avrechy"},
    {"city": "Avricourt"},
    {"city": "Avrigny"},
    {"city": "Babœuf"},
    {"city": "Bacouël"},
    {"city": "Bailleul-le-Soc"},
    {"city": "Bailleul-sur-Thérain"},
    {"city": "Bailleval"},
    {"city": "Bailly"},
    {"city": "Balagny-sur-Thérain"},
    {"city": "Barbery"},
    {"city": "Bargny"},
    {"city": "Baron"},
    {"city": "Baugy"},
    {"city": "Bazancourt"},
    {"city": "Bazicourt"},
    {"city": "Beaudéduit"},
    {"city": "Beaugies-sous-Bois"},
    {"city": "Beaulieu-les-Fontaines"},
    {"city": "Les Hauts-Talican"},
    {"city": "Beaurains-lès-Noyon"},
    {"city": "Beaurepaire"},
    {"city": "Beauvais"},
    {"city": "Beauvoir"},
    {"city": "Béhéricourt"},
    {"city": "Belle-Église"},
    {"city": "Belloy"},
    {"city": "Berlancourt"},
    {"city": "Berneuil-en-Bray"},
    {"city": "Berneuil-sur-Aisne"},
    {"city": "Berthecourt"},
    {"city": "Béthancourt-en-Valois"},
    {"city": "Béthisy-Saint-Martin"},
    {"city": "Béthisy-Saint-Pierre"},
    {"city": "Betz"},
    {"city": "Bienville"},
    {"city": "Biermont"},
    {"city": "Bitry"},
    {"city": "Blacourt"},
    {"city": "Blaincourt-lès-Précy"},
    {"city": "Blancfossé"},
    {"city": "Blargies"},
    {"city": "Blicourt"},
    {"city": "Blincourt"},
    {"city": "Boissy-Fresnoy"},
    {"city": "Bonlier"},
    {"city": "Bonneuil-les-Eaux"},
    {"city": "Bonneuil-en-Valois"},
    {"city": "Bonnières"},
    {"city": "Bonvillers"},
    {"city": "Boran-sur-Oise"},
    {"city": "Borest"},
    {"city": "Bornel"},
    {"city": "Boubiers"},
    {"city": "Bouconvillers"},
    {"city": "Bouillancy"},
    {"city": "Boullarre"},
    {"city": "Boulogne-la-Grasse"},
    {"city": "Boursonne"},
    {"city": "Boury-en-Vexin"},
    {"city": "Boutencourt"},
    {"city": "Bouvresse"},
    {"city": "Braisnes-sur-Aronde"},
    {"city": "Brasseuse"},
    {"city": "Brégy"},
    {"city": "Brenouille"},
    {"city": "Bresles"},
    {"city": "Breteuil"},
    {"city": "Brétigny"},
    {"city": "Breuil-le-Sec"},
    {"city": "Breuil-le-Vert"},
    {"city": "Briot"},
    {"city": "Brombos"},
    {"city": "Broquiers"},
    {"city": "Broyes"},
    {"city": "Brunvillers-la-Motte"},
    {"city": "Bucamps"},
    {"city": "Buicourt"},
    {"city": "Bulles"},
    {"city": "Bury"},
    {"city": "Bussy"},
    {"city": "Caisnes"},
    {"city": "Cambronne-lès-Ribécourt"},
    {"city": "Cambronne-lès-Clermont"},
    {"city": "Campagne"},
    {"city": "Campeaux"},
    {"city": "Campremy"},
    {"city": "Candor"},
    {"city": "Canly"},
    {"city": "Cannectancourt"},
    {"city": "Canny-sur-Matz"},
    {"city": "Canny-sur-Thérain"},
    {"city": "Carlepont"},
    {"city": "Catenoy"},
    {"city": "Catheux"},
    {"city": "Catigny"},
    {"city": "Catillon-Fumechon"},
    {"city": "Cauffry"},
    {"city": "Cauvigny"},
    {"city": "Cempuis"},
    {"city": "Cernoy"},
    {"city": "Chamant"},
    {"city": "Chambly"},
    {"city": "Chambors"},
    {"city": "Chantilly"},
    {"city": "La Chapelle-en-Serval"},
    {"city": "Chaumont-en-Vexin"},
    {"city": "Chavençon"},
    {"city": "Chelles"},
    {"city": "Chepoix"},
    {"city": "Chevincourt"},
    {"city": "Chèvreville"},
    {"city": "Chevrières"},
    {"city": "Chiry-Ourscamp"},
    {"city": "Choisy-au-Bac"},
    {"city": "Choisy-la-Victoire"},
    {"city": "Choqueuse-les-Bénards"},
    {"city": "Cinqueux"},
    {"city": "Cires-lès-Mello"},
    {"city": "Clairoix"},
    {"city": "Clermont"},
    {"city": "Coivrel"},
    {"city": "Compiègne"},
    {"city": "Conchy-les-Pots"},
    {"city": "Conteville"},
    {"city": "Corbeil-Cerf"},
    {"city": "Cormeilles"},
    {"city": "Le Coudray-Saint-Germer"},
    {"city": "Le Coudray-sur-Thelle"},
    {"city": "Coudun"},
    {"city": "Couloisy"},
    {"city": "Courcelles-Epayelles"},
    {"city": "Courcelles-lès-Gisors"},
    {"city": "Courteuil"},
    {"city": "Courtieux"},
    {"city": "Coye-la-Forêt"},
    {"city": "Cramoisy"},
    {"city": "Crapeaumesnil"},
    {"city": "Creil"},
    {"city": "Crépy-en-Valois"},
    {"city": "Cressonsacq"},
    {"city": "Crèvecœur-le-Grand"},
    {"city": "Crèvecœur-le-Petit"},
    {"city": "Crillon"},
    {"city": "Crisolles"},
    {"city": "Le Crocq"},
    {"city": "Croissy-sur-Celle"},
    {"city": "Croutoy"},
    {"city": "Crouy-en-Thelle"},
    {"city": "Cuignières"},
    {"city": "Cuigy-en-Bray"},
    {"city": "Cuise-la-Motte"},
    {"city": "Cuts"},
    {"city": "Cuvergnon"},
    {"city": "Cuvilly"},
    {"city": "Cuy"},
    {"city": "Daméraucourt"},
    {"city": "Dargies"},
    {"city": "Delincourt"},
    {"city": "La Drenne"},
    {"city": "Dieudonné"},
    {"city": "Dives"},
    {"city": "Doméliers"},
    {"city": "Domfront"},
    {"city": "Dompierre"},
    {"city": "Duvy"},
    {"city": "Écuvilly"},
    {"city": "Élencourt"},
    {"city": "Élincourt-Sainte-Marguerite"},
    {"city": "Éméville"},
    {"city": "Énencourt-Léage"},
    {"city": "La Corne-en-Vexin"},
    {"city": "Épineuse"},
    {"city": "Éragny-sur-Epte"},
    {"city": "Ercuis"},
    {"city": "Ermenonville"},
    {"city": "Ernemont-Boutavent"},
    {"city": "Erquery"},
    {"city": "Erquinvillers"},
    {"city": "Escames"},
    {"city": "Esches"},
    {"city": "Escles-Saint-Pierre"},
    {"city": "Espaubourg"},
    {"city": "Esquennoy"},
    {"city": "Essuiles"},
    {"city": "Estrées-Saint-Denis"},
    {"city": "Étavigny"},
    {"city": "Étouy"},
    {"city": "Ève"},
    {"city": "Évricourt"},
    {"city": "Fay-les-Étangs"},
    {"city": "Le Fayel"},
    {"city": "Le Fay-Saint-Quentin"},
    {"city": "Feigneux"},
    {"city": "Ferrières"},
    {"city": "Feuquières"},
    {"city": "Fitz-James"},
    {"city": "Flavacourt"},
    {"city": "Flavy-le-Meldeux"},
    {"city": "Fléchy"},
    {"city": "Fleurines"},
    {"city": "Fleury"},
    {"city": "Fontaine-Bonneleau"},
    {"city": "Fontaine-Chaalis"},
    {"city": "Fontaine-Lavaganne"},
    {"city": "Fontaine-Saint-Lucien"},
    {"city": "Fontenay-Torcy"},
    {"city": "Formerie"},
    {"city": "Fouilleuse"},
    {"city": "Fouilloy"},
    {"city": "Foulangues"},
    {"city": "Fouquenies"},
    {"city": "Fouquerolles"},
    {"city": "Fournival"},
    {"city": "Francastel"},
    {"city": "Francières"},
    {"city": "Fréniches"},
    {"city": "Montchevreuil"},
    {"city": "Fresne-Léguillon"},
    {"city": "Fresnières"},
    {"city": "Fresnoy-en-Thelle"},
    {"city": "Fresnoy-la-Rivière"},
    {"city": "Fresnoy-le-Luat"},
    {"city": "Le Frestoy-Vaux"},
    {"city": "Frétoy-le-Château"},
    {"city": "Frocourt"},
    {"city": "Froissy"},
    {"city": "Le Gallet"},
    {"city": "Gannes"},
    {"city": "Gaudechart"},
    {"city": "Genvry"},
    {"city": "Gerberoy"},
    {"city": "Gilocourt"},
    {"city": "Giraumont"},
    {"city": "Glaignes"},
    {"city": "Glatigny"},
    {"city": "Godenvillers"},
    {"city": "Goincourt"},
    {"city": "Golancourt"},
    {"city": "Gondreville"},
    {"city": "Gourchelles"},
    {"city": "Gournay-sur-Aronde"},
    {"city": "Gouvieux"},
    {"city": "Gouy-les-Groseillers"},
    {"city": "Grandfresnoy"},
    {"city": "Grandvillers-aux-Bois"},
    {"city": "Grandvilliers"},
    {"city": "Grandrû"},
    {"city": "Grémévillers"},
    {"city": "Grez"},
    {"city": "Guignecourt"},
    {"city": "Guiscard"},
    {"city": "Gury"},
    {"city": "Hadancourt-le-Haut-Clocher"},
    {"city": "Hainvillers"},
    {"city": "Halloy"},
    {"city": "Hannaches"},
    {"city": "Le Hamel"},
    {"city": "Hanvoile"},
    {"city": "Hardivillers"},
    {"city": "Haucourt"},
    {"city": "Haudivillers"},
    {"city": "Hautbos"},
    {"city": "Haute-Épine"},
    {"city": "Hautefontaine"},
    {"city": "Hécourt"},
    {"city": "Heilles"},
    {"city": "Hémévillers"},
    {"city": "Hénonville"},
    {"city": "Herchies"},
    {"city": "La Hérelle"},
    {"city": "Héricourt-sur-Thérain"},
    {"city": "Hermes"},
    {"city": "Hétomesnil"},
    {"city": "Hodenc-en-Bray"},
    {"city": "Hodenc-l'Évêque"},
    {"city": "Hondainville"},
    {"city": "Houdancourt"},
    {"city": "La Houssoye"},
    {"city": "Ivors"},
    {"city": "Ivry-le-Temple"},
    {"city": "Jaméricourt"},
    {"city": "Janville"},
    {"city": "Jaulzy"},
    {"city": "Jaux"},
    {"city": "Jonquières"},
    {"city": "Jouy-sous-Thelle"},
    {"city": "Juvignies"},
    {"city": "Laberlière"},
    {"city": "Laboissière-en-Thelle"},
    {"city": "Labosse"},
    {"city": "Labruyère"},
    {"city": "Lachapelle-aux-Pots"},
    {"city": "Lachapelle-Saint-Pierre"},
    {"city": "Lachapelle-sous-Gerberoy"},
    {"city": "Lachaussée-du-Bois-d'Écu"},
    {"city": "Lachelle"},
    {"city": "Lacroix-Saint-Ouen"},
    {"city": "Lafraye"},
    {"city": "Lagny"},
    {"city": "Lagny-le-Sec"},
    {"city": "Laigneville"},
    {"city": "Lalande-en-Son"},
    {"city": "Lalandelle"},
    {"city": "Lamécourt"},
    {"city": "Lamorlaye"},
    {"city": "Lannoy-Cuillère"},
    {"city": "Larbroye"},
    {"city": "Lassigny"},
    {"city": "Lataule"},
    {"city": "Lattainville"},
    {"city": "Lavacquerie"},
    {"city": "Laverrière"},
    {"city": "Laversines"},
    {"city": "Lavilletertre"},
    {"city": "Léglantiers"},
    {"city": "Lévignen"},
    {"city": "Lhéraule"},
    {"city": "Liancourt"},
    {"city": "Liancourt-Saint-Pierre"},
    {"city": "Libermont"},
    {"city": "Lierville"},
    {"city": "Lieuvillers"},
    {"city": "Lihus"},
    {"city": "Litz"},
    {"city": "Loconville"},
    {"city": "Longueil-Annel"},
    {"city": "Longueil-Sainte-Marie"},
    {"city": "Lormaison"},
    {"city": "Loueuse"},
    {"city": "Luchy"},
    {"city": "Machemont"},
    {"city": "Maignelay-Montigny"},
    {"city": "Maimbeville"},
    {"city": "Maisoncelle-Saint-Pierre"},
    {"city": "Maisoncelle-Tuilerie"},
    {"city": "Marest-sur-Matz"},
    {"city": "Mareuil-la-Motte"},
    {"city": "Mareuil-sur-Ourcq"},
    {"city": "Margny-aux-Cerises"},
    {"city": "Margny-lès-Compiègne"},
    {"city": "Margny-sur-Matz"},
    {"city": "Marolles"},
    {"city": "Marquéglise"},
    {"city": "Marseille-en-Beauvaisis"},
    {"city": "Martincourt"},
    {"city": "Maucourt"},
    {"city": "Maulers"},
    {"city": "Maysel"},
    {"city": "Mélicocq"},
    {"city": "Mello"},
    {"city": "Ménévillers"},
    {"city": "Méru"},
    {"city": "Méry-la-Bataille"},
    {"city": "Le Mesnil-Conteville"},
    {"city": "Le Mesnil-en-Thelle"},
    {"city": "Le Mesnil-Saint-Firmin"},
    {"city": "Le Mesnil-sur-Bulles"},
    {"city": "Le Mesnil-Théribus"},
    {"city": "Le Meux"},
    {"city": "Milly-sur-Thérain"},
    {"city": "Mogneville"},
    {"city": "Moliens"},
    {"city": "Monceaux"},
    {"city": "Monceaux-l'Abbaye"},
    {"city": "Monchy-Humières"},
    {"city": "Monchy-Saint-Éloi"},
    {"city": "Mondescourt"},
    {"city": "Monneville"},
    {"city": "Montagny-en-Vexin"},
    {"city": "Montagny-Sainte-Félicité"},
    {"city": "Montataire"},
    {"city": "Montépilloy"},
    {"city": "Montgérain"},
    {"city": "Montiers"},
    {"city": "Montjavoult"},
    {"city": "Mont-l'Évêque"},
    {"city": "Montlognon"},
    {"city": "Montmacq"},
    {"city": "Montmartin"},
    {"city": "Montreuil-sur-Brêche"},
    {"city": "Montreuil-sur-Thérain"},
    {"city": "Monts"},
    {"city": "Le Mont-Saint-Adrien"},
    {"city": "Morangles"},
    {"city": "Morienval"},
    {"city": "Morlincourt"},
    {"city": "Mortefontaine"},
    {"city": "Mortefontaine-en-Thelle"},
    {"city": "Mortemer"},
    {"city": "Morvillers"},
    {"city": "Mory-Montcrux"},
    {"city": "Mouchy-le-Châtel"},
    {"city": "Moulin-sous-Touvent"},
    {"city": "Mouy"},
    {"city": "Moyenneville"},
    {"city": "Moyvillers"},
    {"city": "Muidorge"},
    {"city": "Muirancourt"},
    {"city": "Mureaumont"},
    {"city": "Nampcel"},
    {"city": "Nanteuil-le-Haudouin"},
    {"city": "Néry"},
    {"city": "Neufchelles"},
    {"city": "Neufvy-sur-Aronde"},
    {"city": "Neuilly-en-Thelle"},
    {"city": "Neuilly-sous-Clermont"},
    {"city": "Neuville-Bosc"},
    {"city": "La Neuville-en-Hez"},
    {"city": "La Neuville-Roy"},
    {"city": "La Neuville-Saint-Pierre"},
    {"city": "La Neuville-sur-Oudeuil"},
    {"city": "La Neuville-sur-Ressons"},
    {"city": "La Neuville-Vault"},
    {"city": "Nivillers"},
    {"city": "Noailles"},
    {"city": "Nogent-sur-Oise"},
    {"city": "Nointel"},
    {"city": "Noirémont"},
    {"city": "Noroy"},
    {"city": "Nourard-le-Franc"},
    {"city": "Novillers"},
    {"city": "Noyers-Saint-Martin"},
    {"city": "Noyon"},
    {"city": "Offoy"},
    {"city": "Ognes"},
    {"city": "Ognolles"},
    {"city": "Omécourt"},
    {"city": "Ons-en-Bray"},
    {"city": "Ormoy-le-Davien"},
    {"city": "Ormoy-Villers"},
    {"city": "Oroër"},
    {"city": "Orrouy"},
    {"city": "Orry-la-Ville"},
    {"city": "Orvillers-Sorel"},
    {"city": "Oudeuil"},
    {"city": "Oursel-Maison"},
    {"city": "Paillart"},
    {"city": "Parnes"},
    {"city": "Passel"},
    {"city": "Péroy-les-Gombries"},
    {"city": "Pierrefitte-en-Beauvaisis"},
    {"city": "Pierrefonds"},
    {"city": "Pimprez"},
    {"city": "Pisseleu"},
    {"city": "Plailly"},
    {"city": "Plainval"},
    {"city": "Plainville"},
    {"city": "Le Plessier-sur-Bulles"},
    {"city": "Le Plessier-sur-Saint-Just"},
    {"city": "Plessis-de-Roye"},
    {"city": "Le Plessis-Belleville"},
    {"city": "Le Plessis-Brion"},
    {"city": "Le Plessis-Patte-d'Oie"},
    {"city": "Le Ployron"},
    {"city": "Ponchon"},
    {"city": "Pontarmé"},
    {"city": "Pont-l'Évêque"},
    {"city": "Pontoise-lès-Noyon"},
    {"city": "Pontpoint"},
    {"city": "Pont-Sainte-Maxence"},
    {"city": "Porcheux"},
    {"city": "Porquéricourt"},
    {"city": "Pouilly"},
    {"city": "Précy-sur-Oise"},
    {"city": "Prévillers"},
    {"city": "Pronleroy"},
    {"city": "Puiseux-en-Bray"},
    {"city": "Puiseux-le-Hauberger"},
    {"city": "Puits-la-Vallée"},
    {"city": "Quesmy"},
    {"city": "Le Quesnel-Aubry"},
    {"city": "Quincampoix-Fleuzy"},
    {"city": "Quinquempoix"},
    {"city": "Rainvillers"},
    {"city": "Rantigny"},
    {"city": "Raray"},
    {"city": "Ravenel"},
    {"city": "Réez-Fosse-Martin"},
    {"city": "Reilly"},
    {"city": "Rémécourt"},
    {"city": "Rémérangles"},
    {"city": "Remy"},
    {"city": "Ressons-sur-Matz"},
    {"city": "Rethondes"},
    {"city": "Reuil-sur-Brêche"},
    {"city": "Rhuis"},
    {"city": "Ribécourt-Dreslincourt"},
    {"city": "Ricquebourg"},
    {"city": "Rieux"},
    {"city": "Rivecourt"},
    {"city": "Roberval"},
    {"city": "Rochy-Condé"},
    {"city": "Rocquemont"},
    {"city": "Rocquencourt"},
    {"city": "Romescamps"},
    {"city": "Rosières"},
    {"city": "Rosoy"},
    {"city": "Rosoy-en-Multien"},
    {"city": "Rotangy"},
    {"city": "Rothois"},
    {"city": "Rousseloy"},
    {"city": "Rouville"},
    {"city": "Rouvillers"},
    {"city": "Rouvres-en-Multien"},
    {"city": "Rouvroy-les-Merles"},
    {"city": "Royaucourt"},
    {"city": "Roy-Boissy"},
    {"city": "Roye-sur-Matz"},
    {"city": "La Rue-Saint-Pierre"},
    {"city": "Rully"},
    {"city": "Russy-Bémont"},
    {"city": "Sacy-le-Grand"},
    {"city": "Sacy-le-Petit"},
    {"city": "Sains-Morainvillers"},
    {"city": "Saint-André-Farivillers"},
    {"city": "Saint-Arnoult"},
    {"city": "Saint-Aubin-en-Bray"},
    {"city": "Saint-Aubin-sous-Erquery"},
    {"city": "Saint-Crépin-aux-Bois"},
    {"city": "Saint-Crépin-Ibouvillers"},
    {"city": "Saint-Deniscourt"},
    {"city": "Saint-Étienne-Roilaye"},
    {"city": "Sainte-Eusoye"},
    {"city": "Saint-Félix"},
    {"city": "Sainte-Geneviève"},
    {"city": "Saint-Germain-la-Poterie"},
    {"city": "Saint-Germer-de-Fly"},
    {"city": "Saintines"},
    {"city": "Saint-Jean-aux-Bois"},
    {"city": "Saint-Just-en-Chaussée"},
    {"city": "Saint-Léger-aux-Bois"},
    {"city": "Saint-Léger-en-Bray"},
    {"city": "Saint-Leu-d'Esserent"},
    {"city": "Saint-Martin-aux-Bois"},
    {"city": "Saint-Martin-le-Nœud"},
    {"city": "Saint-Martin-Longueau"},
    {"city": "Saint-Maur"},
    {"city": "Saint-Maximin"},
    {"city": "Saint-Omer-en-Chaussée"},
    {"city": "Saint-Paul"},
    {"city": "Saint-Pierre-es-Champs"},
    {"city": "Saint-Pierre-lès-Bitry"},
    {"city": "Saint-Quentin-des-Prés"},
    {"city": "Saint-Remy-en-l'Eau"},
    {"city": "Saint-Samson-la-Poterie"},
    {"city": "Saint-Sauveur"},
    {"city": "Saint-Sulpice"},
    {"city": "Saint-Thibault"},
    {"city": "Saint-Vaast-de-Longmont"},
    {"city": "Saint-Vaast-lès-Mello"},
    {"city": "Saint-Valery"},
    {"city": "Salency"},
    {"city": "Sarcus"},
    {"city": "Sarnois"},
    {"city": "Le Saulchoy"},
    {"city": "Savignies"},
    {"city": "Sempigny"},
    {"city": "Senantes"},
    {"city": "Senlis"},
    {"city": "Senots"},
    {"city": "Serans"},
    {"city": "Sérévillers"},
    {"city": "Sérifontaine"},
    {"city": "Sermaize"},
    {"city": "Séry-Magneval"},
    {"city": "Silly-le-Long"},
    {"city": "Silly-Tillard"},
    {"city": "Solente"},
    {"city": "Sommereux"},
    {"city": "Songeons"},
    {"city": "Sully"},
    {"city": "Suzoy"},
    {"city": "Talmontiers"},
    {"city": "Tartigny"},
    {"city": "Therdonne"},
    {"city": "Thérines"},
    {"city": "Thibivillers"},
    {"city": "Thiers-sur-Thève"},
    {"city": "Thiescourt"},
    {"city": "Thieuloy-Saint-Antoine"},
    {"city": "Thieux"},
    {"city": "Thiverny"},
    {"city": "Thourotte"},
    {"city": "Thury-en-Valois"},
    {"city": "Thury-sous-Clermont"},
    {"city": "Tillé"},
    {"city": "Tourly"},
    {"city": "Tracy-le-Mont"},
    {"city": "Tracy-le-Val"},
    {"city": "Tricot"},
    {"city": "Trie-Château"},
    {"city": "Trie-la-Ville"},
    {"city": "Troissereux"},
    {"city": "Trosly-Breuil"},
    {"city": "Troussencourt"},
    {"city": "Trumilly"},
    {"city": "Ully-Saint-Georges"},
    {"city": "Valdampierre"},
    {"city": "Valescourt"},
    {"city": "Vandélicourt"},
    {"city": "Varesnes"},
    {"city": "Varinfroy"},
    {"city": "Vauchelles"},
    {"city": "Vauciennes"},
    {"city": "Vaudancourt"},
    {"city": "Le Vaumain"},
    {"city": "Vaumoise"},
    {"city": "Le Vauroux"},
    {"city": "Velennes"},
    {"city": "Vendeuil-Caply"},
    {"city": "Venette"},
    {"city": "Ver-sur-Launette"},
    {"city": "Verberie"},
    {"city": "Verderel-lès-Sauqueuse"},
    {"city": "Verderonne"},
    {"city": "Verneuil-en-Halatte"},
    {"city": "Versigny"},
    {"city": "Vez"},
    {"city": "Viefvillers"},
    {"city": "Vieux-Moulin"},
    {"city": "Vignemont"},
    {"city": "Ville"},
    {"city": "Villembray"},
    {"city": "Villeneuve-les-Sablons"},
    {"city": "La Villeneuve-sous-Thury"},
    {"city": "Villeneuve-sur-Verberie"},
    {"city": "Villers-Saint-Barthélemy"},
    {"city": "Villers-Saint-Frambourg-Ognon"},
    {"city": "Villers-Saint-Genest"},
    {"city": "Villers-Saint-Paul"},
    {"city": "Villers-Saint-Sépulcre"},
    {"city": "Villers-sous-Saint-Leu"},
    {"city": "Villers-sur-Auchy"},
    {"city": "Villers-sur-Bonnières"},
    {"city": "Villers-sur-Coudun"},
    {"city": "Villers-Vermont"},
    {"city": "Villers-Vicomte"},
    {"city": "Villeselve"},
    {"city": "Vineuil-Saint-Firmin"},
    {"city": "Vrocourt"},
    {"city": "Wacquemoulin"},
    {"city": "Wambez"},
    {"city": "Warluis"},
    {"city": "Wavignies"},
    {"city": "Welles-Pérennes"},
    {"city": "Aux Marais"},
    {"city": "Alençon"},
    {"city": "Almenêches"},
    {"city": "Appenai-sous-Bellême"},
    {"city": "Argentan"},
    {"city": "Athis-Val de Rouvre"},
    {"city": "Aube"},
    {"city": "Aubry-le-Panthou"},
    {"city": "Aubusson"},
    {"city": "Auguaise"},
    {"city": "Aunay-les-Bois"},
    {"city": "Aunou-le-Faucon"},
    {"city": "Aunou-sur-Orne"},
    {"city": "Les Authieux-du-Puits"},
    {"city": "Avernes-Saint-Gourgon"},
    {"city": "Avoine"},
    {"city": "Avrilly"},
    {"city": "Bailleul"},
    {"city": "Banvou"},
    {"city": "Barville"},
    {"city": "Bazoches-au-Houlme"},
    {"city": "Bazoches-sur-Hoëne"},
    {"city": "La Bazoque"},
    {"city": "Beaufai"},
    {"city": "Beaulieu"},
    {"city": "Beauvain"},
    {"city": "Belfonds"},
    {"city": "Bellavilliers"},
    {"city": "Bellême"},
    {"city": "La Bellière"},
    {"city": "Bellou-en-Houlme"},
    {"city": "Bellou-le-Trichard"},
    {"city": "Berd'huis"},
    {"city": "Berjou"},
    {"city": "Bizou"},
    {"city": "Boëcé"},
    {"city": "Boissei-la-Lande"},
    {"city": "Cour-Maugis sur Huisne"},
    {"city": "Boitron"},
    {"city": "Bonnefoi"},
    {"city": "Bonsmoulins"},
    {"city": "Le Bosc-Renoult"},
    {"city": "Boucé"},
    {"city": "Le Bouillon"},
    {"city": "Brethel"},
    {"city": "Bretoncelles"},
    {"city": "Brieux"},
    {"city": "Briouze"},
    {"city": "Brullemail"},
    {"city": "Buré"},
    {"city": "Bures"},
    {"city": "Bursard"},
    {"city": "Cahan"},
    {"city": "Caligny"},
    {"city": "Camembert"},
    {"city": "Canapville"},
    {"city": "Carrouges"},
    {"city": "Ceaucé"},
    {"city": "Le Cercueil"},
    {"city": "Cerisé"},
    {"city": "Cerisy-Belle-Étoile"},
    {"city": "Ceton"},
    {"city": "Chahains"},
    {"city": "Chailloué"},
    {"city": "Le Chalange"},
    {"city": "Champcerie"},
    {"city": "Le Champ-de-la-Pierre"},
    {"city": "Les Champeaux"},
    {"city": "Champeaux-sur-Sarthe"},
    {"city": "Champ-Haut"},
    {"city": "Champosoult"},
    {"city": "Champsecret"},
    {"city": "Chandai"},
    {"city": "Chanu"},
    {"city": "La Chapelle-au-Moine"},
    {"city": "La Chapelle-Biche"},
    {"city": "Rives d'Andaine"},
    {"city": "La Chapelle-Montligeon"},
    {"city": "La Chapelle-près-Sées"},
    {"city": "La Chapelle-Souëf"},
    {"city": "La Chapelle-Viel"},
    {"city": "Le Château-d'Almenêches"},
    {"city": "Le Châtellier"},
    {"city": "Chaumont"},
    {"city": "La Chaux"},
    {"city": "Chemilli"},
    {"city": "Ciral"},
    {"city": "Cisai-Saint-Aubin"},
    {"city": "Colombiers"},
    {"city": "Comblot"},
    {"city": "Commeaux"},
    {"city": "Sablons sur Huisne"},
    {"city": "Condé-sur-Sarthe"},
    {"city": "Corbon"},
    {"city": "Coudehard"},
    {"city": "Coulimer"},
    {"city": "Coulmer"},
    {"city": "Coulonces"},
    {"city": "La Coulonche"},
    {"city": "Coulonges-sur-Sarthe"},
    {"city": "Courgeon"},
    {"city": "Courgeoût"},
    {"city": "Courtomer"},
    {"city": "Craménil"},
    {"city": "Croisilles"},
    {"city": "Crouttes"},
    {"city": "Crulai"},
    {"city": "Cuissai"},
    {"city": "Dame-Marie"},
    {"city": "Damigny"},
    {"city": "Domfront en Poiraie"},
    {"city": "Dompierre"},
    {"city": "Durcet"},
    {"city": "Échalou"},
    {"city": "Échauffour"},
    {"city": "Écorcei"},
    {"city": "Écorches"},
    {"city": "Écouché-les-Vallées"},
    {"city": "Essay"},
    {"city": "Faverolles"},
    {"city": "Fay"},
    {"city": "Feings"},
    {"city": "La Ferrière-au-Doyen"},
    {"city": "La Ferrière-aux-Étangs"},
    {"city": "La Ferrière-Béchet"},
    {"city": "La Ferrière-Bochard"},
    {"city": "Ferrières-la-Verrerie"},
    {"city": "La Ferté-en-Ouche"},
    {"city": "La Ferté Macé"},
    {"city": "Flers"},
    {"city": "Fleuré"},
    {"city": "Fontaine-les-Bassets"},
    {"city": "Francheville"},
    {"city": "La Fresnaie-Fayel"},
    {"city": "Fresnay-le-Samson"},
    {"city": "Gacé"},
    {"city": "Gandelain"},
    {"city": "Gâprée"},
    {"city": "Les Genettes"},
    {"city": "La Genevraie"},
    {"city": "Giel-Courteilles"},
    {"city": "Ginai"},
    {"city": "Godisson"},
    {"city": "La Gonfrière"},
    {"city": "Monts-sur-Orne"},
    {"city": "Le Grais"},
    {"city": "Belforêt-en-Perche"},
    {"city": "Guêprei"},
    {"city": "Guerquesalles"},
    {"city": "Habloville"},
    {"city": "Hauterive"},
    {"city": "Héloup"},
    {"city": "L'Hôme-Chamondot"},
    {"city": "Igé"},
    {"city": "Irai"},
    {"city": "Joué-du-Bois"},
    {"city": "Joué-du-Plain"},
    {"city": "Juvigny Val d'Andaine"},
    {"city": "Juvigny-sur-Orne"},
    {"city": "Lalacelle"},
    {"city": "L'Aigle"},
    {"city": "Laleu"},
    {"city": "La Lande-de-Goult"},
    {"city": "La Lande-de-Lougé"},
    {"city": "La Lande-Patry"},
    {"city": "La Lande-Saint-Siméon"},
    {"city": "Landigou"},
    {"city": "Landisacq"},
    {"city": "Larré"},
    {"city": "Lignères"},
    {"city": "Lignou"},
    {"city": "L'Orée-d'Écouves"},
    {"city": "Loisail"},
    {"city": "Longny les Villages"},
    {"city": "Lonlay-l'Abbaye"},
    {"city": "Lonlay-le-Tesson"},
    {"city": "Lonrai"},
    {"city": "Lougé-sur-Maire"},
    {"city": "Louvières-en-Auge"},
    {"city": "Macé"},
    {"city": "La Madeleine-Bouvet"},
    {"city": "Le Mage"},
    {"city": "Magny-le-Désert"},
    {"city": "Mahéru"},
    {"city": "Mantilly"},
    {"city": "Marchemaisons"},
    {"city": "Mardilly"},
    {"city": "Mauves-sur-Huisne"},
    {"city": "Médavy"},
    {"city": "Méhoudin"},
    {"city": "Le Mêle-sur-Sarthe"},
    {"city": "Le Ménil-Bérard"},
    {"city": "Le Ménil-de-Briouze"},
    {"city": "Le Ménil-Broût"},
    {"city": "Le Ménil-Ciboult"},
    {"city": "Ménil-Erreux"},
    {"city": "Ménil-Froger"},
    {"city": "Ménil-Gondouin"},
    {"city": "Le Ménil-Guyon"},
    {"city": "Ménil-Hermei"},
    {"city": "Ménil-Hubert-en-Exmes"},
    {"city": "Ménil-Hubert-sur-Orne"},
    {"city": "Le Ménil-Scelleur"},
    {"city": "Le Ménil-Vicomte"},
    {"city": "Ménil-Vin"},
    {"city": "Les Menus"},
    {"city": "Le Merlerault"},
    {"city": "Merri"},
    {"city": "La Mesnière"},
    {"city": "Messei"},
    {"city": "Mieuxcé"},
    {"city": "Moncy"},
    {"city": "Montabard"},
    {"city": "Montchevrel"},
    {"city": "Montgaudry"},
    {"city": "Montilly-sur-Noireau"},
    {"city": "Montmerrei"},
    {"city": "Mont-Ormel"},
    {"city": "Montreuil-au-Houlme"},
    {"city": "Montreuil-la-Cambe"},
    {"city": "Montsecret-Clairefougère"},
    {"city": "Mortagne-au-Perche"},
    {"city": "Mortrée"},
    {"city": "La Motte-Fouquet"},
    {"city": "Moulins-la-Marche"},
    {"city": "Moulins-sur-Orne"},
    {"city": "Moutiers-au-Perche"},
    {"city": "Neauphe-sous-Essai"},
    {"city": "Neauphe-sur-Dive"},
    {"city": "Nécy"},
    {"city": "Neuilly-le-Bisson"},
    {"city": "Neuville-sur-Touques"},
    {"city": "Neuvy-au-Houlme"},
    {"city": "Perche en Nocé"},
    {"city": "Nonant-le-Pin"},
    {"city": "Occagnes"},
    {"city": "Ommoy"},
    {"city": "Orgères"},
    {"city": "Origny-le-Roux"},
    {"city": "Pacé"},
    {"city": "Parfondeval"},
    {"city": "Le Pas-Saint-l'Homer"},
    {"city": "Passais Villages"},
    {"city": "Perrou"},
    {"city": "Pervenchères"},
    {"city": "Le Pin-au-Haras"},
    {"city": "Le Pin-la-Garenne"},
    {"city": "Planches"},
    {"city": "Le Plantis"},
    {"city": "Pointel"},
    {"city": "Pontchardon"},
    {"city": "Pouvrai"},
    {"city": "Putanges-le-Lac"},
    {"city": "Écouves"},
    {"city": "Rai"},
    {"city": "Rânes"},
    {"city": "Rémalard en Perche"},
    {"city": "Le Renouard"},
    {"city": "Résenlieu"},
    {"city": "Réveillon"},
    {"city": "Ri"},
    {"city": "La Roche-Mabile"},
    {"city": "Roiville"},
    {"city": "Rônai"},
    {"city": "Rouperroux"},
    {"city": "Sai"},
    {"city": "Saint-Agnan-sur-Sarthe"},
    {"city": "Saint-André-de-Briouze"},
    {"city": "Saint-André-de-Messei"},
    {"city": "Saint-Aquilin-de-Corbion"},
    {"city": "Saint-Aubin-d'Appenai"},
    {"city": "Saint-Aubin-de-Bonneval"},
    {"city": "Saint-Aubin-de-Courteraie"},
    {"city": "Saint-Bômer-les-Forges"},
    {"city": "Saint-Brice"},
    {"city": "Saint-Brice-sous-Rânes"},
    {"city": "Saint-Céneri-le-Gérei"},
    {"city": "Sainte-Céronne-lès-Mortagne"},
    {"city": "Saint-Christophe-de-Chaulieu"},
    {"city": "Boischampré"},
    {"city": "Saint-Clair-de-Halouze"},
    {"city": "Saint-Cyr-la-Rosière"},
    {"city": "Saint-Denis-sur-Huisne"},
    {"city": "Saint-Denis-sur-Sarthon"},
    {"city": "Saint-Ellier-les-Bois"},
    {"city": "Saint-Evroult-de-Montfort"},
    {"city": "Saint-Evroult-Notre-Dame-du-Bois"},
    {"city": "Saint-Fraimbault"},
    {"city": "Saint-Fulgent-des-Ormes"},
    {"city": "Sainte-Gauburge-Sainte-Colombe"},
    {"city": "Saint-Georges-d'Annebecq"},
    {"city": "Saint-Georges-des-Groseillers"},
    {"city": "Saint-Germain-d'Aunay"},
    {"city": "Saint-Germain-de-Clairefeuille"},
    {"city": "Saint-Germain-de-la-Coudre"},
    {"city": "Saint-Germain-des-Grois"},
    {"city": "Saint-Germain-de-Martigny"},
    {"city": "Saint-Germain-du-Corbéis"},
    {"city": "Saint-Germain-le-Vieux"},
    {"city": "Saint-Gervais-des-Sablons"},
    {"city": "Saint-Gervais-du-Perron"},
    {"city": "Saint-Gilles-des-Marais"},
    {"city": "Saint-Hilaire-de-Briouze"},
    {"city": "Saint-Hilaire-le-Châtel"},
    {"city": "Saint-Hilaire-sur-Erre"},
    {"city": "Saint-Hilaire-sur-Risle"},
    {"city": "Sainte-Honorine-la-Chardonne"},
    {"city": "Sainte-Honorine-la-Guillaume"},
    {"city": "Saint-Jouin-de-Blavou"},
    {"city": "Saint-Julien-sur-Sarthe"},
    {"city": "Saint-Lambert-sur-Dive"},
    {"city": "Saint-Langis-lès-Mortagne"},
    {"city": "Saint-Léger-sur-Sarthe"},
    {"city": "Saint-Léonard-des-Parcs"},
    {"city": "Saint-Mard-de-Réno"},
    {"city": "Sainte-Marguerite-de-Carrouges"},
    {"city": "Sainte-Marie-la-Robert"},
    {"city": "Saint-Mars-d'Égrenne"},
    {"city": "Les Aspres"},
    {"city": "Saint-Martin-d'Écublei"},
    {"city": "Saint-Martin-des-Landes"},
    {"city": "Saint-Martin-des-Pézerits"},
    {"city": "Saint-Martin-du-Vieux-Bellême"},
    {"city": "Saint-Martin-l'Aiguillon"},
    {"city": "Charencey"},
    {"city": "Saint-Michel-Tubœuf"},
    {"city": "Saint-Nicolas-des-Bois"},
    {"city": "Saint-Nicolas-de-Sommaire"},
    {"city": "Sainte-Opportune"},
    {"city": "Saint-Ouen-de-Sécherouvre"},
    {"city": "Saint-Ouen-le-Brisoult"},
    {"city": "Saint-Ouen-sur-Iton"},
    {"city": "Saint-Patrice-du-Désert"},
    {"city": "Saint-Paul"},
    {"city": "Saint-Philbert-sur-Orne"},
    {"city": "Saint-Pierre-d'Entremont"},
    {"city": "Saint-Pierre-des-Loges"},
    {"city": "Saint-Pierre-du-Regard"},
    {"city": "Saint-Pierre-la-Bruyère"},
    {"city": "Saint-Quentin-de-Blavou"},
    {"city": "Saint-Quentin-les-Chardonnets"},
    {"city": "Saint-Roch-sur-Égrenne"},
    {"city": "Saint-Sauveur-de-Carrouges"},
    {"city": "Sainte-Scolasse-sur-Sarthe"},
    {"city": "Saint-Sulpice-sur-Risle"},
    {"city": "Saint-Symphorien-des-Bruyères"},
    {"city": "Saires-la-Verrerie"},
    {"city": "Sap-en-Auge"},
    {"city": "Le Sap-André"},
    {"city": "Sarceaux"},
    {"city": "Les Monts d'Andaine"},
    {"city": "Sées"},
    {"city": "La Selle-la-Forge"},
    {"city": "Semallé"},
    {"city": "Sévigny"},
    {"city": "Sevrai"},
    {"city": "Gouffern en Auge"},
    {"city": "Soligny-la-Trappe"},
    {"city": "Suré"},
    {"city": "Tanques"},
    {"city": "Tanville"},
    {"city": "Tellières-le-Plessis"},
    {"city": "Tessé-Froulay"},
    {"city": "Bagnoles de l'Orne Normandie"},
    {"city": "Val-au-Perche"},
    {"city": "Ticheville"},
    {"city": "Tinchebray-Bocage"},
    {"city": "Torchamp"},
    {"city": "Touquettes"},
    {"city": "Tournai-sur-Dive"},
    {"city": "Tourouvre au Perche"},
    {"city": "Trémont"},
    {"city": "La Trinité-des-Laitiers"},
    {"city": "Trun"},
    {"city": "Valframbert"},
    {"city": "Vaunoise"},
    {"city": "Les Ventes-de-Bourse"},
    {"city": "La Ventrouze"},
    {"city": "Verrières"},
    {"city": "Vidai"},
    {"city": "Vieux-Pont"},
    {"city": "Villedieu-lès-Bailleul"},
    {"city": "Villiers-sous-Mortagne"},
    {"city": "Vimoutiers"},
    {"city": "Vitrai-sous-Laigle"},
    {"city": "Les Yveteaux"},
    {"city": "Ablain-Saint-Nazaire"},
    {"city": "Ablainzevelle"},
    {"city": "Acheville"},
    {"city": "Achicourt"},
    {"city": "Achiet-le-Grand"},
    {"city": "Achiet-le-Petit"},
    {"city": "Acq"},
    {"city": "Acquin-Westbécourt"},
    {"city": "Adinfer"},
    {"city": "Affringues"},
    {"city": "Agnez-lès-Duisans"},
    {"city": "Agnières"},
    {"city": "Agny"},
    {"city": "Aire-sur-la-Lys"},
    {"city": "Airon-Notre-Dame"},
    {"city": "Airon-Saint-Vaast"},
    {"city": "Aix-en-Ergny"},
    {"city": "Aix-en-Issart"},
    {"city": "Aix-Noulette"},
    {"city": "Alembon"},
    {"city": "Alette"},
    {"city": "Alincthun"},
    {"city": "Allouagne"},
    {"city": "Alquines"},
    {"city": "Ambleteuse"},
    {"city": "Ambricourt"},
    {"city": "Ambrines"},
    {"city": "Ames"},
    {"city": "Amettes"},
    {"city": "Amplier"},
    {"city": "Andres"},
    {"city": "Angres"},
    {"city": "Annay"},
    {"city": "Annequin"},
    {"city": "Annezin"},
    {"city": "Anvin"},
    {"city": "Anzin-Saint-Aubin"},
    {"city": "Ardres"},
    {"city": "Arleux-en-Gohelle"},
    {"city": "Arques"},
    {"city": "Arras"},
    {"city": "Athies"},
    {"city": "Les Attaques"},
    {"city": "Attin"},
    {"city": "Aubigny-en-Artois"},
    {"city": "Aubin-Saint-Vaast"},
    {"city": "Aubrometz"},
    {"city": "Auchel"},
    {"city": "Auchy-au-Bois"},
    {"city": "Auchy-lès-Hesdin"},
    {"city": "Auchy-les-Mines"},
    {"city": "Audembert"},
    {"city": "Audincthun"},
    {"city": "Audinghen"},
    {"city": "Audrehem"},
    {"city": "Audresselles"},
    {"city": "Audruicq"},
    {"city": "Aumerval"},
    {"city": "Autingues"},
    {"city": "Auxi-le-Château"},
    {"city": "Averdoingt"},
    {"city": "Avesnes"},
    {"city": "Avesnes-le-Comte"},
    {"city": "Avesnes-lès-Bapaume"},
    {"city": "Avion"},
    {"city": "Avondance"},
    {"city": "Avroult"},
    {"city": "Ayette"},
    {"city": "Azincourt"},
    {"city": "Bailleul-aux-Cornailles"},
    {"city": "Bailleul-lès-Pernes"},
    {"city": "Bailleulmont"},
    {"city": "Bailleul-Sir-Berthoult"},
    {"city": "Bailleulval"},
    {"city": "Baincthun"},
    {"city": "Bainghen"},
    {"city": "Bajus"},
    {"city": "Balinghem"},
    {"city": "Bancourt"},
    {"city": "Bapaume"},
    {"city": "Baralle"},
    {"city": "Barastre"},
    {"city": "Barlin"},
    {"city": "Barly"},
    {"city": "Basseux"},
    {"city": "Bavincourt"},
    {"city": "Bayenghem-lès-Éperlecques"},
    {"city": "Bayenghem-lès-Seninghem"},
    {"city": "Bazinghen"},
    {"city": "Béalencourt"},
    {"city": "Beaudricourt"},
    {"city": "Beaufort-Blavincourt"},
    {"city": "Beaulencourt"},
    {"city": "Beaumerie-Saint-Martin"},
    {"city": "Beaumetz-lès-Aire"},
    {"city": "Beaumetz-lès-Cambrai"},
    {"city": "Beaumetz-lès-Loges"},
    {"city": "Beaurains"},
    {"city": "Beaurainville"},
    {"city": "Beauvois"},
    {"city": "Bécourt"},
    {"city": "Béhagnies"},
    {"city": "Bellebrune"},
    {"city": "Belle-et-Houllefort"},
    {"city": "Bellonne"},
    {"city": "Bénifontaine"},
    {"city": "Berck"},
    {"city": "Bergueneuse"},
    {"city": "Berlencourt-le-Cauroy"},
    {"city": "Berles-au-Bois"},
    {"city": "Berles-Monchel"},
    {"city": "Bermicourt"},
    {"city": "Berneville"},
    {"city": "Bernieulles"},
    {"city": "Bertincourt"},
    {"city": "Béthonsart"},
    {"city": "Béthune"},
    {"city": "Beugin"},
    {"city": "Beugnâtre"},
    {"city": "Beugny"},
    {"city": "Beussent"},
    {"city": "Beutin"},
    {"city": "Beuvrequen"},
    {"city": "Beuvry"},
    {"city": "Bezinghem"},
    {"city": "Biache-Saint-Vaast"},
    {"city": "Biefvillers-lès-Bapaume"},
    {"city": "Bienvillers-au-Bois"},
    {"city": "Bihucourt"},
    {"city": "Billy-Berclau"},
    {"city": "Billy-Montigny"},
    {"city": "Bimont"},
    {"city": "Blairville"},
    {"city": "Blangerval-Blangermont"},
    {"city": "Blangy-sur-Ternoise"},
    {"city": "Blendecques"},
    {"city": "Bléquin"},
    {"city": "Blessy"},
    {"city": "Blingel"},
    {"city": "Boffles"},
    {"city": "Boiry-Becquerelle"},
    {"city": "Boiry-Notre-Dame"},
    {"city": "Boiry-Saint-Martin"},
    {"city": "Boiry-Sainte-Rictrude"},
    {"city": "Bois-Bernard"},
    {"city": "Boisdinghem"},
    {"city": "Boisjean"},
    {"city": "Boisleux-au-Mont"},
    {"city": "Boisleux-Saint-Marc"},
    {"city": "Bomy"},
    {"city": "Bonnières"},
    {"city": "Bonningues-lès-Ardres"},
    {"city": "Bonningues-lès-Calais"},
    {"city": "Boubers-lès-Hesmond"},
    {"city": "Boubers-sur-Canche"},
    {"city": "Boulogne-sur-Mer"},
    {"city": "Bouquehault"},
    {"city": "Bourecq"},
    {"city": "Bouret-sur-Canche"},
    {"city": "Bourlon"},
    {"city": "Bournonville"},
    {"city": "Bours"},
    {"city": "Boursin"},
    {"city": "Bourthes"},
    {"city": "Bouvelinghem"},
    {"city": "Bouvigny-Boyeffles"},
    {"city": "Boyaval"},
    {"city": "Boyelles"},
    {"city": "Brebières"},
    {"city": "Brêmes"},
    {"city": "Brévillers"},
    {"city": "Bréxent-Énocq"},
    {"city": "Brimeux"},
    {"city": "Bruay-la-Buissière"},
    {"city": "Brunembert"},
    {"city": "Brias"},
    {"city": "Bucquoy"},
    {"city": "Buire-au-Bois"},
    {"city": "Buire-le-Sec"},
    {"city": "Buissy"},
    {"city": "Bullecourt"},
    {"city": "Bully-les-Mines"},
    {"city": "Buneville"},
    {"city": "Burbure"},
    {"city": "Bus"},
    {"city": "Busnes"},
    {"city": "Caffiers"},
    {"city": "Cagnicourt"},
    {"city": "Calais"},
    {"city": "Calonne-Ricouart"},
    {"city": "Calonne-sur-la-Lys"},
    {"city": "La Calotterie"},
    {"city": "Camblain-Châtelain"},
    {"city": "Cambligneul"},
    {"city": "Camblain-l'Abbé"},
    {"city": "Cambrin"},
    {"city": "Camiers"},
    {"city": "Campagne-lès-Boulonnais"},
    {"city": "Campagne-lès-Guines"},
    {"city": "Campagne-lès-Hesdin"},
    {"city": "Campagne-lès-Wardrecques"},
    {"city": "Campigneulles-les-Grandes"},
    {"city": "Campigneulles-les-Petites"},
    {"city": "Canettemont"},
    {"city": "Canlers"},
    {"city": "Capelle-Fermont"},
    {"city": "Capelle-lès-Hesdin"},
    {"city": "Carency"},
    {"city": "Carly"},
    {"city": "Carvin"},
    {"city": "La Cauchie"},
    {"city": "Cauchy-à-la-Tour"},
    {"city": "Caucourt"},
    {"city": "Caumont"},
    {"city": "Cavron-Saint-Martin"},
    {"city": "Chelers"},
    {"city": "Chériennes"},
    {"city": "Chérisy"},
    {"city": "Chocques"},
    {"city": "Clairmarais"},
    {"city": "Clenleu"},
    {"city": "Clerques"},
    {"city": "Cléty"},
    {"city": "Colembert"},
    {"city": "Colline-Beaumont"},
    {"city": "La Comté"},
    {"city": "Conchil-le-Temple"},
    {"city": "Conchy-sur-Canche"},
    {"city": "Condette"},
    {"city": "Contes"},
    {"city": "Conteville-lès-Boulogne"},
    {"city": "Conteville-en-Ternois"},
    {"city": "Coquelles"},
    {"city": "Corbehem"},
    {"city": "Cormont"},
    {"city": "Couin"},
    {"city": "Coullemont"},
    {"city": "Coulogne"},
    {"city": "Coulomby"},
    {"city": "Coupelle-Neuve"},
    {"city": "Coupelle-Vieille"},
    {"city": "Courcelles-le-Comte"},
    {"city": "Courcelles-lès-Lens"},
    {"city": "Courrières"},
    {"city": "Courset"},
    {"city": "La Couture"},
    {"city": "Couturelle"},
    {"city": "Coyecques"},
    {"city": "Crémarest"},
    {"city": "Crépy"},
    {"city": "Créquy"},
    {"city": "Croisette"},
    {"city": "Croisilles"},
    {"city": "Croix-en-Ternois"},
    {"city": "Cucq"},
    {"city": "Cuinchy"},
    {"city": "Dainville"},
    {"city": "Dannes"},
    {"city": "Delettes"},
    {"city": "Denier"},
    {"city": "Dennebrœucq"},
    {"city": "Desvres"},
    {"city": "Diéval"},
    {"city": "Divion"},
    {"city": "Dohem"},
    {"city": "Douchy-lès-Ayette"},
    {"city": "Doudeauville"},
    {"city": "Dourges"},
    {"city": "Douriez"},
    {"city": "Douvrin"},
    {"city": "Drocourt"},
    {"city": "Drouvin-le-Marais"},
    {"city": "Duisans"},
    {"city": "Dury"},
    {"city": "Echinghen"},
    {"city": "Éclimeux"},
    {"city": "Écoivres"},
    {"city": "Écourt-Saint-Quentin"},
    {"city": "Écoust-Saint-Mein"},
    {"city": "Ecquedecques"},
    {"city": "Ecques"},
    {"city": "Écuires"},
    {"city": "Écurie"},
    {"city": "Éleu-dit-Leauwette"},
    {"city": "Elnes"},
    {"city": "Embry"},
    {"city": "Enquin-lez-Guinegatte"},
    {"city": "Enquin-sur-Baillons"},
    {"city": "Éperlecques"},
    {"city": "Épinoy"},
    {"city": "Eps"},
    {"city": "Équihen-Plage"},
    {"city": "Équirre"},
    {"city": "Ergny"},
    {"city": "Érin"},
    {"city": "Erny-Saint-Julien"},
    {"city": "Ervillers"},
    {"city": "Escalles"},
    {"city": "Escœuilles"},
    {"city": "Esquerdes"},
    {"city": "Essars"},
    {"city": "Estevelles"},
    {"city": "Estrée"},
    {"city": "Estrée-Blanche"},
    {"city": "Estrée-Cauchy"},
    {"city": "Estréelles"},
    {"city": "Estrée-Wamin"},
    {"city": "Étaing"},
    {"city": "Étaples"},
    {"city": "Éterpigny"},
    {"city": "Étrun"},
    {"city": "Évin-Malmaison"},
    {"city": "Famechon"},
    {"city": "Fampoux"},
    {"city": "Farbus"},
    {"city": "Fauquembergues"},
    {"city": "Favreuil"},
    {"city": "Febvin-Palfart"},
    {"city": "Ferfay"},
    {"city": "Ferques"},
    {"city": "Festubert"},
    {"city": "Feuchy"},
    {"city": "Ficheux"},
    {"city": "Fiefs"},
    {"city": "Fiennes"},
    {"city": "Fillièvres"},
    {"city": "Fléchin"},
    {"city": "Flers"},
    {"city": "Fleurbaix"},
    {"city": "Fleury"},
    {"city": "Floringhem"},
    {"city": "Foncquevillers"},
    {"city": "Fontaine-lès-Boulans"},
    {"city": "Fontaine-lès-Croisilles"},
    {"city": "Fontaine-lès-Hermans"},
    {"city": "Fontaine-l'Étalon"},
    {"city": "Fortel-en-Artois"},
    {"city": "Fosseux"},
    {"city": "Foufflin-Ricametz"},
    {"city": "Fouquereuil"},
    {"city": "Fouquières-lès-Béthune"},
    {"city": "Fouquières-lès-Lens"},
    {"city": "Framecourt"},
    {"city": "Frémicourt"},
    {"city": "Frencq"},
    {"city": "Fresnes-lès-Montauban"},
    {"city": "Fresnicourt-le-Dolmen"},
    {"city": "Fresnoy"},
    {"city": "Fresnoy-en-Gohelle"},
    {"city": "Fressin"},
    {"city": "Fréthun"},
    {"city": "Frévent"},
    {"city": "Frévillers"},
    {"city": "Frévin-Capelle"},
    {"city": "Fruges"},
    {"city": "Galametz"},
    {"city": "Gauchin-Légal"},
    {"city": "Gauchin-Verloingt"},
    {"city": "Gaudiempré"},
    {"city": "Gavrelle"},
    {"city": "Gennes-Ivergny"},
    {"city": "Givenchy-en-Gohelle"},
    {"city": "Givenchy-le-Noble"},
    {"city": "Givenchy-lès-la-Bassée"},
    {"city": "Gomiécourt"},
    {"city": "Gommecourt"},
    {"city": "Gonnehem"},
    {"city": "Gosnay"},
    {"city": "Gouves"},
    {"city": "Gouy-en-Artois"},
    {"city": "Gouy-Servins"},
    {"city": "Gouy-en-Ternois"},
    {"city": "Gouy-Saint-André"},
    {"city": "Gouy-sous-Bellonne"},
    {"city": "Graincourt-lès-Havrincourt"},
    {"city": "Grand-Rullecourt"},
    {"city": "Grenay"},
    {"city": "Grévillers"},
    {"city": "Grigny"},
    {"city": "Grincourt-lès-Pas"},
    {"city": "Groffliers"},
    {"city": "Guarbecque"},
    {"city": "Guémappe"},
    {"city": "Guemps"},
    {"city": "Guigny"},
    {"city": "Guinecourt"},
    {"city": "Guînes"},
    {"city": "Guisy"},
    {"city": "Habarcq"},
    {"city": "Haillicourt"},
    {"city": "Haisnes"},
    {"city": "Halinghen"},
    {"city": "Hallines"},
    {"city": "Halloy"},
    {"city": "Hamblain-les-Prés"},
    {"city": "Hamelincourt"},
    {"city": "Ham-en-Artois"},
    {"city": "Hames-Boucres"},
    {"city": "Hannescamps"},
    {"city": "Haplincourt"},
    {"city": "Haravesnes"},
    {"city": "Hardinghen"},
    {"city": "Harnes"},
    {"city": "Haucourt"},
    {"city": "Haute-Avesnes"},
    {"city": "Hautecloque"},
    {"city": "Hauteville"},
    {"city": "Haut-Loquin"},
    {"city": "Havrincourt"},
    {"city": "Hébuterne"},
    {"city": "Helfaut"},
    {"city": "Hendecourt-lès-Cagnicourt"},
    {"city": "Hendecourt-lès-Ransart"},
    {"city": "Héninel"},
    {"city": "Hénin-Beaumont"},
    {"city": "Hénin-sur-Cojeul"},
    {"city": "Henneveux"},
    {"city": "Hénu"},
    {"city": "Herbinghen"},
    {"city": "Héricourt"},
    {"city": "La Herlière"},
    {"city": "Herlincourt"},
    {"city": "Herlin-le-Sec"},
    {"city": "Herly"},
    {"city": "Hermaville"},
    {"city": "Hermelinghen"},
    {"city": "Hermies"},
    {"city": "Hermin"},
    {"city": "Hernicourt"},
    {"city": "Hersin-Coupigny"},
    {"city": "Hervelinghen"},
    {"city": "Hesdigneul-lès-Béthune"},
    {"city": "Hesdigneul-lès-Boulogne"},
    {"city": "Hesdin"},
    {"city": "Hesdin-l'Abbé"},
    {"city": "Hesmond"},
    {"city": "Hestrus"},
    {"city": "Heuchin"},
    {"city": "Heuringhem"},
    {"city": "Hézecques"},
    {"city": "Hinges"},
    {"city": "Hocquinghen"},
    {"city": "Houchin"},
    {"city": "Houdain"},
    {"city": "Houlle"},
    {"city": "Houvin-Houvigneul"},
    {"city": "Hubersent"},
    {"city": "Huby-Saint-Leu"},
    {"city": "Huclier"},
    {"city": "Hucqueliers"},
    {"city": "Hulluch"},
    {"city": "Humbercamps"},
    {"city": "Humbert"},
    {"city": "Humerœuille"},
    {"city": "Humières"},
    {"city": "Inchy-en-Artois"},
    {"city": "Incourt"},
    {"city": "Bellinghem"},
    {"city": "Inxent"},
    {"city": "Isbergues"},
    {"city": "Isques"},
    {"city": "Ivergny"},
    {"city": "Izel-lès-Équerchin"},
    {"city": "Izel-lès-Hameau"},
    {"city": "Journy"},
    {"city": "Labeuvrière"},
    {"city": "Labourse"},
    {"city": "Labroye"},
    {"city": "Lacres"},
    {"city": "Lagnicourt-Marcel"},
    {"city": "Laires"},
    {"city": "Lambres"},
    {"city": "Landrethun-le-Nord"},
    {"city": "Landrethun-lès-Ardres"},
    {"city": "Lapugnoy"},
    {"city": "Lattre-Saint-Quentin"},
    {"city": "Laventie"},
    {"city": "Lebiez"},
    {"city": "Lebucquière"},
    {"city": "Léchelle"},
    {"city": "Ledinghem"},
    {"city": "Lefaux"},
    {"city": "Leforest"},
    {"city": "Lens"},
    {"city": "Lépine"},
    {"city": "Lespesses"},
    {"city": "Lespinoy"},
    {"city": "Lestrem"},
    {"city": "Leubringhen"},
    {"city": "Leulinghem"},
    {"city": "Leulinghen-Bernes"},
    {"city": "Licques"},
    {"city": "Liencourt"},
    {"city": "Lières"},
    {"city": "Liettres"},
    {"city": "Liévin"},
    {"city": "Lignereuil"},
    {"city": "Ligny-lès-Aire"},
    {"city": "Ligny-sur-Canche"},
    {"city": "Ligny-Saint-Flochel"},
    {"city": "Ligny-Thilloy"},
    {"city": "Lillers"},
    {"city": "Linghem"},
    {"city": "Linzeux"},
    {"city": "Lisbourg"},
    {"city": "Locon"},
    {"city": "La Loge"},
    {"city": "Loison-sur-Créquoise"},
    {"city": "Loison-sous-Lens"},
    {"city": "Longfossé"},
    {"city": "Longuenesse"},
    {"city": "Longueville"},
    {"city": "Longvilliers"},
    {"city": "Loos-en-Gohelle"},
    {"city": "Lorgies"},
    {"city": "Lottinghen"},
    {"city": "Louches"},
    {"city": "Lozinghem"},
    {"city": "Lugy"},
    {"city": "Lumbres"},
    {"city": "La Madelaine-sous-Montreuil"},
    {"city": "Magnicourt-en-Comte"},
    {"city": "Magnicourt-sur-Canche"},
    {"city": "Maintenay"},
    {"city": "Maisnil"},
    {"city": "Maisnil-lès-Ruitz"},
    {"city": "Maisoncelle"},
    {"city": "Maizières"},
    {"city": "Mametz"},
    {"city": "Manin"},
    {"city": "Maninghem"},
    {"city": "Maninghen-Henne"},
    {"city": "Marant"},
    {"city": "Marck"},
    {"city": "Marconne"},
    {"city": "Marconnelle"},
    {"city": "Marenla"},
    {"city": "Maresquel-Ecquemicourt"},
    {"city": "Marest"},
    {"city": "Maresville"},
    {"city": "Marles-les-Mines"},
    {"city": "Marles-sur-Canche"},
    {"city": "Marœuil"},
    {"city": "Marquay"},
    {"city": "Marquion"},
    {"city": "Marquise"},
    {"city": "Martinpuich"},
    {"city": "Matringhem"},
    {"city": "Mazingarbe"},
    {"city": "Mazinghem"},
    {"city": "Mencas"},
    {"city": "Menneville"},
    {"city": "Mentque-Nortbécourt"},
    {"city": "Mercatel"},
    {"city": "Merck-Saint-Liévin"},
    {"city": "Méricourt"},
    {"city": "Merlimont"},
    {"city": "Metz-en-Couture"},
    {"city": "Meurchin"},
    {"city": "Mingoval"},
    {"city": "Moncheaux-lès-Frévent"},
    {"city": "Monchel-sur-Canche"},
    {"city": "Monchiet"},
    {"city": "Monchy-au-Bois"},
    {"city": "Monchy-Breton"},
    {"city": "Monchy-Cayeux"},
    {"city": "Monchy-le-Preux"},
    {"city": "Mondicourt"},
    {"city": "Mont-Bernanchon"},
    {"city": "Montcavrel"},
    {"city": "Montenescourt"},
    {"city": "Montigny-en-Gohelle"},
    {"city": "Montreuil"},
    {"city": "Mont-Saint-Éloi"},
    {"city": "Monts-en-Ternois"},
    {"city": "Morchies"},
    {"city": "Moringhem"},
    {"city": "Morval"},
    {"city": "Mory"},
    {"city": "Moulle"},
    {"city": "Mouriez"},
    {"city": "Moyenneville"},
    {"city": "Muncq-Nieurlet"},
    {"city": "Nabringhen"},
    {"city": "Nédon"},
    {"city": "Nédonchel"},
    {"city": "Nempont-Saint-Firmin"},
    {"city": "Nesles"},
    {"city": "Neufchâtel-Hardelot"},
    {"city": "Neulette"},
    {"city": "Neuve-Chapelle"},
    {"city": "Neuville-au-Cornet"},
    {"city": "Neuville-Bourjonval"},
    {"city": "Neuville-Saint-Vaast"},
    {"city": "Neuville-sous-Montreuil"},
    {"city": "Neuville-Vitasse"},
    {"city": "Neuvireuil"},
    {"city": "Nielles-lès-Bléquin"},
    {"city": "Nielles-lès-Ardres"},
    {"city": "Nielles-lès-Calais"},
    {"city": "Nœux-lès-Auxi"},
    {"city": "Nœux-les-Mines"},
    {"city": "Nordausques"},
    {"city": "Noreuil"},
    {"city": "Norrent-Fontes"},
    {"city": "Nortkerque"},
    {"city": "Nort-Leulinghem"},
    {"city": "Nouvelle-Église"},
    {"city": "Noyelles-Godault"},
    {"city": "Noyelles-lès-Humières"},
    {"city": "Noyelles-lès-Vermelles"},
    {"city": "Noyelles-sous-Bellonne"},
    {"city": "Noyelles-sous-Lens"},
    {"city": "Noyellette"},
    {"city": "Noyelle-Vion"},
    {"city": "Nuncq-Hautecôte"},
    {"city": "Oblinghem"},
    {"city": "Œuf-en-Ternois"},
    {"city": "Offekerque"},
    {"city": "Offin"},
    {"city": "Offrethun"},
    {"city": "Oignies"},
    {"city": "Oisy-le-Verger"},
    {"city": "Oppy"},
    {"city": "Orville"},
    {"city": "Ostreville"},
    {"city": "Ourton"},
    {"city": "Outreau"},
    {"city": "Ouve-Wirquin"},
    {"city": "Oye-Plage"},
    {"city": "Palluel"},
    {"city": "Le Parcq"},
    {"city": "Parenty"},
    {"city": "Pas-en-Artois"},
    {"city": "Pelves"},
    {"city": "Penin"},
    {"city": "Pernes"},
    {"city": "Pernes-lès-Boulogne"},
    {"city": "Peuplingues"},
    {"city": "Pierremont"},
    {"city": "Pihem"},
    {"city": "Pihen-lès-Guînes"},
    {"city": "Pittefaux"},
    {"city": "Planques"},
    {"city": "Plouvain"},
    {"city": "Bouin-Plumoison"},
    {"city": "Polincove"},
    {"city": "Pommera"},
    {"city": "Pommier"},
    {"city": "Le Ponchel"},
    {"city": "Pont-à-Vendin"},
    {"city": "Le Portel"},
    {"city": "Prédefin"},
    {"city": "Pressy"},
    {"city": "Preures"},
    {"city": "Pronville-en-Artois"},
    {"city": "Puisieux"},
    {"city": "Quéant"},
    {"city": "Quelmes"},
    {"city": "Quercamps"},
    {"city": "Quernes"},
    {"city": "Le Quesnoy-en-Artois"},
    {"city": "Quesques"},
    {"city": "Questrecques"},
    {"city": "Quiéry-la-Motte"},
    {"city": "Quiestède"},
    {"city": "Quilen"},
    {"city": "Quœux-Haut-Maînil"},
    {"city": "Racquinghem"},
    {"city": "Radinghem"},
    {"city": "Ramecourt"},
    {"city": "Rang-du-Fliers"},
    {"city": "Ransart"},
    {"city": "Raye-sur-Authie"},
    {"city": "Saint-Augustin"},
    {"city": "Rebergues"},
    {"city": "Rebreuve-Ranchicourt"},
    {"city": "Rebreuve-sur-Canche"},
    {"city": "Rebreuviette"},
    {"city": "Reclinghem"},
    {"city": "Récourt"},
    {"city": "Recques-sur-Course"},
    {"city": "Recques-sur-Hem"},
    {"city": "Regnauville"},
    {"city": "Rely"},
    {"city": "Remilly-Wirquin"},
    {"city": "Rémy"},
    {"city": "Renty"},
    {"city": "Rety"},
    {"city": "Richebourg"},
    {"city": "Riencourt-lès-Bapaume"},
    {"city": "Riencourt-lès-Cagnicourt"},
    {"city": "Rimboval"},
    {"city": "Rinxent"},
    {"city": "Rivière"},
    {"city": "Robecq"},
    {"city": "Roclincourt"},
    {"city": "Rocquigny"},
    {"city": "Rodelinghem"},
    {"city": "Roëllecourt"},
    {"city": "Rœux"},
    {"city": "Rollancourt"},
    {"city": "Rombly"},
    {"city": "Roquetoire"},
    {"city": "Rougefay"},
    {"city": "Roussent"},
    {"city": "Rouvroy"},
    {"city": "Royon"},
    {"city": "Ruisseauville"},
    {"city": "Ruitz"},
    {"city": "Rumaucourt"},
    {"city": "Rumilly"},
    {"city": "Ruminghem"},
    {"city": "Ruyaulcourt"},
    {"city": "Sachin"},
    {"city": "Sailly-au-Bois"},
    {"city": "Sailly-en-Ostrevent"},
    {"city": "Sailly-Labourse"},
    {"city": "Sailly-sur-la-Lys"},
    {"city": "Sains-en-Gohelle"},
    {"city": "Sains-lès-Fressin"},
    {"city": "Sains-lès-Marquion"},
    {"city": "Sains-lès-Pernes"},
    {"city": "Saint-Amand"},
    {"city": "Saint-Aubin"},
    {"city": "Sainte-Austreberthe"},
    {"city": "Sainte-Catherine"},
    {"city": "Saint-Denœux"},
    {"city": "Saint-Étienne-au-Mont"},
    {"city": "Saint-Floris"},
    {"city": "Saint-Folquin"},
    {"city": "Saint-Georges"},
    {"city": "Saint-Hilaire-Cottes"},
    {"city": "Saint-Inglevert"},
    {"city": "Saint-Josse"},
    {"city": "Saint-Laurent-Blangy"},
    {"city": "Saint-Léger"},
    {"city": "Saint-Léonard"},
    {"city": "Sainte-Marie-Kerque"},
    {"city": "Saint-Martin-lez-Tatinghem"},
    {"city": "Saint-Martin-Boulogne"},
    {"city": "Saint-Martin-Choquel"},
    {"city": "Saint-Martin-d'Hardinghem"},
    {"city": "Saint-Martin-sur-Cojeul"},
    {"city": "Saint-Michel-sous-Bois"},
    {"city": "Saint-Michel-sur-Ternoise"},
    {"city": "Saint-Nicolas"},
    {"city": "Saint-Omer"},
    {"city": "Saint-Omer-Capelle"},
    {"city": "Saint-Pol-sur-Ternoise"},
    {"city": "Saint-Rémy-au-Bois"},
    {"city": "Saint-Tricat"},
    {"city": "Saint-Venant"},
    {"city": "Sallaumines"},
    {"city": "Salperwick"},
    {"city": "Samer"},
    {"city": "Sangatte"},
    {"city": "Sanghen"},
    {"city": "Sapignies"},
    {"city": "Le Sars"},
    {"city": "Sars-le-Bois"},
    {"city": "Sarton"},
    {"city": "Sauchy-Cauchy"},
    {"city": "Sauchy-Lestrée"},
    {"city": "Saudemont"},
    {"city": "Saulchoy"},
    {"city": "Saulty"},
    {"city": "Savy-Berlette"},
    {"city": "Selles"},
    {"city": "Sempy"},
    {"city": "Seninghem"},
    {"city": "Senlecques"},
    {"city": "Senlis"},
    {"city": "Séricourt"},
    {"city": "Serques"},
    {"city": "Servins"},
    {"city": "Setques"},
    {"city": "Sibiville"},
    {"city": "Simencourt"},
    {"city": "Siracourt"},
    {"city": "Sombrin"},
    {"city": "Sorrus"},
    {"city": "Souastre"},
    {"city": "Souchez"},
    {"city": "Le Souich"},
    {"city": "Surques"},
    {"city": "Sus-Saint-Léger"},
    {"city": "Tangry"},
    {"city": "Tardinghen"},
    {"city": "Teneur"},
    {"city": "Ternas"},
    {"city": "Thélus"},
    {"city": "Thérouanne"},
    {"city": "Thiembronne"},
    {"city": "La Thieuloye"},
    {"city": "Thièvres"},
    {"city": "Tigny-Noyelle"},
    {"city": "Tilloy-lès-Hermaville"},
    {"city": "Tilloy-lès-Mofflaines"},
    {"city": "Tilly-Capelle"},
    {"city": "Tilques"},
    {"city": "Tincques"},
    {"city": "Tingry"},
    {"city": "Tollent"},
    {"city": "Torcy"},
    {"city": "Tortefontaine"},
    {"city": "Tortequesne"},
    {"city": "Le Touquet-Paris-Plage"},
    {"city": "Tournehem-sur-la-Hem"},
    {"city": "Tramecourt"},
    {"city": "Le Transloy"},
    {"city": "Trescault"},
    {"city": "Troisvaux"},
    {"city": "Tubersent"},
    {"city": "Vacquerie-le-Boucq"},
    {"city": "Vacqueriette-Erquières"},
    {"city": "Valhuon"},
    {"city": "Vaudricourt"},
    {"city": "Vaudringhem"},
    {"city": "Vaulx"},
    {"city": "Vaulx-Vraucourt"},
    {"city": "Vélu"},
    {"city": "Vendin-lès-Béthune"},
    {"city": "Vendin-le-Vieil"},
    {"city": "Verchin"},
    {"city": "Verchocq"},
    {"city": "Verlincthun"},
    {"city": "Vermelles"},
    {"city": "Verquigneul"},
    {"city": "Verquin"},
    {"city": "Verton"},
    {"city": "Vieil-Hesdin"},
    {"city": "Vieille-Chapelle"},
    {"city": "Vieille-Église"},
    {"city": "Vieil-Moutier"},
    {"city": "Villers-au-Bois"},
    {"city": "Villers-au-Flos"},
    {"city": "Villers-Brûlin"},
    {"city": "Villers-Châtel"},
    {"city": "Villers-lès-Cagnicourt"},
    {"city": "Villers-l'Hôpital"},
    {"city": "Villers-Sir-Simon"},
    {"city": "Vimy"},
    {"city": "Vincly"},
    {"city": "Violaines"},
    {"city": "Vis-en-Artois"},
    {"city": "Vitry-en-Artois"},
    {"city": "Waben"},
    {"city": "Wacquinghen"},
    {"city": "Wail"},
    {"city": "Wailly"},
    {"city": "Wailly-Beaucamp"},
    {"city": "Wambercourt"},
    {"city": "Wamin"},
    {"city": "Wancourt"},
    {"city": "Wanquetin"},
    {"city": "Wardrecques"},
    {"city": "Warlencourt-Eaucourt"},
    {"city": "Warlincourt-lès-Pas"},
    {"city": "Warlus"},
    {"city": "Warluzel"},
    {"city": "Le Wast"},
    {"city": "Beauvoir-Wavans"},
    {"city": "Wavrans-sur-l'Aa"},
    {"city": "Wavrans-sur-Ternoise"},
    {"city": "Westrehem"},
    {"city": "Wicquinghem"},
    {"city": "Widehem"},
    {"city": "Wierre-au-Bois"},
    {"city": "Wierre-Effroy"},
    {"city": "Willeman"},
    {"city": "Willencourt"},
    {"city": "Willerval"},
    {"city": "Wimereux"},
    {"city": "Wimille"},
    {"city": "Wingles"},
    {"city": "Wirwignes"},
    {"city": "Wismes"},
    {"city": "Wisques"},
    {"city": "Wissant"},
    {"city": "Witternesse"},
    {"city": "Wittes"},
    {"city": "Wizernes"},
    {"city": "Zoteux"},
    {"city": "Zouafques"},
    {"city": "Zudausques"},
    {"city": "Zutkerque"},
    {"city": "Libercourt"},
    {"city": "La Capelle-lès-Boulogne"},
    {"city": "Ytres"},
    {"city": "Aigueperse"},
    {"city": "Aix-la-Fayette"},
    {"city": "Ambert"},
    {"city": "Les Ancizes-Comps"},
    {"city": "Antoingt"},
    {"city": "Anzat-le-Luguet"},
    {"city": "Apchat"},
    {"city": "Arconsat"},
    {"city": "Ardes"},
    {"city": "Arlanc"},
    {"city": "Ars-les-Favets"},
    {"city": "Artonne"},
    {"city": "Aubiat"},
    {"city": "Aubière"},
    {"city": "Aubusson-d'Auvergne"},
    {"city": "Augerolles"},
    {"city": "Augnat"},
    {"city": "Aulnat"},
    {"city": "Aurières"},
    {"city": "Authezat"},
    {"city": "Auzat-la-Combelle"},
    {"city": "Auzelles"},
    {"city": "Avèze"},
    {"city": "Ayat-sur-Sioule"},
    {"city": "Aydat"},
    {"city": "Baffie"},
    {"city": "Bagnols"},
    {"city": "Bansat"},
    {"city": "Bas-et-Lezat"},
    {"city": "Beaulieu"},
    {"city": "Beaumont"},
    {"city": "Beaumont-lès-Randan"},
    {"city": "Beauregard-l'Évêque"},
    {"city": "Beauregard-Vendon"},
    {"city": "Bergonne"},
    {"city": "Bertignat"},
    {"city": "Besse-et-Saint-Anastaise"},
    {"city": "Beurières"},
    {"city": "Billom"},
    {"city": "Biollet"},
    {"city": "Blanzat"},
    {"city": "Blot-l'Église"},
    {"city": "Bongheat"},
    {"city": "Bort-l'Étang"},
    {"city": "Boudes"},
    {"city": "La Bourboule"},
    {"city": "Bourg-Lastic"},
    {"city": "Bouzel"},
    {"city": "Brassac-les-Mines"},
    {"city": "Brenat"},
    {"city": "Le Breuil-sur-Couze"},
    {"city": "Briffons"},
    {"city": "Le Broc"},
    {"city": "Bromont-Lamothe"},
    {"city": "Brousse"},
    {"city": "Le Brugeron"},
    {"city": "Bulhon"},
    {"city": "Busséol"},
    {"city": "Bussières"},
    {"city": "Bussières-et-Pruns"},
    {"city": "Buxières-sous-Montaigut"},
    {"city": "Cébazat"},
    {"city": "La Celle"},
    {"city": "Ceilloux"},
    {"city": "Celles-sur-Durolle"},
    {"city": "La Cellette"},
    {"city": "Le Cendre"},
    {"city": "Ceyrat"},
    {"city": "Ceyssat"},
    {"city": "Chabreloche"},
    {"city": "Chadeleuf"},
    {"city": "Chalus"},
    {"city": "Chamalières"},
    {"city": "Chambon-sur-Dolore"},
    {"city": "Chambon-sur-Lac"},
    {"city": "Champagnat-le-Jeune"},
    {"city": "Champeix"},
    {"city": "Champétières"},
    {"city": "Champs"},
    {"city": "Chanat-la-Mouteyre"},
    {"city": "Chanonat"},
    {"city": "Chapdes-Beaufort"},
    {"city": "La Chapelle-Agnon"},
    {"city": "La Chapelle-Marcousse"},
    {"city": "La Chapelle-sur-Usson"},
    {"city": "Chappes"},
    {"city": "Chaptuzat"},
    {"city": "Charbonnier-les-Mines"},
    {"city": "Charbonnières-les-Varennes"},
    {"city": "Charbonnières-les-Vieilles"},
    {"city": "Charensat"},
    {"city": "Charnat"},
    {"city": "Chas"},
    {"city": "Chassagne"},
    {"city": "Chastreix"},
    {"city": "Châteaugay"},
    {"city": "Châteauneuf-les-Bains"},
    {"city": "Château-sur-Cher"},
    {"city": "Châteldon"},
    {"city": "Châtel-Guyon"},
    {"city": "La Chaulme"},
    {"city": "Chaumont-le-Bourg"},
    {"city": "Chauriat"},
    {"city": "Chavaroux"},
    {"city": "Le Cheix"},
    {"city": "Chidrac"},
    {"city": "Cisternes-la-Forêt"},
    {"city": "Clémensat"},
    {"city": "Clerlande"},
    {"city": "Clermont-Ferrand"},
    {"city": "Collanges"},
    {"city": "Combrailles"},
    {"city": "Combronde"},
    {"city": "Compains"},
    {"city": "Condat-en-Combraille"},
    {"city": "Condat-lès-Montboissier"},
    {"city": "Corent"},
    {"city": "Coudes"},
    {"city": "Courgoul"},
    {"city": "Cournols"},
    {"city": "Cournon-d'Auvergne"},
    {"city": "Courpière"},
    {"city": "Le Crest"},
    {"city": "Crevant-Laveine"},
    {"city": "Cros"},
    {"city": "La Crouzille"},
    {"city": "Culhat"},
    {"city": "Cunlhat"},
    {"city": "Dauzat-sur-Vodable"},
    {"city": "Davayat"},
    {"city": "Domaize"},
    {"city": "Doranges"},
    {"city": "Dorat"},
    {"city": "Dore-l'Église"},
    {"city": "Durmignat"},
    {"city": "Durtol"},
    {"city": "Échandelys"},
    {"city": "Effiat"},
    {"city": "Égliseneuve-d'Entraigues"},
    {"city": "Égliseneuve-des-Liards"},
    {"city": "Égliseneuve-près-Billom"},
    {"city": "Églisolles"},
    {"city": "Ennezat"},
    {"city": "Entraigues"},
    {"city": "Enval"},
    {"city": "Escoutoux"},
    {"city": "Espinasse"},
    {"city": "Espinchal"},
    {"city": "Espirat"},
    {"city": "Estandeuil"},
    {"city": "Esteil"},
    {"city": "Fayet-le-Château"},
    {"city": "Fayet-Ronaye"},
    {"city": "Fernoël"},
    {"city": "Aulhat-Flat"},
    {"city": "La Forie"},
    {"city": "Fournols"},
    {"city": "Gelles"},
    {"city": "Gerzat"},
    {"city": "Giat"},
    {"city": "Gignat"},
    {"city": "Gimeaux"},
    {"city": "Glaine-Montaigut"},
    {"city": "La Godivelle"},
    {"city": "La Goutelle"},
    {"city": "Gouttières"},
    {"city": "Grandeyrolles"},
    {"city": "Grandrif"},
    {"city": "Grandval"},
    {"city": "Herment"},
    {"city": "Heume-l'Église"},
    {"city": "Isserteaux"},
    {"city": "Issoire"},
    {"city": "Job"},
    {"city": "Joze"},
    {"city": "Jozerand"},
    {"city": "Jumeaux"},
    {"city": "Labessette"},
    {"city": "Lachaux"},
    {"city": "Lamontgie"},
    {"city": "Landogne"},
    {"city": "Lapeyrouse"},
    {"city": "Laps"},
    {"city": "Laqueuille"},
    {"city": "Larodde"},
    {"city": "Lastic"},
    {"city": "La Tour-d'Auvergne"},
    {"city": "Lempdes"},
    {"city": "Lempty"},
    {"city": "Lezoux"},
    {"city": "Limons"},
    {"city": "Lisseuil"},
    {"city": "Loubeyrat"},
    {"city": "Ludesse"},
    {"city": "Lussat"},
    {"city": "Luzillat"},
    {"city": "Madriat"},
    {"city": "Malauzat"},
    {"city": "Malintrat"},
    {"city": "Manglieu"},
    {"city": "Manzat"},
    {"city": "Marat"},
    {"city": "Marcillat"},
    {"city": "Mareugheol"},
    {"city": "Maringues"},
    {"city": "Marsac-en-Livradois"},
    {"city": "Marsat"},
    {"city": "Les Martres-d'Artière"},
    {"city": "Les Martres-de-Veyre"},
    {"city": "Martres-sur-Morge"},
    {"city": "Mauzun"},
    {"city": "Mayres"},
    {"city": "Mazaye"},
    {"city": "Mazoires"},
    {"city": "Medeyrolles"},
    {"city": "Meilhaud"},
    {"city": "Menat"},
    {"city": "Ménétrol"},
    {"city": "Messeix"},
    {"city": "Mur-sur-Allier"},
    {"city": "Mirefleurs"},
    {"city": "Miremont"},
    {"city": "Moissat"},
    {"city": "Le Monestier"},
    {"city": "La Monnerie-le-Montel"},
    {"city": "Mons"},
    {"city": "Montaigut"},
    {"city": "Montaigut-le-Blanc"},
    {"city": "Montcel"},
    {"city": "Mont-Dore"},
    {"city": "Montel-de-Gelat"},
    {"city": "Montfermy"},
    {"city": "Montmorin"},
    {"city": "Montpensier"},
    {"city": "Montpeyroux"},
    {"city": "Moriat"},
    {"city": "Moureuille"},
    {"city": "Chambaron sur Morge"},
    {"city": "Mozac"},
    {"city": "Murat-le-Quaire"},
    {"city": "Murol"},
    {"city": "Nébouzat"},
    {"city": "Néronde-sur-Dore"},
    {"city": "Neschers"},
    {"city": "Neuf-Église"},
    {"city": "Neuville"},
    {"city": "Noalhat"},
    {"city": "Nohanent"},
    {"city": "Nonette-Orsonnette"},
    {"city": "Novacelles"},
    {"city": "Olby"},
    {"city": "Olliergues"},
    {"city": "Olloix"},
    {"city": "Olmet"},
    {"city": "Orbeil"},
    {"city": "Orcet"},
    {"city": "Orcines"},
    {"city": "Orcival"},
    {"city": "Orléat"},
    {"city": "Palladuc"},
    {"city": "Pardines"},
    {"city": "Parent"},
    {"city": "Parentignat"},
    {"city": "Paslières"},
    {"city": "Pérignat-lès-Sarliève"},
    {"city": "Pérignat-sur-Allier"},
    {"city": "Perpezat"},
    {"city": "Perrier"},
    {"city": "Peschadoires"},
    {"city": "Peslières"},
    {"city": "Pessat-Villeneuve"},
    {"city": "Picherande"},
    {"city": "Pignols"},
    {"city": "Pionsat"},
    {"city": "Plauzat"},
    {"city": "Pontaumur"},
    {"city": "Pont-du-Château"},
    {"city": "Pontgibaud"},
    {"city": "Pouzol"},
    {"city": "Les Pradeaux"},
    {"city": "Prompsat"},
    {"city": "Prondines"},
    {"city": "Pulvérières"},
    {"city": "Puy-Guillaume"},
    {"city": "Puy-Saint-Gulmier"},
    {"city": "Le Quartier"},
    {"city": "Queuille"},
    {"city": "Randan"},
    {"city": "Ravel"},
    {"city": "Reignat"},
    {"city": "La Renaudie"},
    {"city": "Rentières"},
    {"city": "Riom"},
    {"city": "Ris"},
    {"city": "La Roche-Blanche"},
    {"city": "Roche-Charles-la-Mayrand"},
    {"city": "Roche-d'Agoux"},
    {"city": "Rochefort-Montagne"},
    {"city": "La Roche-Noire"},
    {"city": "Romagnat"},
    {"city": "Royat"},
    {"city": "Saillant"},
    {"city": "Sainte-Agathe"},
    {"city": "Saint-Agoulin"},
    {"city": "Saint-Alyre-d'Arlanc"},
    {"city": "Saint-Alyre-ès-Montagne"},
    {"city": "Saint-Amant-Roche-Savine"},
    {"city": "Saint-Amant-Tallende"},
    {"city": "Saint-André-le-Coq"},
    {"city": "Saint-Angel"},
    {"city": "Saint-Anthème"},
    {"city": "Saint-Avit"},
    {"city": "Saint-Babel"},
    {"city": "Saint-Beauzire"},
    {"city": "Saint-Bonnet-le-Bourg"},
    {"city": "Saint-Bonnet-le-Chastel"},
    {"city": "Saint-Bonnet-lès-Allier"},
    {"city": "Saint-Bonnet-près-Orcival"},
    {"city": "Saint-Bonnet-près-Riom"},
    {"city": "Sainte-Catherine"},
    {"city": "Sainte-Christine"},
    {"city": "Saint-Cirgues-sur-Couze"},
    {"city": "Saint-Clément-de-Valorgue"},
    {"city": "Saint-Clément-de-Régnat"},
    {"city": "Saint-Denis-Combarnazat"},
    {"city": "Saint-Dier-d'Auvergne"},
    {"city": "Saint-Diéry"},
    {"city": "Saint-Donat"},
    {"city": "Saint-Éloy-la-Glacière"},
    {"city": "Saint-Éloy-les-Mines"},
    {"city": "Saint-Étienne-des-Champs"},
    {"city": "Saint-Étienne-sur-Usson"},
    {"city": "Saint-Ferréol-des-Côtes"},
    {"city": "Saint-Floret"},
    {"city": "Saint-Flour"},
    {"city": "Saint-Gal-sur-Sioule"},
    {"city": "Saint-Genès-Champanelle"},
    {"city": "Saint-Genès-Champespe"},
    {"city": "Saint-Genès-du-Retz"},
    {"city": "Saint-Genès-la-Tourette"},
    {"city": "Saint-Georges-de-Mons"},
    {"city": "Saint-Georges-sur-Allier"},
    {"city": "Saint-Germain-près-Herment"},
    {"city": "Saint-Germain-Lembron"},
    {"city": "Saint-Germain-l'Herm"},
    {"city": "Saint-Gervais-d'Auvergne"},
    {"city": "Saint-Gervais-sous-Meymont"},
    {"city": "Saint-Gervazy"},
    {"city": "Saint-Hérent"},
    {"city": "Saint-Hilaire-la-Croix"},
    {"city": "Saint-Hilaire-les-Monges"},
    {"city": "Saint-Hilaire"},
    {"city": "Saint-Ignat"},
    {"city": "Saint-Jacques-d'Ambur"},
    {"city": "Saint-Jean-d'Heurs"},
    {"city": "Saint-Jean-des-Ollières"},
    {"city": "Saint-Jean-en-Val"},
    {"city": "Saint-Jean-Saint-Gervais"},
    {"city": "Saint-Julien-de-Coppel"},
    {"city": "Saint-Julien-la-Geneste"},
    {"city": "Saint-Julien-Puy-Lavèze"},
    {"city": "Saint-Just"},
    {"city": "Saint-Laure"},
    {"city": "Saint-Maigner"},
    {"city": "Saint-Martin-des-Olmes"},
    {"city": "Saint-Martin-des-Plains"},
    {"city": "Saint-Martin-d'Ollières"},
    {"city": "Saint-Maurice-près-Pionsat"},
    {"city": "Saint-Maurice"},
    {"city": "Saint-Myon"},
    {"city": "Saint-Nectaire"},
    {"city": "Saint-Ours"},
    {"city": "Saint-Pardoux"},
    {"city": "Saint-Pierre-Colamine"},
    {"city": "Saint-Pierre-la-Bourlhonne"},
    {"city": "Saint-Pierre-le-Chastel"},
    {"city": "Saint-Pierre-Roche"},
    {"city": "Saint-Priest-Bramefant"},
    {"city": "Saint-Priest-des-Champs"},
    {"city": "Saint-Quentin-sur-Sauxillanges"},
    {"city": "Saint-Quintin-sur-Sioule"},
    {"city": "Saint-Rémy-de-Blot"},
    {"city": "Saint-Rémy-de-Chargnat"},
    {"city": "Saint-Rémy-sur-Durolle"},
    {"city": "Saint-Romain"},
    {"city": "Saint-Sandoux"},
    {"city": "Saint-Saturnin"},
    {"city": "Saint-Sauves-d'Auvergne"},
    {"city": "Saint-Sauveur-la-Sagne"},
    {"city": "Saint-Sulpice"},
    {"city": "Saint-Sylvestre-Pragoulin"},
    {"city": "Saint-Victor-la-Rivière"},
    {"city": "Saint-Victor-Montvianeix"},
    {"city": "Saint-Vincent"},
    {"city": "Saint-Yvoine"},
    {"city": "Sallèdes"},
    {"city": "Sardon"},
    {"city": "Saulzet-le-Froid"},
    {"city": "Sauret-Besserve"},
    {"city": "Saurier"},
    {"city": "Sauvagnat"},
    {"city": "Sauvagnat-Sainte-Marthe"},
    {"city": "Sauvessanges"},
    {"city": "La Sauvetat"},
    {"city": "Sauviat"},
    {"city": "Sauxillanges"},
    {"city": "Savennes"},
    {"city": "Sayat"},
    {"city": "Sermentizon"},
    {"city": "Servant"},
    {"city": "Seychalles"},
    {"city": "Singles"},
    {"city": "Solignat"},
    {"city": "Sugères"},
    {"city": "Surat"},
    {"city": "Tallende"},
    {"city": "Tauves"},
    {"city": "Teilhède"},
    {"city": "Teilhet"},
    {"city": "Ternant-les-Eaux"},
    {"city": "Thiers"},
    {"city": "Thiolières"},
    {"city": "Thuret"},
    {"city": "Tortebesse"},
    {"city": "Tours-sur-Meymont"},
    {"city": "Tourzel-Ronzières"},
    {"city": "Tralaigues"},
    {"city": "Trémouille-Saint-Loup"},
    {"city": "Trézioux"},
    {"city": "Usson"},
    {"city": "Valbeleix"},
    {"city": "Valcivières"},
    {"city": "Valz-sous-Châteauneuf"},
    {"city": "Varennes-sur-Morge"},
    {"city": "Varennes-sur-Usson"},
    {"city": "Vassel"},
    {"city": "Vensat"},
    {"city": "Vergheas"},
    {"city": "Le Vernet-Chaméane"},
    {"city": "Le Vernet-Sainte-Marguerite"},
    {"city": "Verneugheol"},
    {"city": "Vernines"},
    {"city": "Verrières"},
    {"city": "Vertaizon"},
    {"city": "Vertolaye"},
    {"city": "Veyre-Monton"},
    {"city": "Vichel"},
    {"city": "Vic-le-Comte"},
    {"city": "Villeneuve"},
    {"city": "Villeneuve-les-Cerfs"},
    {"city": "Villosanges"},
    {"city": "Vinzelles"},
    {"city": "Virlet"},
    {"city": "Viscomtat"},
    {"city": "Vitrac"},
    {"city": "Viverols"},
    {"city": "Vodable"},
    {"city": "Voingt"},
    {"city": "Vollore-Montagne"},
    {"city": "Vollore-Ville"},
    {"city": "Volvic"},
    {"city": "Youx"},
    {"city": "Yronde-et-Buron"},
    {"city": "Yssac-la-Tourette"},
    {"city": "Aast"},
    {"city": "Abère"},
    {"city": "Abidos"},
    {"city": "Abitain"},
    {"city": "Abos"},
    {"city": "Accous"},
    {"city": "Agnos"},
    {"city": "Ahaxe-Alciette-Bascassan"},
    {"city": "Ahetze"},
    {"city": "Aïcirits-Camou-Suhast"},
    {"city": "Aincille"},
    {"city": "Ainharp"},
    {"city": "Ainhice-Mongelos"},
    {"city": "Ainhoa"},
    {"city": "Alçay-Alçabéhéty-Sunharette"},
    {"city": "Aldudes"},
    {"city": "Alos-Sibas-Abense"},
    {"city": "Amendeuix-Oneix"},
    {"city": "Amorots-Succos"},
    {"city": "Andoins"},
    {"city": "Andrein"},
    {"city": "Angaïs"},
    {"city": "Anglet"},
    {"city": "Angous"},
    {"city": "Anhaux"},
    {"city": "Anos"},
    {"city": "Anoye"},
    {"city": "Aramits"},
    {"city": "Arancou"},
    {"city": "Araujuzon"},
    {"city": "Araux"},
    {"city": "Arbérats-Sillègue"},
    {"city": "Arbonne"},
    {"city": "Arbouet-Sussaute"},
    {"city": "Arbus"},
    {"city": "Arcangues"},
    {"city": "Aren"},
    {"city": "Arette"},
    {"city": "Aressy"},
    {"city": "Argagnon"},
    {"city": "Argelos"},
    {"city": "Arget"},
    {"city": "Arhansus"},
    {"city": "Armendarits"},
    {"city": "Arnéguy"},
    {"city": "Arnos"},
    {"city": "Aroue-Ithorots-Olhaïby"},
    {"city": "Arrast-Larrebieu"},
    {"city": "Arraute-Charritte"},
    {"city": "Arricau-Bordes"},
    {"city": "Arrien"},
    {"city": "Arros-de-Nay"},
    {"city": "Arrosès"},
    {"city": "Arthez-de-Béarn"},
    {"city": "Arthez-d'Asson"},
    {"city": "Artigueloutan"},
    {"city": "Artiguelouve"},
    {"city": "Artix"},
    {"city": "Arudy"},
    {"city": "Arzacq-Arraziguet"},
    {"city": "Asasp-Arros"},
    {"city": "Ascain"},
    {"city": "Ascarat"},
    {"city": "Assat"},
    {"city": "Asson"},
    {"city": "Aste-Béon"},
    {"city": "Astis"},
    {"city": "Athos-Aspis"},
    {"city": "Aubertin"},
    {"city": "Aubin"},
    {"city": "Aubous"},
    {"city": "Audaux"},
    {"city": "Auga"},
    {"city": "Auriac"},
    {"city": "Aurions-Idernes"},
    {"city": "Aussevielle"},
    {"city": "Aussurucq"},
    {"city": "Auterrive"},
    {"city": "Autevielle-Saint-Martin-Bideren"},
    {"city": "Aydie"},
    {"city": "Aydius"},
    {"city": "Ayherre"},
    {"city": "Baigts-de-Béarn"},
    {"city": "Balansun"},
    {"city": "Baleix"},
    {"city": "Baliracq-Maumusson"},
    {"city": "Baliros"},
    {"city": "Banca"},
    {"city": "Barcus"},
    {"city": "Bardos"},
    {"city": "Barinque"},
    {"city": "Barraute-Camu"},
    {"city": "Barzun"},
    {"city": "Bassillon-Vauzé"},
    {"city": "Bastanès"},
    {"city": "Bassussarry"},
    {"city": "Baudreix"},
    {"city": "Bayonne"},
    {"city": "Bédeille"},
    {"city": "Bedous"},
    {"city": "Béguios"},
    {"city": "Béhasque-Lapiste"},
    {"city": "Béhorléguy"},
    {"city": "Bellocq"},
    {"city": "Bénéjacq"},
    {"city": "Béost"},
    {"city": "Bentayou-Sérée"},
    {"city": "Bérenx"},
    {"city": "Bergouey-Viellenave"},
    {"city": "Bernadets"},
    {"city": "Berrogain-Laruns"},
    {"city": "Bescat"},
    {"city": "Bésingrand"},
    {"city": "Bétracq"},
    {"city": "Beuste"},
    {"city": "Beyrie-sur-Joyeuse"},
    {"city": "Beyrie-en-Béarn"},
    {"city": "Biarritz"},
    {"city": "Bidache"},
    {"city": "Bidarray"},
    {"city": "Bidart"},
    {"city": "Bidos"},
    {"city": "Bielle"},
    {"city": "Bilhères"},
    {"city": "Billère"},
    {"city": "Biriatou"},
    {"city": "Biron"},
    {"city": "Bizanos"},
    {"city": "Boeil-Bezing"},
    {"city": "Bonloc"},
    {"city": "Bonnut"},
    {"city": "Borce"},
    {"city": "Bordères"},
    {"city": "Bordes"},
    {"city": "Bosdarros"},
    {"city": "Boucau"},
    {"city": "Boueilh-Boueilho-Lasque"},
    {"city": "Bougarber"},
    {"city": "Bouillon"},
    {"city": "Boumourt"},
    {"city": "Bourdettes"},
    {"city": "Bournos"},
    {"city": "Briscous"},
    {"city": "Bruges-Capbis-Mifaget"},
    {"city": "Bugnein"},
    {"city": "Bunus"},
    {"city": "Burgaronne"},
    {"city": "Buros"},
    {"city": "Burosse-Mendousse"},
    {"city": "Bussunarits-Sarrasquette"},
    {"city": "Bustince-Iriberry"},
    {"city": "Buziet"},
    {"city": "Buzy"},
    {"city": "Cabidos"},
    {"city": "Cadillon"},
    {"city": "Cambo-les-Bains"},
    {"city": "Came"},
    {"city": "Camou-Cihigue"},
    {"city": "Cardesse"},
    {"city": "Caro"},
    {"city": "Carrère"},
    {"city": "Carresse-Cassaber"},
    {"city": "Castagnède"},
    {"city": "Casteide-Cami"},
    {"city": "Casteide-Candau"},
    {"city": "Casteide-Doat"},
    {"city": "Castéra-Loubix"},
    {"city": "Castet"},
    {"city": "Castetbon"},
    {"city": "Castétis"},
    {"city": "Castetnau-Camblong"},
    {"city": "Castetner"},
    {"city": "Castetpugon"},
    {"city": "Castillon (Canton d'Arthez-de-Béarn)"},
    {"city": "Castillon (Canton de Lembeye)"},
    {"city": "Caubios-Loos"},
    {"city": "Cescau"},
    {"city": "Cette-Eygun"},
    {"city": "Charre"},
    {"city": "Charritte-de-Bas"},
    {"city": "Chéraute"},
    {"city": "Ciboure"},
    {"city": "Claracq"},
    {"city": "Coarraze"},
    {"city": "Conchez-de-Béarn"},
    {"city": "Corbère-Abères"},
    {"city": "Coslédaà-Lube-Boast"},
    {"city": "Coublucq"},
    {"city": "Crouseilles"},
    {"city": "Cuqueron"},
    {"city": "Denguin"},
    {"city": "Diusse"},
    {"city": "Doazon"},
    {"city": "Dognen"},
    {"city": "Domezain-Berraute"},
    {"city": "Doumy"},
    {"city": "Eaux-Bonnes"},
    {"city": "Escos"},
    {"city": "Escot"},
    {"city": "Escou"},
    {"city": "Escoubès"},
    {"city": "Escout"},
    {"city": "Escurès"},
    {"city": "Eslourenties-Daban"},
    {"city": "Espéchède"},
    {"city": "Espelette"},
    {"city": "Espès-Undurein"},
    {"city": "Espiute"},
    {"city": "Espoey"},
    {"city": "Esquiule"},
    {"city": "Estérençuby"},
    {"city": "Estialescq"},
    {"city": "Estos"},
    {"city": "Etcharry"},
    {"city": "Etchebar"},
    {"city": "Etsaut"},
    {"city": "Eysus"},
    {"city": "Ance Féas"},
    {"city": "Fichous-Riumayou"},
    {"city": "Gabaston"},
    {"city": "Gabat"},
    {"city": "Gamarthe"},
    {"city": "Gan"},
    {"city": "Garindein"},
    {"city": "Garlède-Mondebat"},
    {"city": "Garlin"},
    {"city": "Garos"},
    {"city": "Garris"},
    {"city": "Gayon"},
    {"city": "Gelos"},
    {"city": "Ger"},
    {"city": "Gerderest"},
    {"city": "Gère-Bélesten"},
    {"city": "Géronce"},
    {"city": "Gestas"},
    {"city": "Géus-d'Arzacq"},
    {"city": "Geüs-d'Oloron"},
    {"city": "Goès"},
    {"city": "Gomer"},
    {"city": "Gotein-Libarrenx"},
    {"city": "Guéthary"},
    {"city": "Guiche"},
    {"city": "Guinarthe-Parenties"},
    {"city": "Gurmençon"},
    {"city": "Gurs"},
    {"city": "Hagetaubin"},
    {"city": "Halsou"},
    {"city": "Hasparren"},
    {"city": "Haut-de-Bosdarros"},
    {"city": "Haux"},
    {"city": "Hélette"},
    {"city": "Hendaye"},
    {"city": "Herrère"},
    {"city": "Higuères-Souye"},
    {"city": "L'Hôpital-d'Orion"},
    {"city": "L'Hôpital-Saint-Blaise"},
    {"city": "Hosta"},
    {"city": "Hours"},
    {"city": "Ibarrolle"},
    {"city": "Idaux-Mendy"},
    {"city": "Idron"},
    {"city": "Igon"},
    {"city": "Iholdy"},
    {"city": "Ilharre"},
    {"city": "Irissarry"},
    {"city": "Irouléguy"},
    {"city": "Ispoure"},
    {"city": "Issor"},
    {"city": "Isturits"},
    {"city": "Itxassou"},
    {"city": "Izeste"},
    {"city": "Jasses"},
    {"city": "Jatxou"},
    {"city": "Jaxu"},
    {"city": "Jurançon"},
    {"city": "Juxue"},
    {"city": "Laà-Mondrans"},
    {"city": "Laàs"},
    {"city": "Labastide-Cézéracq"},
    {"city": "La Bastide-Clairence"},
    {"city": "Labastide-Monréjeau"},
    {"city": "Labastide-Villefranche"},
    {"city": "Labatmale"},
    {"city": "Labatut"},
    {"city": "Labets-Biscay"},
    {"city": "Labeyrie"},
    {"city": "Lacadée"},
    {"city": "Lacarre"},
    {"city": "Lacarry-Arhan-Charritte-de-Haut"},
    {"city": "Lacommande"},
    {"city": "Lacq"},
    {"city": "Lagor"},
    {"city": "Lagos"},
    {"city": "Laguinge-Restoue"},
    {"city": "Lahonce"},
    {"city": "Lahontan"},
    {"city": "Lahourcade"},
    {"city": "Lalongue"},
    {"city": "Lalonquette"},
    {"city": "Lamayou"},
    {"city": "Lanne-en-Barétous"},
    {"city": "Lannecaube"},
    {"city": "Lanneplaà"},
    {"city": "Lantabat"},
    {"city": "Larceveau-Arros-Cibits"},
    {"city": "Laroin"},
    {"city": "Larrau"},
    {"city": "Larressore"},
    {"city": "Larreule"},
    {"city": "Larribar-Sorhapuru"},
    {"city": "Laruns"},
    {"city": "Lasclaveries"},
    {"city": "Lasse"},
    {"city": "Lasserre"},
    {"city": "Lasseube"},
    {"city": "Lasseubetat"},
    {"city": "Lay-Lamidou"},
    {"city": "Lecumberry"},
    {"city": "Ledeuix"},
    {"city": "Lée"},
    {"city": "Lées-Athas"},
    {"city": "Lembeye"},
    {"city": "Lème"},
    {"city": "Léren"},
    {"city": "Lescar"},
    {"city": "Lescun"},
    {"city": "Lespielle"},
    {"city": "Lespourcy"},
    {"city": "Lestelle-Bétharram"},
    {"city": "Lichans-Sunhar"},
    {"city": "Lichos"},
    {"city": "Licq-Athérey"},
    {"city": "Limendous"},
    {"city": "Livron"},
    {"city": "Lohitzun-Oyhercq"},
    {"city": "Lombia"},
    {"city": "Lonçon"},
    {"city": "Lons"},
    {"city": "Loubieng"},
    {"city": "Louhossoa"},
    {"city": "Lourdios-Ichère"},
    {"city": "Lourenties"},
    {"city": "Louvie-Juzon"},
    {"city": "Louvie-Soubiron"},
    {"city": "Louvigny"},
    {"city": "Luc-Armau"},
    {"city": "Lucarré"},
    {"city": "Lucgarier"},
    {"city": "Lucq-de-Béarn"},
    {"city": "Lurbe-Saint-Christau"},
    {"city": "Lussagnet-Lusson"},
    {"city": "Luxe-Sumberraute"},
    {"city": "Lys"},
    {"city": "Macaye"},
    {"city": "Malaussanne"},
    {"city": "Mascaraàs-Haron"},
    {"city": "Maslacq"},
    {"city": "Masparraute"},
    {"city": "Maspie-Lalonquère-Juillacq"},
    {"city": "Maucor"},
    {"city": "Mauléon-Licharre"},
    {"city": "Maure"},
    {"city": "Mazères-Lezons"},
    {"city": "Mazerolles"},
    {"city": "Méharin"},
    {"city": "Meillon"},
    {"city": "Mendionde"},
    {"city": "Menditte"},
    {"city": "Mendive"},
    {"city": "Méracq"},
    {"city": "Méritein"},
    {"city": "Mesplède"},
    {"city": "Mialos"},
    {"city": "Miossens-Lanusse"},
    {"city": "Mirepeix"},
    {"city": "Momas"},
    {"city": "Momy"},
    {"city": "Monassut-Audiracq"},
    {"city": "Moncaup"},
    {"city": "Moncayolle-Larrory-Mendibieu"},
    {"city": "Moncla"},
    {"city": "Monein"},
    {"city": "Monpezat"},
    {"city": "Monségur"},
    {"city": "Mont"},
    {"city": "Montagut"},
    {"city": "Montaner"},
    {"city": "Montardon"},
    {"city": "Montaut"},
    {"city": "Mont-Disse"},
    {"city": "Montfort"},
    {"city": "Montory"},
    {"city": "Morlaàs"},
    {"city": "Morlanne"},
    {"city": "Mouguerre"},
    {"city": "Mouhous"},
    {"city": "Moumour"},
    {"city": "Mourenx"},
    {"city": "Musculdy"},
    {"city": "Nabas"},
    {"city": "Narcastet"},
    {"city": "Narp"},
    {"city": "Navailles-Angos"},
    {"city": "Navarrenx"},
    {"city": "Nay"},
    {"city": "Noguères"},
    {"city": "Nousty"},
    {"city": "Ogenne-Camptort"},
    {"city": "Ogeu-les-Bains"},
    {"city": "Oloron-Sainte-Marie"},
    {"city": "Oraàs"},
    {"city": "Ordiarp"},
    {"city": "Orègue"},
    {"city": "Orin"},
    {"city": "Orion"},
    {"city": "Orriule"},
    {"city": "Orsanco"},
    {"city": "Orthez"},
    {"city": "Os-Marsillon"},
    {"city": "Ossas-Suhare"},
    {"city": "Osse-en-Aspe"},
    {"city": "Ossenx"},
    {"city": "Osserain-Rivareyte"},
    {"city": "Ossès"},
    {"city": "Ostabat-Asme"},
    {"city": "Ouillon"},
    {"city": "Ousse"},
    {"city": "Ozenx-Montestrucq"},
    {"city": "Pagolle"},
    {"city": "Parbayse"},
    {"city": "Pardies"},
    {"city": "Pardies-Piétat"},
    {"city": "Pau"},
    {"city": "Peyrelongue-Abos"},
    {"city": "Piets-Plasence-Moustrou"},
    {"city": "Poey-de-Lescar"},
    {"city": "Poey-d'Oloron"},
    {"city": "Pomps"},
    {"city": "Ponson-Debat-Pouts"},
    {"city": "Ponson-Dessus"},
    {"city": "Pontacq"},
    {"city": "Pontiacq-Viellepinte"},
    {"city": "Portet"},
    {"city": "Pouliacq"},
    {"city": "Poursiugues-Boucoue"},
    {"city": "Préchacq-Josbaig"},
    {"city": "Préchacq-Navarrenx"},
    {"city": "Précilhon"},
    {"city": "Puyoô"},
    {"city": "Ramous"},
    {"city": "Rébénacq"},
    {"city": "Ribarrouy"},
    {"city": "Riupeyrous"},
    {"city": "Rivehaute"},
    {"city": "Rontignon"},
    {"city": "Roquiague"},
    {"city": "Saint-Abit"},
    {"city": "Saint-Armou"},
    {"city": "Saint-Boès"},
    {"city": "Saint-Castin"},
    {"city": "Sainte-Colome"},
    {"city": "Saint-Dos"},
    {"city": "Sainte-Engrâce"},
    {"city": "Saint-Esteben"},
    {"city": "Saint-Étienne-de-Baïgorry"},
    {"city": "Saint-Faust"},
    {"city": "Saint-Girons-en-Béarn"},
    {"city": "Saint-Gladie-Arrive-Munein"},
    {"city": "Saint-Goin"},
    {"city": "Saint-Jammes"},
    {"city": "Saint-Jean-de-Luz"},
    {"city": "Saint-Jean-le-Vieux"},
    {"city": "Saint-Jean-Pied-de-Port"},
    {"city": "Saint-Jean-Poudge"},
    {"city": "Saint-Just-Ibarre"},
    {"city": "Saint-Laurent-Bretagne"},
    {"city": "Saint-Martin-d'Arberoue"},
    {"city": "Saint-Martin-d'Arrossa"},
    {"city": "Saint-Médard"},
    {"city": "Saint-Michel"},
    {"city": "Saint-Palais"},
    {"city": "Saint-Pé-de-Léren"},
    {"city": "Saint-Pée-sur-Nivelle"},
    {"city": "Saint-Pierre-d'Irube"},
    {"city": "Saint-Vincent"},
    {"city": "Salies-de-Béarn"},
    {"city": "Salles-Mongiscard"},
    {"city": "Sallespisse"},
    {"city": "Sames"},
    {"city": "Samsons-Lion"},
    {"city": "Sare"},
    {"city": "Sarpourenx"},
    {"city": "Sarrance"},
    {"city": "Saubole"},
    {"city": "Saucède"},
    {"city": "Sauguis-Saint-Étienne"},
    {"city": "Sault-de-Navailles"},
    {"city": "Sauvagnon"},
    {"city": "Sauvelade"},
    {"city": "Sauveterre-de-Béarn"},
    {"city": "Séby"},
    {"city": "Sedze-Maubecq"},
    {"city": "Sedzère"},
    {"city": "Séméacq-Blachon"},
    {"city": "Sendets"},
    {"city": "Serres-Castet"},
    {"city": "Serres-Morlaàs"},
    {"city": "Serres-Sainte-Marie"},
    {"city": "Sévignacq-Meyracq"},
    {"city": "Sévignacq"},
    {"city": "Simacourbe"},
    {"city": "Siros"},
    {"city": "Soumoulou"},
    {"city": "Souraïde"},
    {"city": "Suhescun"},
    {"city": "Sus"},
    {"city": "Susmiou"},
    {"city": "Tabaille-Usquain"},
    {"city": "Tadousse-Ussau"},
    {"city": "Tardets-Sorholus"},
    {"city": "Taron-Sadirac-Viellenave"},
    {"city": "Tarsacq"},
    {"city": "Thèze"},
    {"city": "Trois-Villes"},
    {"city": "Uhart-Cize"},
    {"city": "Uhart-Mixe"},
    {"city": "Urcuit"},
    {"city": "Urdès"},
    {"city": "Urdos"},
    {"city": "Urepel"},
    {"city": "Urost"},
    {"city": "Urrugne"},
    {"city": "Urt"},
    {"city": "Ustaritz"},
    {"city": "Uzan"},
    {"city": "Uzein"},
    {"city": "Uzos"},
    {"city": "Verdets"},
    {"city": "Vialer"},
    {"city": "Viellenave-d'Arthez"},
    {"city": "Viellenave-de-Navarrenx"},
    {"city": "Vielleségure"},
    {"city": "Vignes"},
    {"city": "Villefranque"},
    {"city": "Viodos-Abense-de-Bas"},
    {"city": "Viven"},
    {"city": "Adast"},
    {"city": "Adé"},
    {"city": "Adervielle-Pouchergues"},
    {"city": "Agos-Vidalos"},
    {"city": "Allier"},
    {"city": "Ancizan"},
    {"city": "Andrest"},
    {"city": "Anères"},
    {"city": "Angos"},
    {"city": "Les Angles"},
    {"city": "Anla"},
    {"city": "Ansost"},
    {"city": "Antichan"},
    {"city": "Antin"},
    {"city": "Antist"},
    {"city": "Aragnouet"},
    {"city": "Arbéost"},
    {"city": "Arcizac-Adour"},
    {"city": "Arcizac-ez-Angles"},
    {"city": "Arcizans-Avant"},
    {"city": "Arcizans-Dessus"},
    {"city": "Ardengost"},
    {"city": "Argelès-Bagnères"},
    {"city": "Argelès-Gazost"},
    {"city": "Aries-Espénan"},
    {"city": "Arné"},
    {"city": "Arras-en-Lavedan"},
    {"city": "Arreau"},
    {"city": "Arrens-Marsous"},
    {"city": "Arrodets-ez-Angles"},
    {"city": "Arrodets"},
    {"city": "Artagnan"},
    {"city": "Artalens-Souin"},
    {"city": "Artiguemy"},
    {"city": "Artigues"},
    {"city": "Aspin-Aure"},
    {"city": "Aspin-en-Lavedan"},
    {"city": "Asque"},
    {"city": "Asté"},
    {"city": "Astugue"},
    {"city": "Aubarède"},
    {"city": "Aucun"},
    {"city": "Aulon"},
    {"city": "Aureilhan"},
    {"city": "Aurensan"},
    {"city": "Auriébat"},
    {"city": "Avajan"},
    {"city": "Aventignan"},
    {"city": "Averan"},
    {"city": "Aveux"},
    {"city": "Avezac-Prat-Lahitte"},
    {"city": "Ayros-Arbouix"},
    {"city": "Ayzac-Ost"},
    {"city": "Azereix"},
    {"city": "Azet"},
    {"city": "Bagnères-de-Bigorre"},
    {"city": "Banios"},
    {"city": "Barbachen"},
    {"city": "Barbazan-Debat"},
    {"city": "Barbazan-Dessus"},
    {"city": "Bareilles"},
    {"city": "Barlest"},
    {"city": "Barrancoueu"},
    {"city": "Barry"},
    {"city": "Barthe"},
    {"city": "La Barthe-de-Neste"},
    {"city": "Bartrès"},
    {"city": "Batsère"},
    {"city": "Bazet"},
    {"city": "Bazillac"},
    {"city": "Bazordan"},
    {"city": "Bazus-Aure"},
    {"city": "Bazus-Neste"},
    {"city": "Beaucens"},
    {"city": "Beaudéan"},
    {"city": "Bégole"},
    {"city": "Bénac"},
    {"city": "Benqué-Molère"},
    {"city": "Berbérust-Lias"},
    {"city": "Bernac-Debat"},
    {"city": "Bernac-Dessus"},
    {"city": "Bernadets-Debat"},
    {"city": "Bernadets-Dessus"},
    {"city": "Bertren"},
    {"city": "Betbèze"},
    {"city": "Betpouey"},
    {"city": "Betpouy"},
    {"city": "Bettes"},
    {"city": "Beyrède-Jumet-Camous"},
    {"city": "Bize"},
    {"city": "Bizous"},
    {"city": "Bonnefont"},
    {"city": "Bonnemazon"},
    {"city": "Bonrepos"},
    {"city": "Boô-Silhen"},
    {"city": "Bordères-Louron"},
    {"city": "Bordères-sur-l'Échez"},
    {"city": "Bordes"},
    {"city": "Bouilh-Devant"},
    {"city": "Bouilh-Péreuilh"},
    {"city": "Boulin"},
    {"city": "Bourg-de-Bigorre"},
    {"city": "Bourisp"},
    {"city": "Bourréac"},
    {"city": "Bours"},
    {"city": "Bramevaque"},
    {"city": "Bugard"},
    {"city": "Bulan"},
    {"city": "Bun"},
    {"city": "Burg"},
    {"city": "Buzon"},
    {"city": "Cabanac"},
    {"city": "Cadéac"},
    {"city": "Cadeilhan-Trachère"},
    {"city": "Caharet"},
    {"city": "Caixon"},
    {"city": "Calavanté"},
    {"city": "Camalès"},
    {"city": "Campan"},
    {"city": "Camparan"},
    {"city": "Campistrous"},
    {"city": "Campuzan"},
    {"city": "Capvern"},
    {"city": "Castelbajac"},
    {"city": "Castelnau-Magnoac"},
    {"city": "Castelnau-Rivière-Basse"},
    {"city": "Castelvieilh"},
    {"city": "Castéra-Lanusse"},
    {"city": "Castéra-Lou"},
    {"city": "Casterets"},
    {"city": "Castillon"},
    {"city": "Caubous"},
    {"city": "Caussade-Rivière"},
    {"city": "Cauterets"},
    {"city": "Cazarilh"},
    {"city": "Cazaux-Debat"},
    {"city": "Cazaux-Fréchet-Anéran-Camors"},
    {"city": "Chelle-Debat"},
    {"city": "Chelle-Spou"},
    {"city": "Cheust"},
    {"city": "Chèze"},
    {"city": "Chis"},
    {"city": "Cieutat"},
    {"city": "Cizos"},
    {"city": "Clarac"},
    {"city": "Clarens"},
    {"city": "Collongues"},
    {"city": "Coussan"},
    {"city": "Créchets"},
    {"city": "Devèze"},
    {"city": "Dours"},
    {"city": "Ens"},
    {"city": "Esbareich"},
    {"city": "Escala"},
    {"city": "Escaunets"},
    {"city": "Escondeaux"},
    {"city": "Esconnets"},
    {"city": "Escots"},
    {"city": "Escoubès-Pouts"},
    {"city": "Esparros"},
    {"city": "Espèche"},
    {"city": "Espieilh"},
    {"city": "Esquièze-Sère"},
    {"city": "Estaing"},
    {"city": "Estampures"},
    {"city": "Estarvielle"},
    {"city": "Estensan"},
    {"city": "Esterre"},
    {"city": "Estirac"},
    {"city": "Ferrère"},
    {"city": "Ferrières"},
    {"city": "Fontrailles"},
    {"city": "Fréchède"},
    {"city": "Fréchendets"},
    {"city": "Fréchet-Aure"},
    {"city": "Fréchou-Fréchet"},
    {"city": "Gaillagos"},
    {"city": "Galan"},
    {"city": "Galez"},
    {"city": "Gardères"},
    {"city": "Gaudent"},
    {"city": "Gaussan"},
    {"city": "Gayan"},
    {"city": "Gazave"},
    {"city": "Gazost"},
    {"city": "Gavarnie-Gèdre"},
    {"city": "Gembrie"},
    {"city": "Générest"},
    {"city": "Génos"},
    {"city": "Gensac"},
    {"city": "Ger"},
    {"city": "Gerde"},
    {"city": "Germ"},
    {"city": "Germs-sur-l'Oussouet"},
    {"city": "Geu"},
    {"city": "Gez"},
    {"city": "Gez-ez-Angles"},
    {"city": "Gonez"},
    {"city": "Gouaux"},
    {"city": "Goudon"},
    {"city": "Gourgue"},
    {"city": "Grailhen"},
    {"city": "Grézian"},
    {"city": "Grust"},
    {"city": "Guchan"},
    {"city": "Guchen"},
    {"city": "Guizerix"},
    {"city": "Hachan"},
    {"city": "Hagedet"},
    {"city": "Hauban"},
    {"city": "Hautaget"},
    {"city": "Hèches"},
    {"city": "Hères"},
    {"city": "Hibarette"},
    {"city": "Hiis"},
    {"city": "Hitte"},
    {"city": "Horgues"},
    {"city": "Houeydets"},
    {"city": "Hourc"},
    {"city": "Ibos"},
    {"city": "Ilhet"},
    {"city": "Ilheu"},
    {"city": "Izaourt"},
    {"city": "Izaux"},
    {"city": "Jacque"},
    {"city": "Jarret"},
    {"city": "Jézeau"},
    {"city": "Juillan"},
    {"city": "Julos"},
    {"city": "Juncalas"},
    {"city": "Labassère"},
    {"city": "Labastide"},
    {"city": "Labatut-Rivière"},
    {"city": "Laborde"},
    {"city": "Lacassagne"},
    {"city": "Lafitole"},
    {"city": "Lagarde"},
    {"city": "Lagrange"},
    {"city": "Arrayou-Lahitte"},
    {"city": "Lahitte-Toupière"},
    {"city": "Lalanne"},
    {"city": "Lalanne-Trie"},
    {"city": "Laloubère"},
    {"city": "Lamarque-Pontacq"},
    {"city": "Lamarque-Rustaing"},
    {"city": "Laméac"},
    {"city": "Lançon"},
    {"city": "Lanespède"},
    {"city": "Lanne"},
    {"city": "Lannemezan"},
    {"city": "Lansac"},
    {"city": "Lapeyre"},
    {"city": "Laran"},
    {"city": "Larreule"},
    {"city": "Larroque"},
    {"city": "Lascazères"},
    {"city": "Laslades"},
    {"city": "Lassales"},
    {"city": "Lau-Balagnas"},
    {"city": "Layrisse"},
    {"city": "Lescurry"},
    {"city": "Lespouey"},
    {"city": "Lézignan"},
    {"city": "Lhez"},
    {"city": "Liac"},
    {"city": "Libaros"},
    {"city": "Lies"},
    {"city": "Lizos"},
    {"city": "Lombrès"},
    {"city": "Lomné"},
    {"city": "Lortet"},
    {"city": "Loubajac"},
    {"city": "Loucrup"},
    {"city": "Loudenvielle"},
    {"city": "Loudervielle"},
    {"city": "Louey"},
    {"city": "Louit"},
    {"city": "Lourdes"},
    {"city": "Loures-Barousse"},
    {"city": "Lubret-Saint-Luc"},
    {"city": "Luby-Betmont"},
    {"city": "Luc"},
    {"city": "Lugagnan"},
    {"city": "Luquet"},
    {"city": "Lustar"},
    {"city": "Lutilhous"},
    {"city": "Luz-Saint-Sauveur"},
    {"city": "Madiran"},
    {"city": "Mansan"},
    {"city": "Marquerie"},
    {"city": "Marsac"},
    {"city": "Marsas"},
    {"city": "Marseillan"},
    {"city": "Mascaras"},
    {"city": "Maubourguet"},
    {"city": "Mauléon-Barousse"},
    {"city": "Mauvezin"},
    {"city": "Mazères-de-Neste"},
    {"city": "Mazerolles"},
    {"city": "Mazouau"},
    {"city": "Mérilheu"},
    {"city": "Mingot"},
    {"city": "Momères"},
    {"city": "Monfaucon"},
    {"city": "Monléon-Magnoac"},
    {"city": "Monlong"},
    {"city": "Mont"},
    {"city": "Montastruc"},
    {"city": "Montégut"},
    {"city": "Montgaillard"},
    {"city": "Montignac"},
    {"city": "Montoussé"},
    {"city": "Montsérié"},
    {"city": "Moulédous"},
    {"city": "Moumoulous"},
    {"city": "Mun"},
    {"city": "Nestier"},
    {"city": "Neuilh"},
    {"city": "Nistos"},
    {"city": "Nouilhan"},
    {"city": "Odos"},
    {"city": "Oléac-Debat"},
    {"city": "Oléac-Dessus"},
    {"city": "Omex"},
    {"city": "Ordizan"},
    {"city": "Organ"},
    {"city": "Orieux"},
    {"city": "Orignac"},
    {"city": "Orincles"},
    {"city": "Orleix"},
    {"city": "Oroix"},
    {"city": "Osmets"},
    {"city": "Ossen"},
    {"city": "Ossun"},
    {"city": "Ossun-ez-Angles"},
    {"city": "Oueilloux"},
    {"city": "Ourde"},
    {"city": "Ourdis-Cotdoussan"},
    {"city": "Ourdon"},
    {"city": "Oursbelille"},
    {"city": "Ousté"},
    {"city": "Ouzous"},
    {"city": "Ozon"},
    {"city": "Pailhac"},
    {"city": "Paréac"},
    {"city": "Péré"},
    {"city": "Peyraube"},
    {"city": "Peyret-Saint-André"},
    {"city": "Peyriguère"},
    {"city": "Peyrouse"},
    {"city": "Peyrun"},
    {"city": "Pierrefitte-Nestalas"},
    {"city": "Pinas"},
    {"city": "Pintac"},
    {"city": "Poueyferré"},
    {"city": "Poumarous"},
    {"city": "Pouy"},
    {"city": "Pouyastruc"},
    {"city": "Pouzac"},
    {"city": "Préchac"},
    {"city": "Pujo"},
    {"city": "Puntous"},
    {"city": "Puydarrieux"},
    {"city": "Rabastens-de-Bigorre"},
    {"city": "Recurt"},
    {"city": "Réjaumont"},
    {"city": "Ricaud"},
    {"city": "Ris"},
    {"city": "Sabalos"},
    {"city": "Sabarros"},
    {"city": "Sacoué"},
    {"city": "Sadournin"},
    {"city": "Sailhan"},
    {"city": "Saint-Arroman"},
    {"city": "Saint-Créac"},
    {"city": "Saint-Lanne"},
    {"city": "Saint-Lary-Soulan"},
    {"city": "Saint-Laurent-de-Neste"},
    {"city": "Saint-Lézer"},
    {"city": "Sainte-Marie"},
    {"city": "Saint-Martin"},
    {"city": "Saint-Pastous"},
    {"city": "Saint-Paul"},
    {"city": "Saint-Pé-de-Bigorre"},
    {"city": "Saint-Savin"},
    {"city": "Saint-Sever-de-Rustan"},
    {"city": "Saléchan"},
    {"city": "Saligos"},
    {"city": "Salles"},
    {"city": "Salles-Adour"},
    {"city": "Samuran"},
    {"city": "Sanous"},
    {"city": "Sariac-Magnoac"},
    {"city": "Sarlabous"},
    {"city": "Sarniguet"},
    {"city": "Sarp"},
    {"city": "Sarrancolin"},
    {"city": "Sarriac-Bigorre"},
    {"city": "Sarrouilles"},
    {"city": "Sassis"},
    {"city": "Sauveterre"},
    {"city": "Sazos"},
    {"city": "Ségalas"},
    {"city": "Ségus"},
    {"city": "Seich"},
    {"city": "Séméac"},
    {"city": "Sénac"},
    {"city": "Sentous"},
    {"city": "Sère-en-Lavedan"},
    {"city": "Sère-Lanso"},
    {"city": "Séron"},
    {"city": "Sère-Rustaing"},
    {"city": "Sers"},
    {"city": "Siarrouy"},
    {"city": "Sinzos"},
    {"city": "Siradan"},
    {"city": "Sireix"},
    {"city": "Sombrun"},
    {"city": "Soréac"},
    {"city": "Sost"},
    {"city": "Soublecause"},
    {"city": "Soues"},
    {"city": "Soulom"},
    {"city": "Souyeaux"},
    {"city": "Tajan"},
    {"city": "Talazac"},
    {"city": "Tarasteix"},
    {"city": "Tarbes"},
    {"city": "Thèbe"},
    {"city": "Thermes-Magnoac"},
    {"city": "Thuy"},
    {"city": "Tibiran-Jaunac"},
    {"city": "Tilhouse"},
    {"city": "Tostat"},
    {"city": "Tournay"},
    {"city": "Tournous-Darré"},
    {"city": "Tournous-Devant"},
    {"city": "Tramezaïgues"},
    {"city": "Trébons"},
    {"city": "Trie-sur-Baïse"},
    {"city": "Troubat"},
    {"city": "Trouley-Labarthe"},
    {"city": "Tuzaguet"},
    {"city": "Uglas"},
    {"city": "Ugnouas"},
    {"city": "Uz"},
    {"city": "Uzer"},
    {"city": "Vic-en-Bigorre"},
    {"city": "Vidou"},
    {"city": "Vidouze"},
    {"city": "Viella"},
    {"city": "Vielle-Adour"},
    {"city": "Vielle-Aure"},
    {"city": "Vielle-Louron"},
    {"city": "Vier-Bordes"},
    {"city": "Vieuzos"},
    {"city": "Viey"},
    {"city": "Viger"},
    {"city": "Vignec"},
    {"city": "Villefranque"},
    {"city": "Villelongue"},
    {"city": "Villembits"},
    {"city": "Villemur"},
    {"city": "Villenave-près-Béarn"},
    {"city": "Villenave-près-Marsac"},
    {"city": "Viscos"},
    {"city": "Visker"},
    {"city": "Barèges"},
    {"city": "Cantaous"},
    {"city": "L'Albère"},
    {"city": "Alénya"},
    {"city": "Amélie-les-Bains-Palalda"},
    {"city": "Les Angles"},
    {"city": "Angoustrine-Villeneuve-des-Escaldes"},
    {"city": "Ansignan"},
    {"city": "Arboussols"},
    {"city": "Argelès-sur-Mer"},
    {"city": "Arles-sur-Tech"},
    {"city": "Ayguatébia-Talau"},
    {"city": "Bages"},
    {"city": "Baho"},
    {"city": "Baillestavy"},
    {"city": "Baixas"},
    {"city": "Banyuls-dels-Aspres"},
    {"city": "Banyuls-sur-Mer"},
    {"city": "Le Barcarès"},
    {"city": "La Bastide"},
    {"city": "Bélesta"},
    {"city": "Bolquère"},
    {"city": "Bompas"},
    {"city": "Boule-d'Amont"},
    {"city": "Bouleternère"},
    {"city": "Le Boulou"},
    {"city": "Bourg-Madame"},
    {"city": "Brouilla"},
    {"city": "La Cabanasse"},
    {"city": "Cabestany"},
    {"city": "Caixas"},
    {"city": "Calce"},
    {"city": "Calmeilles"},
    {"city": "Camélas"},
    {"city": "Campôme"},
    {"city": "Campoussy"},
    {"city": "Canaveilles"},
    {"city": "Canet-en-Roussillon"},
    {"city": "Canohès"},
    {"city": "Caramany"},
    {"city": "Casefabre"},
    {"city": "Cases-de-Pène"},
    {"city": "Cassagnes"},
    {"city": "Casteil"},
    {"city": "Castelnou"},
    {"city": "Catllar"},
    {"city": "Caudiès-de-Fenouillèdes"},
    {"city": "Caudiès-de-Conflent"},
    {"city": "Cerbère"},
    {"city": "Céret"},
    {"city": "Claira"},
    {"city": "Clara-Villerach"},
    {"city": "Codalet"},
    {"city": "Collioure"},
    {"city": "Conat"},
    {"city": "Corbère"},
    {"city": "Corbère-les-Cabanes"},
    {"city": "Corneilla-de-Conflent"},
    {"city": "Corneilla-la-Rivière"},
    {"city": "Corneilla-del-Vercol"},
    {"city": "Corsavy"},
    {"city": "Coustouges"},
    {"city": "Dorres"},
    {"city": "Les Cluses"},
    {"city": "Égat"},
    {"city": "Elne"},
    {"city": "Enveitg"},
    {"city": "Err"},
    {"city": "Escaro"},
    {"city": "Espira-de-l'Agly"},
    {"city": "Espira-de-Conflent"},
    {"city": "Estagel"},
    {"city": "Estavar"},
    {"city": "Estoher"},
    {"city": "Eus"},
    {"city": "Eyne"},
    {"city": "Felluns"},
    {"city": "Fenouillet"},
    {"city": "Fillols"},
    {"city": "Finestret"},
    {"city": "Fontpédrouse"},
    {"city": "Fontrabiouse"},
    {"city": "Formiguères"},
    {"city": "Fosse"},
    {"city": "Fourques"},
    {"city": "Fuilla"},
    {"city": "Glorianes"},
    {"city": "Ille-sur-Têt"},
    {"city": "Joch"},
    {"city": "Jujols"},
    {"city": "Lamanère"},
    {"city": "Lansac"},
    {"city": "Laroque-des-Albères"},
    {"city": "Latour-Bas-Elne"},
    {"city": "Latour-de-Carol"},
    {"city": "Latour-de-France"},
    {"city": "Lesquerde"},
    {"city": "La Llagonne"},
    {"city": "Llauro"},
    {"city": "Llo"},
    {"city": "Llupia"},
    {"city": "Mantet"},
    {"city": "Marquixanes"},
    {"city": "Los Masos"},
    {"city": "Matemale"},
    {"city": "Maureillas-las-Illas"},
    {"city": "Maury"},
    {"city": "Millas"},
    {"city": "Molitg-les-Bains"},
    {"city": "Montalba-le-Château"},
    {"city": "Montauriol"},
    {"city": "Montbolo"},
    {"city": "Montescot"},
    {"city": "Montesquieu-des-Albères"},
    {"city": "Montferrer"},
    {"city": "Mont-Louis"},
    {"city": "Montner"},
    {"city": "Mosset"},
    {"city": "Nahuja"},
    {"city": "Néfiach"},
    {"city": "Nohèdes"},
    {"city": "Nyer"},
    {"city": "Font-Romeu-Odeillo-Via"},
    {"city": "Olette"},
    {"city": "Oms"},
    {"city": "Opoul-Périllos"},
    {"city": "Oreilla"},
    {"city": "Ortaffa"},
    {"city": "Osséja"},
    {"city": "Palau-de-Cerdagne"},
    {"city": "Palau-del-Vidre"},
    {"city": "Passa"},
    {"city": "Perpignan"},
    {"city": "Le Perthus"},
    {"city": "Peyrestortes"},
    {"city": "Pézilla-de-Conflent"},
    {"city": "Pézilla-la-Rivière"},
    {"city": "Pia"},
    {"city": "Planès"},
    {"city": "Planèzes"},
    {"city": "Pollestres"},
    {"city": "Ponteilla"},
    {"city": "Porta"},
    {"city": "Porté-Puymorens"},
    {"city": "Port-Vendres"},
    {"city": "Prades"},
    {"city": "Prats-de-Mollo-la-Preste"},
    {"city": "Prats-de-Sournia"},
    {"city": "Prugnanes"},
    {"city": "Prunet-et-Belpuig"},
    {"city": "Puyvalador"},
    {"city": "Py"},
    {"city": "Rabouillet"},
    {"city": "Railleu"},
    {"city": "Rasiguères"},
    {"city": "Réal"},
    {"city": "Reynès"},
    {"city": "Ria-Sirach"},
    {"city": "Rigarda"},
    {"city": "Rivesaltes"},
    {"city": "Rodès"},
    {"city": "Sahorre"},
    {"city": "Saillagouse"},
    {"city": "Saint-André"},
    {"city": "Saint-Arnac"},
    {"city": "Sainte-Colombe-de-la-Commanderie"},
    {"city": "Saint-Cyprien"},
    {"city": "Saint-Estève"},
    {"city": "Saint-Féliu-d'Amont"},
    {"city": "Saint-Féliu-d'Avall"},
    {"city": "Saint-Génis-des-Fontaines"},
    {"city": "Saint-Hippolyte"},
    {"city": "Saint-Jean-Lasseille"},
    {"city": "Saint-Jean-Pla-de-Corts"},
    {"city": "Saint-Laurent-de-Cerdans"},
    {"city": "Saint-Laurent-de-la-Salanque"},
    {"city": "Sainte-Léocadie"},
    {"city": "Sainte-Marie-la-Mer"},
    {"city": "Saint-Marsal"},
    {"city": "Saint-Martin-de-Fenouillet"},
    {"city": "Saint-Michel-de-Llotes"},
    {"city": "Saint-Nazaire"},
    {"city": "Saint-Paul-de-Fenouillet"},
    {"city": "Saint-Pierre-dels-Forcats"},
    {"city": "Saleilles"},
    {"city": "Salses-le-Château"},
    {"city": "Sansa"},
    {"city": "Sauto"},
    {"city": "Serdinya"},
    {"city": "Serralongue"},
    {"city": "Le Soler"},
    {"city": "Sorède"},
    {"city": "Souanyas"},
    {"city": "Sournia"},
    {"city": "Taillet"},
    {"city": "Tarerach"},
    {"city": "Targassonne"},
    {"city": "Taulis"},
    {"city": "Taurinya"},
    {"city": "Tautavel"},
    {"city": "Le Tech"},
    {"city": "Terrats"},
    {"city": "Théza"},
    {"city": "Thuès-Entre-Valls"},
    {"city": "Thuir"},
    {"city": "Tordères"},
    {"city": "Torreilles"},
    {"city": "Toulouges"},
    {"city": "Tresserre"},
    {"city": "Trévillach"},
    {"city": "Trilla"},
    {"city": "Trouillas"},
    {"city": "Ur"},
    {"city": "Urbanya"},
    {"city": "Valcebollère"},
    {"city": "Valmanya"},
    {"city": "Vernet-les-Bains"},
    {"city": "Villefranche-de-Conflent"},
    {"city": "Villelongue-de-la-Salanque"},
    {"city": "Villelongue-dels-Monts"},
    {"city": "Villemolaque"},
    {"city": "Villeneuve-de-la-Raho"},
    {"city": "Villeneuve-la-Rivière"},
    {"city": "Vinça"},
    {"city": "Vingrau"},
    {"city": "Vira"},
    {"city": "Vivès"},
    {"city": "Le Vivier"},
    {"city": "Achenheim"},
    {"city": "Adamswiller"},
    {"city": "Albé"},
    {"city": "Sommerau"},
    {"city": "Alteckendorf"},
    {"city": "Altenheim"},
    {"city": "Altorf"},
    {"city": "Altwiller"},
    {"city": "Andlau"},
    {"city": "Artolsheim"},
    {"city": "Aschbach"},
    {"city": "Asswiller"},
    {"city": "Avolsheim"},
    {"city": "Baerendorf"},
    {"city": "Balbronn"},
    {"city": "Baldenheim"},
    {"city": "Barembach"},
    {"city": "Barr"},
    {"city": "Bassemberg"},
    {"city": "Batzendorf"},
    {"city": "Beinheim"},
    {"city": "Bellefosse"},
    {"city": "Belmont"},
    {"city": "Benfeld"},
    {"city": "Berg"},
    {"city": "Bergbieten"},
    {"city": "Bernardswiller"},
    {"city": "Bernardvillé"},
    {"city": "Bernolsheim"},
    {"city": "Berstett"},
    {"city": "Berstheim"},
    {"city": "Bettwiller"},
    {"city": "Biblisheim"},
    {"city": "Bietlenheim"},
    {"city": "Bilwisheim"},
    {"city": "Bindernheim"},
    {"city": "Bischheim"},
    {"city": "Bischholtz"},
    {"city": "Bischoffsheim"},
    {"city": "Bischwiller"},
    {"city": "Bissert"},
    {"city": "Bitschhoffen"},
    {"city": "Blaesheim"},
    {"city": "Blancherupt"},
    {"city": "Blienschwiller"},
    {"city": "Bœrsch"},
    {"city": "Bœsenbiesen"},
    {"city": "Bolsenheim"},
    {"city": "Boofzheim"},
    {"city": "Bootzheim"},
    {"city": "Bosselshausen"},
    {"city": "Bossendorf"},
    {"city": "Bourg-Bruche"},
    {"city": "Bourgheim"},
    {"city": "Bouxwiller"},
    {"city": "Breitenau"},
    {"city": "Breitenbach"},
    {"city": "Breuschwickersheim"},
    {"city": "La Broque"},
    {"city": "Brumath"},
    {"city": "Buswiller"},
    {"city": "Buhl"},
    {"city": "Burbach"},
    {"city": "Bust"},
    {"city": "Butten"},
    {"city": "Châtenois"},
    {"city": "Cleebourg"},
    {"city": "Climbach"},
    {"city": "Colroy-la-Roche"},
    {"city": "Cosswiller"},
    {"city": "Crastatt"},
    {"city": "Crœttwiller"},
    {"city": "Dachstein"},
    {"city": "Dahlenheim"},
    {"city": "Dalhunden"},
    {"city": "Dambach"},
    {"city": "Dambach-la-Ville"},
    {"city": "Dangolsheim"},
    {"city": "Daubensand"},
    {"city": "Dauendorf"},
    {"city": "Dehlingen"},
    {"city": "Dettwiller"},
    {"city": "Diebolsheim"},
    {"city": "Diedendorf"},
    {"city": "Dieffenbach-au-Val"},
    {"city": "Dieffenbach-lès-Wœrth"},
    {"city": "Dieffenthal"},
    {"city": "Diemeringen"},
    {"city": "Dimbsthal"},
    {"city": "Dingsheim"},
    {"city": "Dinsheim-sur-Bruche"},
    {"city": "Domfessel"},
    {"city": "Donnenheim"},
    {"city": "Dorlisheim"},
    {"city": "Dossenheim-Kochersberg"},
    {"city": "Dossenheim-sur-Zinsel"},
    {"city": "Drachenbronn-Birlenbach"},
    {"city": "Drulingen"},
    {"city": "Drusenheim"},
    {"city": "Duntzenheim"},
    {"city": "Duppigheim"},
    {"city": "Durningen"},
    {"city": "Durrenbach"},
    {"city": "Durstel"},
    {"city": "Duttlenheim"},
    {"city": "Eberbach-Seltz"},
    {"city": "Ebersheim"},
    {"city": "Ebersmunster"},
    {"city": "Eckartswiller"},
    {"city": "Eckbolsheim"},
    {"city": "Eckwersheim"},
    {"city": "Eichhoffen"},
    {"city": "Elsenheim"},
    {"city": "Wangenbourg-Engenthal"},
    {"city": "Engwiller"},
    {"city": "Entzheim"},
    {"city": "Epfig"},
    {"city": "Erckartswiller"},
    {"city": "Ergersheim"},
    {"city": "Ernolsheim-Bruche"},
    {"city": "Ernolsheim-lès-Saverne"},
    {"city": "Erstein"},
    {"city": "Eschau"},
    {"city": "Eschbach"},
    {"city": "Eschbourg"},
    {"city": "Eschwiller"},
    {"city": "Ettendorf"},
    {"city": "Eywiller"},
    {"city": "Fegersheim"},
    {"city": "Fessenheim-le-Bas"},
    {"city": "Flexbourg"},
    {"city": "Forstfeld"},
    {"city": "Forstheim"},
    {"city": "Fort-Louis"},
    {"city": "Fouchy"},
    {"city": "Fouday"},
    {"city": "Friedolsheim"},
    {"city": "Friesenheim"},
    {"city": "Frœschwiller"},
    {"city": "Frohmuhl"},
    {"city": "Furchhausen"},
    {"city": "Furdenheim"},
    {"city": "Gambsheim"},
    {"city": "Geispolsheim"},
    {"city": "Geiswiller-Zœbersdorf"},
    {"city": "Gerstheim"},
    {"city": "Gertwiller"},
    {"city": "Geudertheim"},
    {"city": "Gœrlingen"},
    {"city": "Gœrsdorf"},
    {"city": "Gottenhouse"},
    {"city": "Gottesheim"},
    {"city": "Gougenheim"},
    {"city": "Goxwiller"},
    {"city": "Grandfontaine"},
    {"city": "Grassendorf"},
    {"city": "Grendelbruch"},
    {"city": "Gresswiller"},
    {"city": "Gries"},
    {"city": "Griesheim-près-Molsheim"},
    {"city": "Griesheim-sur-Souffel"},
    {"city": "Gumbrechtshoffen"},
    {"city": "Gundershoffen"},
    {"city": "Gunstett"},
    {"city": "Gungwiller"},
    {"city": "Haegen"},
    {"city": "Haguenau"},
    {"city": "Handschuheim"},
    {"city": "Hangenbieten"},
    {"city": "Harskirchen"},
    {"city": "Hatten"},
    {"city": "Hattmatt"},
    {"city": "Hegeney"},
    {"city": "Heidolsheim"},
    {"city": "Heiligenberg"},
    {"city": "Heiligenstein"},
    {"city": "Hengwiller"},
    {"city": "Herbitzheim"},
    {"city": "Herbsheim"},
    {"city": "Herrlisheim"},
    {"city": "Hessenheim"},
    {"city": "Hilsenheim"},
    {"city": "Hindisheim"},
    {"city": "Hinsbourg"},
    {"city": "Hinsingen"},
    {"city": "Hipsheim"},
    {"city": "Hirschland"},
    {"city": "Hochfelden"},
    {"city": "Hochstett"},
    {"city": "Hœnheim"},
    {"city": "Hœrdt"},
    {"city": "Hoffen"},
    {"city": "Hohengœft"},
    {"city": "Hohfrankenheim"},
    {"city": "Le Hohwald"},
    {"city": "Holtzheim"},
    {"city": "Hunspach"},
    {"city": "Hurtigheim"},
    {"city": "Huttendorf"},
    {"city": "Huttenheim"},
    {"city": "Ichtratzheim"},
    {"city": "Illkirch-Graffenstaden"},
    {"city": "Ingenheim"},
    {"city": "Ingolsheim"},
    {"city": "Ingwiller"},
    {"city": "Innenheim"},
    {"city": "Issenhausen"},
    {"city": "Ittenheim"},
    {"city": "Itterswiller"},
    {"city": "Neugartheim-Ittlenheim"},
    {"city": "Jetterswiller"},
    {"city": "Kaltenhouse"},
    {"city": "Kauffenheim"},
    {"city": "Keffenach"},
    {"city": "Kertzfeld"},
    {"city": "Keskastel"},
    {"city": "Kesseldorf"},
    {"city": "Kienheim"},
    {"city": "Kilstett"},
    {"city": "Kindwiller"},
    {"city": "Kintzheim"},
    {"city": "Kirchheim"},
    {"city": "Kirrberg"},
    {"city": "Kirrwiller"},
    {"city": "Kleingœft"},
    {"city": "Knœrsheim"},
    {"city": "Kogenheim"},
    {"city": "Kolbsheim"},
    {"city": "Krautergersheim"},
    {"city": "Krautwiller"},
    {"city": "Kriegsheim"},
    {"city": "Kurtzenhouse"},
    {"city": "Kuttolsheim"},
    {"city": "Kutzenhausen"},
    {"city": "Lalaye"},
    {"city": "Lampertheim"},
    {"city": "Lampertsloch"},
    {"city": "Landersheim"},
    {"city": "Langensoultzbach"},
    {"city": "Laubach"},
    {"city": "Lauterbourg"},
    {"city": "Lembach"},
    {"city": "Leutenheim"},
    {"city": "Lichtenberg"},
    {"city": "Limersheim"},
    {"city": "Lingolsheim"},
    {"city": "Lipsheim"},
    {"city": "Littenheim"},
    {"city": "Lixhausen"},
    {"city": "Lobsann"},
    {"city": "Lochwiller"},
    {"city": "Lohr"},
    {"city": "Lorentzen"},
    {"city": "Lupstein"},
    {"city": "Lutzelhouse"},
    {"city": "Mackenheim"},
    {"city": "Mackwiller"},
    {"city": "Maennolsheim"},
    {"city": "Maisonsgoutte"},
    {"city": "Marckolsheim"},
    {"city": "Marlenheim"},
    {"city": "Marmoutier"},
    {"city": "Matzenheim"},
    {"city": "Meistratzheim"},
    {"city": "Melsheim"},
    {"city": "Memmelshoffen"},
    {"city": "Menchhoffen"},
    {"city": "Merkwiller-Pechelbronn"},
    {"city": "Mertzwiller"},
    {"city": "Mietesheim"},
    {"city": "Minversheim"},
    {"city": "Mittelbergheim"},
    {"city": "Mittelhausbergen"},
    {"city": "Mittelschaeffolsheim"},
    {"city": "Mollkirch"},
    {"city": "Molsheim"},
    {"city": "Mommenheim"},
    {"city": "Monswiller"},
    {"city": "Morsbronn-les-Bains"},
    {"city": "Morschwiller"},
    {"city": "Mothern"},
    {"city": "Muhlbach-sur-Bruche"},
    {"city": "Mulhausen"},
    {"city": "Munchhausen"},
    {"city": "Mundolsheim"},
    {"city": "Mussig"},
    {"city": "Muttersholtz"},
    {"city": "Mutzenhouse"},
    {"city": "Mutzig"},
    {"city": "Natzwiller"},
    {"city": "Neewiller-près-Lauterbourg"},
    {"city": "Neubois"},
    {"city": "Neuhaeusel"},
    {"city": "Neuve-Église"},
    {"city": "Neuviller-la-Roche"},
    {"city": "Neuwiller-lès-Saverne"},
    {"city": "Niederbronn-les-Bains"},
    {"city": "Niederhaslach"},
    {"city": "Niederhausbergen"},
    {"city": "Niederlauterbach"},
    {"city": "Niedermodern"},
    {"city": "Niedernai"},
    {"city": "Niederrœdern"},
    {"city": "Niederschaeffolsheim"},
    {"city": "Niedersoultzbach"},
    {"city": "Niedersteinbach"},
    {"city": "Nordheim"},
    {"city": "Nordhouse"},
    {"city": "Nothalten"},
    {"city": "Obenheim"},
    {"city": "Betschdorf"},
    {"city": "Oberbronn"},
    {"city": "Oberdorf-Spachbach"},
    {"city": "Oberhaslach"},
    {"city": "Oberhausbergen"},
    {"city": "Oberhoffen-lès-Wissembourg"},
    {"city": "Oberhoffen-sur-Moder"},
    {"city": "Oberlauterbach"},
    {"city": "Obermodern-Zutzendorf"},
    {"city": "Obernai"},
    {"city": "Oberrœdern"},
    {"city": "Oberschaeffolsheim"},
    {"city": "Seebach"},
    {"city": "Obersoultzbach"},
    {"city": "Obersteinbach"},
    {"city": "Odratzheim"},
    {"city": "Oermingen"},
    {"city": "Offendorf"},
    {"city": "Offwiller"},
    {"city": "Ohlungen"},
    {"city": "Ohnenheim"},
    {"city": "Olwisheim"},
    {"city": "Orschwiller"},
    {"city": "Osthoffen"},
    {"city": "Osthouse"},
    {"city": "Ostwald"},
    {"city": "Ottersthal"},
    {"city": "Otterswiller"},
    {"city": "Ottrott"},
    {"city": "Ottwiller"},
    {"city": "Petersbach"},
    {"city": "La Petite-Pierre"},
    {"city": "Val-de-Moder"},
    {"city": "Pfalzweyer"},
    {"city": "Pfulgriesheim"},
    {"city": "Plaine"},
    {"city": "Plobsheim"},
    {"city": "Preuschdorf"},
    {"city": "Printzheim"},
    {"city": "Puberg"},
    {"city": "Quatzenheim"},
    {"city": "Rangen"},
    {"city": "Ranrupt"},
    {"city": "Ratzwiller"},
    {"city": "Rauwiller"},
    {"city": "Reichsfeld"},
    {"city": "Reichshoffen"},
    {"city": "Reichstett"},
    {"city": "Reinhardsmunster"},
    {"city": "Reipertswiller"},
    {"city": "Retschwiller"},
    {"city": "Reutenbourg"},
    {"city": "Rexingen"},
    {"city": "Rhinau"},
    {"city": "Richtolsheim"},
    {"city": "Riedseltz"},
    {"city": "Rimsdorf"},
    {"city": "Ringendorf"},
    {"city": "Rittershoffen"},
    {"city": "Rœschwoog"},
    {"city": "Rohr"},
    {"city": "Rohrwiller"},
    {"city": "Romanswiller"},
    {"city": "Roppenheim"},
    {"city": "Rosenwiller"},
    {"city": "Rosheim"},
    {"city": "Rossfeld"},
    {"city": "Rosteig"},
    {"city": "Rothau"},
    {"city": "Rothbach"},
    {"city": "Rott"},
    {"city": "Rottelsheim"},
    {"city": "Rountzenheim-Auenheim"},
    {"city": "Russ"},
    {"city": "Saales"},
    {"city": "Saasenheim"},
    {"city": "Saessolsheim"},
    {"city": "Saint-Blaise-la-Roche"},
    {"city": "Saint-Jean-Saverne"},
    {"city": "Saint-Martin"},
    {"city": "Saint-Maurice"},
    {"city": "Saint-Nabor"},
    {"city": "Saint-Pierre"},
    {"city": "Saint-Pierre-Bois"},
    {"city": "Salmbach"},
    {"city": "Sand"},
    {"city": "Sarre-Union"},
    {"city": "Sarrewerden"},
    {"city": "Saulxures"},
    {"city": "Saverne"},
    {"city": "Schaeffersheim"},
    {"city": "Schaffhouse-près-Seltz"},
    {"city": "Schalkendorf"},
    {"city": "Scharrachbergheim-Irmstett"},
    {"city": "Scheibenhard"},
    {"city": "Scherlenheim"},
    {"city": "Scherwiller"},
    {"city": "Schillersdorf"},
    {"city": "Schiltigheim"},
    {"city": "Schirmeck"},
    {"city": "Schirrhein"},
    {"city": "Schirrhoffen"},
    {"city": "Schleithal"},
    {"city": "Schnersheim"},
    {"city": "Schœnau"},
    {"city": "Schœnbourg"},
    {"city": "Schœnenbourg"},
    {"city": "Schopperten"},
    {"city": "Schweighouse-sur-Moder"},
    {"city": "Schwenheim"},
    {"city": "Schwindratzheim"},
    {"city": "Schwobsheim"},
    {"city": "Sélestat"},
    {"city": "Seltz"},
    {"city": "Sermersheim"},
    {"city": "Sessenheim"},
    {"city": "Siegen"},
    {"city": "Siewiller"},
    {"city": "Siltzheim"},
    {"city": "Solbach"},
    {"city": "Souffelweyersheim"},
    {"city": "Soufflenheim"},
    {"city": "Soultz-les-Bains"},
    {"city": "Soultz-sous-Forêts"},
    {"city": "Sparsbach"},
    {"city": "Stattmatten"},
    {"city": "Steige"},
    {"city": "Steinbourg"},
    {"city": "Steinseltz"},
    {"city": "Still"},
    {"city": "Stotzheim"},
    {"city": "Strasbourg"},
    {"city": "Struth"},
    {"city": "Stundwiller"},
    {"city": "Stutzheim-Offenheim"},
    {"city": "Sundhouse"},
    {"city": "Surbourg"},
    {"city": "Thal-Drulingen"},
    {"city": "Thal-Marmoutier"},
    {"city": "Thanvillé"},
    {"city": "Tieffenbach"},
    {"city": "Traenheim"},
    {"city": "Triembach-au-Val"},
    {"city": "Trimbach"},
    {"city": "Truchtersheim"},
    {"city": "Uhlwiller"},
    {"city": "Uhrwiller"},
    {"city": "Urbeis"},
    {"city": "Urmatt"},
    {"city": "Uttenheim"},
    {"city": "Uttenhoffen"},
    {"city": "Uttwiller"},
    {"city": "Valff"},
    {"city": "La Vancelle"},
    {"city": "Vendenheim"},
    {"city": "Villé"},
    {"city": "Vœllerdingen"},
    {"city": "Volksberg"},
    {"city": "Wahlenheim"},
    {"city": "Walbourg"},
    {"city": "Waldersbach"},
    {"city": "Waldhambach"},
    {"city": "Waldolwisheim"},
    {"city": "Waltenheim-sur-Zorn"},
    {"city": "Wangen"},
    {"city": "La Wantzenau"},
    {"city": "Wasselonne"},
    {"city": "Weinbourg"},
    {"city": "Weislingen"},
    {"city": "Weitbruch"},
    {"city": "Weiterswiller"},
    {"city": "Westhoffen"},
    {"city": "Westhouse"},
    {"city": "Westhouse-Marmoutier"},
    {"city": "Weyer"},
    {"city": "Weyersheim"},
    {"city": "Wickersheim-Wilshausen"},
    {"city": "Wildersbach"},
    {"city": "Willgottheim"},
    {"city": "Wilwisheim"},
    {"city": "Wimmenau"},
    {"city": "Windstein"},
    {"city": "Wingen"},
    {"city": "Wingen-sur-Moder"},
    {"city": "Wingersheim les Quatre Bans"},
    {"city": "Wintershouse"},
    {"city": "Wintzenbach"},
    {"city": "Wintzenheim-Kochersberg"},
    {"city": "Wisches"},
    {"city": "Wissembourg"},
    {"city": "Witternheim"},
    {"city": "Wittersheim"},
    {"city": "Wittisheim"},
    {"city": "Wiwersheim"},
    {"city": "Wœrth"},
    {"city": "Wolfisheim"},
    {"city": "Wolfskirchen"},
    {"city": "Wolschheim"},
    {"city": "Wolxheim"},
    {"city": "Zehnacker"},
    {"city": "Zeinheim"},
    {"city": "Zellwiller"},
    {"city": "Zinswiller"},
    {"city": "Zittersheim"},
    {"city": "Algolsheim"},
    {"city": "Altenach"},
    {"city": "Altkirch"},
    {"city": "Ammerschwihr"},
    {"city": "Bernwiller"},
    {"city": "Andolsheim"},
    {"city": "Appenwihr"},
    {"city": "Artzenheim"},
    {"city": "Aspach"},
    {"city": "Aspach-le-Bas"},
    {"city": "Aspach-Michelbach"},
    {"city": "Attenschwiller"},
    {"city": "Aubure"},
    {"city": "Baldersheim"},
    {"city": "Balgau"},
    {"city": "Ballersdorf"},
    {"city": "Balschwiller"},
    {"city": "Baltzenheim"},
    {"city": "Bantzenheim"},
    {"city": "Bartenheim"},
    {"city": "Battenheim"},
    {"city": "Beblenheim"},
    {"city": "Bellemagny"},
    {"city": "Bendorf"},
    {"city": "Bennwihr"},
    {"city": "Berentzwiller"},
    {"city": "Bergheim"},
    {"city": "Bergholtz"},
    {"city": "Bergholtzzell"},
    {"city": "Berrwiller"},
    {"city": "Bettendorf"},
    {"city": "Bettlach"},
    {"city": "Biederthal"},
    {"city": "Biesheim"},
    {"city": "Biltzheim"},
    {"city": "Bischwihr"},
    {"city": "Bisel"},
    {"city": "Bitschwiller-lès-Thann"},
    {"city": "Blodelsheim"},
    {"city": "Blotzheim"},
    {"city": "Bollwiller"},
    {"city": "Le Bonhomme"},
    {"city": "Bourbach-le-Bas"},
    {"city": "Bourbach-le-Haut"},
    {"city": "Bouxwiller"},
    {"city": "Bréchaumont"},
    {"city": "Breitenbach-Haut-Rhin"},
    {"city": "Bretten"},
    {"city": "Brinckheim"},
    {"city": "Bruebach"},
    {"city": "Brunstatt-Didenheim"},
    {"city": "Buethwiller"},
    {"city": "Buhl"},
    {"city": "Burnhaupt-le-Bas"},
    {"city": "Burnhaupt-le-Haut"},
    {"city": "Buschwiller"},
    {"city": "Carspach"},
    {"city": "Cernay"},
    {"city": "Chalampé"},
    {"city": "Chavannes-sur-l'Étang"},
    {"city": "Colmar"},
    {"city": "Courtavon"},
    {"city": "Dannemarie"},
    {"city": "Dessenheim"},
    {"city": "Diefmatten"},
    {"city": "Dietwiller"},
    {"city": "Dolleren"},
    {"city": "Durlinsdorf"},
    {"city": "Durmenach"},
    {"city": "Durrenentzen"},
    {"city": "Eglingen"},
    {"city": "Eguisheim"},
    {"city": "Elbach"},
    {"city": "Emlingen"},
    {"city": "Saint-Bernard"},
    {"city": "Ensisheim"},
    {"city": "Eschbach-au-Val"},
    {"city": "Eschentzwiller"},
    {"city": "Eteimbes"},
    {"city": "Falkwiller"},
    {"city": "Feldbach"},
    {"city": "Feldkirch"},
    {"city": "Fellering"},
    {"city": "Ferrette"},
    {"city": "Fessenheim"},
    {"city": "Fislis"},
    {"city": "Flaxlanden"},
    {"city": "Folgensbourg"},
    {"city": "Fortschwihr"},
    {"city": "Franken"},
    {"city": "Fréland"},
    {"city": "Friesen"},
    {"city": "Frœningen"},
    {"city": "Fulleren"},
    {"city": "Galfingue"},
    {"city": "Geishouse"},
    {"city": "Geispitzen"},
    {"city": "Geiswasser"},
    {"city": "Gildwiller"},
    {"city": "Goldbach-Altenbach"},
    {"city": "Gommersdorf"},
    {"city": "Griesbach-au-Val"},
    {"city": "Grussenheim"},
    {"city": "Gueberschwihr"},
    {"city": "Guebwiller"},
    {"city": "Guémar"},
    {"city": "Guevenatten"},
    {"city": "Guewenheim"},
    {"city": "Gundolsheim"},
    {"city": "Gunsbach"},
    {"city": "Habsheim"},
    {"city": "Hagenbach"},
    {"city": "Hagenthal-le-Bas"},
    {"city": "Hagenthal-le-Haut"},
    {"city": "Hartmannswiller"},
    {"city": "Hattstatt"},
    {"city": "Hausgauen"},
    {"city": "Hecken"},
    {"city": "Hégenheim"},
    {"city": "Heidwiller"},
    {"city": "Heimersdorf"},
    {"city": "Heimsbrunn"},
    {"city": "Heiteren"},
    {"city": "Heiwiller"},
    {"city": "Helfrantzkirch"},
    {"city": "Herrlisheim-près-Colmar"},
    {"city": "Hésingue"},
    {"city": "Hettenschlag"},
    {"city": "Hindlingen"},
    {"city": "Hirsingue"},
    {"city": "Hirtzbach"},
    {"city": "Hirtzfelden"},
    {"city": "Hochstatt"},
    {"city": "Hohrod"},
    {"city": "Porte du Ried"},
    {"city": "Hombourg"},
    {"city": "Horbourg-Wihr"},
    {"city": "Houssen"},
    {"city": "Hunawihr"},
    {"city": "Hundsbach"},
    {"city": "Huningue"},
    {"city": "Husseren-les-Châteaux"},
    {"city": "Husseren-Wesserling"},
    {"city": "Illfurth"},
    {"city": "Illhaeusern"},
    {"city": "Illzach"},
    {"city": "Ingersheim"},
    {"city": "Issenheim"},
    {"city": "Jebsheim"},
    {"city": "Jettingen"},
    {"city": "Jungholtz"},
    {"city": "Kappelen"},
    {"city": "Katzenthal"},
    {"city": "Kaysersberg Vignoble"},
    {"city": "Kembs"},
    {"city": "Kiffis"},
    {"city": "Kingersheim"},
    {"city": "Kirchberg"},
    {"city": "Knœringue"},
    {"city": "Kœstlach"},
    {"city": "Kœtzingue"},
    {"city": "Kruth"},
    {"city": "Kunheim"},
    {"city": "Labaroche"},
    {"city": "Landser"},
    {"city": "Lapoutroie"},
    {"city": "Largitzen"},
    {"city": "Lautenbach"},
    {"city": "Lautenbachzell"},
    {"city": "Lauw"},
    {"city": "Leimbach"},
    {"city": "Levoncourt"},
    {"city": "Leymen"},
    {"city": "Liebenswiller"},
    {"city": "Liebsdorf"},
    {"city": "Lièpvre"},
    {"city": "Ligsdorf"},
    {"city": "Linsdorf"},
    {"city": "Linthal"},
    {"city": "Logelheim"},
    {"city": "Lucelle"},
    {"city": "Luemschwiller"},
    {"city": "Valdieu-Lutran"},
    {"city": "Luttenbach-près-Munster"},
    {"city": "Lutter"},
    {"city": "Lutterbach"},
    {"city": "Magny"},
    {"city": "Magstatt-le-Bas"},
    {"city": "Magstatt-le-Haut"},
    {"city": "Malmerspach"},
    {"city": "Manspach"},
    {"city": "Masevaux-Niederbruck"},
    {"city": "Mertzen"},
    {"city": "Merxheim"},
    {"city": "Metzeral"},
    {"city": "Meyenheim"},
    {"city": "Michelbach-le-Bas"},
    {"city": "Michelbach-le-Haut"},
    {"city": "Mittelwihr"},
    {"city": "Mittlach"},
    {"city": "Mitzach"},
    {"city": "Mœrnach"},
    {"city": "Mollau"},
    {"city": "Montreux-Jeune"},
    {"city": "Montreux-Vieux"},
    {"city": "Mooslargue"},
    {"city": "Moosch"},
    {"city": "Morschwiller-le-Bas"},
    {"city": "Le Haut Soultzbach"},
    {"city": "Muespach"},
    {"city": "Muespach-le-Haut"},
    {"city": "Muhlbach-sur-Munster"},
    {"city": "Mulhouse"},
    {"city": "Munchhouse"},
    {"city": "Munster"},
    {"city": "Muntzenheim"},
    {"city": "Munwiller"},
    {"city": "Murbach"},
    {"city": "Nambsheim"},
    {"city": "Neuf-Brisach"},
    {"city": "Neuwiller"},
    {"city": "Niederentzen"},
    {"city": "Niederhergheim"},
    {"city": "Niedermorschwihr"},
    {"city": "Niffer"},
    {"city": "Oberbruck"},
    {"city": "Illtal"},
    {"city": "Oberentzen"},
    {"city": "Oberhergheim"},
    {"city": "Oberlarg"},
    {"city": "Obermorschwihr"},
    {"city": "Obermorschwiller"},
    {"city": "Obersaasheim"},
    {"city": "Oderen"},
    {"city": "Oltingue"},
    {"city": "Orbey"},
    {"city": "Orschwihr"},
    {"city": "Osenbach"},
    {"city": "Ostheim"},
    {"city": "Ottmarsheim"},
    {"city": "Petit-Landau"},
    {"city": "Pfaffenheim"},
    {"city": "Pfastatt"},
    {"city": "Pfetterhouse"},
    {"city": "Pulversheim"},
    {"city": "Raedersdorf"},
    {"city": "Raedersheim"},
    {"city": "Rammersmatt"},
    {"city": "Ranspach"},
    {"city": "Ranspach-le-Bas"},
    {"city": "Ranspach-le-Haut"},
    {"city": "Rantzwiller"},
    {"city": "Réguisheim"},
    {"city": "Reiningue"},
    {"city": "Retzwiller"},
    {"city": "Ribeauvillé"},
    {"city": "Richwiller"},
    {"city": "Riedisheim"},
    {"city": "Riespach"},
    {"city": "Rimbach-près-Guebwiller"},
    {"city": "Rimbach-près-Masevaux"},
    {"city": "Rimbachzell"},
    {"city": "Riquewihr"},
    {"city": "Rixheim"},
    {"city": "Roderen"},
    {"city": "Rodern"},
    {"city": "Roggenhouse"},
    {"city": "Romagny"},
    {"city": "Rombach-le-Franc"},
    {"city": "Roppentzwiller"},
    {"city": "Rorschwihr"},
    {"city": "Rosenau"},
    {"city": "Rouffach"},
    {"city": "Ruederbach"},
    {"city": "Ruelisheim"},
    {"city": "Rustenhart"},
    {"city": "Rumersheim-le-Haut"},
    {"city": "Saint-Amarin"},
    {"city": "Saint-Cosme"},
    {"city": "Sainte-Croix-aux-Mines"},
    {"city": "Sainte-Croix-en-Plaine"},
    {"city": "Saint-Hippolyte"},
    {"city": "Saint-Louis"},
    {"city": "Sainte-Marie-aux-Mines"},
    {"city": "Saint-Ulrich"},
    {"city": "Sausheim"},
    {"city": "Schlierbach"},
    {"city": "Schweighouse-Thann"},
    {"city": "Schwoben"},
    {"city": "Sentheim"},
    {"city": "Seppois-le-Bas"},
    {"city": "Seppois-le-Haut"},
    {"city": "Sewen"},
    {"city": "Sickert"},
    {"city": "Sierentz"},
    {"city": "Sondernach"},
    {"city": "Sondersdorf"},
    {"city": "Soppe-le-Bas"},
    {"city": "Soultz-Haut-Rhin"},
    {"city": "Soultzbach-les-Bains"},
    {"city": "Soultzeren"},
    {"city": "Soultzmatt"},
    {"city": "Spechbach"},
    {"city": "Staffelfelden"},
    {"city": "Steinbach"},
    {"city": "Steinbrunn-le-Bas"},
    {"city": "Steinbrunn-le-Haut"},
    {"city": "Steinsoultz"},
    {"city": "Sternenberg"},
    {"city": "Stetten"},
    {"city": "Storckensohn"},
    {"city": "Stosswihr"},
    {"city": "Strueth"},
    {"city": "Sundhoffen"},
    {"city": "Tagolsheim"},
    {"city": "Tagsdorf"},
    {"city": "Thann"},
    {"city": "Thannenkirch"},
    {"city": "Traubach-le-Bas"},
    {"city": "Traubach-le-Haut"},
    {"city": "Turckheim"},
    {"city": "Ueberstrass"},
    {"city": "Uffheim"},
    {"city": "Uffholtz"},
    {"city": "Ungersheim"},
    {"city": "Urbès"},
    {"city": "Urschenheim"},
    {"city": "Vieux-Ferrette"},
    {"city": "Vieux-Thann"},
    {"city": "Village-Neuf"},
    {"city": "Vœgtlinshoffen"},
    {"city": "Vogelgrun"},
    {"city": "Volgelsheim"},
    {"city": "Wahlbach"},
    {"city": "Walbach"},
    {"city": "Waldighofen"},
    {"city": "Walheim"},
    {"city": "Waltenheim"},
    {"city": "Wasserbourg"},
    {"city": "Wattwiller"},
    {"city": "Weckolsheim"},
    {"city": "Wegscheid"},
    {"city": "Wentzwiller"},
    {"city": "Werentzhouse"},
    {"city": "Westhalten"},
    {"city": "Wettolsheim"},
    {"city": "Wickerschwihr"},
    {"city": "Widensolen"},
    {"city": "Wihr-au-Val"},
    {"city": "Wildenstein"},
    {"city": "Willer"},
    {"city": "Willer-sur-Thur"},
    {"city": "Winkel"},
    {"city": "Wintzenheim"},
    {"city": "Wittelsheim"},
    {"city": "Wittenheim"},
    {"city": "Wittersdorf"},
    {"city": "Wolfersdorf"},
    {"city": "Wolfgantzen"},
    {"city": "Wolschwiller"},
    {"city": "Wuenheim"},
    {"city": "Zaessingue"},
    {"city": "Zellenberg"},
    {"city": "Zillisheim"},
    {"city": "Zimmerbach"},
    {"city": "Zimmersheim"},
    {"city": "Affoux"},
    {"city": "Aigueperse"},
    {"city": "Albigny-sur-Saône"},
    {"city": "Alix"},
    {"city": "Ambérieux"},
    {"city": "Amplepuis"},
    {"city": "Ampuis"},
    {"city": "Ancy"},
    {"city": "Anse"},
    {"city": "L'Arbresle"},
    {"city": "Les Ardillats"},
    {"city": "Arnas"},
    {"city": "Aveize"},
    {"city": "Azolette"},
    {"city": "Bagnols"},
    {"city": "Beaujeu"},
    {"city": "Belleville-en-Beaujolais"},
    {"city": "Belmont-d'Azergues"},
    {"city": "Bessenay"},
    {"city": "Bibost"},
    {"city": "Blacé"},
    {"city": "Val d'Oingt"},
    {"city": "Le Breuil"},
    {"city": "Brignais"},
    {"city": "Brindas"},
    {"city": "Bron"},
    {"city": "Brullioles"},
    {"city": "Brussieu"},
    {"city": "Bully"},
    {"city": "Cailloux-sur-Fontaines"},
    {"city": "Caluire-et-Cuire"},
    {"city": "Cenves"},
    {"city": "Cercié"},
    {"city": "Chambost-Allières"},
    {"city": "Chambost-Longessaigne"},
    {"city": "Chamelet"},
    {"city": "Champagne-au-Mont-d'Or"},
    {"city": "La Chapelle-sur-Coise"},
    {"city": "Chaponost"},
    {"city": "Charbonnières-les-Bains"},
    {"city": "Charentay"},
    {"city": "Charly"},
    {"city": "Charnay"},
    {"city": "Chasselay"},
    {"city": "Châtillon"},
    {"city": "Chaussan"},
    {"city": "Chazay-d'Azergues"},
    {"city": "Chénas"},
    {"city": "Chénelette"},
    {"city": "Les Chères"},
    {"city": "Chessy"},
    {"city": "Chevinay"},
    {"city": "Chiroubles"},
    {"city": "Civrieux-d'Azergues"},
    {"city": "Claveisolles"},
    {"city": "Cogny"},
    {"city": "Coise"},
    {"city": "Collonges-au-Mont-d'Or"},
    {"city": "Condrieu"},
    {"city": "Corcelles-en-Beaujolais"},
    {"city": "Cours"},
    {"city": "Courzieu"},
    {"city": "Couzon-au-Mont-d'Or"},
    {"city": "Craponne"},
    {"city": "Cublize"},
    {"city": "Curis-au-Mont-d'Or"},
    {"city": "Dardilly"},
    {"city": "Denicé"},
    {"city": "Dième"},
    {"city": "Dommartin"},
    {"city": "Dracé"},
    {"city": "Duerne"},
    {"city": "Échalas"},
    {"city": "Écully"},
    {"city": "Émeringes"},
    {"city": "Éveux"},
    {"city": "Fleurie"},
    {"city": "Fleurieu-sur-Saône"},
    {"city": "Fleurieux-sur-l'Arbresle"},
    {"city": "Fontaines-Saint-Martin"},
    {"city": "Fontaines-sur-Saône"},
    {"city": "Francheville"},
    {"city": "Frontenas"},
    {"city": "Givors"},
    {"city": "Gleizé"},
    {"city": "Grandris"},
    {"city": "Grézieu-la-Varenne"},
    {"city": "Grézieu-le-Marché"},
    {"city": "Grigny"},
    {"city": "Les Haies"},
    {"city": "Les Halles"},
    {"city": "Haute-Rivoire"},
    {"city": "Irigny"},
    {"city": "Joux"},
    {"city": "Juliénas"},
    {"city": "Jullié"},
    {"city": "Lacenas"},
    {"city": "Lachassagne"},
    {"city": "Lamure-sur-Azergues"},
    {"city": "Lancié"},
    {"city": "Lantignié"},
    {"city": "Larajasse"},
    {"city": "Légny"},
    {"city": "Lentilly"},
    {"city": "Létra"},
    {"city": "Limas"},
    {"city": "Limonest"},
    {"city": "Lissieu"},
    {"city": "Loire-sur-Rhône"},
    {"city": "Longes"},
    {"city": "Longessaigne"},
    {"city": "Lozanne"},
    {"city": "Lucenay"},
    {"city": "Lyon"},
    {"city": "Marchampt"},
    {"city": "Marcilly-d'Azergues"},
    {"city": "Marcy"},
    {"city": "Marcy-l'Étoile"},
    {"city": "Meaux-la-Montagne"},
    {"city": "Messimy"},
    {"city": "Meys"},
    {"city": "Millery"},
    {"city": "Moiré"},
    {"city": "Deux-Grosnes"},
    {"city": "Montagny"},
    {"city": "Montmelas-Saint-Sorlin"},
    {"city": "Montromant"},
    {"city": "Montrottier"},
    {"city": "Morancé"},
    {"city": "Mornant"},
    {"city": "La Mulatière"},
    {"city": "Neuville-sur-Saône"},
    {"city": "Odenas"},
    {"city": "Orliénas"},
    {"city": "Oullins"},
    {"city": "Le Perréon"},
    {"city": "Pierre-Bénite"},
    {"city": "Poleymieux-au-Mont-d'Or"},
    {"city": "Pollionnay"},
    {"city": "Pomeys"},
    {"city": "Pommiers"},
    {"city": "Vindry-sur-Turdine"},
    {"city": "Porte des Pierres Dorées"},
    {"city": "Poule-les-Écharmeaux"},
    {"city": "Propières"},
    {"city": "Quincié-en-Beaujolais"},
    {"city": "Quincieux"},
    {"city": "Ranchal"},
    {"city": "Régnié-Durette"},
    {"city": "Riverie"},
    {"city": "Rivolet"},
    {"city": "Rochetaillée-sur-Saône"},
    {"city": "Ronno"},
    {"city": "Rontalon"},
    {"city": "Sain-Bel"},
    {"city": "Salles-Arbuissonnas-en-Beaujolais"},
    {"city": "Sarcey"},
    {"city": "Les Sauvages"},
    {"city": "Savigny"},
    {"city": "Soucieu-en-Jarrest"},
    {"city": "Sourcieux-les-Mines"},
    {"city": "Souzy"},
    {"city": "Beauvallon"},
    {"city": "Saint-André-la-Côte"},
    {"city": "Saint-Appolinaire"},
    {"city": "Saint-Bonnet-des-Bruyères"},
    {"city": "Saint-Bonnet-le-Troncy"},
    {"city": "Sainte-Catherine"},
    {"city": "Saint-Clément-de-Vers"},
    {"city": "Saint-Clément-les-Places"},
    {"city": "Saint-Clément-sur-Valsonne"},
    {"city": "Sainte-Colombe"},
    {"city": "Sainte-Consorce"},
    {"city": "Saint-Cyr-au-Mont-d'Or"},
    {"city": "Saint-Cyr-le-Chatoux"},
    {"city": "Saint-Cyr-sur-le-Rhône"},
    {"city": "Saint-Didier-au-Mont-d'Or"},
    {"city": "Saint-Didier-sur-Beaujeu"},
    {"city": "Saint-Étienne-des-Oullières"},
    {"city": "Saint-Étienne-la-Varenne"},
    {"city": "Saint-Fons"},
    {"city": "Saint-Forgeux"},
    {"city": "Sainte-Foy-l'Argentière"},
    {"city": "Sainte-Foy-lès-Lyon"},
    {"city": "Saint-Genis-l'Argentière"},
    {"city": "Saint-Genis-Laval"},
    {"city": "Saint-Genis-les-Ollières"},
    {"city": "Saint-Georges-de-Reneins"},
    {"city": "Saint-Germain-au-Mont-d'Or"},
    {"city": "Saint-Germain-Nuelles"},
    {"city": "Saint-Igny-de-Vers"},
    {"city": "Saint-Jean-des-Vignes"},
    {"city": "Saint-Jean-la-Bussière"},
    {"city": "Saint-Julien"},
    {"city": "Saint-Julien-sur-Bibost"},
    {"city": "Saint-Just-d'Avray"},
    {"city": "Saint-Lager"},
    {"city": "Saint-Laurent-d'Agny"},
    {"city": "Saint-Laurent-de-Chamousset"},
    {"city": "Saint-Marcel-l'Éclairé"},
    {"city": "Saint-Martin-en-Haut"},
    {"city": "Chabanière"},
    {"city": "Saint-Nizier-d'Azergues"},
    {"city": "Sainte-Paule"},
    {"city": "Saint-Pierre-la-Palud"},
    {"city": "Saint-Romain-au-Mont-d'Or"},
    {"city": "Saint-Romain-de-Popey"},
    {"city": "Saint-Romain-en-Gal"},
    {"city": "Saint-Romain-en-Gier"},
    {"city": "Saint-Symphorien-sur-Coise"},
    {"city": "Saint-Vérand"},
    {"city": "Saint-Vincent-de-Reins"},
    {"city": "Taluyers"},
    {"city": "Taponas"},
    {"city": "Tarare"},
    {"city": "Tassin-la-Demi-Lune"},
    {"city": "Ternand"},
    {"city": "Theizé"},
    {"city": "Thizy-les-Bourgs"},
    {"city": "Thurins"},
    {"city": "La Tour-de-Salvagny"},
    {"city": "Trèves"},
    {"city": "Tupin-et-Semons"},
    {"city": "Valsonne"},
    {"city": "Vaugneray"},
    {"city": "Vaulx-en-Velin"},
    {"city": "Vaux-en-Beaujolais"},
    {"city": "Vauxrenard"},
    {"city": "Vénissieux"},
    {"city": "Vernaison"},
    {"city": "Vernay"},
    {"city": "Villechenève"},
    {"city": "Villefranche-sur-Saône"},
    {"city": "Ville-sur-Jarnioux"},
    {"city": "Villeurbanne"},
    {"city": "Villié-Morgon"},
    {"city": "Vourles"},
    {"city": "Yzeron"},
    {"city": "Chaponnay"},
    {"city": "Chassieu"},
    {"city": "Communay"},
    {"city": "Corbas"},
    {"city": "Décines-Charpieu"},
    {"city": "Feyzin"},
    {"city": "Genas"},
    {"city": "Genay"},
    {"city": "Jonage"},
    {"city": "Jons"},
    {"city": "Marennes"},
    {"city": "Meyzieu"},
    {"city": "Mions"},
    {"city": "Montanay"},
    {"city": "Pusignan"},
    {"city": "Rillieux-la-Pape"},
    {"city": "Saint-Bonnet-de-Mure"},
    {"city": "Saint-Laurent-de-Mure"},
    {"city": "Saint-Pierre-de-Chandieu"},
    {"city": "Saint-Priest"},
    {"city": "Saint-Symphorien-d'Ozon"},
    {"city": "Sathonay-Camp"},
    {"city": "Sathonay-Village"},
    {"city": "Sérézin-du-Rhône"},
    {"city": "Simandres"},
    {"city": "Solaize"},
    {"city": "Ternay"},
    {"city": "Toussieu"},
    {"city": "Colombier-Saugnieu"},
    {"city": "Abelcourt"},
    {"city": "Aboncourt-Gesincourt"},
    {"city": "Achey"},
    {"city": "Adelans-et-le-Val-de-Bithaine"},
    {"city": "Aillevans"},
    {"city": "Aillevillers-et-Lyaumont"},
    {"city": "Ailloncourt"},
    {"city": "Ainvelle"},
    {"city": "Aisey-et-Richecourt"},
    {"city": "Alaincourt"},
    {"city": "Amage"},
    {"city": "Amance"},
    {"city": "Ambiévillers"},
    {"city": "Amblans-et-Velotte"},
    {"city": "Amoncourt"},
    {"city": "Amont-et-Effreney"},
    {"city": "Anchenoncourt-et-Chazel"},
    {"city": "Ancier"},
    {"city": "Andelarre"},
    {"city": "Andelarrot"},
    {"city": "Andornay"},
    {"city": "Angirey"},
    {"city": "Anjeux"},
    {"city": "Apremont"},
    {"city": "Arbecey"},
    {"city": "Arc-lès-Gray"},
    {"city": "Argillières"},
    {"city": "Aroz"},
    {"city": "Arpenans"},
    {"city": "Arsans"},
    {"city": "Athesans-Étroitefontaine"},
    {"city": "Attricourt"},
    {"city": "Augicourt"},
    {"city": "Aulx-lès-Cromary"},
    {"city": "Autet"},
    {"city": "Authoison"},
    {"city": "Autoreille"},
    {"city": "Autrey-lès-Cerre"},
    {"city": "Autrey-lès-Gray"},
    {"city": "Autrey-le-Vay"},
    {"city": "Auvet-et-la-Chapelotte"},
    {"city": "Auxon"},
    {"city": "Avrigney-Virey"},
    {"city": "Les Aynans"},
    {"city": "Baignes"},
    {"city": "Bard-lès-Pesmes"},
    {"city": "Barges"},
    {"city": "La Barre"},
    {"city": "La Basse-Vaivre"},
    {"city": "Bassigney"},
    {"city": "Les Bâties"},
    {"city": "Battrans"},
    {"city": "Baudoncourt"},
    {"city": "Baulay"},
    {"city": "Bay"},
    {"city": "Beaujeu-Saint-Vallier-Pierrejux-et-Quitteur"},
    {"city": "Beaumotte-Aubertans"},
    {"city": "Beaumotte-lès-Pin"},
    {"city": "Belfahy"},
    {"city": "Belmont"},
    {"city": "Belonchamp"},
    {"city": "Belverne"},
    {"city": "Besnans"},
    {"city": "Betaucourt"},
    {"city": "Betoncourt-lès-Brotte"},
    {"city": "Betoncourt-Saint-Pancras"},
    {"city": "Betoncourt-sur-Mance"},
    {"city": "Beulotte-Saint-Laurent"},
    {"city": "Beveuge"},
    {"city": "Blondefontaine"},
    {"city": "Bonboillon"},
    {"city": "Bonnevent-Velloreille"},
    {"city": "Borey"},
    {"city": "Bougey"},
    {"city": "Bougnon"},
    {"city": "Bouhans-et-Feurg"},
    {"city": "Bouhans-lès-Lure"},
    {"city": "Bouhans-lès-Montbozon"},
    {"city": "Bouligney"},
    {"city": "Boulot"},
    {"city": "Boult"},
    {"city": "Bourbévelle"},
    {"city": "Bourguignon-lès-Conflans"},
    {"city": "Bourguignon-lès-la-Charité"},
    {"city": "Bourguignon-lès-Morey"},
    {"city": "Boursières"},
    {"city": "Bousseraucourt"},
    {"city": "Bresilley"},
    {"city": "Breuches"},
    {"city": "Breuchotte"},
    {"city": "Breurey-lès-Faverney"},
    {"city": "Brevilliers"},
    {"city": "Briaucourt"},
    {"city": "Brotte-lès-Luxeuil"},
    {"city": "Brotte-lès-Ray"},
    {"city": "Broye-les-Loups-et-Verfontaine"},
    {"city": "Broye-Aubigney-Montseugny"},
    {"city": "Brussey"},
    {"city": "La Bruyère"},
    {"city": "Bucey-lès-Gy"},
    {"city": "Bucey-lès-Traves"},
    {"city": "Buffignécourt"},
    {"city": "Bussières"},
    {"city": "Buthiers"},
    {"city": "Calmoutier"},
    {"city": "Cemboing"},
    {"city": "Cenans"},
    {"city": "Cendrecourt"},
    {"city": "Cerre-lès-Noroy"},
    {"city": "Chagey"},
    {"city": "Châlonvillars"},
    {"city": "Chambornay-lès-Bellevaux"},
    {"city": "Chambornay-lès-Pin"},
    {"city": "Champagney"},
    {"city": "Champey"},
    {"city": "Champlitte"},
    {"city": "Champtonnay"},
    {"city": "Champvans"},
    {"city": "Chancey"},
    {"city": "Chantes"},
    {"city": "La Chapelle-lès-Luxeuil"},
    {"city": "La Chapelle-Saint-Quillain"},
    {"city": "Charcenne"},
    {"city": "Chargey-lès-Gray"},
    {"city": "Chargey-lès-Port"},
    {"city": "Chariez"},
    {"city": "Charmes-Saint-Valbert"},
    {"city": "Charmoille"},
    {"city": "Chassey-lès-Montbozon"},
    {"city": "Chassey-lès-Scey"},
    {"city": "Châteney"},
    {"city": "Châtenois"},
    {"city": "Chaumercenne"},
    {"city": "Chauvirey-le-Châtel"},
    {"city": "Chauvirey-le-Vieil"},
    {"city": "Chaux-la-Lotière"},
    {"city": "Chaux-lès-Port"},
    {"city": "Chavanne"},
    {"city": "Chemilly"},
    {"city": "Chenebier"},
    {"city": "Chenevrey-et-Morogne"},
    {"city": "Chevigney"},
    {"city": "Choye"},
    {"city": "Cintrey"},
    {"city": "Cirey"},
    {"city": "Citers"},
    {"city": "Citey"},
    {"city": "Clairegoutte"},
    {"city": "Clans"},
    {"city": "Cognières"},
    {"city": "Coisevaux"},
    {"city": "Colombe-lès-Vesoul"},
    {"city": "Colombier"},
    {"city": "Colombotte"},
    {"city": "Combeaufontaine"},
    {"city": "Comberjon"},
    {"city": "Conflandey"},
    {"city": "Conflans-sur-Lanterne"},
    {"city": "Confracourt"},
    {"city": "Contréglise"},
    {"city": "Corbenay"},
    {"city": "La Corbière"},
    {"city": "Cordonnet"},
    {"city": "Cornot"},
    {"city": "Corravillers"},
    {"city": "Corre"},
    {"city": "La Côte"},
    {"city": "Coulevon"},
    {"city": "Courchaton"},
    {"city": "Courcuire"},
    {"city": "Courmont"},
    {"city": "Courtesoult-et-Gatey"},
    {"city": "Couthenans"},
    {"city": "Cresancey"},
    {"city": "La Creuse"},
    {"city": "Crevans-et-la-Chapelle-lès-Granges"},
    {"city": "Creveney"},
    {"city": "Cromary"},
    {"city": "Cubry-lès-Faverney"},
    {"city": "Cugney"},
    {"city": "Cult"},
    {"city": "Cuve"},
    {"city": "Dambenoît-lès-Colombe"},
    {"city": "Dampierre-lès-Conflans"},
    {"city": "Dampierre-sur-Linotte"},
    {"city": "Dampierre-sur-Salon"},
    {"city": "Dampvalley-lès-Colombe"},
    {"city": "Dampvalley-Saint-Pancras"},
    {"city": "Delain"},
    {"city": "Demangevelle"},
    {"city": "La Demie"},
    {"city": "Denèvre"},
    {"city": "Échavanne"},
    {"city": "Échenans-sous-Mont-Vaudois"},
    {"city": "Échenoz-la-Méline"},
    {"city": "Échenoz-le-Sec"},
    {"city": "Écromagny"},
    {"city": "Écuelle"},
    {"city": "Éhuns"},
    {"city": "Équevilley"},
    {"city": "Errevet"},
    {"city": "Esboz-Brest"},
    {"city": "Esmoulières"},
    {"city": "Esmoulins"},
    {"city": "Esprels"},
    {"city": "Essertenne-et-Cecey"},
    {"city": "Étobon"},
    {"city": "Étrelles-et-la-Montbleuse"},
    {"city": "Étuz"},
    {"city": "Fahy-lès-Autrey"},
    {"city": "Fallon"},
    {"city": "Faucogney-et-la-Mer"},
    {"city": "Faverney"},
    {"city": "Faymont"},
    {"city": "Fédry"},
    {"city": "Ferrières-lès-Ray"},
    {"city": "Ferrières-lès-Scey"},
    {"city": "Les Fessey"},
    {"city": "Filain"},
    {"city": "Flagy"},
    {"city": "Fleurey-lès-Faverney"},
    {"city": "Fleurey-lès-Lavoncourt"},
    {"city": "Fleurey-lès-Saint-Loup"},
    {"city": "Fondremand"},
    {"city": "Fontaine-lès-Luxeuil"},
    {"city": "Fontenois-la-Ville"},
    {"city": "Fontenois-lès-Montbozon"},
    {"city": "Fouchécourt"},
    {"city": "Fougerolles-Saint-Valbert"},
    {"city": "Fouvent-Saint-Andoche"},
    {"city": "Frahier-et-Chatebier"},
    {"city": "Francalmont"},
    {"city": "Franchevelle"},
    {"city": "Francourt"},
    {"city": "Framont"},
    {"city": "Frasne-le-Château"},
    {"city": "Frédéric-Fontaine"},
    {"city": "Fresne-Saint-Mamès"},
    {"city": "Fresse"},
    {"city": "Fretigney-et-Velloreille"},
    {"city": "Froideconche"},
    {"city": "Froideterre"},
    {"city": "Frotey-lès-Lure"},
    {"city": "Frotey-lès-Vesoul"},
    {"city": "Genevreuille"},
    {"city": "Genevrey"},
    {"city": "Georfans"},
    {"city": "Germigney"},
    {"city": "Gevigney-et-Mercey"},
    {"city": "Gézier-et-Fontenelay"},
    {"city": "Girefontaine"},
    {"city": "Gouhenans"},
    {"city": "Gourgeon"},
    {"city": "Grammont"},
    {"city": "Grandecourt"},
    {"city": "Grandvelle-et-le-Perrenot"},
    {"city": "Granges-la-Ville"},
    {"city": "Granges-le-Bourg"},
    {"city": "Grattery"},
    {"city": "Gray"},
    {"city": "Gray-la-Ville"},
    {"city": "Gy"},
    {"city": "Haut-du-Them-Château-Lambert"},
    {"city": "Hautevelle"},
    {"city": "Héricourt"},
    {"city": "Hugier"},
    {"city": "Hurecourt"},
    {"city": "Hyet"},
    {"city": "Igny"},
    {"city": "Jasney"},
    {"city": "Jonvelle"},
    {"city": "Jussey"},
    {"city": "Lambrey"},
    {"city": "Lantenot"},
    {"city": "La Lanterne-et-les-Armonts"},
    {"city": "Larians-et-Munans"},
    {"city": "Larret"},
    {"city": "Lavigney"},
    {"city": "Lavoncourt"},
    {"city": "Lieffrans"},
    {"city": "Lieucourt"},
    {"city": "Liévans"},
    {"city": "Linexert"},
    {"city": "Lœuilley"},
    {"city": "Lomont"},
    {"city": "Longevelle"},
    {"city": "La Longine"},
    {"city": "Loulans-Verchamp"},
    {"city": "Lure"},
    {"city": "Luxeuil-les-Bains"},
    {"city": "Luze"},
    {"city": "Lyoffans"},
    {"city": "Magnivray"},
    {"city": "Magnoncourt"},
    {"city": "Le Magnoray"},
    {"city": "Les Magny"},
    {"city": "Magny-Danigon"},
    {"city": "Magny-Jobert"},
    {"city": "Magny-lès-Jussey"},
    {"city": "Magny-Vernois"},
    {"city": "Mailleroncourt-Charette"},
    {"city": "Mailleroncourt-Saint-Pancras"},
    {"city": "Mailley-et-Chazelot"},
    {"city": "Maizières"},
    {"city": "La Malachère"},
    {"city": "Malans"},
    {"city": "Malbouhans"},
    {"city": "Malvillers"},
    {"city": "Mandrevillars"},
    {"city": "Mantoche"},
    {"city": "Marast"},
    {"city": "Marnay"},
    {"city": "Maussans"},
    {"city": "Mélecey"},
    {"city": "Melin"},
    {"city": "Melincourt"},
    {"city": "Mélisey"},
    {"city": "Membrey"},
    {"city": "Menoux"},
    {"city": "Mercey-sur-Saône"},
    {"city": "Mersuay"},
    {"city": "Meurcourt"},
    {"city": "Mignavillers"},
    {"city": "Moffans-et-Vacheresse"},
    {"city": "Moimay"},
    {"city": "Molay"},
    {"city": "Mollans"},
    {"city": "La Montagne"},
    {"city": "Montagney"},
    {"city": "Montarlot-lès-Rioz"},
    {"city": "Montboillon"},
    {"city": "Montbozon"},
    {"city": "Montcey"},
    {"city": "Montcourt"},
    {"city": "Montdoré"},
    {"city": "Montessaux"},
    {"city": "Montigny-lès-Cherlieu"},
    {"city": "Montigny-lès-Vesoul"},
    {"city": "Montjustin-et-Velotte"},
    {"city": "Villers-Chemin-et-Mont-lès-Étrelles"},
    {"city": "Mont-le-Vernois"},
    {"city": "Montot"},
    {"city": "Mont-Saint-Léger"},
    {"city": "Montureux-et-Prantigny"},
    {"city": "Montureux-lès-Baulay"},
    {"city": "La Roche-Morey"},
    {"city": "Motey-Besuche"},
    {"city": "Nantilly"},
    {"city": "Navenne"},
    {"city": "Neurey-en-Vaux"},
    {"city": "Neurey-lès-la-Demie"},
    {"city": "Neuvelle-lès-Cromary"},
    {"city": "Neuvelle-lès-la-Charité"},
    {"city": "La Neuvelle-lès-Lure"},
    {"city": "La Neuvelle-lès-Scey"},
    {"city": "Noidans-le-Ferroux"},
    {"city": "Noidans-lès-Vesoul"},
    {"city": "Noiron"},
    {"city": "Noroy-le-Bourg"},
    {"city": "Oigney"},
    {"city": "Oiselay-et-Grachaux"},
    {"city": "Onay"},
    {"city": "Oppenans"},
    {"city": "Oricourt"},
    {"city": "Ormenans"},
    {"city": "Ormoiche"},
    {"city": "Ormoy"},
    {"city": "Ouge"},
    {"city": "Ovanches"},
    {"city": "Oyrières"},
    {"city": "Palante"},
    {"city": "Passavant-la-Rochère"},
    {"city": "Pennesières"},
    {"city": "Percey-le-Grand"},
    {"city": "Perrouse"},
    {"city": "Pesmes"},
    {"city": "Pierrecourt"},
    {"city": "Pin"},
    {"city": "La Pisseure"},
    {"city": "Plainemont"},
    {"city": "Plancher-Bas"},
    {"city": "Plancher-les-Mines"},
    {"city": "Polaincourt-et-Clairefontaine"},
    {"city": "Pomoy"},
    {"city": "Pontcey"},
    {"city": "La Romaine"},
    {"city": "Pont-du-Bois"},
    {"city": "Pont-sur-l'Ognon"},
    {"city": "Port-sur-Saône"},
    {"city": "Poyans"},
    {"city": "Preigney"},
    {"city": "La Proiselière-et-Langle"},
    {"city": "Provenchère"},
    {"city": "Purgerot"},
    {"city": "Pusey"},
    {"city": "Pusy-et-Épenoux"},
    {"city": "La Quarte"},
    {"city": "Quenoche"},
    {"city": "Quers"},
    {"city": "Quincey"},
    {"city": "Raddon-et-Chapendu"},
    {"city": "Raincourt"},
    {"city": "Ranzevelle"},
    {"city": "Ray-sur-Saône"},
    {"city": "Raze"},
    {"city": "Recologne"},
    {"city": "Recologne-lès-Rioz"},
    {"city": "Renaucourt"},
    {"city": "La Grande-Résie"},
    {"city": "La Résie-Saint-Martin"},
    {"city": "Rignovelle"},
    {"city": "Rigny"},
    {"city": "Rioz"},
    {"city": "Roche-et-Raucourt"},
    {"city": "Roche-sur-Linotte-et-Sorans-les-Cordiers"},
    {"city": "La Rochelle"},
    {"city": "Ronchamp"},
    {"city": "Rosey"},
    {"city": "La Rosière"},
    {"city": "Rosières-sur-Mance"},
    {"city": "Roye"},
    {"city": "Ruhans"},
    {"city": "Rupt-sur-Saône"},
    {"city": "Saint-Barthélemy"},
    {"city": "Saint-Bresson"},
    {"city": "Saint-Broing"},
    {"city": "Saint-Ferjeux"},
    {"city": "Saint-Gand"},
    {"city": "Saint-Germain"},
    {"city": "Saint-Loup-Nantouard"},
    {"city": "Saint-Loup-sur-Semouse"},
    {"city": "Saint-Marcel"},
    {"city": "Sainte-Marie-en-Chanois"},
    {"city": "Sainte-Marie-en-Chaux"},
    {"city": "Sainte-Reine"},
    {"city": "Saint-Rémy-en-Comté"},
    {"city": "Saint-Sauveur"},
    {"city": "Saint-Sulpice"},
    {"city": "Saponcourt"},
    {"city": "Saulnot"},
    {"city": "Saulx"},
    {"city": "Sauvigney-lès-Gray"},
    {"city": "Sauvigney-lès-Pesmes"},
    {"city": "Savoyeux"},
    {"city": "Scey-sur-Saône-et-Saint-Albin"},
    {"city": "Scye"},
    {"city": "Secenans"},
    {"city": "Selles"},
    {"city": "Semmadon"},
    {"city": "Senargent-Mignafans"},
    {"city": "Senoncourt"},
    {"city": "Servance-Miellin"},
    {"city": "Servigney"},
    {"city": "Seveux-Motey"},
    {"city": "Soing-Cubry-Charentenay"},
    {"city": "Sorans-lès-Breurey"},
    {"city": "Sornay"},
    {"city": "Tartécourt"},
    {"city": "Ternuay-Melay-et-Saint-Hilaire"},
    {"city": "Theuley"},
    {"city": "Thieffrans"},
    {"city": "Thiénans"},
    {"city": "Tincey-et-Pontrebeau"},
    {"city": "Traitiéfontaine"},
    {"city": "Traves"},
    {"city": "Le Tremblois"},
    {"city": "Trémoins"},
    {"city": "Trésilley"},
    {"city": "Tromarey"},
    {"city": "Vadans"},
    {"city": "Vaite"},
    {"city": "La Vaivre"},
    {"city": "Vaivre-et-Montoille"},
    {"city": "Valay"},
    {"city": "Le Val-de-Gouhenans"},
    {"city": "Vallerois-le-Bois"},
    {"city": "Vallerois-Lorioz"},
    {"city": "Le Val-Saint-Éloi"},
    {"city": "Vandelans"},
    {"city": "Vanne"},
    {"city": "Vantoux-et-Longevelle"},
    {"city": "Varogne"},
    {"city": "Vars"},
    {"city": "Vauchoux"},
    {"city": "Vauconcourt-Nervezain"},
    {"city": "Vauvillers"},
    {"city": "Vaux-le-Moncelot"},
    {"city": "Velesmes-Échevanne"},
    {"city": "Velet"},
    {"city": "Vellechevreux-et-Courbenans"},
    {"city": "Velleclaire"},
    {"city": "Vellefaux"},
    {"city": "Vellefrey-et-Vellefrange"},
    {"city": "Vellefrie"},
    {"city": "Velleguindry-et-Levrecey"},
    {"city": "Velle-le-Châtel"},
    {"city": "Velleminfroy"},
    {"city": "Vellemoz"},
    {"city": "Vellexon-Queutrey-et-Vaudey"},
    {"city": "Velloreille-lès-Choye"},
    {"city": "Velorcey"},
    {"city": "Venère"},
    {"city": "La Vergenne"},
    {"city": "Venisey"},
    {"city": "Vereux"},
    {"city": "Verlans"},
    {"city": "Vernois-sur-Mance"},
    {"city": "La Vernotte"},
    {"city": "Vesoul"},
    {"city": "Villafans"},
    {"city": "Villargent"},
    {"city": "Villars-le-Pautel"},
    {"city": "La Villedieu-en-Fontenette"},
    {"city": "Villefrancon"},
    {"city": "La Villeneuve-Bellenoye-et-la-Maize"},
    {"city": "Villeparois"},
    {"city": "Villers-Bouton"},
    {"city": "Villersexel"},
    {"city": "Villers-la-Ville"},
    {"city": "Villers-le-Sec"},
    {"city": "Villers-lès-Luxeuil"},
    {"city": "Villers-Pater"},
    {"city": "Villers-sur-Port"},
    {"city": "Villers-sur-Saulnot"},
    {"city": "Villers-Vaudey"},
    {"city": "Vilory"},
    {"city": "Visoncourt"},
    {"city": "Vitrey-sur-Mance"},
    {"city": "La Voivre"},
    {"city": "Volon"},
    {"city": "Voray-sur-l'Ognon"},
    {"city": "Vougécourt"},
    {"city": "Vouhenans"},
    {"city": "Vregille"},
    {"city": "Vyans-le-Val"},
    {"city": "Vy-le-Ferroux"},
    {"city": "Vy-lès-Lure"},
    {"city": "Vy-lès-Rupt"},
    {"city": "Vy-lès-Filain"},
    {"city": "L'Abergement-de-Cuisery"},
    {"city": "L'Abergement-Sainte-Colombe"},
    {"city": "Allerey-sur-Saône"},
    {"city": "Allériot"},
    {"city": "Aluze"},
    {"city": "Amanzé"},
    {"city": "Ameugny"},
    {"city": "Anglure-sous-Dun"},
    {"city": "Anost"},
    {"city": "Antully"},
    {"city": "Anzy-le-Duc"},
    {"city": "Artaix"},
    {"city": "Authumes"},
    {"city": "Autun"},
    {"city": "Auxy"},
    {"city": "Azé"},
    {"city": "Ballore"},
    {"city": "Bantanges"},
    {"city": "Barizey"},
    {"city": "Barnay"},
    {"city": "Baron"},
    {"city": "Baudemont"},
    {"city": "Baudrières"},
    {"city": "Baugy"},
    {"city": "Beaubery"},
    {"city": "Beaumont-sur-Grosne"},
    {"city": "Beaurepaire-en-Bresse"},
    {"city": "Beauvernois"},
    {"city": "Bellevesvre"},
    {"city": "Bergesserin"},
    {"city": "Berzé-le-Châtel"},
    {"city": "Berzé-la-Ville"},
    {"city": "Bey"},
    {"city": "Bissey-sous-Cruchaud"},
    {"city": "Bissy-la-Mâconnaise"},
    {"city": "Bissy-sous-Uxelles"},
    {"city": "Bissy-sur-Fley"},
    {"city": "Les Bizots"},
    {"city": "Blanot"},
    {"city": "Blanzy"},
    {"city": "Bois-Sainte-Marie"},
    {"city": "Bonnay"},
    {"city": "Les Bordes"},
    {"city": "Bosjean"},
    {"city": "Bouhans"},
    {"city": "La Boulaye"},
    {"city": "Bourbon-Lancy"},
    {"city": "Bourg-le-Comte"},
    {"city": "Bourgvilain"},
    {"city": "Bouzeron"},
    {"city": "Boyer"},
    {"city": "Bragny-sur-Saône"},
    {"city": "Branges"},
    {"city": "Bray"},
    {"city": "Bresse-sur-Grosne"},
    {"city": "Le Breuil"},
    {"city": "Briant"},
    {"city": "Brienne"},
    {"city": "Brion"},
    {"city": "Broye"},
    {"city": "Bruailles"},
    {"city": "Buffières"},
    {"city": "Burgy"},
    {"city": "Burnand"},
    {"city": "Burzy"},
    {"city": "Bussières"},
    {"city": "Buxy"},
    {"city": "Céron"},
    {"city": "Cersot"},
    {"city": "Chagny"},
    {"city": "Chaintré"},
    {"city": "Chalmoux"},
    {"city": "Chalon-sur-Saône"},
    {"city": "Chambilly"},
    {"city": "Chamilly"},
    {"city": "Champagnat"},
    {"city": "Champagny-sous-Uxelles"},
    {"city": "Champforgeuil"},
    {"city": "Champlecy"},
    {"city": "Chânes"},
    {"city": "Change"},
    {"city": "Changy"},
    {"city": "Chapaize"},
    {"city": "La Chapelle-au-Mans"},
    {"city": "La Chapelle-de-Bragny"},
    {"city": "La Chapelle-de-Guinchay"},
    {"city": "La Chapelle-du-Mont-de-France"},
    {"city": "La Chapelle-Naude"},
    {"city": "La Chapelle-Saint-Sauveur"},
    {"city": "La Chapelle-sous-Brancion"},
    {"city": "La Chapelle-sous-Dun"},
    {"city": "La Chapelle-sous-Uchon"},
    {"city": "La Chapelle-Thècle"},
    {"city": "Charbonnat"},
    {"city": "Charbonnières"},
    {"city": "Chardonnay"},
    {"city": "Charette-Varennes"},
    {"city": "La Charmée"},
    {"city": "Charmoy"},
    {"city": "Charnay-lès-Chalon"},
    {"city": "Charnay-lès-Mâcon"},
    {"city": "Charolles"},
    {"city": "Charrecey"},
    {"city": "Chasselas"},
    {"city": "Chassey-le-Camp"},
    {"city": "Chassigny-sous-Dun"},
    {"city": "Chassy"},
    {"city": "Château"},
    {"city": "Châteauneuf"},
    {"city": "Châtel-Moron"},
    {"city": "Châtenay"},
    {"city": "Châtenoy-en-Bresse"},
    {"city": "Châtenoy-le-Royal"},
    {"city": "Chaudenay"},
    {"city": "Chauffailles"},
    {"city": "La Chaux"},
    {"city": "Cheilly-lès-Maranges"},
    {"city": "Chenay-le-Châtel"},
    {"city": "Chenôves"},
    {"city": "Chérizet"},
    {"city": "Chevagny-les-Chevrières"},
    {"city": "Chevagny-sur-Guye"},
    {"city": "Chiddes"},
    {"city": "Chissey-en-Morvan"},
    {"city": "Chissey-lès-Mâcon"},
    {"city": "Ciel"},
    {"city": "Ciry-le-Noble"},
    {"city": "La Clayette"},
    {"city": "Navour-sur-Grosne"},
    {"city": "Clessé"},
    {"city": "Clessy"},
    {"city": "Cluny"},
    {"city": "Collonge-en-Charollais"},
    {"city": "Collonge-la-Madeleine"},
    {"city": "Colombier-en-Brionnais"},
    {"city": "La Comelle"},
    {"city": "Condal"},
    {"city": "Cordesse"},
    {"city": "Cormatin"},
    {"city": "Cortambert"},
    {"city": "Cortevaix"},
    {"city": "Coublanc"},
    {"city": "Couches"},
    {"city": "Crêches-sur-Saône"},
    {"city": "Créot"},
    {"city": "Cressy-sur-Somme"},
    {"city": "Le Creusot"},
    {"city": "Crissey"},
    {"city": "Cronat"},
    {"city": "Cruzille"},
    {"city": "Cuiseaux"},
    {"city": "Cuisery"},
    {"city": "Culles-les-Roches"},
    {"city": "Curbigny"},
    {"city": "Curdin"},
    {"city": "Curgy"},
    {"city": "Curtil-sous-Buffières"},
    {"city": "Curtil-sous-Burnand"},
    {"city": "Cussy-en-Morvan"},
    {"city": "Cuzy"},
    {"city": "Damerey"},
    {"city": "Dampierre-en-Bresse"},
    {"city": "Davayé"},
    {"city": "Demigny"},
    {"city": "Dennevy"},
    {"city": "Dettey"},
    {"city": "Devrouze"},
    {"city": "Dezize-lès-Maranges"},
    {"city": "Diconne"},
    {"city": "Digoin"},
    {"city": "Dommartin-lès-Cuiseaux"},
    {"city": "Dompierre-les-Ormes"},
    {"city": "Dompierre-sous-Sanvignes"},
    {"city": "Donzy-le-Pertuis"},
    {"city": "Dracy-le-Fort"},
    {"city": "Dracy-lès-Couches"},
    {"city": "Dracy-Saint-Loup"},
    {"city": "Dyo"},
    {"city": "Écuelles"},
    {"city": "Écuisses"},
    {"city": "Épertully"},
    {"city": "Épervans"},
    {"city": "Épinac"},
    {"city": "Essertenne"},
    {"city": "Étang-sur-Arroux"},
    {"city": "Étrigny"},
    {"city": "Farges-lès-Chalon"},
    {"city": "Farges-lès-Mâcon"},
    {"city": "Le Fay"},
    {"city": "Flacey-en-Bresse"},
    {"city": "Flagy"},
    {"city": "Fleury-la-Montagne"},
    {"city": "Fley"},
    {"city": "Fontaines"},
    {"city": "Fontenay"},
    {"city": "Fragnes-La Loyère"},
    {"city": "Frangy-en-Bresse"},
    {"city": "La Frette"},
    {"city": "Fretterans"},
    {"city": "Frontenard"},
    {"city": "Frontenaud"},
    {"city": "Fuissé"},
    {"city": "Génelard"},
    {"city": "La Genête"},
    {"city": "Genouilly"},
    {"city": "Gergy"},
    {"city": "Germagny"},
    {"city": "Germolles-sur-Grosne"},
    {"city": "Gibles"},
    {"city": "Gigny-sur-Saône"},
    {"city": "Gilly-sur-Loire"},
    {"city": "Givry"},
    {"city": "Gourdon"},
    {"city": "La Grande-Verrière"},
    {"city": "Grandvaux"},
    {"city": "Granges"},
    {"city": "Grevilly"},
    {"city": "Grury"},
    {"city": "Guerfand"},
    {"city": "Les Guerreaux"},
    {"city": "Gueugnon"},
    {"city": "La Guiche"},
    {"city": "Hautefond"},
    {"city": "L'Hôpital-le-Mercier"},
    {"city": "Huilly-sur-Seille"},
    {"city": "Hurigny"},
    {"city": "Igé"},
    {"city": "Igornay"},
    {"city": "Iguerande"},
    {"city": "Issy-l'Évêque"},
    {"city": "Jalogny"},
    {"city": "Jambles"},
    {"city": "Joncy"},
    {"city": "Joudes"},
    {"city": "Jouvençon"},
    {"city": "Jugy"},
    {"city": "Juif"},
    {"city": "Jully-lès-Buxy"},
    {"city": "Lacrost"},
    {"city": "Laives"},
    {"city": "Laizé"},
    {"city": "Laizy"},
    {"city": "Lalheue"},
    {"city": "Lans"},
    {"city": "Lays-sur-le-Doubs"},
    {"city": "Lesme"},
    {"city": "Lessard-en-Bresse"},
    {"city": "Lessard-le-National"},
    {"city": "Leynes"},
    {"city": "Ligny-en-Brionnais"},
    {"city": "Loisy"},
    {"city": "Longepierre"},
    {"city": "Louhans"},
    {"city": "Lournand"},
    {"city": "Lucenay-l'Évêque"},
    {"city": "Lugny"},
    {"city": "Lugny-lès-Charolles"},
    {"city": "Lux"},
    {"city": "Mâcon"},
    {"city": "Mailly"},
    {"city": "Malay"},
    {"city": "Maltat"},
    {"city": "Mancey"},
    {"city": "Marcigny"},
    {"city": "Marcilly-la-Gueurce"},
    {"city": "Marcilly-lès-Buxy"},
    {"city": "Marigny"},
    {"city": "Le Rousset-Marizy"},
    {"city": "Marly-sous-Issy"},
    {"city": "Marly-sur-Arroux"},
    {"city": "Marmagne"},
    {"city": "Marnay"},
    {"city": "Martailly-lès-Brancion"},
    {"city": "Martigny-le-Comte"},
    {"city": "Mary"},
    {"city": "Massilly"},
    {"city": "Matour"},
    {"city": "Mazille"},
    {"city": "Melay"},
    {"city": "Mellecey"},
    {"city": "Ménetreuil"},
    {"city": "Mercurey"},
    {"city": "Mervans"},
    {"city": "Messey-sur-Grosne"},
    {"city": "Mesvres"},
    {"city": "Milly-Lamartine"},
    {"city": "Le Miroir"},
    {"city": "Mont"},
    {"city": "Montagny-lès-Buxy"},
    {"city": "Montagny-près-Louhans"},
    {"city": "Montbellet"},
    {"city": "Montceau-les-Mines"},
    {"city": "Montceaux-l'Étoile"},
    {"city": "Montceaux-Ragny"},
    {"city": "Montcenis"},
    {"city": "Montchanin"},
    {"city": "Montcony"},
    {"city": "Montcoy"},
    {"city": "Monthelon"},
    {"city": "Montjay"},
    {"city": "Mont-lès-Seurre"},
    {"city": "Montmelard"},
    {"city": "Montmort"},
    {"city": "Montpont-en-Bresse"},
    {"city": "Montret"},
    {"city": "Mont-Saint-Vincent"},
    {"city": "Morey"},
    {"city": "Morlet"},
    {"city": "Mornay"},
    {"city": "Moroges"},
    {"city": "La Motte-Saint-Jean"},
    {"city": "Mouthier-en-Bresse"},
    {"city": "Mussy-sous-Dun"},
    {"city": "Nanton"},
    {"city": "Navilly"},
    {"city": "Neuvy-Grandchamp"},
    {"city": "Nochize"},
    {"city": "Ormes"},
    {"city": "Oslon"},
    {"city": "Oudry"},
    {"city": "Ouroux-sous-le-Bois-Sainte-Marie"},
    {"city": "Ouroux-sur-Saône"},
    {"city": "Oyé"},
    {"city": "Ozenay"},
    {"city": "Ozolles"},
    {"city": "Palinges"},
    {"city": "Palleau"},
    {"city": "Paray-le-Monial"},
    {"city": "Paris-l'Hôpital"},
    {"city": "Passy"},
    {"city": "Péronne"},
    {"city": "Perrecy-les-Forges"},
    {"city": "Perreuil"},
    {"city": "Perrigny-sur-Loire"},
    {"city": "La Petite-Verrière"},
    {"city": "Pierreclos"},
    {"city": "Pierre-de-Bresse"},
    {"city": "Le Planois"},
    {"city": "Plottes"},
    {"city": "Poisson"},
    {"city": "Pontoux"},
    {"city": "Pouilloux"},
    {"city": "Pourlans"},
    {"city": "Pressy-sous-Dondin"},
    {"city": "Préty"},
    {"city": "Prissé"},
    {"city": "Prizy"},
    {"city": "Pruzilly"},
    {"city": "Le Puley"},
    {"city": "La Racineuse"},
    {"city": "Rancy"},
    {"city": "Ratenelle"},
    {"city": "Ratte"},
    {"city": "Reclesne"},
    {"city": "Remigny"},
    {"city": "Rigny-sur-Arroux"},
    {"city": "La Roche-Vineuse"},
    {"city": "Romanèche-Thorins"},
    {"city": "Romenay"},
    {"city": "Rosey"},
    {"city": "Roussillon-en-Morvan"},
    {"city": "Royer"},
    {"city": "Rully"},
    {"city": "Sagy"},
    {"city": "Saillenard"},
    {"city": "Sailly"},
    {"city": "Saint-Agnan"},
    {"city": "Saint-Albain"},
    {"city": "Saint-Ambreuil"},
    {"city": "Saint-Amour-Bellevue"},
    {"city": "Saint-André-en-Bresse"},
    {"city": "Saint-André-le-Désert"},
    {"city": "Saint-Aubin-en-Charollais"},
    {"city": "Saint-Aubin-sur-Loire"},
    {"city": "Saint-Berain-sous-Sanvignes"},
    {"city": "Saint-Bérain-sur-Dheune"},
    {"city": "Saint-Boil"},
    {"city": "Saint-Bonnet-de-Cray"},
    {"city": "Saint-Bonnet-de-Joux"},
    {"city": "Saint-Bonnet-de-Vieille-Vigne"},
    {"city": "Saint-Bonnet-en-Bresse"},
    {"city": "Sainte-Cécile"},
    {"city": "Saint-Christophe-en-Bresse"},
    {"city": "Saint-Christophe-en-Brionnais"},
    {"city": "Saint-Clément-sur-Guye"},
    {"city": "Sainte-Croix"},
    {"city": "Saint-Cyr"},
    {"city": "Saint-Denis-de-Vaux"},
    {"city": "Saint-Désert"},
    {"city": "Saint-Didier-en-Bresse"},
    {"city": "Saint-Didier-en-Brionnais"},
    {"city": "Saint-Didier-sur-Arroux"},
    {"city": "Saint-Edmond"},
    {"city": "Saint-Émiland"},
    {"city": "Saint-Étienne-en-Bresse"},
    {"city": "Saint-Eugène"},
    {"city": "Saint-Eusèbe"},
    {"city": "Saint-Firmin"},
    {"city": "Saint-Forgeot"},
    {"city": "Sainte-Foy"},
    {"city": "Saint-Gengoux-de-Scissé"},
    {"city": "Saint-Gengoux-le-National"},
    {"city": "Saint-Germain-du-Bois"},
    {"city": "Saint-Germain-du-Plain"},
    {"city": "Saint-Germain-en-Brionnais"},
    {"city": "Saint-Germain-lès-Buxy"},
    {"city": "Saint-Gervais-en-Vallière"},
    {"city": "Saint-Gervais-sur-Couches"},
    {"city": "Saint-Gilles"},
    {"city": "Sainte-Hélène"},
    {"city": "Saint-Huruge"},
    {"city": "Saint-Igny-de-Roche"},
    {"city": "Saint-Jean-de-Vaux"},
    {"city": "Saint-Jean-de-Trézy"},
    {"city": "Saint-Julien-de-Civry"},
    {"city": "Saint-Julien-de-Jonzy"},
    {"city": "Saint-Julien-sur-Dheune"},
    {"city": "Saint-Laurent-d'Andenay"},
    {"city": "Saint-Laurent-en-Brionnais"},
    {"city": "Saint-Léger-du-Bois"},
    {"city": "Saint-Léger-lès-Paray"},
    {"city": "Saint-Léger-sous-Beuvray"},
    {"city": "Saint-Léger-sous-la-Bussière"},
    {"city": "Saint-Léger-sur-Dheune"},
    {"city": "Saint-Loup-Géanges"},
    {"city": "Saint-Loup-de-Varennes"},
    {"city": "Saint-Marcel"},
    {"city": "Saint-Marcelin-de-Cray"},
    {"city": "Saint-Mard-de-Vaux"},
    {"city": "Saint-Martin-Belle-Roche"},
    {"city": "Saint-Martin-d'Auxy"},
    {"city": "Saint-Martin-de-Commune"},
    {"city": "Saint-Martin-de-Lixy"},
    {"city": "Saint-Martin-de-Salencey"},
    {"city": "Saint-Martin-du-Lac"},
    {"city": "Saint-Martin-du-Mont"},
    {"city": "Saint-Martin-du-Tartre"},
    {"city": "Saint-Martin-en-Bresse"},
    {"city": "Saint-Martin-en-Gâtinois"},
    {"city": "Saint-Martin-la-Patrouille"},
    {"city": "Saint-Martin-sous-Montaigu"},
    {"city": "Saint-Maurice-de-Satonnay"},
    {"city": "Saint-Maurice-des-Champs"},
    {"city": "Saint-Maurice-en-Rivière"},
    {"city": "Saint-Maurice-lès-Châteauneuf"},
    {"city": "Saint-Maurice-lès-Couches"},
    {"city": "Saint-Micaud"},
    {"city": "Saint-Nizier-sur-Arroux"},
    {"city": "Saint-Pierre-de-Varennes"},
    {"city": "Saint-Pierre-le-Vieux"},
    {"city": "Saint-Point"},
    {"city": "Saint-Privé"},
    {"city": "Saint-Prix"},
    {"city": "Saint-Racho"},
    {"city": "Sainte-Radegonde"},
    {"city": "Saint-Rémy"},
    {"city": "Saint-Romain-sous-Gourdon"},
    {"city": "Saint-Romain-sous-Versigny"},
    {"city": "Saint-Sernin-du-Bois"},
    {"city": "Saint-Sernin-du-Plain"},
    {"city": "Saint-Symphorien-d'Ancelles"},
    {"city": "Saint-Symphorien-de-Marmagne"},
    {"city": "Saint-Symphorien-des-Bois"},
    {"city": "Saint-Usuge"},
    {"city": "Saint-Vallerin"},
    {"city": "Saint-Vallier"},
    {"city": "Saint-Vérand"},
    {"city": "Saint-Vincent-des-Prés"},
    {"city": "Saint-Vincent-en-Bresse"},
    {"city": "Saint-Vincent-Bragny"},
    {"city": "Saint-Yan"},
    {"city": "Saint-Ythaire"},
    {"city": "Saisy"},
    {"city": "La Salle"},
    {"city": "Salornay-sur-Guye"},
    {"city": "Sampigny-lès-Maranges"},
    {"city": "Sancé"},
    {"city": "Santilly"},
    {"city": "Sanvignes-les-Mines"},
    {"city": "Sarry"},
    {"city": "Sassangy"},
    {"city": "Sassenay"},
    {"city": "Saules"},
    {"city": "Saunières"},
    {"city": "Savianges"},
    {"city": "Savigny-en-Revermont"},
    {"city": "Savigny-sur-Grosne"},
    {"city": "Savigny-sur-Seille"},
    {"city": "La Celle-en-Morvan"},
    {"city": "Semur-en-Brionnais"},
    {"city": "Sennecey-le-Grand"},
    {"city": "Senozan"},
    {"city": "Sens-sur-Seille"},
    {"city": "Sercy"},
    {"city": "Serley"},
    {"city": "Sermesse"},
    {"city": "Serrières"},
    {"city": "Serrigny-en-Bresse"},
    {"city": "Sevrey"},
    {"city": "Sigy-le-Châtel"},
    {"city": "Simandre"},
    {"city": "Simard"},
    {"city": "Sivignon"},
    {"city": "Sologny"},
    {"city": "Solutré-Pouilly"},
    {"city": "Sommant"},
    {"city": "Sornay"},
    {"city": "Suin"},
    {"city": "Sully"},
    {"city": "La Tagnière"},
    {"city": "Taizé"},
    {"city": "Tancon"},
    {"city": "Le Tartre"},
    {"city": "Tavernay"},
    {"city": "Thil-sur-Arroux"},
    {"city": "Thurey"},
    {"city": "Tintry"},
    {"city": "Torcy"},
    {"city": "Torpes"},
    {"city": "Toulon-sur-Arroux"},
    {"city": "Tournus"},
    {"city": "Toutenant"},
    {"city": "Tramayes"},
    {"city": "Trambly"},
    {"city": "Trivy"},
    {"city": "Tronchy"},
    {"city": "La Truchère"},
    {"city": "Uchizy"},
    {"city": "Uchon"},
    {"city": "Uxeau"},
    {"city": "Vareilles"},
    {"city": "Varenne-l'Arconce"},
    {"city": "Varennes-le-Grand"},
    {"city": "Varennes-lès-Mâcon"},
    {"city": "Varenne-Saint-Germain"},
    {"city": "Varennes-Saint-Sauveur"},
    {"city": "Varennes-sous-Dun"},
    {"city": "Vauban"},
    {"city": "Vaudebarrier"},
    {"city": "Vaux-en-Pré"},
    {"city": "Vendenesse-lès-Charolles"},
    {"city": "Vendenesse-sur-Arroux"},
    {"city": "Verdun-sur-le-Doubs"},
    {"city": "Vergisson"},
    {"city": "Vérissey"},
    {"city": "Verjux"},
    {"city": "Verosvres"},
    {"city": "Vers"},
    {"city": "Versaugues"},
    {"city": "Verzé"},
    {"city": "Le Villars"},
    {"city": "Villegaudin"},
    {"city": "Clux-Villeneuve"},
    {"city": "Villeneuve-en-Montagne"},
    {"city": "Vincelles"},
    {"city": "Vindecy"},
    {"city": "La Vineuse sur Fregande"},
    {"city": "Vinzelles"},
    {"city": "Viré"},
    {"city": "Virey-le-Grand"},
    {"city": "Viry"},
    {"city": "Vitry-en-Charollais"},
    {"city": "Vitry-sur-Loire"},
    {"city": "Volesvres"},
    {"city": "Fleurville"},
    {"city": "Aigné"},
    {"city": "Aillières-Beauvoir"},
    {"city": "Allonnes"},
    {"city": "Amné"},
    {"city": "Ancinnes"},
    {"city": "Arçonnay"},
    {"city": "Ardenay-sur-Mérize"},
    {"city": "Arnage"},
    {"city": "Arthezé"},
    {"city": "Asnières-sur-Vègre"},
    {"city": "Assé-le-Boisne"},
    {"city": "Assé-le-Riboul"},
    {"city": "Aubigné-Racan"},
    {"city": "Les Aulneaux"},
    {"city": "Auvers-le-Hamon"},
    {"city": "Auvers-sous-Montfaucon"},
    {"city": "Avesnes-en-Saosnois"},
    {"city": "Avessé"},
    {"city": "Avezé"},
    {"city": "Avoise"},
    {"city": "Le Bailleul"},
    {"city": "Ballon-Saint Mars"},
    {"city": "La Bazoge"},
    {"city": "Bazouges Cré sur Loir"},
    {"city": "Beaufay"},
    {"city": "Beaumont-sur-Dême"},
    {"city": "Beaumont-Pied-de-Bœuf"},
    {"city": "Beaumont-sur-Sarthe"},
    {"city": "Beillé"},
    {"city": "Berfay"},
    {"city": "Bérus"},
    {"city": "Bessé-sur-Braye"},
    {"city": "Béthon"},
    {"city": "Blèves"},
    {"city": "Boëssé-le-Sec"},
    {"city": "Bonnétable"},
    {"city": "La Bosse"},
    {"city": "Bouër"},
    {"city": "Bouloire"},
    {"city": "Bourg-le-Roi"},
    {"city": "Bousse"},
    {"city": "Brains-sur-Gée"},
    {"city": "Le Breil-sur-Mérize"},
    {"city": "Brette-les-Pins"},
    {"city": "Briosne-lès-Sables"},
    {"city": "La Bruère-sur-Loir"},
    {"city": "Brûlon"},
    {"city": "Cérans-Foulletourte"},
    {"city": "Chahaignes"},
    {"city": "Challes"},
    {"city": "Champagné"},
    {"city": "Champfleur"},
    {"city": "Champrond"},
    {"city": "Changé"},
    {"city": "Chantenay-Villedieu"},
    {"city": "La Chapelle-aux-Choux"},
    {"city": "La Chapelle-d'Aligné"},
    {"city": "La Chapelle-du-Bois"},
    {"city": "La Chapelle-Huon"},
    {"city": "La Chapelle-Saint-Aubin"},
    {"city": "La Chapelle-Saint-Fray"},
    {"city": "La Chapelle-Saint-Rémy"},
    {"city": "La Chartre-sur-le-Loir"},
    {"city": "Chassillé"},
    {"city": "Montval-sur-Loir"},
    {"city": "Château-l'Hermitage"},
    {"city": "Chaufour-Notre-Dame"},
    {"city": "Chemiré-en-Charnie"},
    {"city": "Chemiré-le-Gaudin"},
    {"city": "Chenay"},
    {"city": "Chenu"},
    {"city": "Chérancé"},
    {"city": "Chérisay"},
    {"city": "Cherré-Au"},
    {"city": "Chevillé"},
    {"city": "Clermont-Créans"},
    {"city": "Cogners"},
    {"city": "Commerveil"},
    {"city": "Conflans-sur-Anille"},
    {"city": "Congé-sur-Orne"},
    {"city": "Conlie"},
    {"city": "Connerré"},
    {"city": "Contilly"},
    {"city": "Cormes"},
    {"city": "Coudrecieux"},
    {"city": "Coulaines"},
    {"city": "Coulans-sur-Gée"},
    {"city": "Coulongé"},
    {"city": "Courcebœufs"},
    {"city": "Courcelles-la-Forêt"},
    {"city": "Courcemont"},
    {"city": "Courcival"},
    {"city": "Courdemanche"},
    {"city": "Courgains"},
    {"city": "Courgenard"},
    {"city": "Courtillers"},
    {"city": "Crannes-en-Champagne"},
    {"city": "Crissé"},
    {"city": "Crosmières"},
    {"city": "Cures"},
    {"city": "Dangeul"},
    {"city": "Degré"},
    {"city": "Dehault"},
    {"city": "Dissay-sous-Courcillon"},
    {"city": "Dollon"},
    {"city": "Domfront-en-Champagne"},
    {"city": "Doucelles"},
    {"city": "Douillet"},
    {"city": "Duneau"},
    {"city": "Dureil"},
    {"city": "Écommoy"},
    {"city": "Écorpain"},
    {"city": "Épineu-le-Chevreuil"},
    {"city": "Étival-lès-le-Mans"},
    {"city": "Val-d'Étangson"},
    {"city": "Fatines"},
    {"city": "Fay"},
    {"city": "Fercé-sur-Sarthe"},
    {"city": "La Ferté-Bernard"},
    {"city": "Fillé"},
    {"city": "Flée"},
    {"city": "La Fontaine-Saint-Martin"},
    {"city": "Fontenay-sur-Vègre"},
    {"city": "Villeneuve-en-Perseigne"},
    {"city": "Fresnay-sur-Sarthe"},
    {"city": "Fyé"},
    {"city": "Gesnes-le-Gandelin"},
    {"city": "Grandchamp"},
    {"city": "Le Grand-Lucé"},
    {"city": "Gréez-sur-Roc"},
    {"city": "Le Grez"},
    {"city": "Guécélard"},
    {"city": "La Guierche"},
    {"city": "Jauzé"},
    {"city": "Joué-en-Charnie"},
    {"city": "Joué-l'Abbé"},
    {"city": "Juigné-sur-Sarthe"},
    {"city": "Juillé"},
    {"city": "Jupilles"},
    {"city": "La Flèche"},
    {"city": "Laigné-en-Belin"},
    {"city": "Lamnay"},
    {"city": "Lavardin"},
    {"city": "Lavaré"},
    {"city": "Lavernat"},
    {"city": "Lhomme"},
    {"city": "Ligron"},
    {"city": "Livet-en-Saosnois"},
    {"city": "Lombron"},
    {"city": "Longnes"},
    {"city": "Louailles"},
    {"city": "Loué"},
    {"city": "Louplande"},
    {"city": "Louvigny"},
    {"city": "Louzes"},
    {"city": "Le Luart"},
    {"city": "Luceau"},
    {"city": "Lucé-sous-Ballon"},
    {"city": "Luché-Pringé"},
    {"city": "Le Lude"},
    {"city": "Maigné"},
    {"city": "Maisoncelles"},
    {"city": "Malicorne-sur-Sarthe"},
    {"city": "Mamers"},
    {"city": "Le Mans"},
    {"city": "Mansigné"},
    {"city": "Marçon"},
    {"city": "Mareil-en-Champagne"},
    {"city": "Mareil-sur-Loir"},
    {"city": "Maresché"},
    {"city": "Marigné-Laillé"},
    {"city": "Marollette"},
    {"city": "Marolles-les-Braults"},
    {"city": "Marolles-lès-Saint-Calais"},
    {"city": "Mayet"},
    {"city": "Les Mées"},
    {"city": "Melleray"},
    {"city": "Meurcé"},
    {"city": "Mézeray"},
    {"city": "Mézières-sur-Ponthouin"},
    {"city": "Mézières-sous-Lavardin"},
    {"city": "La Milesse"},
    {"city": "Moitron-sur-Sarthe"},
    {"city": "Moncé-en-Belin"},
    {"city": "Moncé-en-Saosnois"},
    {"city": "Monhoudou"},
    {"city": "Montaillé"},
    {"city": "Montbizot"},
    {"city": "Montmirail"},
    {"city": "Montreuil-le-Chétif"},
    {"city": "Montreuil-le-Henri"},
    {"city": "Mont-Saint-Jean"},
    {"city": "Moulins-le-Carbonnel"},
    {"city": "Mulsanne"},
    {"city": "Nauvay"},
    {"city": "Neufchâtel-en-Saosnois"},
    {"city": "Neuvillalais"},
    {"city": "Neuville-sur-Sarthe"},
    {"city": "Neuvillette-en-Charnie"},
    {"city": "Bernay-Neuvy-en-Champagne"},
    {"city": "Nogent-le-Bernard"},
    {"city": "Nogent-sur-Loir"},
    {"city": "Nouans"},
    {"city": "Noyen-sur-Sarthe"},
    {"city": "Nuillé-le-Jalais"},
    {"city": "Oisseau-le-Petit"},
    {"city": "Oizé"},
    {"city": "Panon"},
    {"city": "Parcé-sur-Sarthe"},
    {"city": "Parennes"},
    {"city": "Parigné-le-Pôlin"},
    {"city": "Parigné-l'Évêque"},
    {"city": "Notre-Dame-du-Pé"},
    {"city": "Peray"},
    {"city": "Pezé-le-Robert"},
    {"city": "Piacé"},
    {"city": "Pincé"},
    {"city": "Pirmil"},
    {"city": "Pizieux"},
    {"city": "Poillé-sur-Vègre"},
    {"city": "Montfort-le-Gesnois"},
    {"city": "Pontvallain"},
    {"city": "Précigné"},
    {"city": "Préval"},
    {"city": "Prévelles"},
    {"city": "Pruillé-le-Chétif"},
    {"city": "Pruillé-l'Éguillé"},
    {"city": "La Quinte"},
    {"city": "Rahay"},
    {"city": "René"},
    {"city": "Requeil"},
    {"city": "Roézé-sur-Sarthe"},
    {"city": "Rouessé-Fontaine"},
    {"city": "Rouessé-Vassé"},
    {"city": "Rouez"},
    {"city": "Rouillon"},
    {"city": "Rouperroux-le-Coquet"},
    {"city": "Ruaudin"},
    {"city": "Ruillé-en-Champagne"},
    {"city": "Loir en Vallée"},
    {"city": "Sablé-sur-Sarthe"},
    {"city": "Saint-Aignan"},
    {"city": "Saint-Aubin-de-Locquenay"},
    {"city": "Saint-Aubin-des-Coudrais"},
    {"city": "Saint-Biez-en-Belin"},
    {"city": "Saint-Calais"},
    {"city": "Saint-Calez-en-Saosnois"},
    {"city": "Saint-Célerin"},
    {"city": "Sainte-Cérotte"},
    {"city": "Saint-Christophe-du-Jambet"},
    {"city": "Saint-Christophe-en-Champagne"},
    {"city": "Saint-Corneille"},
    {"city": "Saint-Cosme-en-Vairais"},
    {"city": "Saint-Denis-des-Coudrais"},
    {"city": "Saint-Denis-d'Orques"},
    {"city": "Saint-Georges-de-la-Couée"},
    {"city": "Saint-Georges-du-Bois"},
    {"city": "Saint-Georges-du-Rosay"},
    {"city": "Saint-Georges-le-Gaultier"},
    {"city": "Saint-Germain-d'Arcé"},
    {"city": "Saint-Gervais-de-Vic"},
    {"city": "Saint-Gervais-en-Belin"},
    {"city": "Sainte-Jamme-sur-Sarthe"},
    {"city": "Saint-Jean-d'Assé"},
    {"city": "Saint-Jean-de-la-Motte"},
    {"city": "Saint-Jean-des-Échelles"},
    {"city": "Saint-Jean-du-Bois"},
    {"city": "Saint-Léonard-des-Bois"},
    {"city": "Saint-Longis"},
    {"city": "Saint-Maixent"},
    {"city": "Saint-Marceau"},
    {"city": "Saint-Mars-de-Locquenay"},
    {"city": "Saint-Mars-d'Outillé"},
    {"city": "Saint-Mars-la-Brière"},
    {"city": "Saint-Martin-des-Monts"},
    {"city": "Saint-Michel-de-Chavaignes"},
    {"city": "Saint-Ouen-de-Mimbré"},
    {"city": "Saint-Ouen-en-Belin"},
    {"city": "Saint-Ouen-en-Champagne"},
    {"city": "Saint-Paterne - Le Chevain"},
    {"city": "Saint-Paul-le-Gaultier"},
    {"city": "Saint-Pavace"},
    {"city": "Saint-Pierre-de-Chevillé"},
    {"city": "Saint-Pierre-des-Bois"},
    {"city": "Saint-Pierre-des-Ormes"},
    {"city": "Saint-Pierre-du-Lorouër"},
    {"city": "Saint-Rémy-de-Sillé"},
    {"city": "Saint-Rémy-des-Monts"},
    {"city": "Saint-Rémy-du-Val"},
    {"city": "Sainte-Sabine-sur-Longève"},
    {"city": "Saint-Saturnin"},
    {"city": "Saint-Symphorien"},
    {"city": "Saint-Ulphace"},
    {"city": "Saint-Victeur"},
    {"city": "Saint-Vincent-des-Prés"},
    {"city": "Saint-Vincent-du-Lorouër"},
    {"city": "Saosnes"},
    {"city": "Sarcé"},
    {"city": "Sargé-lès-le-Mans"},
    {"city": "Savigné-l'Évêque"},
    {"city": "Savigné-sous-le-Lude"},
    {"city": "Sceaux-sur-Huisne"},
    {"city": "Ségrie"},
    {"city": "Semur-en-Vallon"},
    {"city": "Sillé-le-Guillaume"},
    {"city": "Sillé-le-Philippe"},
    {"city": "Solesmes"},
    {"city": "Sougé-le-Ganelon"},
    {"city": "Souillé"},
    {"city": "Souligné-Flacé"},
    {"city": "Souligné-sous-Ballon"},
    {"city": "Soulitré"},
    {"city": "Souvigné-sur-Même"},
    {"city": "Souvigné-sur-Sarthe"},
    {"city": "Spay"},
    {"city": "Surfonds"},
    {"city": "La Suze-sur-Sarthe"},
    {"city": "Tassé"},
    {"city": "Tassillé"},
    {"city": "Teillé"},
    {"city": "Teloché"},
    {"city": "Tennie"},
    {"city": "Terrehault"},
    {"city": "Théligny"},
    {"city": "Thoigné"},
    {"city": "Thoiré-sous-Contensor"},
    {"city": "Thoiré-sur-Dinan"},
    {"city": "Thorée-les-Pins"},
    {"city": "Thorigné-sur-Dué"},
    {"city": "Torcé-en-Vallée"},
    {"city": "Trangé"},
    {"city": "Tresson"},
    {"city": "Le Tronchet"},
    {"city": "Tuffé Val de la Chéronne"},
    {"city": "Vaas"},
    {"city": "Valennes"},
    {"city": "Vallon-sur-Gée"},
    {"city": "Vancé"},
    {"city": "Verneil-le-Chétif"},
    {"city": "Vernie"},
    {"city": "Vezot"},
    {"city": "Vibraye"},
    {"city": "Villaines-la-Carelle"},
    {"city": "Villaines-la-Gonais"},
    {"city": "Villaines-sous-Lucé"},
    {"city": "Villaines-sous-Malicorne"},
    {"city": "Vion"},
    {"city": "Viré-en-Champagne"},
    {"city": "Vivoin"},
    {"city": "Voivres-lès-le-Mans"},
    {"city": "Volnay"},
    {"city": "Vouvray-sur-Huisne"},
    {"city": "Yvré-le-Pôlin"},
    {"city": "Yvré-l'Évêque"},
    {"city": "Aiguebelette-le-Lac"},
    {"city": "Grand-Aigueblanche"},
    {"city": "Aillon-le-Jeune"},
    {"city": "Aillon-le-Vieux"},
    {"city": "Aime-la-Plagne"},
    {"city": "Aiton"},
    {"city": "Aix-les-Bains"},
    {"city": "Entrelacs"},
    {"city": "Albertville"},
    {"city": "Albiez-le-Jeune"},
    {"city": "Albiez-Montrond"},
    {"city": "Allondaz"},
    {"city": "Les Allues"},
    {"city": "Apremont"},
    {"city": "Arbin"},
    {"city": "Argentine"},
    {"city": "Arith"},
    {"city": "Arvillard"},
    {"city": "Attignat-Oncin"},
    {"city": "Aussois"},
    {"city": "Les Avanchers-Valmorel"},
    {"city": "Avressieux"},
    {"city": "Avrieux"},
    {"city": "Ayn"},
    {"city": "La Balme"},
    {"city": "Barberaz"},
    {"city": "Barby"},
    {"city": "Bassens"},
    {"city": "La Bâthie"},
    {"city": "La Bauche"},
    {"city": "Beaufort"},
    {"city": "Bellecombe-en-Bauges"},
    {"city": "Belmont-Tramonet"},
    {"city": "Bessans"},
    {"city": "Betton-Bettonet"},
    {"city": "Billième"},
    {"city": "La Biolle"},
    {"city": "Bonneval-sur-Arc"},
    {"city": "Bonvillard"},
    {"city": "Bonvillaret"},
    {"city": "Bourdeau"},
    {"city": "Le Bourget-du-Lac"},
    {"city": "Bourget-en-Huile"},
    {"city": "Bourgneuf"},
    {"city": "Bourg-Saint-Maurice"},
    {"city": "Bozel"},
    {"city": "Brides-les-Bains"},
    {"city": "La Bridoire"},
    {"city": "Brison-Saint-Innocent"},
    {"city": "Césarches"},
    {"city": "Cevins"},
    {"city": "Challes-les-Eaux"},
    {"city": "Chambéry"},
    {"city": "La Chambre"},
    {"city": "Chamousset"},
    {"city": "Chamoux-sur-Gelon"},
    {"city": "Champagneux"},
    {"city": "Champagny-en-Vanoise"},
    {"city": "Champ-Laurent"},
    {"city": "Chanaz"},
    {"city": "La Chapelle"},
    {"city": "La Chapelle-Blanche"},
    {"city": "La Chapelle-du-Mont-du-Chat"},
    {"city": "Les Chapelles"},
    {"city": "La Chapelle-Saint-Martin"},
    {"city": "Châteauneuf"},
    {"city": "Le Châtelard"},
    {"city": "La Chavanne"},
    {"city": "Les Chavannes-en-Maurienne"},
    {"city": "Chignin"},
    {"city": "Chindrieux"},
    {"city": "Cléry"},
    {"city": "Cognin"},
    {"city": "Cohennoz"},
    {"city": "Coise-Saint-Jean-Pied-Gauthier"},
    {"city": "La Compôte"},
    {"city": "Conjux"},
    {"city": "Corbel"},
    {"city": "Crest-Voland"},
    {"city": "La Croix-de-la-Rochette"},
    {"city": "Cruet"},
    {"city": "Curienne"},
    {"city": "Les Déserts"},
    {"city": "Détrier"},
    {"city": "Domessin"},
    {"city": "Doucy-en-Bauges"},
    {"city": "Drumettaz-Clarafond"},
    {"city": "Dullin"},
    {"city": "Les Échelles"},
    {"city": "École"},
    {"city": "Entremont-le-Vieux"},
    {"city": "Épierre"},
    {"city": "Esserts-Blay"},
    {"city": "Feissons-sur-Salins"},
    {"city": "Flumet"},
    {"city": "Fontcouverte-la-Toussuire"},
    {"city": "Fourneaux"},
    {"city": "Freney"},
    {"city": "Fréterive"},
    {"city": "Frontenex"},
    {"city": "Gerbaix"},
    {"city": "La Giettaz"},
    {"city": "Gilly-sur-Isère"},
    {"city": "Grésy-sur-Aix"},
    {"city": "Grésy-sur-Isère"},
    {"city": "Grignon"},
    {"city": "Hautecour"},
    {"city": "Hauteluce"},
    {"city": "Hauteville"},
    {"city": "La Tour-en-Maurienne"},
    {"city": "Jacob-Bellecombette"},
    {"city": "Jarrier"},
    {"city": "Jarsy"},
    {"city": "Jongieux"},
    {"city": "Laissaud"},
    {"city": "Landry"},
    {"city": "Lépin-le-Lac"},
    {"city": "Lescheraines"},
    {"city": "Loisieux"},
    {"city": "Lucey"},
    {"city": "La Plagne Tarentaise"},
    {"city": "Porte-de-Savoie"},
    {"city": "Marcieux"},
    {"city": "Marthod"},
    {"city": "Mercury"},
    {"city": "Méry"},
    {"city": "Meyrieux-Trouet"},
    {"city": "Modane"},
    {"city": "Les Mollettes"},
    {"city": "Montagnole"},
    {"city": "Montagny"},
    {"city": "Montailleur"},
    {"city": "Montcel"},
    {"city": "Montendry"},
    {"city": "Montgilbert"},
    {"city": "Monthion"},
    {"city": "Montmélian"},
    {"city": "Montricher-Albanne"},
    {"city": "Montsapey"},
    {"city": "Montvalezan"},
    {"city": "Montvernier"},
    {"city": "La Motte-en-Bauges"},
    {"city": "La Motte-Servolex"},
    {"city": "Motz"},
    {"city": "Moûtiers"},
    {"city": "Mouxy"},
    {"city": "Myans"},
    {"city": "Nances"},
    {"city": "Notre-Dame-de-Bellecombe"},
    {"city": "La Léchère"},
    {"city": "Notre-Dame-des-Millières"},
    {"city": "Notre-Dame-du-Cruet"},
    {"city": "Notre-Dame-du-Pré"},
    {"city": "Novalaise"},
    {"city": "Le Noyer"},
    {"city": "Ontex"},
    {"city": "Orelle"},
    {"city": "Pallud"},
    {"city": "Peisey-Nancroix"},
    {"city": "Planaise"},
    {"city": "Planay"},
    {"city": "Plancherine"},
    {"city": "Le Pont-de-Beauvoisin"},
    {"city": "Le Pontet"},
    {"city": "Pralognan-la-Vanoise"},
    {"city": "Presle"},
    {"city": "Pugny-Chatenod"},
    {"city": "Puygros"},
    {"city": "Queige"},
    {"city": "Val-d'Arc"},
    {"city": "La Ravoire"},
    {"city": "Rochefort"},
    {"city": "Valgelon-La Rochette"},
    {"city": "Rognaix"},
    {"city": "Rotherens"},
    {"city": "Ruffieux"},
    {"city": "Saint-Alban-de-Montbel"},
    {"city": "Saint-Alban-d'Hurtières"},
    {"city": "Saint-Alban-des-Villards"},
    {"city": "Saint-Alban-Leysse"},
    {"city": "Saint-André"},
    {"city": "Saint-Avre"},
    {"city": "Saint-Baldoph"},
    {"city": "Saint-Béron"},
    {"city": "Courchevel"},
    {"city": "Saint-Cassin"},
    {"city": "Saint-Christophe"},
    {"city": "Saint-Colomban-des-Villards"},
    {"city": "Saint-Étienne-de-Cuines"},
    {"city": "Sainte-Foy-Tarentaise"},
    {"city": "Saint-Franc"},
    {"city": "Saint-François-de-Sales"},
    {"city": "Saint François Longchamp"},
    {"city": "Saint-Genix-les-Villages"},
    {"city": "Saint-Georges-d'Hurtières"},
    {"city": "Sainte-Hélène-du-Lac"},
    {"city": "Sainte-Hélène-sur-Isère"},
    {"city": "Saint-Jean-d'Arves"},
    {"city": "Saint-Jean-d'Arvey"},
    {"city": "Saint-Jean-de-Chevelu"},
    {"city": "Saint-Jean-de-Couz"},
    {"city": "Saint-Jean-de-la-Porte"},
    {"city": "Saint-Jean-de-Maurienne"},
    {"city": "Saint-Jeoire-Prieuré"},
    {"city": "Saint-Julien-Mont-Denis"},
    {"city": "Saint-Léger"},
    {"city": "Saint-Marcel"},
    {"city": "Sainte-Marie-d'Alvey"},
    {"city": "Sainte-Marie-de-Cuines"},
    {"city": "Saint-Martin-d'Arc"},
    {"city": "Les Belleville"},
    {"city": "Saint-Martin-de-la-Porte"},
    {"city": "Saint-Martin-sur-la-Chambre"},
    {"city": "Saint-Michel-de-Maurienne"},
    {"city": "Saint-Nicolas-la-Chapelle"},
    {"city": "Saint-Offenge"},
    {"city": "Saint-Ours"},
    {"city": "Saint-Pancrace"},
    {"city": "Saint-Paul-sur-Isère"},
    {"city": "Saint-Paul"},
    {"city": "Saint-Pierre-d'Albigny"},
    {"city": "Saint-Pierre-d'Alvey"},
    {"city": "Saint-Pierre-de-Belleville"},
    {"city": "Saint-Pierre-de-Curtille"},
    {"city": "Saint-Pierre-d'Entremont"},
    {"city": "Saint-Pierre-de-Genebroz"},
    {"city": "Saint-Pierre-de-Soucy"},
    {"city": "Sainte-Reine"},
    {"city": "Saint-Rémy-de-Maurienne"},
    {"city": "Saint-Sorlin-d'Arves"},
    {"city": "Saint-Sulpice"},
    {"city": "Saint-Thibaud-de-Couz"},
    {"city": "Saint-Vital"},
    {"city": "Salins-Fontaine"},
    {"city": "Séez"},
    {"city": "Serrières-en-Chautagne"},
    {"city": "Sonnaz"},
    {"city": "La Table"},
    {"city": "Val-Cenis"},
    {"city": "Thénésol"},
    {"city": "Thoiry"},
    {"city": "La Thuile"},
    {"city": "Tignes"},
    {"city": "Tournon"},
    {"city": "Tours-en-Savoie"},
    {"city": "Traize"},
    {"city": "Tresserve"},
    {"city": "Trévignin"},
    {"city": "La Trinité"},
    {"city": "Ugine"},
    {"city": "Val-d'Isère"},
    {"city": "Valloire"},
    {"city": "Valmeinier"},
    {"city": "Venthon"},
    {"city": "Verel-de-Montbel"},
    {"city": "Verel-Pragondran"},
    {"city": "Le Verneil"},
    {"city": "Verrens-Arvey"},
    {"city": "Verthemex"},
    {"city": "Villard-d'Héry"},
    {"city": "Villard-Léger"},
    {"city": "Villard-Sallet"},
    {"city": "Villard-sur-Doron"},
    {"city": "Villarembert"},
    {"city": "Villargondran"},
    {"city": "Villarodin-Bourget"},
    {"city": "Villaroger"},
    {"city": "Villaroux"},
    {"city": "Vimines"},
    {"city": "Vions"},
    {"city": "Viviers-du-Lac"},
    {"city": "Voglans"},
    {"city": "Yenne"},
    {"city": "Abondance"},
    {"city": "Alby-sur-Chéran"},
    {"city": "Alex"},
    {"city": "Allèves"},
    {"city": "Allinges"},
    {"city": "Allonzier-la-Caille"},
    {"city": "Amancy"},
    {"city": "Ambilly"},
    {"city": "Andilly"},
    {"city": "Annecy"},
    {"city": "Annemasse"},
    {"city": "Anthy-sur-Léman"},
    {"city": "Arâches-la-Frasse"},
    {"city": "Arbusigny"},
    {"city": "Archamps"},
    {"city": "Arenthon"},
    {"city": "Argonay"},
    {"city": "Armoy"},
    {"city": "Arthaz-Pont-Notre-Dame"},
    {"city": "Ayse"},
    {"city": "Ballaison"},
    {"city": "La Balme-de-Sillingy"},
    {"city": "La Balme-de-Thuy"},
    {"city": "Bassy"},
    {"city": "La Baume"},
    {"city": "Beaumont"},
    {"city": "Bellevaux"},
    {"city": "Bernex"},
    {"city": "Le Biot"},
    {"city": "Bloye"},
    {"city": "Bluffy"},
    {"city": "Boëge"},
    {"city": "Bogève"},
    {"city": "Bonne"},
    {"city": "Bonnevaux"},
    {"city": "Bonneville"},
    {"city": "Bons-en-Chablais"},
    {"city": "Bossey"},
    {"city": "Le Bouchet-Mont-Charvin"},
    {"city": "Boussy"},
    {"city": "Brenthonne"},
    {"city": "Brizon"},
    {"city": "Burdignin"},
    {"city": "Cercier"},
    {"city": "Cernex"},
    {"city": "Cervens"},
    {"city": "Chainaz-les-Frasses"},
    {"city": "Challonges"},
    {"city": "Chamonix-Mont-Blanc"},
    {"city": "Champanges"},
    {"city": "La Chapelle-d'Abondance"},
    {"city": "La Chapelle-Rambaud"},
    {"city": "La Chapelle-Saint-Maurice"},
    {"city": "Chapeiry"},
    {"city": "Charvonnex"},
    {"city": "Châtel"},
    {"city": "Châtillon-sur-Cluses"},
    {"city": "Chaumont"},
    {"city": "Chavannaz"},
    {"city": "Chavanod"},
    {"city": "Chêne-en-Semine"},
    {"city": "Chênex"},
    {"city": "Chens-sur-Léman"},
    {"city": "Chessenaz"},
    {"city": "Chevaline"},
    {"city": "Chevenoz"},
    {"city": "Chevrier"},
    {"city": "Chilly"},
    {"city": "Choisy"},
    {"city": "Clarafond-Arcine"},
    {"city": "Clermont"},
    {"city": "Les Clefs"},
    {"city": "La Clusaz"},
    {"city": "Cluses"},
    {"city": "Collonges-sous-Salève"},
    {"city": "Combloux"},
    {"city": "Les Contamines-Montjoie"},
    {"city": "Contamine-Sarzin"},
    {"city": "Contamine-sur-Arve"},
    {"city": "Copponex"},
    {"city": "Cordon"},
    {"city": "Cornier"},
    {"city": "La Côte-d'Arbroz"},
    {"city": "Cranves-Sales"},
    {"city": "Crempigny-Bonneguête"},
    {"city": "Cruseilles"},
    {"city": "Cusy"},
    {"city": "Cuvat"},
    {"city": "Demi-Quartier"},
    {"city": "Desingy"},
    {"city": "Dingy-en-Vuache"},
    {"city": "Dingy-Saint-Clair"},
    {"city": "Domancy"},
    {"city": "Doussard"},
    {"city": "Douvaine"},
    {"city": "Draillant"},
    {"city": "Droisy"},
    {"city": "Duingt"},
    {"city": "Éloise"},
    {"city": "Entrevernes"},
    {"city": "Epagny Metz-Tessy"},
    {"city": "Essert-Romand"},
    {"city": "Etaux"},
    {"city": "Étercy"},
    {"city": "Étrembières"},
    {"city": "Évian-les-Bains"},
    {"city": "Excenevex"},
    {"city": "Faucigny"},
    {"city": "Faverges-Seythenex"},
    {"city": "Feigères"},
    {"city": "Fessy"},
    {"city": "Féternes"},
    {"city": "Fillinges"},
    {"city": "La Forclaz"},
    {"city": "Franclens"},
    {"city": "Frangy"},
    {"city": "Gaillard"},
    {"city": "Les Gets"},
    {"city": "Giez"},
    {"city": "Le Grand-Bornand"},
    {"city": "Groisy"},
    {"city": "Gruffy"},
    {"city": "Habère-Lullin"},
    {"city": "Habère-Poche"},
    {"city": "Hauteville-sur-Fier"},
    {"city": "Héry-sur-Alby"},
    {"city": "Les Houches"},
    {"city": "Jonzier-Épagny"},
    {"city": "Juvigny"},
    {"city": "Larringes"},
    {"city": "Lathuile"},
    {"city": "Leschaux"},
    {"city": "Loisin"},
    {"city": "Lornay"},
    {"city": "Lovagny"},
    {"city": "Lucinges"},
    {"city": "Lugrin"},
    {"city": "Lullin"},
    {"city": "Lully"},
    {"city": "Lyaud"},
    {"city": "Machilly"},
    {"city": "Magland"},
    {"city": "Manigod"},
    {"city": "Marcellaz-Albanais"},
    {"city": "Marcellaz"},
    {"city": "Margencel"},
    {"city": "Marignier"},
    {"city": "Marigny-Saint-Marcel"},
    {"city": "Marin"},
    {"city": "Val de Chaise"},
    {"city": "Marlioz"},
    {"city": "Marnaz"},
    {"city": "Massingy"},
    {"city": "Massongy"},
    {"city": "Maxilly-sur-Léman"},
    {"city": "Megève"},
    {"city": "Mégevette"},
    {"city": "Meillerie"},
    {"city": "Menthon-Saint-Bernard"},
    {"city": "Menthonnex-en-Bornes"},
    {"city": "Menthonnex-sous-Clermont"},
    {"city": "Mésigny"},
    {"city": "Messery"},
    {"city": "Mieussy"},
    {"city": "Minzier"},
    {"city": "Monnetier-Mornex"},
    {"city": "Montagny-les-Lanches"},
    {"city": "Montriond"},
    {"city": "Mont-Saxonnex"},
    {"city": "Morillon"},
    {"city": "Morzine"},
    {"city": "Moye"},
    {"city": "La Muraz"},
    {"city": "Mûres"},
    {"city": "Musièges"},
    {"city": "Nancy-sur-Cluses"},
    {"city": "Nangy"},
    {"city": "Nâves-Parmelan"},
    {"city": "Nernier"},
    {"city": "Neuvecelle"},
    {"city": "Neydens"},
    {"city": "Nonglard"},
    {"city": "Novel"},
    {"city": "Onnion"},
    {"city": "Orcier"},
    {"city": "Passy"},
    {"city": "Peillonnex"},
    {"city": "Perrignier"},
    {"city": "Pers-Jussy"},
    {"city": "Glières-Val-de-Borne"},
    {"city": "Poisy"},
    {"city": "Praz-sur-Arly"},
    {"city": "Présilly"},
    {"city": "Publier"},
    {"city": "Quintal"},
    {"city": "Reignier-Ésery"},
    {"city": "Le Reposoir"},
    {"city": "Reyvroz"},
    {"city": "La Rivière-Enverse"},
    {"city": "La Roche-sur-Foron"},
    {"city": "Rumilly"},
    {"city": "Saint-André-de-Boëge"},
    {"city": "Saint-Blaise"},
    {"city": "Saint-Cergues"},
    {"city": "Saint-Eusèbe"},
    {"city": "Saint-Eustache"},
    {"city": "Saint-Félix"},
    {"city": "Saint-Ferréol"},
    {"city": "Saint-Germain-sur-Rhône"},
    {"city": "Saint-Gervais-les-Bains"},
    {"city": "Saint-Gingolph"},
    {"city": "Saint-Jean-d'Aulps"},
    {"city": "Saint-Jean-de-Sixt"},
    {"city": "Saint-Jean-de-Tholome"},
    {"city": "Saint-Jeoire"},
    {"city": "Saint-Jorioz"},
    {"city": "Saint-Julien-en-Genevois"},
    {"city": "Saint-Laurent"},
    {"city": "Saint-Paul-en-Chablais"},
    {"city": "Saint-Pierre-en-Faucigny"},
    {"city": "Saint-Sigismond"},
    {"city": "Saint-Sixt"},
    {"city": "Saint-Sylvestre"},
    {"city": "Sales"},
    {"city": "Sallanches"},
    {"city": "Sallenôves"},
    {"city": "Samoëns"},
    {"city": "Le Sappey"},
    {"city": "Savigny"},
    {"city": "Saxel"},
    {"city": "Scientrier"},
    {"city": "Sciez"},
    {"city": "Scionzier"},
    {"city": "Serraval"},
    {"city": "Servoz"},
    {"city": "Sevrier"},
    {"city": "Seyssel"},
    {"city": "Seytroux"},
    {"city": "Sillingy"},
    {"city": "Sixt-Fer-à-Cheval"},
    {"city": "Talloires-Montmin"},
    {"city": "Taninges"},
    {"city": "Thyez"},
    {"city": "Thollon-les-Mémises"},
    {"city": "Thônes"},
    {"city": "Thonon-les-Bains"},
    {"city": "Fillière"},
    {"city": "Thusy"},
    {"city": "La Tour"},
    {"city": "Usinens"},
    {"city": "Vacheresse"},
    {"city": "Vailly"},
    {"city": "Valleiry"},
    {"city": "Vallières-sur-Fier"},
    {"city": "Vallorcine"},
    {"city": "Vanzy"},
    {"city": "Vaulx"},
    {"city": "Veigy-Foncenex"},
    {"city": "Verchaix"},
    {"city": "La Vernaz"},
    {"city": "Vers"},
    {"city": "Versonnex"},
    {"city": "Vétraz-Monthoux"},
    {"city": "Veyrier-du-Lac"},
    {"city": "Villard"},
    {"city": "Les Villards-sur-Thônes"},
    {"city": "Villaz"},
    {"city": "Ville-en-Sallaz"},
    {"city": "Ville-la-Grand"},
    {"city": "Villy-le-Bouveret"},
    {"city": "Villy-le-Pelloux"},
    {"city": "Vinzier"},
    {"city": "Viry"},
    {"city": "Viuz-la-Chiésaz"},
    {"city": "Viuz-en-Sallaz"},
    {"city": "Vougy"},
    {"city": "Vovray-en-Bornes"},
    {"city": "Vulbens"},
    {"city": "Yvoire"},
    {"city": "Paris"},
    {"city": "Allouville-Bellefosse"},
    {"city": "Alvimare"},
    {"city": "Ambrumesnil"},
    {"city": "Amfreville-la-Mi-Voie"},
    {"city": "Amfreville-les-Champs"},
    {"city": "Anceaumeville"},
    {"city": "Ancourt"},
    {"city": "Ancourteville-sur-Héricourt"},
    {"city": "Ancretiéville-Saint-Victor"},
    {"city": "Ancretteville-sur-Mer"},
    {"city": "Angerville-Bailleul"},
    {"city": "Angerville-la-Martel"},
    {"city": "Angerville-l'Orcher"},
    {"city": "Angiens"},
    {"city": "Anglesqueville-la-Bras-Long"},
    {"city": "Anglesqueville-l'Esneval"},
    {"city": "Val-de-Saâne"},
    {"city": "Anneville-sur-Scie"},
    {"city": "Anneville-Ambourville"},
    {"city": "Annouville-Vilmesnil"},
    {"city": "Anquetierville"},
    {"city": "Anvéville"},
    {"city": "Ardouval"},
    {"city": "Argueil"},
    {"city": "Arques-la-Bataille"},
    {"city": "Aubéguimont"},
    {"city": "Aubermesnil-aux-Érables"},
    {"city": "Aubermesnil-Beaumais"},
    {"city": "Auberville-la-Manuel"},
    {"city": "Auberville-la-Renault"},
    {"city": "Val-de-Scie"},
    {"city": "Aumale"},
    {"city": "Auppegard"},
    {"city": "Authieux-Ratiéville"},
    {"city": "Les Authieux-sur-le-Port-Saint-Ouen"},
    {"city": "Autigny"},
    {"city": "Les Hauts-de-Caux"},
    {"city": "Auvilliers"},
    {"city": "Auzebosc"},
    {"city": "Auzouville-l'Esneval"},
    {"city": "Auzouville-sur-Ry"},
    {"city": "Auzouville-sur-Saâne"},
    {"city": "Avesnes-en-Bray"},
    {"city": "Avesnes-en-Val"},
    {"city": "Avremesnil"},
    {"city": "Bacqueville-en-Caux"},
    {"city": "Bailleul-Neuville"},
    {"city": "Baillolet"},
    {"city": "Bailly-en-Rivière"},
    {"city": "Baons-le-Comte"},
    {"city": "Bardouville"},
    {"city": "Barentin"},
    {"city": "Baromesnil"},
    {"city": "Bazinval"},
    {"city": "Beaubec-la-Rosière"},
    {"city": "Beaumont-le-Hareng"},
    {"city": "Beauval-en-Caux"},
    {"city": "Beaurepaire"},
    {"city": "Beaussault"},
    {"city": "Beautot"},
    {"city": "Beauvoir-en-Lyons"},
    {"city": "Bec-de-Mortagne"},
    {"city": "Belbeuf"},
    {"city": "Bellencombre"},
    {"city": "Bellengreville"},
    {"city": "Belleville-en-Caux"},
    {"city": "La Bellière"},
    {"city": "Belmesnil"},
    {"city": "Bénarville"},
    {"city": "Bénesville"},
    {"city": "Bénouville"},
    {"city": "Bernières"},
    {"city": "Bertheauville"},
    {"city": "Bertreville"},
    {"city": "Bertreville-Saint-Ouen"},
    {"city": "Bertrimont"},
    {"city": "Berville-en-Caux"},
    {"city": "Berville-sur-Seine"},
    {"city": "Beuzeville-la-Grenier"},
    {"city": "Beuzeville-la-Guérard"},
    {"city": "Beuzevillette"},
    {"city": "Bézancourt"},
    {"city": "Bierville"},
    {"city": "Bihorel"},
    {"city": "Biville-la-Baignarde"},
    {"city": "Biville-la-Rivière"},
    {"city": "Blacqueville"},
    {"city": "Blainville-Crevon"},
    {"city": "Blangy-sur-Bresle"},
    {"city": "Bonsecours"},
    {"city": "Blosseville"},
    {"city": "Le Bocasse"},
    {"city": "Bois-d'Ennebourg"},
    {"city": "Bois-Guilbert"},
    {"city": "Bois-Guillaume"},
    {"city": "Bois-Héroult"},
    {"city": "Bois-Himont"},
    {"city": "Bois-l'Évêque"},
    {"city": "Le Bois-Robert"},
    {"city": "Boissay"},
    {"city": "Bolbec"},
    {"city": "Bolleville"},
    {"city": "Boos"},
    {"city": "Bordeaux-Saint-Clair"},
    {"city": "Bornambusc"},
    {"city": "Bosc-Bérenger"},
    {"city": "Bosc-Bordel"},
    {"city": "Bosc-Édeline"},
    {"city": "Callengeville"},
    {"city": "Bosc-Guérard-Saint-Adrien"},
    {"city": "Bosc-Hyons"},
    {"city": "Bosc-le-Hard"},
    {"city": "Bosc-Mesnil"},
    {"city": "Bosville"},
    {"city": "Boudeville"},
    {"city": "Bouelles"},
    {"city": "La Bouille"},
    {"city": "Bourdainville"},
    {"city": "Le Bourg-Dun"},
    {"city": "Bourville"},
    {"city": "Bouville"},
    {"city": "Brachy"},
    {"city": "Bracquetuit"},
    {"city": "Bradiancourt"},
    {"city": "Brametot"},
    {"city": "Bréauté"},
    {"city": "Brémontier-Merval"},
    {"city": "Bretteville-du-Grand-Caux"},
    {"city": "Bretteville-Saint-Laurent"},
    {"city": "Buchy"},
    {"city": "Bully"},
    {"city": "Bures-en-Bray"},
    {"city": "Butot"},
    {"city": "Cailleville"},
    {"city": "Cailly"},
    {"city": "Calleville-les-Deux-Églises"},
    {"city": "Campneuseville"},
    {"city": "Canehan"},
    {"city": "Canouville"},
    {"city": "Canteleu"},
    {"city": "Canville-les-Deux-Églises"},
    {"city": "Cany-Barville"},
    {"city": "Carville-la-Folletière"},
    {"city": "Carville-Pot-de-Fer"},
    {"city": "Le Catelier"},
    {"city": "Catenay"},
    {"city": "Rives-en-Seine"},
    {"city": "Caudebec-lès-Elbeuf"},
    {"city": "Le Caule-Sainte-Beuve"},
    {"city": "Cauville-sur-Mer"},
    {"city": "Les Cent-Acres"},
    {"city": "La Cerlangue"},
    {"city": "La Chapelle-du-Bourgay"},
    {"city": "La Chapelle-Saint-Ouen"},
    {"city": "La Chapelle-sur-Dun"},
    {"city": "La Chaussée"},
    {"city": "Cideville"},
    {"city": "Clais"},
    {"city": "Clasville"},
    {"city": "Claville-Motteville"},
    {"city": "Cléon"},
    {"city": "Clères"},
    {"city": "Cleuville"},
    {"city": "Cléville"},
    {"city": "Cliponville"},
    {"city": "Colleville"},
    {"city": "Colmesnil-Manneville"},
    {"city": "Compainville"},
    {"city": "Conteville"},
    {"city": "Contremoulins"},
    {"city": "Cottévrard"},
    {"city": "Crasville-la-Mallet"},
    {"city": "Crasville-la-Rocquefort"},
    {"city": "Criel-sur-Mer"},
    {"city": "La Crique"},
    {"city": "Criquebeuf-en-Caux"},
    {"city": "Criquetot-le-Mauconduit"},
    {"city": "Criquetot-l'Esneval"},
    {"city": "Criquetot-sur-Longueville"},
    {"city": "Criquetot-sur-Ouville"},
    {"city": "Criquiers"},
    {"city": "Critot"},
    {"city": "Croisy-sur-Andelle"},
    {"city": "Croixdalle"},
    {"city": "Croix-Mare"},
    {"city": "Cropus"},
    {"city": "Crosville-sur-Scie"},
    {"city": "Cuverville"},
    {"city": "Cuverville-sur-Yères"},
    {"city": "Cuy-Saint-Fiacre"},
    {"city": "Dampierre-en-Bray"},
    {"city": "Dampierre-Saint-Nicolas"},
    {"city": "Dancourt"},
    {"city": "Darnétal"},
    {"city": "Daubeuf-Serville"},
    {"city": "Dénestanville"},
    {"city": "Déville-lès-Rouen"},
    {"city": "Dieppe"},
    {"city": "Doudeauville"},
    {"city": "Doudeville"},
    {"city": "Douvrend"},
    {"city": "Drosay"},
    {"city": "Duclair"},
    {"city": "Écalles-Alix"},
    {"city": "Écrainville"},
    {"city": "Écretteville-lès-Baons"},
    {"city": "Écretteville-sur-Mer"},
    {"city": "Ectot-l'Auber"},
    {"city": "Ectot-lès-Baons"},
    {"city": "Elbeuf-en-Bray"},
    {"city": "Elbeuf-sur-Andelle"},
    {"city": "Elbeuf"},
    {"city": "Életot"},
    {"city": "Ellecourt"},
    {"city": "Émanville"},
    {"city": "Envermeu"},
    {"city": "Envronville"},
    {"city": "Épinay-sur-Duclair"},
    {"city": "Épouville"},
    {"city": "Épretot"},
    {"city": "Épreville"},
    {"city": "Ermenouville"},
    {"city": "Ernemont-la-Villette"},
    {"city": "Ernemont-sur-Buchy"},
    {"city": "Esclavelles"},
    {"city": "Eslettes"},
    {"city": "Esteville"},
    {"city": "Étaimpuis"},
    {"city": "Étainhus"},
    {"city": "Étalleville"},
    {"city": "Étalondes"},
    {"city": "Étoutteville"},
    {"city": "Étretat"},
    {"city": "Eu"},
    {"city": "Fallencourt"},
    {"city": "Terres-de-Caux"},
    {"city": "Fécamp"},
    {"city": "Ferrières-en-Bray"},
    {"city": "La Ferté-Saint-Samson"},
    {"city": "Fesques"},
    {"city": "La Feuillie"},
    {"city": "Flamanville"},
    {"city": "Flamets-Frétils"},
    {"city": "Flocques"},
    {"city": "Fongueusemare"},
    {"city": "Fontaine-en-Bray"},
    {"city": "Fontaine-la-Mallet"},
    {"city": "Fontaine-le-Bourg"},
    {"city": "Fontaine-le-Dun"},
    {"city": "Fontaine-sous-Préaux"},
    {"city": "La Fontelaye"},
    {"city": "Fontenay"},
    {"city": "Forges-les-Eaux"},
    {"city": "Foucarmont"},
    {"city": "Foucart"},
    {"city": "Fréauville"},
    {"city": "La Frénaye"},
    {"city": "Freneuse"},
    {"city": "Fresles"},
    {"city": "Fresnay-le-Long"},
    {"city": "Fresne-le-Plan"},
    {"city": "Fresnoy-Folny"},
    {"city": "Fresquiennes"},
    {"city": "Freulleville"},
    {"city": "Saint Martin de l'If"},
    {"city": "Frichemesnil"},
    {"city": "Froberville"},
    {"city": "Fry"},
    {"city": "Fultot"},
    {"city": "La Gaillarde"},
    {"city": "Gaillefontaine"},
    {"city": "Gainneville"},
    {"city": "Gancourt-Saint-Étienne"},
    {"city": "Ganzeville"},
    {"city": "Gerponville"},
    {"city": "Gerville"},
    {"city": "Goderville"},
    {"city": "Gommerville"},
    {"city": "Gonfreville-Caillot"},
    {"city": "Gonfreville-l'Orcher"},
    {"city": "Gonnetot"},
    {"city": "Gonneville-la-Mallet"},
    {"city": "Gonneville-sur-Scie"},
    {"city": "Gonzeville"},
    {"city": "Goupillières"},
    {"city": "Gournay-en-Bray"},
    {"city": "Gouy"},
    {"city": "Graimbouville"},
    {"city": "Grainville-la-Teinturière"},
    {"city": "Grainville-sur-Ry"},
    {"city": "Grainville-Ymauville"},
    {"city": "Grand-Camp"},
    {"city": "Grand-Couronne"},
    {"city": "Grandcourt"},
    {"city": "Les Grandes-Ventes"},
    {"city": "Le Grand-Quevilly"},
    {"city": "Graval"},
    {"city": "Grèges"},
    {"city": "Grémonville"},
    {"city": "Greuville"},
    {"city": "Grigneuseville"},
    {"city": "Gruchet-le-Valasse"},
    {"city": "Gruchet-Saint-Siméon"},
    {"city": "Grugny"},
    {"city": "Grumesnil"},
    {"city": "Guerville"},
    {"city": "Gueures"},
    {"city": "Gueutteville"},
    {"city": "Gueutteville-les-Grès"},
    {"city": "La Hallotière"},
    {"city": "Le Hanouard"},
    {"city": "Harcanville"},
    {"city": "Harfleur"},
    {"city": "Hattenville"},
    {"city": "Haucourt"},
    {"city": "Haudricourt"},
    {"city": "Haussez"},
    {"city": "Hautot-l'Auvray"},
    {"city": "Hautot-le-Vatois"},
    {"city": "Hautot-Saint-Sulpice"},
    {"city": "Hautot-sur-Mer"},
    {"city": "Hautot-sur-Seine"},
    {"city": "Le Havre"},
    {"city": "La Haye"},
    {"city": "Héberville"},
    {"city": "Hénouville"},
    {"city": "Héricourt-en-Caux"},
    {"city": "Hermanville"},
    {"city": "Hermeville"},
    {"city": "Le Héron"},
    {"city": "Héronchelles"},
    {"city": "Heugleville-sur-Scie"},
    {"city": "Heuqueville"},
    {"city": "Heurteauville"},
    {"city": "Hodeng-au-Bosc"},
    {"city": "Hodeng-Hodenger"},
    {"city": "Houdetot"},
    {"city": "Le Houlme"},
    {"city": "Houppeville"},
    {"city": "Houquetot"},
    {"city": "La Houssaye-Béranger"},
    {"city": "Hugleville-en-Caux"},
    {"city": "Les Ifs"},
    {"city": "Illois"},
    {"city": "Imbleville"},
    {"city": "Incheville"},
    {"city": "Ingouville"},
    {"city": "Isneauville"},
    {"city": "Jumièges"},
    {"city": "Lamberville"},
    {"city": "Lammerville"},
    {"city": "Landes-Vieilles-et-Neuves"},
    {"city": "Lanquetot"},
    {"city": "Lestanville"},
    {"city": "Lillebonne"},
    {"city": "Limésy"},
    {"city": "Limpiville"},
    {"city": "Lindebeuf"},
    {"city": "Lintot"},
    {"city": "Lintot-les-Bois"},
    {"city": "Les Loges"},
    {"city": "La Londe"},
    {"city": "Londinières"},
    {"city": "Longmesnil"},
    {"city": "Longroy"},
    {"city": "Longueil"},
    {"city": "Longuerue"},
    {"city": "Longueville-sur-Scie"},
    {"city": "Louvetot"},
    {"city": "Lucy"},
    {"city": "Luneray"},
    {"city": "Arelaune-en-Seine"},
    {"city": "Malaunay"},
    {"city": "Malleville-les-Grès"},
    {"city": "Manéglise"},
    {"city": "Manéhouville"},
    {"city": "Maniquerville"},
    {"city": "Manneville-ès-Plains"},
    {"city": "Manneville-la-Goupil"},
    {"city": "Mannevillette"},
    {"city": "Maromme"},
    {"city": "Marques"},
    {"city": "Martainville-Épreville"},
    {"city": "Martigny"},
    {"city": "Martin-Église"},
    {"city": "Massy"},
    {"city": "Mathonville"},
    {"city": "Maucomble"},
    {"city": "Maulévrier-Sainte-Gertrude"},
    {"city": "Mauny"},
    {"city": "Mauquenchy"},
    {"city": "Mélamare"},
    {"city": "Melleville"},
    {"city": "Ménerval"},
    {"city": "Ménonval"},
    {"city": "Mentheville"},
    {"city": "Mésangueville"},
    {"city": "Mesnières-en-Bray"},
    {"city": "Le Mesnil-Durdent"},
    {"city": "Le Mesnil-Esnard"},
    {"city": "Mesnil-Follemprise"},
    {"city": "Le Mesnil-Lieubray"},
    {"city": "Mesnil-Mauger"},
    {"city": "Mesnil-Panneville"},
    {"city": "Mesnil-Raoul"},
    {"city": "Le Mesnil-Réaume"},
    {"city": "Le Mesnil-sous-Jumièges"},
    {"city": "Meulers"},
    {"city": "Millebosc"},
    {"city": "Mirville"},
    {"city": "Molagnies"},
    {"city": "Monchaux-Soreng"},
    {"city": "Monchy-sur-Eu"},
    {"city": "Mont-Cauvaire"},
    {"city": "Montérolier"},
    {"city": "Montigny"},
    {"city": "Montivilliers"},
    {"city": "Montmain"},
    {"city": "Montreuil-en-Caux"},
    {"city": "Montroty"},
    {"city": "Mont-Saint-Aignan"},
    {"city": "Montville"},
    {"city": "Morgny-la-Pommeraye"},
    {"city": "Mortemer"},
    {"city": "Morville-sur-Andelle"},
    {"city": "Motteville"},
    {"city": "Moulineaux"},
    {"city": "Muchedent"},
    {"city": "Nesle-Hodeng"},
    {"city": "Nesle-Normandeuse"},
    {"city": "Neufbosc"},
    {"city": "Neufchâtel-en-Bray"},
    {"city": "Neuf-Marché"},
    {"city": "La Neuville-Chant-d'Oisel"},
    {"city": "Neuville-Ferrières"},
    {"city": "Néville"},
    {"city": "Nointot"},
    {"city": "Nolléval"},
    {"city": "Normanville"},
    {"city": "Norville"},
    {"city": "Notre-Dame-d'Aliermont"},
    {"city": "Notre-Dame-de-Bliquetuit"},
    {"city": "Notre-Dame-de-Bondeville"},
    {"city": "Franqueville-Saint-Pierre"},
    {"city": "Port-Jérôme-sur-Seine"},
    {"city": "Notre-Dame-du-Bec"},
    {"city": "Notre-Dame-du-Parc"},
    {"city": "Nullemont"},
    {"city": "Ocqueville"},
    {"city": "Octeville-sur-Mer"},
    {"city": "Offranville"},
    {"city": "Oherville"},
    {"city": "Oissel"},
    {"city": "Omonville"},
    {"city": "Orival"},
    {"city": "Osmoy-Saint-Valery"},
    {"city": "Ouainville"},
    {"city": "Oudalle"},
    {"city": "Ourville-en-Caux"},
    {"city": "Ouville-l'Abbaye"},
    {"city": "Ouville-la-Rivière"},
    {"city": "Paluel"},
    {"city": "Parc-d'Anxtot"},
    {"city": "Pavilly"},
    {"city": "Petit-Couronne"},
    {"city": "Le Petit-Quevilly"},
    {"city": "Petiville"},
    {"city": "Pierrecourt"},
    {"city": "Pierrefiques"},
    {"city": "Pierreval"},
    {"city": "Pissy-Pôville"},
    {"city": "Pleine-Sève"},
    {"city": "Pommereux"},
    {"city": "Pommeréval"},
    {"city": "Ponts-et-Marais"},
    {"city": "La Poterie-Cap-d'Antifer"},
    {"city": "Préaux"},
    {"city": "Prétot-Vicquemare"},
    {"city": "Preuseville"},
    {"city": "Puisenval"},
    {"city": "Quevillon"},
    {"city": "Quévreville-la-Poterie"},
    {"city": "Quiberville"},
    {"city": "Quièvrecourt"},
    {"city": "Quincampoix"},
    {"city": "Raffetot"},
    {"city": "Rainfreville"},
    {"city": "Réalcamp"},
    {"city": "Rebets"},
    {"city": "La Remuée"},
    {"city": "Rétonval"},
    {"city": "Reuville"},
    {"city": "Ricarville-du-Val"},
    {"city": "Richemont"},
    {"city": "Rieux"},
    {"city": "Riville"},
    {"city": "Robertot"},
    {"city": "Rocquefort"},
    {"city": "Rocquemont"},
    {"city": "Rogerville"},
    {"city": "Rolleville"},
    {"city": "Roncherolles-en-Bray"},
    {"city": "Roncherolles-sur-le-Vivier"},
    {"city": "Ronchois"},
    {"city": "Rosay"},
    {"city": "Rouen"},
    {"city": "Roumare"},
    {"city": "Routes"},
    {"city": "Rouville"},
    {"city": "Rouvray-Catillon"},
    {"city": "Rouxmesnil-Bouteilles"},
    {"city": "Royville"},
    {"city": "La Rue-Saint-Pierre"},
    {"city": "Ry"},
    {"city": "Saâne-Saint-Just"},
    {"city": "Sahurs"},
    {"city": "Sainneville"},
    {"city": "Sainte-Adresse"},
    {"city": "Sainte-Agathe-d'Aliermont"},
    {"city": "Saint-Aignan-sur-Ry"},
    {"city": "Saint-André-sur-Cailly"},
    {"city": "Saint-Antoine-la-Forêt"},
    {"city": "Saint-Arnoult"},
    {"city": "Saint-Aubin-Celloville"},
    {"city": "Saint-Aubin-de-Crétot"},
    {"city": "Saint-Aubin-Épinay"},
    {"city": "Saint-Aubin-lès-Elbeuf"},
    {"city": "Saint-Aubin-le-Cauf"},
    {"city": "Saint-Aubin-Routot"},
    {"city": "Saint-Aubin-sur-Mer"},
    {"city": "Saint-Aubin-sur-Scie"},
    {"city": "Sainte-Austreberthe"},
    {"city": "Sainte-Beuve-en-Rivière"},
    {"city": "Saint-Clair-sur-les-Monts"},
    {"city": "Sainte-Colombe"},
    {"city": "Saint-Crespin"},
    {"city": "Sainte-Croix-sur-Buchy"},
    {"city": "Saint-Denis-d'Aclon"},
    {"city": "Saint-Denis-le-Thiboult"},
    {"city": "Saint-Denis-sur-Scie"},
    {"city": "Saint-Étienne-du-Rouvray"},
    {"city": "Saint-Eustache-la-Forêt"},
    {"city": "Sainte-Foy"},
    {"city": "Sainte-Geneviève"},
    {"city": "Saint-Georges-sur-Fontaine"},
    {"city": "Saint-Germain-des-Essourts"},
    {"city": "Saint-Germain-d'Étables"},
    {"city": "Saint-Germain-sous-Cailly"},
    {"city": "Saint-Germain-sur-Eaulne"},
    {"city": "Saint-Gilles-de-Crétot"},
    {"city": "Saint-Gilles-de-la-Neuville"},
    {"city": "Sainte-Hélène-Bondeville"},
    {"city": "Saint-Hellier"},
    {"city": "Saint-Honoré"},
    {"city": "Saint-Jacques-d'Aliermont"},
    {"city": "Saint-Jacques-sur-Darnétal"},
    {"city": "Saint-Jean-de-Folleville"},
    {"city": "Saint-Jean-de-la-Neuville"},
    {"city": "Saint-Jean-du-Cardonnay"},
    {"city": "Saint-Jouin-Bruneval"},
    {"city": "Saint-Laurent-de-Brèvedent"},
    {"city": "Saint-Laurent-en-Caux"},
    {"city": "Saint-Léger-aux-Bois"},
    {"city": "Saint-Léger-du-Bourg-Denis"},
    {"city": "Saint-Léonard"},
    {"city": "Saint-Lucien"},
    {"city": "Saint-Maclou-de-Folleville"},
    {"city": "Saint-Maclou-la-Brière"},
    {"city": "Saint-Mards"},
    {"city": "Sainte-Marguerite-sur-Mer"},
    {"city": "Morienne"},
    {"city": "Sainte-Marguerite-sur-Duclair"},
    {"city": "Sainte-Marie-au-Bosc"},
    {"city": "Sainte-Marie-des-Champs"},
    {"city": "Saint-Martin-aux-Arbres"},
    {"city": "Saint-Martin-au-Bosc"},
    {"city": "Saint-Martin-aux-Buneaux"},
    {"city": "Saint-Martin-de-Boscherville"},
    {"city": "Saint-Martin-du-Bec"},
    {"city": "Saint-Martin-du-Manoir"},
    {"city": "Saint-Martin-du-Vivier"},
    {"city": "Petit-Caux"},
    {"city": "Saint-Martin-le-Gaillard"},
    {"city": "Saint-Martin-l'Hortier"},
    {"city": "Saint-Martin-Osmonville"},
    {"city": "Saint-Maurice-d'Ételan"},
    {"city": "Saint-Michel-d'Halescourt"},
    {"city": "Saint-Nicolas-d'Aliermont"},
    {"city": "Saint-Nicolas-de-la-Haie"},
    {"city": "Saint-Nicolas-de-la-Taille"},
    {"city": "Saint-Ouen-du-Breuil"},
    {"city": "Saint-Ouen-le-Mauger"},
    {"city": "Saint-Ouen-sous-Bailly"},
    {"city": "Saint-Paër"},
    {"city": "Saint-Pierre-Bénouville"},
    {"city": "Saint-Pierre-de-Manneville"},
    {"city": "Saint-Pierre-des-Jonquières"},
    {"city": "Saint-Pierre-de-Varengeville"},
    {"city": "Saint-Pierre-en-Port"},
    {"city": "Saint-Pierre-en-Val"},
    {"city": "Saint-Pierre-lès-Elbeuf"},
    {"city": "Saint-Pierre-le-Vieux"},
    {"city": "Saint-Pierre-le-Viger"},
    {"city": "Saint-Rémy-Boscrocourt"},
    {"city": "Saint-Riquier-en-Rivière"},
    {"city": "Saint-Riquier-ès-Plains"},
    {"city": "Saint-Romain-de-Colbosc"},
    {"city": "Saint-Saëns"},
    {"city": "Saint-Saire"},
    {"city": "Saint-Sauveur-d'Émalleville"},
    {"city": "Saint-Sylvain"},
    {"city": "Saint-Vaast-d'Équiqueville"},
    {"city": "Saint-Vaast-Dieppedalle"},
    {"city": "Saint-Vaast-du-Val"},
    {"city": "Saint-Valery-en-Caux"},
    {"city": "Saint-Victor-l'Abbaye"},
    {"city": "Saint-Vigor-d'Ymonville"},
    {"city": "Saint-Vincent-Cramesnil"},
    {"city": "Sandouville"},
    {"city": "Sassetot-le-Malgardé"},
    {"city": "Sassetot-le-Mauconduit"},
    {"city": "Sasseville"},
    {"city": "Sauchay"},
    {"city": "Saumont-la-Poterie"},
    {"city": "Sauqueville"},
    {"city": "Saussay"},
    {"city": "Sausseuzemare-en-Caux"},
    {"city": "Senneville-sur-Fécamp"},
    {"city": "Sept-Meules"},
    {"city": "Serqueux"},
    {"city": "Servaville-Salmonville"},
    {"city": "Sierville"},
    {"city": "Sigy-en-Bray"},
    {"city": "Smermesnil"},
    {"city": "Sommery"},
    {"city": "Sommesnil"},
    {"city": "Sorquainville"},
    {"city": "Sotteville-lès-Rouen"},
    {"city": "Sotteville-sous-le-Val"},
    {"city": "Sotteville-sur-Mer"},
    {"city": "Tancarville"},
    {"city": "Thérouldeville"},
    {"city": "Theuville-aux-Maillots"},
    {"city": "Thiergeville"},
    {"city": "Thiétreville"},
    {"city": "Thil-Manneville"},
    {"city": "Le Thil-Riberpré"},
    {"city": "Thiouville"},
    {"city": "Le Tilleul"},
    {"city": "Tocqueville-en-Caux"},
    {"city": "Tocqueville-les-Murs"},
    {"city": "Torcy-le-Grand"},
    {"city": "Torcy-le-Petit"},
    {"city": "Le Torp-Mesnil"},
    {"city": "Tôtes"},
    {"city": "Touffreville-la-Corbeline"},
    {"city": "Touffreville-sur-Eu"},
    {"city": "Tourville-la-Rivière"},
    {"city": "Tourville-les-Ifs"},
    {"city": "Tourville-sur-Arques"},
    {"city": "Toussaint"},
    {"city": "Le Trait"},
    {"city": "Trémauville"},
    {"city": "Le Tréport"},
    {"city": "La Trinité-du-Mont"},
    {"city": "Les Trois-Pierres"},
    {"city": "Trouville"},
    {"city": "Turretot"},
    {"city": "Val-de-la-Haye"},
    {"city": "Valliquerville"},
    {"city": "Valmont"},
    {"city": "Varengeville-sur-Mer"},
    {"city": "Varneville-Bretteville"},
    {"city": "Vassonville"},
    {"city": "Vatierville"},
    {"city": "Vattetot-sous-Beaumont"},
    {"city": "Vattetot-sur-Mer"},
    {"city": "Vatteville-la-Rue"},
    {"city": "La Vaupalière"},
    {"city": "Veauville-lès-Quelles"},
    {"city": "Vénestanville"},
    {"city": "Butot-Vénesville"},
    {"city": "Ventes-Saint-Rémy"},
    {"city": "Vergetot"},
    {"city": "Veules-les-Roses"},
    {"city": "Veulettes-sur-Mer"},
    {"city": "Vibeuf"},
    {"city": "Vieux-Manoir"},
    {"city": "Vieux-Rouen-sur-Bresle"},
    {"city": "La Vieux-Rue"},
    {"city": "Villainville"},
    {"city": "Villers-Écalles"},
    {"city": "Villers-sous-Foucarmont"},
    {"city": "Villy-sur-Yères"},
    {"city": "Vinnemerville"},
    {"city": "Virville"},
    {"city": "Vittefleur"},
    {"city": "Wanchy-Capval"},
    {"city": "Yainville"},
    {"city": "Yébleron"},
    {"city": "Yerville"},
    {"city": "Ymare"},
    {"city": "Yport"},
    {"city": "Ypreville-Biville"},
    {"city": "Yquebeuf"},
    {"city": "Yvecrique"},
    {"city": "Yvetot"},
    {"city": "Yville-sur-Seine"},
    {"city": "Achères-la-Forêt"},
    {"city": "Amillis"},
    {"city": "Amponville"},
    {"city": "Andrezel"},
    {"city": "Annet-sur-Marne"},
    {"city": "Arbonne-la-Forêt"},
    {"city": "Argentières"},
    {"city": "Armentières-en-Brie"},
    {"city": "Arville"},
    {"city": "Aubepierre-Ozouer-le-Repos"},
    {"city": "Aufferville"},
    {"city": "Augers-en-Brie"},
    {"city": "Aulnoy"},
    {"city": "Avon"},
    {"city": "Baby"},
    {"city": "Bagneaux-sur-Loing"},
    {"city": "Bailly-Romainvilliers"},
    {"city": "Balloy"},
    {"city": "Bannost-Villegagnon"},
    {"city": "Barbey"},
    {"city": "Barbizon"},
    {"city": "Barcy"},
    {"city": "Bassevelle"},
    {"city": "Bazoches-lès-Bray"},
    {"city": "Beauchery-Saint-Martin"},
    {"city": "Beaumont-du-Gâtinais"},
    {"city": "Beauvoir"},
    {"city": "Bellot"},
    {"city": "Bernay-Vilbert"},
    {"city": "Beton-Bazoches"},
    {"city": "Bezalles"},
    {"city": "Blandy"},
    {"city": "Blennes"},
    {"city": "Boisdon"},
    {"city": "Bois-le-Roi"},
    {"city": "Boissettes"},
    {"city": "Boissise-la-Bertrand"},
    {"city": "Boissise-le-Roi"},
    {"city": "Boissy-aux-Cailles"},
    {"city": "Boissy-le-Châtel"},
    {"city": "Boitron"},
    {"city": "Bombon"},
    {"city": "Bougligny"},
    {"city": "Boulancourt"},
    {"city": "Bouleurs"},
    {"city": "Bourron-Marlotte"},
    {"city": "Boutigny"},
    {"city": "Bransles"},
    {"city": "Bray-sur-Seine"},
    {"city": "Bréau"},
    {"city": "Brie-Comte-Robert"},
    {"city": "La Brosse-Montceaux"},
    {"city": "Brou-sur-Chantereine"},
    {"city": "Burcy"},
    {"city": "Bussières"},
    {"city": "Bussy-Saint-Georges"},
    {"city": "Bussy-Saint-Martin"},
    {"city": "Buthiers"},
    {"city": "Cannes-Écluse"},
    {"city": "Carnetin"},
    {"city": "La Celle-sur-Morin"},
    {"city": "Cély"},
    {"city": "Cerneux"},
    {"city": "Cesson"},
    {"city": "Cessoy-en-Montois"},
    {"city": "Chailly-en-Bière"},
    {"city": "Chailly-en-Brie"},
    {"city": "Chaintreaux"},
    {"city": "Chalautre-la-Grande"},
    {"city": "Chalautre-la-Petite"},
    {"city": "Chalifert"},
    {"city": "Chalmaison"},
    {"city": "Chambry"},
    {"city": "Chamigny"},
    {"city": "Champagne-sur-Seine"},
    {"city": "Champcenest"},
    {"city": "Champdeuil"},
    {"city": "Champeaux"},
    {"city": "Champs-sur-Marne"},
    {"city": "Changis-sur-Marne"},
    {"city": "Chanteloup-en-Brie"},
    {"city": "La Chapelle-Gauthier"},
    {"city": "La Chapelle-Iger"},
    {"city": "La Chapelle-la-Reine"},
    {"city": "La Chapelle-Rablais"},
    {"city": "La Chapelle-Saint-Sulpice"},
    {"city": "Les Chapelles-Bourbon"},
    {"city": "La Chapelle-Moutils"},
    {"city": "Charmentray"},
    {"city": "Charny"},
    {"city": "Chartrettes"},
    {"city": "Chartronges"},
    {"city": "Châteaubleau"},
    {"city": "Château-Landon"},
    {"city": "Le Châtelet-en-Brie"},
    {"city": "Châtenay-sur-Seine"},
    {"city": "Châtenoy"},
    {"city": "Châtillon-la-Borde"},
    {"city": "Châtres"},
    {"city": "Chauffry"},
    {"city": "Chaumes-en-Brie"},
    {"city": "Chelles"},
    {"city": "Chenoise-Cucharmoy"},
    {"city": "Chenou"},
    {"city": "Chessy"},
    {"city": "Chevrainvilliers"},
    {"city": "Chevru"},
    {"city": "Chevry-Cossigny"},
    {"city": "Chevry-en-Sereine"},
    {"city": "Choisy-en-Brie"},
    {"city": "Citry"},
    {"city": "Claye-Souilly"},
    {"city": "Clos-Fontaine"},
    {"city": "Cocherel"},
    {"city": "Collégien"},
    {"city": "Combs-la-Ville"},
    {"city": "Compans"},
    {"city": "Conches-sur-Gondoire"},
    {"city": "Condé-Sainte-Libiaire"},
    {"city": "Congis-sur-Thérouanne"},
    {"city": "Coubert"},
    {"city": "Couilly-Pont-aux-Dames"},
    {"city": "Coulombs-en-Valois"},
    {"city": "Coulommes"},
    {"city": "Coulommiers"},
    {"city": "Coupvray"},
    {"city": "Courcelles-en-Bassée"},
    {"city": "Courchamp"},
    {"city": "Courpalay"},
    {"city": "Courquetaine"},
    {"city": "Courtacon"},
    {"city": "Courtomer"},
    {"city": "Courtry"},
    {"city": "Coutençon"},
    {"city": "Coutevroult"},
    {"city": "Crécy-la-Chapelle"},
    {"city": "Crégy-lès-Meaux"},
    {"city": "Crèvecœur-en-Brie"},
    {"city": "Crisenoy"},
    {"city": "Croissy-Beaubourg"},
    {"city": "La Croix-en-Brie"},
    {"city": "Crouy-sur-Ourcq"},
    {"city": "Cuisy"},
    {"city": "Dagny"},
    {"city": "Dammarie-les-Lys"},
    {"city": "Dammartin-en-Goële"},
    {"city": "Dammartin-sur-Tigeaux"},
    {"city": "Dampmart"},
    {"city": "Darvault"},
    {"city": "Dhuisy"},
    {"city": "Diant"},
    {"city": "Donnemarie-Dontilly"},
    {"city": "Dormelles"},
    {"city": "Doue"},
    {"city": "Douy-la-Ramée"},
    {"city": "Échouboulains"},
    {"city": "Les Écrennes"},
    {"city": "Égligny"},
    {"city": "Égreville"},
    {"city": "Émerainville"},
    {"city": "Esbly"},
    {"city": "Esmans"},
    {"city": "Étrépilly"},
    {"city": "Everly"},
    {"city": "Évry-Grégy-sur-Yerre"},
    {"city": "Faremoutiers"},
    {"city": "Favières"},
    {"city": "Faÿ-lès-Nemours"},
    {"city": "Féricy"},
    {"city": "Férolles-Attilly"},
    {"city": "Ferrières-en-Brie"},
    {"city": "La Ferté-Gaucher"},
    {"city": "La Ferté-sous-Jouarre"},
    {"city": "Flagy"},
    {"city": "Fleury-en-Bière"},
    {"city": "Fontainebleau"},
    {"city": "Fontaine-Fourches"},
    {"city": "Fontaine-le-Port"},
    {"city": "Fontains"},
    {"city": "Fontenailles"},
    {"city": "Fontenay-Trésigny"},
    {"city": "Forfry"},
    {"city": "Forges"},
    {"city": "Fouju"},
    {"city": "Fresnes-sur-Marne"},
    {"city": "Frétoy"},
    {"city": "Fromont"},
    {"city": "Fublaines"},
    {"city": "Garentreville"},
    {"city": "Gastins"},
    {"city": "La Genevraye"},
    {"city": "Germigny-l'Évêque"},
    {"city": "Germigny-sous-Coulombs"},
    {"city": "Gesvres-le-Chapitre"},
    {"city": "Giremoutiers"},
    {"city": "Gironville"},
    {"city": "Gouaix"},
    {"city": "Gouvernes"},
    {"city": "La Grande-Paroisse"},
    {"city": "Grandpuits-Bailly-Carrois"},
    {"city": "Gravon"},
    {"city": "Gressy"},
    {"city": "Gretz-Armainvilliers"},
    {"city": "Grez-sur-Loing"},
    {"city": "Grisy-Suisnes"},
    {"city": "Grisy-sur-Seine"},
    {"city": "Guérard"},
    {"city": "Guercheville"},
    {"city": "Guermantes"},
    {"city": "Guignes"},
    {"city": "Gurcy-le-Châtel"},
    {"city": "Hautefeuille"},
    {"city": "La Haute-Maison"},
    {"city": "Héricy"},
    {"city": "Hermé"},
    {"city": "Hondevilliers"},
    {"city": "La Houssaye-en-Brie"},
    {"city": "Ichy"},
    {"city": "Isles-les-Meldeuses"},
    {"city": "Isles-lès-Villenoy"},
    {"city": "Iverny"},
    {"city": "Jablines"},
    {"city": "Jaignes"},
    {"city": "Jaulnes"},
    {"city": "Jossigny"},
    {"city": "Jouarre"},
    {"city": "Jouy-le-Châtel"},
    {"city": "Jouy-sur-Morin"},
    {"city": "Juilly"},
    {"city": "Jutigny"},
    {"city": "Lagny-sur-Marne"},
    {"city": "Larchant"},
    {"city": "Laval-en-Brie"},
    {"city": "Léchelle"},
    {"city": "Lescherolles"},
    {"city": "Lesches"},
    {"city": "Lésigny"},
    {"city": "Leudon-en-Brie"},
    {"city": "Lieusaint"},
    {"city": "Limoges-Fourches"},
    {"city": "Lissy"},
    {"city": "Liverdy-en-Brie"},
    {"city": "Livry-sur-Seine"},
    {"city": "Lizines"},
    {"city": "Lizy-sur-Ourcq"},
    {"city": "Lognes"},
    {"city": "Longperrier"},
    {"city": "Longueville"},
    {"city": "Lorrez-le-Bocage-Préaux"},
    {"city": "Louan-Villegruis-Fontaine"},
    {"city": "Luisetaines"},
    {"city": "Lumigny-Nesles-Ormeaux"},
    {"city": "Luzancy"},
    {"city": "Machault"},
    {"city": "La Madeleine-sur-Loing"},
    {"city": "Magny-le-Hongre"},
    {"city": "Maincy"},
    {"city": "Maisoncelles-en-Brie"},
    {"city": "Maisoncelles-en-Gâtinais"},
    {"city": "Maison-Rouge"},
    {"city": "Marchémoret"},
    {"city": "Marcilly"},
    {"city": "Les Marêts"},
    {"city": "Mareuil-lès-Meaux"},
    {"city": "Marles-en-Brie"},
    {"city": "Marolles-en-Brie"},
    {"city": "Marolles-sur-Seine"},
    {"city": "Mary-sur-Marne"},
    {"city": "Mauperthuis"},
    {"city": "Mauregard"},
    {"city": "May-en-Multien"},
    {"city": "Meaux"},
    {"city": "Le Mée-sur-Seine"},
    {"city": "Meigneux"},
    {"city": "Meilleray"},
    {"city": "Melun"},
    {"city": "Melz-sur-Seine"},
    {"city": "Méry-sur-Marne"},
    {"city": "Le Mesnil-Amelot"},
    {"city": "Messy"},
    {"city": "Misy-sur-Yonne"},
    {"city": "Mitry-Mory"},
    {"city": "Moisenay"},
    {"city": "Moissy-Cramayel"},
    {"city": "Mondreville"},
    {"city": "Mons-en-Montois"},
    {"city": "Montceaux-lès-Meaux"},
    {"city": "Montceaux-lès-Provins"},
    {"city": "Montcourt-Fromonville"},
    {"city": "Montdauphin"},
    {"city": "Montenils"},
    {"city": "Montereau-Fault-Yonne"},
    {"city": "Montereau-sur-le-Jard"},
    {"city": "Montévrain"},
    {"city": "Montgé-en-Goële"},
    {"city": "Monthyon"},
    {"city": "Montigny-le-Guesdier"},
    {"city": "Montigny-Lencoup"},
    {"city": "Montigny-sur-Loing"},
    {"city": "Montmachoux"},
    {"city": "Montolivet"},
    {"city": "Montry"},
    {"city": "Moret-Loing-et-Orvanne"},
    {"city": "Mormant"},
    {"city": "Mortcerf"},
    {"city": "Mortery"},
    {"city": "Mouroux"},
    {"city": "Mousseaux-lès-Bray"},
    {"city": "Moussy-le-Neuf"},
    {"city": "Moussy-le-Vieux"},
    {"city": "Mouy-sur-Seine"},
    {"city": "Nandy"},
    {"city": "Nangis"},
    {"city": "Nanteau-sur-Essonne"},
    {"city": "Nanteau-sur-Lunain"},
    {"city": "Nanteuil-lès-Meaux"},
    {"city": "Nanteuil-sur-Marne"},
    {"city": "Nantouillet"},
    {"city": "Nemours"},
    {"city": "Chauconin-Neufmontiers"},
    {"city": "Neufmoutiers-en-Brie"},
    {"city": "Noisiel"},
    {"city": "Noisy-Rudignon"},
    {"city": "Noisy-sur-École"},
    {"city": "Nonville"},
    {"city": "Noyen-sur-Seine"},
    {"city": "Obsonville"},
    {"city": "Ocquerre"},
    {"city": "Oissery"},
    {"city": "Orly-sur-Morin"},
    {"city": "Les Ormes-sur-Voulzie"},
    {"city": "Ormesson"},
    {"city": "Othis"},
    {"city": "Ozoir-la-Ferrière"},
    {"city": "Ozouer-le-Voulgis"},
    {"city": "Paley"},
    {"city": "Pamfou"},
    {"city": "Paroy"},
    {"city": "Passy-sur-Seine"},
    {"city": "Pécy"},
    {"city": "Penchard"},
    {"city": "Perthes"},
    {"city": "Pézarches"},
    {"city": "Pierre-Levée"},
    {"city": "Le Pin"},
    {"city": "Le Plessis-aux-Bois"},
    {"city": "Le Plessis-Feu-Aussoux"},
    {"city": "Le Plessis-l'Évêque"},
    {"city": "Le Plessis-Placy"},
    {"city": "Poigny"},
    {"city": "Poincy"},
    {"city": "Poligny"},
    {"city": "Pommeuse"},
    {"city": "Pomponne"},
    {"city": "Pontault-Combault"},
    {"city": "Pontcarré"},
    {"city": "Précy-sur-Marne"},
    {"city": "Presles-en-Brie"},
    {"city": "Pringy"},
    {"city": "Provins"},
    {"city": "Puisieux"},
    {"city": "Quiers"},
    {"city": "Quincy-Voisins"},
    {"city": "Rampillon"},
    {"city": "Réau"},
    {"city": "Rebais"},
    {"city": "Recloses"},
    {"city": "Remauville"},
    {"city": "Reuil-en-Brie"},
    {"city": "La Rochette"},
    {"city": "Roissy-en-Brie"},
    {"city": "Rouilly"},
    {"city": "Rouvres"},
    {"city": "Rozay-en-Brie"},
    {"city": "Rubelles"},
    {"city": "Rumont"},
    {"city": "Rupéreux"},
    {"city": "Saâcy-sur-Marne"},
    {"city": "Sablonnières"},
    {"city": "Saint-Augustin"},
    {"city": "Sainte-Aulde"},
    {"city": "Saint-Barthélemy"},
    {"city": "Saint-Brice"},
    {"city": "Sainte-Colombe"},
    {"city": "Saint-Cyr-sur-Morin"},
    {"city": "Saint-Denis-lès-Rebais"},
    {"city": "Saint-Fargeau-Ponthierry"},
    {"city": "Saint-Fiacre"},
    {"city": "Saint-Germain-Laval"},
    {"city": "Saint-Germain-Laxis"},
    {"city": "Saint-Germain-sous-Doue"},
    {"city": "Saint-Germain-sur-École"},
    {"city": "Saint-Germain-sur-Morin"},
    {"city": "Saint-Hilliers"},
    {"city": "Saint-Jean-les-Deux-Jumeaux"},
    {"city": "Saint-Just-en-Brie"},
    {"city": "Saint-Léger"},
    {"city": "Saint-Loup-de-Naud"},
    {"city": "Saint-Mammès"},
    {"city": "Saint-Mard"},
    {"city": "Saint-Mars-Vieux-Maisons"},
    {"city": "Saint-Martin-des-Champs"},
    {"city": "Saint-Martin-du-Boschet"},
    {"city": "Saint-Martin-en-Bière"},
    {"city": "Saint-Méry"},
    {"city": "Saint-Mesmes"},
    {"city": "Saint-Ouen-en-Brie"},
    {"city": "Saint-Ouen-sur-Morin"},
    {"city": "Saint-Pathus"},
    {"city": "Saint-Pierre-lès-Nemours"},
    {"city": "Saint-Rémy-la-Vanne"},
    {"city": "Beautheil-Saints"},
    {"city": "Saint-Sauveur-lès-Bray"},
    {"city": "Saint-Sauveur-sur-École"},
    {"city": "Saint-Siméon"},
    {"city": "Saint-Soupplets"},
    {"city": "Saint-Thibault-des-Vignes"},
    {"city": "Salins"},
    {"city": "Sammeron"},
    {"city": "Samois-sur-Seine"},
    {"city": "Samoreau"},
    {"city": "Sancy"},
    {"city": "Sancy-lès-Provins"},
    {"city": "Savigny-le-Temple"},
    {"city": "Savins"},
    {"city": "Seine-Port"},
    {"city": "Sept-Sorts"},
    {"city": "Serris"},
    {"city": "Servon"},
    {"city": "Signy-Signets"},
    {"city": "Sigy"},
    {"city": "Sivry-Courtry"},
    {"city": "Sognolles-en-Montois"},
    {"city": "Soignolles-en-Brie"},
    {"city": "Soisy-Bouy"},
    {"city": "Solers"},
    {"city": "Souppes-sur-Loing"},
    {"city": "Sourdun"},
    {"city": "Tancrou"},
    {"city": "Thénisy"},
    {"city": "Thieux"},
    {"city": "Thomery"},
    {"city": "Thorigny-sur-Marne"},
    {"city": "Thoury-Férottes"},
    {"city": "Tigeaux"},
    {"city": "La Tombe"},
    {"city": "Torcy"},
    {"city": "Touquin"},
    {"city": "Tournan-en-Brie"},
    {"city": "Tousson"},
    {"city": "La Trétoire"},
    {"city": "Treuzy-Levelay"},
    {"city": "Trilbardou"},
    {"city": "Trilport"},
    {"city": "Trocy-en-Multien"},
    {"city": "Ury"},
    {"city": "Ussy-sur-Marne"},
    {"city": "Vaires-sur-Marne"},
    {"city": "Valence-en-Brie"},
    {"city": "Vanvillé"},
    {"city": "Varennes-sur-Seine"},
    {"city": "Varreddes"},
    {"city": "Vaucourtois"},
    {"city": "Le Vaudoué"},
    {"city": "Vaudoy-en-Brie"},
    {"city": "Vaux-le-Pénil"},
    {"city": "Vaux-sur-Lunain"},
    {"city": "Vendrest"},
    {"city": "Verdelot"},
    {"city": "Verneuil-l'Étang"},
    {"city": "Vernou-la-Celle-sur-Seine"},
    {"city": "Vert-Saint-Denis"},
    {"city": "Vieux-Champagne"},
    {"city": "Vignely"},
    {"city": "Villebéon"},
    {"city": "Villecerf"},
    {"city": "Villemaréchal"},
    {"city": "Villemareuil"},
    {"city": "Villemer"},
    {"city": "Villenauxe-la-Petite"},
    {"city": "Villeneuve-le-Comte"},
    {"city": "Villeneuve-les-Bordes"},
    {"city": "Villeneuve-Saint-Denis"},
    {"city": "Villeneuve-sous-Dammartin"},
    {"city": "Villeneuve-sur-Bellot"},
    {"city": "Villenoy"},
    {"city": "Villeparisis"},
    {"city": "Villeroy"},
    {"city": "Ville-Saint-Jacques"},
    {"city": "Villevaudé"},
    {"city": "Villiers-en-Bière"},
    {"city": "Villiers-Saint-Georges"},
    {"city": "Villiers-sous-Grez"},
    {"city": "Villiers-sur-Morin"},
    {"city": "Villiers-sur-Seine"},
    {"city": "Villuis"},
    {"city": "Vimpelles"},
    {"city": "Vinantes"},
    {"city": "Vincy-Manœuvre"},
    {"city": "Voinsles"},
    {"city": "Voisenon"},
    {"city": "Voulangis"},
    {"city": "Voulton"},
    {"city": "Voulx"},
    {"city": "Vulaines-lès-Provins"},
    {"city": "Vulaines-sur-Seine"},
    {"city": "Yèbles"},
    {"city": "Ablis"},
    {"city": "Achères"},
    {"city": "Adainville"},
    {"city": "Aigremont"},
    {"city": "Allainville"},
    {"city": "Les Alluets-le-Roi"},
    {"city": "Andelu"},
    {"city": "Andrésy"},
    {"city": "Arnouville-lès-Mantes"},
    {"city": "Aubergenville"},
    {"city": "Auffargis"},
    {"city": "Auffreville-Brasseuil"},
    {"city": "Aulnay-sur-Mauldre"},
    {"city": "Auteuil"},
    {"city": "Autouillet"},
    {"city": "Bailly"},
    {"city": "Bazainville"},
    {"city": "Bazemont"},
    {"city": "Bazoches-sur-Guyonne"},
    {"city": "Béhoust"},
    {"city": "Bennecourt"},
    {"city": "Beynes"},
    {"city": "Blaru"},
    {"city": "Boinville-en-Mantois"},
    {"city": "Boinville-le-Gaillard"},
    {"city": "Boinvilliers"},
    {"city": "Bois-d'Arcy"},
    {"city": "Boissets"},
    {"city": "La Boissière-École"},
    {"city": "Boissy-Mauvoisin"},
    {"city": "Boissy-sans-Avoir"},
    {"city": "Bonnelles"},
    {"city": "Bonnières-sur-Seine"},
    {"city": "Bouafle"},
    {"city": "Bougival"},
    {"city": "Bourdonné"},
    {"city": "Breuil-Bois-Robert"},
    {"city": "Bréval"},
    {"city": "Les Bréviaires"},
    {"city": "Brueil-en-Vexin"},
    {"city": "Buc"},
    {"city": "Buchelay"},
    {"city": "Bullion"},
    {"city": "Carrières-sous-Poissy"},
    {"city": "Carrières-sur-Seine"},
    {"city": "La Celle-les-Bordes"},
    {"city": "La Celle-Saint-Cloud"},
    {"city": "Cernay-la-Ville"},
    {"city": "Chambourcy"},
    {"city": "Chanteloup-les-Vignes"},
    {"city": "Chapet"},
    {"city": "Châteaufort"},
    {"city": "Chatou"},
    {"city": "Chaufour-lès-Bonnières"},
    {"city": "Chavenay"},
    {"city": "Le Chesnay-Rocquencourt"},
    {"city": "Chevreuse"},
    {"city": "Choisel"},
    {"city": "Civry-la-Forêt"},
    {"city": "Clairefontaine-en-Yvelines"},
    {"city": "Les Clayes-sous-Bois"},
    {"city": "Coignières"},
    {"city": "Condé-sur-Vesgre"},
    {"city": "Conflans-Sainte-Honorine"},
    {"city": "Courgent"},
    {"city": "Cravent"},
    {"city": "Crespières"},
    {"city": "Croissy-sur-Seine"},
    {"city": "Dammartin-en-Serve"},
    {"city": "Dampierre-en-Yvelines"},
    {"city": "Dannemarie"},
    {"city": "Davron"},
    {"city": "Drocourt"},
    {"city": "Ecquevilly"},
    {"city": "Élancourt"},
    {"city": "Émancé"},
    {"city": "Épône"},
    {"city": "Les Essarts-le-Roi"},
    {"city": "L'Étang-la-Ville"},
    {"city": "Évecquemont"},
    {"city": "La Falaise"},
    {"city": "Favrieux"},
    {"city": "Feucherolles"},
    {"city": "Flacourt"},
    {"city": "Flexanville"},
    {"city": "Flins-Neuve-Église"},
    {"city": "Flins-sur-Seine"},
    {"city": "Follainville-Dennemont"},
    {"city": "Fontenay-le-Fleury"},
    {"city": "Fontenay-Mauvoisin"},
    {"city": "Fontenay-Saint-Père"},
    {"city": "Freneuse"},
    {"city": "Gaillon-sur-Montcient"},
    {"city": "Galluis"},
    {"city": "Gambais"},
    {"city": "Gambaiseuil"},
    {"city": "Garancières"},
    {"city": "Gargenville"},
    {"city": "Gazeran"},
    {"city": "Gommecourt"},
    {"city": "Goupillières"},
    {"city": "Goussonville"},
    {"city": "Grandchamp"},
    {"city": "Gressey"},
    {"city": "Grosrouvre"},
    {"city": "Guernes"},
    {"city": "Guerville"},
    {"city": "Guitrancourt"},
    {"city": "Guyancourt"},
    {"city": "Hardricourt"},
    {"city": "Hargeville"},
    {"city": "La Hauteville"},
    {"city": "Herbeville"},
    {"city": "Hermeray"},
    {"city": "Houdan"},
    {"city": "Houilles"},
    {"city": "Issou"},
    {"city": "Jambville"},
    {"city": "Notre-Dame-de-la-Mer"},
    {"city": "Jouars-Pontchartrain"},
    {"city": "Jouy-en-Josas"},
    {"city": "Jouy-Mauvoisin"},
    {"city": "Jumeauville"},
    {"city": "Juziers"},
    {"city": "Lainville-en-Vexin"},
    {"city": "Lévis-Saint-Nom"},
    {"city": "Limay"},
    {"city": "Limetz-Villez"},
    {"city": "Les Loges-en-Josas"},
    {"city": "Lommoye"},
    {"city": "Longnes"},
    {"city": "Longvilliers"},
    {"city": "Louveciennes"},
    {"city": "Magnanville"},
    {"city": "Magny-les-Hameaux"},
    {"city": "Maisons-Laffitte"},
    {"city": "Mantes-la-Jolie"},
    {"city": "Mantes-la-Ville"},
    {"city": "Marcq"},
    {"city": "Mareil-le-Guyon"},
    {"city": "Mareil-Marly"},
    {"city": "Mareil-sur-Mauldre"},
    {"city": "Marly-le-Roi"},
    {"city": "Maule"},
    {"city": "Maulette"},
    {"city": "Maurecourt"},
    {"city": "Maurepas"},
    {"city": "Médan"},
    {"city": "Ménerville"},
    {"city": "Méré"},
    {"city": "Méricourt"},
    {"city": "Le Mesnil-le-Roi"},
    {"city": "Le Mesnil-Saint-Denis"},
    {"city": "Les Mesnuls"},
    {"city": "Meulan-en-Yvelines"},
    {"city": "Mézières-sur-Seine"},
    {"city": "Mézy-sur-Seine"},
    {"city": "Millemont"},
    {"city": "Milon-la-Chapelle"},
    {"city": "Mittainville"},
    {"city": "Moisson"},
    {"city": "Mondreville"},
    {"city": "Montainville"},
    {"city": "Montalet-le-Bois"},
    {"city": "Montchauvet"},
    {"city": "Montesson"},
    {"city": "Montfort-l'Amaury"},
    {"city": "Montigny-le-Bretonneux"},
    {"city": "Morainvilliers"},
    {"city": "Mousseaux-sur-Seine"},
    {"city": "Mulcent"},
    {"city": "Les Mureaux"},
    {"city": "Neauphle-le-Château"},
    {"city": "Neauphle-le-Vieux"},
    {"city": "Neauphlette"},
    {"city": "Nézel"},
    {"city": "Noisy-le-Roi"},
    {"city": "Oinville-sur-Montcient"},
    {"city": "Orcemont"},
    {"city": "Orgerus"},
    {"city": "Orgeval"},
    {"city": "Orphin"},
    {"city": "Orsonville"},
    {"city": "Orvilliers"},
    {"city": "Osmoy"},
    {"city": "Paray-Douaville"},
    {"city": "Le Pecq"},
    {"city": "Perdreauville"},
    {"city": "Le Perray-en-Yvelines"},
    {"city": "Plaisir"},
    {"city": "Poigny-la-Forêt"},
    {"city": "Poissy"},
    {"city": "Ponthévrard"},
    {"city": "Porcheville"},
    {"city": "Le Port-Marly"},
    {"city": "Prunay-le-Temple"},
    {"city": "Prunay-en-Yvelines"},
    {"city": "La Queue-les-Yvelines"},
    {"city": "Raizeux"},
    {"city": "Rambouillet"},
    {"city": "Rennemoulin"},
    {"city": "Richebourg"},
    {"city": "Rochefort-en-Yvelines"},
    {"city": "Rolleboise"},
    {"city": "Rosay"},
    {"city": "Rosny-sur-Seine"},
    {"city": "Sailly"},
    {"city": "Saint-Arnoult-en-Yvelines"},
    {"city": "Saint-Cyr-l'École"},
    {"city": "Saint-Forget"},
    {"city": "Saint-Germain-de-la-Grange"},
    {"city": "Saint-Germain-en-Laye"},
    {"city": "Saint-Hilarion"},
    {"city": "Saint-Illiers-la-Ville"},
    {"city": "Saint-Illiers-le-Bois"},
    {"city": "Saint-Lambert"},
    {"city": "Saint-Léger-en-Yvelines"},
    {"city": "Saint-Martin-de-Bréthencourt"},
    {"city": "Saint-Martin-des-Champs"},
    {"city": "Saint-Martin-la-Garenne"},
    {"city": "Sainte-Mesme"},
    {"city": "Saint-Nom-la-Bretèche"},
    {"city": "Saint-Rémy-lès-Chevreuse"},
    {"city": "Saint-Rémy-l'Honoré"},
    {"city": "Sartrouville"},
    {"city": "Saulx-Marchais"},
    {"city": "Senlisse"},
    {"city": "Septeuil"},
    {"city": "Soindres"},
    {"city": "Sonchamp"},
    {"city": "Tacoignières"},
    {"city": "Le Tartre-Gaudran"},
    {"city": "Le Tertre-Saint-Denis"},
    {"city": "Tessancourt-sur-Aubette"},
    {"city": "Thiverval-Grignon"},
    {"city": "Thoiry"},
    {"city": "Tilly"},
    {"city": "Toussus-le-Noble"},
    {"city": "Trappes"},
    {"city": "Le Tremblay-sur-Mauldre"},
    {"city": "Triel-sur-Seine"},
    {"city": "Vaux-sur-Seine"},
    {"city": "Vélizy-Villacoublay"},
    {"city": "Verneuil-sur-Seine"},
    {"city": "Vernouillet"},
    {"city": "La Verrière"},
    {"city": "Versailles"},
    {"city": "Vert"},
    {"city": "Le Vésinet"},
    {"city": "Vicq"},
    {"city": "Vieille-Église-en-Yvelines"},
    {"city": "La Villeneuve-en-Chevrie"},
    {"city": "Villennes-sur-Seine"},
    {"city": "Villepreux"},
    {"city": "Villette"},
    {"city": "Villiers-le-Mahieu"},
    {"city": "Villiers-Saint-Frédéric"},
    {"city": "Viroflay"},
    {"city": "Voisins-le-Bretonneux"},
    {"city": "L'Absie"},
    {"city": "Adilly"},
    {"city": "Aiffres"},
    {"city": "Airvault"},
    {"city": "Allonne"},
    {"city": "Amailloux"},
    {"city": "Amuré"},
    {"city": "Arçais"},
    {"city": "Ardin"},
    {"city": "Argentonnay"},
    {"city": "Loretz-d'Argenton"},
    {"city": "Asnières-en-Poitou"},
    {"city": "Assais-les-Jumeaux"},
    {"city": "Aubigné"},
    {"city": "Aubigny"},
    {"city": "Augé"},
    {"city": "Availles-Thouarsais"},
    {"city": "Avon"},
    {"city": "Azay-le-Brûlé"},
    {"city": "Azay-sur-Thouet"},
    {"city": "Beaulieu-sous-Parthenay"},
    {"city": "Beaussais-Vitré"},
    {"city": "Beauvoir-sur-Niort"},
    {"city": "Béceleuf"},
    {"city": "Bessines"},
    {"city": "Boismé"},
    {"city": "La Boissière-en-Gâtine"},
    {"city": "Bougon"},
    {"city": "Le Bourdet"},
    {"city": "Boussais"},
    {"city": "La Crèche"},
    {"city": "Bressuire"},
    {"city": "Bretignolles"},
    {"city": "Brieuil-sur-Chizé"},
    {"city": "Brion-près-Thouet"},
    {"city": "Brioux-sur-Boutonne"},
    {"city": "Brûlain"},
    {"city": "Le Busseau"},
    {"city": "Caunay"},
    {"city": "Celles-sur-Belle"},
    {"city": "Cerizay"},
    {"city": "Val en Vignes"},
    {"city": "Fontivillié"},
    {"city": "Champdeniers"},
    {"city": "Chanteloup"},
    {"city": "La Chapelle-Bâton"},
    {"city": "La Chapelle-Bertrand"},
    {"city": "La Chapelle-Pouilloux"},
    {"city": "La Chapelle-Saint-Laurent"},
    {"city": "Beugnon-Thireuil"},
    {"city": "Plaine-d'Argenson"},
    {"city": "Mauléon"},
    {"city": "Châtillon-sur-Thouet"},
    {"city": "Chauray"},
    {"city": "Chef-Boutonne"},
    {"city": "Chenay"},
    {"city": "Chérigné"},
    {"city": "Cherveux"},
    {"city": "Chey"},
    {"city": "Chiché"},
    {"city": "Le Chillou"},
    {"city": "Chizé"},
    {"city": "Cirières"},
    {"city": "Clavé"},
    {"city": "Clessé"},
    {"city": "Clussais-la-Pommeraie"},
    {"city": "Combrand"},
    {"city": "Coulon"},
    {"city": "Coulonges-sur-l'Autize"},
    {"city": "Coulonges-Thouarsais"},
    {"city": "Courlay"},
    {"city": "Cours"},
    {"city": "Les Châteliers"},
    {"city": "Couture-d'Argenson"},
    {"city": "Doux"},
    {"city": "Échiré"},
    {"city": "Ensigné"},
    {"city": "Épannes"},
    {"city": "Exireuil"},
    {"city": "Exoudun"},
    {"city": "Faye-l'Abbesse"},
    {"city": "Faye-sur-Ardin"},
    {"city": "Fénery"},
    {"city": "Fenioux"},
    {"city": "La Ferrière-en-Parthenay"},
    {"city": "Fomperron"},
    {"city": "Fontenille-Saint-Martin-d'Entraigues"},
    {"city": "La Forêt-sur-Sèvre"},
    {"city": "Les Forges"},
    {"city": "Fors"},
    {"city": "Les Fosses"},
    {"city": "La Foye-Monjault"},
    {"city": "François"},
    {"city": "Fressines"},
    {"city": "Frontenay-Rohan-Rohan"},
    {"city": "Geay"},
    {"city": "Genneton"},
    {"city": "Germond-Rouvre"},
    {"city": "Glénay"},
    {"city": "Gourgé"},
    {"city": "Alloinay"},
    {"city": "Granzay-Gript"},
    {"city": "Les Groseillers"},
    {"city": "Valdelaume"},
    {"city": "Irais"},
    {"city": "Juillé"},
    {"city": "Juscorps"},
    {"city": "Lageon"},
    {"city": "Largeasse"},
    {"city": "Lezay"},
    {"city": "Lhoumois"},
    {"city": "Limalonges"},
    {"city": "Lorigné"},
    {"city": "Loubigné"},
    {"city": "Loubillé"},
    {"city": "Louin"},
    {"city": "Louzy"},
    {"city": "Luché-sur-Brioux"},
    {"city": "Luché-Thouarsais"},
    {"city": "Lusseray"},
    {"city": "Luzay"},
    {"city": "Magné"},
    {"city": "Mairé-Levescault"},
    {"city": "Maisonnay"},
    {"city": "Maisontiers"},
    {"city": "Marigny"},
    {"city": "Marnes"},
    {"city": "Mauzé-sur-le-Mignon"},
    {"city": "Mazières-en-Gâtine"},
    {"city": "Melle"},
    {"city": "Melleran"},
    {"city": "Ménigoute"},
    {"city": "Messé"},
    {"city": "Moncoutant-sur-Sèvre"},
    {"city": "Montalembert"},
    {"city": "Montravers"},
    {"city": "La Mothe-Saint-Héray"},
    {"city": "Aigondigné"},
    {"city": "Nanteuil"},
    {"city": "Neuvy-Bouin"},
    {"city": "Niort"},
    {"city": "Nueil-les-Aubiers"},
    {"city": "Plaine-et-Vallées"},
    {"city": "Oroux"},
    {"city": "Paizay-le-Chapt"},
    {"city": "Pamplie"},
    {"city": "Pamproux"},
    {"city": "Parthenay"},
    {"city": "Pas-de-Jeu"},
    {"city": "Périgné"},
    {"city": "Pers"},
    {"city": "La Petite-Boissière"},
    {"city": "La Peyratte"},
    {"city": "Pierrefitte"},
    {"city": "Le Pin"},
    {"city": "Pliboux"},
    {"city": "Pompaire"},
    {"city": "Pougne-Hérisson"},
    {"city": "Prahecq"},
    {"city": "Prailles-La Couarde"},
    {"city": "Pressigny"},
    {"city": "Prin-Deyrançon"},
    {"city": "Puihardy"},
    {"city": "Reffannes"},
    {"city": "Le Retail"},
    {"city": "La Rochénard"},
    {"city": "Rom"},
    {"city": "Romans"},
    {"city": "Saint-Amand-sur-Sèvre"},
    {"city": "Saint-André-sur-Sèvre"},
    {"city": "Saint-Aubin-du-Plain"},
    {"city": "Saint-Aubin-le-Cloud"},
    {"city": "Saint-Christophe-sur-Roc"},
    {"city": "Voulmentin"},
    {"city": "Saint-Coutant"},
    {"city": "Saint-Cyr-la-Lande"},
    {"city": "Sainte-Eanne"},
    {"city": "Saint-Gelais"},
    {"city": "Sainte-Gemme"},
    {"city": "Marcillé"},
    {"city": "Saint-Généroux"},
    {"city": "Saint-Georges-de-Noisné"},
    {"city": "Saint-Georges-de-Rex"},
    {"city": "Saint-Germain-de-Longue-Chaume"},
    {"city": "Saint-Germier"},
    {"city": "Saint-Hilaire-la-Palud"},
    {"city": "Saint-Jacques-de-Thouars"},
    {"city": "Saint-Jean-de-Thouars"},
    {"city": "Saint-Laurs"},
    {"city": "Saint-Léger-de-Montbrun"},
    {"city": "Saint-Lin"},
    {"city": "Saint-Loup-Lamairé"},
    {"city": "Saint-Maixent-de-Beugné"},
    {"city": "Saint-Maixent-l'École"},
    {"city": "Saint-Marc-la-Lande"},
    {"city": "Saint-Martin-de-Bernegoue"},
    {"city": "Saint-Martin-de-Mâcon"},
    {"city": "Saint-Martin-de-Saint-Maixent"},
    {"city": "Saint-Martin-de-Sanzay"},
    {"city": "Saint-Martin-du-Fouilloux"},
    {"city": "Saint Maurice Étusson"},
    {"city": "Saint-Maxire"},
    {"city": "Sainte-Néomaye"},
    {"city": "Sainte-Ouenne"},
    {"city": "Saint-Pardoux-Soutiers"},
    {"city": "Saint-Paul-en-Gâtine"},
    {"city": "Saint-Pierre-des-Échaubrognes"},
    {"city": "Saint-Pompain"},
    {"city": "Saint-Rémy"},
    {"city": "Saint-Romans-des-Champs"},
    {"city": "Saint-Romans-lès-Melle"},
    {"city": "Sainte-Soline"},
    {"city": "Saint-Symphorien"},
    {"city": "Saint-Varent"},
    {"city": "Sainte-Verge"},
    {"city": "Saint-Vincent-la-Châtre"},
    {"city": "Saivres"},
    {"city": "Salles"},
    {"city": "Sansais"},
    {"city": "Saurais"},
    {"city": "Sauzé-Vaussais"},
    {"city": "Sciecq"},
    {"city": "Scillé"},
    {"city": "Secondigné-sur-Belle"},
    {"city": "Secondigny"},
    {"city": "Séligné"},
    {"city": "Sepvret"},
    {"city": "Soudan"},
    {"city": "Souvigné"},
    {"city": "Surin"},
    {"city": "Le Tallud"},
    {"city": "Thénezay"},
    {"city": "Thouars"},
    {"city": "Tourtenay"},
    {"city": "Trayes"},
    {"city": "Val-du-Mignon"},
    {"city": "Vallans"},
    {"city": "Vançais"},
    {"city": "Le Vanneau-Irleau"},
    {"city": "Vanzay"},
    {"city": "Vasles"},
    {"city": "Vausseroux"},
    {"city": "Vautebis"},
    {"city": "Vernoux-en-Gâtine"},
    {"city": "Vernoux-sur-Boutonne"},
    {"city": "Verruyes"},
    {"city": "Le Vert"},
    {"city": "Viennay"},
    {"city": "Villefollet"},
    {"city": "Villemain"},
    {"city": "Villiers-en-Bois"},
    {"city": "Villiers-en-Plaine"},
    {"city": "Villiers-sur-Chizé"},
    {"city": "Vouhé"},
    {"city": "Vouillé"},
    {"city": "Xaintray"},
    {"city": "Abbeville"},
    {"city": "Ablaincourt-Pressoir"},
    {"city": "Acheux-en-Amiénois"},
    {"city": "Acheux-en-Vimeu"},
    {"city": "Agenville"},
    {"city": "Agenvillers"},
    {"city": "Aigneville"},
    {"city": "Ailly-le-Haut-Clocher"},
    {"city": "Ailly-sur-Noye"},
    {"city": "Ailly-sur-Somme"},
    {"city": "Airaines"},
    {"city": "Aizecourt-le-Bas"},
    {"city": "Aizecourt-le-Haut"},
    {"city": "Albert"},
    {"city": "Allaines"},
    {"city": "Allenay"},
    {"city": "Allery"},
    {"city": "Allonville"},
    {"city": "Amiens"},
    {"city": "Andainville"},
    {"city": "Andechy"},
    {"city": "Argœuves"},
    {"city": "Argoules"},
    {"city": "Arguel"},
    {"city": "Armancourt"},
    {"city": "Arquèves"},
    {"city": "Arrest"},
    {"city": "Arry"},
    {"city": "Arvillers"},
    {"city": "Assainvillers"},
    {"city": "Assevillers"},
    {"city": "Athies"},
    {"city": "Aubercourt"},
    {"city": "Aubigny"},
    {"city": "Aubvillers"},
    {"city": "Auchonvillers"},
    {"city": "Ault"},
    {"city": "Aumâtre"},
    {"city": "Aumont"},
    {"city": "Autheux"},
    {"city": "Authie"},
    {"city": "Authieule"},
    {"city": "Authuille"},
    {"city": "Avelesges"},
    {"city": "Aveluy"},
    {"city": "Avesnes-Chaussoy"},
    {"city": "Ayencourt"},
    {"city": "Bacouel-sur-Selle"},
    {"city": "Bailleul"},
    {"city": "Baizieux"},
    {"city": "Balâtre"},
    {"city": "Barleux"},
    {"city": "Barly"},
    {"city": "Bavelincourt"},
    {"city": "Bayencourt"},
    {"city": "Bayonvillers"},
    {"city": "Bazentin"},
    {"city": "Béalcourt"},
    {"city": "Beaucamps-le-Jeune"},
    {"city": "Beaucamps-le-Vieux"},
    {"city": "Beauchamps"},
    {"city": "Beaucourt-en-Santerre"},
    {"city": "Beaucourt-sur-l'Ancre"},
    {"city": "Beaucourt-sur-l'Hallue"},
    {"city": "Beaufort-en-Santerre"},
    {"city": "Beaumetz"},
    {"city": "Beaumont-Hamel"},
    {"city": "Beauquesne"},
    {"city": "Beauval"},
    {"city": "Bécordel-Bécourt"},
    {"city": "Becquigny"},
    {"city": "Béhen"},
    {"city": "Béhencourt"},
    {"city": "Bellancourt"},
    {"city": "Belleuse"},
    {"city": "Belloy-en-Santerre"},
    {"city": "Belloy-Saint-Léonard"},
    {"city": "Belloy-sur-Somme"},
    {"city": "Bergicourt"},
    {"city": "Bermesnil"},
    {"city": "Bernâtre"},
    {"city": "Bernaville"},
    {"city": "Bernay-en-Ponthieu"},
    {"city": "Bernes"},
    {"city": "Berneuil"},
    {"city": "Berny-en-Santerre"},
    {"city": "Bertangles"},
    {"city": "Berteaucourt-les-Dames"},
    {"city": "Berteaucourt-lès-Thennes"},
    {"city": "Bertrancourt"},
    {"city": "Béthencourt-sur-Mer"},
    {"city": "Béthencourt-sur-Somme"},
    {"city": "Bettembos"},
    {"city": "Bettencourt-Rivière"},
    {"city": "Bettencourt-Saint-Ouen"},
    {"city": "Beuvraignes"},
    {"city": "Biaches"},
    {"city": "Biarre"},
    {"city": "Biencourt"},
    {"city": "Billancourt"},
    {"city": "Blangy-sous-Poix"},
    {"city": "Blangy-Tronville"},
    {"city": "Boisbergues"},
    {"city": "Le Boisle"},
    {"city": "Boismont"},
    {"city": "Bonnay"},
    {"city": "Bonneville"},
    {"city": "Bosquel"},
    {"city": "Bouchavesnes-Bergen"},
    {"city": "Bouchoir"},
    {"city": "Bouchon"},
    {"city": "Boufflers"},
    {"city": "Bougainville"},
    {"city": "Bouillancourt-en-Séry"},
    {"city": "Bouillancourt-la-Bataille"},
    {"city": "Bouquemaison"},
    {"city": "Bourdon"},
    {"city": "Bourseville"},
    {"city": "Boussicourt"},
    {"city": "Bouttencourt"},
    {"city": "Bouvaincourt-sur-Bresle"},
    {"city": "Bouvincourt-en-Vermandois"},
    {"city": "Bouzincourt"},
    {"city": "Bovelles"},
    {"city": "Boves"},
    {"city": "Braches"},
    {"city": "Brailly-Cornehotte"},
    {"city": "Brassy"},
    {"city": "Bray-lès-Mareuil"},
    {"city": "Bray-sur-Somme"},
    {"city": "Breilly"},
    {"city": "Bresle"},
    {"city": "Breuil"},
    {"city": "Brévillers"},
    {"city": "Brie"},
    {"city": "Briquemesnil-Floxicourt"},
    {"city": "Brocourt"},
    {"city": "Brouchy"},
    {"city": "Brucamps"},
    {"city": "Brutelles"},
    {"city": "Buigny-l'Abbé"},
    {"city": "Buigny-lès-Gamaches"},
    {"city": "Buigny-Saint-Maclou"},
    {"city": "Buire-Courcelles"},
    {"city": "Buire-sur-l'Ancre"},
    {"city": "Bus-la-Mésière"},
    {"city": "Bus-lès-Artois"},
    {"city": "Bussu"},
    {"city": "Bussus-Bussuel"},
    {"city": "Bussy-lès-Daours"},
    {"city": "Bussy-lès-Poix"},
    {"city": "Buverchy"},
    {"city": "Cachy"},
    {"city": "Cagny"},
    {"city": "Cahon"},
    {"city": "Caix"},
    {"city": "Cambron"},
    {"city": "Camon"},
    {"city": "Camps-en-Amiénois"},
    {"city": "Canaples"},
    {"city": "Canchy"},
    {"city": "Candas"},
    {"city": "Cannessières"},
    {"city": "Cantigny"},
    {"city": "Caours"},
    {"city": "Cappy"},
    {"city": "Cardonnette"},
    {"city": "Le Cardonnois"},
    {"city": "Carrépuis"},
    {"city": "Cartigny"},
    {"city": "Caulières"},
    {"city": "Cavillon"},
    {"city": "Cayeux-en-Santerre"},
    {"city": "Cayeux-sur-Mer"},
    {"city": "Cerisy-Buleux"},
    {"city": "Cerisy"},
    {"city": "Champien"},
    {"city": "Chaulnes"},
    {"city": "La Chaussée-Tirancourt"},
    {"city": "Chaussoy-Epagny"},
    {"city": "La Chavatte"},
    {"city": "Chépy"},
    {"city": "Chilly"},
    {"city": "Chipilly"},
    {"city": "Chirmont"},
    {"city": "Chuignes"},
    {"city": "Chuignolles"},
    {"city": "Citerne"},
    {"city": "Cizancourt"},
    {"city": "Clairy-Saulchoix"},
    {"city": "Cléry-sur-Somme"},
    {"city": "Cocquerel"},
    {"city": "Coigneux"},
    {"city": "Coisy"},
    {"city": "Colincamps"},
    {"city": "Combles"},
    {"city": "Condé-Folie"},
    {"city": "Contalmaison"},
    {"city": "Contay"},
    {"city": "Conteville"},
    {"city": "Contre"},
    {"city": "Conty"},
    {"city": "Corbie"},
    {"city": "Cottenchy"},
    {"city": "Coullemelle"},
    {"city": "Coulonvillers"},
    {"city": "Courcelette"},
    {"city": "Courcelles-au-Bois"},
    {"city": "Courcelles-sous-Moyencourt"},
    {"city": "Courcelles-sous-Thoix"},
    {"city": "Courtemanche"},
    {"city": "Cramont"},
    {"city": "Crécy-en-Ponthieu"},
    {"city": "Crémery"},
    {"city": "Cressy-Omencourt"},
    {"city": "Creuse"},
    {"city": "Croix-Moligneaux"},
    {"city": "Croixrault"},
    {"city": "Le Crotoy"},
    {"city": "Crouy-Saint-Pierre"},
    {"city": "Curchy"},
    {"city": "Curlu"},
    {"city": "Damery"},
    {"city": "Dancourt-Popincourt"},
    {"city": "Daours"},
    {"city": "Dargnies"},
    {"city": "Davenescourt"},
    {"city": "Démuin"},
    {"city": "Dernancourt"},
    {"city": "Devise"},
    {"city": "Doingt"},
    {"city": "Domart-en-Ponthieu"},
    {"city": "Domart-sur-la-Luce"},
    {"city": "Domesmont"},
    {"city": "Dominois"},
    {"city": "Domléger-Longvillers"},
    {"city": "Dommartin"},
    {"city": "Dompierre-Becquincourt"},
    {"city": "Dompierre-sur-Authie"},
    {"city": "Domqueur"},
    {"city": "Domvast"},
    {"city": "Doudelainville"},
    {"city": "Douilly"},
    {"city": "Doullens"},
    {"city": "Dreuil-lès-Amiens"},
    {"city": "Driencourt"},
    {"city": "Dromesnil"},
    {"city": "Drucat"},
    {"city": "Dury"},
    {"city": "Eaucourt-sur-Somme"},
    {"city": "L'Échelle-Saint-Aurin"},
    {"city": "Éclusier-Vaux"},
    {"city": "Embreville"},
    {"city": "Englebelmer"},
    {"city": "Ennemain"},
    {"city": "Épagne-Épagnette"},
    {"city": "Épaumesnil"},
    {"city": "Épécamps"},
    {"city": "Épehy"},
    {"city": "Épénancourt"},
    {"city": "Éplessier"},
    {"city": "Eppeville"},
    {"city": "Équancourt"},
    {"city": "Équennes-Éramecourt"},
    {"city": "Erches"},
    {"city": "Ercheu"},
    {"city": "Ercourt"},
    {"city": "Ergnies"},
    {"city": "Érondelle"},
    {"city": "Esclainvillers"},
    {"city": "Esmery-Hallon"},
    {"city": "Essertaux"},
    {"city": "Estrébœuf"},
    {"city": "Estrées-Deniécourt"},
    {"city": "Estrées-lès-Crécy"},
    {"city": "Estrées-sur-Noye"},
    {"city": "Étalon"},
    {"city": "Ételfay"},
    {"city": "Éterpigny"},
    {"city": "Étinehem-Méricourt"},
    {"city": "L'Étoile"},
    {"city": "Étréjust"},
    {"city": "Étricourt-Manancourt"},
    {"city": "La Faloise"},
    {"city": "Falvy"},
    {"city": "Famechon"},
    {"city": "Faverolles"},
    {"city": "Favières"},
    {"city": "Fay"},
    {"city": "Ferrières"},
    {"city": "Fescamps"},
    {"city": "Feuillères"},
    {"city": "Feuquières-en-Vimeu"},
    {"city": "Fienvillers"},
    {"city": "Fignières"},
    {"city": "Fins"},
    {"city": "Flaucourt"},
    {"city": "Flers"},
    {"city": "Flers-sur-Noye"},
    {"city": "Flesselles"},
    {"city": "Fleury"},
    {"city": "Flixecourt"},
    {"city": "Fluy"},
    {"city": "Folies"},
    {"city": "Folleville"},
    {"city": "Fonches-Fonchette"},
    {"city": "Fontaine-le-Sec"},
    {"city": "Fontaine-lès-Cappy"},
    {"city": "Fontaine-sous-Montdidier"},
    {"city": "Fontaine-sur-Maye"},
    {"city": "Fontaine-sur-Somme"},
    {"city": "Forceville"},
    {"city": "Forceville-en-Vimeu"},
    {"city": "Forest-l'Abbaye"},
    {"city": "Forest-Montiers"},
    {"city": "Fort-Mahon-Plage"},
    {"city": "Fossemanant"},
    {"city": "Foucaucourt-en-Santerre"},
    {"city": "Foucaucourt-Hors-Nesle"},
    {"city": "Fouencamps"},
    {"city": "Fouilloy"},
    {"city": "Fouquescourt"},
    {"city": "Fourcigny"},
    {"city": "Fourdrinoy"},
    {"city": "Framerville-Rainecourt"},
    {"city": "Framicourt"},
    {"city": "Francières"},
    {"city": "Franleu"},
    {"city": "Franqueville"},
    {"city": "Fransart"},
    {"city": "Fransu"},
    {"city": "Fransures"},
    {"city": "Franvillers"},
    {"city": "Fréchencourt"},
    {"city": "Frémontiers"},
    {"city": "Fresnes-Mazancourt"},
    {"city": "Fresnes-Tilloloy"},
    {"city": "Fresneville"},
    {"city": "Fresnoy-Andainville"},
    {"city": "Fresnoy-au-Val"},
    {"city": "Fresnoy-en-Chaussée"},
    {"city": "Fresnoy-lès-Roye"},
    {"city": "Fressenneville"},
    {"city": "Frettecuisse"},
    {"city": "Frettemeule"},
    {"city": "Friaucourt"},
    {"city": "Fricamps"},
    {"city": "Fricourt"},
    {"city": "Frise"},
    {"city": "Friville-Escarbotin"},
    {"city": "Frohen-sur-Authie"},
    {"city": "Froyelles"},
    {"city": "Frucourt"},
    {"city": "Gamaches"},
    {"city": "Gapennes"},
    {"city": "Gauville"},
    {"city": "Gentelles"},
    {"city": "Gézaincourt"},
    {"city": "Ginchy"},
    {"city": "Glisy"},
    {"city": "Gorenflos"},
    {"city": "Gorges"},
    {"city": "Goyencourt"},
    {"city": "Grandcourt"},
    {"city": "Grand-Laviers"},
    {"city": "Gratibus"},
    {"city": "Grattepanche"},
    {"city": "Grébault-Mesnil"},
    {"city": "Grivesnes"},
    {"city": "Grivillers"},
    {"city": "Grouches-Luchuel"},
    {"city": "Gruny"},
    {"city": "Guerbigny"},
    {"city": "Gueschart"},
    {"city": "Gueudecourt"},
    {"city": "Guignemicourt"},
    {"city": "Guillaucourt"},
    {"city": "Guillemont"},
    {"city": "Guizancourt"},
    {"city": "Guyencourt-sur-Noye"},
    {"city": "Guyencourt-Saulcourt"},
    {"city": "Hailles"},
    {"city": "Hallencourt"},
    {"city": "Hallivillers"},
    {"city": "Halloy-lès-Pernois"},
    {"city": "Hallu"},
    {"city": "Ham"},
    {"city": "Le Hamel"},
    {"city": "Hamelet"},
    {"city": "Hancourt"},
    {"city": "Hangard"},
    {"city": "Hangest-en-Santerre"},
    {"city": "Hangest-sur-Somme"},
    {"city": "Harbonnières"},
    {"city": "Hardecourt-aux-Bois"},
    {"city": "Harponville"},
    {"city": "Hattencourt"},
    {"city": "Hautvillers-Ouville"},
    {"city": "Havernas"},
    {"city": "Hébécourt"},
    {"city": "Hédauville"},
    {"city": "Heilly"},
    {"city": "Hem-Hardinval"},
    {"city": "Hem-Monacu"},
    {"city": "Hénencourt"},
    {"city": "Herbécourt"},
    {"city": "Hérissart"},
    {"city": "Herleville"},
    {"city": "Herly"},
    {"city": "Hervilly"},
    {"city": "Hesbécourt"},
    {"city": "Hescamps"},
    {"city": "Heucourt-Croquoison"},
    {"city": "Heudicourt"},
    {"city": "Heuzecourt"},
    {"city": "Hiermont"},
    {"city": "Hombleux"},
    {"city": "Hornoy-le-Bourg"},
    {"city": "Huchenneville"},
    {"city": "Humbercourt"},
    {"city": "Huppy"},
    {"city": "Ignaucourt"},
    {"city": "Inval-Boiron"},
    {"city": "Irles"},
    {"city": "Jumel"},
    {"city": "Laboissière-en-Santerre"},
    {"city": "Lachapelle"},
    {"city": "Lafresguimont-Saint-Martin"},
    {"city": "Lahoussoye"},
    {"city": "Laleu"},
    {"city": "Lamaronde"},
    {"city": "Lamotte-Brebière"},
    {"city": "Lamotte-Buleux"},
    {"city": "Lamotte-Warfusée"},
    {"city": "Lanchères"},
    {"city": "Languevoisin-Quiquery"},
    {"city": "Lanches-Saint-Hilaire"},
    {"city": "Laucourt"},
    {"city": "Laviéville"},
    {"city": "Lawarde-Mauger-l'Hortoy"},
    {"city": "Léalvillers"},
    {"city": "Lesbœufs"},
    {"city": "Liancourt-Fosse"},
    {"city": "Licourt"},
    {"city": "Liéramont"},
    {"city": "Liercourt"},
    {"city": "Ligescourt"},
    {"city": "Lignières"},
    {"city": "Lignières-Châtelain"},
    {"city": "Lignières-en-Vimeu"},
    {"city": "Lihons"},
    {"city": "Limeux"},
    {"city": "Liomer"},
    {"city": "Ô-de-Selle"},
    {"city": "Long"},
    {"city": "Longavesnes"},
    {"city": "Longpré-les-Corps-Saints"},
    {"city": "Longueau"},
    {"city": "Longueval"},
    {"city": "Longuevillette"},
    {"city": "Louvencourt"},
    {"city": "Louvrechy"},
    {"city": "Lucheux"},
    {"city": "Machiel"},
    {"city": "Machy"},
    {"city": "Mailly-Maillet"},
    {"city": "Mailly-Raineval"},
    {"city": "Maisnières"},
    {"city": "Maison-Ponthieu"},
    {"city": "Maison-Roland"},
    {"city": "Maizicourt"},
    {"city": "Malpart"},
    {"city": "Carnoy-Mametz"},
    {"city": "Marcelcave"},
    {"city": "Marché-Allouarde"},
    {"city": "Marchélepot-Misery"},
    {"city": "Marestmontiers"},
    {"city": "Mareuil-Caubert"},
    {"city": "Maricourt"},
    {"city": "Marieux"},
    {"city": "Marlers"},
    {"city": "Marquaix"},
    {"city": "Marquivillers"},
    {"city": "Martainneville"},
    {"city": "Matigny"},
    {"city": "Maucourt"},
    {"city": "Maurepas"},
    {"city": "Le Mazis"},
    {"city": "Méaulte"},
    {"city": "Méharicourt"},
    {"city": "Meigneux"},
    {"city": "Le Meillard"},
    {"city": "Méneslies"},
    {"city": "Méréaucourt"},
    {"city": "Mérélessart"},
    {"city": "Méricourt-l'Abbé"},
    {"city": "Méricourt-en-Vimeu"},
    {"city": "Mers-les-Bains"},
    {"city": "Le Mesge"},
    {"city": "Mesnil-Bruntel"},
    {"city": "Mesnil-Domqueur"},
    {"city": "Mesnil-en-Arrouaise"},
    {"city": "Mesnil-Martinsart"},
    {"city": "Mesnil-Saint-Georges"},
    {"city": "Mesnil-Saint-Nicaise"},
    {"city": "Métigny"},
    {"city": "Mézerolles"},
    {"city": "Mézières-en-Santerre"},
    {"city": "Miannay"},
    {"city": "Millencourt"},
    {"city": "Millencourt-en-Ponthieu"},
    {"city": "Miraumont"},
    {"city": "Mirvaux"},
    {"city": "Moislains"},
    {"city": "Molliens-au-Bois"},
    {"city": "Molliens-Dreuil"},
    {"city": "Monchy-Lagache"},
    {"city": "Mons-Boubert"},
    {"city": "Estrées-Mons"},
    {"city": "Monsures"},
    {"city": "Montagne-Fayel"},
    {"city": "Montauban-de-Picardie"},
    {"city": "Montdidier"},
    {"city": "Montigny-sur-l'Hallue"},
    {"city": "Montigny-les-Jongleurs"},
    {"city": "Montonvillers"},
    {"city": "Fieffes-Montrelet"},
    {"city": "Morchain"},
    {"city": "Morcourt"},
    {"city": "Moreuil"},
    {"city": "Morisel"},
    {"city": "Morlancourt"},
    {"city": "Morvillers-Saint-Saturnin"},
    {"city": "Mouflers"},
    {"city": "Mouflières"},
    {"city": "Moyencourt"},
    {"city": "Moyencourt-lès-Poix"},
    {"city": "Moyenneville"},
    {"city": "Muille-Villette"},
    {"city": "Nampont"},
    {"city": "Namps-Maisnil"},
    {"city": "Nampty"},
    {"city": "Naours"},
    {"city": "Nesle"},
    {"city": "Nesle-l'Hôpital"},
    {"city": "Neslette"},
    {"city": "Neufmoulin"},
    {"city": "Neuilly-le-Dien"},
    {"city": "Neuilly-l'Hôpital"},
    {"city": "Neuville-au-Bois"},
    {"city": "Neuville-Coppegueule"},
    {"city": "La Neuville-lès-Bray"},
    {"city": "La Neuville-Sire-Bernard"},
    {"city": "Neuvillette"},
    {"city": "Nibas"},
    {"city": "Nouvion"},
    {"city": "Noyelles-en-Chaussée"},
    {"city": "Noyelles-sur-Mer"},
    {"city": "Nurlu"},
    {"city": "Occoches"},
    {"city": "Ochancourt"},
    {"city": "Offignies"},
    {"city": "Offoy"},
    {"city": "Oisemont"},
    {"city": "Oissy"},
    {"city": "Oneux"},
    {"city": "Oresmaux"},
    {"city": "Oust-Marest"},
    {"city": "Outrebois"},
    {"city": "Ovillers-la-Boisselle"},
    {"city": "Pargny"},
    {"city": "Parvillers-le-Quesnoy"},
    {"city": "Pendé"},
    {"city": "Pernois"},
    {"city": "Péronne"},
    {"city": "Hypercourt"},
    {"city": "Picquigny"},
    {"city": "Piennes-Onvillers"},
    {"city": "Pierregot"},
    {"city": "Trois-Rivières"},
    {"city": "Pissy"},
    {"city": "Plachy-Buyon"},
    {"city": "Le Plessier-Rozainvillers"},
    {"city": "Pœuilly"},
    {"city": "Poix-de-Picardie"},
    {"city": "Ponches-Estruval"},
    {"city": "Pont-de-Metz"},
    {"city": "Ponthoile"},
    {"city": "Pont-Noyelles"},
    {"city": "Pont-Remy"},
    {"city": "Port-le-Grand"},
    {"city": "Potte"},
    {"city": "Poulainville"},
    {"city": "Pozières"},
    {"city": "Prouville"},
    {"city": "Prouzel"},
    {"city": "Proyart"},
    {"city": "Puchevillers"},
    {"city": "Punchy"},
    {"city": "Puzeaux"},
    {"city": "Pys"},
    {"city": "Quend"},
    {"city": "Querrieu"},
    {"city": "Le Quesne"},
    {"city": "Le Quesnel"},
    {"city": "Quesnoy-le-Montant"},
    {"city": "Quesnoy-sur-Airaines"},
    {"city": "Quevauvillers"},
    {"city": "Quiry-le-Sec"},
    {"city": "Quivières"},
    {"city": "Raincheval"},
    {"city": "Rainneville"},
    {"city": "Ramburelles"},
    {"city": "Rambures"},
    {"city": "Rancourt"},
    {"city": "Regnière-Écluse"},
    {"city": "Remaisnil"},
    {"city": "Remaugies"},
    {"city": "Remiencourt"},
    {"city": "Rethonvillers"},
    {"city": "Revelles"},
    {"city": "Ribeaucourt"},
    {"city": "Ribemont-sur-Ancre"},
    {"city": "Riencourt"},
    {"city": "Rivery"},
    {"city": "Rogy"},
    {"city": "Roiglise"},
    {"city": "Roisel"},
    {"city": "Rollot"},
    {"city": "Ronssoy"},
    {"city": "Rosières-en-Santerre"},
    {"city": "Rouvrel"},
    {"city": "Rouvroy-en-Santerre"},
    {"city": "Rouy-le-Grand"},
    {"city": "Rouy-le-Petit"},
    {"city": "Roye"},
    {"city": "Rubempré"},
    {"city": "Rubescourt"},
    {"city": "Rue"},
    {"city": "Rumigny"},
    {"city": "Saigneville"},
    {"city": "Sailly-Flibeaucourt"},
    {"city": "Sailly-Laurette"},
    {"city": "Sailly-le-Sec"},
    {"city": "Sailly-Saillisel"},
    {"city": "Sains-en-Amiénois"},
    {"city": "Saint-Acheul"},
    {"city": "Saint-Aubin-Montenoy"},
    {"city": "Saint-Aubin-Rivière"},
    {"city": "Saint-Blimont"},
    {"city": "Saint-Christ-Briost"},
    {"city": "Saint-Fuscien"},
    {"city": "Saint-Germain-sur-Bresle"},
    {"city": "Saint-Gratien"},
    {"city": "Saint-Léger-lès-Authie"},
    {"city": "Saint-Léger-lès-Domart"},
    {"city": "Saint-Léger-sur-Bresle"},
    {"city": "Saint-Mard"},
    {"city": "Saint-Maulvis"},
    {"city": "Saint-Maxent"},
    {"city": "Saint-Ouen"},
    {"city": "Saint-Quentin-en-Tourmont"},
    {"city": "Saint-Quentin-la-Motte-Croix-au-Bailly"},
    {"city": "Saint-Riquier"},
    {"city": "Saint-Sauflieu"},
    {"city": "Saint-Sauveur"},
    {"city": "Sainte-Segrée"},
    {"city": "Saint-Valery-sur-Somme"},
    {"city": "Saint-Vaast-en-Chaussée"},
    {"city": "Saisseval"},
    {"city": "Saleux"},
    {"city": "Salouël"},
    {"city": "Sancourt"},
    {"city": "Saulchoy-sous-Poix"},
    {"city": "Sauvillers-Mongival"},
    {"city": "Saveuse"},
    {"city": "Senarpont"},
    {"city": "Senlis-le-Sec"},
    {"city": "Sentelie"},
    {"city": "Seux"},
    {"city": "Sorel-en-Vimeu"},
    {"city": "Sorel"},
    {"city": "Soues"},
    {"city": "Sourdon"},
    {"city": "Soyécourt"},
    {"city": "Surcamps"},
    {"city": "Suzanne"},
    {"city": "Tailly"},
    {"city": "Talmas"},
    {"city": "Templeux-la-Fosse"},
    {"city": "Templeux-le-Guérard"},
    {"city": "Terramesnil"},
    {"city": "Tertry"},
    {"city": "Thennes"},
    {"city": "Thézy-Glimont"},
    {"city": "Thiepval"},
    {"city": "Thieulloy-l'Abbaye"},
    {"city": "Thieulloy-la-Ville"},
    {"city": "Thièvres"},
    {"city": "Thoix"},
    {"city": "Thory"},
    {"city": "Tilloloy"},
    {"city": "Tilloy-Floriville"},
    {"city": "Tincourt-Boucly"},
    {"city": "Le Titre"},
    {"city": "Tœufles"},
    {"city": "Tours-en-Vimeu"},
    {"city": "Toutencourt"},
    {"city": "Le Translay"},
    {"city": "Treux"},
    {"city": "Tully"},
    {"city": "Ugny-l'Équipée"},
    {"city": "Vadencourt"},
    {"city": "Vaire-sous-Corbie"},
    {"city": "Valines"},
    {"city": "Varennes"},
    {"city": "Vauchelles-lès-Authie"},
    {"city": "Vauchelles-lès-Domart"},
    {"city": "Vauchelles-les-Quesnoy"},
    {"city": "Vaudricourt"},
    {"city": "Vauvillers"},
    {"city": "Vaux-en-Amiénois"},
    {"city": "Vaux-Marquenneville"},
    {"city": "Vaux-sur-Somme"},
    {"city": "Vecquemont"},
    {"city": "Velennes"},
    {"city": "Vercourt"},
    {"city": "Vergies"},
    {"city": "Vermandovillers"},
    {"city": "Verpillières"},
    {"city": "Vers-sur-Selle"},
    {"city": "La Vicogne"},
    {"city": "Vignacourt"},
    {"city": "Villecourt"},
    {"city": "Ville-le-Marclet"},
    {"city": "Villeroy"},
    {"city": "Villers-aux-Érables"},
    {"city": "Villers-Bocage"},
    {"city": "Villers-Bretonneux"},
    {"city": "Villers-Campsart"},
    {"city": "Villers-Carbonnel"},
    {"city": "Villers-Faucon"},
    {"city": "Villers-lès-Roye"},
    {"city": "Villers-sous-Ailly"},
    {"city": "Villers-Tournelle"},
    {"city": "Villers-sur-Authie"},
    {"city": "Ville-sur-Ancre"},
    {"city": "Vironchaux"},
    {"city": "Vismes"},
    {"city": "Vitz-sur-Authie"},
    {"city": "Voyennes"},
    {"city": "Vraignes-en-Vermandois"},
    {"city": "Vraignes-lès-Hornoy"},
    {"city": "Vrély"},
    {"city": "Vron"},
    {"city": "Wargnies"},
    {"city": "Warloy-Baillon"},
    {"city": "Warlus"},
    {"city": "Warsy"},
    {"city": "Warvillers"},
    {"city": "Wiencourt-l'Équipée"},
    {"city": "Wiry-au-Mont"},
    {"city": "Woignarue"},
    {"city": "Woincourt"},
    {"city": "Woirel"},
    {"city": "Y"},
    {"city": "Yaucourt-Bussus"},
    {"city": "Yvrench"},
    {"city": "Yvrencheux"},
    {"city": "Yzengremer"},
    {"city": "Yzeux"},
    {"city": "Yonval"},
    {"city": "Aguts"},
    {"city": "Aiguefonde"},
    {"city": "Alban"},
    {"city": "Albi"},
    {"city": "Albine"},
    {"city": "Algans"},
    {"city": "Alos"},
    {"city": "Almayrac"},
    {"city": "Amarens"},
    {"city": "Ambialet"},
    {"city": "Ambres"},
    {"city": "Andillac"},
    {"city": "Andouque"},
    {"city": "Anglès"},
    {"city": "Appelle"},
    {"city": "Arfons"},
    {"city": "Arifat"},
    {"city": "Arthès"},
    {"city": "Assac"},
    {"city": "Aussac"},
    {"city": "Aussillon"},
    {"city": "Bannières"},
    {"city": "Barre"},
    {"city": "Beauvais-sur-Tescou"},
    {"city": "Belcastel"},
    {"city": "Bellegarde-Marsal"},
    {"city": "Belleserre"},
    {"city": "Berlats"},
    {"city": "Bernac"},
    {"city": "Bertre"},
    {"city": "Le Bez"},
    {"city": "Blan"},
    {"city": "Blaye-les-Mines"},
    {"city": "Boissezon"},
    {"city": "Bournazel"},
    {"city": "Bout-du-Pont-de-Larn"},
    {"city": "Brassac"},
    {"city": "Brens"},
    {"city": "Briatexte"},
    {"city": "Brousse"},
    {"city": "Broze"},
    {"city": "Burlats"},
    {"city": "Busque"},
    {"city": "Cabanès"},
    {"city": "Les Cabannes"},
    {"city": "Cadalen"},
    {"city": "Cadix"},
    {"city": "Cagnac-les-Mines"},
    {"city": "Cahuzac"},
    {"city": "Cambon-lès-Lavaur"},
    {"city": "Cahuzac-sur-Vère"},
    {"city": "Cambon"},
    {"city": "Cambounès"},
    {"city": "Cambounet-sur-le-Sor"},
    {"city": "Les Cammazes"},
    {"city": "Campagnac"},
    {"city": "Carbes"},
    {"city": "Carlus"},
    {"city": "Carmaux"},
    {"city": "Castanet"},
    {"city": "Fontrieu"},
    {"city": "Castelnau-de-Lévis"},
    {"city": "Castelnau-de-Montmiral"},
    {"city": "Castres"},
    {"city": "Caucalières"},
    {"city": "Cestayrols"},
    {"city": "Combefa"},
    {"city": "Cordes-sur-Ciel"},
    {"city": "Coufouleux"},
    {"city": "Courris"},
    {"city": "Crespin"},
    {"city": "Crespinet"},
    {"city": "Cunac"},
    {"city": "Cuq"},
    {"city": "Cuq-Toulza"},
    {"city": "Curvalle"},
    {"city": "Damiatte"},
    {"city": "Dénat"},
    {"city": "Donnazac"},
    {"city": "Dourgne"},
    {"city": "Le Dourn"},
    {"city": "Durfort"},
    {"city": "Escoussens"},
    {"city": "Escroux"},
    {"city": "Espérausses"},
    {"city": "Fayssac"},
    {"city": "Fauch"},
    {"city": "Faussergues"},
    {"city": "Fénols"},
    {"city": "Fiac"},
    {"city": "Florentin"},
    {"city": "Fraissines"},
    {"city": "Frausseilles"},
    {"city": "Le Fraysse"},
    {"city": "Fréjairolles"},
    {"city": "Fréjeville"},
    {"city": "Gaillac"},
    {"city": "Garrevaques"},
    {"city": "Le Garric"},
    {"city": "Garrigues"},
    {"city": "Gijounet"},
    {"city": "Giroussens"},
    {"city": "Graulhet"},
    {"city": "Grazac"},
    {"city": "Itzac"},
    {"city": "Jonquières"},
    {"city": "Jouqueviel"},
    {"city": "Labarthe-Bleys"},
    {"city": "Labastide-de-Lévis"},
    {"city": "Labastide-Gabausse"},
    {"city": "Labastide-Rouairoux"},
    {"city": "Labastide-Saint-Georges"},
    {"city": "Labessière-Candeil"},
    {"city": "Laboulbène"},
    {"city": "Laboutarie"},
    {"city": "Labruguière"},
    {"city": "Lacabarède"},
    {"city": "Lacapelle-Pinet"},
    {"city": "Lacapelle-Ségalar"},
    {"city": "Lacaune"},
    {"city": "Lacaze"},
    {"city": "Lacougotte-Cadoul"},
    {"city": "Lacroisille"},
    {"city": "Lacrouzette"},
    {"city": "Lagardiolle"},
    {"city": "Lagarrigue"},
    {"city": "Lagrave"},
    {"city": "Guitalens-L'Albarède"},
    {"city": "Lamillarié"},
    {"city": "Lamontélarié"},
    {"city": "Laparrouquial"},
    {"city": "Larroque"},
    {"city": "Lasfaillades"},
    {"city": "Lasgraisses"},
    {"city": "Lautrec"},
    {"city": "Lavaur"},
    {"city": "Lédas-et-Penthiès"},
    {"city": "Lempaut"},
    {"city": "Lescout"},
    {"city": "Lescure-d'Albigeois"},
    {"city": "Lisle-sur-Tarn"},
    {"city": "Livers-Cazelles"},
    {"city": "Lombers"},
    {"city": "Loubers"},
    {"city": "Loupiac"},
    {"city": "Lugan"},
    {"city": "Magrin"},
    {"city": "Mailhoc"},
    {"city": "Marnaves"},
    {"city": "Marssac-sur-Tarn"},
    {"city": "Marzens"},
    {"city": "Le Masnau-Massuguiès"},
    {"city": "Massac-Séran"},
    {"city": "Massaguel"},
    {"city": "Massals"},
    {"city": "Maurens-Scopont"},
    {"city": "Mazamet"},
    {"city": "Mézens"},
    {"city": "Milhars"},
    {"city": "Milhavet"},
    {"city": "Miolles"},
    {"city": "Mirandol-Bourgnounac"},
    {"city": "Missècle"},
    {"city": "Monestiés"},
    {"city": "Montans"},
    {"city": "Montauriol"},
    {"city": "Montcabrier"},
    {"city": "Montdragon"},
    {"city": "Montdurausse"},
    {"city": "Montels"},
    {"city": "Montfa"},
    {"city": "Montgaillard"},
    {"city": "Montgey"},
    {"city": "Montirat"},
    {"city": "Montpinier"},
    {"city": "Montredon-Labessonnié"},
    {"city": "Mont-Roc"},
    {"city": "Montrosier"},
    {"city": "Montvalen"},
    {"city": "Moularès"},
    {"city": "Moulayrès"},
    {"city": "Moulin-Mage"},
    {"city": "Mouzens"},
    {"city": "Mouzieys-Teulet"},
    {"city": "Mouzieys-Panens"},
    {"city": "Murat-sur-Vèbre"},
    {"city": "Nages"},
    {"city": "Navès"},
    {"city": "Noailhac"},
    {"city": "Noailles"},
    {"city": "Orban"},
    {"city": "Padiès"},
    {"city": "Palleville"},
    {"city": "Pampelonne"},
    {"city": "Parisot"},
    {"city": "Paulinet"},
    {"city": "Payrin-Augmontel"},
    {"city": "Péchaudier"},
    {"city": "Penne"},
    {"city": "Peyregoux"},
    {"city": "Peyrole"},
    {"city": "Pont-de-Larn"},
    {"city": "Poudis"},
    {"city": "Poulan-Pouzols"},
    {"city": "Prades"},
    {"city": "Pratviel"},
    {"city": "Puéchoursi"},
    {"city": "Puybegon"},
    {"city": "Puycalvel"},
    {"city": "Puycelsi"},
    {"city": "Puygouzon"},
    {"city": "Puylaurens"},
    {"city": "Rabastens"},
    {"city": "Rayssac"},
    {"city": "Réalmont"},
    {"city": "Le Rialet"},
    {"city": "Le Riols"},
    {"city": "Rivières"},
    {"city": "Roquecourbe"},
    {"city": "Roquemaure"},
    {"city": "Roquevidal"},
    {"city": "Rosières"},
    {"city": "Rouairoux"},
    {"city": "Rouffiac"},
    {"city": "Terre-de-Bancalié"},
    {"city": "Roussayrolles"},
    {"city": "Saint-Affrique-les-Montagnes"},
    {"city": "Saint-Agnan"},
    {"city": "Saint-Amancet"},
    {"city": "Saint-Amans-Soult"},
    {"city": "Saint-Amans-Valtoret"},
    {"city": "Saint-André"},
    {"city": "Saint-Avit"},
    {"city": "Saint-Beauzile"},
    {"city": "Saint-Benoît-de-Carmaux"},
    {"city": "Saint-Christophe"},
    {"city": "Sainte-Cécile-du-Cayrou"},
    {"city": "Saint-Cirgue"},
    {"city": "Saint-Gauzens"},
    {"city": "Sainte-Gemme"},
    {"city": "Saint-Genest-de-Contest"},
    {"city": "Saint-Germain-des-Prés"},
    {"city": "Saint-Germier"},
    {"city": "Saint-Grégoire"},
    {"city": "Saint-Jean-de-Marcel"},
    {"city": "Saint-Jean-de-Rives"},
    {"city": "Saint-Jean-de-Vals"},
    {"city": "Saint-Juéry"},
    {"city": "Saint-Julien-du-Puy"},
    {"city": "Saint-Julien-Gaulène"},
    {"city": "Saint-Lieux-lès-Lavaur"},
    {"city": "Saint-Marcel-Campes"},
    {"city": "Saint-Martin-Laguépie"},
    {"city": "Saint-Michel-Labadié"},
    {"city": "Saint-Michel-de-Vax"},
    {"city": "Saint-Paul-Cap-de-Joux"},
    {"city": "Saint-Pierre-de-Trivisy"},
    {"city": "Saint-Salvi-de-Carcavès"},
    {"city": "Saint-Salvy-de-la-Balme"},
    {"city": "Saint-Sernin-lès-Lavaur"},
    {"city": "Saint-Sulpice-la-Pointe"},
    {"city": "Saint-Urcisse"},
    {"city": "Saïx"},
    {"city": "Saliès"},
    {"city": "Salles"},
    {"city": "Salvagnac"},
    {"city": "Saussenac"},
    {"city": "Sauveterre"},
    {"city": "La Sauzière-Saint-Jean"},
    {"city": "Le Ségur"},
    {"city": "Sémalens"},
    {"city": "Senaux"},
    {"city": "Senouillac"},
    {"city": "Le Sequestre"},
    {"city": "Sérénac"},
    {"city": "Serviès"},
    {"city": "Sieurac"},
    {"city": "Sorèze"},
    {"city": "Soual"},
    {"city": "Souel"},
    {"city": "Taïx"},
    {"city": "Tanus"},
    {"city": "Tauriac"},
    {"city": "Técou"},
    {"city": "Teillet"},
    {"city": "Terssac"},
    {"city": "Teulat"},
    {"city": "Teyssode"},
    {"city": "Tonnac"},
    {"city": "Tréban"},
    {"city": "Trébas"},
    {"city": "Trévien"},
    {"city": "Vabre"},
    {"city": "Valderiès"},
    {"city": "Valdurenque"},
    {"city": "Valence-d'Albigeois"},
    {"city": "Vaour"},
    {"city": "Veilhes"},
    {"city": "Vénès"},
    {"city": "Verdalle"},
    {"city": "Le Verdier"},
    {"city": "Viane"},
    {"city": "Vielmur-sur-Agout"},
    {"city": "Vieux"},
    {"city": "Villefranche-d'Albigeois"},
    {"city": "Villeneuve-lès-Lavaur"},
    {"city": "Villeneuve-sur-Vère"},
    {"city": "Vindrac-Alayrac"},
    {"city": "Le Vintrou"},
    {"city": "Virac"},
    {"city": "Viterbe"},
    {"city": "Viviers-lès-Lavaur"},
    {"city": "Viviers-lès-Montagnes"},
    {"city": "Sainte-Croix"},
    {"city": "Albefeuille-Lagarde"},
    {"city": "Albias"},
    {"city": "Angeville"},
    {"city": "Asques"},
    {"city": "Aucamville"},
    {"city": "Auterive"},
    {"city": "Auty"},
    {"city": "Auvillar"},
    {"city": "Balignac"},
    {"city": "Bardigues"},
    {"city": "Barry-d'Islemade"},
    {"city": "Les Barthes"},
    {"city": "Beaumont-de-Lomagne"},
    {"city": "Beaupuy"},
    {"city": "Belbèze-en-Lomagne"},
    {"city": "Belvèze"},
    {"city": "Bessens"},
    {"city": "Bioule"},
    {"city": "Boudou"},
    {"city": "Bouillac"},
    {"city": "Bouloc-en-Quercy"},
    {"city": "Bourg-de-Visa"},
    {"city": "Bourret"},
    {"city": "Brassac"},
    {"city": "Bressols"},
    {"city": "Bruniquel"},
    {"city": "Campsas"},
    {"city": "Canals"},
    {"city": "Castanet"},
    {"city": "Castelferrus"},
    {"city": "Castelmayran"},
    {"city": "Castelsagrat"},
    {"city": "Castelsarrasin"},
    {"city": "Castéra-Bouzet"},
    {"city": "Caumont"},
    {"city": "Le Causé"},
    {"city": "Caussade"},
    {"city": "Caylus"},
    {"city": "Cayrac"},
    {"city": "Cayriech"},
    {"city": "Cazals"},
    {"city": "Cazes-Mondenard"},
    {"city": "Comberouger"},
    {"city": "Corbarieu"},
    {"city": "Cordes-Tolosannes"},
    {"city": "Coutures"},
    {"city": "Cumont"},
    {"city": "Dieupentale"},
    {"city": "Donzac"},
    {"city": "Dunes"},
    {"city": "Durfort-Lacapelette"},
    {"city": "Escatalens"},
    {"city": "Escazeaux"},
    {"city": "Espalais"},
    {"city": "Esparsac"},
    {"city": "Espinas"},
    {"city": "Fabas"},
    {"city": "Fajolles"},
    {"city": "Faudoas"},
    {"city": "Fauroux"},
    {"city": "Féneyrols"},
    {"city": "Finhan"},
    {"city": "Garganvillar"},
    {"city": "Gariès"},
    {"city": "Gasques"},
    {"city": "Génébrières"},
    {"city": "Gensac"},
    {"city": "Gimat"},
    {"city": "Ginals"},
    {"city": "Glatens"},
    {"city": "Goas"},
    {"city": "Golfech"},
    {"city": "Goudourville"},
    {"city": "Gramont"},
    {"city": "Grisolles"},
    {"city": "L'Honor-de-Cos"},
    {"city": "Labarthe"},
    {"city": "Labastide-de-Penne"},
    {"city": "Labastide-Saint-Pierre"},
    {"city": "Labastide-du-Temple"},
    {"city": "Labourgade"},
    {"city": "Lacapelle-Livron"},
    {"city": "Lachapelle"},
    {"city": "Lacour"},
    {"city": "Lacourt-Saint-Pierre"},
    {"city": "Lafitte"},
    {"city": "Lafrançaise"},
    {"city": "Laguépie"},
    {"city": "Lamagistère"},
    {"city": "Lamothe-Capdeville"},
    {"city": "Lamothe-Cumont"},
    {"city": "Lapenche"},
    {"city": "Larrazet"},
    {"city": "Lauzerte"},
    {"city": "Lavaurette"},
    {"city": "La Ville-Dieu-du-Temple"},
    {"city": "Lavit"},
    {"city": "Léojac"},
    {"city": "Lizac"},
    {"city": "Loze"},
    {"city": "Malause"},
    {"city": "Mansonville"},
    {"city": "Marignac"},
    {"city": "Marsac"},
    {"city": "Mas-Grenier"},
    {"city": "Maubec"},
    {"city": "Maumusson"},
    {"city": "Meauzac"},
    {"city": "Merles"},
    {"city": "Mirabel"},
    {"city": "Miramont-de-Quercy"},
    {"city": "Moissac"},
    {"city": "Molières"},
    {"city": "Monbéqui"},
    {"city": "Monclar-de-Quercy"},
    {"city": "Montagudet"},
    {"city": "Montaigu-de-Quercy"},
    {"city": "Montaïn"},
    {"city": "Montalzat"},
    {"city": "Montastruc"},
    {"city": "Montauban"},
    {"city": "Montbarla"},
    {"city": "Montbartier"},
    {"city": "Montbeton"},
    {"city": "Montech"},
    {"city": "Monteils"},
    {"city": "Montesquieu"},
    {"city": "Montfermier"},
    {"city": "Montgaillard"},
    {"city": "Montjoi"},
    {"city": "Montpezat-de-Quercy"},
    {"city": "Montricoux"},
    {"city": "Mouillac"},
    {"city": "Nègrepelisse"},
    {"city": "Nohic"},
    {"city": "Orgueil"},
    {"city": "Parisot"},
    {"city": "Perville"},
    {"city": "Le Pin"},
    {"city": "Piquecos"},
    {"city": "Pommevic"},
    {"city": "Pompignan"},
    {"city": "Poupas"},
    {"city": "Puycornet"},
    {"city": "Puygaillard-de-Quercy"},
    {"city": "Puygaillard-de-Lomagne"},
    {"city": "Puylagarde"},
    {"city": "Puylaroque"},
    {"city": "Réalville"},
    {"city": "Reyniès"},
    {"city": "Roquecor"},
    {"city": "Saint-Aignan"},
    {"city": "Saint-Amans-du-Pech"},
    {"city": "Saint-Amans-de-Pellagal"},
    {"city": "Saint-Antonin-Noble-Val"},
    {"city": "Saint-Arroumex"},
    {"city": "Saint-Beauzeil"},
    {"city": "Saint-Cirice"},
    {"city": "Saint-Cirq"},
    {"city": "Saint-Clair"},
    {"city": "Saint-Étienne-de-Tulmont"},
    {"city": "Saint-Georges"},
    {"city": "Saint-Jean-du-Bouzet"},
    {"city": "Sainte-Juliette"},
    {"city": "Saint-Loup"},
    {"city": "Saint-Michel"},
    {"city": "Saint-Nauphary"},
    {"city": "Saint-Nazaire-de-Valentane"},
    {"city": "Saint-Nicolas-de-la-Grave"},
    {"city": "Saint-Paul-d'Espis"},
    {"city": "Saint-Porquier"},
    {"city": "Saint-Projet"},
    {"city": "Saint-Sardos"},
    {"city": "Saint-Vincent-d'Autéjac"},
    {"city": "Saint-Vincent-Lespinasse"},
    {"city": "La Salvetat-Belmontet"},
    {"city": "Sauveterre"},
    {"city": "Savenès"},
    {"city": "Septfonds"},
    {"city": "Sérignac"},
    {"city": "Sistels"},
    {"city": "Touffailles"},
    {"city": "Tréjouls"},
    {"city": "Vaïssac"},
    {"city": "Valeilles"},
    {"city": "Valence"},
    {"city": "Varen"},
    {"city": "Varennes"},
    {"city": "Vazerac"},
    {"city": "Verdun-sur-Garonne"},
    {"city": "Verfeil"},
    {"city": "Verlhac-Tescou"},
    {"city": "Vigueron"},
    {"city": "Villebrumier"},
    {"city": "Villemade"},
    {"city": "Les Adrets-de-l'Estérel"},
    {"city": "Aiguines"},
    {"city": "Ampus"},
    {"city": "Les Arcs"},
    {"city": "Artignosc-sur-Verdon"},
    {"city": "Artigues"},
    {"city": "Aups"},
    {"city": "Bagnols-en-Forêt"},
    {"city": "Bandol"},
    {"city": "Bargème"},
    {"city": "Bargemon"},
    {"city": "Barjols"},
    {"city": "La Bastide"},
    {"city": "Baudinard-sur-Verdon"},
    {"city": "Bauduen"},
    {"city": "Le Beausset"},
    {"city": "Belgentier"},
    {"city": "Besse-sur-Issole"},
    {"city": "Bormes-les-Mimosas"},
    {"city": "Le Bourguet"},
    {"city": "Bras"},
    {"city": "Brenon"},
    {"city": "Brignoles"},
    {"city": "Brue-Auriac"},
    {"city": "Cabasse"},
    {"city": "La Cadière-d'Azur"},
    {"city": "Callas"},
    {"city": "Callian"},
    {"city": "Camps-la-Source"},
    {"city": "Le Cannet-des-Maures"},
    {"city": "Carcès"},
    {"city": "Carnoules"},
    {"city": "Carqueiranne"},
    {"city": "Le Castellet"},
    {"city": "Cavalaire-sur-Mer"},
    {"city": "La Celle"},
    {"city": "Châteaudouble"},
    {"city": "Châteauvert"},
    {"city": "Châteauvieux"},
    {"city": "Claviers"},
    {"city": "Cogolin"},
    {"city": "Collobrières"},
    {"city": "Comps-sur-Artuby"},
    {"city": "Correns"},
    {"city": "Cotignac"},
    {"city": "La Crau"},
    {"city": "La Croix-Valmer"},
    {"city": "Cuers"},
    {"city": "Draguignan"},
    {"city": "Entrecasteaux"},
    {"city": "Esparron"},
    {"city": "Évenos"},
    {"city": "La Farlède"},
    {"city": "Fayence"},
    {"city": "Figanières"},
    {"city": "Flassans-sur-Issole"},
    {"city": "Flayosc"},
    {"city": "Forcalqueiret"},
    {"city": "Fox-Amphoux"},
    {"city": "Fréjus"},
    {"city": "La Garde"},
    {"city": "La Garde-Freinet"},
    {"city": "Garéoult"},
    {"city": "Gassin"},
    {"city": "Ginasservis"},
    {"city": "Gonfaron"},
    {"city": "Grimaud"},
    {"city": "Hyères"},
    {"city": "Le Lavandou"},
    {"city": "La Londe-les-Maures"},
    {"city": "Lorgues"},
    {"city": "Le Luc"},
    {"city": "La Martre"},
    {"city": "Les Mayons"},
    {"city": "Mazaugues"},
    {"city": "Méounes-lès-Montrieux"},
    {"city": "Moissac-Bellevue"},
    {"city": "La Môle"},
    {"city": "Mons"},
    {"city": "Montauroux"},
    {"city": "Montferrat"},
    {"city": "Montfort-sur-Argens"},
    {"city": "Montmeyan"},
    {"city": "La Motte"},
    {"city": "Le Muy"},
    {"city": "Nans-les-Pins"},
    {"city": "Néoules"},
    {"city": "Ollières"},
    {"city": "Ollioules"},
    {"city": "Pierrefeu-du-Var"},
    {"city": "Pignans"},
    {"city": "Plan-d'Aups-Sainte-Baume"},
    {"city": "Le Plan-de-la-Tour"},
    {"city": "Pontevès"},
    {"city": "Pourcieux"},
    {"city": "Pourrières"},
    {"city": "Le Pradet"},
    {"city": "Puget-sur-Argens"},
    {"city": "Puget-Ville"},
    {"city": "Ramatuelle"},
    {"city": "Régusse"},
    {"city": "Le Revest-les-Eaux"},
    {"city": "Rians"},
    {"city": "Riboux"},
    {"city": "Rocbaron"},
    {"city": "Roquebrune-sur-Argens"},
    {"city": "La Roquebrussanne"},
    {"city": "La Roque-Esclapon"},
    {"city": "Rougiers"},
    {"city": "Sainte-Anastasie-sur-Issole"},
    {"city": "Saint-Cyr-sur-Mer"},
    {"city": "Saint-Julien"},
    {"city": "Saint-Martin-de-Pallières"},
    {"city": "Sainte-Maxime"},
    {"city": "Saint-Maximin-la-Sainte-Baume"},
    {"city": "Saint-Paul-en-Forêt"},
    {"city": "Saint-Raphaël"},
    {"city": "Saint-Tropez"},
    {"city": "Saint-Zacharie"},
    {"city": "Salernes"},
    {"city": "Les Salles-sur-Verdon"},
    {"city": "Sanary-sur-Mer"},
    {"city": "Seillans"},
    {"city": "Seillons-Source-d'Argens"},
    {"city": "La Seyne-sur-Mer"},
    {"city": "Signes"},
    {"city": "Sillans-la-Cascade"},
    {"city": "Six-Fours-les-Plages"},
    {"city": "Solliès-Pont"},
    {"city": "Solliès-Toucas"},
    {"city": "Solliès-Ville"},
    {"city": "Tanneron"},
    {"city": "Taradeau"},
    {"city": "Tavernes"},
    {"city": "Le Thoronet"},
    {"city": "Toulon"},
    {"city": "Tourrettes"},
    {"city": "Tourtour"},
    {"city": "Tourves"},
    {"city": "Trans-en-Provence"},
    {"city": "Trigance"},
    {"city": "Le Val"},
    {"city": "La Valette-du-Var"},
    {"city": "Varages"},
    {"city": "La Verdière"},
    {"city": "Vérignon"},
    {"city": "Vidauban"},
    {"city": "Villecroze"},
    {"city": "Vinon-sur-Verdon"},
    {"city": "Vins-sur-Caramy"},
    {"city": "Rayol-Canadel-sur-Mer"},
    {"city": "Saint-Mandrier-sur-Mer"},
    {"city": "Saint-Antonin-du-Var"},
    {"city": "Althen-des-Paluds"},
    {"city": "Ansouis"},
    {"city": "Apt"},
    {"city": "Aubignan"},
    {"city": "Aurel"},
    {"city": "Auribeau"},
    {"city": "Avignon"},
    {"city": "Le Barroux"},
    {"city": "La Bastide-des-Jourdans"},
    {"city": "La Bastidonne"},
    {"city": "Le Beaucet"},
    {"city": "Beaumes-de-Venise"},
    {"city": "Beaumettes"},
    {"city": "Beaumont-de-Pertuis"},
    {"city": "Beaumont-du-Ventoux"},
    {"city": "Bédarrides"},
    {"city": "Bédoin"},
    {"city": "Blauvac"},
    {"city": "Bollène"},
    {"city": "Bonnieux"},
    {"city": "Brantes"},
    {"city": "Buisson"},
    {"city": "Buoux"},
    {"city": "Cabrières-d'Aigues"},
    {"city": "Cabrières-d'Avignon"},
    {"city": "Cadenet"},
    {"city": "Caderousse"},
    {"city": "Cairanne"},
    {"city": "Camaret-sur-Aigues"},
    {"city": "Caromb"},
    {"city": "Carpentras"},
    {"city": "Caseneuve"},
    {"city": "Castellet-en-Luberon"},
    {"city": "Caumont-sur-Durance"},
    {"city": "Cavaillon"},
    {"city": "Châteauneuf-de-Gadagne"},
    {"city": "Châteauneuf-du-Pape"},
    {"city": "Cheval-Blanc"},
    {"city": "Courthézon"},
    {"city": "Crestet"},
    {"city": "Crillon-le-Brave"},
    {"city": "Cucuron"},
    {"city": "Entraigues-sur-la-Sorgue"},
    {"city": "Entrechaux"},
    {"city": "Faucon"},
    {"city": "Flassan"},
    {"city": "Gargas"},
    {"city": "Gignac"},
    {"city": "Gigondas"},
    {"city": "Gordes"},
    {"city": "Goult"},
    {"city": "Grambois"},
    {"city": "Grillon"},
    {"city": "L'Isle-sur-la-Sorgue"},
    {"city": "Jonquerettes"},
    {"city": "Jonquières"},
    {"city": "Joucas"},
    {"city": "Lacoste"},
    {"city": "Lafare"},
    {"city": "Lagarde-d'Apt"},
    {"city": "Lagarde-Paréol"},
    {"city": "Lagnes"},
    {"city": "Lamotte-du-Rhône"},
    {"city": "Lapalud"},
    {"city": "Lauris"},
    {"city": "Lioux"},
    {"city": "Loriol-du-Comtat"},
    {"city": "Lourmarin"},
    {"city": "Malaucène"},
    {"city": "Malemort-du-Comtat"},
    {"city": "Maubec"},
    {"city": "Mazan"},
    {"city": "Ménerbes"},
    {"city": "Mérindol"},
    {"city": "Méthamis"},
    {"city": "Mirabeau"},
    {"city": "Modène"},
    {"city": "Mondragon"},
    {"city": "Monieux"},
    {"city": "Monteux"},
    {"city": "Morières-lès-Avignon"},
    {"city": "Mormoiron"},
    {"city": "Mornas"},
    {"city": "La Motte-d'Aigues"},
    {"city": "Murs"},
    {"city": "Oppède"},
    {"city": "Orange"},
    {"city": "Pernes-les-Fontaines"},
    {"city": "Pertuis"},
    {"city": "Peypin-d'Aigues"},
    {"city": "Piolenc"},
    {"city": "Le Pontet"},
    {"city": "Puget"},
    {"city": "Puyméras"},
    {"city": "Puyvert"},
    {"city": "Rasteau"},
    {"city": "Richerenches"},
    {"city": "Roaix"},
    {"city": "Robion"},
    {"city": "La Roque-Alric"},
    {"city": "La Roque-sur-Pernes"},
    {"city": "Roussillon"},
    {"city": "Rustrel"},
    {"city": "Sablet"},
    {"city": "Saignon"},
    {"city": "Sainte-Cécile-les-Vignes"},
    {"city": "Saint-Christol"},
    {"city": "Saint-Didier"},
    {"city": "Saint-Hippolyte-le-Graveyron"},
    {"city": "Saint-Léger-du-Ventoux"},
    {"city": "Saint-Marcellin-lès-Vaison"},
    {"city": "Saint-Martin-de-Castillon"},
    {"city": "Saint-Martin-de-la-Brasque"},
    {"city": "Saint-Pantaléon"},
    {"city": "Saint-Pierre-de-Vassols"},
    {"city": "Saint-Romain-en-Viennois"},
    {"city": "Saint-Roman-de-Malegarde"},
    {"city": "Saint-Saturnin-lès-Apt"},
    {"city": "Saint-Saturnin-lès-Avignon"},
    {"city": "Saint-Trinit"},
    {"city": "Sannes"},
    {"city": "Sarrians"},
    {"city": "Sault"},
    {"city": "Saumane-de-Vaucluse"},
    {"city": "Savoillan"},
    {"city": "Séguret"},
    {"city": "Sérignan-du-Comtat"},
    {"city": "Sivergues"},
    {"city": "Sorgues"},
    {"city": "Suzette"},
    {"city": "Taillades"},
    {"city": "Le Thor"},
    {"city": "La Tour-d'Aigues"},
    {"city": "Travaillan"},
    {"city": "Uchaux"},
    {"city": "Vacqueyras"},
    {"city": "Vaison-la-Romaine"},
    {"city": "Valréas"},
    {"city": "Fontaine-de-Vaucluse"},
    {"city": "Vaugines"},
    {"city": "Vedène"},
    {"city": "Velleron"},
    {"city": "Venasque"},
    {"city": "Viens"},
    {"city": "Villars"},
    {"city": "Villedieu"},
    {"city": "Villelaure"},
    {"city": "Villes-sur-Auzon"},
    {"city": "Violès"},
    {"city": "Visan"},
    {"city": "Vitrolles-en-Lubéron"},
    {"city": "L'Aiguillon-sur-Mer"},
    {"city": "L'Aiguillon-sur-Vie"},
    {"city": "Aizenay"},
    {"city": "Angles"},
    {"city": "Antigny"},
    {"city": "Apremont"},
    {"city": "Aubigny-Les Clouzeaux"},
    {"city": "Auchay-sur-Vendée"},
    {"city": "Avrillé"},
    {"city": "Barbâtre"},
    {"city": "La Barre-de-Monts"},
    {"city": "Bazoges-en-Paillers"},
    {"city": "Bazoges-en-Pareds"},
    {"city": "Beaufou"},
    {"city": "Beaulieu-sous-la-Roche"},
    {"city": "Beaurepaire"},
    {"city": "Beauvoir-sur-Mer"},
    {"city": "Bellevigny"},
    {"city": "Benet"},
    {"city": "La Bernardière"},
    {"city": "Le Bernard"},
    {"city": "Bessay"},
    {"city": "Bois-de-Céné"},
    {"city": "La Boissière-de-Montaigu"},
    {"city": "La Boissière-des-Landes"},
    {"city": "Bouillé-Courdault"},
    {"city": "Bouin"},
    {"city": "Le Boupère"},
    {"city": "Bourneau"},
    {"city": "Bournezeau"},
    {"city": "Bretignolles-sur-Mer"},
    {"city": "La Bretonnière-la-Claye"},
    {"city": "Breuil-Barret"},
    {"city": "Les Brouzils"},
    {"city": "La Bruffière"},
    {"city": "La Caillère-Saint-Hilaire"},
    {"city": "Cezais"},
    {"city": "Chaillé-les-Marais"},
    {"city": "La Chaize-Giraud"},
    {"city": "La Chaize-le-Vicomte"},
    {"city": "Challans"},
    {"city": "Champagné-les-Marais"},
    {"city": "Le Champ-Saint-Père"},
    {"city": "Chantonnay"},
    {"city": "La Chapelle-aux-Lys"},
    {"city": "La Chapelle-Hermier"},
    {"city": "La Chapelle-Palluau"},
    {"city": "La Chapelle-Thémer"},
    {"city": "Chasnais"},
    {"city": "La Châtaigneraie"},
    {"city": "Château-Guibert"},
    {"city": "Châteauneuf"},
    {"city": "Chauché"},
    {"city": "Chavagnes-en-Paillers"},
    {"city": "Chavagnes-les-Redoux"},
    {"city": "Cheffois"},
    {"city": "Coëx"},
    {"city": "Commequiers"},
    {"city": "La Copechagnière"},
    {"city": "Corpe"},
    {"city": "La Couture"},
    {"city": "Cugand"},
    {"city": "Curzon"},
    {"city": "Damvix"},
    {"city": "Doix lès Fontaines"},
    {"city": "Dompierre-sur-Yon"},
    {"city": "Les Epesses"},
    {"city": "L'Épine"},
    {"city": "Essarts en Bocage"},
    {"city": "Falleron"},
    {"city": "Faymoreau"},
    {"city": "Le Fenouiller"},
    {"city": "La Ferrière"},
    {"city": "Sèvremont"},
    {"city": "Fontenay-le-Comte"},
    {"city": "Fougeré"},
    {"city": "Foussais-Payré"},
    {"city": "Froidfond"},
    {"city": "La Garnache"},
    {"city": "La Gaubretière"},
    {"city": "La Genétouze"},
    {"city": "Le Girouard"},
    {"city": "Givrand"},
    {"city": "Le Givre"},
    {"city": "Grand'Landes"},
    {"city": "Grosbreuil"},
    {"city": "Grues"},
    {"city": "Le Gué-de-Velluire"},
    {"city": "La Guérinière"},
    {"city": "L'Herbergement"},
    {"city": "Les Herbiers"},
    {"city": "L'Hermenault"},
    {"city": "L'Île-d'Elle"},
    {"city": "L'Île-d'Olonne"},
    {"city": "L'Île-d'Yeu"},
    {"city": "Jard-sur-Mer"},
    {"city": "La Jaudonnière"},
    {"city": "La Jonchère"},
    {"city": "Lairoux"},
    {"city": "Landeronde"},
    {"city": "Les Landes-Genusson"},
    {"city": "Landevieille"},
    {"city": "Le Langon"},
    {"city": "Liez"},
    {"city": "Loge-Fougereuse"},
    {"city": "Longèves"},
    {"city": "Longeville-sur-Mer"},
    {"city": "Luçon"},
    {"city": "Les Lucs-sur-Boulogne"},
    {"city": "Maché"},
    {"city": "Les Magnils-Reigniers"},
    {"city": "Maillé"},
    {"city": "Maillezais"},
    {"city": "Mallièvre"},
    {"city": "Mareuil-sur-Lay-Dissais"},
    {"city": "Marillet"},
    {"city": "Marsais-Sainte-Radégonde"},
    {"city": "Martinet"},
    {"city": "Le Mazeau"},
    {"city": "La Meilleraie-Tillay"},
    {"city": "Menomblet"},
    {"city": "La Merlatière"},
    {"city": "Mervent"},
    {"city": "Mesnard-la-Barotière"},
    {"city": "Monsireigne"},
    {"city": "Montaigu-Vendée"},
    {"city": "Montournais"},
    {"city": "Montreuil"},
    {"city": "Moreilles"},
    {"city": "Mortagne-sur-Sèvre"},
    {"city": "Les Achards"},
    {"city": "Mouchamps"},
    {"city": "Mouilleron-Saint-Germain"},
    {"city": "Mouilleron-le-Captif"},
    {"city": "Moutiers-les-Mauxfaits"},
    {"city": "Moutiers-sur-le-Lay"},
    {"city": "Mouzeuil-Saint-Martin"},
    {"city": "Nalliers"},
    {"city": "Nesmy"},
    {"city": "Nieul-le-Dolent"},
    {"city": "Rives-d'Autise"},
    {"city": "Noirmoutier-en-l'Île"},
    {"city": "Notre-Dame-de-Monts"},
    {"city": "L'Orbrie"},
    {"city": "Palluau"},
    {"city": "Péault"},
    {"city": "Le Perrier"},
    {"city": "Petosse"},
    {"city": "Les Pineaux"},
    {"city": "Pissotte"},
    {"city": "Les Velluire-sur-Vendée"},
    {"city": "Le Poiré-sur-Vie"},
    {"city": "Poiroux"},
    {"city": "Pouillé"},
    {"city": "Pouzauges"},
    {"city": "Puy-de-Serre"},
    {"city": "Puyravault"},
    {"city": "La Rabatelière"},
    {"city": "Réaumur"},
    {"city": "La Réorthe"},
    {"city": "Notre-Dame-de-Riez"},
    {"city": "Rocheservière"},
    {"city": "La Roche-sur-Yon"},
    {"city": "Rochetrejoux"},
    {"city": "Rosnay"},
    {"city": "Les Sables-d'Olonne"},
    {"city": "Saint-André-Goule-d'Oie"},
    {"city": "Montréverd"},
    {"city": "Saint-Aubin-des-Ormeaux"},
    {"city": "Saint-Aubin-la-Plaine"},
    {"city": "Saint-Avaugourd-des-Landes"},
    {"city": "Saint-Benoist-sur-Mer"},
    {"city": "Sainte-Cécile"},
    {"city": "Saint-Christophe-du-Ligneron"},
    {"city": "Saint-Cyr-des-Gâts"},
    {"city": "Saint-Cyr-en-Talmondais"},
    {"city": "Saint-Denis-du-Payré"},
    {"city": "Saint-Denis-la-Chevasse"},
    {"city": "Saint-Étienne-de-Brillouet"},
    {"city": "Saint-Étienne-du-Bois"},
    {"city": "Sainte-Flaive-des-Loups"},
    {"city": "Rives de l'Yon"},
    {"city": "Sainte-Foy"},
    {"city": "Saint-Fulgent"},
    {"city": "Sainte-Gemme-la-Plaine"},
    {"city": "Saint-Georges-de-Pointindoux"},
    {"city": "Saint-Germain-de-Prinçay"},
    {"city": "Saint-Gervais"},
    {"city": "Saint-Gilles-Croix-de-Vie"},
    {"city": "Sainte-Hermine"},
    {"city": "Saint-Hilaire-de-Riez"},
    {"city": "Saint-Hilaire-des-Loges"},
    {"city": "Saint-Hilaire-de-Voust"},
    {"city": "Saint-Hilaire-la-Forêt"},
    {"city": "Saint-Hilaire-le-Vouhis"},
    {"city": "Saint-Jean-de-Beugné"},
    {"city": "Saint-Jean-de-Monts"},
    {"city": "Saint-Juire-Champgillon"},
    {"city": "Saint-Julien-des-Landes"},
    {"city": "Saint-Laurent-de-la-Salle"},
    {"city": "Saint-Laurent-sur-Sèvre"},
    {"city": "Saint-Maixent-sur-Vie"},
    {"city": "Saint-Malô-du-Bois"},
    {"city": "Saint-Mars-la-Réorthe"},
    {"city": "Brem-sur-Mer"},
    {"city": "Saint-Martin-de-Fraigneau"},
    {"city": "Saint-Martin-des-Fontaines"},
    {"city": "Saint-Martin-des-Noyers"},
    {"city": "Saint-Martin-des-Tilleuls"},
    {"city": "Saint-Martin-Lars-en-Sainte-Hermine"},
    {"city": "Saint-Mathurin"},
    {"city": "Saint-Maurice-des-Noues"},
    {"city": "Saint-Maurice-le-Girard"},
    {"city": "Saint-Mesmin"},
    {"city": "Saint-Michel-en-l'Herm"},
    {"city": "Saint-Michel-le-Cloucq"},
    {"city": "Saint-Paul-en-Pareds"},
    {"city": "Saint-Paul-Mont-Penit"},
    {"city": "Sainte-Pexine"},
    {"city": "Saint-Philbert-de-Bouaine"},
    {"city": "Saint-Pierre-du-Chemin"},
    {"city": "Saint-Pierre-le-Vieux"},
    {"city": "Saint-Prouant"},
    {"city": "Sainte-Radégonde-des-Noyers"},
    {"city": "Saint-Révérend"},
    {"city": "Saint-Sigismond"},
    {"city": "Saint-Sulpice-en-Pareds"},
    {"city": "Saint-Urbain"},
    {"city": "Saint-Valérien"},
    {"city": "Saint-Vincent-Sterlanges"},
    {"city": "Saint-Vincent-sur-Graon"},
    {"city": "Saint-Vincent-sur-Jard"},
    {"city": "Sallertaine"},
    {"city": "Sérigné"},
    {"city": "Sigournais"},
    {"city": "Soullans"},
    {"city": "Le Tablier"},
    {"city": "La Taillée"},
    {"city": "Tallud-Sainte-Gemme"},
    {"city": "Talmont-Saint-Hilaire"},
    {"city": "La Tardière"},
    {"city": "Thiré"},
    {"city": "Thorigny"},
    {"city": "Thouarsais-Bouildroux"},
    {"city": "Tiffauges"},
    {"city": "La Tranche-sur-Mer"},
    {"city": "Treize-Septiers"},
    {"city": "Treize-Vents"},
    {"city": "Triaize"},
    {"city": "Vairé"},
    {"city": "Venansault"},
    {"city": "Vendrennes"},
    {"city": "Chanverrie"},
    {"city": "Vix"},
    {"city": "Vouillé-les-Marais"},
    {"city": "Vouvant"},
    {"city": "Xanton-Chassenon"},
    {"city": "La Faute-sur-Mer"},
    {"city": "Adriers"},
    {"city": "Amberre"},
    {"city": "Anché"},
    {"city": "Angles-sur-l'Anglin"},
    {"city": "Angliers"},
    {"city": "Antigny"},
    {"city": "Antran"},
    {"city": "Arçay"},
    {"city": "Archigny"},
    {"city": "Aslonnes"},
    {"city": "Asnières-sur-Blour"},
    {"city": "Asnois"},
    {"city": "Aulnay"},
    {"city": "Availles-en-Châtellerault"},
    {"city": "Availles-Limouzine"},
    {"city": "Avanton"},
    {"city": "Ayron"},
    {"city": "Basses"},
    {"city": "Beaumont Saint-Cyr"},
    {"city": "Bellefonds"},
    {"city": "Berrie"},
    {"city": "Berthegon"},
    {"city": "Béruges"},
    {"city": "Béthines"},
    {"city": "Beuxes"},
    {"city": "Biard"},
    {"city": "Bignoux"},
    {"city": "Blanzay"},
    {"city": "Bonnes"},
    {"city": "Bonneuil-Matours"},
    {"city": "Bouresse"},
    {"city": "Bourg-Archambault"},
    {"city": "Bournand"},
    {"city": "Brigueil-le-Chantre"},
    {"city": "Brion"},
    {"city": "Brux"},
    {"city": "La Bussière"},
    {"city": "Buxerolles"},
    {"city": "Buxeuil"},
    {"city": "Ceaux-en-Loudun"},
    {"city": "Celle-Lévescault"},
    {"city": "Cenon-sur-Vienne"},
    {"city": "Cernay"},
    {"city": "Chabournay"},
    {"city": "Chalais"},
    {"city": "Chalandray"},
    {"city": "Champagné-le-Sec"},
    {"city": "Champagné-Saint-Hilaire"},
    {"city": "Champigny en Rochereau"},
    {"city": "Champniers"},
    {"city": "La Chapelle-Bâton"},
    {"city": "La Chapelle-Moulière"},
    {"city": "Chapelle-Viviers"},
    {"city": "Charroux"},
    {"city": "Chasseneuil-du-Poitou"},
    {"city": "Chatain"},
    {"city": "Château-Garnier"},
    {"city": "Château-Larcher"},
    {"city": "Châtellerault"},
    {"city": "Chaunay"},
    {"city": "La Chaussée"},
    {"city": "Chauvigny"},
    {"city": "Chenevelles"},
    {"city": "Cherves"},
    {"city": "Chiré-en-Montreuil"},
    {"city": "Chouppes"},
    {"city": "Cissé"},
    {"city": "Civaux"},
    {"city": "Civray"},
    {"city": "La Roche-Rigault"},
    {"city": "Cloué"},
    {"city": "Colombiers"},
    {"city": "Valence-en-Poitou"},
    {"city": "Coulombiers"},
    {"city": "Coulonges"},
    {"city": "Coussay"},
    {"city": "Coussay-les-Bois"},
    {"city": "Craon"},
    {"city": "Croutelle"},
    {"city": "Cuhon"},
    {"city": "Curçay-sur-Dive"},
    {"city": "Curzay-sur-Vonne"},
    {"city": "Dangé-Saint-Romain"},
    {"city": "Dercé"},
    {"city": "Dienné"},
    {"city": "Dissay"},
    {"city": "Doussay"},
    {"city": "La Ferrière-Airoux"},
    {"city": "Fleix"},
    {"city": "Fleuré"},
    {"city": "Fontaine-le-Comte"},
    {"city": "Frozes"},
    {"city": "Gençay"},
    {"city": "Genouillé"},
    {"city": "Gizay"},
    {"city": "Glénouze"},
    {"city": "Gouex"},
    {"city": "La Grimaudière"},
    {"city": "Guesnes"},
    {"city": "Haims"},
    {"city": "Ingrandes"},
    {"city": "L'Isle-Jourdain"},
    {"city": "Iteuil"},
    {"city": "Jardres"},
    {"city": "Jaunay-Marigny"},
    {"city": "Jazeneuil"},
    {"city": "Jouhet"},
    {"city": "Journet"},
    {"city": "Joussé"},
    {"city": "Lathus-Saint-Rémy"},
    {"city": "Latillé"},
    {"city": "Lauthiers"},
    {"city": "Boivre-la-Vallée"},
    {"city": "Lavoux"},
    {"city": "Leigné-les-Bois"},
    {"city": "Leignes-sur-Fontaine"},
    {"city": "Leigné-sur-Usseau"},
    {"city": "Lencloître"},
    {"city": "Lésigny"},
    {"city": "Leugny"},
    {"city": "Lhommaizé"},
    {"city": "Liglet"},
    {"city": "Ligugé"},
    {"city": "Linazay"},
    {"city": "Liniers"},
    {"city": "Lizant"},
    {"city": "Loudun"},
    {"city": "Luchapt"},
    {"city": "Lusignan"},
    {"city": "Lussac-les-Châteaux"},
    {"city": "Magné"},
    {"city": "Maillé"},
    {"city": "Mairé"},
    {"city": "Maisonneuve"},
    {"city": "Marçay"},
    {"city": "Marigny-Chemereau"},
    {"city": "Marnay"},
    {"city": "Martaizé"},
    {"city": "Massognes"},
    {"city": "Maulay"},
    {"city": "Mauprévoir"},
    {"city": "Mazerolles"},
    {"city": "Mazeuil"},
    {"city": "Messemé"},
    {"city": "Mignaloux-Beauvoir"},
    {"city": "Migné-Auxances"},
    {"city": "Millac"},
    {"city": "Mirebeau"},
    {"city": "Moncontour"},
    {"city": "Mondion"},
    {"city": "Montamisé"},
    {"city": "Monthoiron"},
    {"city": "Montmorillon"},
    {"city": "Monts-sur-Guesnes"},
    {"city": "Morton"},
    {"city": "Moulismes"},
    {"city": "Moussac"},
    {"city": "Mouterre-sur-Blourde"},
    {"city": "Mouterre-Silly"},
    {"city": "Naintré"},
    {"city": "Nalliers"},
    {"city": "Nérignac"},
    {"city": "Neuville-de-Poitou"},
    {"city": "Nieuil-l'Espoir"},
    {"city": "Nouaillé-Maupertuis"},
    {"city": "Nueil-sous-Faye"},
    {"city": "Orches"},
    {"city": "Les Ormes"},
    {"city": "Ouzilly"},
    {"city": "Oyré"},
    {"city": "Paizay-le-Sec"},
    {"city": "Payroux"},
    {"city": "Persac"},
    {"city": "Pindray"},
    {"city": "Plaisance"},
    {"city": "Pleumartin"},
    {"city": "Poitiers"},
    {"city": "Port-de-Piles"},
    {"city": "Pouançay"},
    {"city": "Pouant"},
    {"city": "Pouillé"},
    {"city": "Pressac"},
    {"city": "Prinçay"},
    {"city": "La Puye"},
    {"city": "Queaux"},
    {"city": "Quinçay"},
    {"city": "Ranton"},
    {"city": "Raslay"},
    {"city": "La Roche-Posay"},
    {"city": "Roches-Prémarie-Andillé"},
    {"city": "Roiffé"},
    {"city": "Romagne"},
    {"city": "Rouillé"},
    {"city": "Saint-Benoît"},
    {"city": "Saint-Christophe"},
    {"city": "Saint-Clair"},
    {"city": "Saint-Gaudent"},
    {"city": "Saint-Genest-d'Ambière"},
    {"city": "Saint-Georges-lès-Baillargeaux"},
    {"city": "Saint-Germain"},
    {"city": "Saint-Gervais-les-Trois-Clochers"},
    {"city": "Saint-Jean-de-Sauves"},
    {"city": "Saint-Julien-l'Ars"},
    {"city": "Saint-Laon"},
    {"city": "Saint-Laurent-de-Jourdes"},
    {"city": "Saint-Léger-de-Montbrillais"},
    {"city": "Saint-Léomer"},
    {"city": "Saint-Macoux"},
    {"city": "Valdivienne"},
    {"city": "Saint-Martin-l'Ars"},
    {"city": "Saint-Maurice-la-Clouère"},
    {"city": "Saint-Pierre-de-Maillé"},
    {"city": "Saint-Pierre-d'Exideuil"},
    {"city": "Sainte-Radégonde"},
    {"city": "Saint-Rémy-sur-Creuse"},
    {"city": "Saint-Romain"},
    {"city": "Saint-Sauvant"},
    {"city": "Senillé-Saint-Sauveur"},
    {"city": "Saint-Savin"},
    {"city": "Saint-Saviol"},
    {"city": "Saint-Secondin"},
    {"city": "Saires"},
    {"city": "Saix"},
    {"city": "Sammarçolles"},
    {"city": "Sanxay"},
    {"city": "Saulgé"},
    {"city": "Savigné"},
    {"city": "Savigny-Lévescault"},
    {"city": "Savigny-sous-Faye"},
    {"city": "Scorbé-Clairvaux"},
    {"city": "Sérigny"},
    {"city": "Sèvres-Anxaumont"},
    {"city": "Sillars"},
    {"city": "Smarves"},
    {"city": "Sommières-du-Clain"},
    {"city": "Sossais"},
    {"city": "Surin"},
    {"city": "Tercé"},
    {"city": "Ternay"},
    {"city": "Thollet"},
    {"city": "Thurageau"},
    {"city": "Thuré"},
    {"city": "La Trimouille"},
    {"city": "Les Trois-Moutiers"},
    {"city": "Usseau"},
    {"city": "Usson-du-Poitou"},
    {"city": "Vaux-sur-Vienne"},
    {"city": "Vellèches"},
    {"city": "Saint-Martin-la-Pallu"},
    {"city": "Vernon"},
    {"city": "Verrières"},
    {"city": "Verrue"},
    {"city": "Vézières"},
    {"city": "Vicq-sur-Gartempe"},
    {"city": "Le Vigeant"},
    {"city": "La Villedieu-du-Clain"},
    {"city": "Villemort"},
    {"city": "Villiers"},
    {"city": "Vivonne"},
    {"city": "Vouillé"},
    {"city": "Voulême"},
    {"city": "Voulon"},
    {"city": "Vouneuil-sous-Biard"},
    {"city": "Vouneuil-sur-Vienne"},
    {"city": "Vouzailles"},
    {"city": "Yversay"},
    {"city": "Aixe-sur-Vienne"},
    {"city": "Ambazac"},
    {"city": "Arnac-la-Poste"},
    {"city": "Augne"},
    {"city": "Aureil"},
    {"city": "Azat-le-Ris"},
    {"city": "Balledent"},
    {"city": "La Bazeuge"},
    {"city": "Beaumont-du-Lac"},
    {"city": "Bellac"},
    {"city": "Berneuil"},
    {"city": "Bersac-sur-Rivalier"},
    {"city": "Bessines-sur-Gartempe"},
    {"city": "Beynac"},
    {"city": "Les Billanges"},
    {"city": "Blanzac"},
    {"city": "Blond"},
    {"city": "Boisseuil"},
    {"city": "Bonnac-la-Côte"},
    {"city": "Bosmie-l'Aiguille"},
    {"city": "Breuilaufa"},
    {"city": "Le Buis"},
    {"city": "Bujaleuf"},
    {"city": "Burgnac"},
    {"city": "Bussière-Galant"},
    {"city": "Val-d'Oire-et-Gartempe"},
    {"city": "Les Cars"},
    {"city": "Chaillac-sur-Vienne"},
    {"city": "Le Chalard"},
    {"city": "Châlus"},
    {"city": "Chamboret"},
    {"city": "Champagnac-la-Rivière"},
    {"city": "Champnétery"},
    {"city": "Champsac"},
    {"city": "La Chapelle-Montbrandeix"},
    {"city": "Chaptelat"},
    {"city": "Château-Chervix"},
    {"city": "Châteauneuf-la-Forêt"},
    {"city": "Châteauponsac"},
    {"city": "Le Châtenet-en-Dognon"},
    {"city": "Cheissoux"},
    {"city": "Chéronnac"},
    {"city": "Cieux"},
    {"city": "Cognac-la-Forêt"},
    {"city": "Compreignac"},
    {"city": "Condat-sur-Vienne"},
    {"city": "Coussac-Bonneval"},
    {"city": "Couzeix"},
    {"city": "La Croisille-sur-Briance"},
    {"city": "La Croix-sur-Gartempe"},
    {"city": "Cromac"},
    {"city": "Cussac"},
    {"city": "Dinsac"},
    {"city": "Dompierre-les-Églises"},
    {"city": "Domps"},
    {"city": "Le Dorat"},
    {"city": "Dournazac"},
    {"city": "Droux"},
    {"city": "Eybouleuf"},
    {"city": "Eyjeaux"},
    {"city": "Eymoutiers"},
    {"city": "Feytiat"},
    {"city": "Flavignac"},
    {"city": "Folles"},
    {"city": "Fromental"},
    {"city": "Gajoubert"},
    {"city": "La Geneytouse"},
    {"city": "Glandon"},
    {"city": "Glanges"},
    {"city": "Gorre"},
    {"city": "Les Grands-Chézeaux"},
    {"city": "Isle"},
    {"city": "Jabreilles-les-Bordes"},
    {"city": "Janailhac"},
    {"city": "Javerdat"},
    {"city": "La Jonchère-Saint-Maurice"},
    {"city": "Jouac"},
    {"city": "Jourgnac"},
    {"city": "Ladignac-le-Long"},
    {"city": "Laurière"},
    {"city": "Lavignac"},
    {"city": "Limoges"},
    {"city": "Linards"},
    {"city": "Lussac-les-Églises"},
    {"city": "Magnac-Bourg"},
    {"city": "Magnac-Laval"},
    {"city": "Mailhac-sur-Benaize"},
    {"city": "Maisonnais-sur-Tardoire"},
    {"city": "Marval"},
    {"city": "Masléon"},
    {"city": "Meilhac"},
    {"city": "Meuzac"},
    {"city": "La Meyze"},
    {"city": "Val d'Issoire"},
    {"city": "Moissannes"},
    {"city": "Montrol-Sénard"},
    {"city": "Mortemart"},
    {"city": "Nantiat"},
    {"city": "Nedde"},
    {"city": "Neuvic-Entier"},
    {"city": "Nexon"},
    {"city": "Nieul"},
    {"city": "Nouic"},
    {"city": "Oradour-Saint-Genest"},
    {"city": "Oradour-sur-Glane"},
    {"city": "Oradour-sur-Vayres"},
    {"city": "Pageas"},
    {"city": "Le Palais-sur-Vienne"},
    {"city": "Panazol"},
    {"city": "Pensol"},
    {"city": "Peyrat-de-Bellac"},
    {"city": "Peyrat-le-Château"},
    {"city": "Peyrilhac"},
    {"city": "Pierre-Buffière"},
    {"city": "La Porcherie"},
    {"city": "Rancon"},
    {"city": "Razès"},
    {"city": "Rempnat"},
    {"city": "Rilhac-Lastours"},
    {"city": "Rilhac-Rancon"},
    {"city": "Rochechouart"},
    {"city": "La Roche-l'Abeille"},
    {"city": "Saint-Pardoux-le-Lac"},
    {"city": "Royères"},
    {"city": "Roziers-Saint-Georges"},
    {"city": "Saillat-sur-Vienne"},
    {"city": "Saint-Amand-le-Petit"},
    {"city": "Saint-Amand-Magnazeix"},
    {"city": "Sainte-Anne-Saint-Priest"},
    {"city": "Saint-Auvent"},
    {"city": "Saint-Bazile"},
    {"city": "Saint-Bonnet-Briance"},
    {"city": "Saint-Bonnet-de-Bellac"},
    {"city": "Saint-Brice-sur-Vienne"},
    {"city": "Saint-Cyr"},
    {"city": "Saint-Denis-des-Murs"},
    {"city": "Saint-Gence"},
    {"city": "Saint-Genest-sur-Roselle"},
    {"city": "Saint-Georges-les-Landes"},
    {"city": "Saint-Germain-les-Belles"},
    {"city": "Saint-Gilles-les-Forêts"},
    {"city": "Saint-Hilaire-Bonneval"},
    {"city": "Saint-Hilaire-la-Treille"},
    {"city": "Saint-Hilaire-les-Places"},
    {"city": "Saint-Jean-Ligoure"},
    {"city": "Saint-Jouvent"},
    {"city": "Saint-Julien-le-Petit"},
    {"city": "Saint-Junien"},
    {"city": "Saint-Junien-les-Combes"},
    {"city": "Saint-Just-le-Martel"},
    {"city": "Saint-Laurent-les-Églises"},
    {"city": "Saint-Laurent-sur-Gorre"},
    {"city": "Saint-Léger-la-Montagne"},
    {"city": "Saint-Léger-Magnazeix"},
    {"city": "Saint-Léonard-de-Noblat"},
    {"city": "Sainte-Marie-de-Vaux"},
    {"city": "Saint-Martial-sur-Isop"},
    {"city": "Saint-Martin-de-Jussac"},
    {"city": "Saint-Martin-le-Mault"},
    {"city": "Saint-Martin-le-Vieux"},
    {"city": "Saint-Martin-Terressus"},
    {"city": "Saint-Mathieu"},
    {"city": "Saint-Maurice-les-Brousses"},
    {"city": "Saint-Méard"},
    {"city": "Saint-Ouen-sur-Gartempe"},
    {"city": "Saint-Paul"},
    {"city": "Saint-Priest-Ligoure"},
    {"city": "Saint-Priest-sous-Aixe"},
    {"city": "Saint-Priest-Taurion"},
    {"city": "Saint-Sornin-la-Marche"},
    {"city": "Saint-Sornin-Leulac"},
    {"city": "Saint-Sulpice-Laurière"},
    {"city": "Saint-Sulpice-les-Feuilles"},
    {"city": "Saint-Sylvestre"},
    {"city": "Saint-Victurnien"},
    {"city": "Saint-Vitte-sur-Briance"},
    {"city": "Saint-Yrieix-la-Perche"},
    {"city": "Saint-Yrieix-sous-Aixe"},
    {"city": "Les Salles-Lavauguyon"},
    {"city": "Sauviat-sur-Vige"},
    {"city": "Séreilhac"},
    {"city": "Solignac"},
    {"city": "Surdoux"},
    {"city": "Sussac"},
    {"city": "Tersannes"},
    {"city": "Thouron"},
    {"city": "Vaulry"},
    {"city": "Vayres"},
    {"city": "Verneuil-Moustiers"},
    {"city": "Verneuil-sur-Vienne"},
    {"city": "Veyrac"},
    {"city": "Vicq-sur-Breuilh"},
    {"city": "Videix"},
    {"city": "Le Vigen"},
    {"city": "Villefavard"},
    {"city": "Les Ableuvenettes"},
    {"city": "Ahéville"},
    {"city": "Aingeville"},
    {"city": "Ainvelle"},
    {"city": "Allarmont"},
    {"city": "Ambacourt"},
    {"city": "Ameuvelle"},
    {"city": "Anglemont"},
    {"city": "Anould"},
    {"city": "Aouze"},
    {"city": "Arches"},
    {"city": "Archettes"},
    {"city": "Aroffe"},
    {"city": "Arrentès-de-Corcieux"},
    {"city": "Attignéville"},
    {"city": "Attigny"},
    {"city": "Aulnois"},
    {"city": "Autigny-la-Tour"},
    {"city": "Autreville"},
    {"city": "Autrey"},
    {"city": "Auzainvilliers"},
    {"city": "Avillers"},
    {"city": "Avrainville"},
    {"city": "Avranville"},
    {"city": "Aydoilles"},
    {"city": "Badménil-aux-Bois"},
    {"city": "La Baffe"},
    {"city": "La Vôge-les-Bains"},
    {"city": "Bainville-aux-Saules"},
    {"city": "Balléville"},
    {"city": "Ban-de-Laveline"},
    {"city": "Ban-de-Sapt"},
    {"city": "Barbey-Seroux"},
    {"city": "Barville"},
    {"city": "Basse-sur-le-Rupt"},
    {"city": "Battexey"},
    {"city": "Baudricourt"},
    {"city": "Bayecourt"},
    {"city": "Bazegney"},
    {"city": "Bazien"},
    {"city": "Bazoilles-et-Ménil"},
    {"city": "Bazoilles-sur-Meuse"},
    {"city": "Beaufremont"},
    {"city": "Beauménil"},
    {"city": "Begnécourt"},
    {"city": "Bellefontaine"},
    {"city": "Belmont-lès-Darney"},
    {"city": "Belmont-sur-Buttant"},
    {"city": "Belmont-sur-Vair"},
    {"city": "Belrupt"},
    {"city": "Belval"},
    {"city": "Bertrimoutier"},
    {"city": "Bettegney-Saint-Brice"},
    {"city": "Bettoncourt"},
    {"city": "Le Beulay"},
    {"city": "Biécourt"},
    {"city": "Biffontaine"},
    {"city": "Blémerey"},
    {"city": "Bleurville"},
    {"city": "Blevaincourt"},
    {"city": "Bocquegney"},
    {"city": "Bois-de-Champ"},
    {"city": "Bonvillet"},
    {"city": "Boulaincourt"},
    {"city": "La Bourgonce"},
    {"city": "Bouxières-aux-Bois"},
    {"city": "Bouxurulles"},
    {"city": "Bouzemont"},
    {"city": "Brantigny"},
    {"city": "Brechainville"},
    {"city": "La Bresse"},
    {"city": "Brouvelieures"},
    {"city": "Brû"},
    {"city": "Bruyères"},
    {"city": "Bulgnéville"},
    {"city": "Bult"},
    {"city": "Bussang"},
    {"city": "Celles-sur-Plaine"},
    {"city": "Certilleux"},
    {"city": "Chamagne"},
    {"city": "Champdray"},
    {"city": "Champ-le-Duc"},
    {"city": "Chantraine"},
    {"city": "La Chapelle-aux-Bois"},
    {"city": "La Chapelle-devant-Bruyères"},
    {"city": "Charmes"},
    {"city": "Charmois-devant-Bruyères"},
    {"city": "Charmois-l'Orgueilleux"},
    {"city": "Châtas"},
    {"city": "Châtel-sur-Moselle"},
    {"city": "Châtenois"},
    {"city": "Châtillon-sur-Saône"},
    {"city": "Chauffecourt"},
    {"city": "Chaumousey"},
    {"city": "Chavelot"},
    {"city": "Chef-Haut"},
    {"city": "Cheniménil"},
    {"city": "Chermisey"},
    {"city": "Circourt"},
    {"city": "Circourt-sur-Mouzon"},
    {"city": "Claudon"},
    {"city": "Ban-sur-Meurthe-Clefcy"},
    {"city": "Clérey-la-Côte"},
    {"city": "Le Clerjus"},
    {"city": "Cleurie"},
    {"city": "Clézentaine"},
    {"city": "Coinches"},
    {"city": "Combrimont"},
    {"city": "Contrexéville"},
    {"city": "Corcieux"},
    {"city": "Cornimont"},
    {"city": "Courcelles-sous-Châtenois"},
    {"city": "Coussey"},
    {"city": "Crainvilliers"},
    {"city": "La Croix-aux-Mines"},
    {"city": "Damas-aux-Bois"},
    {"city": "Damas-et-Bettegney"},
    {"city": "Damblain"},
    {"city": "Darney"},
    {"city": "Darney-aux-Chênes"},
    {"city": "Darnieulles"},
    {"city": "Deinvillers"},
    {"city": "Denipaire"},
    {"city": "Derbamont"},
    {"city": "Destord"},
    {"city": "Deycimont"},
    {"city": "Deyvillers"},
    {"city": "Dignonville"},
    {"city": "Dinozé"},
    {"city": "Docelles"},
    {"city": "Dogneville"},
    {"city": "Dolaincourt"},
    {"city": "Dombasle-devant-Darney"},
    {"city": "Dombasle-en-Xaintois"},
    {"city": "Dombrot-le-Sec"},
    {"city": "Dombrot-sur-Vair"},
    {"city": "Domèvre-sur-Avière"},
    {"city": "Domèvre-sur-Durbion"},
    {"city": "Domèvre-sous-Montfort"},
    {"city": "Domfaing"},
    {"city": "Domjulien"},
    {"city": "Dommartin-aux-Bois"},
    {"city": "Dommartin-lès-Remiremont"},
    {"city": "Dommartin-lès-Vallois"},
    {"city": "Dommartin-sur-Vraine"},
    {"city": "Dompaire"},
    {"city": "Dompierre"},
    {"city": "Domptail"},
    {"city": "Domrémy-la-Pucelle"},
    {"city": "Domvallier"},
    {"city": "Doncières"},
    {"city": "Dounoux"},
    {"city": "Éloyes"},
    {"city": "Entre-deux-Eaux"},
    {"city": "Épinal"},
    {"city": "Escles"},
    {"city": "Esley"},
    {"city": "Essegney"},
    {"city": "Estrennes"},
    {"city": "Étival-Clairefontaine"},
    {"city": "Évaux-et-Ménil"},
    {"city": "Faucompierre"},
    {"city": "Fauconcourt"},
    {"city": "Fays"},
    {"city": "Ferdrupt"},
    {"city": "Fignévelle"},
    {"city": "Fiménil"},
    {"city": "Florémont"},
    {"city": "Fomerey"},
    {"city": "Fontenay"},
    {"city": "Fontenoy-le-Château"},
    {"city": "La Forge"},
    {"city": "Les Forges"},
    {"city": "Fouchécourt"},
    {"city": "Frain"},
    {"city": "Fraize"},
    {"city": "Frapelle"},
    {"city": "Frebécourt"},
    {"city": "Fremifontaine"},
    {"city": "Frenelle-la-Grande"},
    {"city": "Frenelle-la-Petite"},
    {"city": "Frénois"},
    {"city": "Fresse-sur-Moselle"},
    {"city": "Fréville"},
    {"city": "Frizon"},
    {"city": "Gelvécourt-et-Adompt"},
    {"city": "Gemaingoutte"},
    {"city": "Gemmelaincourt"},
    {"city": "Gendreville"},
    {"city": "Gérardmer"},
    {"city": "Gerbamont"},
    {"city": "Gerbépal"},
    {"city": "Gignéville"},
    {"city": "Gigney"},
    {"city": "Girancourt"},
    {"city": "Gircourt-lès-Viéville"},
    {"city": "Girecourt-sur-Durbion"},
    {"city": "Girmont-Val-d'Ajol"},
    {"city": "Gironcourt-sur-Vraine"},
    {"city": "Godoncourt"},
    {"city": "Golbey"},
    {"city": "Gorhey"},
    {"city": "Grand"},
    {"city": "La Grande-Fosse"},
    {"city": "Grandrupt-de-Bains"},
    {"city": "Grandrupt"},
    {"city": "Grandvillers"},
    {"city": "Granges-Aumontzey"},
    {"city": "Greux"},
    {"city": "Grignoncourt"},
    {"city": "Gruey-lès-Surance"},
    {"city": "Gugnécourt"},
    {"city": "Gugney-aux-Aulx"},
    {"city": "Hadigny-les-Verrières"},
    {"city": "Hadol"},
    {"city": "Hagécourt"},
    {"city": "Hagnéville-et-Roncourt"},
    {"city": "Haillainville"},
    {"city": "Harchéchamp"},
    {"city": "Hardancourt"},
    {"city": "Haréville"},
    {"city": "Harmonville"},
    {"city": "Harol"},
    {"city": "La Haye"},
    {"city": "Hennecourt"},
    {"city": "Hennezel"},
    {"city": "Hergugney"},
    {"city": "Herpelmont"},
    {"city": "Houécourt"},
    {"city": "Houéville"},
    {"city": "Housseras"},
    {"city": "La Houssière"},
    {"city": "Hurbache"},
    {"city": "Hymont"},
    {"city": "Igney"},
    {"city": "Isches"},
    {"city": "Jainvillotte"},
    {"city": "Jarménil"},
    {"city": "Jeanménil"},
    {"city": "Jésonville"},
    {"city": "Jeuxey"},
    {"city": "Jorxey"},
    {"city": "Jubainville"},
    {"city": "Jussarupt"},
    {"city": "Juvaincourt"},
    {"city": "Lamarche"},
    {"city": "Landaville"},
    {"city": "Langley"},
    {"city": "Laval-sur-Vologne"},
    {"city": "Laveline-devant-Bruyères"},
    {"city": "Laveline-du-Houx"},
    {"city": "Légéville-et-Bonfays"},
    {"city": "Lemmecourt"},
    {"city": "Lépanges-sur-Vologne"},
    {"city": "Lerrain"},
    {"city": "Lesseux"},
    {"city": "Liézey"},
    {"city": "Liffol-le-Grand"},
    {"city": "Lignéville"},
    {"city": "Lironcourt"},
    {"city": "Longchamp"},
    {"city": "Longchamp-sous-Châtenois"},
    {"city": "Lubine"},
    {"city": "Lusse"},
    {"city": "Luvigny"},
    {"city": "Maconcourt"},
    {"city": "Madecourt"},
    {"city": "Madegney"},
    {"city": "Madonne-et-Lamerey"},
    {"city": "Malaincourt"},
    {"city": "Mandray"},
    {"city": "Mandres-sur-Vair"},
    {"city": "Marainville-sur-Madon"},
    {"city": "Marey"},
    {"city": "Maroncourt"},
    {"city": "Martigny-les-Bains"},
    {"city": "Martigny-les-Gerbonvaux"},
    {"city": "Martinvelle"},
    {"city": "Mattaincourt"},
    {"city": "Maxey-sur-Meuse"},
    {"city": "Mazeley"},
    {"city": "Mazirot"},
    {"city": "Médonville"},
    {"city": "Méménil"},
    {"city": "Ménarmont"},
    {"city": "Ménil-en-Xaintois"},
    {"city": "Ménil-de-Senones"},
    {"city": "Ménil-sur-Belvitte"},
    {"city": "Le Ménil"},
    {"city": "Midrevaux"},
    {"city": "Mirecourt"},
    {"city": "Moncel-sur-Vair"},
    {"city": "Le Mont"},
    {"city": "Mont-lès-Lamarche"},
    {"city": "Mont-lès-Neufchâteau"},
    {"city": "Monthureux-le-Sec"},
    {"city": "Monthureux-sur-Saône"},
    {"city": "Montmotier"},
    {"city": "Morelmaison"},
    {"city": "Moriville"},
    {"city": "Morizécourt"},
    {"city": "Mortagne"},
    {"city": "Morville"},
    {"city": "Moussey"},
    {"city": "Moyemont"},
    {"city": "Moyenmoutier"},
    {"city": "Nayemont-les-Fosses"},
    {"city": "Neufchâteau"},
    {"city": "La Neuveville-devant-Lépanges"},
    {"city": "La Neuveville-sous-Châtenois"},
    {"city": "La Neuveville-sous-Montfort"},
    {"city": "Neuvillers-sur-Fave"},
    {"city": "Nomexy"},
    {"city": "Nompatelize"},
    {"city": "Nonville"},
    {"city": "Nonzeville"},
    {"city": "Norroy"},
    {"city": "Nossoncourt"},
    {"city": "Oëlleville"},
    {"city": "Offroicourt"},
    {"city": "Ollainville"},
    {"city": "Ortoncourt"},
    {"city": "Padoux"},
    {"city": "Pair-et-Grandrupt"},
    {"city": "Pallegney"},
    {"city": "Parey-sous-Montfort"},
    {"city": "Pargny-sous-Mureau"},
    {"city": "La Petite-Fosse"},
    {"city": "La Petite-Raon"},
    {"city": "Pierrefitte"},
    {"city": "Pierrepont-sur-l'Arentèle"},
    {"city": "Plainfaing"},
    {"city": "Pleuvezain"},
    {"city": "Plombières-les-Bains"},
    {"city": "Pompierre"},
    {"city": "Pont-lès-Bonfays"},
    {"city": "Pont-sur-Madon"},
    {"city": "Portieux"},
    {"city": "Les Poulières"},
    {"city": "Poussay"},
    {"city": "Pouxeux"},
    {"city": "Prey"},
    {"city": "Provenchères-lès-Darney"},
    {"city": "Provenchères-et-Colroy"},
    {"city": "Le Puid"},
    {"city": "Punerot"},
    {"city": "Puzieux"},
    {"city": "Racécourt"},
    {"city": "Rainville"},
    {"city": "Rambervillers"},
    {"city": "Ramecourt"},
    {"city": "Ramonchamp"},
    {"city": "Rancourt"},
    {"city": "Raon-aux-Bois"},
    {"city": "Raon-l'Étape"},
    {"city": "Raon-sur-Plaine"},
    {"city": "Rapey"},
    {"city": "Raves"},
    {"city": "Rebeuville"},
    {"city": "Regnévelle"},
    {"city": "Regney"},
    {"city": "Rehaincourt"},
    {"city": "Rehaupal"},
    {"city": "Relanges"},
    {"city": "Remicourt"},
    {"city": "Remiremont"},
    {"city": "Remoncourt"},
    {"city": "Remomeix"},
    {"city": "Removille"},
    {"city": "Renauvoid"},
    {"city": "Repel"},
    {"city": "Robécourt"},
    {"city": "Rochesson"},
    {"city": "Rollainville"},
    {"city": "Romain-aux-Bois"},
    {"city": "Romont"},
    {"city": "Les Rouges-Eaux"},
    {"city": "Le Roulier"},
    {"city": "Rouvres-en-Xaintois"},
    {"city": "Rouvres-la-Chétive"},
    {"city": "Roville-aux-Chênes"},
    {"city": "Rozerotte"},
    {"city": "Rozières-sur-Mouzon"},
    {"city": "Rugney"},
    {"city": "Ruppes"},
    {"city": "Rupt-sur-Moselle"},
    {"city": "Saint-Amé"},
    {"city": "Sainte-Barbe"},
    {"city": "Saint-Baslemont"},
    {"city": "Saint-Benoît-la-Chipotte"},
    {"city": "Saint-Dié-des-Vosges"},
    {"city": "Saint-Étienne-lès-Remiremont"},
    {"city": "Saint-Genest"},
    {"city": "Saint-Gorgon"},
    {"city": "Sainte-Hélène"},
    {"city": "Saint-Jean-d'Ormont"},
    {"city": "Saint-Julien"},
    {"city": "Saint-Léonard"},
    {"city": "Sainte-Marguerite"},
    {"city": "Saint-Maurice-sur-Mortagne"},
    {"city": "Saint-Maurice-sur-Moselle"},
    {"city": "Saint-Menge"},
    {"city": "Saint-Michel-sur-Meurthe"},
    {"city": "Saint-Nabord"},
    {"city": "Saint-Ouen-lès-Parey"},
    {"city": "Saint-Paul"},
    {"city": "Saint-Pierremont"},
    {"city": "Saint-Prancher"},
    {"city": "Saint-Remimont"},
    {"city": "Saint-Remy"},
    {"city": "Saint-Stail"},
    {"city": "Saint-Vallier"},
    {"city": "La Salle"},
    {"city": "Sanchey"},
    {"city": "Sandaucourt"},
    {"city": "Sans-Vallois"},
    {"city": "Sapois"},
    {"city": "Sartes"},
    {"city": "Le Saulcy"},
    {"city": "Saulcy-sur-Meurthe"},
    {"city": "Saulxures-lès-Bulgnéville"},
    {"city": "Saulxures-sur-Moselotte"},
    {"city": "Sauville"},
    {"city": "Savigny"},
    {"city": "Senaide"},
    {"city": "Senones"},
    {"city": "Senonges"},
    {"city": "Seraumont"},
    {"city": "Sercœur"},
    {"city": "Serécourt"},
    {"city": "Serocourt"},
    {"city": "Sionne"},
    {"city": "Socourt"},
    {"city": "Soncourt"},
    {"city": "Soulosse-sous-Saint-Élophe"},
    {"city": "Suriauville"},
    {"city": "Le Syndicat"},
    {"city": "Taintrux"},
    {"city": "Tendon"},
    {"city": "Capavenir Vosges"},
    {"city": "They-sous-Montfort"},
    {"city": "Thiéfosse"},
    {"city": "Le Thillot"},
    {"city": "Thiraucourt"},
    {"city": "Le Tholy"},
    {"city": "Les Thons"},
    {"city": "Thuillières"},
    {"city": "Tignécourt"},
    {"city": "Tilleux"},
    {"city": "Tollaincourt"},
    {"city": "Totainville"},
    {"city": "Trampot"},
    {"city": "Tranqueville-Graux"},
    {"city": "Trémonzey"},
    {"city": "Ubexy"},
    {"city": "Uriménil"},
    {"city": "Urville"},
    {"city": "Uxegney"},
    {"city": "Uzemain"},
    {"city": "La Vacheresse-et-la-Rouillie"},
    {"city": "Vagney"},
    {"city": "Le Val-d'Ajol"},
    {"city": "Valfroicourt"},
    {"city": "Valleroy-aux-Saules"},
    {"city": "Valleroy-le-Sec"},
    {"city": "Les Vallois"},
    {"city": "Le Valtin"},
    {"city": "Varmonzey"},
    {"city": "Vaubexy"},
    {"city": "Vaudéville"},
    {"city": "Vaudoncourt"},
    {"city": "Vaxoncourt"},
    {"city": "Vecoux"},
    {"city": "Velotte-et-Tatignécourt"},
    {"city": "Ventron"},
    {"city": "Le Vermont"},
    {"city": "Vervezelle"},
    {"city": "Vexaincourt"},
    {"city": "Vicherey"},
    {"city": "Vienville"},
    {"city": "Vieux-Moulin"},
    {"city": "Villers"},
    {"city": "Ville-sur-Illon"},
    {"city": "Villoncourt"},
    {"city": "Villotte"},
    {"city": "Villouxel"},
    {"city": "Viménil"},
    {"city": "Vincey"},
    {"city": "Viocourt"},
    {"city": "Vioménil"},
    {"city": "Vittel"},
    {"city": "Viviers-le-Gras"},
    {"city": "Viviers-lès-Offroicourt"},
    {"city": "La Voivre"},
    {"city": "Les Voivres"},
    {"city": "Vomécourt"},
    {"city": "Vomécourt-sur-Madon"},
    {"city": "Vouxey"},
    {"city": "Vrécourt"},
    {"city": "Vroville"},
    {"city": "Wisembach"},
    {"city": "Xaffévillers"},
    {"city": "Xamontarupt"},
    {"city": "Xaronval"},
    {"city": "Xertigny"},
    {"city": "Xonrupt-Longemer"},
    {"city": "Zincourt"},
    {"city": "Aigremont"},
    {"city": "Montholon"},
    {"city": "Aisy-sur-Armançon"},
    {"city": "Ancy-le-Franc"},
    {"city": "Ancy-le-Libre"},
    {"city": "Andryes"},
    {"city": "Angely"},
    {"city": "Annay-la-Côte"},
    {"city": "Annay-sur-Serein"},
    {"city": "Annéot"},
    {"city": "Annoux"},
    {"city": "Appoigny"},
    {"city": "Arces-Dilo"},
    {"city": "Arcy-sur-Cure"},
    {"city": "Argentenay"},
    {"city": "Argenteuil-sur-Armançon"},
    {"city": "Armeau"},
    {"city": "Arthonnay"},
    {"city": "Asnières-sous-Bois"},
    {"city": "Asquins"},
    {"city": "Athie"},
    {"city": "Augy"},
    {"city": "Auxerre"},
    {"city": "Avallon"},
    {"city": "Bagneaux"},
    {"city": "Baon"},
    {"city": "Bassou"},
    {"city": "Bazarnes"},
    {"city": "Beaumont"},
    {"city": "Beauvilliers"},
    {"city": "Beauvoir"},
    {"city": "Beine"},
    {"city": "Bellechaume"},
    {"city": "La Belliole"},
    {"city": "Béon"},
    {"city": "Bernouil"},
    {"city": "Béru"},
    {"city": "Bessy-sur-Cure"},
    {"city": "Beugnon"},
    {"city": "Bierry-les-Belles-Fontaines"},
    {"city": "Blacy"},
    {"city": "Blannay"},
    {"city": "Bleigny-le-Carreau"},
    {"city": "Bléneau"},
    {"city": "Bœurs-en-Othe"},
    {"city": "Bois-d'Arcy"},
    {"city": "Bonnard"},
    {"city": "Les Bordes"},
    {"city": "Branches"},
    {"city": "Brannay"},
    {"city": "Brienon-sur-Armançon"},
    {"city": "Brion"},
    {"city": "Brosses"},
    {"city": "Bussières"},
    {"city": "Bussy-en-Othe"},
    {"city": "Bussy-le-Repos"},
    {"city": "Butteaux"},
    {"city": "Carisey"},
    {"city": "La Celle-Saint-Cyr"},
    {"city": "Censy"},
    {"city": "Cérilly"},
    {"city": "Cerisiers"},
    {"city": "Cézy"},
    {"city": "Chablis"},
    {"city": "Chailley"},
    {"city": "Chamoux"},
    {"city": "Champcevrais"},
    {"city": "Champignelles"},
    {"city": "Champigny"},
    {"city": "Champlay"},
    {"city": "Champlost"},
    {"city": "Champs-sur-Yonne"},
    {"city": "Chamvres"},
    {"city": "La Chapelle-sur-Oreuse"},
    {"city": "La Chapelle-Vaupelteigne"},
    {"city": "Charbuy"},
    {"city": "Charentenay"},
    {"city": "Charmoy"},
    {"city": "Charny Orée de Puisaye"},
    {"city": "Chassignelles"},
    {"city": "Chassy"},
    {"city": "Chastellux-sur-Cure"},
    {"city": "Châtel-Censoir"},
    {"city": "Châtel-Gérard"},
    {"city": "Chaumont"},
    {"city": "Chaumot"},
    {"city": "Chemilly-sur-Serein"},
    {"city": "Chemilly-sur-Yonne"},
    {"city": "Cheney"},
    {"city": "Cheny"},
    {"city": "Chéroy"},
    {"city": "Chéu"},
    {"city": "Chevannes"},
    {"city": "Chichée"},
    {"city": "Chichery"},
    {"city": "Chitry"},
    {"city": "Les Clérimois"},
    {"city": "Collan"},
    {"city": "Collemiers"},
    {"city": "Compigny"},
    {"city": "Cornant"},
    {"city": "Coulangeron"},
    {"city": "Coulanges-la-Vineuse"},
    {"city": "Coulanges-sur-Yonne"},
    {"city": "Coulours"},
    {"city": "Courgenay"},
    {"city": "Courgis"},
    {"city": "Courlon-sur-Yonne"},
    {"city": "Courson-les-Carrières"},
    {"city": "Courtoin"},
    {"city": "Courtois-sur-Yonne"},
    {"city": "Coutarnoux"},
    {"city": "Crain"},
    {"city": "Deux Rivières"},
    {"city": "Cruzy-le-Châtel"},
    {"city": "Cry"},
    {"city": "Cudot"},
    {"city": "Cussy-les-Forges"},
    {"city": "Cuy"},
    {"city": "Dannemoine"},
    {"city": "Diges"},
    {"city": "Dissangis"},
    {"city": "Dixmont"},
    {"city": "Dollot"},
    {"city": "Domats"},
    {"city": "Domecy-sur-Cure"},
    {"city": "Domecy-sur-le-Vault"},
    {"city": "Dracy"},
    {"city": "Druyes-les-Belles-Fontaines"},
    {"city": "Dyé"},
    {"city": "Égleny"},
    {"city": "Égriselles-le-Bocage"},
    {"city": "Épineau-les-Voves"},
    {"city": "Épineuil"},
    {"city": "Escamps"},
    {"city": "Escolives-Sainte-Camille"},
    {"city": "Esnon"},
    {"city": "Étais-la-Sauvin"},
    {"city": "Étaule"},
    {"city": "Étigny"},
    {"city": "Étivey"},
    {"city": "Évry"},
    {"city": "La Ferté-Loupière"},
    {"city": "Festigny"},
    {"city": "Flacy"},
    {"city": "Fleury-la-Vallée"},
    {"city": "Fleys"},
    {"city": "Flogny-la-Chapelle"},
    {"city": "Foissy-lès-Vézelay"},
    {"city": "Foissy-sur-Vanne"},
    {"city": "Fontaine-la-Gaillarde"},
    {"city": "Fontaines"},
    {"city": "Fontenay-près-Chablis"},
    {"city": "Fontenay-près-Vézelay"},
    {"city": "Fontenay-sous-Fouronnes"},
    {"city": "Fontenoy"},
    {"city": "Fouchères"},
    {"city": "Fournaudin"},
    {"city": "Fouronnes"},
    {"city": "Fresnes"},
    {"city": "Fulvy"},
    {"city": "Germigny"},
    {"city": "Gigny"},
    {"city": "Girolles"},
    {"city": "Gisy-les-Nobles"},
    {"city": "Givry"},
    {"city": "Gland"},
    {"city": "Grimault"},
    {"city": "Gron"},
    {"city": "Valravillon"},
    {"city": "Guillon-Terre-Plaine"},
    {"city": "Gurgy"},
    {"city": "Gy-l'Évêque"},
    {"city": "Hauterive"},
    {"city": "Héry"},
    {"city": "Irancy"},
    {"city": "Island"},
    {"city": "L'Isle-sur-Serein"},
    {"city": "Jaulges"},
    {"city": "Joigny"},
    {"city": "Jouancy"},
    {"city": "Joux-la-Ville"},
    {"city": "Jouy"},
    {"city": "Jully"},
    {"city": "Junay"},
    {"city": "Jussy"},
    {"city": "Lailly"},
    {"city": "Lain"},
    {"city": "Lainsecq"},
    {"city": "Lalande"},
    {"city": "Laroche-Saint-Cydroine"},
    {"city": "Lasson"},
    {"city": "Lavau"},
    {"city": "Leugny"},
    {"city": "Levis"},
    {"city": "Lézinnes"},
    {"city": "Lichères-près-Aigremont"},
    {"city": "Lichères-sur-Yonne"},
    {"city": "Lignorelles"},
    {"city": "Ligny-le-Châtel"},
    {"city": "Lindry"},
    {"city": "Lixy"},
    {"city": "Looze"},
    {"city": "Lucy-le-Bois"},
    {"city": "Lucy-sur-Cure"},
    {"city": "Lucy-sur-Yonne"},
    {"city": "Magny"},
    {"city": "Maillot"},
    {"city": "Mailly-la-Ville"},
    {"city": "Mailly-le-Château"},
    {"city": "Malay-le-Grand"},
    {"city": "Malay-le-Petit"},
    {"city": "Maligny"},
    {"city": "Marmeaux"},
    {"city": "Marsangy"},
    {"city": "Massangis"},
    {"city": "Mélisey"},
    {"city": "Menades"},
    {"city": "Mercy"},
    {"city": "Méré"},
    {"city": "Merry-la-Vallée"},
    {"city": "Merry-Sec"},
    {"city": "Merry-sur-Yonne"},
    {"city": "Mézilles"},
    {"city": "Michery"},
    {"city": "Migé"},
    {"city": "Migennes"},
    {"city": "Môlay"},
    {"city": "Molinons"},
    {"city": "Molosmes"},
    {"city": "Monéteau"},
    {"city": "Montacher-Villegardin"},
    {"city": "Montigny-la-Resle"},
    {"city": "Montillot"},
    {"city": "Montréal"},
    {"city": "Mont-Saint-Sulpice"},
    {"city": "Mouffy"},
    {"city": "Moulins-en-Tonnerrois"},
    {"city": "Moulins-sur-Ouanne"},
    {"city": "Moutiers-en-Puisaye"},
    {"city": "Nailly"},
    {"city": "Neuvy-Sautour"},
    {"city": "Nitry"},
    {"city": "Noé"},
    {"city": "Noyers"},
    {"city": "Nuits"},
    {"city": "Les Ormes"},
    {"city": "Ormoy"},
    {"city": "Ouanne"},
    {"city": "Pacy-sur-Armançon"},
    {"city": "Pailly"},
    {"city": "Parly"},
    {"city": "Paron"},
    {"city": "Paroy-en-Othe"},
    {"city": "Paroy-sur-Tholon"},
    {"city": "Pasilly"},
    {"city": "Passy"},
    {"city": "Percey"},
    {"city": "Perrigny"},
    {"city": "Perrigny-sur-Armançon"},
    {"city": "Pierre-Perthuis"},
    {"city": "Piffonds"},
    {"city": "Pimelles"},
    {"city": "Pisy"},
    {"city": "Plessis-Saint-Jean"},
    {"city": "Poilly-sur-Serein"},
    {"city": "Poilly-sur-Tholon"},
    {"city": "Pontaubert"},
    {"city": "Pontigny"},
    {"city": "Pont-sur-Vanne"},
    {"city": "Pont-sur-Yonne"},
    {"city": "La Postolle"},
    {"city": "Pourrain"},
    {"city": "Précy-le-Sec"},
    {"city": "Précy-sur-Vrin"},
    {"city": "Prégilbert"},
    {"city": "Préhy"},
    {"city": "Provency"},
    {"city": "Quarré-les-Tombes"},
    {"city": "Quenne"},
    {"city": "Quincerot"},
    {"city": "Ravières"},
    {"city": "Roffey"},
    {"city": "Rogny-les-Sept-Écluses"},
    {"city": "Ronchères"},
    {"city": "Rosoy"},
    {"city": "Rousson"},
    {"city": "Rouvray"},
    {"city": "Rugny"},
    {"city": "Sainpuits"},
    {"city": "Saint-Agnan"},
    {"city": "Saint-André-en-Terre-Plaine"},
    {"city": "Le Val d'Ocre"},
    {"city": "Saint-Aubin-sur-Yonne"},
    {"city": "Saint-Brancher"},
    {"city": "Saint-Bris-le-Vineux"},
    {"city": "Saint-Clément"},
    {"city": "Sainte-Colombe"},
    {"city": "Saint-Cyr-les-Colons"},
    {"city": "Saint-Denis-lès-Sens"},
    {"city": "Saint-Fargeau"},
    {"city": "Saint-Florentin"},
    {"city": "Saint-Georges-sur-Baulche"},
    {"city": "Saint-Germain-des-Champs"},
    {"city": "Saint-Julien-du-Sault"},
    {"city": "Saint-Léger-Vauban"},
    {"city": "Saint-Loup-d'Ordon"},
    {"city": "Sainte-Magnance"},
    {"city": "Saint-Martin-des-Champs"},
    {"city": "Saint-Martin-d'Ordon"},
    {"city": "Saint-Martin-du-Tertre"},
    {"city": "Saint-Martin-sur-Armançon"},
    {"city": "Saint-Maurice-aux-Riches-Hommes"},
    {"city": "Saint-Maurice-le-Vieil"},
    {"city": "Saint-Maurice-Thizouaille"},
    {"city": "Saint-Moré"},
    {"city": "Sainte-Pallaye"},
    {"city": "Saint-Père"},
    {"city": "Saint-Privé"},
    {"city": "Saints-en-Puisaye"},
    {"city": "Saint-Sauveur-en-Puisaye"},
    {"city": "Saint-Sérotin"},
    {"city": "Saint-Valérien"},
    {"city": "Sainte-Vertu"},
    {"city": "Saligny"},
    {"city": "Sambourg"},
    {"city": "Santigny"},
    {"city": "Sarry"},
    {"city": "Sauvigny-le-Beuréal"},
    {"city": "Sauvigny-le-Bois"},
    {"city": "Savigny-en-Terre-Plaine"},
    {"city": "Savigny-sur-Clairis"},
    {"city": "Seignelay"},
    {"city": "Sementron"},
    {"city": "Senan"},
    {"city": "Sennevoy-le-Bas"},
    {"city": "Sennevoy-le-Haut"},
    {"city": "Sens"},
    {"city": "Sépeaux-Saint Romain"},
    {"city": "Serbonnes"},
    {"city": "Sergines"},
    {"city": "Sermizelles"},
    {"city": "Serrigny"},
    {"city": "Sery"},
    {"city": "Les Sièges"},
    {"city": "Sommecaise"},
    {"city": "Sormery"},
    {"city": "Soucy"},
    {"city": "Sougères-en-Puisaye"},
    {"city": "Soumaintrain"},
    {"city": "Stigny"},
    {"city": "Subligny"},
    {"city": "Les Hauts de Forterre"},
    {"city": "Talcy"},
    {"city": "Tanlay"},
    {"city": "Tannerre-en-Puisaye"},
    {"city": "Tharoiseau"},
    {"city": "Tharot"},
    {"city": "Les Vallées de la Vanne"},
    {"city": "Thizy"},
    {"city": "Thorey"},
    {"city": "Thorigny-sur-Oreuse"},
    {"city": "Thory"},
    {"city": "Thury"},
    {"city": "Tissey"},
    {"city": "Tonnerre"},
    {"city": "Toucy"},
    {"city": "Treigny-Perreuse-Sainte-Colombe"},
    {"city": "Trichey"},
    {"city": "Tronchoy"},
    {"city": "Trucy-sur-Yonne"},
    {"city": "Turny"},
    {"city": "Val-de-Mercy"},
    {"city": "Vallan"},
    {"city": "Vallery"},
    {"city": "Varennes"},
    {"city": "Vassy-sous-Pisy"},
    {"city": "Vaudeurs"},
    {"city": "Vault-de-Lugny"},
    {"city": "Vaumort"},
    {"city": "Venizy"},
    {"city": "Venouse"},
    {"city": "Venoy"},
    {"city": "Vergigny"},
    {"city": "Verlin"},
    {"city": "Vermenton"},
    {"city": "Vernoy"},
    {"city": "Véron"},
    {"city": "Vézannes"},
    {"city": "Vézelay"},
    {"city": "Vézinnes"},
    {"city": "Villeblevin"},
    {"city": "Villebougis"},
    {"city": "Villechétive"},
    {"city": "Villecien"},
    {"city": "Villefargeau"},
    {"city": "Villemanoche"},
    {"city": "Villenavotte"},
    {"city": "Villeneuve-la-Dondagre"},
    {"city": "Villeneuve-la-Guyard"},
    {"city": "Villeneuve-l'Archevêque"},
    {"city": "Villeneuve-les-Genêts"},
    {"city": "Villeneuve-Saint-Salves"},
    {"city": "Villeneuve-sur-Yonne"},
    {"city": "Villeperrot"},
    {"city": "Villeroy"},
    {"city": "Villethierry"},
    {"city": "Villevallier"},
    {"city": "Perceneige"},
    {"city": "Villiers-les-Hauts"},
    {"city": "Villiers-Louis"},
    {"city": "Villiers-Saint-Benoît"},
    {"city": "Villiers-Vineux"},
    {"city": "Villon"},
    {"city": "Villy"},
    {"city": "Vincelles"},
    {"city": "Vincelottes"},
    {"city": "Vinneuf"},
    {"city": "Vireaux"},
    {"city": "Viviers"},
    {"city": "Voisines"},
    {"city": "Voutenay-sur-Cure"},
    {"city": "Yrouerre"},
    {"city": "Andelnans"},
    {"city": "Angeot"},
    {"city": "Anjoutey"},
    {"city": "Argiésans"},
    {"city": "Auxelles-Bas"},
    {"city": "Auxelles-Haut"},
    {"city": "Banvillars"},
    {"city": "Bavilliers"},
    {"city": "Beaucourt"},
    {"city": "Belfort"},
    {"city": "Bermont"},
    {"city": "Bessoncourt"},
    {"city": "Bethonvilliers"},
    {"city": "Boron"},
    {"city": "Botans"},
    {"city": "Bourg-sous-Châtelet"},
    {"city": "Bourogne"},
    {"city": "Brebotte"},
    {"city": "Bretagne"},
    {"city": "Buc"},
    {"city": "Charmois"},
    {"city": "Châtenois-les-Forges"},
    {"city": "Chaux"},
    {"city": "Chavanatte"},
    {"city": "Chavannes-les-Grands"},
    {"city": "Chèvremont"},
    {"city": "Courcelles"},
    {"city": "Courtelevant"},
    {"city": "Cravanche"},
    {"city": "Croix"},
    {"city": "Cunelières"},
    {"city": "Danjoutin"},
    {"city": "Delle"},
    {"city": "Denney"},
    {"city": "Dorans"},
    {"city": "Eguenigue"},
    {"city": "Éloie"},
    {"city": "Essert"},
    {"city": "Étueffont"},
    {"city": "Évette-Salbert"},
    {"city": "Faverois"},
    {"city": "Felon"},
    {"city": "Fêche-l'Église"},
    {"city": "Florimont"},
    {"city": "Fontaine"},
    {"city": "Fontenelle"},
    {"city": "Foussemagne"},
    {"city": "Frais"},
    {"city": "Froidefontaine"},
    {"city": "Giromagny"},
    {"city": "Grandvillars"},
    {"city": "Grosmagny"},
    {"city": "Grosne"},
    {"city": "Joncherey"},
    {"city": "Lachapelle-sous-Chaux"},
    {"city": "Lachapelle-sous-Rougemont"},
    {"city": "Lacollonge"},
    {"city": "Lagrange"},
    {"city": "Lamadeleine-Val-des-Anges"},
    {"city": "Larivière"},
    {"city": "Lebetain"},
    {"city": "Lepuix-Neuf"},
    {"city": "Lepuix"},
    {"city": "Leval"},
    {"city": "Menoncourt"},
    {"city": "Meroux-Moval"},
    {"city": "Méziré"},
    {"city": "Montbouton"},
    {"city": "Montreux-Château"},
    {"city": "Morvillars"},
    {"city": "Novillard"},
    {"city": "Offemont"},
    {"city": "Pérouse"},
    {"city": "Petit-Croix"},
    {"city": "Petitefontaine"},
    {"city": "Petitmagny"},
    {"city": "Phaffans"},
    {"city": "Réchésy"},
    {"city": "Autrechêne"},
    {"city": "Recouvrance"},
    {"city": "Reppe"},
    {"city": "Riervescemont"},
    {"city": "Romagny-sous-Rougemont"},
    {"city": "Roppe"},
    {"city": "Rougegoutte"},
    {"city": "Rougemont-le-Château"},
    {"city": "Saint-Dizier-l'Évêque"},
    {"city": "Saint-Germain-le-Châtelet"},
    {"city": "Sermamagny"},
    {"city": "Sevenans"},
    {"city": "Suarce"},
    {"city": "Thiancourt"},
    {"city": "Trévenans"},
    {"city": "Urcerey"},
    {"city": "Valdoie"},
    {"city": "Vauthiermont"},
    {"city": "Vellescot"},
    {"city": "Vescemont"},
    {"city": "Vétrigne"},
    {"city": "Vézelois"},
    {"city": "Villars-le-Sec"},
    {"city": "Abbéville-la-Rivière"},
    {"city": "Angerville"},
    {"city": "Angervilliers"},
    {"city": "Arpajon"},
    {"city": "Arrancourt"},
    {"city": "Athis-Mons"},
    {"city": "Authon-la-Plaine"},
    {"city": "Auvernaux"},
    {"city": "Auvers-Saint-Georges"},
    {"city": "Avrainville"},
    {"city": "Ballainvilliers"},
    {"city": "Ballancourt-sur-Essonne"},
    {"city": "Baulne"},
    {"city": "Bièvres"},
    {"city": "Blandy"},
    {"city": "Boigneville"},
    {"city": "Bois-Herpin"},
    {"city": "Boissy-la-Rivière"},
    {"city": "Boissy-le-Cutté"},
    {"city": "Boissy-le-Sec"},
    {"city": "Boissy-sous-Saint-Yon"},
    {"city": "Bondoufle"},
    {"city": "Boullay-les-Troux"},
    {"city": "Bouray-sur-Juine"},
    {"city": "Boussy-Saint-Antoine"},
    {"city": "Boutervilliers"},
    {"city": "Boutigny-sur-Essonne"},
    {"city": "Bouville"},
    {"city": "Brétigny-sur-Orge"},
    {"city": "Breuillet"},
    {"city": "Breux-Jouy"},
    {"city": "Brières-les-Scellés"},
    {"city": "Briis-sous-Forges"},
    {"city": "Brouy"},
    {"city": "Brunoy"},
    {"city": "Bruyères-le-Châtel"},
    {"city": "Buno-Bonnevaux"},
    {"city": "Bures-sur-Yvette"},
    {"city": "Cerny"},
    {"city": "Chalo-Saint-Mars"},
    {"city": "Chalou-Moulineux"},
    {"city": "Chamarande"},
    {"city": "Champcueil"},
    {"city": "Champlan"},
    {"city": "Champmotteux"},
    {"city": "Chatignonville"},
    {"city": "Chauffour-lès-Étréchy"},
    {"city": "Cheptainville"},
    {"city": "Chevannes"},
    {"city": "Chilly-Mazarin"},
    {"city": "Corbeil-Essonnes"},
    {"city": "Corbreuse"},
    {"city": "Le Coudray-Montceaux"},
    {"city": "Courances"},
    {"city": "Courdimanche-sur-Essonne"},
    {"city": "Courson-Monteloup"},
    {"city": "Crosne"},
    {"city": "Dannemois"},
    {"city": "D'Huison-Longueville"},
    {"city": "Dourdan"},
    {"city": "Draveil"},
    {"city": "Écharcon"},
    {"city": "Égly"},
    {"city": "Épinay-sous-Sénart"},
    {"city": "Épinay-sur-Orge"},
    {"city": "Étampes"},
    {"city": "Étiolles"},
    {"city": "Étréchy"},
    {"city": "Évry-Courcouronnes"},
    {"city": "La Ferté-Alais"},
    {"city": "Fleury-Mérogis"},
    {"city": "Fontaine-la-Rivière"},
    {"city": "Fontenay-lès-Briis"},
    {"city": "Fontenay-le-Vicomte"},
    {"city": "La Forêt-le-Roi"},
    {"city": "La Forêt-Sainte-Croix"},
    {"city": "Forges-les-Bains"},
    {"city": "Gif-sur-Yvette"},
    {"city": "Gironville-sur-Essonne"},
    {"city": "Gometz-la-Ville"},
    {"city": "Gometz-le-Châtel"},
    {"city": "Les Granges-le-Roi"},
    {"city": "Grigny"},
    {"city": "Guibeville"},
    {"city": "Guigneville-sur-Essonne"},
    {"city": "Guillerval"},
    {"city": "Igny"},
    {"city": "Itteville"},
    {"city": "Janville-sur-Juine"},
    {"city": "Janvry"},
    {"city": "Juvisy-sur-Orge"},
    {"city": "Lardy"},
    {"city": "Leudeville"},
    {"city": "Leuville-sur-Orge"},
    {"city": "Limours"},
    {"city": "Linas"},
    {"city": "Lisses"},
    {"city": "Longjumeau"},
    {"city": "Longpont-sur-Orge"},
    {"city": "Maisse"},
    {"city": "Marcoussis"},
    {"city": "Marolles-en-Beauce"},
    {"city": "Marolles-en-Hurepoix"},
    {"city": "Massy"},
    {"city": "Mauchamps"},
    {"city": "Mennecy"},
    {"city": "Le Mérévillois"},
    {"city": "Mérobert"},
    {"city": "Mespuits"},
    {"city": "Milly-la-Forêt"},
    {"city": "Moigny-sur-École"},
    {"city": "Les Molières"},
    {"city": "Mondeville"},
    {"city": "Monnerville"},
    {"city": "Montgeron"},
    {"city": "Montlhéry"},
    {"city": "Morangis"},
    {"city": "Morigny-Champigny"},
    {"city": "Morsang-sur-Orge"},
    {"city": "Morsang-sur-Seine"},
    {"city": "Nainville-les-Roches"},
    {"city": "La Norville"},
    {"city": "Nozay"},
    {"city": "Ollainville"},
    {"city": "Oncy-sur-École"},
    {"city": "Ormoy"},
    {"city": "Ormoy-la-Rivière"},
    {"city": "Orsay"},
    {"city": "Orveau"},
    {"city": "Palaiseau"},
    {"city": "Paray-Vieille-Poste"},
    {"city": "Pecqueuse"},
    {"city": "Le Plessis-Pâté"},
    {"city": "Plessis-Saint-Benoist"},
    {"city": "Prunay-sur-Essonne"},
    {"city": "Puiselet-le-Marais"},
    {"city": "Pussay"},
    {"city": "Quincy-sous-Sénart"},
    {"city": "Richarville"},
    {"city": "Ris-Orangis"},
    {"city": "Roinville"},
    {"city": "Roinvilliers"},
    {"city": "Saclas"},
    {"city": "Saclay"},
    {"city": "Saint-Aubin"},
    {"city": "Saint-Chéron"},
    {"city": "Saint-Cyr-la-Rivière"},
    {"city": "Saint-Cyr-sous-Dourdan"},
    {"city": "Saint-Escobille"},
    {"city": "Sainte-Geneviève-des-Bois"},
    {"city": "Saint-Germain-lès-Arpajon"},
    {"city": "Saint-Germain-lès-Corbeil"},
    {"city": "Saint-Hilaire"},
    {"city": "Saint-Jean-de-Beauregard"},
    {"city": "Saint-Maurice-Montcouronne"},
    {"city": "Saint-Michel-sur-Orge"},
    {"city": "Saint-Pierre-du-Perray"},
    {"city": "Saintry-sur-Seine"},
    {"city": "Saint-Sulpice-de-Favières"},
    {"city": "Saint-Vrain"},
    {"city": "Saint-Yon"},
    {"city": "Saulx-les-Chartreux"},
    {"city": "Savigny-sur-Orge"},
    {"city": "Sermaise"},
    {"city": "Soisy-sur-École"},
    {"city": "Soisy-sur-Seine"},
    {"city": "Souzy-la-Briche"},
    {"city": "Congerville-Thionville"},
    {"city": "Tigery"},
    {"city": "Torfou"},
    {"city": "Valpuiseaux"},
    {"city": "Le Val-Saint-Germain"},
    {"city": "Varennes-Jarcy"},
    {"city": "Vaugrigneuse"},
    {"city": "Vauhallan"},
    {"city": "Vayres-sur-Essonne"},
    {"city": "Verrières-le-Buisson"},
    {"city": "Vert-le-Grand"},
    {"city": "Vert-le-Petit"},
    {"city": "Videlles"},
    {"city": "Vigneux-sur-Seine"},
    {"city": "Villabé"},
    {"city": "Villebon-sur-Yvette"},
    {"city": "Villeconin"},
    {"city": "La Ville-du-Bois"},
    {"city": "Villejust"},
    {"city": "Villemoisson-sur-Orge"},
    {"city": "Villeneuve-sur-Auvers"},
    {"city": "Villiers-le-Bâcle"},
    {"city": "Villiers-sur-Orge"},
    {"city": "Viry-Châtillon"},
    {"city": "Wissous"},
    {"city": "Yerres"},
    {"city": "Les Ulis"},
    {"city": "Antony"},
    {"city": "Asnières-sur-Seine"},
    {"city": "Bagneux"},
    {"city": "Bois-Colombes"},
    {"city": "Boulogne-Billancourt"},
    {"city": "Bourg-la-Reine"},
    {"city": "Châtenay-Malabry"},
    {"city": "Châtillon"},
    {"city": "Chaville"},
    {"city": "Clamart"},
    {"city": "Clichy"},
    {"city": "Colombes"},
    {"city": "Courbevoie"},
    {"city": "Fontenay-aux-Roses"},
    {"city": "Garches"},
    {"city": "La Garenne-Colombes"},
    {"city": "Gennevilliers"},
    {"city": "Issy-les-Moulineaux"},
    {"city": "Levallois-Perret"},
    {"city": "Malakoff"},
    {"city": "Marnes-la-Coquette"},
    {"city": "Meudon"},
    {"city": "Montrouge"},
    {"city": "Nanterre"},
    {"city": "Neuilly-sur-Seine"},
    {"city": "Le Plessis-Robinson"},
    {"city": "Puteaux"},
    {"city": "Rueil-Malmaison"},
    {"city": "Saint-Cloud"},
    {"city": "Sceaux"},
    {"city": "Sèvres"},
    {"city": "Suresnes"},
    {"city": "Vanves"},
    {"city": "Vaucresson"},
    {"city": "Ville-d'Avray"},
    {"city": "Villeneuve-la-Garenne"},
    {"city": "Aubervilliers"},
    {"city": "Aulnay-sous-Bois"},
    {"city": "Bagnolet"},
    {"city": "Le Blanc-Mesnil"},
    {"city": "Bobigny"},
    {"city": "Bondy"},
    {"city": "Le Bourget"},
    {"city": "Clichy-sous-Bois"},
    {"city": "Coubron"},
    {"city": "La Courneuve"},
    {"city": "Drancy"},
    {"city": "Dugny"},
    {"city": "Épinay-sur-Seine"},
    {"city": "Gagny"},
    {"city": "Gournay-sur-Marne"},
    {"city": "L'Île-Saint-Denis"},
    {"city": "Les Lilas"},
    {"city": "Livry-Gargan"},
    {"city": "Montfermeil"},
    {"city": "Montreuil"},
    {"city": "Neuilly-Plaisance"},
    {"city": "Neuilly-sur-Marne"},
    {"city": "Noisy-le-Grand"},
    {"city": "Noisy-le-Sec"},
    {"city": "Pantin"},
    {"city": "Les Pavillons-sous-Bois"},
    {"city": "Pierrefitte-sur-Seine"},
    {"city": "Le Pré-Saint-Gervais"},
    {"city": "Le Raincy"},
    {"city": "Romainville"},
    {"city": "Rosny-sous-Bois"},
    {"city": "Saint-Denis"},
    {"city": "Saint-Ouen-sur-Seine"},
    {"city": "Sevran"},
    {"city": "Stains"},
    {"city": "Tremblay-en-France"},
    {"city": "Vaujours"},
    {"city": "Villemomble"},
    {"city": "Villepinte"},
    {"city": "Villetaneuse"},
    {"city": "Ablon-sur-Seine"},
    {"city": "Alfortville"},
    {"city": "Arcueil"},
    {"city": "Boissy-Saint-Léger"},
    {"city": "Bonneuil-sur-Marne"},
    {"city": "Bry-sur-Marne"},
    {"city": "Cachan"},
    {"city": "Champigny-sur-Marne"},
    {"city": "Charenton-le-Pont"},
    {"city": "Chennevières-sur-Marne"},
    {"city": "Chevilly-Larue"},
    {"city": "Choisy-le-Roi"},
    {"city": "Créteil"},
    {"city": "Fontenay-sous-Bois"},
    {"city": "Fresnes"},
    {"city": "Gentilly"},
    {"city": "L'Haÿ-les-Roses"},
    {"city": "Ivry-sur-Seine"},
    {"city": "Joinville-le-Pont"},
    {"city": "Le Kremlin-Bicêtre"},
    {"city": "Limeil-Brévannes"},
    {"city": "Maisons-Alfort"},
    {"city": "Mandres-les-Roses"},
    {"city": "Marolles-en-Brie"},
    {"city": "Nogent-sur-Marne"},
    {"city": "Noiseau"},
    {"city": "Orly"},
    {"city": "Ormesson-sur-Marne"},
    {"city": "Périgny"},
    {"city": "Le Perreux-sur-Marne"},
    {"city": "Le Plessis-Trévise"},
    {"city": "La Queue-en-Brie"},
    {"city": "Rungis"},
    {"city": "Saint-Mandé"},
    {"city": "Saint-Maur-des-Fossés"},
    {"city": "Saint-Maurice"},
    {"city": "Santeny"},
    {"city": "Sucy-en-Brie"},
    {"city": "Thiais"},
    {"city": "Valenton"},
    {"city": "Villecresnes"},
    {"city": "Villejuif"},
    {"city": "Villeneuve-le-Roi"},
    {"city": "Villeneuve-Saint-Georges"},
    {"city": "Villiers-sur-Marne"},
    {"city": "Vincennes"},
    {"city": "Vitry-sur-Seine"},
    {"city": "Ableiges"},
    {"city": "Aincourt"},
    {"city": "Ambleville"},
    {"city": "Amenucourt"},
    {"city": "Andilly"},
    {"city": "Argenteuil"},
    {"city": "Arnouville"},
    {"city": "Arronville"},
    {"city": "Arthies"},
    {"city": "Asnières-sur-Oise"},
    {"city": "Attainville"},
    {"city": "Auvers-sur-Oise"},
    {"city": "Avernes"},
    {"city": "Baillet-en-France"},
    {"city": "Banthelu"},
    {"city": "Beauchamp"},
    {"city": "Beaumont-sur-Oise"},
    {"city": "Le Bellay-en-Vexin"},
    {"city": "Bellefontaine"},
    {"city": "Belloy-en-France"},
    {"city": "Bernes-sur-Oise"},
    {"city": "Berville"},
    {"city": "Bessancourt"},
    {"city": "Béthemont-la-Forêt"},
    {"city": "Bezons"},
    {"city": "Boisemont"},
    {"city": "Boissy-l'Aillerie"},
    {"city": "Bonneuil-en-France"},
    {"city": "Bouffémont"},
    {"city": "Bouqueval"},
    {"city": "Bray-et-Lû"},
    {"city": "Bréançon"},
    {"city": "Brignancourt"},
    {"city": "Bruyères-sur-Oise"},
    {"city": "Buhy"},
    {"city": "Butry-sur-Oise"},
    {"city": "Cergy"},
    {"city": "Champagne-sur-Oise"},
    {"city": "La Chapelle-en-Vexin"},
    {"city": "Charmont"},
    {"city": "Chars"},
    {"city": "Châtenay-en-France"},
    {"city": "Chaumontel"},
    {"city": "Chaussy"},
    {"city": "Chauvry"},
    {"city": "Chennevières-lès-Louvres"},
    {"city": "Chérence"},
    {"city": "Cléry-en-Vexin"},
    {"city": "Commeny"},
    {"city": "Condécourt"},
    {"city": "Cormeilles-en-Parisis"},
    {"city": "Cormeilles-en-Vexin"},
    {"city": "Courcelles-sur-Viosne"},
    {"city": "Courdimanche"},
    {"city": "Deuil-la-Barre"},
    {"city": "Domont"},
    {"city": "Eaubonne"},
    {"city": "Écouen"},
    {"city": "Enghien-les-Bains"},
    {"city": "Ennery"},
    {"city": "Épiais-lès-Louvres"},
    {"city": "Épiais-Rhus"},
    {"city": "Épinay-Champlâtreux"},
    {"city": "Éragny"},
    {"city": "Ermont"},
    {"city": "Ézanville"},
    {"city": "Fontenay-en-Parisis"},
    {"city": "Fosses"},
    {"city": "Franconville"},
    {"city": "Frémainville"},
    {"city": "Frémécourt"},
    {"city": "Frépillon"},
    {"city": "La Frette-sur-Seine"},
    {"city": "Frouville"},
    {"city": "Garges-lès-Gonesse"},
    {"city": "Genainville"},
    {"city": "Génicourt"},
    {"city": "Gonesse"},
    {"city": "Goussainville"},
    {"city": "Gouzangrez"},
    {"city": "Grisy-les-Plâtres"},
    {"city": "Groslay"},
    {"city": "Guiry-en-Vexin"},
    {"city": "Haravilliers"},
    {"city": "Haute-Isle"},
    {"city": "Le Heaulme"},
    {"city": "Hédouville"},
    {"city": "Herblay-sur-Seine"},
    {"city": "Hérouville-en-Vexin"},
    {"city": "Hodent"},
    {"city": "L'Isle-Adam"},
    {"city": "Jagny-sous-Bois"},
    {"city": "Jouy-le-Moutier"},
    {"city": "Labbeville"},
    {"city": "Lassy"},
    {"city": "Livilliers"},
    {"city": "Longuesse"},
    {"city": "Louvres"},
    {"city": "Luzarches"},
    {"city": "Maffliers"},
    {"city": "Magny-en-Vexin"},
    {"city": "Mareil-en-France"},
    {"city": "Margency"},
    {"city": "Marines"},
    {"city": "Marly-la-Ville"},
    {"city": "Maudétour-en-Vexin"},
    {"city": "Menouville"},
    {"city": "Menucourt"},
    {"city": "Mériel"},
    {"city": "Méry-sur-Oise"},
    {"city": "Le Mesnil-Aubry"},
    {"city": "Moisselles"},
    {"city": "Montgeroult"},
    {"city": "Montigny-lès-Cormeilles"},
    {"city": "Montlignon"},
    {"city": "Montmagny"},
    {"city": "Montmorency"},
    {"city": "Montreuil-sur-Epte"},
    {"city": "Montsoult"},
    {"city": "Mours"},
    {"city": "Moussy"},
    {"city": "Nerville-la-Forêt"},
    {"city": "Nesles-la-Vallée"},
    {"city": "Neuilly-en-Vexin"},
    {"city": "Neuville-sur-Oise"},
    {"city": "Nointel"},
    {"city": "Noisy-sur-Oise"},
    {"city": "Nucourt"},
    {"city": "Omerville"},
    {"city": "Osny"},
    {"city": "Parmain"},
    {"city": "Le Perchay"},
    {"city": "Persan"},
    {"city": "Pierrelaye"},
    {"city": "Piscop"},
    {"city": "Le Plessis-Bouchard"},
    {"city": "Le Plessis-Gassot"},
    {"city": "Le Plessis-Luzarches"},
    {"city": "Pontoise"},
    {"city": "Presles"},
    {"city": "Puiseux-en-France"},
    {"city": "Puiseux-Pontoise"},
    {"city": "La Roche-Guyon"},
    {"city": "Roissy-en-France"},
    {"city": "Ronquerolles"},
    {"city": "Sagy"},
    {"city": "Saint-Brice-sous-Forêt"},
    {"city": "Saint-Clair-sur-Epte"},
    {"city": "Saint-Cyr-en-Arthies"},
    {"city": "Saint-Gervais"},
    {"city": "Saint-Gratien"},
    {"city": "Saint-Leu-la-Forêt"},
    {"city": "Saint-Martin-du-Tertre"},
    {"city": "Saint-Ouen-l'Aumône"},
    {"city": "Saint-Prix"},
    {"city": "Saint-Witz"},
    {"city": "Sannois"},
    {"city": "Santeuil"},
    {"city": "Sarcelles"},
    {"city": "Seraincourt"},
    {"city": "Seugy"},
    {"city": "Soisy-sous-Montmorency"},
    {"city": "Survilliers"},
    {"city": "Taverny"},
    {"city": "Théméricourt"},
    {"city": "Theuville"},
    {"city": "Le Thillay"},
    {"city": "Us"},
    {"city": "Vallangoujard"},
    {"city": "Valmondois"},
    {"city": "Vaudherland"},
    {"city": "Vauréal"},
    {"city": "Vémars"},
    {"city": "Vétheuil"},
    {"city": "Viarmes"},
    {"city": "Vienne-en-Arthies"},
    {"city": "Vigny"},
    {"city": "Villaines-sous-Bois"},
    {"city": "Villeron"},
    {"city": "Villers-en-Arthies"},
    {"city": "Villiers-Adam"},
    {"city": "Villiers-le-Bel"},
    {"city": "Villiers-le-Sec"},
    {"city": "Wy-dit-Joli-Village"},
    {"city": "Les Abymes"},
    {"city": "Anse-Bertrand"},
    {"city": "Baie-Mahault"},
    {"city": "Baillif"},
    {"city": "Basse-Terre"},
    {"city": "Bouillante"},
    {"city": "Capesterre-Belle-Eau"},
    {"city": "Capesterre-de-Marie-Galante"},
    {"city": "Gourbeyre"},
    {"city": "La Désirade"},
    {"city": "Deshaies"},
    {"city": "Grand-Bourg"},
    {"city": "Le Gosier"},
    {"city": "Goyave"},
    {"city": "Lamentin"},
    {"city": "Morne-à-l'Eau"},
    {"city": "Le Moule"},
    {"city": "Petit-Bourg"},
    {"city": "Petit-Canal"},
    {"city": "Pointe-à-Pitre"},
    {"city": "Pointe-Noire"},
    {"city": "Port-Louis"},
    {"city": "Saint-Claude"},
    {"city": "Saint-François"},
    {"city": "Saint-Louis"},
    {"city": "Sainte-Anne"},
    {"city": "Sainte-Rose"},
    {"city": "Terre-de-Bas"},
    {"city": "Terre-de-Haut"},
    {"city": "Trois-Rivières"},
    {"city": "Vieux-Fort"},
    {"city": "Vieux-Habitants"},
    {"city": "L'Ajoupa-Bouillon"},
    {"city": "Les Anses-d'Arlet"},
    {"city": "Basse-Pointe"},
    {"city": "Le Carbet"},
    {"city": "Case-Pilote"},
    {"city": "Le Diamant"},
    {"city": "Ducos"},
    {"city": "Fonds-Saint-Denis"},
    {"city": "Fort-de-France"},
    {"city": "Le François"},
    {"city": "Grand'Rivière"},
    {"city": "Gros-Morne"},
    {"city": "Le Lamentin"},
    {"city": "Le Lorrain"},
    {"city": "Macouba"},
    {"city": "Le Marigot"},
    {"city": "Le Marin"},
    {"city": "Le Morne-Rouge"},
    {"city": "Le Prêcheur"},
    {"city": "Rivière-Pilote"},
    {"city": "Rivière-Salée"},
    {"city": "Le Robert"},
    {"city": "Saint-Esprit"},
    {"city": "Saint-Joseph"},
    {"city": "Saint-Pierre"},
    {"city": "Sainte-Anne"},
    {"city": "Sainte-Luce"},
    {"city": "Sainte-Marie"},
    {"city": "Schœlcher"},
    {"city": "La Trinité"},
    {"city": "Les Trois-Îlets"},
    {"city": "Le Vauclin"},
    {"city": "Le Morne-Vert"},
    {"city": "Bellefontaine"},
    {"city": "Régina"},
    {"city": "Cayenne"},
    {"city": "Iracoubo"},
    {"city": "Kourou"},
    {"city": "Macouria"},
    {"city": "Mana"},
    {"city": "Matoury"},
    {"city": "Saint-Georges"},
    {"city": "Remire-Montjoly"},
    {"city": "Roura"},
    {"city": "Saint-Laurent-du-Maroni"},
    {"city": "Sinnamary"},
    {"city": "Montsinéry-Tonnegrande"},
    {"city": "Ouanary"},
    {"city": "Saül"},
    {"city": "Maripasoula"},
    {"city": "Camopi"},
    {"city": "Grand-Santi"},
    {"city": "Saint-Élie"},
    {"city": "Apatou"},
    {"city": "Awala-Yalimapo"},
    {"city": "Papaichton"},
    {"city": "Les Avirons"},
    {"city": "Bras-Panon"},
    {"city": "Entre-Deux"},
    {"city": "L'Étang-Salé"},
    {"city": "Petite-Île"},
    {"city": "La Plaine-des-Palmistes"},
    {"city": "Le Port"},
    {"city": "La Possession"},
    {"city": "Saint-André"},
    {"city": "Saint-Benoît"},
    {"city": "Saint-Denis"},
    {"city": "Saint-Joseph"},
    {"city": "Saint-Leu"},
    {"city": "Saint-Louis"},
    {"city": "Saint-Paul"},
    {"city": "Saint-Pierre"},
    {"city": "Saint-Philippe"},
    {"city": "Sainte-Marie"},
    {"city": "Sainte-Rose"},
    {"city": "Sainte-Suzanne"},
    {"city": "Salazie"},
    {"city": "Le Tampon"},
    {"city": "Les Trois-Bassins"},
    {"city": "Cilaos"},
    {"city": "Acoua"},
    {"city": "Bandraboua"},
    {"city": "Bandrele"},
    {"city": "Bouéni"},
    {"city": "Chiconi"},
    {"city": "Chirongui"},
    {"city": "Dembeni"},
    {"city": "Dzaoudzi"},
    {"city": "Kani-Kéli"},
    {"city": "Koungou"},
    {"city": "Mamoudzou"},
    {"city": "Mtsamboro"},
    {"city": "M'Tsangamouji"},
    {"city": "Ouangani"},
    {"city": "Pamandzi"},
    {"city": "Sada"},
    {"city": "Tsingoni"},
    {"city": "Marseille 1er Arrondissement"},
    {"city": "Marseille 2e Arrondissement"},
    {"city": "Marseille 3e Arrondissement"},
    {"city": "Marseille 4e Arrondissement"},
    {"city": "Marseille 5e Arrondissement"},
    {"city": "Marseille 6e Arrondissement"},
    {"city": "Marseille 7e Arrondissement"},
    {"city": "Marseille 8e Arrondissement"},
    {"city": "Marseille 9e Arrondissement"},
    {"city": "Marseille 10e Arrondissement"},
    {"city": "Marseille 11e Arrondissement"},
    {"city": "Marseille 12e Arrondissement"},
    {"city": "Marseille 13e Arrondissement"},
    {"city": "Marseille 14e Arrondissement"},
    {"city": "Marseille 15e Arrondissement"},
    {"city": "Marseille 16e Arrondissement"},
    {"city": "Lyon 1er Arrondissement"},
    {"city": "Lyon 2e Arrondissement"},
    {"city": "Lyon 3e Arrondissement"},
    {"city": "Lyon 4e Arrondissement"},
    {"city": "Lyon 5e Arrondissement"},
    {"city": "Lyon 6e Arrondissement"},
    {"city": "Lyon 7e Arrondissement"},
    {"city": "Lyon 8e Arrondissement"},
    {"city": "Lyon 9e Arrondissement"},
    {"city": "Paris 1er Arrondissement"},
    {"city": "Paris 2e Arrondissement"},
    {"city": "Paris 3e Arrondissement"},
    {"city": "Paris 4e Arrondissement"},
    {"city": "Paris 5e Arrondissement"},
    {"city": "Paris 6e Arrondissement"},
    {"city": "Paris 7e Arrondissement"},
    {"city": "Paris 8e Arrondissement"},
    {"city": "Paris 9e Arrondissement"},
    {"city": "Paris 10e Arrondissement"},
    {"city": "Paris 11e Arrondissement"},
    {"city": "Paris 12e Arrondissement"},
    {"city": "Paris 13e Arrondissement"},
    {"city": "Paris 14e Arrondissement"},
    {"city": "Paris 15e Arrondissement"},
    {"city": "Paris 16e Arrondissement"},
    {"city": "Paris 17e Arrondissement"},
    {"city": "Paris 18e Arrondissement"},
    {"city": "Paris 19e Arrondissement"},
    {"city": "Paris 20e Arrondissement"}
];

export default CitiesModel;